import Joi from "joi-browser";
import { getCOPSDv2Schema } from "./COPSDv2";
import { getCOTFCPSDv2Schema } from "./COTFCPSDv2";

export function getSchema(formVersionID) {
  switch (formVersionID) {
    case "68515378-4B21-F011-81A3-9A54DAF47D01":
      return getCOPSDv2Schema();
    case "69515378-4B21-F011-81A3-9A54DAF47D01":
      return getCOTFCPSDv2Schema();
    default:
      return forms[formVersionID.toUpperCase()];
  }
}

const forms = {
  "937C0A13-0A8C-EB11-85AA-0050F21C5B14": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    beginDate: Joi.date().required().label("Begin Date"),
    endDate: Joi.date().required().label("End Date"),
    progress: Joi.string().required().label("Progress"),
    incidents: Joi.string().required().label("Incidents"),
    educationalProgressChange: Joi.string().allow("").allow(null, ""),
    educationalProgress: Joi.string()
      .allow("")
      .required()
      .label("Educational progress"),
    functioning: Joi.string()
      .allow("")
      .required()
      .label("Psychological and Social Functioning"),
    physicalConditionChange: Joi.string().allow("").allow(null, ""),
    physicalCondition: Joi.string()
      .allow("")
      .required()
      .label("Child's Physical Condition"),
    familySituationChange: Joi.string().allow("").allow(null, ""),
    familySituation: Joi.string()
      .allow("")
      .required()
      .label("Family Situation"),
    primaryContactChange: Joi.string().allow("").allow(null, ""),
    primaryContact: Joi.string()
      .allow("")
      .required()
      .label("Primary Family Contact"),
    clientRanAway: Joi.boolean(),
    experiencedSIHI: Joi.boolean(),
    placementChanged: Joi.boolean(),
    clientDischarged: Joi.boolean(),
    other: Joi.boolean(),
    otherText: Joi.string().allow("").allow(null, ""),
    signatures: Joi.any(),
  },
  "29CE0FA8-63B2-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    PrimaryCaregivers: Joi.string()
      .allow("")
      .required()
      .label("Primary Caregivers"),
    CustodialAgent: Joi.string().required().label("Custodial Agent"),
    DiagnosticInitials: Joi.string()
      .allow("")
      .max(5)
      .label("Diagnostic Initials"),
    TFCInitials: Joi.string().allow("").max(5).label("TFC Initials"),
    CaseManagementInitials: Joi.string()
      .allow("")
      .max(5)
      .label("Case Management Initials"),
    InHomeServicesInitials: Joi.string()
      .allow("")
      .max(5)
      .label("In Home Services Initials"),
    WrapServicesInitials: Joi.string()
      .allow("")
      .max(5)
      .label("Wrap Services Initials"),
    ProfessionalDisclosureInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Professional Disclosure Initials"),
    SurpriseBalanceBillingDisclosureInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Surprise/Balance Billing Disclosure Initials"),
    FosterCareHandbookInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Foster Care Handbook Initials"),
    PrivatePracticesInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Private Practices Initials"),
    TextMessageInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Text Message Consent Initials"),
    EmailInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Email Consent Initials"),
    VoicemailInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Voicemail Consent Initials"),
  },
  "C38B0D83-EDB7-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    PrimaryCaregivers: Joi.string()
      .allow("")
      .required()
      .label("Primary Caregivers"),
    CustodialAgent: Joi.string().required().label("Custodial Agent"),
    DiagnosticInitials: Joi.string()
      .allow("")
      .max(5)
      .label("Diagnostic Initials"),
    CaseManagementInitials: Joi.string()
      .allow("")
      .max(5)
      .label("Case Management Initials"),
    InHomeServicesInitials: Joi.string()
      .allow("")
      .max(5)
      .label("In Home Services Initials"),
    WrapServicesInitials: Joi.string()
      .allow("")
      .max(5)
      .label("Wrap Services Initials"),
    ProfessionalDisclosureInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Professional Disclosure Initials"),
    SurpriseBalanceBillingDisclosureInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Surprise/Balance Billing Disclosure Initials"),
    FosterCareHandbookInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Foster Care Handbook Initials"),
    PrivatePracticesInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Private Practices Initials"),
    TextMessageInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Text Message Consent Initials"),
    EmailInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Email Consent Initials"),
    VoicemailInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Voicemail Consent Initials"),
  },
  "3F546069-85B2-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    FosterFamilyName: Joi.string()
      .allow("")
      .required()
      .label("Foster Family Name"),
    PlacementDate: Joi.string().required().label("Placement Date"),
    TourInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Tour Initials"),
    EmergencyInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Emergency Initials"),
    FosterCareHandbookInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Foster Care Handbook Initials"),
    HouseRulesInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("House Rules Initials"),
    HouseRules: Joi.string().required().label("House Rules"),
    Condition: Joi.string().required().label("Condition"),
    OwnWords: Joi.string().required().label("Removed from home"),
    Preferences: Joi.string().required().label("Preferences"),
    Questions: Joi.string().required().label("Questions"),
  },
  "7CD57D92-A5B2-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    TravelAddress: Joi.string().required().label("Travel Address"),
    TravelStartDate: Joi.string()
      .allow("")
      .required()
      .label("Travel Start Date"),
    TravelEndDate: Joi.string().required().label("Travel End Date"),
    SpecialRestrictions: Joi.string()
      .allow("")
      .required()
      .label("Special Restrictions"),
  },
  "281914C1-32B3-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    TourInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Tour Initials"),
    EmergencyInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Emergency Initials"),
    FosterCareHandbookInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("Foster Care Handbook Initials"),
    HouseRulesInitials: Joi.string()
      .allow("")
      .required()
      .max(5)
      .label("House Rules Initials"),
    HouseRules: Joi.string().required().label("House Rules"),
    MedicalAppointmentDate: Joi.string()
      .allow("")
      .required()
      .label("Medical Appointment Date"),
    DentalAppointmentDate: Joi.string()
      .allow("")
      .required()
      .label("Dental Appointment Date"),
    VisionAppointmentDate: Joi.string()
      .allow("")
      .required()
      .label("Vision Appointment Date"),
    PsychiatricAppointmentDate: Joi.string()
      .allow("")
      .required()
      .label("Psychiatric Appointment Date"),
    Condition: Joi.string().required().label("Condition"),
    Preferences: Joi.string().required().label("Preferences"),
    Questions: Joi.string().required().label("Questions"),
  },
  "D317320F-FFB3-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateOfDischarge: Joi.string()
      .allow("")
      .required()
      .label("Date of Discharge"),
    DischargedTo: Joi.string()
      .allow("")
      .required()
      .label("Person/Agency to which client has been discharged"),
    DischargedToAddress: Joi.string()
      .allow("")
      .required()
      .label("Address of where client has been discharged"),
    DischargeReason: Joi.string()
      .allow("")
      .required()
      .label("Reason for discharge"),
    BriefExplanation: Joi.string()
      .allow("")
      .label("Brief Explanation")
      .when("DischargeReason", {
        is: "186460008",
        then: Joi.required(),
      })
      .when("DischargeReason", {
        is: "186460005",
        then: Joi.required(),
      })
      .when("DischargeReason", {
        is: "186460006",
        then: Joi.required(),
      }),
    OutpatientMentalHealth: Joi.boolean(),
    OutpatientMentalHealthReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("OutpatientMentalHealth", {
        is: true,
        then: Joi.required(),
      }),
    OutpatientSubstanceAbuse: Joi.string()
      .allow("")
      .label("Outpatient Alcohol/Substance Abuse"),
    OutpatientSubstanceAbuseReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("OutpatientSubstanceAbuse", {
        is: true,
        then: Joi.required(),
      }),
    HousingAssistance: Joi.boolean(),
    HousingAssistanceReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("HousingAssistance", {
        is: true,
        then: Joi.required(),
      }),
    JobTraining: Joi.boolean(),
    JobTrainingReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("JobTraining", {
        is: true,
        then: Joi.required(),
      }),
    EducationServices: Joi.boolean(),
    EducationServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("EducationServices", {
        is: true,
        then: Joi.required(),
      }),
    Tutoring: Joi.boolean(),
    TutoringReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("Tutoring", { is: true, then: Joi.required() }),
    PsychiatricAppointment: Joi.boolean(),
    PsychiatricAppointmentReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("PsychiatricAppointment", {
        is: true,
        then: Joi.required(),
      }),
    Prescriptions: Joi.boolean(),
    PrescriptionsReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("Prescriptions", {
        is: true,
        then: Joi.required(),
      }),
    MedicalServices: Joi.boolean(),
    MedicalServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("MedicalServices", {
        is: true,
        then: Joi.required(),
      }),
    Probation: Joi.boolean(),
    ProbationReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("Probation", {
        is: true,
        then: Joi.required(),
      }),
    LegalServices: Joi.boolean(),
    LegalServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("LegalServices", {
        is: true,
        then: Joi.required(),
      }),
    PhysicianAppointment: Joi.boolean(),
    PhysicianAppointmentReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("PhysicianAppointment", {
        is: true,
        then: Joi.required(),
      }),
    WelfareSupport: Joi.boolean(),
    WelfareSupportReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("WelfareSupport", {
        is: true,
        then: Joi.required(),
      }),
    FinancialSupport: Joi.boolean(),
    FinancialSupportReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("FinancialSupport", {
        is: true,
        then: Joi.required(),
      }),
    InHomeServices: Joi.boolean(),
    InHomeServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("InHomeServices", {
        is: true,
        then: Joi.required(),
      }),
    OtherServices: Joi.boolean(),
    OtherServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("OtherServices", {
        is: true,
        then: Joi.required(),
      }),
    LocalCrisisCenter: Joi.string()
      .allow("")
      .required()
      .label("Local Crisis Center"),
    LocalCrisisCenterDetails: Joi.string()
      .allow("")
      .required()
      .label("Local Crisis Center Details"),
    ServicesNarrative: Joi.string()
      .allow("")
      .required()
      .label("Services Narrative"),
    PlacementHistory: Joi.string()
      .allow("")
      .required()
      .label("Placement History"),
    Behavior: Joi.string().required().label("Behavior"),
    SocialInteraction: Joi.string()
      .allow("")
      .required()
      .label("Social and Peer Interaction"),
    ResponseToCaregivers: Joi.string()
      .allow("")
      .required()
      .label("Response to Caregives or Redirection"),
    SchoolInformation: Joi.string()
      .allow("")
      .required()
      .label("School Information and Participation"),
    AdditionalAccomplishments: Joi.string()
      .allow("")
      .required()
      .label("Additional Accomplishments"),
    FollowUp: Joi.string()
      .allow("")
      .required()
      .label("Follow-up/Scheduled Appointments"),
    CopingSkills: Joi.string().required().label("Coping Skills"),
    SelfRegulate: Joi.string().required().label("Self-regulate"),
    Boundaries: Joi.string().required().label("Boundaries"),
    SchoolAttendance: Joi.string()
      .allow("")
      .required()
      .label("School Attendance"),
    NewCharges: Joi.string().required().label("New Charges"),
    ReducedContact: Joi.string()
      .allow("")
      .required()
      .label("Reduced hospital or police contact"),
    NavigateCrisis: Joi.string().required().label("Navigate crisis"),
    Advocate: Joi.string().required().label("Advocate for needs"),
    PositiveSupports: Joi.string()
      .allow("")
      .required()
      .label("Positive supports"),
    DecreasedSubstanceAbuse: Joi.string()
      .allow("")
      .required()
      .label("Decreased Substance Abuse"),
    OtherOutcomes: Joi.string().allow("").label("Other Outcomes"),
  },
  "8C1E2966-27B4-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateOfDischarge: Joi.string()
      .allow("")
      .required()
      .label("Date of Discharge"),
    DischargedTo: Joi.string()
      .allow("")
      .required()
      .label("Person/Agency to which client has been discharged"),
    DischargedToAddress: Joi.string()
      .allow("")
      .required()
      .label("Address to which client has been discharged"),
    DischargeReason: Joi.string()
      .allow("")
      .required()
      .label("Reason for discharge"),
    BriefExplanation: Joi.string().when("DischargeReason", {
      is: Joi.any().valid("186460008", "186460005", "186460006"),
      then: Joi.required(),
    }),
    OutpatientMentalHealth: Joi.boolean(),
    OutpatientMentalHealthReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("OutpatientMentalHealth", {
        is: true,
        then: Joi.required(),
      }),
    OutpatientSubstanceAbuse: Joi.string()
      .allow("")
      .label("Outpatient Alcohol/Substance Abuse"),
    OutpatientSubstanceAbuseReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("OutpatientSubstanceAbuse", {
        is: true,
        then: Joi.required(),
      }),
    HousingAssistance: Joi.boolean(),
    HousingAssistanceReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("HousingAssistance", {
        is: true,
        then: Joi.required(),
      }),
    JobTraining: Joi.boolean(),
    JobTrainingReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("JobTraining", {
        is: true,
        then: Joi.required(),
      }),
    EducationServices: Joi.boolean(),
    EducationServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("EducationServices", {
        is: true,
        then: Joi.required(),
      }),
    Tutoring: Joi.boolean(),
    TutoringReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("Tutoring", { is: true, then: Joi.required() }),
    PsychiatricAppointment: Joi.boolean(),
    PsychiatricAppointmentReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("PsychiatricAppointment", {
        is: true,
        then: Joi.required(),
      }),
    Prescriptions: Joi.boolean(),
    PrescriptionsReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("Prescriptions", {
        is: true,
        then: Joi.required(),
      }),
    MedicalServices: Joi.boolean(),
    MedicalServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("MedicalServices", {
        is: true,
        then: Joi.required(),
      }),
    Probation: Joi.boolean(),
    ProbationReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("Probation", {
        is: true,
        then: Joi.required(),
      }),
    LegalServices: Joi.boolean(),
    LegalServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("LegalServices", {
        is: true,
        then: Joi.required(),
      }),
    PhysicianAppointment: Joi.boolean(),
    PhysicianAppointmentReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("PhysicianAppointment", {
        is: true,
        then: Joi.required(),
      }),
    WelfareSupport: Joi.boolean(),
    WelfareSupportReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("WelfareSupport", {
        is: true,
        then: Joi.required(),
      }),
    FinancialSupport: Joi.boolean(),
    FinancialSupportReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("FinancialSupport", {
        is: true,
        then: Joi.required(),
      }),
    InHomeServices: Joi.boolean(),
    InHomeServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("InHomeServices", {
        is: true,
        then: Joi.required(),
      }),
    OtherServices: Joi.boolean(),
    OtherServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("OtherServices", {
        is: true,
        then: Joi.required(),
      }),
    LocalCrisisCenter: Joi.string()
      .allow("")
      .required()
      .label("Local Crisis Center"),
    LocalCrisisCenterDetails: Joi.string()
      .allow("")
      .required()
      .label("Local Crisis Center Details"),
    ServicesNarrative: Joi.string()
      .allow("")
      .required()
      .label("Services Narrative"),
    PlacementHistory: Joi.string()
      .allow("")
      .required()
      .label("Placement History"),
    Behavior: Joi.string().required().label("Behavior"),
    SocialInteraction: Joi.string()
      .allow("")
      .required()
      .label("Social and Peer Interaction"),
    ResponseToCaregivers: Joi.string()
      .allow("")
      .required()
      .label("Response to Caregives or Redirection"),
    SchoolInformation: Joi.string()
      .allow("")
      .required()
      .label("School Information and Participation"),
    AdditionalAccomplishments: Joi.string()
      .allow("")
      .required()
      .label("Additional Accomplishments"),
    FollowUp: Joi.string()
      .allow("")
      .required()
      .label("Follow-up/Scheduled Appointments"),
    CopingSkills: Joi.string().required().label("Coping Skills"),
    SelfRegulate: Joi.string().required().label("Self-regulate"),
    Boundaries: Joi.string().required().label("Boundaries"),
    SchoolAttendance: Joi.string()
      .allow("")
      .required()
      .label("School Attendance"),
    NewCharges: Joi.string().required().label("New Charges"),
    ReducedContact: Joi.string()
      .allow("")
      .required()
      .label("Reduced hospital or police contact"),
    NavigateCrisis: Joi.string().required().label("Navigate crisis"),
    Advocate: Joi.string().required().label("Advocate for needs"),
    PositiveSupports: Joi.string()
      .allow("")
      .required()
      .label("Positive supports"),
    DecreasedSubstanceAbuse: Joi.string()
      .allow("")
      .required()
      .label("Decreased Substance Abuse"),
    OtherOutcomes: Joi.string().allow("").label("Other Outcomes"),
    CGTrauma: Joi.string().required().label("Understanding trauma"),
    CGNavigateCrisis: Joi.string()
      .allow("")
      .required()
      .label("Navigate crisis"),
    CGAttuned: Joi.string()
      .allow("")
      .required()
      .label("Attuned to child's needs"),
    CGRegulated: Joi.string().required().label("Regulated"),
    CGAdvocate: Joi.string().required().label("Advocate for family"),
    CGSupports: Joi.string().required().label("Natural supports"),
    CGSelfCare: Joi.string().required().label("Self-care"),
    CGSkills: Joi.string().required().label("Problem-solving skills"),
    CGTraumaInformed: Joi.string()
      .allow("")
      .required()
      .label("Trauma-informed skills"),
    CGResources: Joi.string().required().label("Find resources"),
    CGOtherOutcomes: Joi.string().allow("").label("Other Outcomes"),
    HigherLevel: Joi.string()
      .allow("")
      .required()
      .label("Higher level of care"),
    Reunified: Joi.string().required().label("Reunified"),
    Functioning: Joi.string().required().label("Family functioning"),
    FamilyOtherOutcomes: Joi.string().allow("").label("Other Outcomes"),
  },
  "5F59C37A-C3B4-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    YouthStrengths: Joi.string().required().label("Youth strengths"),
    YouthPlaceOfBirth: Joi.string()
      .allow("")
      .required()
      .label("Place of birth"),
    ReligiousNeeds: Joi.string()
      .allow("")
      .required()
      .label("Religious Preferences or Needs"),
    SpecialNeeds: Joi.string().required().label("Special Needs"),
    PermanencyPlan: Joi.string().required().label("Permanency Plan"),
    PermanencyPlanOther: Joi.string()
      .allow("")
      .label("Permanency Plan Other")
      .when("PermanencyPlan", {
        is: "4",
        then: Joi.required(),
      }),
    FirstEntry: Joi.string().required().label("1st entry"),
    HealthConcerns: Joi.string()
      .allow("")
      .required()
      .label("Any health concerns"),
    HealthConcernsDetails: Joi.string()
      .allow("")
      .label("Health concerns")
      .when("HealthConcerns", {
        is: "1",
        then: Joi.required(),
      }),
    Allergies: Joi.string().required().label("Allergies & Reaction"),
    EpiPen: Joi.string()
      .allow("")
      .label("Epi-pen")
      .when("Allergies", { is: "1", then: Joi.required() }),
    RecentHospitalizations: Joi.string()
      .allow("")
      .required()
      .label("Recent hospitalizations"),
    RecentHospitalizationsDetails: Joi.string()
      .allow("")
      .label("Recent hospitalization details")
      .when("RecentHospitalizations", {
        is: "1",
        then: Joi.required(),
      }),
    Height: Joi.string().required().label("Height"),
    Weight: Joi.string().required().label("Weight"),
    HairColor: Joi.string().required().label("Hair Color"),
    EyeColor: Joi.string().required().label("Eye Color"),
    LastDoctorVisit: Joi.string()
      .allow("")
      .required()
      .label("Last doctor visit"),
    LastDoctorVisitIssues: Joi.string()
      .allow("")
      .required()
      .label("Last doctor visit issues"),
    LastDentalVisit: Joi.string()
      .allow("")
      .required()
      .label("Last dental visit"),
    LastDentalVisitIssues: Joi.string()
      .allow("")
      .required()
      .label("Last dental visit issues"),
    ImmunizationRecords: Joi.string()
      .allow("")
      .required()
      .label("Immunization records included"),
    ImmunizationRecordsPlan: Joi.string()
      .allow("")
      .label("Immunization records plan")
      .when("ImmunizationRecords", {
        is: "0",
        then: Joi.required(),
      }),
    RecentSelfHarm: Joi.string().required().label("Recent self-harm"),
    RecentSelfHarmDetails: Joi.string()
      .allow("")
      .label("Recent self-harm details")
      .when("RecentSelfHarm", {
        is: "1",
        then: Joi.required(),
      }),
    YouthTriggers: Joi.string().required().label("Youth's Triggers"),
    EffectiveStrategies: Joi.string()
      .allow("")
      .required()
      .label("Effective Strategies"),
    SupervisionNeeds: Joi.string()
      .allow("")
      .required()
      .label("Special Supervision Needs"),
    Unsupervised: Joi.string().required().label("Left unsupervised"),
    UnsupervisedDetails: Joi.string()
      .allow("")
      .label("Unsupervised details")
      .when("Unsupervised", {
        is: "1",
        then: Joi.required(),
      }),
    ContactFamily: Joi.string()
      .allow("")
      .required()
      .label("Contact primary family"),
    ContactFamilyNames: Joi.string()
      .allow("")
      .label("Contact family names")
      .when("ContactFamily", {
        is: "1",
        then: Joi.required(),
      }),
    ContactRestrictions: Joi.string()
      .allow("")
      .required()
      .label("Contact restrictions"),
    ContactRestrictionsDetails: Joi.string()
      .allow("")
      .label("Contact restrictions details")
      .when("ContactRestrictions", {
        is: "1",
        then: Joi.required(),
      }),
    FamilyVisitation: Joi.string()
      .allow("")
      .required()
      .label("Family visitation"),
    VisitationFrequency: Joi.string()
      .allow("")
      .label("Visitation Frequency")
      .when("FamilyVisitation", {
        is: "1",
        then: Joi.required(),
      }),
    VisitationLocation: Joi.string()
      .allow("")
      .label("Visitation Location")
      .when("FamilyVisitation", {
        is: "1",
        then: Joi.required(),
      }),
    VisitationDuration: Joi.string()
      .allow("")
      .label("Visitation Duration")
      .when("FamilyVisitation", {
        is: "1",
        then: Joi.required(),
      }),
    VisitationRestrictions: Joi.string()
      .allow("")
      .label("Visitation Restrictions"),
    NoContact: Joi.string().required().label("No contact"),
    NoContactDetails: Joi.string()
      .allow("")
      .label("No contact details")
      .when("NoContact", { is: "1", then: Joi.required() }),
    OtherNotes: Joi.string().allow("").label("Other notes"),
  },
  "838083D1-19B7-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    ToName: Joi.string().required().label("Name"),
    ToOrganization: Joi.string().required().label("Organization"),
    ToStreetAddress: Joi.string().required().label("Street Address"),
    ToCityState: Joi.string().required().label("City/State"),
    ToPhone: Joi.string().required().label("Phone"),
    ToFax: Joi.string().allow(""),
    ToATTN: Joi.string().required().label("ATTN"),
    FromAgency: Joi.string().required().label("Agency"),
    FromStreetAddress: Joi.string()
      .allow("")
      .required()
      .label("Street Address"),
    FromCityState: Joi.string().required().label("City/State"),
    FromPhone: Joi.string().required().label("Phone"),
    FromFax: Joi.string().allow(""),
    FromContact: Joi.string().required().label("Contact"),
    SocialHistory: Joi.boolean(),
    DiagnosticAssessment: Joi.boolean(),
    ProgressReports: Joi.boolean(),
    LivingAssessments: Joi.boolean(),
    DischargeSummary: Joi.boolean(),
    TreatmentPlan: Joi.boolean(),
    Medications: Joi.boolean(),
    HIVTesting: Joi.boolean(),
    AIDSTesting: Joi.boolean(),
    SubstanceAbuse: Joi.boolean(),
    PsychConditions: Joi.boolean(),
    OtherDisclosed: Joi.boolean(),
    OtherDisclosedDetails: Joi.string()
      .allow("")
      .label("Other")
      .when("OtherDisclosed", {
        is: true,
        then: Joi.required(),
      }),
    Continuity: Joi.boolean(),
    TreatmentCompliance: Joi.boolean(),
    Employment: Joi.boolean(),
    Legal: Joi.boolean(),
    FamilyInvolvement: Joi.boolean(),
    PhysicianInvolvement: Joi.boolean(),
    SchoolInvolvement: Joi.boolean(),
    OtherPurpose: Joi.boolean(),
    OtherPurposeDetails: Joi.string()
      .allow("")
      .label("Other")
      .when("OtherPurpose", {
        is: true,
        then: Joi.required(),
      }),
    OneYear: Joi.boolean(),
    NinetyDays: Joi.boolean(),
    SixMonths: Joi.boolean(),
    OtherAmount: Joi.boolean(),
    OtherAmountDetails: Joi.string()
      .allow("")
      .label("Other")
      .when("OtherAmount", {
        is: true,
        then: Joi.required(),
      }),
    Written: Joi.boolean(),
    Verbal: Joi.boolean(),
    Fax: Joi.boolean(),
    Audio: Joi.boolean(),
    Video: Joi.boolean(),
    Email: Joi.boolean(),
    ReleaseInEffect: Joi.boolean(),
    CancellationDate: Joi.string().allow(""),
    CancellationTime: Joi.string().allow(""),
    CancellationMode: Joi.string().allow(""),
  },
  "80617A3A-67B3-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    CloseFriend: Joi.string().required().label("Close Friend"),
    LocalHotline: Joi.string().required().label("Local Hotline"),
    LocalPolice: Joi.string().required().label("Local Police"),
    Email: Joi.string().required().label("Email"),
  },
  "E2F833C4-49B7-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
  },
  "4939E67C-55B7-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    ToName: Joi.string().required().label("Name"),
    ToOrganization: Joi.string().required().label("Organization"),
    ToStreetAddress: Joi.string().required().label("Street Address"),
    ToCityState: Joi.string().required().label("City/State"),
    ToPhone: Joi.string().required().label("Phone"),
    ToFax: Joi.string().allow("").label("Fax"),
    ToATTN: Joi.string().required().label("ATTN"),
    FromInfo: Joi.string().required().label("From Info"),
    SocialHistory: Joi.boolean(),
    DiagnosticAssessment: Joi.boolean(),
    ProgressReports: Joi.boolean(),
    LivingAssessments: Joi.boolean(),
    DischargeSummary: Joi.boolean(),
    TreatmentPlan: Joi.boolean(),
    Medications: Joi.boolean(),
    HIVTesting: Joi.boolean(),
    AIDSTesting: Joi.boolean(),
    SubstanceAbuse: Joi.boolean(),
    PsychConditions: Joi.boolean(),
    OtherDisclosed: Joi.boolean(),
    OtherDisclosedDetails: Joi.string()
      .allow("")
      .label("Other")
      .when("OtherDisclosed", {
        is: true,
        then: Joi.required(),
      }),
    Continuity: Joi.boolean(),
    TreatmentCompliance: Joi.boolean(),
    Employment: Joi.boolean(),
    Legal: Joi.boolean(),
    FamilyInvolvement: Joi.boolean(),
    PhysicianInvolvement: Joi.boolean(),
    SchoolInvolvement: Joi.boolean(),
    OtherPurpose: Joi.boolean(),
    OtherPurposeDetails: Joi.string()
      .allow("")
      .label("Other")
      .when("OtherPurpose", {
        is: true,
        then: Joi.required(),
      }),
    OneYear: Joi.boolean(),
    NinetyDays: Joi.boolean(),
    SixMonths: Joi.boolean(),
    OtherAmount: Joi.boolean(),
    OtherAmountDetails: Joi.string()
      .allow("")
      .label("Other")
      .when("OtherAmount", {
        is: true,
        then: Joi.required(),
      }),
    Written: Joi.boolean(),
    Verbal: Joi.boolean(),
    Fax: Joi.boolean(),
    Audio: Joi.boolean(),
    Video: Joi.boolean(),
    Email: Joi.boolean(),
    ReleaseInEffect: Joi.boolean(),
    CancellationDate: Joi.string().allow(""),
    CancellationTime: Joi.string().allow(""),
    CancellationMode: Joi.string().allow(""),
  },
  "271A5E53-14B8-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    AssessmentDate: Joi.string()
      .allow("")
      .required()
      .label("Date of Assessment"),
    InHomeServices: Joi.string()
      .allow("")
      .required()
      .label("In-home Services Frequency"),
    ClinicianName: Joi.string().required().label("Clinician Name"),
    ClinicianPhone: Joi.string().required().label("Clinician Phone"),
    ClinicianEmail: Joi.string().required().label("Clinician Email"),
    SupervisorName: Joi.string().required().label("Supervisor Name"),
    SupervisorPhone: Joi.string()
      .allow("")
      .required()
      .label("Supervisor Phone"),
    SupervisorEmail: Joi.string()
      .allow("")
      .required()
      .label("Supervisor Email"),
  },
  "1E116355-63BD-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    FosterParents: Joi.string().required().label("Foster Parents"),
    PerDiem: Joi.string().required().label("Per Diem"),
  },
  "9C43B533-6DBE-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SafetyPlanDate: Joi.string().required().label("Safety Plan Date"),
    Relatives: Joi.string().required().label("Relatives"),
    Teachers: Joi.string().required().label("Teachers"),
    ProbationOfficer: Joi.string()
      .allow("")
      .required()
      .label("Probation Officer"),
    Goal: Joi.string().required().label("Safety Plan Goal"),
    RiskFactorOne: Joi.string().required().label("Risk Factor #1"),
    RiskFactorTwo: Joi.string().required().label("Risk Factor #2"),
    RiskFactorThree: Joi.string().required().label("Risk Factor #3"),
    StrategyOne: Joi.string().required().label("Strategy #1"),
    StrategyTwo: Joi.string().required().label("Strategy #2"),
    StrategyThree: Joi.string().required().label("Strategy #3"),
  },
  "B62ACE5A-F7BE-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    FosterParents: Joi.string().required().label("Foster Parents"),
    PerDiem: Joi.string().required().label("Per Diem"),
  },
  "2DB0C964-FABE-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateCompleted: Joi.string().required().label("Date Completed"),
    LivedAlone: Joi.string().required().label("Lived Alone"),
    LivedAloneDetails: Joi.string()
      .allow("")
      .label("Lived alone details")
      .when("LivedAlone", { is: "1", then: Joi.required() }),
    Supports: Joi.string().required().label("Support persons"),
    LiveLocation: Joi.string().required().label("Want to live"),
    ImportantSkills: Joi.string()
      .allow("")
      .required()
      .label("Important skills"),
    Bills: Joi.string().required().label("Basic knowledge of bills"),
    BillsAddressed: Joi.string()
      .allow("")
      .label("Areas needing addressed")
      .when("Bills", { is: "0", then: Joi.required() }),
    SecurityDeposit: Joi.string()
      .allow("")
      .required()
      .label("Security deposit"),
    Lease: Joi.string().required().label("Lease"),
    Utilities: Joi.string().required().label("Utilities"),
    CostOfLiving: Joi.string().required().label("Cost of living"),
    SetUp: Joi.string()
      .allow("")
      .required()
      .label("How to set up an apartment"),
    HouseRules: Joi.string().required().label("House rules"),
    Evicted: Joi.string().required().label("Evicted"),
    UnfairLandlord: Joi.string().required().label("Unfair landlord"),
    Budget: Joi.string().required().label("Budget"),
    Transportation: Joi.string().required().label("Transportation"),
    Job: Joi.string().required().label("Had a job"),
    JobDetails: Joi.string()
      .allow("")
      .label("Job details")
      .when("Job", { is: "1", then: Joi.required() }),
    FindJob: Joi.string().required().label("Find a job"),
    LoseJob: Joi.string().required().label("Lose a job"),
    Paycheck: Joi.string().required().label("Paycheck deductions"),
    Taxes: Joi.string().required().label("Ever filed taxes"),
    Healthy: Joi.string().required().label("Stay healthy"),
    Cook: Joi.string().required().label("Cook for themselves"),
    SelfCare: Joi.string().required().label("Self-care"),
    HealthProvider: Joi.string()
      .allow("")
      .required()
      .label("How to contact a health provider"),
    Insurance: Joi.string().required().label("Insurance"),
    BirthControl: Joi.string()
      .allow("")
      .required()
      .label("Understanding of birth control"),
    SignsOfSTD: Joi.string().required().label("Signs of STDs"),
    SocialSecurity: Joi.string().required().label("SS#"),
    EmergencyPersonnel: Joi.string()
      .allow("")
      .required()
      .label("Emergency Personnel"),
    NewToArea: Joi.string().required().label("New to area"),
    Chores: Joi.string().required().label("Chores"),
    FreeTime: Joi.string().required().label("Free time"),
    HardestPart: Joi.string()
      .allow("")
      .required()
      .label("Hardest part of living alone"),
    Accomplish: Joi.string().required().label("Like to accomplish"),
    LifeSkills: Joi.string().required().label("Life Skilss"),
    Happiest: Joi.string().required().label("Happiest"),
    BestThing: Joi.string().required().label("Best thing about me"),
    Question: Joi.string()
      .allow("")
      .required()
      .label("Question about being on my own"),
    DoWell: Joi.string().required().label("Something I do well"),
  },
  "0FE260B8-23BF-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateOfPlan: Joi.string().required().label("Date of Safety Plan"),
    WarningSigns: Joi.string().required().label("Warning Signs"),
    CopingStrategiesHome: Joi.string()
      .allow("")
      .required()
      .label("Coping Strategies at Home/Community"),
    CopingStrategiesWork: Joi.string()
      .allow("")
      .required()
      .label("Coping Strategies at Work/School"),
    SupportsHome: Joi.string()
      .allow("")
      .required()
      .label("Supports at Home/Community"),
    SupportsWork: Joi.string()
      .allow("")
      .required()
      .label("Supports at Work/School"),
    Reasons: Joi.string().required().label("Reasons for Living"),
    Plan: Joi.string().required().label("Plan to Stay Safe"),
    Steps: Joi.string()
      .allow("")
      .required()
      .label("Steps to Make the Enviroment Safe"),
    Hotline: Joi.string().required().label("Hotline"),
    CrisisCenter: Joi.string().required().label("Crisis Center"),
    Hospital: Joi.string().required().label("Hospital/ED"),
    SAFYCrisisLine: Joi.string().required().label("SAFY Crisis Line"),
    Other: Joi.string().allow("").label("Other"),
  },
  "D6CF2C7C-29BF-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateOfPlan: Joi.string().required().label("Date of Safety Plan"),
    WarningSigns: Joi.string().required().label("Warning Signs"),
    CopingStrategiesHome: Joi.string()
      .allow("")
      .required()
      .label("Coping Strategies at Home/Community"),
    CopingStrategiesSchool: Joi.string()
      .allow("")
      .required()
      .label("Coping Strategies at Work/School"),
    SupportsHome: Joi.string()
      .allow("")
      .required()
      .label("Supports at Home/Community"),
    SupportsSchool: Joi.string()
      .allow("")
      .required()
      .label("Supports at Work/School"),
    Reasons: Joi.string().required().label("Reasons for Living"),
    Plan: Joi.string().required().label("Plan to Stay Safe"),
    FeelingSafe: Joi.string().required().label("Feeling Safe"),
    Triggers: Joi.string()
      .allow("")
      .required()
      .label("Triggers and Warning Signs"),
    TriggerResponse: Joi.string().required().label("How to Respond"),
    Monitoring: Joi.string()
      .allow("")
      .required()
      .label("Ways to Increase Monitoring"),
    Steps: Joi.string()
      .allow("")
      .required()
      .label("Steps to Make the Enviroment Safe"),
    SupportChild: Joi.string()
      .allow("")
      .required()
      .label("Ways to Support My Child"),
    MySupports: Joi.string().required().label("My Supports"),
    Hotline: Joi.string().required().label("Hotline"),
    CrisisCenter: Joi.string().required().label("Crisis Center"),
    Hospital: Joi.string().required().label("Hospital/ED"),
    SAFYCrisisLine: Joi.string().required().label("SAFY Crisis Line"),
    Other: Joi.string().allow("").label("Other"),
  },
  "CF4792F6-F0BE-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    Maintained: Joi.string()
      .allow("")
      .required()
      .label("Maintained structures"),
    WorkingCondition: Joi.string()
      .allow("")
      .required()
      .label("In Working Condition"),
    NoFirearm: Joi.string().required().label("No firearm kept"),
    Telephone: Joi.string().required().label("Access to telephone"),
    Water: Joi.string().required().label("Drinking water"),
    Bathroom: Joi.string().required().label("Operating bathroom"),
    Garbage: Joi.string().required().label("Garbage disposal"),
    SmokeAlarm: Joi.string().required().label("Smoke alarm"),
    Extinguisher: Joi.string().required().label("Fire extinguisher"),
    EvacuationPlan: Joi.string().required().label("Evacuation Plan"),
    OutletPlugs: Joi.string().required().label("Safety Outlet Plugs"),
    Adequate: Joi.string().required().label("Adequate heat, etc."),
    CorrectionDetails: Joi.string()
      .allow("")
      .label("Correction details")
      .when("Maintained", { is: "0", then: Joi.required() })
      .when("WorkingCondition", { is: "0", then: Joi.required() })
      .when("NoFirearm", { is: "0", then: Joi.required() })
      .when("Telephone", { is: "0", then: Joi.required() })
      .when("Water", { is: "0", then: Joi.required() })
      .when("Bathroom", { is: "0", then: Joi.required() })
      .when("Garbage", { is: "0", then: Joi.required() })
      .when("SmokeAlarm", { is: "0", then: Joi.required() })
      .when("Extinguisher", { is: "0", then: Joi.required() })
      .when("EvacuationPlan", { is: "0", then: Joi.required() })
      .when("OutletPlugs", { is: "0", then: Joi.required() })
      .when("Adequate", { is: "0", then: Joi.required() }),
    FollowUpDate: Joi.string().allow("").label("Follow Up Date"),
  },
  "66F0AD03-32BF-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    ClientRights: Joi.string().allow(""),
    ClientGrievance: Joi.string().allow(""),
    GrievanceForms: Joi.string().allow(""),
    PrivacyPractices: Joi.string().allow(""),
    LeaveMessages: Joi.boolean(),
    LeaveMessagesPhone: Joi.string()
      .allow("")
      .label("Phone")
      .when("LeaveMessages", {
        is: true,
        then: Joi.required(),
      }),
    TextMessage: Joi.boolean(),
    TextMessagePhone: Joi.string()
      .allow("")
      .label("Phone")
      .when("TextMessage", {
        is: true,
        then: Joi.required(),
      }),
    Email: Joi.boolean(),
    EmailAddress: Joi.string()
      .allow("")
      .label("Email Address")
      .when("Email", { is: true, then: Joi.required() }),
  },
  "0B2ADCAD-B8BF-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    FamilyName: Joi.string().required().label("Family Name"),
    RehabInitials: Joi.string().allow("").label("Initials"),
    TFCInitials: Joi.string().allow("").label("Initials"),
    InHomeServicesInitials: Joi.string().allow("").label("Initials"),
    CrisisManagementInitials: Joi.string().allow("").label("Initials"),
    OYSProgramInitials: Joi.string().allow("").label("Initials"),
    IndividualInitials: Joi.string().allow("").label("Initials"),
    GroupInitials: Joi.string().allow("").label("Initials"),
    FamilyInitials: Joi.string().allow("").label("Initials"),
  },
  "942891E7-CDBF-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    Photography: Joi.boolean(),
    Audio: Joi.boolean(),
    Video: Joi.boolean(),
  },
  "26919D78-D3BF-EB11-A7AD-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    ClientRights: Joi.string().allow(""),
    ClientGrievance: Joi.string().allow(""),
    GrievanceForms: Joi.string().allow(""),
    PrivacyPractices: Joi.string().allow(""),
    LeaveMessages: Joi.boolean(),
    LeaveMessagesPhone: Joi.string()
      .allow("")
      .label("Phone")
      .when("LeaveMessages", {
        is: true,
        then: Joi.required(),
      }),
    TextMessage: Joi.boolean(),
    TextMessagePhone: Joi.string()
      .allow("")
      .label("Phone")
      .when("TextMessage", {
        is: true,
        then: Joi.required(),
      }),
    Email: Joi.boolean(),
    EmailAddress: Joi.string()
      .allow("")
      .label("Email Address")
      .when("Email", { is: true, then: Joi.required() }),
    AuthorizeTransport: Joi.string()
      .allow("")
      .required()
      .label("Transport Authorization"),
    PeopleToTransport: Joi.string()
      .allow("")
      .label("People to transport")
      .when("AuthorizeTransport", {
        is: "1",
        then: Joi.required(),
      }),
  },
  "73561BEF-20C3-EB11-A7AD-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SAFYOfficeAddress: Joi.string()
      .allow("")
      .required()
      .label("SAFY Office Address"),
    SAFYOfficeContactNumber: Joi.string()
      .allow("")
      .required()
      .label("SAFY Office Contact Number"),
    CustodialAgencyName: Joi.string()
      .allow("")
      .required()
      .label("Custodial Agency Name"),
    CustodialAgencyAddress: Joi.string()
      .allow("")
      .required()
      .label("Custodial Agency Address"),
    CustodialAgencyContactNumber: Joi.string()
      .allow("")
      .required()
      .label("Custodial Agency Contact Number"),
    CustodialCaseworkerName: Joi.string()
      .allow("")
      .required()
      .label("Caseworker Name"),
    CustodialCaseworkerAddress: Joi.string()
      .allow("")
      .required()
      .label("Custodial Caseworker Address"),
    CustodialCaseworkerContactNumber: Joi.string()
      .allow("")
      .required()
      .label("Custodial Caseworker Contact Number"),
    CustodialCaseworkerEmail: Joi.string()
      .allow("")
      .required()
      .label("Custodial Caseworker Email Address"),
    CaregiverName: Joi.string().required().label("Caregiver Name"),
    CaregiverAddress: Joi.string()
      .allow("")
      .required()
      .label("Caregiver Address"),
    ReasonForPlacement: Joi.string()
      .allow("")
      .required()
      .label("Reason for placement"),
    PermanencyPlan: Joi.string().required().label("Permanency plan"),
    SpecialNeeds: Joi.string().required().label("Special needs"),
    History: Joi.string().required().label("History"),
    Procedures: Joi.string().required().label("Procedures"),
    PotentialHarm: Joi.string().required().label("Potential risk"),
    OutOfControlAntecedents: Joi.string()
      .allow("")
      .required()
      .label("Antecedents"),
    PreviousInterventions: Joi.string()
      .allow("")
      .required()
      .label("Previous interventions"),
    PsychologicalFactors: Joi.string()
      .allow("")
      .required()
      .label("Psychological factors"),
    MedicalFactors: Joi.string().required().label("Medical factors"),
    BehaviorManagementInterventions: Joi.string()
      .allow("")
      .required()
      .label("Behavior management interventions"),
    Height: Joi.string().required().label("Height"),
    Weight: Joi.string().required().label("Weight"),
    HairColor: Joi.string().required().label("Hair color"),
    EyeColor: Joi.string().required().label("Eye color"),
    Allergies: Joi.string().allow("").label("Allergies"),
    Reactions: Joi.string().allow(""),
    EpiPenRequired: Joi.string().allow(""),
    RecentSurgeries: Joi.string().allow("").label("Hospital stays"),
    SurgeryComplications: Joi.string()
      .allow("")
      .required()
      .label("Surgery complications"),
    ComplicationsDetails: Joi.string()
      .allow("")
      .label("Surgery complication details")
      .when("SurgeryComplications", {
        is: "1",
        then: Joi.required(),
      }),
    Treated: Joi.string().required().label("Treated"),
    TreatedDetails: Joi.string()
      .allow("")
      .label("Treated Details")
      .when("Treated", { is: "1", then: Joi.required() }),
    LastDoctorVisit: Joi.string()
      .allow("")
      .required()
      .label("Last doctor visit"),
    ReasonForDoctorVisit: Joi.string()
      .allow("")
      .required()
      .label("Reason for doctor visit"),
    SafyContactFamily: Joi.string()
      .allow("")
      .required()
      .label("SAFY family contact"),
    SafyContactRestrictions: Joi.string()
      .allow("")
      .label("SAFY contact restrictions")
      .when("SafyContactFamily", {
        is: "1",
        then: Joi.required(),
      }),
    SafyNoContactDetails: Joi.string()
      .allow("")
      .label("SAFY no contact details")
      .when("SafyContactFamily", {
        is: "0",
        then: Joi.required(),
      }),
    FamilyContactName: Joi.string()
      .allow("")
      .label("Family contact name")
      .when("SafyContactFamily", {
        is: "1",
        then: Joi.required(),
      }),
    FamilyContactPhoneNumber: Joi.string()
      .allow("")
      .label("Family contact phone number")
      .when("SafyContactFamily", {
        is: "1",
        then: Joi.required(),
      }),
    FamilyContactAddress: Joi.string()
      .allow("")
      .label("Family contact address")
      .when("SafyContactFamily", {
        is: "1",
        then: Joi.required(),
      }),
    InitialEntry: Joi.string().required().label("Initial entry"),
    HealthScreening: Joi.string()
      .allow("")
      .label("Health screening")
      .when("InitialEntry", {
        is: "1",
        then: Joi.required(),
      }),
    HealthScreeningDate: Joi.when("InitialEntry", {
      is: "1",
      then: Joi.when("HealthScreening", {
        is: "1",
        then: Joi.string().required().label("Health screening date"),
      }),
    }),
    HealthConcerns: Joi.string().required().label("Health concerns"),
    HealthConcernsDetails: Joi.string()
      .allow("")
      .label("Health concerns details")
      .when("HealthConcerns", {
        is: "1",
        then: Joi.required(),
      }),
    MentalHealthServices: Joi.string()
      .allow("")
      .required()
      .label("Mental health services"),
    MentalHealthServicesDetails: Joi.string()
      .allow("")
      .label("Mental health services details")
      .when("MentalHealthServices", {
        is: "1",
        then: Joi.required(),
      }),
    RecipientSmokes: Joi.string()
      .allow("")
      .required()
      .label("Recipient smokes"),
    PermissionToSmoke: Joi.string()
      .allow("")
      .required()
      .label("Permission to smoke"),
    Unsupervised: Joi.string().required().label("Unsupervised"),
    UnsupervisedDetails: Joi.string()
      .allow("")
      .label("Unsupervised details")
      .when("Unsupervised", {
        is: "1",
        then: Joi.required(),
      }),
    GALCASAWorkerName: Joi.string().allow("").label("GAL name"),
    GALCASAWorkerPhoneNumber: Joi.string().allow("").label("GAL phone number"),
    GALCASAWorkerEmail: Joi.string().allow("").label("GAL worker email"),
    CASAWorkerName: Joi.string().allow("").label("CASA worker name"),
    CASAWorkerPhoneNumber: Joi.string()
      .allow("")
      .label("CASA worker phone number"),
    CASAWorkerEmail: Joi.string().allow("").label("CASA worker email"),
    DriversLicense: Joi.string().required().label("Driver's license"),
    PermissionToDrive: Joi.string()
      .allow("")
      .required()
      .label("Permission to drive"),
    StayWithFriend: Joi.string()
      .allow("")
      .required()
      .label("Permission to stay with friend"),
    RideWithUnderEighteen: Joi.string()
      .allow("")
      .required()
      .label("Permission to ride with under 18"),
    EducationProviders: Joi.string()
      .allow("")
      .required()
      .label("Education providers"),
    LastGrade: Joi.string().required().label("Last grade"),
    VisitationPlan: Joi.string().required().label("Visitation plan"),
    VisitationFrequency: Joi.string()
      .allow("")
      .required()
      .label("Visitation frequency"),
    VisitationLocation: Joi.string()
      .allow("")
      .required()
      .label("Visitation location"),
    VisitationDuration: Joi.string()
      .allow("")
      .required()
      .label("Visitation duration"),
    VisitationLimitations: Joi.string()
      .allow("")
      .required()
      .label("Visitation limitations"),
    VisitationCourtOrders: Joi.string()
      .allow("")
      .required()
      .label("Visitation court orders"),
    VisitationTransportation: Joi.string()
      .allow("")
      .required()
      .label("Visitation transportation"),
    EvacuationPlan: Joi.string().required().label("Evacuation plan"),
    SpecificRules: Joi.string().required().label("Specific rules"),
    PrivacyPractices: Joi.string()
      .allow("")
      .required()
      .label("Privacy practices"),
    SexEd: Joi.string()
      .allow("")
      .required()
      .label("HIV/AIDS and Pregnancy Prevention Education"),
    ClientRights: Joi.string()
      .allow("")
      .required()
      .label("Client Rights and Grievance"),
    TeenMomSIDS: Joi.string().allow(""),
  },
  "119C5CC2-99C4-EB11-A7AD-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateCompleted: Joi.string().allow(""),
    ReportStartDate: Joi.string().allow(""),
    ReportEndDate: Joi.string().allow(""),
    Month: Joi.string().required().label("Month"),
    Year: Joi.string().required().label("Year"),
    SocialInteraction: Joi.string()
      .allow("")
      .required()
      .label("Social Interaction / Skills"),
    Activities: Joi.string()
      .allow("")
      .required()
      .label("Community and Family Activities by Child and Foster Family"),
    Legal: Joi.string().required().label("Legal"),
    Education: Joi.string().required().label("Education"),
    Facility: Joi.string().required().label("Facility"),
    IndependentLiving: Joi.string()
      .allow("")
      .required()
      .label("Independent Living"),
    Health: Joi.string()
      .allow("")
      .required()
      .label("Physical Health, Disabilities and Medication"),
    Behavior: Joi.string().required().label("Behavior and Growth"),
    PrimaryFamily: Joi.string()
      .allow("")
      .required()
      .label("Primary Family Contact/Visitation"),
    Therapy: Joi.string()
      .allow("")
      .required()
      .label("Individual or Group Therapy"),
    Recommendations: Joi.string()
      .allow("")
      .required()
      .label("Recommendations and Next Steps"),
    ContactsVisits: Joi.string()
      .allow("")
      .required()
      .label("Contacts / Visits"),
    Interventions: Joi.string()
      .allow("")
      .required()
      .label("Interventions Between Recipient, SAFY Staff and Foster Parents"),
    AWOL: Joi.string().required().label("AWOL"),
    AttemptedSuicide: Joi.string()
      .allow("")
      .required()
      .label("Attempted Suicide by a Recipient"),
    ChangeOfPlacement: Joi.string()
      .allow("")
      .required()
      .label("Emergency Change of Placement"),
    OffsiteAssessment: Joi.string()
      .allow("")
      .required()
      .label("Off-site Emergency Assessment"),
    OffsiteTreatment: Joi.string()
      .allow("")
      .required()
      .label("Off-site Emergency Medical Treatment"),
    WeaponPossession: Joi.string()
      .allow("")
      .required()
      .label("Possession of a Weapon"),
    SubstancePossession: Joi.string()
      .allow("")
      .required()
      .label("Possession or Use of an Illegal Substance"),
    RemovalFromSchool: Joi.string()
      .allow("")
      .required()
      .label("Removal from School"),
    OutsideAgency: Joi.string()
      .allow("")
      .required()
      .label("Report or Involvement of an Outside Regulatory Agency"),
    ServiceGoals: Joi.string().required().label("Service Goals"),
    ReportOfStaffAbuse: Joi.string().required().label("Reports of staff abuse"),
    ReportOfNonStaffAbuse: Joi.string()
      .required()
      .label("Reports of non-staff abuse"),
    UnplannedDischarge: Joi.string().required().label("Unplanned discharge"),
    LengthOfStay: Joi.string()
      .allow("")
      .label("Length of stay")
      .when("UnplannedDischarge", {
        is: "1",
        then: Joi.required(),
      }),
    VisitationPlan: Joi.string().label("Visitation plan"),
    VisitationFrequency: Joi.string()
      .allow("")
      .label("Visitation frequency")
      .when("VisitationPlan", {
        is: "1",
        then: Joi.required(),
      }),
    VisitationGoal: Joi.string()
      .label("Achieved visitation goal")
      .when("VisitationPlan", {
        is: "1",
        then: Joi.required(),
      }),
    Runaway: Joi.string().required().label("Runaway"),
    DSSRequest: Joi.string().allow(""),
    DHRRequest: Joi.string().allow(""),
  },
  "2A2D1E64-B1C4-EB11-A7AD-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SAFYOfficeAddress: Joi.string().required().label("SAFY Office"),
    FromAgency: Joi.string().required().label("Agency"),
    FromStreetAddress: Joi.string()
      .allow("")
      .required()
      .label("Street Address"),
    FromCityState: Joi.string().required().label("City/State"),
    FromPhone: Joi.string().required().label("Phone"),
    FromFax: Joi.string().allow("").label("Fax"),
    FromContact: Joi.string().required().label("Contact"),
    SocialHistory: Joi.boolean(),
    DiagnosticAssessment: Joi.boolean(),
    ProgressReports: Joi.boolean(),
    LivingAssessments: Joi.boolean(),
    DischargeSummary: Joi.boolean(),
    TreatmentPlan: Joi.boolean(),
    Medications: Joi.boolean(),
    HIVTesting: Joi.boolean(),
    AIDSTesting: Joi.boolean(),
    SubstanceAbuse: Joi.boolean(),
    PsychConditions: Joi.boolean(),
    OtherDisclosed: Joi.boolean(),
    OtherDisclosedDetails: Joi.string()
      .allow("")
      .label("Other")
      .when("OtherDisclosed", {
        is: true,
        then: Joi.required(),
      }),
    Continuity: Joi.boolean(),
    TreatmentCompliance: Joi.boolean(),
    Employment: Joi.boolean(),
    Legal: Joi.boolean(),
    FamilyInvolvement: Joi.boolean(),
    PhysicianInvolvement: Joi.boolean(),
    SchoolInvolvement: Joi.boolean(),
    OtherPurpose: Joi.boolean(),
    OtherPurposeDetails: Joi.string()
      .allow("")
      .label("Other")
      .when("OtherPurpose", {
        is: true,
        then: Joi.required(),
      }),
    OneYear: Joi.boolean(),
    NinetyDays: Joi.boolean(),
    SixMonths: Joi.boolean(),
    OtherAmount: Joi.boolean(),
    OtherAmountDetails: Joi.string()
      .allow("")
      .label("Other")
      .when("OtherAmount", {
        is: true,
        then: Joi.required(),
      }),
    Written: Joi.boolean(),
    Verbal: Joi.boolean(),
    Fax: Joi.boolean(),
    Audio: Joi.boolean(),
    Video: Joi.boolean(),
    Email: Joi.boolean(),
    PermissionForAll: Joi.boolean(),
    ReleaseInEffect: Joi.boolean(),
    SexOffender: Joi.boolean(),
    CancellationDate: Joi.string().allow(""),
    CancellationTime: Joi.string().allow(""),
    CancellationMode: Joi.string().allow(""),
  },
  "97CB3C9C-B3C4-EB11-A7AD-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SAFYOfficeAddress: Joi.string().required().label("SAFY Office"),
    FromInfo: Joi.string().required().label("From Info"),
    SocialHistory: Joi.boolean(),
    DiagnosticAssessment: Joi.boolean(),
    ProgressReports: Joi.boolean(),
    LivingAssessments: Joi.boolean(),
    DischargeSummary: Joi.boolean(),
    TreatmentPlan: Joi.boolean(),
    Medications: Joi.boolean(),
    HIVTesting: Joi.boolean(),
    AIDSTesting: Joi.boolean(),
    SubstanceAbuse: Joi.boolean(),
    PsychConditions: Joi.boolean(),
    OtherDisclosed: Joi.boolean(),
    OtherDisclosedDetails: Joi.string()
      .allow("")
      .label("Other")
      .when("OtherDisclosed", {
        is: true,
        then: Joi.required(),
      }),
    Continuity: Joi.boolean(),
    TreatmentCompliance: Joi.boolean(),
    Employment: Joi.boolean(),
    Legal: Joi.boolean(),
    FamilyInvolvement: Joi.boolean(),
    PhysicianInvolvement: Joi.boolean(),
    SchoolInvolvement: Joi.boolean(),
    OtherPurpose: Joi.boolean(),
    OtherPurposeDetails: Joi.string()
      .allow("")
      .label("Other")
      .when("OtherPurpose", {
        is: true,
        then: Joi.required(),
      }),
    OneYear: Joi.boolean(),
    NinetyDays: Joi.boolean(),
    SixMonths: Joi.boolean(),
    OtherAmount: Joi.boolean(),
    OtherAmountDetails: Joi.string()
      .allow("")
      .label("Other")
      .when("OtherAmount", {
        is: true,
        then: Joi.required(),
      }),
    Written: Joi.boolean(),
    Verbal: Joi.boolean(),
    Fax: Joi.boolean(),
    Audio: Joi.boolean(),
    Video: Joi.boolean(),
    Email: Joi.boolean(),
    PermissionForAll: Joi.boolean(),
    ReleaseInEffect: Joi.boolean(),
    SexOffender: Joi.boolean(),
    CancellationDate: Joi.string().allow(""),
    CancellationTime: Joi.string().allow(""),
    CancellationMode: Joi.string().allow(""),
  },
  "474093A1-E6E0-EB11-A7AD-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    WhyPlan: Joi.string().allow("").label("Why are we planning for success?"),
    Sweating: Joi.boolean(),
    BreathingHard: Joi.boolean(),
    RacingHeart: Joi.boolean(),
    ClenchingTeeth: Joi.boolean(),
    ClenchingFists: Joi.boolean(),
    RedFaced: Joi.boolean(),
    LoudVoice: Joi.boolean(),
    Rocking: Joi.boolean(),
    Fidgety: Joi.boolean(),
    Crying: Joi.boolean(),
    SleepingAlot: Joi.boolean(),
    DifficultSleeping: Joi.boolean(),
    Pacing: Joi.boolean(),
    Nauseous: Joi.boolean(),
    Alone: Joi.boolean(),
    RacingThoughts: Joi.boolean(),
    FallAsleep: Joi.boolean(),
    OtherSign: Joi.string().allow(""),
    Yelling: Joi.boolean(),
    ReadingHome: Joi.boolean(),
    ExerciseHome: Joi.boolean(),
    WritingHome: Joi.boolean(),
    DrawingHome: Joi.boolean(),
    Watching: Joi.boolean(),
    SupportHome: Joi.boolean(),
    Playing: Joi.boolean(),
    Shower: Joi.boolean(),
    MusicHome: Joi.boolean(),
    WalkingHome: Joi.boolean(),
    BlanketHome: Joi.boolean(),
    AnimalsHome: Joi.boolean(),
    OtherHomeStrategy: Joi.string().allow(""),
    ReadingSchool: Joi.boolean(),
    ExerciseSchool: Joi.boolean(),
    WritingSchool: Joi.boolean(),
    DrawingSchool: Joi.boolean(),
    SupportSchool: Joi.boolean(),
    SupportTeacher: Joi.boolean(),
    MusicSchool: Joi.boolean(),
    WalkingSchool: Joi.boolean(),
    BlanketSchool: Joi.boolean(),
    AnimalsSchool: Joi.boolean(),
    OtherSchoolStrategy: Joi.string().allow(""),
    MySupportsHome: Joi.string()
      .allow("")
      .label("My Supports at Home/Community"),
    MySupportsSchool: Joi.string().allow("").label("My Supports at School"),
    InControl: Joi.string().allow("").label("Stay in control"),
    InControlPast: Joi.string().allow("").label("Stay in control in the past"),
    Needs: Joi.string().allow("").label("What do you need"),
    Reasons: Joi.string().allow("").label("Reasons for success"),
    BehaviorIncrease: Joi.string().allow("").label("Increased risk of harm"),
    Challenges: Joi.string().allow("").label("Challenges"),
    Regulate: Joi.string().allow("").label("Already regulating"),
    ExternalAntecedents: Joi.string().allow("").label("External antecedents"),
    EnvironmentalAntecedents: Joi.string()
      .allow("")
      .label("Environmental antecedents"),
    TimesThatTrigger: Joi.string().allow("").label("Times that trigger"),
    Awareness: Joi.string().allow("").label("Child awareness"),
    UnableToRegulate: Joi.string().allow("").label("Unable to regulate"),
    IncreaseSafety: Joi.string().allow("").label("Increase safety"),
    SupportSafety: Joi.string().allow("").label("Support safety"),
    StrategiesToLearn: Joi.string().allow("").label("Strategies to learn"),
    HowTaught: Joi.string().allow("").label("How are strategies taught"),
    DoDifferently: Joi.string().allow("").label("What will we do differently"),
    Escalated: Joi.string().allow("").label("Feeling escalated"),
    VerbalCues: Joi.string().allow("").label("Verbal cues"),
    NonVerbalCues: Joi.string().allow("").label("Non-verbal cues"),
    FacilitateSkills: Joi.string()
      .allow("")
      .label("Facilitate problem solving skills"),
    Independence: Joi.string().allow("").label("Child independence"),
    SupportAdults: Joi.string().allow("").label("Who can support us"),
    AdditionalNotes: Joi.string().allow(""),
    SafyNumber: Joi.string().allow("").label("SAFY After-Hours Number"),
    CrisisCenter: Joi.string().allow("").label("Crisis Center"),
    Hospital: Joi.string().allow("").label("Hospital/ED"),
    OtherEmergency: Joi.string().allow(""),
  },
  "BE6F59A3-9DE9-EB11-A7AD-DC98408D5418": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    WarningSignsOne: Joi.string().required().label("Warning Sign #1"),
    WarningSignsTwo: Joi.string().allow(""),
    WarningSignsThree: Joi.string().allow(""),
    CopingOne: Joi.string().required().label("Coping Strategy #1"),
    CopingTwo: Joi.string().allow(""),
    CopingThree: Joi.string().allow(""),
    CopingFour: Joi.string().allow(""),
    SupportOne: Joi.string()
      .allow("")
      .required()
      .label("People and Social settings #1"),
    SupportOneNumber: Joi.string().allow(""),
    SupportTwo: Joi.string().allow(""),
    SupportTwoNumber: Joi.string().allow(""),
    SupportThree: Joi.string().allow(""),
    SupportThreeNumber: Joi.string().allow(""),
    SupportFour: Joi.string().allow(""),
    SupportFourNumber: Joi.string().allow(""),
    SpecificPeopleOne: Joi.string()
      .allow("")
      .required()
      .label("Specific person #1"),
    SpecificPeopleOneNumber: Joi.string().allow(""),
    SpecificPeopleTwo: Joi.string().allow(""),
    SpecificPeopleTwoNumber: Joi.string().allow(""),
    ClinicianName: Joi.string().allow(""),
    ClinicianNumber: Joi.string().allow(""),
    AfterHoursNumber: Joi.string()
      .allow("")
      .required()
      .label("After hours crises line #"),
    LocalService: Joi.string()
      .allow("")
      .required()
      .label("Local Emergency Service"),
    SafeEnvironmentThree: Joi.string()
      .allow("")
      .required()
      .label("Safe Environment #3"),
    SafeEnvironmentFour: Joi.string().allow(""),
  },
  "A02D05CC-9CE9-EB11-A7AD-DC98408D5418": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SafetyPlanDate: Joi.date().required().label("Safety Plan Date"),
    CareTeam: Joi.string().required().label("Care Team"),
    ProblemBehaviors: Joi.string()
      .allow("")
      .required()
      .label("Problem Behaviors"),
    GoalOne: Joi.string().required().label("Goal #1"),
    GoalTwo: Joi.string().allow(""),
    GoalThree: Joi.string().allow(""),
    RiskFactorOne: Joi.string().required().label("Risk Factor #1"),
    RiskFactorTwo: Joi.string().allow(""),
    RiskFactorThree: Joi.string().allow(""),
    InterventionOne: Joi.string().required().label("Intervention #1"),
    InterventionTwo: Joi.string().allow(""),
    InterventionThree: Joi.string().allow(""),
    InterventionFour: Joi.string().allow(""),
    DeescalationOne: Joi.string()
      .allow("")
      .required()
      .label("De-escalation intervention #1"),
    DeescalationTwo: Joi.string().allow(""),
    DeescalationThree: Joi.string().allow(""),
    SameArea: Joi.boolean(),
    SameFloor: Joi.boolean(),
    Supervises: Joi.boolean(),
    OutOfRoom: Joi.boolean(),
    ShutDoor: Joi.boolean(),
    RestrictedAreas: Joi.boolean(),
    RestrictedAreasDetails: Joi.string()
      .allow("")
      .label("Restricted Area Details")
      .when("RestrictedAreas", { is: true, then: Joi.string().required() }),
    RestrictedObjects: Joi.boolean(),
    RestrictedObjectsDetails: Joi.string()
      .allow("")
      .label("Restricted Objects Details")
      .when("RestrictedObjects", { is: true, then: Joi.string().required() }),
    OtherRoutine: Joi.string().allow(""),
    OwnRoom: Joi.boolean(),
    RoomWithYouth: Joi.boolean(),
    RoomWithOlderKids: Joi.boolean(),
    AdultAsleep: Joi.boolean(),
    DoorAlarm: Joi.boolean(),
    MotionDetector: Joi.boolean(),
    NeedPlan: Joi.boolean(),
    SchoolTransportation: Joi.boolean(),
    EscortToSchool: Joi.boolean(),
    EscortInSchool: Joi.boolean(),
    EscortToClassrooms: Joi.boolean(),
    NoEscort: Joi.boolean(),
    SupervisedBathroom: Joi.boolean(),
    AssignedPerson: Joi.string().allow(""),
    OtherRecommendations: Joi.string().allow(""),
    DiscontinuedDate: Joi.date().allow(""),
  },
  "93E82F68-B9EB-EB11-A7AD-DC98408D5418": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    ClientPLR: Joi.string().required().label("Client's PLR"),
    Relationship: Joi.string().required().label("Relationship"),
    MedicationDetails: Joi.string().required().label("Medications"),
  },
  "D1D5BE25-E3EB-EB11-A7AD-DC98408D5418": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SAFYOfficeAddress: Joi.string().required().label("SAFY Office"),
    FromInfo: Joi.string().required().label("From Info"),
    AllRecords: Joi.boolean(),
    SocialHistory: Joi.boolean(),
    DiagnosticAssessment: Joi.boolean(),
    ProgressReports: Joi.boolean(),
    LivingAssessments: Joi.boolean(),
    DischargeSummary: Joi.boolean(),
    TreatmentPlan: Joi.boolean(),
    Medications: Joi.boolean(),
    CommunicableDiseases: Joi.boolean(),
    SubstanceAbuse: Joi.boolean(),
    PsychConditions: Joi.boolean(),
    ReleaseDate: Joi.string().required().label("Release Date"),
  },
  "43E53ACA-28EE-EB11-B563-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
  },
  "E0CF07BA-BBEB-EB11-A7AD-DC98408D5418": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    AssessmentInitials: Joi.string().allow(""),
    TherapyInitials: Joi.string().allow(""),
    TrainingInitials: Joi.string().allow(""),
    RehabServicesInitials: Joi.string().allow(""),
    ConferencingInitials: Joi.string().allow(""),
    Voicemail: Joi.string().allow(""),
    TextMessage: Joi.string().allow(""),
    Email: Joi.string().allow(""),
    ClientRights: Joi.boolean(),
    GrievanceForm: Joi.boolean(),
    PrivacyPractices: Joi.boolean(),
  },
  "8CA2DB08-D3FE-EB11-B563-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SafetyPlanDate: Joi.string().required().label("Safety Plan Date"),
    CCDCFSWorker: Joi.string().required().label("CCDCFS Worker"),
    SAFYWorker: Joi.string().required().label("SAFY Worker"),
    Relative: Joi.string().required().label("Relative"),
    Friend: Joi.string().required().label("Friend"),
    ProbationOfficer: Joi.string()
      .allow("")
      .required()
      .label("Probation Officer"),
    Other: Joi.string().allow(""),
    Environments: Joi.string().required().label("Environments"),
    Behavior: Joi.string().required().label("Behavior"),
    Plan: Joi.string().required().label("Plan of Action"),
  },
  "97354D51-D9FE-EB11-B563-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateReceived: Joi.string().required().label("Date received"),
    DateAssigned: Joi.string().required().label("Date assigned"),
    AssignedTo: Joi.string().required().label("Assigned to"),
    FirstFamilyContactDate: Joi.string().allow(""),
    FirstFamilyContactOutcome: Joi.string().allow(""),
    SecondFamilyContactDate: Joi.string().allow(""),
    SecondFamilyContactOutcome: Joi.string().allow(""),
    ThirdFamilyContactDate: Joi.string().allow(""),
    ThirdFamilyContactOutcome: Joi.string().allow(""),
    FirstCCDCFSContactDate: Joi.string().allow(""),
    FirstCCDCFSContactOutcome: Joi.string().allow(""),
    SecondCCDCFSContactDate: Joi.string().allow(""),
    SecondCCDCFSContactOutcome: Joi.string().allow(""),
    ThirdCCDCFSContactDate: Joi.string().allow(""),
    ThirdCCDCFSContactOutcome: Joi.string().allow(""),
    Notes: Joi.string().allow(""),
  },
  "252F2CDA-62FF-EB11-B563-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    AllServices: Joi.boolean(),
    AllServicesInitials: Joi.string().allow(""),
    PDA: Joi.boolean(),
    PDAInitials: Joi.string().allow(""),
    Psychotherapy: Joi.boolean(),
    PsychotherapyInitials: Joi.string().allow(""),
    CPST: Joi.boolean(),
    CPSTInitials: Joi.string().allow(""),
    InHome: Joi.boolean(),
    InHomeInitials: Joi.string().allow(""),
    Assessment: Joi.boolean(),
    AssessmentInitials: Joi.string().allow(""),
    MentalHealth: Joi.boolean(),
    MentalHealthEmail: Joi.string().allow(""),
    MentalHealthInitials: Joi.string().allow(""),
    Consent: Joi.boolean(),
    PrivacyPractices: Joi.boolean(),
    LeaveMessages: Joi.boolean(),
    LeavesMessagesPhone: Joi.string().allow(""),
    Text: Joi.boolean(),
    TextPhone: Joi.string().allow(""),
    Email: Joi.boolean(),
    EmailAddress: Joi.string().allow(""),
  },
  "D455C26F-B906-EC11-B563-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    FosterCare: Joi.boolean(),
    FosterCareInitials: Joi.string().allow(""),
    DiagnosticAssessment: Joi.boolean(),
    DiagnosticAssessmentInitials: Joi.string().allow(""),
    Therapy: Joi.boolean(),
    TherapyInitials: Joi.string().allow(""),
    Management: Joi.boolean(),
    ManagementInitials: Joi.string().allow(""),
    RehabilitativeServices: Joi.boolean(),
    RehabilitativeServicesInititals: Joi.string().allow(""),
    Conferencing: Joi.boolean(),
    ConferencingInititals: Joi.string().allow(""),
    Voicemail: Joi.boolean(),
    Text: Joi.boolean(),
    Email: Joi.boolean(),
    CAPAttorneyName: Joi.string().allow(""),
    CAPAttorneyPhone: Joi.string().allow(""),
    BiologicalParentName: Joi.string().allow(""),
    BiologicalParentPhone: Joi.string().allow(""),
    CASAWorkerName: Joi.string().allow(""),
    CASAWorkerPhone: Joi.string().allow(""),
    ILWorkerName: Joi.string().allow(""),
    ILWorkerPhone: Joi.string().allow(""),
    TherapistName: Joi.string().allow(""),
    TherapistPhone: Joi.string().allow(""),
    OtherName: Joi.string().allow(""),
    OtherPhone: Joi.string().allow(""),
    Unsupervised: Joi.string().allow(""),
    UnsupervisedDuration: Joi.string().allow(""),
    ContactPrimary: Joi.string().allow(""),
    ContactRestrictions: Joi.string().allow(""),
    PrimaryVisitsScheduled: Joi.string().allow(""),
    PrimaryVisitsDay: Joi.string().allow(""),
    PrimaryVisitTime: Joi.string().allow(""),
    PrimaryVisitDuration: Joi.string().allow(""),
    PrimaryVisitLocation: Joi.string().allow(""),
    FamilyCanAttend: Joi.string().allow(""),
    VisitLimitations: Joi.string().allow(""),
    CellPhoneRestrictions: Joi.boolean(),
    CellPhoneRestrictionsDetails: Joi.string().allow(""),
    OvernightRestrictions: Joi.boolean(),
    OvernightRestrictionsDetails: Joi.string().allow(""),
    RidingRestrictions: Joi.boolean(),
    RidingRestrictionsDetails: Joi.string().allow(""),
    PublicTransportationRestrictions: Joi.boolean(),
    PublicTransportationRestrictionsDetails: Joi.string().allow(""),
    InternetRestrictions: Joi.boolean(),
    InternetRestrictionsDetails: Joi.string().allow(""),
    DrivingLicenseRestrictions: Joi.boolean(),
    DrivingLicenseRestrictionsDetails: Joi.string().allow(""),
    CurfewRestrictions: Joi.boolean(),
    CurfewRestrictionsDetails: Joi.string().allow(""),
    OtherOneRestrictions: Joi.boolean(),
    OtherOneRestrictionsDetails: Joi.string().allow(""),
    OtherTwoRestrictions: Joi.boolean(),
    OtherTwoRestrictionsDetails: Joi.string().allow(""),
    Appointments: Joi.string().allow(""),
    SchoolOfOrigin: Joi.string().allow(""),
    SchoolOfOriginDetails: Joi.string().allow(""),
    CCSDTransportation: Joi.string().allow(""),
  },
  "126BC11F-6C07-EC11-B563-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    Effective: Joi.string().required().label("Effective"),
    Monday: Joi.boolean(),
    MondayTime: Joi.string().allow(""),
    Tuesday: Joi.boolean(),
    TuesdayTime: Joi.string().allow(""),
    Wednesday: Joi.boolean(),
    WednesdayTime: Joi.string().allow(""),
    Thursday: Joi.boolean(),
    ThursdayTime: Joi.string().allow(""),
    Friday: Joi.boolean(),
    FridayTime: Joi.string().allow(""),
    Saturday: Joi.boolean(),
    SaturdayTime: Joi.string().allow(""),
    Sunday: Joi.boolean(),
    SundayTime: Joi.string().allow(""),
  },
  "68DB8DF9-7807-EC11-B563-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    TargetedBehaviors: Joi.string().allow(""),
    MeetingDate: Joi.string().allow(""),
    MeetingLocation: Joi.string().allow(""),
    NextMeetingDate: Joi.string().allow(""),
  },
  "FF21DF5E-A909-EC11-B563-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    PDA: Joi.boolean(),
    PDAInitials: Joi.string().allow(""),
    Psychotherapy: Joi.boolean(),
    PsychotherapyInitials: Joi.string().allow(""),
    CPST: Joi.boolean(),
    CPSTInitials: Joi.string().allow(""),
    InHome: Joi.boolean(),
    InHomeInitials: Joi.string().allow(""),
    Addiction: Joi.boolean(),
    AddictionInitials: Joi.string().allow(""),
    NotAllowed: Joi.boolean(),
    NotAllowedInitials: Joi.string().allow(""),
    Psychiatric: Joi.boolean(),
    PsychiatricInitials: Joi.string().allow(""),
    MentalHealth: Joi.boolean(),
    MentalHealthEmail1: Joi.string().allow(""),
    MentalHealthEmail2: Joi.string().allow(""),
    MentalHealthInitials: Joi.string().allow(""),
    Consent: Joi.boolean(),
    PrivacyPractices: Joi.boolean(),
    LeaveMessages: Joi.boolean(),
    LeavesMessagesPhone: Joi.string().allow(""),
    Text: Joi.boolean(),
    TextPhone: Joi.string().allow(""),
    Email: Joi.boolean(),
    EmailAddress: Joi.string().allow(""),
  },
  "81BF06BB-AE09-EC11-B563-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    InsuranceDenied: Joi.boolean(),
    Consent: Joi.boolean(),
    Policy: Joi.boolean(),
    Amend: Joi.boolean(),
  },
  "F8588AF4-B309-EC11-B563-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SchoolName: Joi.string().required().label("School Name"),
    GuardianName: Joi.string()
      .allow("")
      .required()
      .label("Parent/Guardian Name"),
    GuardianRelationship: Joi.string()
      .allow("")
      .required()
      .label("Parent/Guardian Relationship"),
    EmailAddress: Joi.string().required().label("Email Address"),
  },
  "426251CA-D609-EC11-B563-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SafetyPlanDate: Joi.date().required().label("Safety Plan Date"),
    CareTeam: Joi.string().allow(""),
    Guardian: Joi.string().allow(""),
    GuardianContact: Joi.string().allow(""),
    FosterParent: Joi.string().allow(""),
    FosterParentContact: Joi.string().allow(""),
    Relatives: Joi.string().allow(""),
    RelativesContact: Joi.string().allow(""),
    Teachers: Joi.string().allow(""),
    TeachersContact: Joi.string().allow(""),
    ProbationOfficer: Joi.string().allow(""),
    ProbationOfficerContact: Joi.string().allow(""),
    ServicesWorker: Joi.string().allow(""),
    ServicesWorkerContact: Joi.string().allow(""),
    Counselor: Joi.string().allow(""),
    CounselorContact: Joi.string().allow(""),
    OthersResponsible: Joi.string().allow(""),
    OthersResponsibleContact: Joi.string().allow(""),
    SafetyPlan: Joi.string().allow(""),
    WarningSign1: Joi.string().allow(""),
    WarningSign2: Joi.string().allow(""),
    WarningSign3: Joi.string().allow(""),
    WarningSign4: Joi.string().allow(""),
    WarningSign5: Joi.string().allow(""),
    WarningSign6: Joi.string().allow(""),
    WarningSign7: Joi.string().allow(""),
    WarningSign8: Joi.string().allow(""),
    WarningSign9: Joi.string().allow(""),
    WarningSign10: Joi.string().allow(""),
    KeepSafe1: Joi.string().allow(""),
    KeepSafe2: Joi.string().allow(""),
    KeepSafe3: Joi.string().allow(""),
    KeepSafe4: Joi.string().allow(""),
    KeepSafe5: Joi.string().allow(""),
    KeepSafe6: Joi.string().allow(""),
    KeepSafe7: Joi.string().allow(""),
    KeepSafe8: Joi.string().allow(""),
    KeepSafe9: Joi.string().allow(""),
    KeepSafe10: Joi.string().allow(""),
    CounselorPhone: Joi.string().allow(""),
    Visible: Joi.boolean(),
    SameArea: Joi.boolean(),
    ShutDoor: Joi.boolean(),
    RestrictedAreas: Joi.boolean(),
    RestrictedAreasDetails: Joi.string()
      .allow("")
      .label("Restricted Area Details")
      .when("RestrictedAreas", { is: true, then: Joi.string().required() }),
    RestrictedObjects: Joi.boolean(),
    RestrictedObjectsDetails: Joi.string()
      .allow("")
      .label("Restricted Objects Details")
      .when("RestrictedObjects", { is: true, then: Joi.string().required() }),
    OtherRoutine: Joi.boolean(),
    OtherRoutineDetails: Joi.string().allow(""),
    OwnRoom: Joi.boolean(),
    RoomWithYouth: Joi.boolean(),
    ParentsRoom: Joi.boolean(),
    CommonArea: Joi.boolean(),
    OtherLocation: Joi.boolean(),
    OtherLocationDetails: Joi.string().allow(""),
    AdultAsleep: Joi.boolean(),
    DoorAlarm: Joi.boolean(),
    MotionDetector: Joi.boolean(),
    OtherObservation: Joi.boolean(),
    OtherObservationDetails: Joi.string().allow(""),
    NoSchool: Joi.boolean(),
    EscortToSchool: Joi.boolean(),
    EscortInSchool: Joi.boolean(),
    EscortToClassrooms: Joi.boolean(),
    SupervisedBathroom: Joi.boolean(),
    NoEscort: Joi.boolean(),
    SchoolTransportation: Joi.boolean(),
    OtherSchool: Joi.boolean(),
    OtherSchoolDetails: Joi.string().allow(""),
  },
  "56471597-7907-EC11-B563-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateOfIntake: Joi.string().required().label("Date of Intake"),
    YouthStreet: Joi.string()
      .allow("")
      .required()
      .label("Youth Street Address"),
    YouthCity: Joi.string().required().label("City"),
    YouthState: Joi.string().required().label("State"),
    YouthZip: Joi.string().required().label("Zip"),
    YouthPrimaryPhone: Joi.string()
      .allow("")
      .required()
      .label("Youth Primary Phone"),
    YouthAltPhone: Joi.string().required().label("Youth Alt. Phone"),
    EmergencyContactName: Joi.string()
      .allow("")
      .required()
      .label("Contact Name"),
    EmergencyContactRelationship: Joi.string()
      .allow("")
      .required()
      .label("Relationship"),
    EmergencyContactStreet: Joi.string()
      .allow("")
      .required()
      .label("Contact Street Address"),
    EmergencyContactCity: Joi.string().required().label("City"),
    EmergencyContactState: Joi.string().required().label("State"),
    EmergencyContactZip: Joi.string().required().label("Zip"),
    EmergencyContactPrimaryPhone: Joi.string()
      .allow("")
      .required()
      .label("Contact Primary Phone"),
    EmergencyContactAltPhone: Joi.string()
      .allow("")
      .required()
      .label("Contact Alt. Phone"),
    ESLAccomodations: Joi.string().required().label("ESL Accomodations"),
    ESLAccomodationsDetails: Joi.string()
      .allow("")
      .label("ESL Accomodation Details")
      .when("ESLAccomodations", { is: "1", then: Joi.required() }),
    Allergies: Joi.string().required().label("Allergies"),
    AllergiesDetails: Joi.string()
      .allow("")
      .label("Allergy Details")
      .when("Allergies", { is: "1", then: Joi.required() }),
    AmericanIndian: Joi.boolean(),
    White: Joi.boolean(),
    Asian: Joi.boolean(),
    OtherRace: Joi.boolean(),
    OtherRaceDetails: Joi.string()
      .allow("")
      .label("Other Race")
      .when("OtherRace", { is: true, then: Joi.required() }),
    AfricanAmerican: Joi.boolean(),
    MultipleRaces: Joi.boolean(),
    Hispanic: Joi.boolean(),
    RaceNotReported: Joi.boolean(),
    Hawaiian: Joi.boolean(),
    Male: Joi.boolean(),
    Female: Joi.boolean(),
    OtherGender: Joi.boolean(),
    OtherGenderDetails: Joi.string()
      .allow("")
      .label("Other Gender")
      .when("OtherGender", { is: true, then: Joi.required() }),
    GenderNotReported: Joi.boolean(),
    IdentifyTheft: Joi.boolean(),
    SexualAbuse: Joi.boolean(),
    KidnappingByParent: Joi.boolean(),
    Homicide: Joi.boolean(),
    KidnappingByStranger: Joi.boolean(),
    DomesticViolence: Joi.boolean(),
    VehicularVictim: Joi.boolean(),
    TeenDating: Joi.boolean(),
    Arson: Joi.boolean(),
    DUIDWI: Joi.boolean(),
    Bullying: Joi.boolean(),
    TerrorismDomestic: Joi.boolean(),
    Burglary: Joi.boolean(),
    TerrorismInternational: Joi.boolean(),
    PhysicalAbuse: Joi.boolean(),
    HumanTraffickingSex: Joi.boolean(),
    Robbery: Joi.boolean(),
    HumanTraffickingLabor: Joi.boolean(),
    ChildPorn: Joi.boolean(),
    HateCrime: Joi.boolean(),
    Stalking: Joi.boolean(),
    CourtOrder: Joi.boolean(),
    OtherVictim: Joi.boolean(),
    OtherVictimDetails: Joi.string()
      .allow("")
      .label("Other")
      .when("OtherVictim", { is: true, then: Joi.required() }),
    Deaf: Joi.boolean(),
    Homeless: Joi.boolean(),
    Disabilty: Joi.boolean(),
    Immigrant: Joi.boolean(),
    LimitedEnglish: Joi.boolean(),
    LGBTQ: Joi.boolean(),
    OtherClass: Joi.boolean(),
    OtherClassDetails: Joi.string()
      .allow("")
      .label("Other classification")
      .when("OtherClass", { is: true, then: Joi.required() }),
    Deodorant: Joi.boolean(),
    Shampoo: Joi.boolean(),
    Conditioner: Joi.boolean(),
    Soap: Joi.boolean(),
    Lotion: Joi.boolean(),
    Toothpaste: Joi.boolean(),
    Toothbrush: Joi.boolean(),
    Pads: Joi.boolean(),
    Tampons: Joi.boolean(),
    OtherHygieneDetails: Joi.string().allow(""),
    Backpack: Joi.boolean(),
    Pencils: Joi.boolean(),
    Pens: Joi.boolean(),
    Folders: Joi.boolean(),
    Notebook: Joi.boolean(),
    Crayons: Joi.boolean(),
    PencilSharpener: Joi.boolean(),
    Notecards: Joi.boolean(),
    OtherSuppliesDetails: Joi.string().allow(""),
    Socks: Joi.boolean(),
    Underwear: Joi.boolean(),
    Tshirts: Joi.boolean(),
    Gloves: Joi.boolean(),
    Hat: Joi.boolean(),
    OtherClothingDetails: Joi.string().allow(""),
    BusRoute: Joi.boolean(),
    BusPass: Joi.boolean(),
    CabNumber: Joi.boolean(),
    OtherTransportationDetails: Joi.string().allow(""),
    Therapist: Joi.boolean(),
    CaseMgmt: Joi.boolean(),
    Pantry: Joi.boolean(),
    Employment: Joi.boolean(),
    AODServices: Joi.boolean(),
    ChildrenServices: Joi.boolean(),
    Shelters: Joi.boolean(),
    CrimeVictimServices: Joi.boolean(),
    OtherReferralsDetails: Joi.string().allow(""),
    ItemsDistributed: Joi.string().required().label("Were Items Distributed"),
    ItemsNotDistributedDetails: Joi.string()
      .allow("")
      .label("Reason items weren't distributed")
      .when("ItemsDistributed", { is: "0", then: Joi.required() }),
    WantCopy: Joi.string().required().label("Copy for your records"),
  },
  "FDD13BC3-9611-EC11-B563-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateRangeOfReport: Joi.string()
      .allow("")
      .required()
      .label("Date range of report"),
    CaregiverNames: Joi.string()
      .allow("")
      .required()
      .label("Caregiver name(s)"),
    ChildrenNames: Joi.string()
      .allow("")
      .required()
      .label("Child(ren) name(s)"),
    DatesOfService: Joi.string().required().label("Dates of service"),
    Tier: Joi.string().required().label("Tier"),
    InterventionSpecialist: Joi.string().allow(""),
    Therapist: Joi.string().allow(""),
    SkillsCoach: Joi.string().allow(""),
    OnCall: Joi.string().allow(""),
    GoalDescription: Joi.string().allow(""),
    FamilyResponse: Joi.string().allow(""),
    WeeklyProgress: Joi.string().allow(""),
    OverallProgress: Joi.string().allow(""),
    InterventionSpecialistNeeds: Joi.string().allow(""),
    AddressInterventionSpecialistNeeds: Joi.string().allow(""),
    TherapistNeeds: Joi.string().allow(""),
    AddressTherapistNeeds: Joi.string().allow(""),
    SkillsCoachNeeds: Joi.string().allow(""),
    AddressSkillsCoachNeeds: Joi.string().allow(""),
    CrisisIntervention: Joi.boolean(),
    ISTherapeuticIntervention: Joi.boolean(),
    SkillBasedCoaching: Joi.boolean(),
    TherapistTherapeuticIntervention: Joi.boolean(),
    TraumaEducation: Joi.boolean(),
    ProfessionalCollaboration: Joi.boolean(),
    CaregiverSupportGroup: Joi.boolean(),
    CrisisSupport: Joi.boolean(),
    CommunityMeetings: Joi.boolean(),
    ClosureSession: Joi.boolean(),
    InterventionSpecialistName: Joi.string()
      .allow("")
      .required()
      .label("Intervention Specialist Name"),
    InterventionSpecialistPhone: Joi.string()
      .allow("")
      .required()
      .label("Intervention Specialist Phone"),
    InterventionSpecialistEmail: Joi.string()
      .allow("")
      .required()
      .label("Intervention Specialist Email"),
    TherapistName: Joi.string().required().label("Therapist Name"),
    TherapistPhone: Joi.string().required().label("Therapist Phone"),
    TherapistEmail: Joi.string().required().label("Therapist Email"),
    SkillsCoachName: Joi.string()
      .allow("")
      .required()
      .label("Skills Coach Name"),
    SkillsCoachPhone: Joi.string()
      .allow("")
      .required()
      .label("Skills Coach Phone"),
    SkillsCoachEmail: Joi.string()
      .allow("")
      .required()
      .label("Skills Coach Email"),
    ProgramSupervisorName: Joi.string()
      .allow("")
      .required()
      .label("Program Supervisor Name"),
    ProgramSupervisorPhone: Joi.string()
      .allow("")
      .required()
      .label("Program Supervisor Phone"),
    ProgramSupervisorEmail: Joi.string()
      .allow("")
      .required()
      .label("Program Supervisor Email"),
  },
  "BFF683E8-B211-EC11-B563-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SAFYOfficeAddress: Joi.string().required().label("SAFY Office"),
    FromInfo: Joi.string().required().label("From Info"),
    AllRecords: Joi.boolean(),
    SocialHistory: Joi.boolean(),
    ContinuityOfCare: Joi.boolean(),
    DiagnosticAssessment: Joi.boolean(),
    TreatmentCompliance: Joi.boolean(),
    ProgressReports: Joi.boolean(),
    Employment: Joi.boolean(),
    LivingAssessments: Joi.boolean(),
    Legal: Joi.boolean(),
    DischargeSummary: Joi.boolean(),
    FamilyInvolvement: Joi.boolean(),
    TreatmentPlan: Joi.boolean(),
    PhysicalInvolvement: Joi.boolean(),
    Medications: Joi.boolean(),
    SchoolInvolvement: Joi.boolean(),
    SubstanceAbuse: Joi.boolean(),
    PsychConditions: Joi.boolean(),
    Other: Joi.boolean(),
    OtherDetails: Joi.string()
      .allow("")
      .label("Other")
      .when("Other", { is: true, then: Joi.required() }),
    Purpose: Joi.string().required().label("Purpose/Need"),
    Written: Joi.boolean(),
    Verbal: Joi.boolean(),
    Fax: Joi.boolean(),
    Audio: Joi.boolean(),
    Video: Joi.boolean(),
    Email: Joi.boolean(),
    CancellationDate: Joi.string().allow(""),
    CancellationTime: Joi.string().allow(""),
    CancellationMode: Joi.string().allow(""),
  },
  "0DE5D8D7-B811-EC11-B563-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    PDA: Joi.boolean(),
    PDAInitials: Joi.string().allow(""),
    Psychotherapy: Joi.boolean(),
    PsychotherapyInitials: Joi.string().allow(""),
    CPST: Joi.boolean(),
    CPSTInitials: Joi.string().allow(""),
    PsychiatricServices: Joi.boolean(),
    PsychiatricServicesInitials: Joi.string().allow(""),
    Videoconferencing: Joi.boolean(),
    VideoconferencingEmail: Joi.string().allow(""),
    VideoconferencingIntials: Joi.string().allow(""),
    ReadConsent: Joi.boolean(),
    GiveConsent: Joi.boolean(),
    PrivacyPractices: Joi.boolean(),
    MethodsOfCommunication: Joi.boolean(),
    Family: Joi.boolean(),
    Restrictions: Joi.string().allow(""),
    GALCASAName: Joi.string().allow(""),
    GALCASAPhone: Joi.string().allow(""),
  },
  "E8E42C4A-C611-EC11-B563-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateOfVisit: Joi.string().required().label("Date of visit"),
    Housing: Joi.boolean(),
    HousingDetails: Joi.string()
      .allow("")
      .label("Housing/Shelter details")
      .when("Housing", { is: true, then: Joi.required() }),
    FoodWater: Joi.boolean(),
    FoodWaterDetails: Joi.string()
      .allow("")
      .label("Food/Water details")
      .when("FoodWater", { is: true, then: Joi.required() }),
    Clothing: Joi.boolean(),
    ClothingDetails: Joi.string()
      .allow("")
      .label("Clothing/Diapers details")
      .when("Clothing", { is: true, then: Joi.required() }),
    Utilities: Joi.boolean(),
    UtilitiesDetails: Joi.string()
      .allow("")
      .label("Utilities details")
      .when("Utilities", { is: true, then: Joi.required() }),
    MedicalCare: Joi.boolean(),
    MedicalCareDetails: Joi.string()
      .allow("")
      .label("Medical Care details")
      .when("MedicalCare", { is: true, then: Joi.required() }),
    PsychiatricCare: Joi.boolean(),
    PsychiatricCareDetails: Joi.string()
      .allow("")
      .label("Emergency psychiatric care details")
      .when("PsychiatricCare", { is: true, then: Joi.required() }),
    Supervision: Joi.boolean(),
    SupervisionDetails: Joi.string()
      .allow("")
      .label("Supervision Plan")
      .when("Supervision", { is: true, then: Joi.required() }),
    LawEnforcement: Joi.boolean(),
    LawEnforcementDetails: Joi.string()
      .allow("")
      .label("Law Enforcement report details")
      .when("LawEnforcement", { is: true, then: Joi.required() }),
    Deescalation: Joi.boolean(),
    DeescalationDetails: Joi.string()
      .allow("")
      .label("De-escalation details")
      .when("Deescalation", { is: true, then: Joi.required() }),
    Other: Joi.boolean(),
    OtherDetails: Joi.string()
      .allow("")
      .label("Other Safety Concern details")
      .when("Other", { is: true, then: Joi.required() }),
    Overall: Joi.string().allow(""),
    CaregiverPerspective: Joi.string().allow(""),
    Strategies: Joi.string().allow(""),
    Referrals: Joi.string().allow(""),
    Appointments: Joi.string().allow(""),
    SafyOnCall: Joi.string().allow(""),
    Worried1: Joi.string().allow(""),
    Strengths1: Joi.string().allow(""),
    Plan1: Joi.string().allow(""),
    Worried2: Joi.string().allow(""),
    Strengths2: Joi.string().allow(""),
    Plan2: Joi.string().allow(""),
    Worried3: Joi.string().allow(""),
    Strengths3: Joi.string().allow(""),
    Plan3: Joi.string().allow(""),
    Worried4: Joi.string().allow(""),
    Strengths4: Joi.string().allow(""),
    Plan4: Joi.string().allow(""),
    Worried5: Joi.string().allow(""),
    Strengths5: Joi.string().allow(""),
    Plan5: Joi.string().allow(""),
    Worried6: Joi.string().allow(""),
    Strengths6: Joi.string().allow(""),
    Plan6: Joi.string().allow(""),
    Worried7: Joi.string().allow(""),
    Strengths7: Joi.string().allow(""),
    Plan7: Joi.string().allow(""),
    Worried8: Joi.string().allow(""),
    Strengths8: Joi.string().allow(""),
    Plan8: Joi.string().allow(""),
    Worried9: Joi.string().allow(""),
    Strengths9: Joi.string().allow(""),
    Plan9: Joi.string().allow(""),
    Worried10: Joi.string().allow(""),
    Strengths10: Joi.string().allow(""),
    Plan10: Joi.string().allow(""),
    Signs: Joi.string().allow(""),
    Support: Joi.string().allow(""),
    SafeEnvironment: Joi.string().allow(""),
  },
  "89186090-4825-EC11-AE72-0050F21C653C": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    CoachName: Joi.string().required().label("Coach Name"),
    FosterHomeName: Joi.string().required().label("Foster Home Name"),
    Agency: Joi.string().required().label("Agency"),
    LocationOfSession: Joi.string()
      .required()
      .label("Location of Coaching Session"),
    StartOfSession: Joi.string().required().label("Session Start Time"),
    SessionDuration: Joi.string().required().label("Session Duration"),
    EndOfSession: Joi.string().required().label("Session End Time"),
    FollowsDirections: Joi.boolean(),
    CompletesHomework: Joi.boolean(),
    FollowsRules: Joi.boolean(),
    GoodHygiene: Joi.boolean(),
    AppropriateTone: Joi.boolean(),
    TellsTruth: Joi.boolean(),
    PerformsWell: Joi.boolean(),
    RespectsProperty: Joi.boolean(),
    CompletesChores: Joi.boolean(),
    RespectsBoundaries: Joi.boolean(),
    ExpressesFeelings: Joi.boolean(),
    OtherPositive: Joi.boolean(),
    OtherPositiveDetails: Joi.string().allow(""),
    VerbalPraise: Joi.boolean(),
    NonVerbalPraise: Joi.boolean(),
    ReminderOfReward: Joi.boolean(),
    BehaviorContract: Joi.boolean(),
    NaturalConsequence: Joi.boolean(),
    Reward: Joi.boolean(),
    TrackPositiveBehavior: Joi.boolean(),
    OtherStrategy: Joi.boolean(),
    OtherStrategyDetails: Joi.string().when("OtherStrategy", {
      is: true,
      then: Joi.required(),
    }),
    StrategiesWorking: Joi.string().required(),
    StrategiesToTry: Joi.string().when("StrategiesWorking", {
      is: "0",
      then: Joi.required(),
    }),
    ProblematicBehaviors: Joi.string().required(),
    ProblemBehavior: Joi.string().required(),
    ProblemBehaviorDetails: Joi.string().when("ProblemBehavior", {
      is: "13",
      then: Joi.required(),
    }),
    BehaviorFrequency: Joi.string().required(),
    BehaviorDuration: Joi.string().required(),
    BehaviorIntensity: Joi.string().required(),
    BehaviorAntecedent: Joi.string().required(),
    BehaviorConsequence: Joi.string().required(),
    InfluenceThoughts: Joi.string().required(),
    InterventionsToAvoid: Joi.string().required(),
    TimeIn: Joi.boolean(),
    TimeOut: Joi.boolean(),
    Restitution: Joi.boolean(),
    DirectionWithWarning: Joi.boolean(),
    ProblemSolving: Joi.boolean(),
    PrivilegeRemoval: Joi.boolean(),
    NaturalConsequenceReduce: Joi.boolean(),
    BehaviorContractReduce: Joi.boolean(),
    LogicalConsequence: Joi.boolean(),
    VerbalPraiseReduce: Joi.boolean(),
    RewardReduce: Joi.boolean(),
    OtherReduce: Joi.boolean(),
    OtherReduceDetails: Joi.string().when("OtherReduce", {
      is: true,
      then: Joi.required(),
    }),
    StrategiesWorkingReduce: Joi.string().required(),
    NewInterventions: Joi.string().when("StrategiesWorkingReduce", {
      is: "0",
      then: Joi.required(),
    }),
    DailyCheckIns: Joi.string().required(),
    CheckInPositiveInfo: Joi.string().required(),
    CheckInConcerns: Joi.string().required(),
    FamilyMeeting: Joi.string().required(),
    FamilyMeetingReviewed: Joi.string().required(),
    FamilyFunTime: Joi.string().required(),
    YouthIdentity: Joi.string().required(),
    PowerStruggle: Joi.string().required(),
    PreTeaching: Joi.boolean(),
    IMessage: Joi.boolean(),
    Ignored: Joi.boolean(),
    Neutral: Joi.boolean(),
    NoButtons: Joi.boolean(),
    WalkedAway: Joi.boolean(),
    Concise: Joi.boolean(),
    RegainComposure: Joi.boolean(),
    NoArguing: Joi.boolean(),
    OtherPowerStruggleStrategy: Joi.boolean(),
    OtherPowerStruggleStrategyDetails: Joi.string().when(
      "OtherPowerStruggleStrategy",
      { is: true, then: Joi.required() }
    ),
    FeelingToday: Joi.string().required(),
    FeelingLastMeeting: Joi.string().required(),
    Respite: Joi.boolean(),
    AloneTime: Joi.boolean(),
    DeepBreathing: Joi.boolean(),
    Meditation: Joi.boolean(),
    Exercise: Joi.boolean(),
    Reading: Joi.boolean(),
    NightAway: Joi.boolean(),
    Prayer: Joi.boolean(),
    Listening: Joi.boolean(),
    Hobby: Joi.boolean(),
    Support: Joi.boolean(),
    OtherSelfCare: Joi.boolean(),
    OtherSelfCareDetails: Joi.string().when("OtherSelfCare", {
      is: true,
      then: Joi.required(),
    }),
    SelfCareStrategies: Joi.string().required(),
    AdditionalComments: Joi.string().allow(""),
  },
  "E7114168-F025-EC11-AE72-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    Agency: Joi.string().allow(""),
    CaregiverName: Joi.string().allow(""),
    Gender: Joi.string().allow(""),
    Ethnicity: Joi.string().allow(""),
    ZipCode: Joi.string().allow(""),
    DateAssessmentRequested: Joi.string().allow(""),
    DateAssessmentCompleted: Joi.string().allow(""),
    CYMHTAAssessorInfo: Joi.string().allow(""),
    ContractedAgency: Joi.string().allow(""),
    AssessmentDetails: Joi.string().allow(""),
    Review: Joi.string().allow(""),
    Purpose: Joi.string().allow(""),
    Situation: Joi.string().allow(""),
    DailyActivities: Joi.string().allow(""),
    LegalProblems: Joi.string().allow(""),
    Medications: Joi.string().allow(""),
    HealthIssues: Joi.string().allow(""),
    Sleep: Joi.string().allow(""),
    Appetite: Joi.string().allow(""),
    CulturalFactors: Joi.string().allow(""),
    SchoolBehaviors: Joi.string().allow(""),
    CareerAspirations: Joi.string().allow(""),
    FunctioningCapacity: Joi.string().allow(""),
    StrengthsByYouth: Joi.string().allow(""),
    StrengthsByCaregiver: Joi.string().allow(""),
    DevelopmentalHistory: Joi.string().allow(""),
    Mania: Joi.boolean(),
    ManiaDetails: Joi.string().allow(""),
    Anxiety: Joi.boolean(),
    AnxietyDetails: Joi.string().allow(""),
    Energy: Joi.boolean(),
    EnergyDetails: Joi.string().allow(""),
    Depression: Joi.boolean(),
    DepressionDetails: Joi.string().allow(""),
    Enuresis: Joi.boolean(),
    EnuresisDetails: Joi.string().allow(""),
    SelfHarm: Joi.boolean(),
    SelfHarmDetails: Joi.string().allow(""),
    SuicideIdeations: Joi.boolean(),
    SuicideIdeationsDetails: Joi.string().allow(""),
    HomicideIdeations: Joi.boolean(),
    HomicideIdeationsDetails: Joi.string().allow(""),
    Violence: Joi.boolean(),
    ViolenceDetails: Joi.string().allow(""),
    AnimalCruelty: Joi.boolean(),
    AnimalCrueltyDetails: Joi.string().allow(""),
    Fire: Joi.boolean(),
    FireDetails: Joi.string().allow(""),
    SubstanceAbuse: Joi.boolean(),
    SubstanceAbuseDetails: Joi.string().allow(""),
    PsychoticSymptoms: Joi.boolean(),
    PsychoticSymptomsDetails: Joi.string().allow(""),
    TraumaHistory: Joi.string().allow(""),
    Behavior: Joi.string().allow(""),
    Speech: Joi.string().allow(""),
    Mood: Joi.string().allow(""),
    Affect: Joi.string().allow(""),
    RecentMemory: Joi.string().allow(""),
    RemoteMemory: Joi.string().allow(""),
    ThoughtProcess: Joi.string().allow(""),
    ThoughtContent: Joi.string().allow(""),
    Associations: Joi.string().allow(""),
    Orientation: Joi.string().allow(""),
    Attention: Joi.string().allow(""),
    Concentration: Joi.string().allow(""),
    Language: Joi.string().allow(""),
    Judgement: Joi.string().allow(""),
    Insight: Joi.string().allow(""),
    SocialServices: Joi.string().allow(""),
    PsychiatricHospitalizations: Joi.string().allow(""),
    CurrentMentalHealthServices: Joi.string().allow(""),
    MentalHealthServicesHistory: Joi.string().allow(""),
    DiagnosisHistory: Joi.string().allow(""),
    Barriers: Joi.string().allow(""),
    Needs: Joi.string().allow(""),
    Diagnosis: Joi.string().allow(""),
    CANSTool: Joi.string().allow(""),
    ClinicalRecommendations: Joi.string().allow(""),
  },
  "C7FAA504-0426-EC11-AE72-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    Hispanic: Joi.string().allow(""),
    Tribe: Joi.string().allow(""),
    AmericanIndian: Joi.boolean(),
    Asian: Joi.boolean(),
    Black: Joi.boolean(),
    Multiracial: Joi.boolean(),
    PacificIslander: Joi.boolean(),
    White: Joi.boolean(),
    ReceivedAnotherState: Joi.string().allow(""),
    ReceivedAnotherStateDetails: Joi.string().allow(""),
    AdoptedAnotherState: Joi.string().allow(""),
    AdoptedAnotherStateDetails: Joi.string().allow(""),
    LivingInSILA: Joi.string().allow(""),
    Adjudicated: Joi.string().allow(""),
    ReceivingDJJServices: Joi.string().allow(""),
    ReceivedSpecialEducation: Joi.string().allow(""),
    LastGrade: Joi.string().allow(""),
    SchoolName: Joi.string().allow(""),
    CurrentGrade: Joi.string().allow(""),
    CurrentSchoolName: Joi.string().allow(""),
    LastCompletedILNA: Joi.string().allow(""),
    AcademicSupportDetails: Joi.string().allow(""),
    AcademicCounseling: Joi.boolean(),
    LiteracyTraining: Joi.boolean(),
    EducationResources: Joi.boolean(),
    GEDPrep: Joi.boolean(),
    Homework: Joi.boolean(),
    StudySkillsTraining: Joi.boolean(),
    PostSecondaryDetails: Joi.string().allow(""),
    TestPrep: Joi.boolean(),
    Scholarships: Joi.boolean(),
    CollegeCounseling: Joi.boolean(),
    CollegeTutoring: Joi.boolean(),
    CollegeApplications: Joi.boolean(),
    CareerPrepDetails: Joi.string().allow(""),
    WorkApplications: Joi.boolean(),
    InterviewSkills: Joi.boolean(),
    CareerInterest: Joi.boolean(),
    VocationalGoals: Joi.boolean(),
    JobSupport: Joi.boolean(),
    JobShadowing: Joi.boolean(),
    WorkWithOthers: Joi.boolean(),
    JobReferrals: Joi.boolean(),
    RetentionSupport: Joi.boolean(),
    WorkPermits: Joi.boolean(),
    UnderstandRelationships: Joi.boolean(),
    UnderstandBenefits: Joi.boolean(),
    UnderstandValues: Joi.boolean(),
    UseResources: Joi.boolean(),
    VocationalAssessment: Joi.boolean(),
    VocationalTrainingDetails: Joi.string().allow(""),
    Internship: Joi.boolean(),
    TradeProgram: Joi.boolean(),
    ReceiptOfTraining: Joi.boolean(),
    BudgetTrainingDetails: Joi.string().allow(""),
    CreditInfo: Joi.boolean(),
    Loans: Joi.boolean(),
    BalancingCheckbook: Joi.boolean(),
    CheckingAccount: Joi.boolean(),
    TaxForms: Joi.boolean(),
    LivingWithinBudget: Joi.boolean(),
    ConsumerAwareness: Joi.boolean(),
    FinancialCounseling: Joi.boolean(),
    HousingTrainingDetails: Joi.string().allow(""),
    Maintenance: Joi.boolean(),
    SecurityDeposit: Joi.boolean(),
    HousingAssistance: Joi.boolean(),
    LivingCooperatively: Joi.boolean(),
    RentalApplications: Joi.boolean(),
    MealPlanning: Joi.boolean(),
    LandlordComplaints: Joi.boolean(),
    SafeHome: Joi.boolean(),
    TenantRights: Joi.boolean(),
    HealthTrainingDetails: Joi.string().allow(""),
    SupplementalAssistance: Joi.boolean(),
    FirstAid: Joi.boolean(),
    HealthCarePowerOfAttorney: Joi.boolean(),
    HealthCareResources: Joi.boolean(),
    HealthCareProxy: Joi.boolean(),
    STDPrevention: Joi.boolean(),
    HealthInsurance: Joi.boolean(),
    HealthInfo: Joi.boolean(),
    SexEd: Joi.boolean(),
    MedicalDental: Joi.boolean(),
    SubstanceAbuseAvoidance: Joi.boolean(),
    PregnancyPrevention: Joi.boolean(),
    MarriageTrainingDetails: Joi.string().allow(""),
    ChildcareSkills: Joi.boolean(),
    DomesticViolencePrevention: Joi.boolean(),
    StableFamilyInfo: Joi.boolean(),
    HealthyCommunication: Joi.boolean(),
    Parenting: Joi.boolean(),
    MurrayStateMentoring: Joi.string().allow(""),
    OtherStateMentoring: Joi.string().allow(""),
    MentorName: Joi.string().allow(""),
    MentorDates: Joi.string().allow(""),
    MentorAddress: Joi.string().allow(""),
    AssistanceFromKY: Joi.string().allow(""),
    AssistanceFromOther: Joi.string().allow(""),
    KYTuitionWaiver: Joi.string().allow(""),
    EducationVoucher: Joi.string().allow(""),
    OtherAssistance: Joi.string().allow(""),
    OtherAssistanceDetails: Joi.string().allow(""),
    ILSkillsStipend: Joi.string().allow(""),
    FormCompletedBy: Joi.string().allow(""),
    FormCompletedDate: Joi.string().allow(""),
    Agency: Joi.string().allow(""),
    Relationship: Joi.string().allow(""),
  },
  "0660AB6E-092D-EC11-AE72-0050F21C653C": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    ClientBuySupplies: Joi.string().allow(""),
    OtherBuySupplies: Joi.string().allow(""),
    ClientTemperature: Joi.string().allow(""),
    OtherTemperature: Joi.string().allow(""),
    ClientSimpleInjuries: Joi.string().allow(""),
    OtherSimpleInjuries: Joi.string().allow(""),
    ClientWhenDoctor: Joi.string().allow(""),
    OtherWhenDoctor: Joi.string().allow(""),
    ClientHowDoctor: Joi.string().allow(""),
    OtherHowDoctor: Joi.string().allow(""),
    ClientNearestClinic: Joi.string().allow(""),
    OtherNearestClinic: Joi.string().allow(""),
    ClientTakeToClinic: Joi.string().allow(""),
    OtherTakeToClinic: Joi.string().allow(""),
    ClientDentist: Joi.string().allow(""),
    OtherDentist: Joi.string().allow(""),
    ClientPurchaseClothing: Joi.string().allow(""),
    OtherPurchaseClothing: Joi.string().allow(""),
    ClientWashed: Joi.string().allow(""),
    OtherWashed: Joi.string().allow(""),
    ClientSort: Joi.string().allow(""),
    OtherSort: Joi.string().allow(""),
    ClientWashTowels: Joi.string().allow(""),
    OtherWashTowels: Joi.string().allow(""),
    ClientDryCleaner: Joi.string().allow(""),
    OtherDryCleaner: Joi.string().allow(""),
    ClientUseWasher: Joi.string().allow(""),
    OtherUseWasher: Joi.string().allow(""),
    ClientCleanRoom: Joi.string().allow(""),
    OtherCleanRoom: Joi.string().allow(""),
    ClientChangeLinens: Joi.string().allow(""),
    OtherChangeLinens: Joi.string().allow(""),
    ClientVacuum: Joi.string().allow(""),
    OtherVacuum: Joi.string().allow(""),
    ClientCleanOther: Joi.string().allow(""),
    OtherCleanOther: Joi.string().allow(""),
    ClientWashDishes: Joi.string().allow(""),
    OtherWashDishes: Joi.string().allow(""),
    ClientCleanKitchen: Joi.string().allow(""),
    OtherCleanKitchen: Joi.string().allow(""),
    ClientPlanMenu: Joi.string().allow(""),
    OtherPlanMenu: Joi.string().allow(""),
    ClientIncludeGroups: Joi.string().allow(""),
    OtherIncludeGroups: Joi.string().allow(""),
    ClientShopFood: Joi.string().allow(""),
    OtherShopFood: Joi.string().allow(""),
    ClientStoreFood: Joi.string().allow(""),
    OtherStoreFood: Joi.string().allow(""),
    ClientCookFood: Joi.string().allow(""),
    OtherCookFood: Joi.string().allow(""),
    ClientRecipe: Joi.string().allow(""),
    OtherRecipe: Joi.string().allow(""),
    ClientTakeBus: Joi.string().allow(""),
    OtherTakeBus: Joi.string().allow(""),
    ClientDriversEd: Joi.string().allow(""),
    OtherDriversEd: Joi.string().allow(""),
    ClientDriversLicense: Joi.string().allow(""),
    OtherDriversLicense: Joi.string().allow(""),
    ClientCarInsurance: Joi.string().allow(""),
    OtherCarInsurance: Joi.string().allow(""),
    ClientCarSalesTax: Joi.string().allow(""),
    OtherCarSalesTax: Joi.string().allow(""),
    ClientRegisterCar: Joi.string().allow(""),
    OtherRegisterCar: Joi.string().allow(""),
    ClientBudget: Joi.string().allow(""),
    OtherBudget: Joi.string().allow(""),
    ClientSavingsAccount: Joi.string().allow(""),
    OtherSavingsAccount: Joi.string().allow(""),
    ClientCheckingAccount: Joi.string().allow(""),
    OtherCheckingAccount: Joi.string().allow(""),
    ClientWriteCheck: Joi.string().allow(""),
    OtherWriteCheck: Joi.string().allow(""),
    ClientInterestRate: Joi.string().allow(""),
    OtherInterestRate: Joi.string().allow(""),
    ClientReadAds: Joi.string().allow(""),
    OtherReadAds: Joi.string().allow(""),
    ClientDeposits: Joi.string().allow(""),
    OtherDeposits: Joi.string().allow(""),
    ClientReadLease: Joi.string().allow(""),
    OtherReadLease: Joi.string().allow(""),
    ClientCriteria: Joi.string().allow(""),
    OtherCriteria: Joi.string().allow(""),
    ClientHouseholdItems: Joi.string().allow(""),
    OtherHouseholdItems: Joi.string().allow(""),
    ClientEcoMap: Joi.string().allow(""),
    OtherEcoMap: Joi.string().allow(""),
    ClientLibraryCard: Joi.string().allow(""),
    OtherLibraryCard: Joi.string().allow(""),
    ClientSendMail: Joi.string().allow(""),
    OtherSendMail: Joi.string().allow(""),
    ClientWelfareOffice: Joi.string().allow(""),
    OtherWelfareOffice: Joi.string().allow(""),
    ClientReligiousOrg: Joi.string().allow(""),
    OtherReligiousOrg: Joi.string().allow(""),
    ClientRegisterToVote: Joi.string().allow(""),
    OtherRegisterToVote: Joi.string().allow(""),
    ClientFireDepartment: Joi.string().allow(""),
    OtherFireDepartment: Joi.string().allow(""),
    ClientPolice: Joi.string().allow(""),
    OtherPolice: Joi.string().allow(""),
    ClientSocialization: Joi.string().allow(""),
    OtherSocialization: Joi.string().allow(""),
    ClientDating: Joi.string().allow(""),
    OtherDating: Joi.string().allow(""),
    ClientCourtship: Joi.string().allow(""),
    OtherCourtship: Joi.string().allow(""),
    ClientSexualResponsibility: Joi.string().allow(""),
    OtherSexualResponsibility: Joi.string().allow(""),
    ClientSexuality: Joi.string().allow(""),
    OtherSexuality: Joi.string().allow(""),
    Assessment: Joi.string().allow(""),
  },
  "F69D77D7-212D-EC11-AE72-0050F21C653C": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    Recipient: Joi.string().required().label("Recipient"),
    CheckingAccount: Joi.number().allow(""),
    SeverancePay: Joi.number().allow(""),
    VacationPay: Joi.number().allow(""),
    SavingsAccounts: Joi.number().allow(""),
    IRAs: Joi.number().allow(""),
    Stocks: Joi.number().allow(""),
    OtherCash: Joi.number().allow(""),
    MonthlySalary: Joi.number().allow(""),
    MonthlyAllowance: Joi.number().allow(""),
    OtherIncome: Joi.number().allow(""),
    FinancialAid: Joi.number().allow(""),
    Rent: Joi.number().allow(""),
    Electricity: Joi.number().allow(""),
    Garbage: Joi.number().allow(""),
    Water: Joi.number().allow(""),
    GasHome: Joi.number().allow(""),
    Cable: Joi.number().allow(""),
    Telephone: Joi.number().allow(""),
    Internet: Joi.number().allow(""),
    Supplies: Joi.number().allow(""),
    Staples: Joi.number().allow(""),
    BusPass: Joi.number().allow(""),
    Cab: Joi.number().allow(""),
    GasMoney: Joi.number().allow(""),
    CarPayment: Joi.number().allow(""),
    LicensePlate: Joi.number().allow(""),
    Registration: Joi.number().allow(""),
    CarMaintenance: Joi.number().allow(""),
    GasCar: Joi.number().allow(""),
    Parking: Joi.number().allow(""),
    CarInsurance: Joi.number().allow(""),
    HealthInsurance: Joi.number().allow(""),
    LifeInsurance: Joi.number().allow(""),
    RentersInsurance: Joi.number().allow(""),
    CoinLaundry: Joi.number().allow(""),
    DryCleaning: Joi.number().allow(""),
    LaundrySupplies: Joi.number().allow(""),
    FoodHome: Joi.number().allow(""),
    FoodOut: Joi.number().allow(""),
    HairCare: Joi.number().allow(""),
    Cosmetics: Joi.number().allow(""),
    Haircuts: Joi.number().allow(""),
    Perms: Joi.number().allow(""),
    Glasses: Joi.number().allow(""),
    OtherPersonal: Joi.number().allow(""),
    Prescriptions: Joi.number().allow(""),
    Vitamins: Joi.number().allow(""),
    DoctorVisits: Joi.number().allow(""),
    OtherHealth: Joi.number().allow(""),
    Clothes: Joi.number().allow(""),
    Shoes: Joi.number().allow(""),
    Accessories: Joi.number().allow(""),
    SpendingMoney: Joi.number().allow(""),
    OtherRecreation: Joi.number().allow(""),
  },
  "6C34AE3F-E02A-EC11-AE72-0050F21C653C": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    DateCompleted: Joi.string().required().label("Date Completed"),
    Division: Joi.string().required().label("Division"),
    PSDType: Joi.string().required().label("Type of PSD"),
    ReviewReason: Joi.string()
      .label("Reason")
      .when("PSDType", { is: "2", then: Joi.required() }),
    ChangeInDiagnosis: Joi.string()
      .label("Change In Diagnosis")
      .when("PSDType", { is: "2", then: Joi.required() }),
    ISClient: Joi.boolean(),
    ISParent: Joi.boolean(),
    ISFamily: Joi.boolean(),
    ISGuardian: Joi.boolean(),
    ISCaregiver: Joi.boolean(),
    ISPhysician: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISCPS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.string().allow(""),
    PresentingProblem: Joi.string().required().label("Presenting Problem"),
    ClientStrengths: Joi.string().required().label("Client strengths"),
    Supports: Joi.string().required().label("Client/Caregiver supports"),
    CurrentPlacement: Joi.string().required().label("Current placement"),
    PlacementHistory: Joi.string().required().label("Placement History"),
    AdditionalAssessment: Joi.string()
      .required()
      .label("Additional assessment"),
    FamilyHistoryUnknown: Joi.boolean(),
    FamilyHistoryDetails: Joi.string()
      .label("Family History")
      .when("FamilyHistoryUnknown", { is: false, then: Joi.required() }),
    CurrentConcernsOfDV: Joi.boolean(),
    PastConcernsOfDV: Joi.boolean(),
    UnknownConcernsOfDV: Joi.boolean(),
    NoReportedConcernsOfDV: Joi.boolean(),
    CurrentMaritalConflict: Joi.boolean(),
    PastMaritalConflict: Joi.boolean(),
    UnknownMaritalConflict: Joi.boolean(),
    NoReportedMaritalConflict: Joi.boolean(),
    CaregiverCooperation: Joi.string()
      .required()
      .label("Caregivers cooperating"),
    SupervisionDifficulties: Joi.string()
      .required()
      .label("Supervision difficulties"),
    DisciplinePracticesEffective: Joi.boolean(),
    DisciplinePracticesInconsistent: Joi.boolean(),
    DisciplinePracticesIneffective: Joi.boolean(),
    DisciplinePracticesNA: Joi.boolean(),
    FamilyHistoryComments: Joi.string()
      .required()
      .label("Family history comments"),
    RaceEthnicity: Joi.string().required().label("Race and ethnicity"),
    PlacesLived: Joi.string().required().label("Places lived"),
    SocioeconomicStatus: Joi.string().required().label("Socioeconomic status"),
    Religion: Joi.string().required().label("Religious information"),
    Traditions: Joi.string().required().label("Cultural events"),
    TraditionsComments: Joi.string()
      .label("Cultural events comments")
      .when("Traditions", { is: "1", then: Joi.required() }),
    MedicalBeliefs: Joi.string()
      .required()
      .label("Beliefs affect health decisions?"),
    MedicalBeliefsComments: Joi.string()
      .label("Beliefs affecting health decisions")
      .when("MedicalBeliefs", { is: "1", then: Joi.required() }),
    InFosterCare: Joi.string().required().label("In foster care?"),
    CulturalDifferences: Joi.string()
      .label("Cultural differences?")
      .when("InFosterCare", { is: "1", then: Joi.required() }),
    CulturalDifferencesComments: Joi.string()
      .label("Cultural differences comments")
      .when("CulturalDifferences", { is: "1", then: Joi.required() }),
    PHNoProblems: Joi.boolean(),
    PHPrenatalCare: Joi.string()
      .label("Prenatal care")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHExposure: Joi.string().label("Prenatal exposure").when("PHNoProblems", {
      is: false,
      then: Joi.required(),
    }),
    PHTrauma: Joi.string().label("Prenatal trauma").when("PHNoProblems", {
      is: false,
      then: Joi.required(),
    }),
    PHComplications: Joi.string()
      .label("Birth complications")
      .when("PHNoProblems", {
        is: false,
        then: Joi.required(),
      }),
    PHConcerns: Joi.string().label("Medical concerns").when("PHNoProblems", {
      is: false,
      then: Joi.required(),
    }),
    PHComments: Joi.string().label("Medical comments").when("PHNoProblems", {
      is: false,
      then: Joi.required(),
    }),
    SpecialNeeds: Joi.string().label("Special needs").required(),
    SpecialNeedsDetails: Joi.string()
      .label("Special needs details")
      .when("SpecialNeeds", {
        is: "1",
        then: Joi.required(),
      }),
    SpecializedServices: Joi.string().label("Specialized services").required(),
    SpecializedServicesDetails: Joi.string()
      .label("Specialized services details")
      .when("SpecializedServices", {
        is: "1",
        then: Joi.required(),
      }),
    EducationStatus: Joi.string().required().label("Education status"),
    SchoolName: Joi.string()
      .label("School Name")
      .when("EducationStatus", { is: "1", then: Joi.required() }),
    CurrentGrade: Joi.string()
      .label("Current Grade")
      .when("EducationStatus", { is: "1", then: Joi.required() }),
    RegularClassroom: Joi.string()
      .label("Regular Classroom")
      .when("EducationStatus", { is: "1", then: Joi.required() }),
    Active504Plan: Joi.string()
      .label("Active 504 Plan")
      .when("EducationStatus", { is: "1", then: Joi.required() }),
    ActiveIEP: Joi.string()
      .label("Active IEP")
      .when("EducationStatus", { is: "1", then: Joi.required() }),
    IEPClassification: Joi.string()
      .label("IEP Classification")
      .when("ActiveIEP", { is: "1", then: Joi.required() }),
    SchoolExperience: Joi.string()
      .label("School Experience")
      .when("EducationStatus", { is: "1", then: Joi.required() })
      .when("EducationStatus", { is: "2", then: Joi.required() })
      .when("EducationStatus", { is: "3", then: Joi.required() })
      .when("EducationStatus", { is: "4", then: Joi.required() }),
    CurrentlyEmployed: Joi.string()
      .label("Currently Employed")
      .when("EducationStatus", { is: "1", then: Joi.required() })
      .when("EducationStatus", { is: "2", then: Joi.required() })
      .when("EducationStatus", { is: "3", then: Joi.required() })
      .when("EducationStatus", { is: "4", then: Joi.required() }),
    EmployerAndTitle: Joi.string()
      .label("Employer name & title")
      .when("CurrentlyEmployed", { is: "1", then: Joi.required() }),
    EmploymentInterests: Joi.string()
      .label("Employer name & title")
      .when("CurrentlyEmployed", { is: "1", then: Joi.required() })
      .when("CurrentlyEmployed", { is: "2", then: Joi.required() }),
    MilitaryHistory: Joi.string()
      .label("Military History")
      .when("EducationStatus", { is: "1", then: Joi.required() })
      .when("EducationStatus", { is: "2", then: Joi.required() })
      .when("EducationStatus", { is: "3", then: Joi.required() })
      .when("EducationStatus", { is: "4", then: Joi.required() }),
    EmploymentComments: Joi.string()
      .label("Military History comments")
      .when("MilitaryHistory", { is: "1", then: Joi.required() }),
    ADLNA: Joi.boolean(),
    MoneyManagement: Joi.string()
      .label("Money management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MoneyManagementDetails: Joi.string()
      .label("Money management explanation")
      .when("MoneyManagement", { is: "1", then: Joi.required() }),
    FoodManagement: Joi.string()
      .label("Food management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    FoodManagementDetails: Joi.string()
      .label("Food management explanation")
      .when("FoodManagement", { is: "1", then: Joi.required() }),
    Hygiene: Joi.string()
      .label("Hygiene")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HygieneDetails: Joi.string()
      .label("Hygiene explanation")
      .when("Hygiene", { is: "1", then: Joi.required() }),
    Health: Joi.string()
      .label("Health")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HealthDetails: Joi.string()
      .label("Health explanation")
      .when("Health", { is: "1", then: Joi.required() }),
    Housekeeping: Joi.string()
      .label("Housekeeping")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HousekeepingDetails: Joi.string()
      .label("Housekeeping explanation")
      .when("Housekeeping", { is: "1", then: Joi.required() }),
    Transportation: Joi.string()
      .label("Transportation")
      .when("ADLNA", { is: false, then: Joi.required() }),
    TransportationDetails: Joi.string()
      .label("Transportation details")
      .when("Transportation", { is: "1", then: Joi.required() }),
    SafetySkills: Joi.string()
      .label("Emergency skills")
      .when("ADLNA", { is: false, then: Joi.required() }),
    SafetySkillsDetails: Joi.string()
      .label("Emergency skills explanation")
      .when("SafetySkills", { is: "1", then: Joi.required() }),
    ResourceKnowledge: Joi.string()
      .label("Resource knowledge")
      .when("ADLNA", { is: false, then: Joi.required() }),
    ResourceKnowledgeDetails: Joi.string()
      .label("Resource knowledge explanation")
      .when("ResourceKnowledge", { is: "1", then: Joi.required() }),
    TimeManagement: Joi.string()
      .label("Time management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    TimeManagementDetails: Joi.string()
      .label("Time management explaination")
      .when("TimeManagement", { is: "1", then: Joi.required() }),
    Interaction: Joi.string()
      .label("Interactions")
      .when("ADLNA", { is: false, then: Joi.required() }),
    InteractionDetails: Joi.string()
      .label("Interactions explanation")
      .when("Interaction", { is: "1", then: Joi.required() }),
    RelationshipsNA: Joi.boolean(),
    CoopSkills: Joi.string()
      .label("Cooperative play skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    CommunicationSkills: Joi.string()
      .label("Communication skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    EmotionalUnderstanding: Joi.string()
      .label("Emotional understanding")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    ProblemSolving: Joi.string()
      .label("Problem-solving skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    ConflictResolution: Joi.string()
      .label("Conflict resolution skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    DecisionMakingSkills: Joi.string()
      .label("Decision making skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    Bullied: Joi.string()
      .label("History of being bullied")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    Bully: Joi.string()
      .label("History of bullying others")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    RelationshipsSummary: Joi.string()
      .label("Friendship Summary Narrative")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    LegalNA: Joi.boolean(),
    LegalInvolvement: Joi.string()
      .label("Legal involvement")
      .when("LegalNA", { is: false, then: Joi.required() }),
    LegalInvolvementDetails: Joi.string()
      .label("Legal involvement details")
      .when("LegalInvolvement", { is: "1", then: Joi.required() }),
    CPSInvolvement: Joi.string()
      .label("CPS involvement")
      .when("LegalNA", { is: false, then: Joi.required() }),
    CPSInvolvementDetails: Joi.string()
      .label("CPS involvement details")
      .when("CPSInvolvement", { is: "1", then: Joi.required() }),
    CPSCaseworker: Joi.string()
      .label("CPS Caseworker")
      .when("LegalNA", { is: false, then: Joi.required() }),
    CPSCaseworkerName: Joi.string()
      .label("CPS Caseworker name")
      .when("CPSCaseworker", { is: "1", then: Joi.required() }),
    ProbationOfficer: Joi.string()
      .label("Probation/Parole Officer")
      .when("LegalNA", { is: false, then: Joi.required() }),
    ProbationOfficerName: Joi.string()
      .label("Probation/Parole Officer name")
      .when("ProbationOfficer", { is: "1", then: Joi.required() }),
    GALCASA: Joi.string()
      .label("GAL/CASA")
      .when("LegalNA", { is: false, then: Joi.required() }),
    OtherLegalDetails: Joi.string().allow(""),
    PCP: Joi.string()
      .label("Primary Care Physician")
      .when("PCPPhoneUnknown", { is: false, then: Joi.required() }),
    PCPPhone: Joi.string()
      .label("PCP Phone")
      .when("PCPPhoneUnknown", { is: false, then: Joi.required() }),
    PCPPhoneUnknown: Joi.boolean(),
    LastMedicalExamDate: Joi.string()
      .required()
      .label("Date of last medical exam"),
    LastDentalExamDate: Joi.string()
      .required()
      .label("Date of last dental exam"),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.string()
      .label("Allergies list")
      .when("Allergies", { is: true, then: Joi.required() }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.string()
      .label("Medical conditions list")
      .when("MedicalConditions", { is: true, then: Joi.required() }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.string()
      .label("Nutritional concerns list")
      .when("NutritionalConcerns", { is: true, then: Joi.required() }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.string()
      .label("Dental concerns list")
      .when("DentalConcerns", { is: true, then: Joi.required() }),
    Undiagnosed: Joi.string().required().label("Potential undiagnosed illness"),
    MedicalComments: Joi.string().required().label("Medical comments"),
    NoMedications: Joi.boolean(),
    CurrentMedicationDetails: Joi.string()
      .label("Current medications")
      .when("NoMedications", { is: false, then: Joi.required() }),
    MedicationCompliance: Joi.string()
      .label("Compliance with medication")
      .when("NoMedications", { is: false, then: Joi.required() }),
    SideEffects: Joi.string()
      .label("Side effects")
      .when("NoMedications", { is: false, then: Joi.required() }),
    SideEffectsDetails: Joi.string()
      .label("Side effects details")
      .when("SideEffects", { is: "1", then: Joi.required() }),
    PsychotropicMeds: Joi.string()
      .required()
      .label("Past psychotropic medications"),
    PsychotropicMedsDetails: Joi.string()
      .label("Past psychotropic medications list")
      .when("PsychotropicMeds", { is: "1", then: Joi.required() }),
    MedicationComments: Joi.string().required().label("Medication comments"),
    SexualHistoryNA: Joi.boolean(),
    SexualOrientation: Joi.string()
      .label("Sexual orientation")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualBehavior: Joi.string()
      .label("Sexual behavior")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualAbuse: Joi.string()
      .label("Sexual abuse or perpetration")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualRelationshipsEducation: Joi.string()
      .label("Sexual behavior/relationships education")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualHistoryComments: Joi.string()
      .label("Sexual history comments")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    MentalHealthNA: Joi.boolean(),
    PastMentalHealthTreatment: Joi.string()
      .label("Past mental health treatment")
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    PastMentalHealthPlacement: Joi.string()
      .label("Past placement")
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    PastMentalHealthDiagnosis: Joi.string()
      .label("Previous mental health diagnosis")
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    MentalHealthComments: Joi.string()
      .label("MH treatment placement details")
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    MentalHealthHistory: Joi.string()
      .label("MH placement history")
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    PerspectiveOfTreatment: Joi.string()
      .label("Perspective of MH treatment")
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    SubstanceUseNA: Joi.boolean(),
    PastSubstanceUse: Joi.string()
      .label("History of past drug or alcohol use")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    SubstanceUseHistory: Joi.string()
      .label("Current drug or alcohol use")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    PerspectiveOfSubstanceUse: Joi.string()
      .label("Perception of substance use")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    SubstanceUseComments: Joi.string()
      .label("Substance use comments")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    NoPastTreatment: Joi.boolean(),
    SubstanceUseTreatmentHistory: Joi.string()
      .label("Alcohol/Drug Treatment History")
      .when("NoPastTreatment", { is: false, then: Joi.required() }),
    PerspectiveOfSubstanceUseTreatment: Joi.string()
      .label("Perspective of treatment")
      .when("NoPastTreatment", { is: false, then: Joi.required() }),
    SubstanceUseTreatmentComments: Joi.string()
      .label("Alcohol/Drug Treatment History Comments")
      .when("NoPastTreatment", { is: false, then: Joi.required() }),
    TraumaNA: Joi.boolean(),
    TraumaHistory: Joi.string()
      .label("Trauma History")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    DistressingMemories: Joi.boolean(),
    BlockOut: Joi.boolean(),
    Hypervigilance: Joi.boolean(),
    PhysiologicalResponses: Joi.boolean(),
    LossOfMemories: Joi.boolean(),
    Hyperarousal: Joi.boolean(),
    SleepDisturbances: Joi.boolean(),
    DevelopmentalRegression: Joi.boolean(),
    Nightmares: Joi.boolean(),
    Avoidant: Joi.boolean(),
    DifficultyConcentratingSymptom: Joi.boolean(),
    UnhealthyBoundaries: Joi.boolean(),
    Flashbacks: Joi.boolean(),
    Detachment: Joi.boolean(),
    EmotionalDysregulation: Joi.boolean(),
    RepetitivePlayOfEvents: Joi.boolean(),
    PsychologicalDistress: Joi.boolean(),
    DiminishedInterests: Joi.boolean(),
    Dissocation: Joi.boolean(),
    NegativeCognitions: Joi.boolean(),
    SocialWithdrawalSymptom: Joi.boolean(),
    NoSymptoms: Joi.boolean(),
    SocialSupports: Joi.boolean(),
    InterpersonalSkills: Joi.boolean(),
    ValidatingExperiences: Joi.boolean(),
    Adaptability: Joi.boolean(),
    SenseOfMastery: Joi.boolean(),
    PositiveOutlook: Joi.boolean(),
    Resources: Joi.boolean(),
    SecureAttachments: Joi.boolean(),
    CaregiverStability: Joi.boolean(),
    PlacementStability: Joi.boolean(),
    TiesToExtendedFamily: Joi.boolean(),
    StrongCulturalIdentity: Joi.boolean(),
    StrongSpiritualBeliefs: Joi.boolean(),
    Pets: Joi.boolean(),
    CopingStrategies: Joi.string()
      .label("Coping strategies")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    TraumaSummary: Joi.string()
      .label("Trauma Impact Summary")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    AppropriateAppearance: Joi.boolean(),
    Neat: Joi.boolean(),
    Disheveled: Joi.boolean(),
    BizarreAppearance: Joi.boolean(),
    OtherAppearance: Joi.boolean(),
    OtherAppearanceDetails: Joi.string()
      .label("Other Appearance Comments")
      .when("OtherAppearance", { is: true, then: Joi.required() }),
    Cooperative: Joi.boolean(),
    Guarded: Joi.boolean(),
    Hyperactive: Joi.boolean(),
    Agitated: Joi.boolean(),
    Paranoid: Joi.boolean(),
    Tics: Joi.boolean(),
    Impulsive: Joi.boolean(),
    Aggressive: Joi.boolean(),
    Withdrawn: Joi.boolean(),
    BizarreBehavior: Joi.boolean(),
    Rigidity: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.string()
      .label("Other Behavior Comments")
      .when("OtherBehavior", { is: true, then: Joi.required() }),
    Normal: Joi.boolean(),
    Slurred: Joi.boolean(),
    Pressured: Joi.boolean(),
    Tangential: Joi.boolean(),
    Incoherent: Joi.boolean(),
    Stutters: Joi.boolean(),
    OtherSpeech: Joi.boolean(),
    OtherSpeechDetails: Joi.string()
      .label("Other Speech Comments")
      .when("OtherSpeech", { is: true, then: Joi.required() }),
    Euthymic: Joi.boolean(),
    Anxious: Joi.boolean(),
    Angry: Joi.boolean(),
    Depressed: Joi.boolean(),
    Euphoric: Joi.boolean(),
    Irritable: Joi.boolean(),
    Fearful: Joi.boolean(),
    OtherMood: Joi.boolean(),
    OtherMoodDetails: Joi.string()
      .label("Other Mood Comments")
      .when("OtherMood", { is: true, then: Joi.required() }),
    FullRange: Joi.boolean(),
    Restricted: Joi.boolean(),
    Blunted: Joi.boolean(),
    Flat: Joi.boolean(),
    Inappropriate: Joi.boolean(),
    OtherAffect: Joi.boolean(),
    OtherAffectDetails: Joi.string()
      .label("Other Affect Comments")
      .when("OtherAffect", { is: true, then: Joi.required() }),
    Logical: Joi.boolean(),
    Preoccupations: Joi.boolean(),
    Delusions: Joi.boolean(),
    Hallucinations: Joi.boolean(),
    Racing: Joi.boolean(),
    Disorganized: Joi.boolean(),
    Concrete: Joi.boolean(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    OtherPerception: Joi.boolean(),
    OtherPerceptionDetails: Joi.string()
      .label("Other Perception Comments")
      .when("OtherPerception", { is: true, then: Joi.required() }),
    NoImpairment: Joi.boolean(),
    ShortAttentionSpan: Joi.boolean(),
    DifficultyConcentrating: Joi.boolean(),
    Distractibility: Joi.boolean(),
    MemoryImpairment: Joi.boolean(),
    LowIntelligence: Joi.boolean(),
    OtherCognition: Joi.boolean(),
    OtherCognitionDetails: Joi.string()
      .label("Other Cognition Comments")
      .when("OtherCognition", { is: true, then: Joi.required() }),
    AppropriateInsight: Joi.boolean(),
    Fair: Joi.boolean(),
    Impaired: Joi.boolean(),
    OtherInsight: Joi.boolean(),
    OtherInsightDetails: Joi.string()
      .label("Other Insight Comments")
      .when("OtherInsight", { is: true, then: Joi.required() }),
    MentalStatusComments: Joi.string()
      .required()
      .label("Mental Status Comments"),
    LethalityNA: Joi.boolean(),
    SelfAbusiveBehavior: Joi.string()
      .label("Self-abusive behavior")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SelfAbusiveBehaviorDetails: Joi.string()
      .label("Self-abusive behavior details")
      .when("SelfAbusiveBehavior", { is: "1", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "2", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "3", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "4", then: Joi.required() }),
    SuicidalThreats: Joi.string()
      .label("Suicidal threats")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicidalThreatsDetails: Joi.string()
      .label("Suicidal threats details")
      .when("SuicidalThreats", { is: "1", then: Joi.required() })
      .when("SuicidalThreats", { is: "2", then: Joi.required() })
      .when("SuicidalThreats", { is: "3", then: Joi.required() })
      .when("SuicidalThreats", { is: "4", then: Joi.required() }),
    SuicideAttempt: Joi.string()
      .label("Suicide attempt")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicideAttemptDetails: Joi.string()
      .label("Suicide attempt details")
      .when("SuicideAttempt", { is: "1", then: Joi.required() })
      .when("SuicideAttempt", { is: "2", then: Joi.required() })
      .when("SuicideAttempt", { is: "3", then: Joi.required() })
      .when("SuicideAttempt", { is: "4", then: Joi.required() }),
    PriorAttempt: Joi.boolean(),
    AccessToMeans: Joi.boolean(),
    HealthCondition: Joi.boolean(),
    MentalHealthDisorder: Joi.boolean(),
    FamilyHistory: Joi.boolean(),
    Exposure: Joi.boolean(),
    ElevatingBeliefs: Joi.boolean(),
    OtherRiskFactors: Joi.boolean(),
    OtherRiskFactorsDetails: Joi.string()
      .label("Risk Factors")
      .when("OtherRiskFactors", { is: true, then: Joi.required() }),
    NoRiskFactors: Joi.boolean(),
    RiskFactorsComments: Joi.string()
      .label("Risk Factors Comments")
      .when("SelfAbusiveBehavior", { is: "1", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "2", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "3", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "4", then: Joi.required() })
      .when("SuicidalThreats", { is: "1", then: Joi.required() })
      .when("SuicidalThreats", { is: "2", then: Joi.required() })
      .when("SuicidalThreats", { is: "3", then: Joi.required() })
      .when("SuicidalThreats", { is: "4", then: Joi.required() })
      .when("SuicideAttempt", { is: "1", then: Joi.required() })
      .when("SuicideAttempt", { is: "2", then: Joi.required() })
      .when("SuicideAttempt", { is: "3", then: Joi.required() })
      .when("SuicideAttempt", { is: "4", then: Joi.required() }),
    ClinicalCare: Joi.boolean(),
    Connected: Joi.boolean(),
    Skills: Joi.boolean(),
    CaregiverContacts: Joi.boolean(),
    DiscouragingBeliefs: Joi.boolean(),
    NoSelfHarmProtectiveFactors: Joi.boolean(),
    ProtectiveFactorsComments: Joi.string()
      .label("Protective Factors Comments")
      .when("SelfAbusiveBehavior", { is: "1", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "2", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "3", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "4", then: Joi.required() })
      .when("SuicidalThreats", { is: "1", then: Joi.required() })
      .when("SuicidalThreats", { is: "2", then: Joi.required() })
      .when("SuicidalThreats", { is: "3", then: Joi.required() })
      .when("SuicidalThreats", { is: "4", then: Joi.required() })
      .when("SuicideAttempt", { is: "1", then: Joi.required() })
      .when("SuicideAttempt", { is: "2", then: Joi.required() })
      .when("SuicideAttempt", { is: "3", then: Joi.required() })
      .when("SuicideAttempt", { is: "4", then: Joi.required() }),
    Threatening: Joi.boolean(),
    SeekingMeans: Joi.boolean(),
    Hopelessness: Joi.boolean(),
    IncreasedSubstanceUse: Joi.boolean(),
    DramaticMoodChanges: Joi.boolean(),
    GivingAwayPossessions: Joi.boolean(),
    SayingGoodbye: Joi.boolean(),
    SocialWithdrawal: Joi.boolean(),
    RecklessBehavior: Joi.boolean(),
    Feelings: Joi.boolean(),
    NoWarningSigns: Joi.boolean(),
    WarningSignsComments: Joi.string()
      .label("Current Warning Signs Comments")
      .when("SelfAbusiveBehavior", { is: "1", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "2", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "3", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "4", then: Joi.required() })
      .when("SuicidalThreats", { is: "1", then: Joi.required() })
      .when("SuicidalThreats", { is: "2", then: Joi.required() })
      .when("SuicidalThreats", { is: "3", then: Joi.required() })
      .when("SuicidalThreats", { is: "4", then: Joi.required() })
      .when("SuicideAttempt", { is: "1", then: Joi.required() })
      .when("SuicideAttempt", { is: "2", then: Joi.required() })
      .when("SuicideAttempt", { is: "3", then: Joi.required() })
      .when("SuicideAttempt", { is: "4", then: Joi.required() }),
    CaregiverConcernsOfSelfHarm: Joi.string()
      .label("Caregiver concerns of self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherConcernsOfSelfHarm: Joi.string()
      .label("Other concerns of self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SelfHarmSafetyPlanStatus: Joi.string()
      .label("Self-harm safety plan status")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentSelfHarmRisk: Joi.string()
      .label("Current Risk of Harm to Self")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentSelfHarmRiskComments: Joi.string()
      .label("Current Risk of Harm to Self Comments")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThreatsToHarmOthers: Joi.string()
      .label("Threats to harm others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThreatsToHarmOthersDetails: Joi.string()
      .label("Threats to harm others details")
      .when("ThreatsToHarmOthers", { is: "1", then: Joi.required() })
      .when("ThreatsToHarmOthers", { is: "2", then: Joi.required() })
      .when("ThreatsToHarmOthers", { is: "3", then: Joi.required() })
      .when("ThreatsToHarmOthers", { is: "4", then: Joi.required() }),
    ThoughtsOfHarm: Joi.string()
      .label("Thoughts of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThoughtsOfHarmDetails: Joi.string()
      .label("Thoughts of harming others details")
      .when("ThoughtsOfHarm", { is: "1", then: Joi.required() })
      .when("ThoughtsOfHarm", { is: "2", then: Joi.required() })
      .when("ThoughtsOfHarm", { is: "3", then: Joi.required() })
      .when("ThoughtsOfHarm", { is: "4", then: Joi.required() }),
    ActsOfHarm: Joi.string()
      .label("Acts of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarmDetails: Joi.string()
      .label("Acts of harming others details")
      .when("ActsOfHarm", { is: "1", then: Joi.required() })
      .when("ActsOfHarm", { is: "2", then: Joi.required() })
      .when("ActsOfHarm", { is: "3", then: Joi.required() })
      .when("ActsOfHarm", { is: "4", then: Joi.required() }),
    ActsOfHarmAnimals: Joi.string()
      .label("Acts of harming animals")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarmAnimalsDetails: Joi.string()
      .label("Acts of harming animals details")
      .when("ActsOfHarmAnimals", { is: "1", then: Joi.required() })
      .when("ActsOfHarmAnimals", { is: "2", then: Joi.required() })
      .when("ActsOfHarmAnimals", { is: "3", then: Joi.required() })
      .when("ActsOfHarmAnimals", { is: "4", then: Joi.required() }),
    ActsInvolvingWeapons: Joi.string()
      .label("Acts involving weapons")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsInvolvingWeaponsDetails: Joi.string()
      .label("Acts involving weapons details")
      .when("ActsInvolvingWeapons", { is: "1", then: Joi.required() })
      .when("ActsInvolvingWeapons", { is: "2", then: Joi.required() })
      .when("ActsInvolvingWeapons", { is: "3", then: Joi.required() })
      .when("ActsInvolvingWeapons", { is: "4", then: Joi.required() }),
    CaregiverConcernOfOtherHarm: Joi.string()
      .required()
      .label("Caregiver concerns of harming others"),
    OtherConcernsOfOtherHarm: Joi.string()
      .required()
      .label("Other concerns of harming others"),
    OtherHarmSafetyPlanStatus: Joi.string()
      .required()
      .label("Harm to others safey plan status"),
    CurrentOtherHarmRisk: Joi.string()
      .required()
      .label("Current Risk of Harm to Others"),
    CurrentOtherHarmRiskDetails: Joi.string()
      .required()
      .label("Current Risk Comments"),
    OMHASNA: Joi.boolean(),
    AgeGroup: Joi.string()
      .label("Age group")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    IntoxWithdrawalLevel: Joi.string()
      .label("Acute Intoxication Withdrawal Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    BiomedicalConditionsLevel: Joi.string()
      .label("Biomedical Conditions/ Complications Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    CognitiveConditionsLevel: Joi.string()
      .label(
        "Emotional/ Behavioral/ Cognitive Conditions and/or Complications Level of Care"
      )
      .when("OMHASNA", { is: false, then: Joi.required() }),
    ReadinessToChangeLevel: Joi.string()
      .label("Readiness to Change Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    RelapsePotentialLevel: Joi.string()
      .label("Relapse Potential Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    RecoveryEnvironmentLevel: Joi.string()
      .label("Recovery Environment Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    LevelOfCareRecommendedLevel: Joi.string()
      .label("Level of Care Recommended")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    LevelOfCarePlacedLevel: Joi.string()
      .label("Level of Care Placed")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    NotPlacedReason: Joi.string().allow(""),
    NotPlacedReasonDetails: Joi.string()
      .label("Other reason details")
      .when("NotPlacedReason", { is: "7", then: Joi.required() }),
    OMHASComments: Joi.string()
      .label("OMHAS Comments")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    ClinicalNarrativeSummary: Joi.string()
      .required()
      .label("Clinical Narrative Summary"),
    ClinicalNarrativeSummaryComments: Joi.string()
      .required()
      .label("Clinical Narrative Summary Comments"),
    DiagnosisDetails: Joi.string().required().label("At least one Diagnosis"),
    SkillsTraining: Joi.boolean(),
    SymptomManagementSkills: Joi.boolean(),
    DecisionMaking: Joi.boolean(),
    FinancialSupport: Joi.boolean(),
    CommunitySupport: Joi.boolean(),
    Mentoring: Joi.boolean(),
    FamilySupport: Joi.boolean(),
    FosterFamilySupport: Joi.boolean(),
    Respite: Joi.boolean(),
    MedicationManagement: Joi.boolean(),
    MedicalDentalVision: Joi.boolean(),
    HealthyHabits: Joi.boolean(),
    EducationSchool: Joi.boolean(),
    Vocational: Joi.boolean(),
    Occupational: Joi.boolean(),
    ProsocialActivities: Joi.boolean(),
    CaseManagement: Joi.boolean(),
    SocialSkills: Joi.boolean(),
    TreatmentNeedsComments: Joi.string()
      .required()
      .label("Assessed Needs Comments"),
    TreatmentRecommendations: Joi.string()
      .required()
      .label("At least one Treatment Recommendation"),
    MorePsychiatric: Joi.boolean(),
    MorePsychological: Joi.boolean(),
    MoreNeurological: Joi.boolean(),
    MoreEducational: Joi.boolean(),
    MoreMedical: Joi.boolean(),
    MoreDental: Joi.boolean(),
    MoreSubstanceUse: Joi.boolean(),
    MoreVocational: Joi.boolean(),
    MoreOccupational: Joi.boolean(),
    MoreVisualAuditory: Joi.boolean(),
    MoreNutritional: Joi.boolean(),
    MoreOther: Joi.boolean(),
    MoreOtherDetails: Joi.string()
      .label("Other Further Evaluation Needs details")
      .when("MoreOther", { is: true, then: Joi.required() }),
    DiagnosisEducation: Joi.string().required().label("Diagnosis education"),
    RecommendationEducation: Joi.string()
      .required()
      .label("Recommendation education"),
    ClientAgrees: Joi.string().required().label("Client in agreement"),
    FamilyAgress: Joi.string().required().label("Family in agreement"),
    SexAssignedAtBirth: Joi.string().label("Sex Assigned at Birth").required(),
    SexAssignedAtBirthDetails: Joi.string()
      .label("Sex Assigned at Birth Specifics")
      .when("SexAssignedAtBirth", {
        is: "Sex not listed",
        then: Joi.required(),
      }),
    Pronouns: Joi.string().label("Pronouns").required(),
    PronounsDescription: Joi.string()
      .label("Pronouns description")
      .when("Pronouns", {
        is: "Prefer to self-describe",
        then: Joi.required(),
      }),
    GenderIdentity: Joi.string().label("Gender Identity").required(),
    GenderIdentityDescription: Joi.string()
      .label("Gender Identity description")
      .when("GenderIdentity", {
        is: "Identity not listed",
        then: Joi.required(),
      }),
    SexualOrientationDetails: Joi.string()
      .label("Sexual Orientation specifics")
      .when("SexualOrientation", {
        is: "Orientation not listed",
        then: Joi.required(),
      }),
    TraumaSymptoms: Joi.boolean(),
    TraumaticExposure: Joi.boolean(),
    AvoidantTrauma: Joi.boolean(),
    HypervigilanceTrauma: Joi.boolean(),
    IntrusiveDreams: Joi.boolean(),
    NegativeThoughts: Joi.boolean(),
    CocentrationProblems: Joi.boolean(),
    RecklessBehaviorTrauma: Joi.boolean(),
    SleepDisturbancesTrauma: Joi.boolean(),
    OtherTrauma: Joi.boolean(),
    OtherTraumaDetails: Joi.string()
      .label("Other Trauma Details")
      .when("OtherTrauma", { is: true, then: Joi.required() }),
    TraumaSymptomsFrequency: Joi.string()
      .label("Trauma Symptoms Frequency")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsIntensity: Joi.string()
      .label("Trauma Symptoms Intensity")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsDuration: Joi.string()
      .label("Trauma Symptoms Duration")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsOnset: Joi.string()
      .label("Trauma Symptoms Onset")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    AnxietyDisorder: Joi.boolean(),
    AnxietyDisorderExcessWorry: Joi.boolean(),
    AnxietyDisorderEasilyFatigued: Joi.boolean(),
    MuscleTension: Joi.boolean(),
    Overworried: Joi.boolean(),
    AnxietyDisorderDifficultyConcentrating: Joi.boolean(),
    SleepDisturbancesAnxiety: Joi.boolean(),
    RestlessAnxiety: Joi.boolean(),
    Irritability: Joi.boolean(),
    OtherAnxiety: Joi.boolean(),
    OtherAnxietyDetails: Joi.string()
      .label("Other Anxiety Details")
      .when("OtherAnxiety", { is: true, then: Joi.required() }),
    AnxietyDisorderFrequency: Joi.string()
      .label("Anxiety Frequency")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    AnxietyDisorderIntensity: Joi.string()
      .label("Anxiety Intensity")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    AnxietyDisorderDuration: Joi.string()
      .label("Anxiety Duration")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    DepressionSymptoms: Joi.boolean(),
    DepressedMood: Joi.boolean(),
    SleepChanges: Joi.boolean(),
    Guilt: Joi.boolean(),
    DiminishedInterest: Joi.boolean(),
    PurposelessMovement: Joi.boolean(),
    DifficultyConcentratingDepression: Joi.boolean(),
    WeightChanges: Joi.boolean(),
    FatigueDepression: Joi.boolean(),
    ThoughtsOfDeath: Joi.boolean(),
    OtherDepression: Joi.boolean(),
    OtherDepressionDetails: Joi.string()
      .label("Other Depression Details")
      .when("OtherDepression", { is: true, then: Joi.required() }),
    DepressionFrequency: Joi.string()
      .label("Depression Frequency")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    DepressionIntensity: Joi.string()
      .label("Depression Intensity")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    DepressionDuration: Joi.string()
      .label("Depression Duration")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    AttentionHyperactivity: Joi.boolean(),
    AttentionHyperactivityEasilyDistracted: Joi.boolean(),
    DifficultyFollowThrough: Joi.boolean(),
    Forgetful: Joi.boolean(),
    DifficultyListening: Joi.boolean(),
    DisorganizedAttention: Joi.boolean(),
    Fidgety: Joi.boolean(),
    LackOfDetails: Joi.boolean(),
    LosesThings: Joi.boolean(),
    InterruptsOthers: Joi.boolean(),
    UnableToSitStill: Joi.boolean(),
    ExcessiveTalking: Joi.boolean(),
    DifficultyWaiting: Joi.boolean(),
    OtherAttention: Joi.boolean(),
    OtherAttentionDetails: Joi.string()
      .label("Other Attention Details")
      .when("OtherAttention", { is: true, then: Joi.required() }),
    AttentionHyperactivityFrequency: Joi.string()
      .label("Attention Frequency")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    AttentionHyperactivityIntensity: Joi.string()
      .label("Attention Intensity")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    AttentionHyperactivityDuration: Joi.string()
      .label("Attention Duration")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    SU: Joi.boolean(),
    PatternOfSubstanceUse: Joi.boolean(),
    DesiresCutDownUse: Joi.boolean(),
    TimeSpentObtaining: Joi.boolean(),
    Cravings: Joi.boolean(),
    FailureOfResponsibilities: Joi.boolean(),
    NegativeImpact: Joi.boolean(),
    AbandonsActivities: Joi.boolean(),
    Tolerance: Joi.boolean(),
    SUWithdrawal: Joi.boolean(),
    SUOther: Joi.boolean(),
    SUOtherDetails: Joi.string()
      .label("Other Substance Use Details")
      .when("SUOther", { is: true, then: Joi.required() }),
    SubstanceUseFrequency: Joi.string()
      .label("Substance Use Frequency")
      .when("SU", { is: true, then: Joi.required() }),
    SubstanceUseIntensity: Joi.string()
      .label("Substance Use Intensity")
      .when("SU", { is: true, then: Joi.required() }),
    SubstanceUseDuration: Joi.string()
      .label("Substance Use Duration")
      .when("SU", { is: true, then: Joi.required() }),
    DMDD: Joi.boolean(),
    Temper: Joi.boolean(),
    OutsideOutbursts: Joi.boolean(),
    FrequentOutbursts: Joi.boolean(),
    DMDDIrritable: Joi.boolean(),
    OutburstsAroundOthers: Joi.boolean(),
    DMDDOther: Joi.boolean(),
    DMDDOtherDetails: Joi.string()
      .label("Other Disruptive Mood Dysregulation Disorder Details")
      .when("DMDDOther", { is: true, then: Joi.required() }),
    DMDDFrequency: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Frequency")
      .when("DMDD", { is: true, then: Joi.required() }),
    DMDDIntensity: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Intensity")
      .when("DMDD", { is: true, then: Joi.required() }),
    DMDDDuration: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Duration")
      .when("DMDD", { is: true, then: Joi.required() }),
    ConductDisorder: Joi.boolean(),
    Aggression: Joi.boolean(),
    DestructionOfProperty: Joi.boolean(),
    Theft: Joi.boolean(),
    SeriousViolations: Joi.boolean(),
    OtherConductDisorder: Joi.boolean(),
    OtherConductDisorderDetails: Joi.string()
      .label("Other Conduct Disorder Details")
      .when("OtherConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderFrequency: Joi.string()
      .label("Conduct Disorder Frequency")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderIntensity: Joi.string()
      .label("Conduct Disorder Intensity")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderDuration: Joi.string()
      .label("Conduct Disorder Duration")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ODD: Joi.boolean(),
    IrritableODD: Joi.boolean(),
    Argumentative: Joi.boolean(),
    Vindictive: Joi.boolean(),
    OtherODD: Joi.boolean(),
    OtherODDDetails: Joi.string()
      .label("Other Oppositional Defiance Disorder Details")
      .when("OtherODD", { is: true, then: Joi.required() }),
    ODDFrequency: Joi.string()
      .label("Oppositional Defiance Disorder Frequency")
      .when("ODD", { is: true, then: Joi.required() }),
    ODDIntensity: Joi.string()
      .label("Oppositional Defiance Disorder Intensity")
      .when("ODD", { is: true, then: Joi.required() }),
    ODDDuration: Joi.string()
      .label("Oppositional Defiance Disorder Duration")
      .when("ODD", { is: true, then: Joi.required() }),
    OCD: Joi.boolean(),
    OCDPresence: Joi.boolean(),
    Obsessions: Joi.boolean(),
    TimeConsuming: Joi.boolean(),
    Compulsions: Joi.boolean(),
    ReduceAnxiety: Joi.boolean(),
    SuppressUrges: Joi.boolean(),
    OCDOther: Joi.boolean(),
    OCDOtherDetails: Joi.string()
      .label("Other Obsessive-Compulsive Disorder Details")
      .when("OCDOther", { is: true, then: Joi.required() }),
    OCDFrequency: Joi.string()
      .label("Obsessive-Compulsive Disorder Frequency")
      .when("OCD", { is: true, then: Joi.required() }),
    OCDIntensity: Joi.string()
      .label("Obsessive-Compulsive Disorder Intensity")
      .when("OCD", { is: true, then: Joi.required() }),
    OCDDuration: Joi.string()
      .label("Obsessive-Compulsive Disorder Duration")
      .when("OCD", { is: true, then: Joi.required() }),
    PanicDisorder: Joi.boolean(),
    PoundingHeart: Joi.boolean(),
    PanicDisorderSweating: Joi.boolean(),
    Trembling: Joi.boolean(),
    ShortnessOfBreath: Joi.boolean(),
    Choking: Joi.boolean(),
    ChestPain: Joi.boolean(),
    PanicDisorderNausea: Joi.boolean(),
    Dizzy: Joi.boolean(),
    Chills: Joi.boolean(),
    Derealization: Joi.boolean(),
    FearOfCrazy: Joi.boolean(),
    FearOfDying: Joi.boolean(),
    PanicDisorderOther: Joi.boolean(),
    PanicDisorderOtherDetails: Joi.string()
      .label("Other Panic Disorder Details")
      .when("PanicDisorderOther", { is: true, then: Joi.required() }),
    PanicDisorderFrequency: Joi.string()
      .label("Panic Disorder Frequency")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    PanicDisorderIntensity: Joi.string()
      .label("Panic Disorder Intensity")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    PanicDisorderDuration: Joi.string()
      .label("Panic Disorder Duration")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    Phobias: Joi.boolean(),
    PhobiasSpecificFear: Joi.boolean(),
    ImmediateFear: Joi.boolean(),
    PhobiasAvoidance: Joi.boolean(),
    FearExaggerated: Joi.boolean(),
    PhobiasOther: Joi.boolean(),
    PhobiasOtherDetails: Joi.string()
      .label("Other Phobia Details")
      .when("PhobiasOther", { is: true, then: Joi.required() }),
    PhobiasFrequency: Joi.string()
      .label("Phobia Frequency")
      .when("Phobias", { is: true, then: Joi.required() }),
    PhobiasIntensity: Joi.string()
      .label("Phobia Intensity")
      .when("Phobias", { is: true, then: Joi.required() }),
    PhobiasDuration: Joi.string()
      .label("Phobia Duration")
      .when("Phobias", { is: true, then: Joi.required() }),
    DI: Joi.boolean(),
    DILowIQ: Joi.boolean(),
    DISensoryImpairments: Joi.boolean(),
    DISpeechDelays: Joi.boolean(),
    DIMotorCoordinationDelays: Joi.boolean(),
    DILearningDisorder: Joi.boolean(),
    DISpatialDelays: Joi.boolean(),
    DevelopmentalImpairmentsOther: Joi.boolean(),
    DevelopmentalImpairmentsOtherDetails: Joi.string()
      .label("Other Developmental Impairments Details")
      .when("DevelopmentalImpairmentsOther", {
        is: true,
        then: Joi.required(),
      }),
    DevelopmentalImpairmentsDetails: Joi.string()
      .label("Developmental Impairments Description")
      .when("DILowIQ", { is: true, then: Joi.required() })
      .when("DISensoryImpairments", { is: true, then: Joi.required() })
      .when("DISpeechDelays", { is: true, then: Joi.required() })
      .when("DIMotorCoordinationDelays", { is: true, then: Joi.required() })
      .when("DILearningDisorder", { is: true, then: Joi.required() })
      .when("DISpatialDelays", { is: true, then: Joi.required() })
      .when("DevelopmentalImpairments", { is: true, then: Joi.required() }),
    Bipolar: Joi.boolean(),
    ManicEpisodes: Joi.boolean(),
    DepressiveEpisodes: Joi.boolean(),
    SignificantMoodChanges: Joi.boolean(),
    BipolarOther: Joi.boolean(),
    BipolarOtherDetails: Joi.string().when("BipolarOther", {
      is: true,
      then: Joi.required(),
    }),
    BipolarFrequency: Joi.string().allow(""),
    BipolarIntensity: Joi.string().allow(""),
    BipolarDuration: Joi.string().allow(""),
    Borderline: Joi.boolean(),
    AvoidAbandonment: Joi.boolean(),
    UnstableRelationships: Joi.boolean(),
    IdentityDisturbances: Joi.boolean(),
    Impulsivity: Joi.boolean(),
    RecurrentSelfHarm: Joi.boolean(),
    AffectiveInstability: Joi.boolean(),
    Emptiness: Joi.boolean(),
    PoorAngerManagement: Joi.boolean(),
    ParanoidIdeation: Joi.boolean(),
    BorderlineOther: Joi.boolean(),
    BorderlineOtherDetails: Joi.string().when("BorderlineOther", {
      is: true,
      then: Joi.required(),
    }),
    BorderlineFrequency: Joi.string().when("Borderline", {
      is: true,
      then: Joi.required(),
    }),
    BorderlineIntensity: Joi.string().when("Borderline", {
      is: true,
      then: Joi.required(),
    }),
    BorderlineDuration: Joi.string().when("Borderline", {
      is: true,
      then: Joi.required(),
    }),
    OtherSymptoms: Joi.boolean(),
    OtherSymptomsDetails: Joi.string()
      .label("Other Symptom Details")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsFrequency: Joi.string()
      .label("Other Symptoms Frequency")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsIntensity: Joi.string()
      .label("Other Symptoms Intensity")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsDuration: Joi.string()
      .label("Other Symptoms Duration")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),

    // DEPRECATED FIELDS
    Depression: Joi.boolean(),
    DepressionDetails: Joi.string()
      .label("Depression details")
      .when("Depression", { is: true, then: Joi.required() }),
    Mania: Joi.boolean(),
    ManiaDetails: Joi.string()
      .label("Mania details")
      .when("Mania", { is: true, then: Joi.required() }),
    BipolarDetails: Joi.string().label("Bipolar details"),
    ObsessiveCompulsive: Joi.boolean(),
    ObsessiveCompulsiveDetails: Joi.string()
      .label("Obsessive Compulsive details")
      .when("ObsessiveCompulsive", { is: true, then: Joi.required() }),
    Psychosis: Joi.boolean(),
    PsychosisDetails: Joi.string()
      .label("Psychosis details")
      .when("Psychosis", { is: true, then: Joi.required() }),
    PTSD: Joi.boolean(),
    PTSDDetails: Joi.string()
      .label("PTSD details")
      .when("PTSD", { is: true, then: Joi.required() }),
    PanicAttacks: Joi.boolean(),
    PanicAttacksDetails: Joi.string()
      .label("Panic Attack details")
      .when("PanicAttacks", { is: true, then: Joi.required() }),
    Anxiety: Joi.boolean(),
    AnxietyDetails: Joi.string()
      .label("Anxiety details")
      .when("Anxiety", { is: true, then: Joi.required() }),
    Phobia: Joi.boolean(),
    PhobiaDetails: Joi.string()
      .label("Phobia details")
      .when("Phobia", { is: true, then: Joi.required() }),
    EatingDisorder: Joi.boolean(),
    EatingDisorderDetails: Joi.string()
      .label("Eating Disorder details")
      .when("EatingDisorder", { is: true, then: Joi.required() }),
    Elimination: Joi.boolean(),
    EliminationDetails: Joi.string()
      .label("Elimination details")
      .when("Elimination", { is: true, then: Joi.required() }),
    Conduct: Joi.boolean(),
    ConductDetails: Joi.string()
      .label("Conduct details")
      .when("Conduct", { is: true, then: Joi.required() }),
    Oppositional: Joi.boolean(),
    OppositionalDetails: Joi.string()
      .label("Oppositional Defiance details")
      .when("Oppositional", { is: true, then: Joi.required() }),
    Attention: Joi.boolean(),
    AttentionDetails: Joi.string()
      .label("Attention details")
      .when("Attention", { is: true, then: Joi.required() }),
    Adjustment: Joi.boolean(),
    AdjustmentDetails: Joi.string()
      .label("Adjustment details")
      .when("Adjustment", { is: true, then: Joi.required() }),
    Attachment: Joi.boolean(),
    AttachmentDetails: Joi.string()
      .label("Attachment details")
      .when("Attachment", { is: true, then: Joi.required() }),
    DevelopmentalImpairments: Joi.boolean(),
    SubstanceUse: Joi.boolean(),
    SubstanceUseDetails: Joi.string()
      .label("Substance Use details")
      .when("SubstanceUse", { is: true, then: Joi.required() }),
    OtherSymptom: Joi.boolean(),
    OtherSymptomDetails: Joi.string()
      .label("Other symptom details")
      .when("OtherSymptom", { is: true, then: Joi.required() }),
    IntoxWithdrawal: Joi.string().allow(""),
    BiomedicalConditions: Joi.string().allow(""),
    CognitiveConditions: Joi.string().allow(""),
    ReadinessToChange: Joi.string().allow(""),
    RelapsePotential: Joi.string().allow(""),
    RecoveryEnvironment: Joi.string().allow(""),
    LevelOfCareRecommended: Joi.string().allow(""),
    LevelOfCarePlaced: Joi.string().allow(""),
  },
  "810317E7-D338-EC11-981F-0050F21C653C": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    DatePassportGiven: Joi.string()
      .required()
      .label("Date Medical Passport was given to Foster Parents"),
    ChildCurrentGrade: Joi.string().required().label("Child's Current Grade"),
    ChildCurrentlyPerforming: Joi.string().allow(""),
    PreviousSchoolInfo: Joi.string().allow(""),
    NewSchoolInfo: Joi.string().allow(""),
    Height: Joi.string().allow(""),
    Weight: Joi.string().allow(""),
    EyeColor: Joi.string().allow(""),
    HairColor: Joi.string().allow(""),
    IdentifyingMarks: Joi.string().allow(""),
    Neglected: Joi.boolean(),
    NeglectedDetails: Joi.string().allow(""),
    AttachmentDifficultiesBehavior: Joi.boolean(),
    AttachmentDifficultiesBehaviorDetails: Joi.string().allow(""),
    PhysicallyAbused: Joi.boolean(),
    PhysicallyAbusedDetails: Joi.string().allow(""),
    DestroysProperty: Joi.boolean(),
    DestroysPropertyDetails: Joi.string().allow(""),
    SexuallyAbused: Joi.boolean(),
    SexuallyAbusedDetails: Joi.string().allow(""),
    InnappropriateBehavior: Joi.boolean(),
    InnappropriateBehaviorDetails: Joi.string().allow(""),
    JuvenileSexOffender: Joi.boolean(),
    JuvenileSexOffenderDetails: Joi.string().allow(""),
    FireSetting: Joi.boolean(),
    FireSettingDetails: Joi.string().allow(""),
    Hyperactivity: Joi.boolean(),
    HyperactivityDetails: Joi.string().allow(""),
    Cooperative: Joi.boolean(),
    CooperativeDetails: Joi.string().allow(""),
    SelfInjury: Joi.boolean(),
    SelfInjuryDetails: Joi.string().allow(""),
    NonCooperative: Joi.boolean(),
    NonCooperativeDetails: Joi.string().allow(""),
    Lying: Joi.boolean(),
    LyingDetails: Joi.string().allow(""),
    Friendly: Joi.boolean(),
    FriendlyDetails: Joi.string().allow(""),
    AttachmentDifficultiesHealth: Joi.boolean(),
    AttachmentDifficultiesHealthDetails: Joi.string().allow(""),
    PhysicallyAggressive: Joi.boolean(),
    PhysicallyAggressiveDetails: Joi.string().allow(""),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.string().allow(""),
    Rocking: Joi.boolean(),
    RockingDetails: Joi.string().allow(""),
    DevelopmentalDelays: Joi.boolean(),
    DevelopmentalDelaysDetails: Joi.string().allow(""),
    RunAway: Joi.boolean(),
    RunAwayDetails: Joi.string().allow(""),
    EatingDisorders: Joi.boolean(),
    EatingDisordersDetails: Joi.string().allow(""),
    Humor: Joi.boolean(),
    HumorDetails: Joi.string().allow(""),
    FailureToThrive: Joi.boolean(),
    FailureToThriveDetails: Joi.string().allow(""),
    SexuallyAggressive: Joi.boolean(),
    SexuallyAggressiveDetails: Joi.string().allow(""),
    MedicallyFragile: Joi.boolean(),
    MedicallyFragileDetails: Joi.string().allow(""),
    Smokes: Joi.boolean(),
    SmokesDetails: Joi.string().allow(""),
    Medications: Joi.boolean(),
    MedicationsDetails: Joi.string().allow(""),
    SubstanceAbuse: Joi.boolean(),
    SubstanceAbuseDetails: Joi.string().allow(""),
    PhysicalHandicaps: Joi.boolean(),
    PhysicalHandicapsDetails: Joi.string().allow(""),
    Stealing: Joi.boolean(),
    StealingDetails: Joi.string().allow(""),
    NutritionalNeeds: Joi.boolean(),
    NutritionalNeedsDetails: Joi.string().allow(""),
    Suicidal: Joi.boolean(),
    SuicidalDetails: Joi.string().allow(""),
    SpeechDisorders: Joi.boolean(),
    SpeechDisordersDetails: Joi.string().allow(""),
    VerballyAggressive: Joi.boolean(),
    VerballyAggressiveDetails: Joi.string().allow(""),
    SleepingDifficulties: Joi.boolean(),
    SleepingDifficultiesDetails: Joi.string().allow(""),
    Wetting: Joi.boolean(),
    WettingDetails: Joi.string().allow(""),
    Talents: Joi.boolean(),
    TalentsDetails: Joi.string().allow(""),
    LikesDislikes: Joi.boolean(),
    LikesDislikesDetails: Joi.string().allow(""),
    ReligiousActivities: Joi.boolean(),
    ReligiousActivitiesDetails: Joi.string().allow(""),
    MusicalTastes: Joi.boolean(),
    MusicalTastesDetails: Joi.string().allow(""),
    FavoriteColor: Joi.boolean(),
    FavoriteColorDetails: Joi.string().allow(""),
    PlacementCount: Joi.string().required().label("Child Placement #"),
    VisitationPlan: Joi.string().allow(""),
    MedicationDetails: Joi.string().allow(""),
    ContactWithFamily: Joi.string().allow(""),
    ContactRestrictions: Joi.string().allow(""),
    NoContactDetails: Joi.string().allow(""),
    FamilyName: Joi.string().allow(""),
    FamilyPhone: Joi.string().allow(""),
    FamilyAddress: Joi.string().allow(""),
    Unsupervised: Joi.string().allow(""),
    UnsupervisedDetails: Joi.string().allow(""),
    GALCASAName: Joi.string().allow(""),
    GALCASAPhone: Joi.string().allow(""),
    TFCHomeAddress: Joi.string().allow(""),
    EmergencyContact: Joi.string().allow(""),
  },
  "759BFBB6-11C3-EB11-A7AD-0050F21C6F69": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    Month: Joi.string().required().label("Month"),
    Year: Joi.string().required().label("Year"),
    CaseType: Joi.string().required().label("Case Type"),
    FamilySupportWorker: Joi.string()
      .allow("")
      .required()
      .label("Family Support Worker"),
    Therapist: Joi.string().required().label("Therapist"),
    DHRWorker: Joi.string().required().label("DHR Worker"),
    DHRSupervisor: Joi.string().required().label("DHR Supervisor"),
    County: Joi.string().required().label("County"),
    StartDate: Joi.string().required().label("Start Date of Service"),
    AnticipatedDischargeDate: Joi.string()
      .allow("")
      .required()
      .label("Anticipated Date of Discharge"),
    CurrentPlacement: Joi.string()
      .allow("")
      .required()
      .label("Current Placement"),
    PermanencyGoals: Joi.string()
      .allow("")
      .required()
      .label("Permanency Goals"),
    ConcurrentPlan: Joi.string().required().label("Concurrent Plan"),
    RiskFactors: Joi.string()
      .allow("")
      .required()
      .label("Current Risk Factors"),
    Barriers: Joi.string().required().label("Barriers to Treatment"),
    ChildBehaviors: Joi.string()
      .allow("")
      .required()
      .label("Child's Current Behaviors"),
    ChildDiagnosis: Joi.string()
      .allow("")
      .required()
      .label("Child's DSM Diagnosis"),
    ParentsBehaviors: Joi.string()
      .allow("")
      .required()
      .label("Parents Current Behaviors"),
    ParentsDiagnosis: Joi.string()
      .allow("")
      .required()
      .label("Parents DSM Diagnosis"),
    ServicePlanGoals: Joi.string()
      .allow("")
      .required()
      .label("Service Plan Goals"),
    AgencyIntervention: Joi.string()
      .allow("")
      .required()
      .label("Agency Intervention Since Last Reporting Period"),
    MentalHealthCoordination: Joi.string()
      .allow("")
      .required()
      .label("Mental Health Care Coordination"),
    OutcomesAchieved: Joi.string()
      .allow("")
      .required()
      .label("Outcomes Achieved Since Last Period"),
    AgencyNextSteps: Joi.string()
      .allow("")
      .required()
      .label("Agency Next Steps"),
    CurrentRecommendations: Joi.string()
      .allow("")
      .required()
      .label("Current Recommendations"),
    Visits: Joi.string().required().label("Visits"),
    MotherVisits: Joi.string().allow(""),
    FatherVisits: Joi.string().allow(""),
    VisitLocation: Joi.string().allow(""),
    UnsupervisedVisits: Joi.string().allow(""),
    OtherVisits: Joi.string().allow(""),
    AnnouncedAgencyVisits: Joi.string().allow(""),
    UnannouncedAgencyVisits: Joi.string().allow(""),
  },
  "F687CB8B-0E3C-EC11-981F-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    UsesUtensils: Joi.string().allow(""),
    UsesNapkin: Joi.string().allow(""),
    UsesToilet: Joi.string().allow(""),
    Wipes: Joi.string().allow(""),
    WashesHands: Joi.string().allow(""),
    WaterTemp: Joi.string().allow(""),
    CleansSelf: Joi.string().allow(""),
    DriesSelf: Joi.string().allow(""),
    ClothesCorrect: Joi.string().allow(""),
    CleanClothes: Joi.string().allow(""),
    WeatherClothes: Joi.string().allow(""),
    OccasionClothes: Joi.string().allow(""),
    ColorClothes: Joi.string().allow(""),
    ShampoosHair: Joi.string().allow(""),
    CombsHair: Joi.string().allow(""),
    Shaves: Joi.string().allow(""),
    NailCare: Joi.string().allow(""),
    BrushesTeeth: Joi.string().allow(""),
    UsesDeodorant: Joi.string().allow(""),
    MenstrualCare: Joi.string().allow(""),
    BlowsNose: Joi.string().allow(""),
    VerbalizeColdSymptoms: Joi.string().allow(""),
    VerbalizeColdTreatment: Joi.string().allow(""),
    VerbalizeFluSymptoms: Joi.string().allow(""),
    VerbalizeFluTreatment: Joi.string().allow(""),
    VerbalizeRest: Joi.string().allow(""),
    VerbalizeExercise: Joi.string().allow(""),
    VerbalizeAvoidGerms: Joi.string().allow(""),
    OwnTemperature: Joi.string().allow(""),
    TreatsCuts: Joi.string().allow(""),
    TreatsAnkle: Joi.string().allow(""),
    SeizureCare: Joi.string().allow(""),
    CallDoctor: Joi.string().allow(""),
    AttendAppt: Joi.string().allow(""),
    GetMedication: Joi.string().allow(""),
    SetMedication: Joi.string().allow(""),
    UseMedication: Joi.string().allow(""),
    FollowMedicationDirections: Joi.string().allow(""),
    StartsLaundry: Joi.string().allow(""),
    SortsLaundry: Joi.string().allow(""),
    SetWasher: Joi.string().allow(""),
    MeasureDetergent: Joi.string().allow(""),
    UseBleach: Joi.string().allow(""),
    SetDryer: Joi.string().allow(""),
    CleansLint: Joi.string().allow(""),
    RemovesDry: Joi.string().allow(""),
    HangsClothes: Joi.string().allow(""),
    FoldsClothes: Joi.string().allow(""),
    MakesBed: Joi.string().allow(""),
    Dusts: Joi.string().allow(""),
    EmptiesWastebasket: Joi.string().allow(""),
    Vacuums: Joi.string().allow(""),
    CleansMirrors: Joi.string().allow(""),
    AppropriateDecor: Joi.string().allow(""),
    CleansToilet: Joi.string().allow(""),
    CleansBathtub: Joi.string().allow(""),
    CleansSink: Joi.string().allow(""),
    WashesTowels: Joi.string().allow(""),
    DisposeHygieneItems: Joi.string().allow(""),
    EmptiesGarbage: Joi.string().allow(""),
    SweepsFloor: Joi.string().allow(""),
    MopsFloor: Joi.string().allow(""),
    WashesDishes: Joi.string().allow(""),
    OperatesDishwasher: Joi.string().allow(""),
    PutAwayDishes: Joi.string().allow(""),
    CleansTable: Joi.string().allow(""),
    CleansCounter: Joi.string().allow(""),
    WipesAppliances: Joi.string().allow(""),
    CleansOven: Joi.string().allow(""),
    CleansRefrigerator: Joi.string().allow(""),
    SetsTable: Joi.string().allow(""),
    OperatesDisposal: Joi.string().allow(""),
    ReadsName: Joi.string().allow(""),
    ReadsSurvivalWords: Joi.string().allow(""),
    ReadsSimpleWords: Joi.string().allow(""),
    ReadsStories: Joi.string().allow(""),
    Alphabetizes: Joi.string().allow(""),
    UsesDictionary: Joi.string().allow(""),
    IdentifiesLetters: Joi.string().allow(""),
    PrintsLetters: Joi.string().allow(""),
    PrintsName: Joi.string().allow(""),
    PrintsAddress: Joi.string().allow(""),
    PrintsSimpleWords: Joi.string().allow(""),
    PrintsSentences: Joi.string().allow(""),
    ComposesLetter: Joi.string().allow(""),
    AddressesEnvelope: Joi.string().allow(""),
    IdentifiesName: Joi.string().allow(""),
    TellsTimeHour: Joi.string().allow(""),
    TellsTimeHalfHour: Joi.string().allow(""),
    TellsTimeFiveMinutes: Joi.string().allow(""),
    SetsTime: Joi.string().allow(""),
    ReadsNumbers: Joi.string().allow(""),
    NamesDays: Joi.string().allow(""),
    NamesPresentDay: Joi.string().allow(""),
    NamesPresentMonth: Joi.string().allow(""),
    NamesSeasons: Joi.string().allow(""),
    NamePresentSeason: Joi.string().allow(""),
    IdentifiesMonths: Joi.string().allow(""),
    StatesOwnBirthday: Joi.string().allow(""),
    LocatesDates: Joi.string().allow(""),
    StatesPresentYear: Joi.string().allow(""),
    StatesPresentDate: Joi.string().allow(""),
    UseCalendar: Joi.string().allow(""),
    DialPhone: Joi.string().allow(""),
    AnswerPhone: Joi.string().allow(""),
    TakeMessages: Joi.string().allow(""),
    RecitePhoneNumber: Joi.string().allow(""),
    RecognizeBusy: Joi.string().allow(""),
    UsePayPhone: Joi.string().allow(""),
    DialZero: Joi.string().allow(""),
    VerbalizesCollectCall: Joi.string().allow(""),
    UsePhone: Joi.string().allow(""),
    Mobility: Joi.string().allow(""),
    CrossesStreet: Joi.string().allow(""),
    UsesTrafficLight: Joi.string().allow(""),
    FindWay: Joi.string().allow(""),
    RidesBike: Joi.string().allow(""),
    UsesBus: Joi.string().allow(""),
    UsesTaxi: Joi.string().allow(""),
    UsesID: Joi.string().allow(""),
    AppropriateWithStrangers: Joi.string().allow(""),
    DrivesCar: Joi.string().allow(""),
    KnowsSafety: Joi.string().allow(""),
    ChangesBulb: Joi.string().allow(""),
    ReportRepairs: Joi.string().allow(""),
    PestControl: Joi.string().allow(""),
    UsesRake: Joi.string().allow(""),
    UsesMower: Joi.string().allow(""),
    WatersLawn: Joi.string().allow(""),
    WatersFlowers: Joi.string().allow(""),
    RealisticPlan: Joi.string().allow(""),
    ShoppingList: Joi.string().allow(""),
    FindItems: Joi.string().allow(""),
    ComparePrices: Joi.string().allow(""),
    AddItems: Joi.string().allow(""),
    UseCoupons: Joi.string().allow(""),
    UseFoodStamps: Joi.string().allow(""),
    StoresGroceries: Joi.string().allow(""),
    StaysInBudget: Joi.string().allow(""),
    AppropriateGroceries: Joi.string().allow(""),
    FoodGroups: Joi.string().allow(""),
    PlansSimpleMeal: Joi.string().allow(""),
    PlansMealsForDay: Joi.string().allow(""),
    PlansMealsForWeek: Joi.string().allow(""),
    StatesFoodPrepOrder: Joi.string().allow(""),
    SetsOvenTemp: Joi.string().allow(""),
    SetsBurner: Joi.string().allow(""),
    FollowsRecipe: Joi.string().allow(""),
    SetsTimer: Joi.string().allow(""),
    TurnsOff: Joi.string().allow(""),
    StoresLeftovers: Joi.string().allow(""),
    MakesBreakfast: Joi.string().allow(""),
    MakesLunch: Joi.string().allow(""),
    MakesDinner: Joi.string().allow(""),
    MakesSnacks: Joi.string().allow(""),
    UsesCanOpener: Joi.string().allow(""),
    UsesMixer: Joi.string().allow(""),
    UsesToaster: Joi.string().allow(""),
    UsesFoodProcessor: Joi.string().allow(""),
    UsesBroiler: Joi.string().allow(""),
    UsesKnife: Joi.string().allow(""),
    UsesGrater: Joi.string().allow(""),
    UsesStrainer: Joi.string().allow(""),
    UsesMicrowave: Joi.string().allow(""),
    UsesStove: Joi.string().allow(""),
    UsesMeasuringCups: Joi.string().allow(""),
    AwareOfHome: Joi.string().allow(""),
    OrientedToPresent: Joi.string().allow(""),
    KnowsArea: Joi.string().allow(""),
    KnowsEmergency: Joi.string().allow(""),
    SafeAppliances: Joi.string().allow(""),
    DangerousSubstances: Joi.string().allow(""),
    UsesMatches: Joi.string().allow(""),
    FireSafety: Joi.string().allow(""),
    UsesExtinguisher: Joi.string().allow(""),
    ChecksBattery: Joi.string().allow(""),
    SafetyCrime: Joi.string().allow(""),
    PublicLibrary: Joi.string().allow(""),
    CommunityResources: Joi.string().allow(""),
    UseTelephoneBook: Joi.string().allow(""),
    Communicates: Joi.string().allow(""),
    Understands: Joi.string().allow(""),
    AppropriateVolume: Joi.string().allow(""),
    AppropriateSpeed: Joi.string().allow(""),
    SpeaksClearly: Joi.string().allow(""),
    SpeaksSentences: Joi.string().allow(""),
    GetsAlong: Joi.string().allow(""),
    Participates: Joi.string().allow(""),
    InitiatesConvo: Joi.string().allow(""),
    RelatesPastEvents: Joi.string().allow(""),
    IdentifiesPeople: Joi.string().allow(""),
    Listens: Joi.string().allow(""),
    EyeContact: Joi.string().allow(""),
    VerbalizesName: Joi.string().allow(""),
    MaintainsSpace: Joi.string().allow(""),
    AppropriateTouch: Joi.string().allow(""),
    ControlsTemper: Joi.string().allow(""),
    ConstructiveCriticism: Joi.string().allow(""),
    FollowsDirections: Joi.string().allow(""),
    DecisionMaking: Joi.string().allow(""),
    StressManagement: Joi.string().allow(""),
    IdentifiesCoins: Joi.string().allow(""),
    VerbalizesValue: Joi.string().allow(""),
    CountsMoney: Joi.string().allow(""),
    MakesChange: Joi.string().allow(""),
    ReadsPrice: Joi.string().allow(""),
    CompletesBudget: Joi.string().allow(""),
    BankingSlips: Joi.string().allow(""),
    OpenAccount: Joi.string().allow(""),
    MoneyOrders: Joi.string().allow(""),
    WritesChecks: Joi.string().allow(""),
    BalanceCheckbook: Joi.string().allow(""),
    JobCoach: Joi.string().allow(""),
    JobResume: Joi.string().allow(""),
    JobInterview: Joi.string().allow(""),
    JobAds: Joi.string().allow(""),
    SetsAlarm: Joi.string().allow(""),
    Punctual: Joi.string().allow(""),
    ObeysAuthority: Joi.string().allow(""),
    UnderstandsWorkRelationships: Joi.string().allow(""),
    KnowsGALName: Joi.string().allow(""),
    KnowsBasicRights: Joi.string().allow(""),
    OtherDetails: Joi.string().allow(""),
    PersonCompletingForm: Joi.string().allow(""),
    Date: Joi.string().allow(""),
  },
  "5B001124-AD3D-EC11-981F-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    Date: Joi.string().allow(""),
    ReferringAgency: Joi.string().allow(""),
    ReferringAgencyAddress: Joi.string().allow(""),
    ReferringAgencyCityStateZip: Joi.string().allow(""),
    Recommendations: Joi.string().allow(""),
    ReferringAgencySupervisor: Joi.string().allow(""),
    ExecDirector: Joi.string().allow(""),
  },
  "76FEB7DD-B93D-EC11-981F-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateAccepted: Joi.string().allow(""),
    TierLevel: Joi.string().allow(""),
    MaintenanceAmount: Joi.string().allow(""),
    HousingType: Joi.string().allow(""),
    RentAmount: Joi.string().allow(""),
    SecurityDeposit: Joi.string().allow(""),
    RentalCompanyNameAndAddress: Joi.string().allow(""),
    RentalCompanyPhone: Joi.string().allow(""),
    RentalCompanyContact: Joi.string().allow(""),
    RentalCompanyTaxID: Joi.string().allow(""),
    SendW9: Joi.boolean(),
    Utilities: Joi.string().allow(""),
    UtilitiesYesNo: Joi.string().allow(""),
    UtilityCompanyNameAndAddress: Joi.string().allow(""),
    UtilityCompanyPhone: Joi.string().allow(""),
    UtilityCompanyContact: Joi.string().allow(""),
    DischargeDate: Joi.string().allow(""),
    NoPlan: Joi.boolean(),
  },
  "59631DE8-5346-EC11-981F-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SAFYOfficeAddress: Joi.string().allow(""),
    FromInfo: Joi.string().allow(""),
    AllRecords: Joi.boolean(),
    SocialHistory: Joi.boolean(),
    DiagnosticAssessment: Joi.boolean(),
    ProgressReports: Joi.boolean(),
    LivingAssessments: Joi.boolean(),
    DischargeSummary: Joi.boolean(),
    TreatmentPlan: Joi.boolean(),
    Medications: Joi.boolean(),
    SubstanceAbuse: Joi.boolean(),
    PsychConditions: Joi.boolean(),
    OtherDisclosed: Joi.boolean(),
    OtherDisclosedDetails: Joi.string().allow(""),
    Continuity: Joi.string().allow(""),
    TreatmentCompliance: Joi.string().allow(""),
    Employment: Joi.string().allow(""),
    Legal: Joi.string().allow(""),
    FamilyInvolvement: Joi.string().allow(""),
    PhysicianInvolvement: Joi.string().allow(""),
    SchoolInvolvement: Joi.string().allow(""),
    OtherPurpose: Joi.string().allow(""),
    OtherPurposeDetails: Joi.string().allow(""),
    Written: Joi.boolean(),
    Verbal: Joi.boolean(),
    Fax: Joi.boolean(),
    Email: Joi.boolean(),
    AllMembers: Joi.boolean(),
    CancellationDateTime: Joi.string().allow(""),
    CancellationMode: Joi.string().allow(""),
  },
  "D737A0D7-ED3C-EC11-981F-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateOfService: Joi.string().allow(""),
    CaseNumber: Joi.string().allow(""),
    ServiceProvider: Joi.string().allow(""),
    ReasonForReferral: Joi.string().allow(""),
    SafetyThreat: Joi.string().allow(""),
    ProtectiveCapacities: Joi.string().allow(""),
    ContactsMade: Joi.string().allow(""),
    Observations: Joi.string().allow(""),
    SummaryVulnerabilities: Joi.string().allow(""),
    SummaryIncidents: Joi.string().allow(""),
    SummaryProtectiveCapacities: Joi.string().allow(""),
    Barriers: Joi.string().allow(""),
    Goals: Joi.string().allow(""),
    Progress: Joi.string().allow(""),
    Recommendations: Joi.string().allow(""),
  },
  "D7D50EC9-1B47-EC11-981F-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    Height: Joi.string().allow(""),
    Weight: Joi.string().allow(""),
    CustodialAgency: Joi.string().allow(""),
    PrescribingDoctor: Joi.string().allow(""),
    PrescribingAgency: Joi.string().allow(""),
    Reason: Joi.string().allow(""),
    DiscontinuedMedications: Joi.string().allow(""),
    NewMedications: Joi.string().allow(""),
    OngoingMedications: Joi.string().allow(""),
    FollowUp: Joi.string().allow(""),
    SAFYWorker: Joi.string().allow(""),
    ApprovalRepresentative: Joi.string().allow(""),
    ApprovalDate: Joi.string().allow(""),
    ApprovalStatus: Joi.string().allow(""),
    RepresentativeName: Joi.string().allow(""),
  },
  "2A7CCAEF-7549-EC11-981F-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DiagnosticAssessment: Joi.boolean(),
    DiagnosticAssessmentInitials: Joi.string().allow(""),
    Therapy: Joi.boolean(),
    TherapyInitials: Joi.string().allow(""),
    CPST: Joi.boolean(),
    CPSTInitials: Joi.string().allow(""),
    Management: Joi.boolean(),
    ManagementInitials: Joi.string().allow(""),
    RehabilitativeServices: Joi.boolean(),
    RehabilitativeServicesInititals: Joi.string().allow(""),
    Conferencing: Joi.boolean(),
    ConferencingInititals: Joi.string().allow(""),
    Email: Joi.boolean(),
    FamilyInfo: Joi.string().allow(""),
    ContactRestrictions: Joi.string().allow(""),
    InitialEntry: Joi.string().allow(""),
    HealthScreening: Joi.string().allow(""),
    HealthScreeningDate: Joi.string().allow(""),
    HealthConcerns: Joi.string().allow(""),
    HealthConcernsDetails: Joi.string().allow(""),
    MentalHealthServices: Joi.string().allow(""),
    MentalHealthServicesDetails: Joi.string().allow(""),
    Smoke: Joi.string().allow(""),
    PermissionToSmoke: Joi.string().allow(""),
    Unsupervised: Joi.string().allow(""),
    UnsupervisedDetails: Joi.string().allow(""),
    CASAWorkerName: Joi.string().allow(""),
    CASAWorkerPhone: Joi.string().allow(""),
    ObtainLicense: Joi.string().allow(""),
    PermissionToDrive: Joi.string().allow(""),
    PermissionToSleepOver: Joi.string().allow(""),
    PermissionToRide: Joi.string().allow(""),
    Consent: Joi.boolean(),
    PrivacyNotices: Joi.boolean(),
    Communication: Joi.boolean(),
  },
  "62C734A6-BA3D-EC11-981F-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SAFYOfficeAddress: Joi.string().required().label("SAFY Office"),
    FromInfo: Joi.string().required().label("From Info"),
    AllRecords: Joi.boolean(),
    SocialHistory: Joi.boolean(),
    ContinuityOfCare: Joi.boolean(),
    DiagnosticAssessment: Joi.boolean(),
    TreatmentCompliance: Joi.boolean(),
    ProgressReports: Joi.boolean(),
    Employment: Joi.boolean(),
    LivingAssessments: Joi.boolean(),
    Legal: Joi.boolean(),
    DischargeSummary: Joi.boolean(),
    FamilyInvolvement: Joi.boolean(),
    TreatmentPlan: Joi.boolean(),
    PhysicalInvolvement: Joi.boolean(),
    Medications: Joi.boolean(),
    SchoolInvolvement: Joi.boolean(),
    SubstanceAbuse: Joi.boolean(),
    PsychConditions: Joi.boolean(),
    Other: Joi.boolean(),
    OtherDetails: Joi.string()
      .allow("")
      .label("Other")
      .when("Other", { is: true, then: Joi.required() }),
    Purpose: Joi.string().required().label("Purpose/Need"),
    Written: Joi.boolean(),
    Verbal: Joi.boolean(),
    Fax: Joi.boolean(),
    Audio: Joi.boolean(),
    Video: Joi.boolean(),
    Email: Joi.boolean(),
    AllMembers: Joi.boolean(),
    CancellationDate: Joi.string().allow(""),
    CancellationTime: Joi.string().allow(""),
    CancellationMode: Joi.string().allow(""),
  },
  "43CE7348-F03C-EC11-981F-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    Date: Joi.string().allow(""),
    ReferrerName: Joi.string().allow(""),
    ReferrerPhone: Joi.string().allow(""),
    ReferrerEmail: Joi.string().allow(""),
    ReferrerRelationship: Joi.string().allow(""),
    ReferringAgency: Joi.string().allow(""),
    ClientSocial: Joi.string().allow(""),
    ClientSex: Joi.string().allow(""),
    ClientRace: Joi.string().allow(""),
    ClientAddress: Joi.string().allow(""),
    ClientCity: Joi.string().allow(""),
    ClientState: Joi.string().allow(""),
    ClientZip: Joi.string().allow(""),
    ClientPhone: Joi.string().allow(""),
    ClientAltPhone: Joi.string().allow(""),
    GuardianName: Joi.string().allow(""),
    GuardianRelationship: Joi.string().allow(""),
    GuardianAddress: Joi.string().allow(""),
    GuardianPhone: Joi.string().allow(""),
    CountyWorker: Joi.string().allow(""),
    CountyWorkerPhone: Joi.string().allow(""),
    PayorSource: Joi.string().allow(""),
    MedicaidNumber: Joi.string().allow(""),
    PrimaryInsurance: Joi.string().allow(""),
    PrimaryInsurancePhone: Joi.string().allow(""),
    SecondaryInsurance: Joi.string().allow(""),
    SecondaryInsurancePhone: Joi.string().allow(""),
    HouseMates: Joi.string().allow(""),
    Problems: Joi.string().allow(""),
    MedicalHistory: Joi.string().allow(""),
    Medications: Joi.string().allow(""),
    TypeOfService: Joi.string().allow(""),
    InCrisis: Joi.string().allow(""),
    InCrisisDetails: Joi.string().allow(""),
    Aware: Joi.string().allow(""),
  },
  "23EA30E7-A453-EC11-981F-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    CoachName: Joi.string().required().label("Coach Name"),
    FosterHomeName: Joi.string().required().label("Foster Home Name"),
    Agency: Joi.string().required().label("Agency"),
    DateOfSession: Joi.string()
      .allow("")
      .required()
      .label("Date of Coaching Session"),
    FollowsDirections: Joi.boolean(),
    CompletesHomework: Joi.boolean(),
    FollowsRules: Joi.boolean(),
    GoodHygiene: Joi.boolean(),
    AppropriateTone: Joi.boolean(),
    TellsTruth: Joi.boolean(),
    PerformsWell: Joi.boolean(),
    RespectsProperty: Joi.boolean(),
    CompletesChores: Joi.boolean(),
    RespectsBoundaries: Joi.boolean(),
    ExpressesFeelings: Joi.boolean(),
    OtherPositive: Joi.boolean(),
    OtherPositiveDetails: Joi.string().allow(""),
    VerbalPraise: Joi.boolean(),
    NonVerbalPraise: Joi.boolean(),
    ReminderOfReward: Joi.boolean(),
    BehaviorContract: Joi.boolean(),
    NaturalConsequence: Joi.boolean(),
    Reward: Joi.boolean(),
    TrackPositiveBehavior: Joi.boolean(),
    OtherStrategy: Joi.boolean(),
    OtherStrategyDetails: Joi.string().allow(""),
    StrategiesWorking: Joi.string().allow(""),
    StrategiesToTry: Joi.string().allow(""),
    ProblematicBehaviors: Joi.string().allow(""),
    ProblemBehavior: Joi.string().allow(""),
    ProblemBehaviorDetails: Joi.string().allow(""),
    BehaviorFrequency: Joi.string().allow(""),
    BehaviorDuration: Joi.string().allow(""),
    BehaviorIntensity: Joi.string().allow(""),
    BehaviorAntecedent: Joi.string().allow(""),
    BehaviorConsequence: Joi.string().allow(""),
    InfluenceThoughts: Joi.string().allow(""),
    InterventionsToAvoid: Joi.string().allow(""),
    TimeIn: Joi.boolean(),
    TimeOut: Joi.boolean(),
    Restitution: Joi.boolean(),
    DirectionWithWarning: Joi.boolean(),
    ProblemSolving: Joi.boolean(),
    PrivilegeRemoval: Joi.boolean(),
    NaturalConsequenceReduce: Joi.boolean(),
    BehaviorContractReduce: Joi.boolean(),
    LogicalConsequence: Joi.boolean(),
    VerbalPraiseReduce: Joi.boolean(),
    RewardReduce: Joi.boolean(),
    OtherReduce: Joi.boolean(),
    OtherReduceDetails: Joi.string().allow(""),
    StrategiesWorkingReduce: Joi.string().allow(""),
    NewInterventions: Joi.string().allow(""),
    DailyCheckIns: Joi.string().allow(""),
    CheckInPositiveInfo: Joi.string().allow(""),
    CheckInConcerns: Joi.string().allow(""),
    FamilyMeeting: Joi.string().allow(""),
    FamilyMeetingReviewed: Joi.string().allow(""),
    FamilyFunTime: Joi.string().allow(""),
    YouthIdentity: Joi.string().allow(""),
    PowerStruggle: Joi.string().allow(""),
    PreTeaching: Joi.boolean(),
    IMessage: Joi.boolean(),
    Ignored: Joi.boolean(),
    Neutral: Joi.boolean(),
    NoButtons: Joi.boolean(),
    WalkedAway: Joi.boolean(),
    Concise: Joi.boolean(),
    RegainComposure: Joi.boolean(),
    NoArguing: Joi.boolean(),
    OtherPowerStruggleStrategy: Joi.boolean(),
    OtherPowerStruggleStrategyDetails: Joi.string().allow(""),
    FeelingToday: Joi.string().allow(""),
    FeelingLastMeeting: Joi.string().allow(""),
    Respite: Joi.boolean(),
    AloneTime: Joi.boolean(),
    DeepBreathing: Joi.boolean(),
    Meditation: Joi.boolean(),
    Exercise: Joi.boolean(),
    Reading: Joi.boolean(),
    NightAway: Joi.boolean(),
    Prayer: Joi.boolean(),
    Listening: Joi.boolean(),
    Hobby: Joi.boolean(),
    Support: Joi.boolean(),
    OtherSelfCare: Joi.boolean(),
    OtherSelfCareDetails: Joi.string().allow(""),
    SelfCareStrategies: Joi.string().allow(""),
    AdditionalComments: Joi.string().allow(""),
  },
  "ABAE1747-BA53-EC11-981F-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    FosterHomeName: Joi.string().required().label("Foster Home Name"),
    DateOfSession: Joi.string().required().label("Date of Session"),
    PositiveLastSession: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    PositiveStrategies: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    HowReinforce: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    PositivityContinues: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    DoDifferent: Joi.string()
      .when("PositivityContinues", { is: "0", then: Joi.required() })
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    GoneWell: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    FollowsDirections: Joi.boolean(),
    FollowsRules: Joi.boolean(),
    CompletesHomework: Joi.boolean(),
    TellsTruth: Joi.boolean(),
    PerformsWell: Joi.boolean(),
    ExpressesFeelings: Joi.boolean(),
    RespectsBoundaries: Joi.boolean(),
    AppropriateTone: Joi.boolean(),
    CompletesChores: Joi.boolean(),
    RespectsProperty: Joi.boolean(),
    GoodHygiene: Joi.boolean(),
    OtherPositive: Joi.boolean(),
    OtherPositiveDetails: Joi.string()
      .when("OtherPositive", { is: "1", then: Joi.required() })
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    PositiveCircumstances: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    VerbalPraise: Joi.boolean(),
    NaturalConsequence: Joi.boolean(),
    NonVerbalPraise: Joi.boolean(),
    Reward: Joi.boolean(),
    ReminderOfReward: Joi.boolean(),
    TrackPositiveBehavior: Joi.boolean(),
    BehaviorContract: Joi.boolean(),
    OtherStrategy: Joi.boolean(),
    OtherStrategyDetails: Joi.string()
      .when("OtherStrategy", { is: "1", then: Joi.required() })
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    DailyCheckIns: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    CheckInPositiveInfo: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    FamilyMeeting: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    FamilyMeetingReviewed: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    PowerStruggle: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    PreTeaching: Joi.boolean(),
    IMessage: Joi.boolean(),
    NoArguing: Joi.boolean(),
    RegainComposure: Joi.boolean(),
    Separated: Joi.boolean(),
    Concise: Joi.boolean(),
    Ignored: Joi.boolean(),
    WalkedAway: Joi.boolean(),
    Neutral: Joi.boolean(),
    NoButtons: Joi.boolean(),
    PowerStruggleNA: Joi.boolean(),
    OtherPowerStruggleStrategy: Joi.boolean(),
    OtherPowerStruggleStrategyDetails: Joi.string()
      .when("OtherPowerStruggleStrategy", { is: "1", then: Joi.required() })
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    RestoreRelationship: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    FamilyFunTime: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    RevisitRules: Joi.boolean(),
    AddressIdentity: Joi.boolean(),
    ImplementBehaviorContract: Joi.boolean(),
    LifeSkill: Joi.boolean(),
    PreviousProblematicBehaviors: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    PreviousStrategies: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    ProblemsContinue: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    NewInterventions: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    FocusProblems: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    NewProblemsDetails: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    PrivilegeRemoval: Joi.boolean(),
    ProblemSolving: Joi.boolean(),
    Restitution: Joi.boolean(),
    BehaviorContractReduce: Joi.boolean(),
    TimeInOut: Joi.boolean(),
    TrackBehavior: Joi.boolean(),
    WorkChore: Joi.boolean(),
    RewardReduce: Joi.boolean(),
    NaturalConsequenceReduce: Joi.boolean(),
    VerbalPraiseReduce: Joi.boolean(),
    LogicalConsequence: Joi.boolean(),
    DirectionWithWarning: Joi.boolean(),
    OtherReduce: Joi.boolean(),
    OtherReduceDetails: Joi.string()
      .when("OtherReduce", { is: "1", then: Joi.required() })
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    TraumaRelated: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    InfluenceThoughts: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    StrategiesToTryOrAvoid: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    NeedRelated: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    LessonToMeetNeed: Joi.string()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      })
      .when("NeedRelated", { is: "1", then: Joi.required() }),
    FeelingLastMeeting: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    FeelingToday: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    ReasonForChange: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    SelfCareStrategies: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    SAFYHelp: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            default:
              error.message = "* Required";
              break;
          }
        });
        return errors;
      }),
    AdditionalComments: Joi.string().required(),
    DateOfNextMeeting: Joi.string().required().label("Date of Next Meeting"),
  },
  "95170327-B056-EC11-981F-DC98408D5418": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    Date: Joi.string().allow(""),
    FosterParentNames: Joi.string().allow(""),
    ClientName: Joi.string().allow(""),
    CaseCoordinatorName: Joi.string().allow(""),
    CaseCoordinatorPhone: Joi.string().allow(""),
    SAFYSupervisorName: Joi.string().allow(""),
    SAFYSupervisorPhone: Joi.string().allow(""),
    CaseWorkerName: Joi.string().allow(""),
    CaseWorkerPhone: Joi.string().allow(""),
  },
  "D2D01099-9D57-EC11-981F-DC98408D5418": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    AllServices: Joi.boolean(),
    CaseManagement: Joi.boolean(),
    BehavioralHealth: Joi.boolean(),
    Therapeutic: Joi.boolean(),
    Authorized: Joi.boolean(),
    Telehealth: Joi.boolean(),
    TelehealthEmail: Joi.string().allow(""),
    PrivacyPractices: Joi.boolean(),
    LeaveMessages: Joi.boolean(),
    LeaveMessagesPhone: Joi.string().allow(""),
    TextMessages: Joi.boolean(),
    TextMessagesPhone: Joi.string().allow(""),
    Email: Joi.boolean(),
    EmailAddress: Joi.string().allow(""),
  },
  "3CB5089F-095A-EC11-94F6-DC98408D5418": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SafetyPlanDate: Joi.string().required(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    SelfHarm: Joi.boolean(),
    AWOL: Joi.boolean(),
    PropertyDestruction: Joi.boolean(),
    PhysicalAggression: Joi.boolean(),
    VerbalAggression: Joi.boolean(),
    SubstanceUse: Joi.boolean(),
    UnsafeSleepBehaviors: Joi.boolean(),
    UnsafeActsTowardsAnimals: Joi.boolean(),
    UnsafeSchoolBehaviors: Joi.boolean(),
    UnsafeSexualBehaviors: Joi.boolean(),
    HumanTraffickingVictim: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.string().allow(""),
    TriggerDetails: Joi.string().allow(""),
    BehaviorDetails: Joi.string().allow(""),
    ReasonsToLive: Joi.string().allow(""),
    FeelingToday: Joi.string().allow(""),
    FeelingAtWorst: Joi.string().allow(""),
    WorryPoint: Joi.string().allow(""),
    CheckInFrequency: Joi.string().allow(""),
    ScalingQuestion: Joi.string().allow(""),
    Sweating: Joi.boolean(),
    BreathingHard: Joi.boolean(),
    RacingHeart: Joi.boolean(),
    ClenchingTeeth: Joi.boolean(),
    ClenchingFists: Joi.boolean(),
    RedFaced: Joi.boolean(),
    LoudVoice: Joi.boolean(),
    Rocking: Joi.boolean(),
    Fidgety: Joi.boolean(),
    Crying: Joi.boolean(),
    SleepingAlot: Joi.boolean(),
    DifficultySleeping: Joi.boolean(),
    Pacing: Joi.boolean(),
    Nauseous: Joi.boolean(),
    Alone: Joi.boolean(),
    RacingThoughts: Joi.boolean(),
    FallAsleep: Joi.boolean(),
    OtherSign: Joi.boolean(),
    OtherSignDetails: Joi.string().allow(""),
    Yelling: Joi.boolean(),
    ReadingHome: Joi.boolean(),
    ExerciseHome: Joi.boolean(),
    WritingHome: Joi.boolean(),
    DrawingHome: Joi.boolean(),
    Watching: Joi.boolean(),
    SupportHome: Joi.boolean(),
    Playing: Joi.boolean(),
    Shower: Joi.boolean(),
    MusicHome: Joi.boolean(),
    WalkingHome: Joi.boolean(),
    BlanketHome: Joi.boolean(),
    AnimalsHome: Joi.boolean(),
    OtherHomeStrategy: Joi.boolean(),
    OtherHomeStrategyDetails: Joi.string().allow(""),
    ReadingSchool: Joi.boolean(),
    ExerciseSchool: Joi.boolean(),
    WritingSchool: Joi.boolean(),
    DrawingSchool: Joi.boolean(),
    SupportSchool: Joi.boolean(),
    SupportTeacher: Joi.boolean(),
    MusicSchool: Joi.boolean(),
    WalkingSchool: Joi.boolean(),
    BlanketSchool: Joi.boolean(),
    AnimalsSchool: Joi.boolean(),
    OtherSchoolStrategy: Joi.boolean(),
    OtherSchoolStrategyDetails: Joi.string().allow(""),
    MySupportsHome: Joi.string().allow(""),
    MySupportsSchool: Joi.string().allow(""),
    SafetyPlan: Joi.string().allow(""),
    TriggersAndWarnings: Joi.string().allow(""),
    TriggersAndWarningsResponse: Joi.string().allow(""),
    Visible: Joi.boolean(),
    SameRoom: Joi.boolean(),
    RestrictedOutings: Joi.boolean(),
    RoomSearch: Joi.boolean(),
    ReviewPhone: Joi.boolean(),
    Cameras: Joi.boolean(),
    RemoveDoors: Joi.boolean(),
    CheckingIn: Joi.boolean(),
    TrackFriendInfo: Joi.boolean(),
    PlanActivities: Joi.boolean(),
    OtherMonitoring: Joi.boolean(),
    OtherMonitoringDetails: Joi.string().allow(""),
    LockupWeapons: Joi.boolean(),
    LockupMeds: Joi.boolean(),
    LockupSharps: Joi.boolean(),
    LockupPoisons: Joi.boolean(),
    DoorWindowAlarms: Joi.boolean(),
    RestrictAlcohol: Joi.boolean(),
    ParkOutside: Joi.boolean(),
    LockupFireStarters: Joi.boolean(),
    KeepKeys: Joi.boolean(),
    OtherSafeStep: Joi.boolean(),
    OtherSafeStepDetails: Joi.string().allow(""),
    SupportChild: Joi.string().allow(""),
    SupportSelf: Joi.string().allow(""),
    Hotline: Joi.string().allow(""),
    Hospital: Joi.string().allow(""),
    CrisisCenter: Joi.string().allow(""),
    Other: Joi.string().allow(""),
    SAFYCrisisCenter: Joi.string().allow(""),

    // DEPRECATED FIELDS
    SAFYCrisisLine: Joi.string().allow(""),
  },
  "7ED7DE67-DC7E-EC11-94F7-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    PreferredName: Joi.string().label("Preferred Name").required(),
    Pronouns: Joi.string().label("Pronouns").required(),
    PronounsDescription: Joi.string()
      .label("Pronouns Description")
      .when("Pronouns", { is: "Describe", then: Joi.required() }),
    IdentifiedRace: Joi.string().label("Race").required(),
    IdentifiedRaceDescription: Joi.string()
      .label("Race Description")
      .when("IdentifiedRace", { is: "Multi-cutural", then: Joi.required() })
      .when("IdentifiedRace", { is: "Other", then: Joi.required() }),
    DateCompleted: Joi.string().label("Date Completed").required(),
    Assessor: Joi.string().label("Assessing Professional/Title").required(),
    PSDType: Joi.string().label("Type of PSD").required(),
    ReviewReason: Joi.string()
      .label("Review Reason")
      .when("PSDType", { is: "Review", then: Joi.required() }),
    ISClient: Joi.boolean(),
    ISParent: Joi.boolean(),
    ISFamily: Joi.boolean(),
    ISGuardian: Joi.boolean(),
    ISCaregiver: Joi.boolean(),
    ISPhysician: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISDFS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISParentDetails: Joi.string()
      .label("Parent source")
      .when("ISParent", { is: true, then: Joi.required() }),
    ISFamilyDetails: Joi.string()
      .label("Family source")
      .when("ISFamily", { is: true, then: Joi.required() }),
    ISGuardianDetails: Joi.string()
      .label("Guardian source")
      .when("ISGuardian", { is: true, then: Joi.required() }),
    ISCaregiverDetails: Joi.string()
      .label("Non-parent Caregiver source")
      .when("ISCaregiver", { is: true, then: Joi.required() }),
    ISPhysicianDetails: Joi.string()
      .label("Physician source")
      .when("ISPhysician", { is: true, then: Joi.required() }),
    ISRecordsDetails: Joi.string()
      .label("Records source")
      .when("ISRecords", { is: true, then: Joi.required() }),
    ISServiceProviderDetails: Joi.string()
      .label("Service Provider source")
      .when("ISServiceProvider", { is: true, then: Joi.required() }),
    ISSchoolDetails: Joi.string()
      .label("School source")
      .when("ISSchool", { is: true, then: Joi.required() }),
    ISCourtDetails: Joi.string()
      .label("Court source")
      .when("ISCourt", { is: true, then: Joi.required() }),
    ISDFSDetails: Joi.string()
      .label("DFS source")
      .when("ISDFS", { is: true, then: Joi.required() }),
    ISOtherDetails: Joi.string()
      .label("Other source")
      .when("ISOther", { is: true, then: Joi.required() }),
    FamilyInformationDetails: Joi.string()
      .label("Family Imformation")
      .required(),
    BioFamilyInfo: Joi.string().allow(""),
    FamilyStrengths: Joi.string().label("Family Strengths").required(),
    GeneticFactors: Joi.string().label("Genetic Factors").required(),
    EpigeneticFactors: Joi.string().label("Epigenetic Facotrs").required(),
    RelationshipHistory: Joi.string()
      .label("Parent Relationship History")
      .required(),
    CPSHistory: Joi.string().label("CPS History").required(),
    PlacementHistory: Joi.string().label("Placement History").required(),
    JuvenileJusticeHistory: Joi.string()
      .label("Juvenile Justice History")
      .required(),
    AdoptionHistory: Joi.string().label("Adoption History").required(),
    PhysicalAbuse: Joi.string().label("Physical Abuse Status").required(),
    PhysicalAbuseComments: Joi.string()
      .label("Physical Abuse Comments")
      .when("PhysicalAbuse", { is: "Yes", then: Joi.required() })
      .when("PhysicalAbuse", { is: "Suspected", then: Joi.required() }),
    SexualAbuse: Joi.string().label("Sexual Abuse Status").required(),
    SexualAbuseComments: Joi.string()
      .label("Sexual Abuse Comments")
      .when("SexualAbuse", { is: "Yes", then: Joi.required() })
      .when("SexualAbuse", { is: "Suspected", then: Joi.required() }),
    EmotionalAbuse: Joi.string().label("Emotional Abuse Status").required(),
    EmotionalAbuseComments: Joi.string()
      .label("Emotional Abuse Comments")
      .when("EmotionalAbuse", { is: "Yes", then: Joi.required() })
      .when("EmotionalAbuse", { is: "Suspected", then: Joi.required() }),
    PhysicalNeglect: Joi.string().label("Physical Neglect Status").required(),
    PhysicalNeglectComments: Joi.string()
      .label("Physical Neglect Comments")
      .when("PhysicalNeglect", { is: "Yes", then: Joi.required() })
      .when("PhysicalNeglect", { is: "Suspected", then: Joi.required() }),
    EmotionalNeglect: Joi.string().label("Emotional Neglect Status").required(),
    EmotionalNeglectComments: Joi.string()
      .label("Emotional Neglect Comments")
      .when("EmotionalNeglect", { is: "Yes", then: Joi.required() })
      .when("EmotionalNeglect", { is: "Suspected", then: Joi.required() }),
    MentalIllness: Joi.string().label("Mental Illness Status").required(),
    MentalIllnessComments: Joi.string()
      .label("Mental Illness Comments")
      .when("MentalIllness", { is: "Yes", then: Joi.required() })
      .when("MentalIllness", { is: "Suspected", then: Joi.required() }),
    Divorce: Joi.string().label("Divorce Status").required(),
    DivorceComments: Joi.string()
      .label("Divorce Comments")
      .when("Divorce", { is: "Yes", then: Joi.required() })
      .when("Divorce", { is: "Suspected", then: Joi.required() }),
    SubstanceAbuse: Joi.string().label("Substance Abuse Status").required(),
    SubstanceAbuseComments: Joi.string()
      .label("Substance Abuse Comments")
      .when("SubstanceAbuse", { is: "Yes", then: Joi.required() })
      .when("SubstanceAbuse", { is: "Suspected", then: Joi.required() }),
    ViolenceAgainstMom: Joi.string()
      .label("Violence Against Mother Status")
      .required(),
    ViolenceAgainstMomComments: Joi.string()
      .label("Violence Against Mother Comments")
      .when("ViolenceAgainstMom", { is: "Yes", then: Joi.required() })
      .when("ViolenceAgainstMom", { is: "Suspected", then: Joi.required() }),
    CaregiverMentalIllness: Joi.string()
      .label("Caregiver Mental Illness Status")
      .required(),
    CaregiverMentalIllnessComments: Joi.string()
      .label("Caregiver Mental Illness Comments")
      .when("CaregiverMentalIllness", { is: "Yes", then: Joi.required() })
      .when("CaregiverMentalIllness", {
        is: "Suspected",
        then: Joi.required(),
      }),
    RelativeJail: Joi.string().label("Relative Been to Jail Status").required(),
    RelativeJailComments: Joi.string()
      .label("Relative Been to Jail Comments")
      .when("RelativeJail", { is: "Yes", then: Joi.required() })
      .when("RelativeJail", { is: "Suspected", then: Joi.required() }),
    AgeCategory: Joi.string().label("Age Category").required(),
    IntrauterineExperiences: Joi.string()
      .label("Intrauterine Experiences")
      .required(),
    BirthExperiences: Joi.string().label("Birth Experiences").required(),
    PerinatalExperiences: Joi.string()
      .label("Perinatal Experiences")
      .required(),
    InfancyExperiences: Joi.string().label("Infancy Experiences").required(),
    EarlyChildhoodExperiences: Joi.string()
      .label("Early Childhood Experiences")
      .required(),
    ChildhoodExperiences: Joi.string()
      .label("Childhood Experiences")
      .when("AgeCategory", { is: "4-10", then: Joi.required() })
      .when("AgeCategory", { is: "11-18", then: Joi.required() })
      .when("AgeCategory", { is: "19-24", then: Joi.required() })
      .when("AgeCategory", { is: "25+", then: Joi.required() }),
    YouthExperiences: Joi.string()
      .label("Youth Experiences")
      .when("AgeCategory", { is: "11-18", then: Joi.required() })
      .when("AgeCategory", { is: "19-24", then: Joi.required() })
      .when("AgeCategory", { is: "25+", then: Joi.required() }),
    EarlyAdultExperiences: Joi.string()
      .label("Early Adult Experiences")
      .when("AgeCategory", { is: "19-24", then: Joi.required() })
      .when("AgeCategory", { is: "25+", then: Joi.required() }),
    AdultExperiences: Joi.string()
      .label("Adult Experiences")
      .when("AgeCategory", { is: "25+", then: Joi.required() }),
    MentalHealthTreatmentNA: Joi.boolean(),
    MentalHealthDiagnoses: Joi.string()
      .label("Mental Health Diagnoses")
      .when("MentalHealthTreatmentNA", { is: false, then: Joi.required() }),
    MentalHealthTreatmentHistory: Joi.string()
      .label("Mental Health Treatment History")
      .when("MentalHealthTreatmentNA", { is: false, then: Joi.required() }),
    SubstanceUseNA: Joi.boolean(),
    PastSubstanceUse: Joi.string()
      .label("History of past drug or alcohol use")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    SubstanceUseHistory: Joi.string()
      .label("Current substance use information")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    PerceptionOfSubstanceUse: Joi.string()
      .label("Perception of substance use")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    SubstanceUseComments: Joi.string()
      .label("Substance use comments")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    NoPastTreatment: Joi.boolean(),
    SubstanceUseTreatmentHistory: Joi.string()
      .label("Substance use treatment history")
      .when("NoPastTreatment", { is: false, then: Joi.required() }),
    ClientStrengths: Joi.string().label("Client Strengths").required(),
    WishToStopExisting: Joi.string()
      .label(
        "Have you ever wished you were dead or wished you could go to sleep and not wake up?"
      )
      .required(),
    WishToStopExistingComments: Joi.string()
      .label("Comments")
      .when("WishToStopExisting", { is: "Yes", then: Joi.required() }),
    ThoughtsOfSuicide: Joi.string()
      .label("Have you had any thoughts of killing yourself?")
      .required(),
    ThoughtsOfSuicideComments: Joi.string()
      .label("Comments")
      .when("ThoughtsOfSuicide", { is: "Yes", then: Joi.required() }),
    HarmedSelf: Joi.string()
      .label("Have you ever engaged in self-harm without intent to die?")
      .required(),
    HarmedSelfComments: Joi.string()
      .label("Comments")
      .when("HarmedSelf", { is: "Yes", then: Joi.required() }),
    RecklessBehavior: Joi.string()
      .label(
        "Have you ever done something reckless/dangerous without concern for your safety?"
      )
      .required(),
    RecklessBehaviorComments: Joi.string()
      .label("Comments")
      .when("RecklessBehavior", { is: "Yes", then: Joi.required() }),
    HarmedOthers: Joi.string()
      .label(
        "Have you ever physically harmed or forced yourself on someone else, including a peer, sibling, parent, caregiver or other adult in charge of your supervision?"
      )
      .required(),
    HarmedOthersComments: Joi.string()
      .label("Comments")
      .when("HarmedOthers", { is: "Yes", then: Joi.required() }),
    Attention: Joi.string().label("Attention").required(),
    NoFocus: Joi.boolean(),
    IncompleteTasks: Joi.boolean(),
    Distracted: Joi.boolean(),
    NoShift: Joi.boolean(),
    AttentionHypervigilance: Joi.boolean(),
    Sleep: Joi.string().label("Sleep").required(),
    NoSleep: Joi.boolean(),
    NoStaySleep: Joi.boolean(),
    NoSleepAlone: Joi.boolean(),
    SleepHypnogogicPhenomenon: Joi.boolean(),
    Nightmares: Joi.boolean(),
    SleepSleepApnea: Joi.boolean(),
    Waking: Joi.boolean(),
    Wandering: Joi.boolean(),
    Sleepiness: Joi.boolean(),
    SleepCycleReversal: Joi.boolean(),
    Dissociation: Joi.string().label("Dissociation").required(),
    SlowBlink: Joi.boolean(),
    EyesGlazeOver: Joi.boolean(),
    LoseTrackOfTime: Joi.boolean(),
    NotHeard: Joi.boolean(),
    Disconnected: Joi.boolean(),
    Hallucinate: Joi.boolean(),
    PainInsensitivity: Joi.boolean(),
    FrequentProblems: Joi.boolean(),
    Daydreams: Joi.boolean(),
    DissociationSelfAbuse: Joi.boolean(),
    Arousal: Joi.string().label("Arousal").required(),
    IncreasedMuscleTone: Joi.boolean(),
    IncreasedMotorActivity: Joi.boolean(),
    ArousalHypervigilance: Joi.boolean(),
    SleepProblems: Joi.boolean(),
    ArousalImpulsivity: Joi.boolean(),
    DifficultTransition: Joi.boolean(),
    MisperceivingCues: Joi.boolean(),
    Resistant: Joi.boolean(),
    Defiant: Joi.boolean(),
    Aggressive: Joi.boolean(),
    Reward: Joi.string().label("Reward").required(),
    DislikesTouch: Joi.boolean(),
    NoValueBehavior: Joi.boolean(),
    DislikesMusic: Joi.boolean(),
    UnhealthySex: Joi.boolean(),
    Overeating: Joi.boolean(),
    RewardSelfAbuse: Joi.boolean(),
    RewardSubstanceUse: Joi.boolean(),
    Mood: Joi.string().label("Affect Regulation/Mood").required(),
    RangeOfEmotions: Joi.boolean(),
    Congruent: Joi.boolean(),
    CorrectResponse: Joi.boolean(),
    Nonverbal: Joi.boolean(),
    MoodAnxious: Joi.boolean(),
    CalmsDown: Joi.boolean(),
    Empathy: Joi.string().label("Attunement / Empathy").required(),
    Selfish: Joi.boolean(),
    Acknowledge: Joi.boolean(),
    MakesEyeContact: Joi.boolean(),
    SharesFeelings: Joi.boolean(),
    ShowsAffection: Joi.boolean(),
    ComfortsOthers: Joi.boolean(),
    CloseRelationships: Joi.boolean(),
    RespondsToCaregiver: Joi.boolean(),
    PlaysWithFriends: Joi.boolean(),
    ReferencesCaregiver: Joi.boolean(),
    RelationalAttachment: Joi.string()
      .label("Relational / Attachment")
      .required(),
    ElicitBehavior: Joi.boolean(),
    IndiscriminateAffection: Joi.boolean(),
    AutisticLikeBehaviors: Joi.boolean(),
    SenseOfTime: Joi.string()
      .label("Sense of Time / Delay Gratification")
      .required(),
    EarnReward: Joi.boolean(),
    TrustsReward: Joi.boolean(),
    Communication: Joi.string().label("Communication").required(),
    SelfAwareness: Joi.string().label("Self-Awareness/Self-Image").required(),
    BodyImageDistortions: Joi.boolean(),
    Narcissistic: Joi.boolean(),
    SelfDefeating: Joi.boolean(),
    NonverbalCognition: Joi.string().label("Non-verbal Cognition").required(),
    ModulateReactivity: Joi.string()
      .label("Modulate Reactivity / Impulsivity")
      .required(),
    AbstractCognition: Joi.string()
      .label("Abstract / Reflective Cognition")
      .required(),
    Morality: Joi.string().label("Values / Beliefs / Morality").required(),
    Dishonest: Joi.boolean(),
    Altruistic: Joi.boolean(),
    ResistsTemptation: Joi.boolean(),
    Delinquent: Joi.boolean(),
    DeviatesCulturalValues: Joi.boolean(),
    SpiritualPractice: Joi.boolean(),
    AppropriateAppearance: Joi.boolean(),
    Neat: Joi.boolean(),
    Disheveled: Joi.boolean(),
    BizarreAppearance: Joi.boolean(),
    OtherAppearance: Joi.boolean(),
    OtherAppearanceDetails: Joi.string()
      .label("Other Appearance Comments")
      .when("OtherAppearance", { is: true, then: Joi.required() }),
    Cooperative: Joi.boolean(),
    Guarded: Joi.boolean(),
    Hyperactive: Joi.boolean(),
    Agitated: Joi.boolean(),
    Paranoid: Joi.boolean(),
    Tics: Joi.boolean(),
    Impulsive: Joi.boolean(),
    ArousalAggressive: Joi.boolean(),
    Withdrawn: Joi.boolean(),
    BizarreBehavior: Joi.boolean(),
    Rigidity: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.string()
      .label("Other Behavior Comments")
      .when("OtherBehavior", { is: true, then: Joi.required() }),
    Normal: Joi.boolean(),
    Slurred: Joi.boolean(),
    Pressured: Joi.boolean(),
    Tangential: Joi.boolean(),
    Incoherent: Joi.boolean(),
    Stutters: Joi.boolean(),
    OtherSpeech: Joi.boolean(),
    OtherSpeechDetails: Joi.string()
      .label("Other Speech Comments")
      .when("OtherSpeech", { is: true, then: Joi.required() }),
    Euthymic: Joi.boolean(),
    Anxious: Joi.boolean(),
    Angry: Joi.boolean(),
    Depressed: Joi.boolean(),
    Euphoric: Joi.boolean(),
    Irritable: Joi.boolean(),
    Fearful: Joi.boolean(),
    OtherMood: Joi.boolean(),
    OtherMoodDetails: Joi.string()
      .label("Other Mood Comments")
      .when("OtherMood", { is: true, then: Joi.required() }),
    FullRange: Joi.boolean(),
    Restricted: Joi.boolean(),
    Blunted: Joi.boolean(),
    Flat: Joi.boolean(),
    Inappropriate: Joi.boolean(),
    OtherAffect: Joi.boolean(),
    OtherAffectDetails: Joi.string()
      .label("Other Affect Comments")
      .when("OtherAffect", { is: true, then: Joi.required() }),
    Logical: Joi.boolean(),
    Preoccupations: Joi.boolean(),
    Delusions: Joi.boolean(),
    Hallucinations: Joi.boolean(),
    Racing: Joi.boolean(),
    Disorganized: Joi.boolean(),
    Concrete: Joi.boolean(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    OtherPerception: Joi.boolean(),
    OtherPerceptionDetails: Joi.string()
      .label("Other Perception Comments")
      .when("OtherPerception", { is: true, then: Joi.required() }),
    NoImpairment: Joi.boolean(),
    ShortAttentionSpan: Joi.boolean(),
    DifficultyConcentrating: Joi.boolean(),
    Distractibility: Joi.boolean(),
    MemoryImpairment: Joi.boolean(),
    LowIntelligence: Joi.boolean(),
    OtherCognition: Joi.boolean(),
    OtherCognitionDetails: Joi.string()
      .label("Other Cognition Comments")
      .when("OtherCognition", { is: true, then: Joi.required() }),
    AppropriateInsight: Joi.boolean(),
    Fair: Joi.boolean(),
    Impaired: Joi.boolean(),
    OtherInsight: Joi.boolean(),
    OtherInsightDetails: Joi.string()
      .label("Other Insight Comments")
      .when("OtherInsight", { is: true, then: Joi.required() }),
    MentalStatusComments: Joi.string()
      .label("Mental Status Comments")
      .required(),
    CurrentlyLiveWith: Joi.string().label("Who you're living with").required(),
    ContactWithBioFamily: Joi.string()
      .label("Do you have contact with biological family")
      .required(),
    RelationshipDynamics: Joi.string()
      .label("Relationship dynamics")
      .required(),
    ParentingStyle: Joi.string()
      .label("Parenting Style and Philosophy")
      .required(),
    CulturalConsiderations: Joi.string()
      .label("Cultural Consideration")
      .required(),
    EducationStatus: Joi.string().label("Education Status").required(),
    EducationalHistory: Joi.string()
      .label("Educational History")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      })
      .when("EducationStatus", { is: "Graduated", then: Joi.required() })
      .when("EducationStatus", { is: "GED", then: Joi.required() })
      .when("EducationStatus", {
        is: "Dropout/Did not complete",
        then: Joi.required(),
      }),
    AcademicFunctioning: Joi.string()
      .label("Academic Functioning")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      })
      .when("EducationStatus", { is: "Graduated", then: Joi.required() })
      .when("EducationStatus", { is: "GED", then: Joi.required() })
      .when("EducationStatus", {
        is: "Dropout/Did not complete",
        then: Joi.required(),
      }),
    RepeatDirections: Joi.boolean(),
    CauseAndEffect: Joi.boolean(),
    Permanence: Joi.boolean(),
    UnderstandMotivations: Joi.boolean(),
    MentalMath: Joi.boolean(),
    Imagery: Joi.boolean(),
    WordProblems: Joi.boolean(),
    Infographics: Joi.boolean(),
    Symbols: Joi.boolean(),
    LargerConcept: Joi.boolean(),
    Writing: Joi.boolean(),
    ConveyMeaning: Joi.boolean(),
    BehavioralFunctioning: Joi.string()
      .label("Behavioral Functioning")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      })
      .when("EducationStatus", { is: "Graduated", then: Joi.required() })
      .when("EducationStatus", { is: "GED", then: Joi.required() })
      .when("EducationStatus", {
        is: "Dropout/Did not complete",
        then: Joi.required(),
      }),
    MedicalHistory: Joi.string().label("Medical History").required(),
    MedicalNeeds: Joi.string()
      .label("Current Medical Needs and Services")
      .required(),
    OccupationalTherapy: Joi.boolean(),
    PhysicalTherapy: Joi.boolean(),
    SpeechTherapy: Joi.boolean(),
    FeedingTherapy: Joi.boolean(),
    Medication: Joi.boolean(),
    ImmunizationDeficiency: Joi.boolean(),
    Precautions: Joi.boolean(),
    ChronicCondition: Joi.boolean(),
    Vitals: Joi.string().label("Most Recent Vitals").required(),
    AutonomicRegulation: Joi.string().label("Autonomic Regulation").required(),
    AutonomicRegulationSleepApnea: Joi.boolean(),
    SIDS: Joi.boolean(),
    ExcessiveSighing: Joi.boolean(),
    ExcessiveYawning: Joi.boolean(),
    Asthma: Joi.boolean(),
    Diabetes: Joi.boolean(),
    Bloating: Joi.boolean(),
    Diarrhea: Joi.boolean(),
    Constipation: Joi.boolean(),
    IBS: Joi.boolean(),
    UrinaryIncontinence: Joi.boolean(),
    LossOfAppetite: Joi.boolean(),
    Dermatitis: Joi.boolean(),
    Hives: Joi.boolean(),
    SkinSensitivities: Joi.boolean(),
    DizzinessUponStanding: Joi.boolean(),
    TempAndMetabolism: Joi.string()
      .label("Temperature Regulation and Metabolism")
      .required(),
    NoWeightGain: Joi.boolean(),
    Obesity: Joi.boolean(),
    PickyEating: Joi.boolean(),
    Hoarding: Joi.boolean(),
    Gorging: Joi.boolean(),
    Purging: Joi.boolean(),
    Vomiting: Joi.boolean(),
    RefluxRumination: Joi.boolean(),
    EyeMovement: Joi.string().label("Extra Occular Eye Movements").required(),
    EyeMovementTics: Joi.boolean(),
    EyeBlinkRate: Joi.boolean(),
    SmoothMovements: Joi.boolean(),
    Convergence: Joi.boolean(),
    SuckSwallowGag: Joi.string().label("Suck, Swallow, Gag").required(),
    ExcessiveSucking: Joi.boolean(),
    ExcessiveSwallowing: Joi.boolean(),
    Gulping: Joi.boolean(),
    Reflux: Joi.boolean(),
    Regurgitation: Joi.boolean(),
    RuminationGagging: Joi.boolean(),
    DifficultyChewing: Joi.boolean(),
    DifficultyPills: Joi.boolean(),
    SoftTextures: Joi.boolean(),
    SuckSwallowGagPica: Joi.boolean(),
    Mouthing: Joi.boolean(),
    OralFixation: Joi.boolean(),
    Appetite: Joi.string().label("Feeding and Appetite").required(),
    Rumination: Joi.boolean(),
    OddFood: Joi.boolean(),
    FoodRefusal: Joi.boolean(),
    Anorexia: Joi.boolean(),
    Cravings: Joi.boolean(),
    AppetitePica: Joi.boolean(),
    EmotionalEating: Joi.boolean(),
    FineMotorSkills: Joi.string().label("Fine Motor Skills").required(),
    HandCoordination: Joi.boolean(),
    Tremors: Joi.boolean(),
    Drawing: Joi.boolean(),
    DrawingShapes: Joi.boolean(),
    WritesWith: Joi.boolean(),
    ScissorsGlue: Joi.boolean(),
    Utensils: Joi.boolean(),
    FeedsDrinks: Joi.boolean(),
    HandlesManipulatives: Joi.boolean(),
    FoldsPaper: Joi.boolean(),
    ButtonsZippers: Joi.boolean(),
    Shoes: Joi.boolean(),
    PlaysWithClay: Joi.boolean(),
    LargeMotorSkills: Joi.string().label("Large Motor Skills").required(),
    WalksCorrectly: Joi.boolean(),
    KickThrow: Joi.boolean(),
    Rhythm: Joi.boolean(),
    DislikesMovements: Joi.boolean(),
    AwkwardMovements: Joi.boolean(),
    Clumsiness: Joi.boolean(),
    Nueroendocrine: Joi.string()
      .label("Neuroendocrine and Hypothalamic Systems")
      .required(),
    PrematurePuberty: Joi.boolean(),
    LatePuberty: Joi.boolean(),
    GrowthAbnormalities: Joi.boolean(),
    LossOfHair: Joi.boolean(),
    TempRegulation: Joi.boolean(),
    HungerThirst: Joi.boolean(),
    ExcessiveFatigue: Joi.boolean(),
    HeightProblems: Joi.boolean(),
    ColdIntolerance: Joi.boolean(),
    Depression: Joi.boolean(),
    ExcessiveWeightLoss: Joi.boolean(),
    UncontrolledUrination: Joi.boolean(),
    InabilityToSmell: Joi.boolean(),
    PrimarySensoryIntegration: Joi.string()
      .label("Primary Sensory Integration")
      .required(),
    TouchHypersensitivity: Joi.boolean(),
    TouchDefensiveness: Joi.boolean(),
    Overwhelmed: Joi.boolean(),
    SensoryIssues: Joi.boolean(),
    MouthsObjects: Joi.boolean(),
    ChewsNonFood: Joi.boolean(),
    IncessantTouching: Joi.boolean(),
    PrimarySensoryIntegrationDislikesTouch: Joi.boolean(),
    DislikesMisc: Joi.boolean(),
    Psychosexual: Joi.string().label("Psychosexual").required(),
    GenderExpression: Joi.boolean(),
    AbnormalSexualPlay: Joi.boolean(),
    Predatory: Joi.boolean(),
    Masturbation: Joi.boolean(),
    Pornography: Joi.boolean(),
    SexualActingOut: Joi.boolean(),
    Somatosensory: Joi.string()
      .label("Somatosensory and Motorsensory")
      .required(),
    MotorDyscoordination: Joi.boolean(),
    Dyspraxia: Joi.boolean(),
    Miswiring: Joi.boolean(),
    SensoryMisperceptions: Joi.boolean(),
    SomatosensoryHypnogogicPhenomenon: Joi.boolean(),
    SomatosensoryHallucinations: Joi.boolean(),
    Speech: Joi.string().label("Speech and Articulation").required(),
    Volume: Joi.boolean(),
    CertainSounds: Joi.boolean(),
    Enunciation: Joi.boolean(),
    Mumbling: Joi.boolean(),
    Muttering: Joi.boolean(),
    Stuttering: Joi.boolean(),
    AssessmentType: Joi.string().label("Assessment Type").required(),
    AssessmentScore: Joi.string().label("Assessment Score").required(),
    SED: Joi.string().label("SED").required(),
    ClinicalNarrativeSummary: Joi.string()
      .label("Clinical Narrative Summary")
      .required(),
    DiagnosisDetails: Joi.string().label("Diagnosis Details").required(),
    TreatmentExpectations: Joi.string()
      .label("Treatment expectations")
      .required(),
    TreatmentRecommendations: Joi.string()
      .label("Treament Recommendations")
      .required(),
  },
  "C170DBB8-95E9-EB11-A7AD-DC98408D5418": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SAFYContact: Joi.string().label("SAFY contact").required(),
    DischargeReason: Joi.string().allow("Discharge/transition reason"),
    TimeFrame: Joi.string().allow("Time frame"),
    TransitioningTo: Joi.string().allow("Transition destination"),
    EmotionalDetails: Joi.string().allow("Emotional/behavioral needs"),
    EmotionalPerson: Joi.string().allow(
      "Person assigned to emotional/behavioral needs"
    ),
    EmotionalDone: Joi.boolean(),
    PhysicalDetails: Joi.string().allow("Physical needs"),
    PhysicalPerson: Joi.string().allow("Person assigned to physical needs"),
    PhysicalDone: Joi.boolean(),
    AppointmentsDetails: Joi.string().allow("Appointment needs"),
    AppointmentsPerson: Joi.string().allow(
      "Person assigned to emotional/behavioral needs"
    ),
    AppointmentsDone: Joi.boolean(),
    HotlineDetails: Joi.string().allow("Hotline"),
    HotlinePerson: Joi.string().allow(
      "Person assigned to emotional/behavioral needs"
    ),
    HotlineDone: Joi.boolean(),
    InitialTransportDetails: Joi.string().label(
      "Person transporting child to initial visit"
    ),
    WhereVisitDetails: Joi.string().label("Visit location"),
    VisitLengthDetails: Joi.string().label("Visit duration"),
    TeamMemberPresentDetails: Joi.string().label("Team Member present?"),
    FirstVisitPerson: Joi.string().label("Person assigned to first visit"),
    VisitDone: Joi.boolean(),
    ContactsDetails: Joi.string().label("Number of contacts"),
    OvernightsDetails: Joi.string().label("Are overnights allowed"),
    SubsequentVisitsPerson: Joi.string().label(
      "Person assigned to subsequenct visits"
    ),
    SubsequentVisitsDone: Joi.boolean(),
    WhenInformed: Joi.string().label("When child was informed"),
    WhenInformedPerson: Joi.string().label(
      "Person assigned to informing child"
    ),
    WhenInformedDone: Joi.boolean(),
    TransitionNeedsDetails: Joi.string().label("Transition needs"),
    TransitionNeedsPerson: Joi.string().label(
      "Person assigned to transition needs"
    ),
    TransitionNeedsDone: Joi.boolean(),
    WhoHelpsPackDetails: Joi.string().label("Packing helper"),
    WhoHelpsPackPerson: Joi.string().label("Person assigned to packing"),
    WhoHelpsPackDone: Joi.boolean(),
    HelpGoodbyeDetails: Joi.string().label("Farewells helper"),
    HelpGoodbyePerson: Joi.string().label("Person assigned to farewells"),
    HelpGoodbyeDone: Joi.boolean(),
    TransportDetails: Joi.string().label("Transport helper"),
    TransportPerson: Joi.string().label("Person assigned to transportation"),
    TransportDone: Joi.boolean(),
    ChildVisitDetails: Joi.string().label("Contact previous caregiver"),
    RespiteDetails: Joi.string().label("Respite possible"),
    ContactPerson: Joi.string().label(
      "Person assigned to contact with previous caregiver"
    ),
    ContactDone: Joi.boolean(),
    DocumentsDetails: Joi.string().label("Documents provided"),
    DocumentsPerson: Joi.string().label("Person assigned to documents"),
    DocumentsDone: Joi.boolean(),
    EmailDFSDetails: Joi.string().label("Email DFS"),
    EmailDFSPerson: Joi.string().label("Person assigned to email DFS"),
    EmailDFSDone: Joi.boolean(),
    EmailCensusDetails: Joi.string().label("Email NV Census"),
    EmailCensusPerson: Joi.string().label("Person assigned to email NV Census"),
    EmailCensusDone: Joi.boolean(),
  },
  "96B4F2C3-7B8F-EC11-A507-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SexAssignedAtBirth: Joi.string().label("Sex Assigned at Birth").required(),
    SexAssignedAtBirthDetails: Joi.string()
      .label("Sex Assigned at Birth Specifics")
      .when("SexAssignedAtBirth", {
        is: "Sex not listed",
        then: Joi.required(),
      }),
    Pronouns: Joi.string().label("Pronouns").required(),
    PronounsDescription: Joi.string()
      .label("Pronouns description")
      .when("Pronouns", {
        is: "Prefer to self-describe",
        then: Joi.required(),
      }),
    GenderIdentity: Joi.string().label("Gender Identity").required(),
    GenderIdentityDescription: Joi.string()
      .label("Gender Identity description")
      .when("GenderIdentity", {
        is: "Identity not listed",
        then: Joi.required(),
      }),
    DateCompleted: Joi.string().label("Date Completed").required(),
    PSDType: Joi.string().label("Type of PSD").required(),
    ReviewReason: Joi.string()
      .label("Review Reason")
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ISClient: Joi.boolean(),
    ISParent: Joi.boolean(),
    ISGuardian: Joi.boolean(),
    ISCaregiver: Joi.boolean(),
    ISPhysician: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISCPS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.string()
      .label("Other Information Source")
      .when("ISOther", { is: true, then: Joi.required() }),
    ReferralReason: Joi.string().label("Reason for Referral").required(),
    ReferralSource: Joi.string().label("Referral Source").required(),
    PresentingProblem: Joi.string().label("Presenting Problem").required(),
    ClientProblem: Joi.string()
      .label("Client Description of Problem")
      .required(),
    CaregiverProblem: Joi.string()
      .label("Caregiver Description of Problem")
      .required(),
    ClientStrengths: Joi.string()
      .label("Client Description of Strengths")
      .required(),
    CaregiverStrengths: Joi.string()
      .label("Caregiver Description of Strengths")
      .required(),
    ClientAbilities: Joi.string()
      .label("Client abilities, skills, and interests")
      .required(),
    PrimaryHouseholdType: Joi.string()
      .label("Primary Household Type")
      .required(),
    PrimaryHouseholdDetails: Joi.string()
      .label("Primary Household Details")
      .required(),
    PrimaryHouseholdDisciplinePracticesNA: Joi.boolean(),
    PrimaryHouseholdCaregiverCooperation: Joi.string()
      .label("Cooperation")
      .when("PrimaryHouseholdDisciplinePracticesNA", {
        is: false,
        then: Joi.required(),
      }),
    PrimaryHouseholdSupervisionDifficulties: Joi.string()
      .label("Supervision difficulties")
      .when("PrimaryHouseholdDisciplinePracticesNA", {
        is: false,
        then: Joi.required(),
      }),
    PrimaryHouseholdDisciplinePracticesDetails: Joi.string()
      .label("Discipline practices details")
      .when("PrimaryHouseholdDisciplinePracticesNA", {
        is: false,
        then: Joi.required(),
      }),
    SecondaryHousehold: Joi.string()
      .label("Is there a secondary household?")
      .required(),
    SecondaryHouseholdType: Joi.string()
      .label("Secondary Household Type")
      .when("SecondaryHousehold", { is: "Yes", then: Joi.required() }),
    SecondaryHouseholdDetails: Joi.string()
      .label("Secondary Household Details")
      .when("SecondaryHousehold", { is: "Yes", then: Joi.required() }),
    SecondaryHouseholdDisciplinePracticesNA: Joi.boolean(),
    SecondaryHouseholdCaregiverCooperation: Joi.string().allow(""),
    SecondaryHouseholdSupervisionDifficulties: Joi.string().allow(""),
    SecondaryHouseholdDisciplinePracticesDetails: Joi.string().allow(""),
    AnySupportivePeople: Joi.string()
      .label("Are there any supportive people")
      .required(),
    SupportivePeopleDetails: Joi.string()
      .label("Supportive people details")
      .when("AnySupportivePeople", { is: "Yes", then: Joi.required() }),
    FamilyHistoryUnknown: Joi.boolean(),
    FamilyHistoryDetails: Joi.string()
      .label("Family History")
      .when("FamilyHistoryUnknown", { is: false, then: Joi.required() }),
    RemovedFromBioHome: Joi.string()
      .label("Has youth been removed from biological home")
      .required(),
    RemovedFromBioHomeFeelings: Joi.string()
      .label("Youth's feelings on being removed")
      .when("RemovedFromBioHome", { is: "Yes", then: Joi.required() }),
    CulturalGroup: Joi.string().label("Identified cultural group").required(),
    Traditions: Joi.string()
      .label("Special cultural traditions/celebrations/rituals")
      .required(),
    TraditionsComments: Joi.string()
      .label(
        "Comments regarding special cultural traditions/celebrations/rituals"
      )
      .when("Traditions", { is: "Yes", then: Joi.required() }),
    LanguagesSpoken: Joi.string().label("Languages spoken").required(),
    FamilyValues: Joi.string().label("Family values").required(),
    NegativeCulturalExperience: Joi.string()
      .label("Negative experiences due to customs/ethnicity/race/SES")
      .required(),
    NegativeCulturalExperienceComments: Joi.string()
      .label("Negative experience comments")
      .when("NegativeCulturalExperience", { is: "Yes", then: Joi.required() }),
    InFosterCare: Joi.string().label("Youth in foster care?").required(),
    PlacesLived: Joi.string()
      .label("Places lived")
      .when("InFosterCare", { is: "Yes", then: Joi.required() }),
    CulturalDifferences: Joi.string()
      .label("Cultural differences")
      .when("InFosterCare", { is: "Yes", then: Joi.required() }),
    CulturalDifferencesComments: Joi.string()
      .label("Cultural differences comments")
      .when("CulturalDifferences", { is: "Yes", then: Joi.required() }),
    Religious: Joi.string()
      .label("Religious or spiritual belief system")
      .required(),
    ReligiousComments: Joi.string()
      .label("Religious or spiritual belief system comments")
      .when("Religious", { is: "Yes", then: Joi.required() }),
    PHNoProblems: Joi.boolean(),
    PHPrenatalCare: Joi.string()
      .label("Prenatal Care")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHPrenatalCareComments: Joi.string()
      .label("Prenatal Care comments")
      .when("PHPrenatalCare", { is: "No", then: Joi.required() }),
    PHExposure: Joi.string()
      .label("Exposure to alcohol, tobacco, and other drugs")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHExposureComments: Joi.string()
      .label(
        "Comments related to mother's exposure to alcohol, tobacco, and other drugs"
      )
      .when("PHExposure", { is: "Yes", then: Joi.required() }),
    PHTrauma: Joi.string()
      .label("History of significant trauma during pregnancy")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHTraumaComments: Joi.string()
      .label("History of significant trauma during pregnancy comments")
      .when("PHTrauma", { is: "Yes", then: Joi.required() }),
    PHComplications: Joi.string()
      .label("Birth complications")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHComplicationsComments: Joi.string()
      .label("Birth complications comments")
      .when("PHComplications", { is: "Yes", then: Joi.required() }),
    PHConcerns: Joi.string()
      .label("Medical concerns")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHConcernsComments: Joi.string()
      .label("Medical concerns comments")
      .when("PHConcerns", { is: "Yes", then: Joi.required() }),
    DevelopmentalDelays: Joi.string().label("Developmental delays").required(),
    DevelopmentalDelaysDetails: Joi.string()
      .label("Developmental Delays details")
      .when("DevelopmentalDelays", { is: "Yes", then: Joi.required() }),
    SpecializedServices: Joi.string().label("Specialized Services").required(),
    SpecializedServicesDetails: Joi.string()
      .label("Specialized Services details")
      .when("SpecializedServices", { is: "Yes", then: Joi.required() }),
    EducationStatus: Joi.string().label("Education status").required(),
    SchoolName: Joi.string().label("School Name").when("EducationStatus", {
      is: "Currently Enrolled in School/Client is School Aged",
      then: Joi.required(),
    }),
    CurrentGrade: Joi.string().label("Current Grade").when("EducationStatus", {
      is: "Currently Enrolled in School/Client is School Aged",
      then: Joi.required(),
    }),
    RegularClassroom: Joi.string()
      .label("Regular Classroom")
      .when("EducationStatus", {
        is: "Currently Enrolled in School/Client is School Aged",
        then: Joi.required(),
      }),
    Active504Plan: Joi.string()
      .label("Active 504 Plan")
      .when("EducationStatus", {
        is: "Currently Enrolled in School/Client is School Aged",
        then: Joi.required(),
      }),
    ActiveIEP: Joi.string().label("Active IEP").when("EducationStatus", {
      is: "Currently Enrolled in School/Client is School Aged",
      then: Joi.required(),
    }),
    DisciplineConcerns: Joi.string()
      .label("Discipline Concerns")
      .when("EducationStatus", {
        is: "Currently Enrolled in School/Client is School Aged",
        then: Joi.required(),
      }),
    DisciplineConcernsDetails: Joi.string()
      .label("Discipline concerns details")
      .when("DisciplineConcerns", { is: "Yes", then: Joi.required() }),
    Awards: Joi.string().label("Awards").when("EducationStatus", {
      is: "Currently Enrolled in School/Client is School Aged",
      then: Joi.required(),
    }),
    AwardsDetails: Joi.string()
      .label("Awards details")
      .when("Awards", { is: "Yes", then: Joi.required() }),
    SchoolAttitude: Joi.string()
      .label("Attitude toward school")
      .when("EducationStatus", {
        is: "Currently Enrolled in School/Client is School Aged",
        then: Joi.required(),
      }),
    CurrentlyEmployed: Joi.string().label("Currently employed").required(),
    ADLNA: Joi.boolean(),
    MoneyManagement: Joi.string()
      .label("Money management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    FoodManagement: Joi.string()
      .label("Food management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Hygiene: Joi.string()
      .label("Personal appearance and hygiene")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Health: Joi.string()
      .label("Health awareness/Personal Health")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Housekeeping: Joi.string()
      .label("Housekeeping")
      .when("ADLNA", { is: false, then: Joi.required() }),
    ResourceKnowledge: Joi.string()
      .label("Knowledge of community resources")
      .when("ADLNA", { is: false, then: Joi.required() }),
    TimeManagement: Joi.string()
      .label("Time Management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Interaction: Joi.string()
      .label("Interactions with Others")
      .when("ADLNA", { is: false, then: Joi.required() }),
    SkillsComments: Joi.string()
      .label("Skill comments")
      .when("ADLNA", { is: false, then: Joi.required() }),
    RelationshipsNA: Joi.boolean(),
    CoopSkills: Joi.string()
      .label("Cooperative play skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    CommunicationSkills: Joi.string()
      .label("Communication and interaction skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    EmotionalUnderstanding: Joi.string()
      .label("Emotional understanding and self-regulation skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    ProblemSolving: Joi.string()
      .label("Social problem-solving skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    ConflictResolution: Joi.string()
      .label("Conflict resolution skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    DecisionMakingSkills: Joi.string()
      .label("Decision making skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    RelationshipSkillsComments: Joi.string()
      .label("Relationship skills comments")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    Bullied: Joi.string()
      .label("History of being bullied")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    BulliedDetails: Joi.string()
      .label("Bullied comments")
      .when("Bullied", { is: "Yes", then: Joi.required() }),
    AcceptedByPeers: Joi.string()
      .label("Accepted by peer group")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    AcceptedByPeersDetails: Joi.string()
      .label("Peer group comments")
      .when("AcceptedByPeers", { is: "No", then: Joi.required() }),
    NegativeAssociations: Joi.string()
      .label("Negative peer group associations")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    NegativeAssociationsDetails: Joi.string()
      .label("Negative associations comments")
      .when("NegativeAssociations", { is: "Yes", then: Joi.required() }),
    LegalNA: Joi.boolean(),
    LegalInvolvement: Joi.string()
      .label("Legal involvement")
      .when("LegalNA", { is: false, then: Joi.required() }),
    OnProbation: Joi.string()
      .label("On probation or parole")
      .when("LegalInvolvement", { is: "Yes", then: Joi.required() }),
    CPSInvolvement: Joi.string()
      .label("CPS Involvement")
      .when("LegalNA", { is: false, then: Joi.required() }),
    CPSInvolvementDetails: Joi.string()
      .label("CPS Involvmenet details")
      .when("CPSInvolvement", { is: "Current", then: Joi.required() })
      .when("CPSInvolvement", { is: "Historical", then: Joi.required() }),
    PCP: Joi.string().label("Primary Care Physician").required(),
    PCPPhone: Joi.string().label("Primary Care Physician Phone").required(),
    LastMedicalExamDate: Joi.string()
      .label("Date of last medical exam")
      .required(),
    LastDentalExamDate: Joi.string()
      .label("Date of last dental exam")
      .required(),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.string()
      .label("Allergies")
      .when("Allergies", { is: true, then: Joi.required() }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.string()
      .label("Medical Conditions/Concerns")
      .when("MedicalConditions", { is: true, then: Joi.required() }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.string()
      .label("Nutritional Concerns")
      .when("NutritionalConcerns", { is: true, then: Joi.required() }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.string()
      .label("Dental Concerns")
      .when("DentalConcerns", { is: true, then: Joi.required() }),
    Concussions: Joi.boolean(),
    ConcussionsDetails: Joi.string()
      .label("Concussions or Head Injuries")
      .when("Concussions", { is: true, then: Joi.required() }),
    Undiagnosed: Joi.string().label("Undiagnosed medical illness").required(),
    UndiagnosedComments: Joi.string()
      .label("Undiagnosed medical illness comments")
      .when("Undiagnosed", { is: "Yes", then: Joi.required() }),
    MedicalComments: Joi.string().label("Medical comments").allow(null, ""),
    AdvanceDirectives: Joi.string().label("Advance directives").required(),
    NoMedications: Joi.boolean(),
    CurrentMedicationDetails: Joi.string()
      .label("Current Medications")
      .when("NoMedications", { is: false, then: Joi.required() }),
    MedicationCompliance: Joi.string()
      .label("Compliance with medication")
      .when("NoMedications", { is: false, then: Joi.required() }),
    SideEffects: Joi.string()
      .label("Side effects")
      .when("NoMedications", { is: false, then: Joi.required() }),
    SideEffectsDetails: Joi.string()
      .label("Side effects details")
      .when("SideEffects", { is: "Yes", then: Joi.required() }),
    PsychotropicMeds: Joi.string()
      .label("Past Psychotropic Medications")
      .when("NoMedications", { is: false, then: Joi.required() }),
    PsychotropicMedsDetails: Joi.string()
      .label("Past Psychotropic Medications list")
      .when("PsychotropicMeds", { is: "Yes", then: Joi.required() }),
    SexualHistoryNA: Joi.boolean(),
    SexualOrientation: Joi.string()
      .label("Sexual orientation")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualOrientationDetails: Joi.string()
      .label("Sexual Orientation specifics")
      .when("SexualOrientation", {
        is: "Orientation not listed",
        then: Joi.required(),
      }),
    SexuallyActive: Joi.string()
      .label("Sexually active")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    CaregiverAware: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.string()
          .required()
          .label("Caregiver aware of sexual history"),
      }),
    }),
    CaregiverAwareComments: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.when("CaregiverAware", {
          is: "Yes",
          then: Joi.string().required().label("Caregiver comments"),
        }),
      }),
    }),
    UseProtection: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.string().required().label("Use of protection"),
      }),
    }),
    UseProtectionComments: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.when("UseProtection", {
          is: "Yes",
          then: Joi.string().label("Protection comments"),
        }),
      }),
    }),
    AwareOfRisks: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.string().required().label("Awareness of sexual risks"),
      }),
    }),
    AwareOfRisksComments: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.when("AwareOfRisks", {
          is: "Yes",
          then: Joi.string().required().label("Sexual risks comments"),
        }),
      }),
    }),
    Pregnancy: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.string().required().label("Pregnancy"),
      }),
    }),
    PregnancyComments: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.when("Pregnancy", {
          is: "Current",
          then: Joi.string().required().label("Pregnancy comments"),
        }),
      }),
    }),
    Children: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.string().required().label("Children"),
      }),
    }),
    ChildrenComments: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.when("Children", {
          is: "Yes",
          then: Joi.string().required().label("Children comments"),
        }),
      }),
    }),
    SexualAbuseVictim: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.string().required().label("Victim of sexual abuse"),
    }),
    SexualAbuseVictimComments: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexualAbuseVictim", {
        is: "Yes",
        then: Joi.string().required().label("Sexual abuse comments"),
      }),
    }),
    SexuallyActingOut: Joi.string()
      .label("Sexually acting out/reactive behavior")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexuallyAbusive: Joi.string()
      .label("Sexually abusive")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexuallyAbusiveComments: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActingOut", {
        is: "Yes",
        then: Joi.string().required(),
      })
        .when("SexuallyAbusive", { is: "Yes", then: Joi.string().required() })
        .label("Sexually abusive comments"),
    }),
    MentalHealthNA: Joi.boolean(),
    PastMentalHealthTreatment: Joi.string()
      .label("Past mental health counseling/treatment")
      .allow(""),
    PastMentalHealthTreatmentComments: Joi.string()
      .label("Past mental health counseling/treatment comments")
      .when("PastMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    PastResidentialFacilityPlacement: Joi.string()
      .label("Past placement in a group home/residential treatment facility")
      .allow(""),
    PastResidentialFacilityPlacementComments: Joi.string()
      .label("Past placement comments")
      .when("PastResidentialFacilityPlacement", {
        is: "Yes",
        then: Joi.required(),
      }),
    PastPsychiatricHospitalPlacement: Joi.string()
      .label("Past placement in a psychiatric hospital/unit")
      .allow(""),
    PastPsychiatricHospitalPlacementComments: Joi.string()
      .label("Past placement comments")
      .when("PastPsychiatricHospitalPlacement", {
        is: "Yes",
        then: Joi.required(),
      }),
    InvoluntaryTreatment: Joi.string()
      .label("History of involuntary/court-ordered treatment")
      .allow(""),
    InvoluntaryTreatmentComments: Joi.string()
      .label("Involuntary treatment comments")
      .when("InvoluntaryTreatment", { is: "Yes", then: Joi.required() }),
    MentalHealthDiagnosis: Joi.string().allow(""),
    SubstanceUseNA: Joi.boolean(),
    SubstanceUse: Joi.string()
      .label("Current or past use of Alcohol/Drugs")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    TobaccoUse: Joi.label("Tobacco related products").when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    AlcoholUse: Joi.label("Alcohol").when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    IllegalDrugUse: Joi.label("Illegal drugs").when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    PrescriptionDrugUse: Joi.label("Prescription drugs").when(
      "SubstanceUseNA",
      {
        is: false,
        then: Joi.string().when("SubstanceUse", {
          is: "Yes",
          then: Joi.required(),
        }),
      }
    ),
    SyntheticDrugUse: Joi.label("Synthetic drugs/substances").when(
      "SubstanceUseNA",
      {
        is: false,
        then: Joi.string().when("SubstanceUse", {
          is: "Yes",
          then: Joi.required(),
        }),
      }
    ),
    SubstanceUseTreatmentHistory: Joi.label(
      "Medical treatment/hospitalization due to use"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    SubstanceUseWithdrawal: Joi.label("Withdrawal").when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    DetoxSymptoms: Joi.label("Presenting detox issues").when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    OverdoseHistory: Joi.label("Overdose history").when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    SubstanceUseLegalInvolvement: Joi.label(
      "Legal charges/involvement due to use"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    SubstanceUseProblems: Joi.label(
      "Use has caused problems in different areas of your life"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    SubstanceUseHistoryComments: Joi.label(
      "Substance use history comments"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    SubstanceUseTreatment: Joi.label("Alcohol/drug related treatment").when(
      "SubstanceUseNA",
      {
        is: false,
        then: Joi.string().when("SubstanceUse", {
          is: "Yes",
          then: Joi.required(),
        }),
      }
    ),
    SubstanceUseTreatmentComments: Joi.string()
      .label("Alcohol/drug related treatment comments")
      .when("SubstanceUseTreatment", { is: "Yes", then: Joi.required() }),
    AppropriateAppearance: Joi.boolean(),
    Neat: Joi.boolean(),
    Disheveled: Joi.boolean(),
    BizarreAppearance: Joi.boolean(),
    OtherAppearance: Joi.boolean(),
    OtherAppearanceDetails: Joi.string()
      .label("Other Appearance details")
      .when("OtherAppearance", { is: true, then: Joi.required() }),
    Cooperative: Joi.boolean(),
    Guarded: Joi.boolean(),
    Hyperactive: Joi.boolean(),
    Agitated: Joi.boolean(),
    Paranoid: Joi.boolean(),
    Tics: Joi.boolean(),
    Impulsive: Joi.boolean(),
    Aggressive: Joi.boolean(),
    Withdrawn: Joi.boolean(),
    BizarreBehavior: Joi.boolean(),
    Rigidity: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.string()
      .label("Other Behavior details")
      .when("OtherBehavior", { is: true, then: Joi.required() }),
    Normal: Joi.boolean(),
    Slurred: Joi.boolean(),
    Pressured: Joi.boolean(),
    Tangential: Joi.boolean(),
    Incoherent: Joi.boolean(),
    Stutters: Joi.boolean(),
    OtherSpeech: Joi.boolean(),
    OtherSpeechDetails: Joi.string()
      .label("Other Speech details")
      .when("OtherSpeech", { is: true, then: Joi.required() }),
    Euthymic: Joi.boolean(),
    Anxious: Joi.boolean(),
    Angry: Joi.boolean(),
    Depressed: Joi.boolean(),
    Euphoric: Joi.boolean(),
    Irritable: Joi.boolean(),
    Fearful: Joi.boolean(),
    OtherMood: Joi.boolean(),
    OtherMoodDetails: Joi.string()
      .label("Other Mood details")
      .when("OtherMood", { is: true, then: Joi.required() }),
    FullRange: Joi.boolean(),
    Restricted: Joi.boolean(),
    Blunted: Joi.boolean(),
    Flat: Joi.boolean(),
    Inappropriate: Joi.boolean(),
    OtherAffect: Joi.boolean(),
    OtherAffectDetails: Joi.string()
      .label("Other Affect details")
      .when("OtherAffect", { is: true, then: Joi.required() }),
    Logical: Joi.boolean(),
    Preoccupations: Joi.boolean(),
    Delusions: Joi.boolean(),
    Hallucinations: Joi.boolean(),
    Racing: Joi.boolean(),
    Disorganized: Joi.boolean(),
    Concrete: Joi.boolean(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    OtherPerception: Joi.boolean(),
    OtherPerceptionDetails: Joi.string()
      .label("Other Thought Process/Perception details")
      .when("OtherPerception", { is: true, then: Joi.required() }),
    NoImpairment: Joi.boolean(),
    ShortAttentionSpan: Joi.boolean(),
    DifficultyConcentrating: Joi.boolean(),
    Distractibility: Joi.boolean(),
    MemoryImpairment: Joi.boolean(),
    LowIntelligence: Joi.boolean(),
    OtherCognition: Joi.boolean(),
    OtherCognitionDetails: Joi.string()
      .label("Other Cognition/Intellectual Functioning details")
      .when("OtherCognition", { is: true, then: Joi.required() }),
    AppropriateInsight: Joi.boolean(),
    Fair: Joi.boolean(),
    Impaired: Joi.boolean(),
    OtherInsight: Joi.boolean(),
    OtherInsightDetails: Joi.string()
      .label("Other Insight/Judgment details")
      .when("OtherInsight", { is: true, then: Joi.required() }),
    MentalStatusComments: Joi.string()
      .label("Mental Status comments")
      .required(),
    LethalityNA: Joi.boolean(),
    SelfAbusiveBehavior: Joi.string()
      .label("Self-abusive behavior")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicidalThreats: Joi.string()
      .label("Suicidal threats")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicideAttempt: Joi.string()
      .label("Suicide attempt")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CaregiverConcernsOfSelfHarm: Joi.string()
      .label("Caregiver concerns of self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherConcernsOfSelfHarm: Joi.string()
      .label("Other concerns of self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentSelfHarmRisk: Joi.string()
      .label("Current Risk of Harm to Self")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SelfHarmComments: Joi.string()
      .label("Self-harm comments")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThreatsToHarmOthers: Joi.string()
      .label("Threats to harm others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThoughtsOfHarm: Joi.string()
      .label("Thoughts of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarm: Joi.string()
      .label("Acts of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarmAnimals: Joi.string()
      .label("Acts of harming animals")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsInvolvingWeapons: Joi.string()
      .label("Acts involving weapons")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CaregiverConcernOfOtherHarm: Joi.string()
      .label("Caregiver concerns of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherConcernsOfOtherHarm: Joi.string()
      .label("Other concerns of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentOtherHarmRisk: Joi.string()
      .label("Current Risk of Harm to Others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherHarmComments: Joi.string()
      .label("Threat to others comments")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    TraumaNA: Joi.boolean(),
    TraumaHistory: Joi.string()
      .label("Trauma History")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    SocialSupports: Joi.boolean(),
    SenseOfMastery: Joi.boolean(),
    CaregiverStability: Joi.boolean(),
    StrongSpiritualBeliefs: Joi.boolean(),
    InterpersonalSkills: Joi.boolean(),
    PositiveOutlook: Joi.boolean(),
    PlacementStability: Joi.boolean(),
    Pets: Joi.boolean(),
    ValidatingExperiences: Joi.boolean(),
    Resources: Joi.boolean(),
    TiesToExtendedFamily: Joi.boolean(),
    Adaptability: Joi.boolean(),
    SecureAttachments: Joi.boolean(),
    StrongCulturalIdentity: Joi.boolean(),
    NoTraumaProtectiveFactors: Joi.boolean(),
    CopingStrategies: Joi.string()
      .label("Coping strategies")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    TraumaSymptoms: Joi.boolean(),
    TraumaticExposure: Joi.boolean(),
    AvoidantTrauma: Joi.boolean(),
    HypervigilanceTrauma: Joi.boolean(),
    IntrusiveDreams: Joi.boolean(),
    NegativeThoughts: Joi.boolean(),
    CocentrationProblems: Joi.boolean(),
    RecklessBehaviorTrauma: Joi.boolean(),
    SleepDisturbancesTrauma: Joi.boolean(),
    OtherTrauma: Joi.boolean(),
    OtherTraumaDetails: Joi.string()
      .label("Other Trauma Details")
      .when("OtherTrauma", { is: true, then: Joi.required() }),
    TraumaSymptomsFrequency: Joi.string()
      .label("Trauma Symptoms Frequency")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsIntensity: Joi.string()
      .label("Trauma Symptoms Intensity")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsDuration: Joi.string()
      .label("Trauma Symptoms Duration")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsOnset: Joi.string()
      .label("Trauma Symptoms Onset")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    AnxietyDisorder: Joi.boolean(),
    AnxietyDisorderExcessWorry: Joi.boolean(),
    AnxietyDisorderEasilyFatigued: Joi.boolean(),
    MuscleTension: Joi.boolean(),
    Overworried: Joi.boolean(),
    AnxietyDisorderDifficultyConcentrating: Joi.boolean(),
    SleepDisturbancesAnxiety: Joi.boolean(),
    RestlessAnxiety: Joi.boolean(),
    Irritability: Joi.boolean(),
    OtherAnxiety: Joi.boolean(),
    OtherAnxietyDetails: Joi.string()
      .label("Other Anxiety Details")
      .when("OtherAnxiety", { is: true, then: Joi.required() }),
    AnxietyDisorderFrequency: Joi.string()
      .label("Anxiety Frequency")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    AnxietyDisorderIntensity: Joi.string()
      .label("Anxiety Intensity")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    AnxietyDisorderDuration: Joi.string()
      .label("Anxiety Duration")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    DepressionSymptoms: Joi.boolean(),
    DepressedMood: Joi.boolean(),
    SleepChanges: Joi.boolean(),
    Guilt: Joi.boolean(),
    DiminishedInterest: Joi.boolean(),
    PurposelessMovement: Joi.boolean(),
    DifficultyConcentratingDepression: Joi.boolean(),
    WeightChanges: Joi.boolean(),
    FatigueDepression: Joi.boolean(),
    ThoughtsOfDeath: Joi.boolean(),
    OtherDepression: Joi.boolean(),
    OtherDepressionDetails: Joi.string()
      .label("Other Depression Details")
      .when("OtherDepression", { is: true, then: Joi.required() }),
    DepressionFrequency: Joi.string()
      .label("Depression Frequency")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    DepressionIntensity: Joi.string()
      .label("Depression Intensity")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    DepressionDuration: Joi.string()
      .label("Depression Duration")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    AttentionHyperactivity: Joi.boolean(),
    AttentionHyperactivityEasilyDistracted: Joi.boolean(),
    DifficultyFollowThrough: Joi.boolean(),
    Forgetful: Joi.boolean(),
    DifficultyListening: Joi.boolean(),
    DisorganizedAttention: Joi.boolean(),
    Fidgety: Joi.boolean(),
    LackOfDetails: Joi.boolean(),
    LosesThings: Joi.boolean(),
    InterruptsOthers: Joi.boolean(),
    UnableToSitStill: Joi.boolean(),
    ExcessiveTalking: Joi.boolean(),
    DifficultyWaiting: Joi.boolean(),
    OtherAttention: Joi.boolean(),
    OtherAttentionDetails: Joi.string()
      .label("Other Attention Details")
      .when("OtherAttention", { is: true, then: Joi.required() }),
    AttentionHyperactivityFrequency: Joi.string()
      .label("Attention Frequency")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    AttentionHyperactivityIntensity: Joi.string()
      .label("Attention Intensity")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    AttentionHyperactivityDuration: Joi.string()
      .label("Attention Duration")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    SU: Joi.boolean(),
    PatternOfSubstanceUse: Joi.boolean(),
    DesiresCutDownUse: Joi.boolean(),
    TimeSpentObtaining: Joi.boolean(),
    Cravings: Joi.boolean(),
    FailureOfResponsibilities: Joi.boolean(),
    NegativeImpact: Joi.boolean(),
    AbandonsActivities: Joi.boolean(),
    Tolerance: Joi.boolean(),
    SUWithdrawal: Joi.boolean(),
    SUOther: Joi.boolean(),
    SUOtherDetails: Joi.string()
      .label("Other Substance Use Details")
      .when("SUOther", { is: true, then: Joi.required() }),
    SubstanceUseFrequency: Joi.string()
      .label("Substance Use Frequency")
      .when("SU", { is: true, then: Joi.required() }),
    SubstanceUseIntensity: Joi.string()
      .label("Substance Use Intensity")
      .when("SU", { is: true, then: Joi.required() }),
    SubstanceUseDuration: Joi.string()
      .label("Substance Use Duration")
      .when("SU", { is: true, then: Joi.required() }),
    DMDD: Joi.boolean(),
    Temper: Joi.boolean(),
    OutsideOutbursts: Joi.boolean(),
    FrequentOutbursts: Joi.boolean(),
    DMDDIrritable: Joi.boolean(),
    OutburstsAroundOthers: Joi.boolean(),
    DMDDOther: Joi.boolean(),
    DMDDOtherDetails: Joi.string()
      .label("Other Disruptive Mood Dysregulation Disorder Details")
      .when("DMDDOther", { is: true, then: Joi.required() }),
    DMDDFrequency: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Frequency")
      .when("DMDD", { is: true, then: Joi.required() }),
    DMDDIntensity: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Intensity")
      .when("DMDD", { is: true, then: Joi.required() }),
    DMDDDuration: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Duration")
      .when("DMDD", { is: true, then: Joi.required() }),
    ConductDisorder: Joi.boolean(),
    Aggression: Joi.boolean(),
    DestructionOfProperty: Joi.boolean(),
    Theft: Joi.boolean(),
    SeriousViolations: Joi.boolean(),
    OtherConductDisorder: Joi.boolean(),
    OtherConductDisorderDetails: Joi.string()
      .label("Other Conduct Disorder Details")
      .when("OtherConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderFrequency: Joi.string()
      .label("Conduct Disorder Frequency")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderIntensity: Joi.string()
      .label("Conduct Disorder Intensity")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderDuration: Joi.string()
      .label("Conduct Disorder Duration")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ODD: Joi.boolean(),
    IrritableODD: Joi.boolean(),
    Argumentative: Joi.boolean(),
    Vindictive: Joi.boolean(),
    OtherODD: Joi.boolean(),
    OtherODDDetails: Joi.string()
      .label("Other Oppositional Defiance Disorder Details")
      .when("OtherODD", { is: true, then: Joi.required() }),
    ODDFrequency: Joi.string()
      .label("Oppositional Defiance Disorder Frequency")
      .when("ODD", { is: true, then: Joi.required() }),
    ODDIntensity: Joi.string()
      .label("Oppositional Defiance Disorder Intensity")
      .when("ODD", { is: true, then: Joi.required() }),
    ODDDuration: Joi.string()
      .label("Oppositional Defiance Disorder Duration")
      .when("ODD", { is: true, then: Joi.required() }),
    OCD: Joi.boolean(),
    OCDPresence: Joi.boolean(),
    Obsessions: Joi.boolean(),
    TimeConsuming: Joi.boolean(),
    Compulsions: Joi.boolean(),
    ReduceAnxiety: Joi.boolean(),
    SuppressUrges: Joi.boolean(),
    OCDOther: Joi.boolean(),
    OCDOtherDetails: Joi.string()
      .label("Other Obsessive-Compulsive Disorder Details")
      .when("OCDOther", { is: true, then: Joi.required() }),
    OCDFrequency: Joi.string()
      .label("Obsessive-Compulsive Disorder Frequency")
      .when("OCD", { is: true, then: Joi.required() }),
    OCDIntensity: Joi.string()
      .label("Obsessive-Compulsive Disorder Intensity")
      .when("OCD", { is: true, then: Joi.required() }),
    OCDDuration: Joi.string()
      .label("Obsessive-Compulsive Disorder Duration")
      .when("OCD", { is: true, then: Joi.required() }),
    PanicDisorder: Joi.boolean(),
    PoundingHeart: Joi.boolean(),
    PanicDisorderSweating: Joi.boolean(),
    Trembling: Joi.boolean(),
    ShortnessOfBreath: Joi.boolean(),
    Choking: Joi.boolean(),
    ChestPain: Joi.boolean(),
    PanicDisorderNausea: Joi.boolean(),
    Dizzy: Joi.boolean(),
    Chills: Joi.boolean(),
    Derealization: Joi.boolean(),
    FearOfCrazy: Joi.boolean(),
    FearOfDying: Joi.boolean(),
    PanicDisorderOther: Joi.boolean(),
    PanicDisorderOtherDetails: Joi.string()
      .label("Other Panic Disorder Details")
      .when("PanicDisorderOther", { is: true, then: Joi.required() }),
    PanicDisorderFrequency: Joi.string()
      .label("Panic Disorder Frequency")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    PanicDisorderIntensity: Joi.string()
      .label("Panic Disorder Intensity")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    PanicDisorderDuration: Joi.string()
      .label("Panic Disorder Duration")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    Phobias: Joi.boolean(),
    PhobiasSpecificFear: Joi.boolean(),
    ImmediateFear: Joi.boolean(),
    PhobiasAvoidance: Joi.boolean(),
    FearExaggerated: Joi.boolean(),
    PhobiasOther: Joi.boolean(),
    PhobiasOtherDetails: Joi.string()
      .label("Other Phobia Details")
      .when("PhobiasOther", { is: true, then: Joi.required() }),
    PhobiasFrequency: Joi.string()
      .label("Phobia Frequency")
      .when("Phobias", { is: true, then: Joi.required() }),
    PhobiasIntensity: Joi.string()
      .label("Phobia Intensity")
      .when("Phobias", { is: true, then: Joi.required() }),
    PhobiasDuration: Joi.string()
      .label("Phobia Duration")
      .when("Phobias", { is: true, then: Joi.required() }),
    DI: Joi.boolean(),
    DILowIQ: Joi.boolean(),
    DISensoryImpairments: Joi.boolean(),
    DISpeechDelays: Joi.boolean(),
    DIMotorCoordinationDelays: Joi.boolean(),
    DILearningDisorder: Joi.boolean(),
    DISpatialDelays: Joi.boolean(),
    DevelopmentalImpairmentsOther: Joi.boolean(),
    DevelopmentalImpairmentsOtherDetails: Joi.string()
      .label("Other Developmental Impairments Details")
      .when("DevelopmentalImpairmentsOther", {
        is: true,
        then: Joi.required(),
      }),
    DevelopmentalImpairmentsDetails: Joi.string()
      .label("Developmental Impairments Description")
      .when("DILowIQ", { is: true, then: Joi.required() })
      .when("DISensoryImpairments", { is: true, then: Joi.required() })
      .when("DISpeechDelays", { is: true, then: Joi.required() })
      .when("DIMotorCoordinationDelays", { is: true, then: Joi.required() })
      .when("DILearningDisorder", { is: true, then: Joi.required() })
      .when("DISpatialDelays", { is: true, then: Joi.required() }),
    OtherSymptoms: Joi.boolean(),
    OtherSymptomsDetails: Joi.string()
      .label("Other Symptom Details")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsFrequency: Joi.string()
      .label("Other Symptoms Frequency")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsIntensity: Joi.string()
      .label("Other Symptoms Intensity")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsDuration: Joi.string()
      .label("Other Symptoms Duration")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    ClinicalNarrativeSummary: Joi.string()
      .label("Clinical Narrative Summary")
      .required(),
    ClinicalNarrativeSummaryComments: Joi.string()
      .label("Clinical Narrative Summary")
      .allow(""),
    TraditionalFosterCare: Joi.string()
      .label("Traditional Foster Care")
      .required(),
    DiagnosisDetails: Joi.string()
      .label("Diagnosis details")
      .when("TraditionalFosterCare", { is: "No", then: Joi.required() }),
    TreatmentRecommendations: Joi.string()
      .label("Treatment Recommendations")
      .required(),
    DiagnosisEducation: Joi.string().label("Diagnosis education").required(),
    RecommendationEducation: Joi.string()
      .label("Recommendation education")
      .required(),
    ClientAgrees: Joi.string().label("Client in agreement").required(),
    FamilyAgress: Joi.string().label("Family in agreement").required(),
    Partnership: Joi.string()
      .label("Partnership with other systems")
      .required(),
    NoPartnershipReason: Joi.string()
      .label("Reason for no partnership")
      .when("Partnership", { is: "No", then: Joi.required() }),
  },
  "F25599E8-9699-EC11-A507-0050F21C6F69": {
    SelectedProgram: Joi.string().label("Selected Program").required(),
    PreferredName: Joi.string().label("Preferred Name").required(),
    DateCompleted: Joi.string().label("Date Completed").required(),
    Division: Joi.string().label("Division").required(),
    PSDType: Joi.string().label("Type of PSD").required(),
    ReviewReason: Joi.string()
      .label("Review Reason")
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ISRecipient: Joi.boolean(),
    ISParent: Joi.boolean(),
    ISFamily: Joi.boolean(),
    ISGuardian: Joi.boolean(),
    ISCaregiver: Joi.boolean(),
    ISPhysician: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISDHR: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISParentDetails: Joi.string()
      .label("Parent/Other Information Source")
      .when("ISParent", { is: true, then: Joi.required() }),
    ISFamilyDetails: Joi.string()
      .label("Family Information Source")
      .when("ISFamily", { is: true, then: Joi.required() }),
    ISGuardianDetails: Joi.string()
      .label("Guardian Information Source")
      .when("ISGuardian", { is: true, then: Joi.required() }),
    ISCaregiverDetails: Joi.string()
      .label("Non-parent Caregiver Information Source")
      .when("ISCaregiver", { is: true, then: Joi.required() }),
    ISPhysicianDetails: Joi.string()
      .label("Physician Information Source")
      .when("ISPhysician", { is: true, then: Joi.required() }),
    ISRecordsDetails: Joi.string()
      .label("Records Information Source")
      .when("ISRecords", { is: true, then: Joi.required() }),
    ISServiceProviderDetails: Joi.string()
      .label("Service Provider Information Source")
      .when("ISServiceProvider", { is: true, then: Joi.required() }),
    ISSchoolDetails: Joi.string()
      .label("School Information Source")
      .when("ISSchool", { is: true, then: Joi.required() }),
    ISCourtDetails: Joi.string()
      .label("Court Information Source")
      .when("ISCourt", { is: true, then: Joi.required() }),
    ISDHRDetails: Joi.string()
      .label("DHR Information Source")
      .when("ISDHR", { is: true, then: Joi.required() }),
    ISOtherDetails: Joi.string()
      .label("Other Information Source")
      .when("ISOther", { is: true, then: Joi.required() }),
    ReferralReason: Joi.string().label("Reason for Referral").required(),
    ReferralSource: Joi.string().label("Referral Source").required(),
    PresentingProblem: Joi.string().label("Presenting Problem").required(),
    RecipientProblem: Joi.string()
      .label("Recipient Description of Problem")
      .required(),
    CaregiverProblem: Joi.string()
      .label("Caregiver Description of Problem")
      .required(),
    RecipientStrengths: Joi.string()
      .label("Recipient Description of Strengths")
      .required(),
    CaregiverStrengths: Joi.string()
      .label("Caregiver Description of Strengths")
      .required(),
    RecipientAbilities: Joi.string()
      .label("Recipient abilities, skills, and interests")
      .required(),
    LivingSituation: Joi.string().label("Living Situation").required(),
    RecipientSupportsUnknown: Joi.boolean(),
    RecipientSupportsDetails: Joi.string()
      .label("Recipient Supports")
      .when("RecipientSupportsUnknown", { is: false, then: Joi.required() }),
    CaregiverCooperation: Joi.string().label("Cooperation").required(),
    CaregiverCooperationDetails: Joi.string()
      .label("Cooperation details")
      .when("CaregiverCooperation", { is: "No", then: Joi.required() }),
    SupervisionDifficulties: Joi.string()
      .label("Supervision difficulties")
      .required(),
    SupervisionDifficultiesDetails: Joi.string()
      .label("Supervision difficulties details")
      .when("SupervisionDifficulties", { is: "Yes", then: Joi.required() }),
    DisciplinePractices: Joi.string().label("Discipline practices").required(),
    DisciplinePracticesDetails: Joi.string()
      .label("Discipline practices details")
      .when("DisciplinePractices", { is: "Yes", then: Joi.required() }),
    FamilyEnvironmentComments: Joi.string()
      .label("Family Environment Comments")
      .required(),
    FamilyHistoryUnknown: Joi.boolean(),
    FamilyHistoryDetails: Joi.string()
      .label("Family History")
      .when("FamilyHistoryUnknown", { is: false, then: Joi.required() }),
    CulturalGroup: Joi.string().label("Identified cultural group").required(),
    Traditions: Joi.string()
      .label("Special cultural traditions/celebrations/rituals")
      .required(),
    TraditionsComments: Joi.string()
      .label("Cultural Tradition comments")
      .when("Traditions", { is: "Yes", then: Joi.required() }),
    LanguagesSpoken: Joi.string().label("Languages spoken").required(),
    NegativeCulturalExperience: Joi.string()
      .label("Negative experiences due to customs/ethnicity/race/SES")
      .required(),
    NegativeCulturalExperienceComments: Joi.string()
      .label("Negative experience comments")
      .when("NegativeCulturalExperience", { is: "Yes", then: Joi.required() }),
    ImportantFactors: Joi.string()
      .label("Important Cultural factors")
      .required(),
    ImportantFactorsComments: Joi.string()
      .label("Cultural factors comments")
      .when("ImportantFactors", { is: "Yes", then: Joi.required() }),
    FaithRole: Joi.string().label("Faith role").required(),
    FaithRoleComments: Joi.string()
      .label("Faith role details")
      .when("FaithRole", { is: "Yes", then: Joi.required() }),
    PHNoProblems: Joi.boolean(),
    PHPrenatalCare: Joi.string()
      .label("Prenatal Care")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHPrenatalCareComments: Joi.string()
      .label("Prenatal Care comments")
      .when("PHPrenatalCare", { is: "No", then: Joi.required() }),
    PHExposure: Joi.string()
      .label("Exposure to alcohol, tobacco, and other drugs")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHExposureComments: Joi.string()
      .label("Exposure comments")
      .when("PHExposure", { is: "Yes", then: Joi.required() }),
    PHTrauma: Joi.string()
      .label("History of significant trauma during pregnancy")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHTraumaComments: Joi.string()
      .label("Trauma comments")
      .when("PHTrauma", { is: "Yes", then: Joi.required() }),
    PHComplications: Joi.string()
      .label("Birth complications")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHComplicationsComments: Joi.string()
      .label("Birth complications comments")
      .when("PHComplications", { is: "Yes", then: Joi.required() }),
    PHConcerns: Joi.string()
      .label("Medical concerns")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHConcernsComments: Joi.string()
      .label("Medical concerns details")
      .when("PHConcerns", { is: "Yes", then: Joi.required() }),
    MilestonesMet: Joi.string().label("Milestones met").required(),
    MilestonesMetDetails: Joi.string()
      .label("Milestones not met details")
      .when("MilestonesMet", { is: "No", then: Joi.required() }),
    SpecialNeeds: Joi.string().label("Special needs").required(),
    SpecialNeedsDetails: Joi.string()
      .label("Special Needs details")
      .when("SpecialNeeds", { is: "Yes", then: Joi.required() }),
    SpecializedServices: Joi.string().label("Specialized Services").required(),
    SpecializedServicesDetails: Joi.string()
      .label("Specialized Services details")
      .when("SpecializedServices", { is: "Yes", then: Joi.required() }),
    EducationStatus: Joi.string().allow("Education status"),
    SchoolName: Joi.string().label("School Name").when("EducationStatus", {
      is: "Currently enrolled in school",
      then: Joi.required(),
    }),
    CurrentGrade: Joi.string().label("Current Grade").when("EducationStatus", {
      is: "Currently enrolled in school",
      then: Joi.required(),
    }),
    RegularClassroom: Joi.string()
      .label("Regular Classroom")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      }),
    Active504Plan: Joi.string()
      .label("Active 504 Plan")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      }),
    ActiveIEP: Joi.string().label("Active IEP").when("EducationStatus", {
      is: "Currently enrolled in school",
      then: Joi.required(),
    }),
    SchoolAttitude: Joi.string()
      .label("School attitude")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      }),
    CurrentlyEmployed: Joi.string()
      .label("Currently Employed")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      })
      .when("EducationStatus", { is: "Graduated", then: Joi.required() })
      .when("EducationStatus", { is: "GED", then: Joi.required() })
      .when("EducationStatus", {
        is: "Dropout/Did not complete",
        then: Joi.required(),
      }),
    Employer: Joi.string()
      .label("Employer")
      .when("CurrentlyEmployed", { is: "Yes", then: Joi.required() }),
    JobTitle: Joi.string()
      .label("JobTitle")
      .when("CurrentlyEmployed", { is: "Yes", then: Joi.required() }),
    EmploymentInterests: Joi.string()
      .label("Employment Interests")
      .when("CurrentlyEmployed", { is: "Yes", then: Joi.required() })
      .when("CurrentlyEmployed", { is: "No", then: Joi.required() }),
    MilitaryHistory: Joi.string()
      .label("Military History")
      .when("EducationStatus", { is: "Graduated", then: Joi.required() })
      .when("EducationStatus", { is: "GED", then: Joi.required() })
      .when("EducationStatus", {
        is: "Dropout/Did not complete",
        then: Joi.required(),
      }),
    ADLNA: Joi.boolean(),
    Hygiene: Joi.string()
      .label("Personal Hygiene achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HygieneNeeded: Joi.string()
      .label("Personal Hygiene needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Housekeeping: Joi.string()
      .label("Housekeeping achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HousekeepingNeeded: Joi.string()
      .label("Housekeeping needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MedicationManagement: Joi.string()
      .label("Medication Management achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MedicationManagementNeeded: Joi.string()
      .label("Medication Management needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Transportation: Joi.string()
      .label("Transportation achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    TransportationNeeded: Joi.string()
      .label("Transportation needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    BehaviorEducation: Joi.string()
      .label("Behavior Education achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    BehaviorEducationNeeded: Joi.string()
      .label("Behavior Education needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    StressManagement: Joi.string()
      .label("Stress Management achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    StressManagementNeeded: Joi.string()
      .label("Stress Management needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HealthyLifestyle: Joi.string()
      .label("Healthy Lifestyle achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HealthyLifestyleNeeded: Joi.string()
      .label("Healthy Lifestyle needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Laundry: Joi.string()
      .label("Laundry achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    LaundryNeeded: Joi.string()
      .label("Laundry needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MealPrep: Joi.string()
      .label("Meal Prep achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MealPrepNeeded: Joi.string()
      .label("Meal Prep needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MoneyManagement: Joi.string()
      .label("Money Management achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MoneyManagementNeeded: Joi.string()
      .label("Money Management needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Shopping: Joi.string()
      .label("Shopping achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    ShoppingNeeded: Joi.string()
      .label("Shopping needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    BasicSkillsComments: Joi.string()
      .label("Basic Living Skills comments")
      .when("ADLNA", { is: false, then: Joi.required() }),
    RelationshipsNA: Joi.boolean(),
    CoopSkills: Joi.string()
      .label("Cooperative Play Skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    CoopSkillsDetails: Joi.string()
      .label("Cooperative Play Skills details")
      .when("CoopSkills", { is: "Problematic", then: Joi.required() }),
    CommunicationSkills: Joi.string()
      .label("Communication Skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    CommunicationSkillsDetails: Joi.string()
      .label("Communication Skills details")
      .when("CommunicationSkills", { is: "Problematic", then: Joi.required() }),
    EmotionalUnderstanding: Joi.string()
      .label("Emotional Understanding")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    EmotionalUnderstandingDetails: Joi.string()
      .label("Emotional Understanding Skills details")
      .when("EmotionalUnderstanding", {
        is: "Problematic",
        then: Joi.required(),
      }),
    ProblemSolving: Joi.string()
      .label("Problem Solving")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    ProblemSolvingDetails: Joi.string()
      .label("Problem Solving Skills details")
      .when("ProblemSolving", { is: "Problematic", then: Joi.required() }),
    ConflictResolution: Joi.string()
      .label("Conflict Resolution")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    ConflictResolutionDetails: Joi.string()
      .label("Conflict Resolution Skills details")
      .when("ConflictResolution", { is: "Problematic", then: Joi.required() }),
    DecisionMakingSkills: Joi.string()
      .label("Decision Making")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    DecisionMakingSkillsDetails: Joi.string()
      .label("Decision Making Skills details")
      .when("DecisionMakingSkills", {
        is: "Problematic",
        then: Joi.required(),
      }),
    Bullied: Joi.string()
      .label("Being bullied")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    BulliedDetails: Joi.string()
      .label("Being bullied details")
      .when("Bullied", { is: "Yes", then: Joi.required() }),
    Bully: Joi.string()
      .label("Bullying others")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    BullyDetails: Joi.string()
      .label("Bullying others details.")
      .when("Bully", { is: "Yes", then: Joi.required() }),
    AcceptedByPeers: Joi.string()
      .label("Accepted by peers")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    AcceptedByPeersDetails: Joi.string()
      .label("Not accepted by peers details")
      .when("AcceptedByPeers", { is: "No", then: Joi.required() }),
    NegativeAssociations: Joi.string()
      .label("Negative Associations")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    NegativeAssociationsDetails: Joi.string()
      .label("Negative Associations details")
      .when("NegativeAssociations", { is: "Yes", then: Joi.required() }),
    LegalNA: Joi.boolean(),
    LegalInvolvement: Joi.string()
      .label("Current legal involvement")
      .when("LegalNA", { is: false, then: Joi.required() }),
    LegalInvolvementDetails: Joi.string()
      .label("Legal involvement details")
      .when("LegalInvolvement", { is: "Yes", then: Joi.required() }),
    DHRInvolvement: Joi.string()
      .label("Current DHR involvement")
      .when("LegalNA", { is: false, then: Joi.required() }),
    DHRInvolvementDetails: Joi.string()
      .label("DHR involvement details")
      .when("DHRInvolvement", { is: "Yes", then: Joi.required() }),
    DHRCaseworker: Joi.string()
      .label("Current DHR Caseworker")
      .when("LegalNA", { is: false, then: Joi.required() }),
    DHRCaseworkerName: Joi.string()
      .label("DHR Caseworker name")
      .when("DHRCaseworker", { is: "Yes", then: Joi.required() }),
    ProbationOfficer: Joi.string()
      .label("Current Probation Officer")
      .when("LegalNA", { is: false, then: Joi.required() }),
    ProbationOfficerName: Joi.string()
      .label("Probation Officer name")
      .when("ProbationOfficer", { is: "Yes", then: Joi.required() }),
    GALCASA: Joi.string()
      .label("GAL/CASA")
      .when("LegalNA", { is: false, then: Joi.required() }),
    GALCASAName: Joi.string()
      .label("GAL/CASA name")
      .when("GALCASA", { is: "Yes", then: Joi.required() }),
    OtherLegalDetails: Joi.string().allow(""),
    PCP: Joi.string().label("Primary Care Physician").required(),
    PCPPhone: Joi.string().label("PCP Phone").required(),
    LastMedicalExamDate: Joi.string()
      .required()
      .label("Date of last medical exam"),
    LastDentalExamDate: Joi.string()
      .required()
      .label("Date of last dental exam"),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.string()
      .label("Allergies list")
      .when("Allergies", { is: true, then: Joi.required() }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.string()
      .label("Medical conditions list")
      .when("MedicalConditions", { is: true, then: Joi.required() }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.string()
      .label("Nutritional concerns list")
      .when("NutritionalConcerns", { is: true, then: Joi.required() }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.string()
      .label("Dental concerns list")
      .when("DentalConcerns", { is: true, then: Joi.required() }),
    Undiagnosed: Joi.string().required().label("Potential undiagnosed illness"),
    UndiagnosedDetails: Joi.string()
      .label("Potential undiagnosed illness details")
      .when("Undiagnosed", { is: "Yes", then: Joi.required() }),
    NoMedications: Joi.boolean(),
    CurrentMedicationDetails: Joi.string()
      .label("Current Medications")
      .when("NoMedications", { is: false, then: Joi.required() }),
    PsychotropicMeds: Joi.string()
      .required()
      .label("Past psychotropic medications"),
    PsychotropicMedsDetails: Joi.string()
      .label("Past psychotropic medications list")
      .when("PsychotropicMeds", { is: "Yes", then: Joi.required() }),
    SexualHistoryNA: Joi.boolean(),
    GenderIdentityConcerns: Joi.string()
      .label("Gender identity concerns")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    GenderIdentityConcernsDetails: Joi.string()
      .label("Gender identity concerns details")
      .when("GenderIdentityConcerns", { is: "Yes", then: Joi.required() }),
    SexualEducation: Joi.string()
      .label("Sexual Education")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexuallyActive: Joi.string()
      .label("Sexually active")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    CaregiverAware: Joi.string()
      .label("Caregiver aware of sexual history")
      .when("SexuallyActive", { is: "Yes", then: Joi.required() }),
    UseProtection: Joi.string()
      .label("Use of protection")
      .when("SexuallyActive", { is: "Yes", then: Joi.required() }),
    AwareOfRisks: Joi.string()
      .label("Awareness of sexual risks")
      .when("SexuallyActive", { is: "Yes", then: Joi.required() }),
    Pregnancy: Joi.string()
      .label("Pregnancy")
      .when("SexuallyActive", { is: "Yes", then: Joi.required() }),
    Children: Joi.string()
      .label("Children")
      .when("SexuallyActive", { is: "Yes", then: Joi.required() }),
    SexuallyActiveComments: Joi.string()
      .label("Sexually active comments")
      .when("SexuallyActive", { is: "Yes", then: Joi.required() }),
    SexualAbuseVictim: Joi.string()
      .label("Victim of sexual abuse")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualBehavior: Joi.string()
      .label("Age inappropriate sexual behavior")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualBehaviorDetails: Joi.string()
      .label("Age inappropriate sexual behavior details")
      .when("SexualBehavior", { is: "Yes", then: Joi.required() }),
    SexuallyActingOut: Joi.string()
      .label("Sexually acting out/reactive behavior")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexuallyActingOutComments: Joi.string()
      .label("Sexually acting out/reactive behavior details")
      .when("SexuallyActingOut", { is: "Yes", then: Joi.required() }),
    SexuallyAbusive: Joi.string()
      .label("Sexually abusive")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexuallyAbusiveComments: Joi.string()
      .label("Sexually abusive/offending behavior details")
      .when("SexuallyAbusive", { is: "Yes", then: Joi.required() }),
    MentalHealthNA: Joi.boolean(),
    PastMentalHealthTreatment: Joi.string()
      .label("Past mental health counseling/treatment")
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    PastMentalHealthPlacement: Joi.string()
      .label(
        "Past placement in a group home/residential treatment facility/psychiatric hospital/unit"
      )
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    PastMentalHealthDiagnosis: Joi.string()
      .label("Past mental health diagnosis")
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    MentalHealthHistory: Joi.string()
      .label("Mental Health treatment history")
      .when("PastMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    RecipientPerspectiveOfTreatment: Joi.string()
      .label("Recipient's perspective of treatment/counseling")
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    CaregiverPerspectiveOfTreatment: Joi.string()
      .label("Caregiver's perspective of treatment/counseling")
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    SubstanceUseNA: Joi.boolean(),
    DeniesSubstanceUse: Joi.boolean(),
    CurrentSubstanceUse: Joi.boolean(),
    PastSubstanceUse: Joi.boolean(),
    SuspectedSubstanceUse: Joi.boolean(),
    SubstanceUseEvidence: Joi.boolean(),
    SubstanceUseByPeers: Joi.boolean(),
    SubstanceUseHistory: Joi.label("Substance Use History").when(
      "SubstanceUseNA",
      {
        is: false,
        then: Joi.when("DeniesSubstanceUse", {
          is: false,
          then: Joi.string().required(),
        }),
      }
    ),
    SubstanceUseTreatment: Joi.label("Medical treatment due to use").when(
      "SubstanceUseNA",
      {
        is: false,
        then: Joi.when("DeniesSubstanceUse", {
          is: false,
          then: Joi.string().required(),
        }),
      }
    ),
    SubstanceUseTreatmentDetails: Joi.string()
      .label("Medical treatment details")
      .when("SubstanceUseTreatment", { is: "Yes", then: Joi.required() }),
    SubstanceUseWithdrawal: Joi.label("Withdrawal").when("SubstanceUseNA", {
      is: false,
      then: Joi.when("DeniesSubstanceUse", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SubstanceUseWithdrawalDetails: Joi.string()
      .label("Withdrawal details")
      .when("SubstanceUseWithdrawal", { is: "Yes", then: Joi.required() }),
    SubstanceUseDetox: Joi.label("Detox issues").when("SubstanceUseNA", {
      is: false,
      then: Joi.when("DeniesSubstanceUse", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SubstanceUseDetoxDetails: Joi.string()
      .label("Detox issues details")
      .when("SubstanceUseDetox", { is: "Yes", then: Joi.required() }),
    SubstanceUseOverdose: Joi.label("Overdose history").when("SubstanceUseNA", {
      is: false,
      then: Joi.when("DeniesSubstanceUse", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SubstanceUseOverdoseDetails: Joi.string()
      .label("Overdose history details")
      .when("SubstanceUseOverdose", { is: "Yes", then: Joi.required() }),
    SubstanceUseLegal: Joi.label("Legal involvement due to use").when(
      "SubstanceUseNA",
      {
        is: false,
        then: Joi.when("DeniesSubstanceUse", {
          is: false,
          then: Joi.string().required(),
        }),
      }
    ),
    SubstanceUseLegalDetails: Joi.string()
      .label("Legal involvement details")
      .when("SubstanceUseLegal", { is: "Yes", then: Joi.required() }),
    SubstanceUseFamilyProblems: Joi.label(
      "Use has caused problems with family or friends"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.when("DeniesSubstanceUse", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SubstanceUseFamilyProblemsDetails: Joi.string()
      .label("Family or friends problems details")
      .when("SubstanceUseFamilyProblems", { is: "Yes", then: Joi.required() }),
    SubstanceUseSchoolProblems: Joi.label(
      "Use has caused problems with school or work"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.when("DeniesSubstanceUse", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SubstanceUseSchoolProblemsDetails: Joi.string()
      .label("School or work problems details")
      .when("SubstanceUseSchoolProblems", { is: "Yes", then: Joi.required() }),
    RecipientPerception: Joi.label(
      "Recipient's perception of substance use"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.when("DeniesSubstanceUse", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    CaregiverPerception: Joi.label(
      "Caregiver's perception of Recipient's substance use"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.when("DeniesSubstanceUse", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    NoPastTreatment: Joi.boolean(),
    SubstanceUseTreatmentHistory: Joi.label(
      "Substance use treatment history"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.when("DeniesSubstanceUse", {
        is: false,
        then: Joi.when("NoPastTreatment", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    TraumaNA: Joi.boolean(),
    TraumaHistory: Joi.string()
      .label("Trauma History")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    DistressingMemories: Joi.boolean(),
    BlockOut: Joi.boolean(),
    Hypervigilance: Joi.boolean(),
    PhysiologicalResponses: Joi.boolean(),
    LossOfMemories: Joi.boolean(),
    Hyperarousal: Joi.boolean(),
    SleepDisturbances: Joi.boolean(),
    DevelopmentalRegression: Joi.boolean(),
    Nightmares: Joi.boolean(),
    Avoidant: Joi.boolean(),
    DifficultyConcentratingSymptom: Joi.boolean(),
    UnhealthyBoundaries: Joi.boolean(),
    Flashbacks: Joi.boolean(),
    Detachment: Joi.boolean(),
    EmotionalDysregulation: Joi.boolean(),
    RepetitivePlayOfEvents: Joi.boolean(),
    PsychologicalDistress: Joi.boolean(),
    DiminishedInterests: Joi.boolean(),
    Dissocation: Joi.boolean(),
    NegativeCognitions: Joi.boolean(),
    SocialWithdrawalSymptom: Joi.boolean(),
    NoSymptoms: Joi.boolean(),
    SocialSupports: Joi.boolean(),
    SenseOfMastery: Joi.boolean(),
    CaregiverStability: Joi.boolean(),
    StrongSpiritualBeliefs: Joi.boolean(),
    InterpersonalSkills: Joi.boolean(),
    PositiveOutlook: Joi.boolean(),
    PlacementStability: Joi.boolean(),
    Pets: Joi.boolean(),
    ValidatingExperiences: Joi.boolean(),
    Resources: Joi.boolean(),
    TiesToExtendedFamily: Joi.boolean(),
    Adaptability: Joi.boolean(),
    SecureAttachments: Joi.boolean(),
    StrongCulturalIdentity: Joi.boolean(),
    NoTraumaProtectiveFactors: Joi.boolean(),
    CopingStrategies: Joi.string()
      .label("Coping strategies")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    RecipientAware: Joi.string()
      .label("Recipient aware of trauma")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    RecipientTraumaPerspective: Joi.string()
      .label("Recipient's perspective of trauma")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    CaregiverTraumaPerspective: Joi.string()
      .label("Caregiver's perspective of trauma")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    AppropriateAppearance: Joi.boolean(),
    Neat: Joi.boolean(),
    Disheveled: Joi.boolean(),
    BizarreAppearance: Joi.boolean(),
    OtherAppearance: Joi.boolean(),
    OtherAppearanceDetails: Joi.string()
      .label("Other Appearance details")
      .when("OtherAppearance", { is: true, then: Joi.required() }),
    Cooperative: Joi.boolean(),
    Guarded: Joi.boolean(),
    Hyperactive: Joi.boolean(),
    Agitated: Joi.boolean(),
    Paranoid: Joi.boolean(),
    Tics: Joi.boolean(),
    Impulsive: Joi.boolean(),
    Aggressive: Joi.boolean(),
    Withdrawn: Joi.boolean(),
    BizarreBehavior: Joi.boolean(),
    Rigidity: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.string()
      .label("Other Behavior details")
      .when("OtherBehavior", { is: true, then: Joi.required() }),
    Normal: Joi.boolean(),
    Slurred: Joi.boolean(),
    Pressured: Joi.boolean(),
    Tangential: Joi.boolean(),
    Incoherent: Joi.boolean(),
    Stutters: Joi.boolean(),
    OtherSpeech: Joi.boolean(),
    OtherSpeechDetails: Joi.string()
      .label("Other Speech details")
      .when("OtherSpeech", { is: true, then: Joi.required() }),
    Euthymic: Joi.boolean(),
    Anxious: Joi.boolean(),
    Angry: Joi.boolean(),
    Depressed: Joi.boolean(),
    Euphoric: Joi.boolean(),
    Irritable: Joi.boolean(),
    Fearful: Joi.boolean(),
    OtherMood: Joi.boolean(),
    OtherMoodDetails: Joi.string()
      .label("Other Mood details")
      .when("OtherMood", { is: true, then: Joi.required() }),
    FullRange: Joi.boolean(),
    Restricted: Joi.boolean(),
    Blunted: Joi.boolean(),
    Flat: Joi.boolean(),
    Inappropriate: Joi.boolean(),
    OtherAffect: Joi.boolean(),
    OtherAffectDetails: Joi.string()
      .label("Other Affect details")
      .when("OtherAffect", { is: true, then: Joi.required() }),
    Logical: Joi.boolean(),
    Preoccupations: Joi.boolean(),
    Delusions: Joi.boolean(),
    Hallucinations: Joi.boolean(),
    Racing: Joi.boolean(),
    Disorganized: Joi.boolean(),
    Concrete: Joi.boolean(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    OtherPerception: Joi.boolean(),
    OtherPerceptionDetails: Joi.string()
      .label("Other Perception details")
      .when("OtherPerception", { is: true, then: Joi.required() }),
    NoImpairment: Joi.boolean(),
    ShortAttentionSpan: Joi.boolean(),
    DifficultyConcentrating: Joi.boolean(),
    Distractibility: Joi.boolean(),
    MemoryImpairment: Joi.boolean(),
    LowIntelligence: Joi.boolean(),
    OtherCognition: Joi.boolean(),
    OtherCognitionDetails: Joi.string()
      .label("Other Cognition details")
      .when("OtherCognition", { is: true, then: Joi.required() }),
    AppropriateInsight: Joi.boolean(),
    Fair: Joi.boolean(),
    Impaired: Joi.boolean(),
    OtherInsight: Joi.boolean(),
    OtherInsightDetails: Joi.string()
      .label("Other Insight details")
      .when("OtherInsight", { is: true, then: Joi.required() }),
    MentalStatusComments: Joi.string()
      .label("Mental Status comments")
      .required(),
    LethalityNA: Joi.boolean(),
    SelfAbusiveBehavior: Joi.string()
      .label("Self-abusive behavior")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SelfAbusiveBehaviorDetails: Joi.string()
      .label("Self-abusive behavior details")
      .when("SelfAbusiveBehavior", { is: "Current", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "Last 30 Days", then: Joi.required() })
      .when("SelfAbusiveBehavior", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("SelfAbusiveBehavior", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    SuicidalThreats: Joi.string()
      .label("Suicidal threats")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicidalThreatsDetails: Joi.string()
      .label("Suicidal threats details")
      .when("SuicidalThreats", { is: "Current", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicidalThreats", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    SuicideAttempt: Joi.string()
      .label("Suicide attempt")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicideAttemptDetails: Joi.string()
      .label("Suicide attempt details")
      .when("SuicideAttempt", { is: "Current", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicideAttempt", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    CaregiverConcernsOfSelfHarm: Joi.string()
      .label("Parent/Caregiver concerns of suicide/self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CaregiverConcernsOfSelfHarmDetails: Joi.string()
      .label("Parent/Caregiver concerns of suicide/self-harm details")
      .when("CaregiverConcernsOfSelfHarm", { is: "Yes", then: Joi.required() }),
    OtherConcernsOfSelfHarm: Joi.string()
      .label("Other expressed concerns of suicide/self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherConcernsOfSelfHarmDetails: Joi.string()
      .label("Other expressed concerns of suicide/self-harm details")
      .when("OtherConcernsOfSelfHarm", { is: "Yes", then: Joi.required() }),
    PriorAttempt: Joi.boolean(),
    FamilyHistory: Joi.boolean(),
    AccessToMeans: Joi.boolean(),
    Exposure: Joi.boolean(),
    HealthCondition: Joi.boolean(),
    ElevatingBeliefs: Joi.boolean(),
    MentalHealthDisorder: Joi.boolean(),
    OtherRiskFactors: Joi.boolean(),
    NoRiskFactors: Joi.boolean(),
    OtherRiskFactorsDetails: Joi.string()
      .label("Other Risk Factor details")
      .when("OtherRiskFactors", { is: true, then: Joi.required() }),
    ClinicalCare: Joi.boolean(),
    Connected: Joi.boolean(),
    Skills: Joi.boolean(),
    CaregiverContacts: Joi.boolean(),
    DiscouragingBeliefs: Joi.boolean(),
    NoSelfHarmProtectiveFactors: Joi.boolean(),
    Threatening: Joi.boolean(),
    SayingGoodbye: Joi.boolean(),
    SeekingMeans: Joi.boolean(),
    SocialWithdrawal: Joi.boolean(),
    Hopelessness: Joi.boolean(),
    RecklessBehavior: Joi.boolean(),
    IncreasedSubstanceUse: Joi.boolean(),
    Feelings: Joi.boolean(),
    DramaticMoodChanges: Joi.boolean(),
    GivingAwayPossessions: Joi.boolean(),
    NoWarningSigns: Joi.boolean(),
    SelfHarmSafetyPlanStatus: Joi.string()
      .label("Safety plan status")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentSelfHarmRisk: Joi.string()
      .label("Current Risk of Harm to Self")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentSelfHarmRiskComments: Joi.string()
      .label("Current Risk of Harm to Self comments")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThreatsToHarmOthers: Joi.string()
      .label("Threats to intentionally harm/endanger others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThreatsToHarmOthersDetails: Joi.string()
      .label("Threats to intentionally harm/endanger others details")
      .when("ThreatsToHarmOthers", { is: "Current", then: Joi.required() })
      .when("ThreatsToHarmOthers", { is: "Last 30 Days", then: Joi.required() })
      .when("ThreatsToHarmOthers", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("ThreatsToHarmOthers", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ThoughtsOfHarm: Joi.string()
      .label("Thoughts of intentionally harming/endangering others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThoughtsOfHarmDetails: Joi.string()
      .label("Thoughts of intentionally harming/endangering others details")
      .when("ThoughtsOfHarm", { is: "Current", then: Joi.required() })
      .when("ThoughtsOfHarm", { is: "Last 30 Days", then: Joi.required() })
      .when("ThoughtsOfHarm", { is: "Last 6 Months", then: Joi.required() })
      .when("ThoughtsOfHarm", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ActsOfHarm: Joi.string()
      .label("Acts of intentionally harm/endangering others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarmDetails: Joi.string()
      .label("Acts of intentionally harm/endangering others details")
      .when("ActsOfHarm", { is: "Current", then: Joi.required() })
      .when("ActsOfHarm", { is: "Last 30 Days", then: Joi.required() })
      .when("ActsOfHarm", { is: "Last 6 Months", then: Joi.required() })
      .when("ActsOfHarm", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ActsOfHarmAnimals: Joi.string()
      .label("Acts of intentionally harm/endangering animals")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarmAnimalsDetails: Joi.string()
      .label("Acts of intentionally harm/endangering animals details")
      .when("ActsOfHarmAnimals", { is: "Current", then: Joi.required() })
      .when("ActsOfHarmAnimals", { is: "Last 30 Days", then: Joi.required() })
      .when("ActsOfHarmAnimals", { is: "Last 6 Months", then: Joi.required() })
      .when("ActsOfHarmAnimals", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ActsInvolvingWeapons: Joi.string()
      .label("Acts involving weapons")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsInvolvingWeaponsDetails: Joi.string()
      .label("Acts involving weapons details")
      .when("ActsInvolvingWeapons", { is: "Current", then: Joi.required() })
      .when("ActsInvolvingWeapons", {
        is: "Last 30 Days",
        then: Joi.required(),
      })
      .when("ActsInvolvingWeapons", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("ActsInvolvingWeapons", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    CaregiverConcernOfOtherHarm: Joi.string()
      .label("Parent/Caregiver concerns of harm/endangering others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherConcernsOfOtherHarm: Joi.string()
      .label("Other expressed concerns of harm/endangering others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherHarmSafetyPlanStatus: Joi.string()
      .label("Safety plan status")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentOtherHarmRisk: Joi.string()
      .label("Current Risk of Harm to Others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentOtherHarmRiskDetails: Joi.string()
      .label("Current Risk of Harm to Others comments")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ClinicalNarrativeSummary: Joi.string()
      .label("Clinical Narrative Summary")
      .required(),
    ClinicalNarrativeSummaryComments: Joi.string()
      .label("Clinical Narrative Summary comments")
      .required(),
    DiagnosisDetails: Joi.string().label("Diagnosis").required(),
    SkillsTraining: Joi.boolean(),
    CommunitySupport: Joi.boolean(),
    MedicalDentalVision: Joi.boolean(),
    SymptomManagementSkills: Joi.boolean(),
    Mentoring: Joi.boolean(),
    HealthyHabits: Joi.boolean(),
    SocialSkills: Joi.boolean(),
    FamilySupport: Joi.boolean(),
    EducationSchool: Joi.boolean(),
    DecisionMaking: Joi.boolean(),
    FosterFamilySupport: Joi.boolean(),
    Vocational: Joi.boolean(),
    FinancialSupport: Joi.boolean(),
    Respite: Joi.boolean(),
    Occupational: Joi.boolean(),
    ProsocialActivities: Joi.boolean(),
    MedicationManagementNeed: Joi.boolean(),
    CaseManagement: Joi.boolean(),
    TreatmentRecommendations: Joi.string()
      .label("Treatment Recommendations")
      .required(),
    MorePsychiatric: Joi.boolean(),
    MorePsychological: Joi.boolean(),
    MoreNeurological: Joi.boolean(),
    MoreEducational: Joi.boolean(),
    MoreMedical: Joi.boolean(),
    MoreDental: Joi.boolean(),
    MoreSubstanceUse: Joi.boolean(),
    MoreVocational: Joi.boolean(),
    MoreOccupational: Joi.boolean(),
    MoreVisualAuditory: Joi.boolean(),
    MoreNutritional: Joi.boolean(),
    MoreOther: Joi.boolean(),
    MoreOtherDetails: Joi.string()
      .label("Other Evaluation Needs")
      .when("MoreOther", { is: true, then: Joi.required() }),
    DiagnosisEducation: Joi.string()
      .label("Diagnosis education provided")
      .required(),
    RecommendationEducation: Joi.string()
      .label("Recommendation education provided")
      .required(),
    RecipientAgrees: Joi.string().label("Recipient in agreement").required(),
    FamilyAgrees: Joi.string().label("Family in agreement").required(),
    SexAssignedAtBirth: Joi.string().label("Sex Assigned at Birth").required(),
    SexAssignedAtBirthDetails: Joi.string()
      .label("Sex Assigned at Birth Specifics")
      .when("SexAssignedAtBirth", {
        is: "Sex not listed",
        then: Joi.required(),
      }),
    Pronouns: Joi.string().label("Pronouns").required(),
    PronounsDescription: Joi.string()
      .label("Pronouns description")
      .when("Pronouns", {
        is: "Prefer to self-describe",
        then: Joi.required(),
      })
      .when("Pronouns", { is: "Describe", then: Joi.required() }),
    GenderIdentity: Joi.string().label("Gender Identity").required(),
    GenderIdentityDescription: Joi.string()
      .label("Gender Identity description")
      .when("GenderIdentity", {
        is: "Identity not listed",
        then: Joi.required(),
      }),
    SexualOrientationDetails: Joi.string()
      .label("Sexual Orientation specifics")
      .when("SexualOrientation", {
        is: "Orientation not listed",
        then: Joi.required(),
      }),
    TraumaSymptoms: Joi.boolean(),
    TraumaticExposure: Joi.boolean(),
    AvoidantTrauma: Joi.boolean(),
    HypervigilanceTrauma: Joi.boolean(),
    IntrusiveDreams: Joi.boolean(),
    NegativeThoughts: Joi.boolean(),
    CocentrationProblems: Joi.boolean(),
    RecklessBehaviorTrauma: Joi.boolean(),
    SleepDisturbancesTrauma: Joi.boolean(),
    OtherTrauma: Joi.boolean(),
    OtherTraumaDetails: Joi.string()
      .label("Other Trauma Details")
      .when("OtherTrauma", { is: true, then: Joi.required() }),
    TraumaSymptomsFrequency: Joi.string()
      .label("Trauma Symptoms Frequency")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsIntensity: Joi.string()
      .label("Trauma Symptoms Intensity")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsDuration: Joi.string()
      .label("Trauma Symptoms Duration")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsOnset: Joi.string()
      .label("Trauma Symptoms Onset")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    AnxietyDisorder: Joi.boolean(),
    AnxietyDisorderExcessWorry: Joi.boolean(),
    AnxietyDisorderEasilyFatigued: Joi.boolean(),
    MuscleTension: Joi.boolean(),
    Overworried: Joi.boolean(),
    AnxietyDisorderDifficultyConcentrating: Joi.boolean(),
    SleepDisturbancesAnxiety: Joi.boolean(),
    RestlessAnxiety: Joi.boolean(),
    Irritability: Joi.boolean(),
    OtherAnxiety: Joi.boolean(),
    OtherAnxietyDetails: Joi.string()
      .label("Other Anxiety Details")
      .when("OtherAnxiety", { is: true, then: Joi.required() }),
    AnxietyDisorderFrequency: Joi.string()
      .label("Anxiety Frequency")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    AnxietyDisorderIntensity: Joi.string()
      .label("Anxiety Intensity")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    AnxietyDisorderDuration: Joi.string()
      .label("Anxiety Duration")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    DepressionSymptoms: Joi.boolean(),
    DepressedMood: Joi.boolean(),
    SleepChanges: Joi.boolean(),
    Guilt: Joi.boolean(),
    DiminishedInterest: Joi.boolean(),
    PurposelessMovement: Joi.boolean(),
    DifficultyConcentratingDepression: Joi.boolean(),
    WeightChanges: Joi.boolean(),
    FatigueDepression: Joi.boolean(),
    ThoughtsOfDeath: Joi.boolean(),
    OtherDepression: Joi.boolean(),
    OtherDepressionDetails: Joi.string()
      .label("Other Depression Details")
      .when("OtherDepression", { is: true, then: Joi.required() }),
    DepressionFrequency: Joi.string()
      .label("Depression Frequency")
      .when("DepressionSymptoms", { is: true, then: Joi.required() })
      .when("Depression", { is: true, then: Joi.required() }),
    DepressionIntensity: Joi.string()
      .label("Depression Intensity")
      .when("DepressionSymptoms", { is: true, then: Joi.required() })
      .when("Depression", { is: true, then: Joi.required() }),
    DepressionDuration: Joi.string()
      .label("Depression Duration")
      .when("DepressionSymptoms", { is: true, then: Joi.required() })
      .when("Depression", { is: true, then: Joi.required() }),
    AttentionHyperactivity: Joi.boolean(),
    AttentionHyperactivityEasilyDistracted: Joi.boolean(),
    DifficultyFollowThrough: Joi.boolean(),
    Forgetful: Joi.boolean(),
    DifficultyListening: Joi.boolean(),
    DisorganizedAttention: Joi.boolean(),
    Fidgety: Joi.boolean(),
    LackOfDetails: Joi.boolean(),
    LosesThings: Joi.boolean(),
    InterruptsOthers: Joi.boolean(),
    UnableToSitStill: Joi.boolean(),
    ExcessiveTalking: Joi.boolean(),
    DifficultyWaiting: Joi.boolean(),
    OtherAttention: Joi.boolean(),
    OtherAttentionDetails: Joi.string()
      .label("Other Attention Details")
      .when("OtherAttention", { is: true, then: Joi.required() }),
    AttentionHyperactivityFrequency: Joi.string()
      .label("Attention Frequency")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    AttentionHyperactivityIntensity: Joi.string()
      .label("Attention Intensity")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    AttentionHyperactivityDuration: Joi.string()
      .label("Attention Duration")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    SU: Joi.boolean(),
    PatternOfSubstanceUse: Joi.boolean(),
    DesiresCutDownUse: Joi.boolean(),
    TimeSpentObtaining: Joi.boolean(),
    Cravings: Joi.boolean(),
    FailureOfResponsibilities: Joi.boolean(),
    NegativeImpact: Joi.boolean(),
    AbandonsActivities: Joi.boolean(),
    Tolerance: Joi.boolean(),
    SUWithdrawal: Joi.boolean(),
    SUOther: Joi.boolean(),
    SUOtherDetails: Joi.string()
      .label("Other Substance Use Details")
      .when("SUOther", { is: true, then: Joi.required() }),
    SubstanceUseFrequency: Joi.string()
      .label("Substance Use Frequency")
      .when("SU", { is: true, then: Joi.required() })
      .when("SubstanceUse", { is: true, then: Joi.required() }),
    SubstanceUseIntensity: Joi.string()
      .label("Substance Use Intensity")
      .when("SU", { is: true, then: Joi.required() })
      .when("SubstanceUse", { is: true, then: Joi.required() }),
    SubstanceUseDuration: Joi.string()
      .label("Substance Use Duration")
      .when("SU", { is: true, then: Joi.required() })
      .when("SubstanceUse", { is: true, then: Joi.required() }),
    DMDD: Joi.boolean(),
    Temper: Joi.boolean(),
    OutsideOutbursts: Joi.boolean(),
    FrequentOutbursts: Joi.boolean(),
    DMDDIrritable: Joi.boolean(),
    OutburstsAroundOthers: Joi.boolean(),
    DMDDOther: Joi.boolean(),
    DMDDOtherDetails: Joi.string()
      .label("Other Disruptive Mood Dysregulation Disorder Details")
      .when("DMDDOther", { is: true, then: Joi.required() }),
    DMDDFrequency: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Frequency")
      .when("DMDD", { is: true, then: Joi.required() }),
    DMDDIntensity: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Intensity")
      .when("DMDD", { is: true, then: Joi.required() }),
    DMDDDuration: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Duration")
      .when("DMDD", { is: true, then: Joi.required() }),
    ConductDisorder: Joi.boolean(),
    Aggression: Joi.boolean(),
    DestructionOfProperty: Joi.boolean(),
    Theft: Joi.boolean(),
    SeriousViolations: Joi.boolean(),
    OtherConductDisorder: Joi.boolean(),
    OtherConductDisorderDetails: Joi.string()
      .label("Other Conduct Disorder Details")
      .when("OtherConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderFrequency: Joi.string()
      .label("Conduct Disorder Frequency")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderIntensity: Joi.string()
      .label("Conduct Disorder Intensity")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderDuration: Joi.string()
      .label("Conduct Disorder Duration")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ODD: Joi.boolean(),
    IrritableODD: Joi.boolean(),
    Argumentative: Joi.boolean(),
    Vindictive: Joi.boolean(),
    OtherODD: Joi.boolean(),
    OtherODDDetails: Joi.string()
      .label("Other Oppositional Defiance Disorder Details")
      .when("OtherODD", { is: true, then: Joi.required() }),
    ODDFrequency: Joi.string()
      .label("Oppositional Defiance Disorder Frequency")
      .when("ODD", { is: true, then: Joi.required() }),
    ODDIntensity: Joi.string()
      .label("Oppositional Defiance Disorder Intensity")
      .when("ODD", { is: true, then: Joi.required() }),
    ODDDuration: Joi.string()
      .label("Oppositional Defiance Disorder Duration")
      .when("ODD", { is: true, then: Joi.required() }),
    OCD: Joi.boolean(),
    OCDPresence: Joi.boolean(),
    Obsessions: Joi.boolean(),
    TimeConsuming: Joi.boolean(),
    Compulsions: Joi.boolean(),
    ReduceAnxiety: Joi.boolean(),
    SuppressUrges: Joi.boolean(),
    OCDOther: Joi.boolean(),
    OCDOtherDetails: Joi.string()
      .label("Other Obsessive-Compulsive Disorder Details")
      .when("OCDOther", { is: true, then: Joi.required() }),
    OCDFrequency: Joi.string()
      .label("Obsessive-Compulsive Disorder Frequency")
      .when("OCD", { is: true, then: Joi.required() }),
    OCDIntensity: Joi.string()
      .label("Obsessive-Compulsive Disorder Intensity")
      .when("OCD", { is: true, then: Joi.required() }),
    OCDDuration: Joi.string()
      .label("Obsessive-Compulsive Disorder Duration")
      .when("OCD", { is: true, then: Joi.required() }),
    PanicDisorder: Joi.boolean(),
    PoundingHeart: Joi.boolean(),
    PanicDisorderSweating: Joi.boolean(),
    Trembling: Joi.boolean(),
    ShortnessOfBreath: Joi.boolean(),
    Choking: Joi.boolean(),
    ChestPain: Joi.boolean(),
    PanicDisorderNausea: Joi.boolean(),
    Dizzy: Joi.boolean(),
    Chills: Joi.boolean(),
    Derealization: Joi.boolean(),
    FearOfCrazy: Joi.boolean(),
    FearOfDying: Joi.boolean(),
    PanicDisorderOther: Joi.boolean(),
    PanicDisorderOtherDetails: Joi.string()
      .label("Other Panic Disorder Details")
      .when("PanicDisorderOther", { is: true, then: Joi.required() }),
    PanicDisorderFrequency: Joi.string()
      .label("Panic Disorder Frequency")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    PanicDisorderIntensity: Joi.string()
      .label("Panic Disorder Intensity")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    PanicDisorderDuration: Joi.string()
      .label("Panic Disorder Duration")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    Phobias: Joi.boolean(),
    PhobiasSpecificFear: Joi.boolean(),
    ImmediateFear: Joi.boolean(),
    PhobiasAvoidance: Joi.boolean(),
    FearExaggerated: Joi.boolean(),
    PhobiasOther: Joi.boolean(),
    PhobiasOtherDetails: Joi.string()
      .label("Other Phobia Details")
      .when("PhobiasOther", { is: true, then: Joi.required() }),
    PhobiasFrequency: Joi.string()
      .label("Phobia Frequency")
      .when("Phobias", { is: true, then: Joi.required() }),
    PhobiasIntensity: Joi.string()
      .label("Phobia Intensity")
      .when("Phobias", { is: true, then: Joi.required() }),
    PhobiasDuration: Joi.string()
      .label("Phobia Duration")
      .when("Phobias", { is: true, then: Joi.required() }),
    DI: Joi.boolean(),
    DILowIQ: Joi.boolean(),
    DISensoryImpairments: Joi.boolean(),
    DISpeechDelays: Joi.boolean(),
    DIMotorCoordinationDelays: Joi.boolean(),
    DILearningDisorder: Joi.boolean(),
    DISpatialDelays: Joi.boolean(),
    DevelopmentalImpairmentsOther: Joi.boolean(),
    DevelopmentalImpairmentsOtherDetails: Joi.string()
      .label("Other Developmental Impairments Details")
      .when("DevelopmentalImpairmentsOther", {
        is: true,
        then: Joi.required(),
      }),
    DevelopmentalImpairmentsDetails: Joi.string()
      .label("Developmental Impairments Description")
      .when("DILowIQ", { is: true, then: Joi.required() })
      .when("DISensoryImpairments", { is: true, then: Joi.required() })
      .when("DISpeechDelays", { is: true, then: Joi.required() })
      .when("DIMotorCoordinationDelays", { is: true, then: Joi.required() })
      .when("DILearningDisorder", { is: true, then: Joi.required() })
      .when("DISpatialDelays", { is: true, then: Joi.required() }),
    OtherSymptoms: Joi.boolean(),
    OtherSymptomsDetails: Joi.string()
      .label("Other Symptom Details")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsFrequency: Joi.string()
      .label("Other Symptoms Frequency")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsIntensity: Joi.string()
      .label("Other Symptoms Intensity")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsDuration: Joi.string()
      .label("Other Symptoms Duration")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),

    // DEPRECATED FIELDS
    Depression: Joi.boolean(),
    Mania: Joi.boolean(),
    ManiaFrequency: Joi.string()
      .label("Mania Frequency")
      .when("Mania", { is: true, then: Joi.required() }),
    ManiaIntensity: Joi.string()
      .label("Mania Intensity")
      .when("Mania", { is: true, then: Joi.required() }),
    ManiaDuration: Joi.string()
      .label("Mania Duration")
      .when("Mania", { is: true, then: Joi.required() }),
    BipolarFrequency: Joi.string()
      .label("Bipolar Frequency")
      .when("Bipolar", { is: true, then: Joi.required() }),
    BipolarIntensity: Joi.string()
      .label("Bipolar Intensity")
      .when("Bipolar", { is: true, then: Joi.required() }),
    BipolarDuration: Joi.string()
      .label("Bipolar Duration")
      .when("Bipolar", { is: true, then: Joi.required() }),
    ObsessiveCompulsive: Joi.boolean(),
    ObsessiveCompulsiveFrequency: Joi.string()
      .label("Obsessive Compulsive Frequency")
      .when("ObsessiveCompulsive", { is: true, then: Joi.required() }),
    ObsessiveCompulsiveIntensity: Joi.string()
      .label("Obsessive Compulsive Intensity")
      .when("ObsessiveCompulsive", { is: true, then: Joi.required() }),
    ObsessiveCompulsiveDuration: Joi.string()
      .label("Obsessive Compulsive Duration")
      .when("ObsessiveCompulsive", { is: true, then: Joi.required() }),
    Psychosis: Joi.boolean(),
    PsychosisFrequency: Joi.string()
      .label("Psychosis Frequency")
      .when("Psychosis", { is: true, then: Joi.required() }),
    PsychosisIntensity: Joi.string()
      .label("Psychosis Intensity")
      .when("Psychosis", { is: true, then: Joi.required() }),
    PsychosisDuration: Joi.string()
      .label("Psychosis Duration")
      .when("Psychosis", { is: true, then: Joi.required() }),
    PTSD: Joi.boolean(),
    PTSDFrequency: Joi.string()
      .label("PTSD Frequency")
      .when("PTSD", { is: true, then: Joi.required() }),
    PTSDIntensity: Joi.string()
      .label("PTSD Intensity")
      .when("PTSD", { is: true, then: Joi.required() }),
    PTSDDuration: Joi.string()
      .label("PTSD Duration")
      .when("PTSD", { is: true, then: Joi.required() }),
    PanicAttacks: Joi.boolean(),
    PanicAttacksFrequency: Joi.string()
      .label("Panic Attacks Frequency")
      .when("PanicAttacks", { is: true, then: Joi.required() }),
    PanicAttacksIntensity: Joi.string()
      .label("Panic Attacks Intensity")
      .when("PanicAttacks", { is: true, then: Joi.required() }),
    PanicAttacksDuration: Joi.string()
      .label("Panic Attacks Duration")
      .when("PanicAttacks", { is: true, then: Joi.required() }),
    Anxiety: Joi.boolean(),
    AnxietyFrequency: Joi.string()
      .label("Anxiety Frequency")
      .when("Anxiety", { is: true, then: Joi.required() }),
    AnxietyIntensity: Joi.string()
      .label("Anxiety Intensity")
      .when("Anxiety", { is: true, then: Joi.required() }),
    AnxietyDuration: Joi.string()
      .label("Anxiety Duration")
      .when("Anxiety", { is: true, then: Joi.required() }),
    Phobia: Joi.boolean(),
    PhobiaFrequency: Joi.string()
      .label("Phobia Frequency")
      .when("Phobia", { is: true, then: Joi.required() }),
    PhobiaIntensity: Joi.string()
      .label("Phobia Intensity")
      .when("Phobia", { is: true, then: Joi.required() }),
    PhobiaDuration: Joi.string()
      .label("Phobia Duration")
      .when("Phobia", { is: true, then: Joi.required() }),
    EatingDisorder: Joi.boolean(),
    EatingDisorderFrequency: Joi.string()
      .label("Eating Disorder Frequency")
      .when("EatingDisorder", { is: true, then: Joi.required() }),
    EatingDisorderIntensity: Joi.string()
      .label("Eating Disorder Intensity")
      .when("EatingDisorder", { is: true, then: Joi.required() }),
    EatingDisorderDuration: Joi.string()
      .label("Eating Disorder Duration")
      .when("EatingDisorder", { is: true, then: Joi.required() }),
    Elimination: Joi.boolean(),
    EliminationFrequency: Joi.string()
      .label("Elimination Frequency")
      .when("Elimination", { is: true, then: Joi.required() }),
    EliminationIntensity: Joi.string()
      .label("Elimination Intensity")
      .when("Elimination", { is: true, then: Joi.required() }),
    EliminationDuration: Joi.string()
      .label("Elimination Duration")
      .when("Elimination", { is: true, then: Joi.required() }),
    Conduct: Joi.boolean(),
    ConductFrequency: Joi.string()
      .label("Conduct Frequency")
      .when("Conduct", { is: true, then: Joi.required() }),
    ConductIntensity: Joi.string()
      .label("Conduct Intensity")
      .when("Conduct", { is: true, then: Joi.required() }),
    ConductDuration: Joi.string()
      .label("Conduct Duration")
      .when("Conduct", { is: true, then: Joi.required() }),
    Oppositional: Joi.boolean(),
    OppositionalFrequency: Joi.string()
      .label("Oppositional Defiance Frequency")
      .when("Oppositional", { is: true, then: Joi.required() }),
    OppositionalIntensity: Joi.string()
      .label("Oppositional Defiance Intensity")
      .when("Oppositional", { is: true, then: Joi.required() }),
    OppositionalDuration: Joi.string()
      .label("Oppositional Defiance Duration")
      .when("Oppositional", { is: true, then: Joi.required() }),
    Attention: Joi.boolean(),
    AttentionFrequency: Joi.string()
      .label("Attention Frequency")
      .when("Attention", { is: true, then: Joi.required() }),
    AttentionIntensity: Joi.string()
      .label("Attention Intensity")
      .when("Attention", { is: true, then: Joi.required() }),
    AttentionDuration: Joi.string()
      .label("Attention Duration")
      .when("Attention", { is: true, then: Joi.required() }),
    Adjustment: Joi.boolean(),
    AdjustmentFrequency: Joi.string()
      .label("Adjustment Frequency")
      .when("Adjustment", { is: true, then: Joi.required() }),
    AdjustmentIntensity: Joi.string()
      .label("Adjustment Intensity")
      .when("Adjustment", { is: true, then: Joi.required() }),
    AdjustmentDuration: Joi.string()
      .label("Adjustment Duration")
      .when("Adjustment", { is: true, then: Joi.required() }),
    Attachment: Joi.boolean(),
    AttachmentFrequency: Joi.string()
      .label("Attachment Frequency")
      .when("Attachment", { is: true, then: Joi.required() }),
    AttachmentIntensity: Joi.string()
      .label("Attachment Intensity")
      .when("Attachment", { is: true, then: Joi.required() }),
    AttachmentDuration: Joi.string()
      .label("Attachment Duration")
      .when("Attachment", { is: true, then: Joi.required() }),
    DevelopmentalImpairments: Joi.boolean(),
    DevelopmentalImpairmentsFrequency: Joi.string()
      .label("Developmental Impairments Frequency")
      .when("DevelopmentalImpairments", { is: true, then: Joi.required() }),
    DevelopmentalImpairmentsIntensity: Joi.string()
      .label("Developmental Impairments Intensity")
      .when("DevelopmentalImpairments", { is: true, then: Joi.required() }),
    DevelopmentalImpairmentsDuration: Joi.string()
      .label("Developmental Impairments Duration")
      .when("DevelopmentalImpairments", { is: true, then: Joi.required() }),
    SubstanceUse: Joi.boolean(),
    OtherSymptom: Joi.boolean(),
    OtherSymptomDetails: Joi.string()
      .label("Other Symptom Details")
      .when("OtherSymptom", { is: true, then: Joi.required() }),
    OtherSymptomFrequency: Joi.string()
      .label("Other Symptom Frequency")
      .when("OtherSymptom", { is: true, then: Joi.required() }),
    OtherSymptomIntensity: Joi.string()
      .label("Other Symptom Intensity")
      .when("OtherSymptom", { is: true, then: Joi.required() }),
    OtherSymptomDuration: Joi.string()
      .label("Other Symptom Duration")
      .when("OtherSymptom", { is: true, then: Joi.required() }),
  },
  "4C6E3F14-2D9B-EC11-A507-0050F21C6F69": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    DateCompleted: Joi.string().required().label("Date Completed"),
    Division: Joi.string().required().label("Division"),
    PSDType: Joi.string().required().label("Type of PSD"),
    ReviewReason: Joi.string()
      .label("Reason")
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ChangeInDiagnosis: Joi.string()
      .label("Change In Diagnosis")
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ISClient: Joi.boolean(),
    ISParent: Joi.boolean(),
    ISFamily: Joi.boolean(),
    ISGuardian: Joi.boolean(),
    ISCaregiver: Joi.boolean(),
    ISPhysician: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISCPS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.string().allow(""),
    PresentingProblem: Joi.string().required().label("Presenting Problem"),
    ClientStrengths: Joi.string().required().label("Client strengths"),
    Supports: Joi.string().required().label("Client/Caregiver supports"),
    CurrentPlacement: Joi.string().required().label("Current placement"),
    PlacementHistory: Joi.string().required().label("Placement History"),
    FamilyHistoryUnknown: Joi.boolean(),
    FamilyHistoryDetails: Joi.string()
      .label("Family History")
      .when("FamilyHistoryUnknown", { is: false, then: Joi.required() }),
    CurrentConcernsOfDV: Joi.boolean(),
    PastConcernsOfDV: Joi.boolean(),
    UnknownConcernsOfDV: Joi.boolean(),
    NoReportedConcernsOfDV: Joi.boolean(),
    ConcernsOfDVVictim: Joi.boolean(),
    ConcernsOfDVWitness: Joi.boolean(),
    CurrentMaritalConflict: Joi.boolean(),
    PastMaritalConflict: Joi.boolean(),
    UnknownMaritalConflict: Joi.boolean(),
    NoReportedMaritalConflict: Joi.boolean(),
    MaritalConflictVictim: Joi.boolean(),
    MaritalConflictWitness: Joi.boolean(),
    CaregiverCooperation: Joi.string()
      .required()
      .label("Caregivers cooperating"),
    SupervisionDifficulties: Joi.string()
      .required()
      .label("Supervision difficulties"),
    DisciplinePracticesEffective: Joi.boolean(),
    DisciplinePracticesInconsistent: Joi.boolean(),
    DisciplinePracticesIneffective: Joi.boolean(),
    DisciplinePracticesNA: Joi.boolean(),
    FamilyHistoryComments: Joi.string()
      .required()
      .label("Family history comments"),
    RaceEthnicity: Joi.string().required().label("Race and ethnicity"),
    PlacesLived: Joi.string().required().label("Places lived"),
    SocioeconomicStatus: Joi.string().required().label("Socioeconomic status"),
    Religion: Joi.string().required().label("Religious information"),
    Traditions: Joi.string().required().label("Cultural events"),
    TraditionsComments: Joi.string()
      .label("Cultural events comments")
      .when("Traditions", { is: "Yes", then: Joi.required() }),
    MedicalBeliefs: Joi.string()
      .required()
      .label("Beliefs affect health decisions?"),
    MedicalBeliefsComments: Joi.string()
      .label("Beliefs affecting health decisions")
      .when("MedicalBeliefs", { is: "Yes", then: Joi.required() }),
    InFosterCare: Joi.string().required().label("In foster care?"),
    CulturalDifferences: Joi.string()
      .label("Cultural differences?")
      .when("InFosterCare", { is: "Yes", then: Joi.required() }),
    CulturalDifferencesComments: Joi.string()
      .label("Cultural differences comments")
      .when("CulturalDifferences", { is: "Yes", then: Joi.required() }),
    PHNoProblems: Joi.boolean(),
    PHPrenatalCare: Joi.string()
      .label("Prenatal care")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHExposure: Joi.string().label("Prenatal exposure").when("PHNoProblems", {
      is: false,
      then: Joi.required(),
    }),
    PHTrauma: Joi.string().label("Prenatal trauma").when("PHNoProblems", {
      is: false,
      then: Joi.required(),
    }),
    PHComplications: Joi.string()
      .label("Birth complications")
      .when("PHNoProblems", {
        is: false,
        then: Joi.required(),
      }),
    PHConcerns: Joi.string().label("Medical concerns").when("PHNoProblems", {
      is: false,
      then: Joi.required(),
    }),
    PHComments: Joi.string().label("Medical comments").when("PHNoProblems", {
      is: false,
      then: Joi.required(),
    }),
    SpecialNeeds: Joi.string().label("Special needs").required(),
    SpecialNeedsDetails: Joi.string()
      .label("Special needs details")
      .when("SpecialNeeds", {
        is: "Yes",
        then: Joi.required(),
      }),
    SpecializedServices: Joi.string().label("Specialized services").required(),
    SpecializedServicesDetails: Joi.string()
      .label("Specialized services details")
      .when("SpecializedServices", {
        is: "Yes",
        then: Joi.required(),
      }),
    EducationStatus: Joi.string().required().label("Education status"),
    SchoolName: Joi.string().label("School Name").when("EducationStatus", {
      is: "Currently enrolled in school",
      then: Joi.required(),
    }),
    CurrentGrade: Joi.string().label("Current Grade").when("EducationStatus", {
      is: "Currently enrolled in school",
      then: Joi.required(),
    }),
    RegularClassroom: Joi.string()
      .label("Regular Classroom")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      }),
    Active504Plan: Joi.string()
      .label("Active 504 Plan")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      }),
    ActiveIEP: Joi.string().label("Active IEP").when("EducationStatus", {
      is: "Currently enrolled in school",
      then: Joi.required(),
    }),
    IEPClassification: Joi.string()
      .label("IEP Classification")
      .when("ActiveIEP", { is: "Yes", then: Joi.required() }),
    SchoolExperience: Joi.string()
      .label("School Experience")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      })
      .when("EducationStatus", { is: "Graduated", then: Joi.required() })
      .when("EducationStatus", { is: "GED", then: Joi.required() })
      .when("EducationStatus", {
        is: "Dropout/Did not complete",
        then: Joi.required(),
      }),
    CurrentlyEmployed: Joi.string()
      .label("Currently Employed")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      })
      .when("EducationStatus", { is: "Graduated", then: Joi.required() })
      .when("EducationStatus", { is: "GED", then: Joi.required() })
      .when("EducationStatus", {
        is: "Dropout/Did not complete",
        then: Joi.required(),
      }),
    EmployerAndTitle: Joi.string()
      .label("Employer name & title")
      .when("CurrentlyEmployed", { is: "Yes", then: Joi.required() }),
    EmploymentInterests: Joi.string()
      .label("Employer name & title")
      .when("CurrentlyEmployed", { is: "Yes", then: Joi.required() })
      .when("CurrentlyEmployed", { is: "No", then: Joi.required() }),
    MilitaryHistory: Joi.string()
      .label("Military History")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      })
      .when("EducationStatus", { is: "Graduated", then: Joi.required() })
      .when("EducationStatus", { is: "GED", then: Joi.required() })
      .when("EducationStatus", {
        is: "Dropout/Did not complete",
        then: Joi.required(),
      }),
    EmploymentComments: Joi.string()
      .label("Military History comments")
      .when("MilitaryHistory", { is: "Yes", then: Joi.required() }),
    ADLNA: Joi.boolean(),
    MoneyManagement: Joi.string()
      .label("Money management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MoneyManagementDetails: Joi.string()
      .label("Money management explanation")
      .when("MoneyManagement", { is: "Yes", then: Joi.required() }),
    FoodManagement: Joi.string()
      .label("Food management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    FoodManagementDetails: Joi.string()
      .label("Food management explanation")
      .when("FoodManagement", { is: "Yes", then: Joi.required() }),
    Hygiene: Joi.string()
      .label("Hygiene")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HygieneDetails: Joi.string()
      .label("Hygiene explanation")
      .when("Hygiene", { is: "Yes", then: Joi.required() }),
    Health: Joi.string()
      .label("Health")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HealthDetails: Joi.string()
      .label("Health explanation")
      .when("Health", { is: "Yes", then: Joi.required() }),
    Housekeeping: Joi.string()
      .label("Housekeeping")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HousekeepingDetails: Joi.string()
      .label("Housekeeping explanation")
      .when("Housekeeping", { is: "Yes", then: Joi.required() }),
    Transportation: Joi.string()
      .label("Transportation")
      .when("ADLNA", { is: false, then: Joi.required() }),
    TransportationDetails: Joi.string()
      .label("Transportation details")
      .when("Transportation", { is: "Yes", then: Joi.required() }),
    SafetySkills: Joi.string()
      .label("Emergency skills")
      .when("ADLNA", { is: false, then: Joi.required() }),
    SafetySkillsDetails: Joi.string()
      .label("Emergency skills explanation")
      .when("SafetySkills", { is: "Yes", then: Joi.required() }),
    ResourceKnowledge: Joi.string()
      .label("Resource knowledge")
      .when("ADLNA", { is: false, then: Joi.required() }),
    ResourceKnowledgeDetails: Joi.string()
      .label("Resource knowledge explanation")
      .when("ResourceKnowledge", { is: "Yes", then: Joi.required() }),
    TimeManagement: Joi.string()
      .label("Time management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    TimeManagementDetails: Joi.string()
      .label("Time management explaination")
      .when("TimeManagement", { is: "Yes", then: Joi.required() }),
    Interaction: Joi.string()
      .label("Interactions")
      .when("ADLNA", { is: false, then: Joi.required() }),
    InteractionDetails: Joi.string()
      .label("Interactions explanation")
      .when("Interaction", { is: "Yes", then: Joi.required() }),
    RelationshipsNA: Joi.boolean(),
    CoopSkills: Joi.string()
      .label("Cooperative play skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    CoopSkillsDetails: Joi.string()
      .label("Cooperative play skills details")
      .when("CoopSkills", { is: "Regressed", then: Joi.required() })
      .when("CoopSkills", { is: "Advanced", then: Joi.required() }),
    CommunicationSkills: Joi.string()
      .label("Communication skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    CommunicationSkillsDetails: Joi.string()
      .label("Communication skills details")
      .when("CommunicationSkills", { is: "Regressed", then: Joi.required() })
      .when("CommunicationSkills", { is: "Advanced", then: Joi.required() }),
    EmotionalUnderstanding: Joi.string()
      .label("Emotional understanding")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    EmotionalUnderstandingDetails: Joi.string()
      .label("Emotional Understanding details")
      .when("EmotionalUnderstanding", { is: "Regressed", then: Joi.required() })
      .when("EmotionalUnderstanding", { is: "Advanced", then: Joi.required() }),
    ProblemSolving: Joi.string()
      .label("Problem-solving skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    ProblemSolvingDetails: Joi.string()
      .label("Problem Solving skills details")
      .when("ProblemSolving", { is: "Regressed", then: Joi.required() })
      .when("ProblemSolving", { is: "Advanced", then: Joi.required() }),
    ConflictResolution: Joi.string()
      .label("Conflict resolution skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    ConflictResolutionDetails: Joi.string()
      .label("Conflict Resolution skills details")
      .when("ConflictResolution", { is: "Regressed", then: Joi.required() })
      .when("ConflictResolution", { is: "Advanced", then: Joi.required() }),
    DecisionMakingSkills: Joi.string()
      .label("Decision making skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    DecisionMakingSkillsDetails: Joi.string()
      .label("Decision making skills details")
      .when("DecisionMakingSkills", { is: "Regressed", then: Joi.required() })
      .when("DecisionMakingSkills", { is: "Advanced", then: Joi.required() }),
    Bullied: Joi.string()
      .label("History of being bullied")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    BulliedDetails: Joi.string()
      .label("Bullied details")
      .when("Bullied", { is: "Yes", then: Joi.required() }),
    Bully: Joi.string()
      .label("History of bullying others")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    BullyDetails: Joi.string()
      .label("Bullying details")
      .when("Bully", { is: "Yes", then: Joi.required() }),
    LegalNA: Joi.boolean(),
    LegalInvolvement: Joi.string()
      .label("Legal involvement")
      .when("LegalNA", { is: false, then: Joi.required() }),
    LegalInvolvementDetails: Joi.string()
      .label("Legal involvement details")
      .when("LegalInvolvement", { is: "Yes", then: Joi.required() }),
    CPSInvolvement: Joi.string()
      .label("CPS involvement")
      .when("LegalNA", { is: false, then: Joi.required() }),
    CPSInvolvementDetails: Joi.string()
      .label("CPS involvement details")
      .when("CPSInvolvement", { is: "Yes", then: Joi.required() }),
    CPSCaseworker: Joi.string()
      .label("CPS Caseworker")
      .when("LegalNA", { is: false, then: Joi.required() }),
    CPSCaseworkerName: Joi.string()
      .label("CPS Caseworker name")
      .when("CPSCaseworker", { is: "Yes", then: Joi.required() }),
    ProbationOfficer: Joi.string()
      .label("Probation/Parole Officer")
      .when("LegalNA", { is: false, then: Joi.required() }),
    ProbationOfficerName: Joi.string()
      .label("Probation/Parole Officer name")
      .when("ProbationOfficer", { is: "Yes", then: Joi.required() }),
    GALCASA: Joi.string()
      .label("GAL/CASA")
      .when("LegalNA", { is: false, then: Joi.required() }),
    GALCASAName: Joi.string()
      .label("GAL/CASA name")
      .when("GALCASA", { is: "Yes", then: Joi.required() }),
    OtherLegalDetails: Joi.string().allow(""),
    PCP: Joi.string()
      .label("Primary Care Physician")
      .when("PCPPhoneUnknown", { is: false, then: Joi.required() }),
    PCPPhone: Joi.string()
      .label("PCP Phone")
      .when("PCPPhoneUnknown", { is: false, then: Joi.required() }),
    PCPPhoneUnknown: Joi.boolean(),
    LastMedicalExamDate: Joi.string()
      .required()
      .label("Date of last medical exam"),
    LastDentalExamDate: Joi.string()
      .required()
      .label("Date of last dental exam"),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.string()
      .label("Allergies list")
      .when("Allergies", { is: true, then: Joi.required() }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.string()
      .label("Medical conditions list")
      .when("MedicalConditions", { is: true, then: Joi.required() }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.string()
      .label("Nutritional concerns list")
      .when("NutritionalConcerns", { is: true, then: Joi.required() }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.string()
      .label("Dental concerns list")
      .when("DentalConcerns", { is: true, then: Joi.required() }),
    Undiagnosed: Joi.string().required().label("Potential undiagnosed illness"),
    UndiagnosedDetails: Joi.string()
      .label("Potential undiagnosed illness details")
      .when("Undiagnosed", { is: "Yes", then: Joi.required() }),
    NoMedications: Joi.boolean(),
    CurrentMedicationDetails: Joi.string()
      .label("Current medications")
      .when("NoMedications", { is: false, then: Joi.required() }),
    MedicationCompliance: Joi.string()
      .label("Compliance with medication")
      .when("NoMedications", { is: false, then: Joi.required() }),
    SideEffects: Joi.string()
      .label("Side effects")
      .when("NoMedications", { is: false, then: Joi.required() }),
    SideEffectsDetails: Joi.string()
      .label("Side effects details")
      .when("SideEffects", { is: "Yes", then: Joi.required() }),
    PsychotropicMeds: Joi.string()
      .required()
      .label("Past psychotropic medications"),
    PsychotropicMedsDetails: Joi.string()
      .label("Past psychotropic medications list")
      .when("PsychotropicMeds", { is: "Yes", then: Joi.required() }),
    MedicationComments: Joi.string().allow(""),
    SexualHistoryNA: Joi.boolean(),
    SexualOrientation: Joi.string()
      .label("Sexual Orientation")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexuallyActive: Joi.string()
      .label("Current or history of sexual behavior")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualBehavior: Joi.string()
      .label("Sexual behavior")
      .when("SexuallyActive", { is: "Yes", then: Joi.required() }),
    SexualAbuseExists: Joi.string()
      .label("Current or history of sexual abuse or perpetration")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualAbuse: Joi.string()
      .label("Sexual abuse or perpetration")
      .when("SexualAbuseExists", { is: "Yes", then: Joi.required() }),
    SexualRelationshipsEducation: Joi.string()
      .label("Sexual behavior/relationships education")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualRelationshipsEducationDetails: Joi.string()
      .label("Education details")
      .when("SexualRelationshipsEducation", {
        is: "Yes",
        then: Joi.required(),
      }),
    SexualHistoryComments: Joi.string()
      .label("Sexual history comments")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    PastMentalHealthTreatment: Joi.string()
      .label("Past mental health treatment")
      .required(),
    PastMentalHealthPlacement: Joi.string()
      .label("Past placement")
      .when("PastMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    PastMentalHealthPlacementDetails: Joi.string()
      .label("Past placement details")
      .when("PastMentalHealthPlacement", { is: "Yes", then: Joi.required() }),
    PastMentalHealthDiagnosis: Joi.string()
      .label("Previous mental health diagnosis")
      .when("PastMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    MentalHealthHistory: Joi.string()
      .label("MH placement history")
      .when("PastMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    PerspectiveOfTreatment: Joi.string()
      .label("Perspective of MH treatment")
      .when("PastMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    BriefMHSummary: Joi.string()
      .label("Brief Summary of SAFY Services")
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    SubstanceUseNA: Joi.boolean(),
    PastSubstanceUse: Joi.string()
      .label("History of past drug or alcohol use")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    SubstanceUseHistory: Joi.string()
      .label("Current drug or alcohol use")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    PerspectiveOfSubstanceUse: Joi.string()
      .label("Perception of substance use")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    SubstanceUseComments: Joi.string()
      .label("Substance use comments")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    NoPastTreatment: Joi.boolean(),
    SubstanceUseTreatmentHistory: Joi.string()
      .label("Alcohol/Drug Treatment History")
      .when("NoPastTreatment", { is: false, then: Joi.required() }),
    PerspectiveOfSubstanceUseTreatment: Joi.string()
      .label("Perspective of treatment")
      .when("NoPastTreatment", { is: false, then: Joi.required() }),
    SubstanceUseTreatmentComments: Joi.string()
      .label("Alcohol/Drug Treatment History Comments")
      .when("NoPastTreatment", { is: false, then: Joi.required() }),
    TraumaNA: Joi.boolean(),
    TraumaHistory: Joi.string()
      .label("Trauma History")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    DistressingMemories: Joi.boolean(),
    LossOfMemories: Joi.boolean(),
    Nightmares: Joi.boolean(),
    Flashbacks: Joi.boolean(),
    RepetitivePlayOfEvents: Joi.boolean(),
    Dissocation: Joi.boolean(),
    BlockOut: Joi.boolean(),
    Hyperarousal: Joi.boolean(),
    Avoidant: Joi.boolean(),
    Detachment: Joi.boolean(),
    PsychologicalDistress: Joi.boolean(),
    NegativeCognitions: Joi.boolean(),
    Hypervigilance: Joi.boolean(),
    SleepDisturbances: Joi.boolean(),
    DifficultyConcentratingSymptom: Joi.boolean(),
    EmotionalDysregulation: Joi.boolean(),
    DiminishedInterests: Joi.boolean(),
    SocialWithdrawalSymptom: Joi.boolean(),
    PhysiologicalResponses: Joi.boolean(),
    DevelopmentalRegression: Joi.boolean(),
    UnhealthyBoundaries: Joi.boolean(),
    NoSymptoms: Joi.boolean(),
    SocialSupports: Joi.boolean(),
    InterpersonalSkills: Joi.boolean(),
    ValidatingExperiences: Joi.boolean(),
    Adaptability: Joi.boolean(),
    SenseOfMastery: Joi.boolean(),
    PositiveOutlook: Joi.boolean(),
    Resources: Joi.boolean(),
    SecureAttachments: Joi.boolean(),
    CaregiverStability: Joi.boolean(),
    PlacementStability: Joi.boolean(),
    TiesToExtendedFamily: Joi.boolean(),
    StrongCulturalIdentity: Joi.boolean(),
    StrongSpiritualBeliefs: Joi.boolean(),
    Resilience: Joi.boolean(),
    Pets: Joi.boolean(),
    NoTraumaProtectiveFactors: Joi.boolean(),
    CopingStrategies: Joi.string()
      .label("Coping strategies")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    TraumaSummary: Joi.string()
      .label("Trauma Impact Summary")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    AppropriateAppearance: Joi.boolean(),
    Neat: Joi.boolean(),
    Disheveled: Joi.boolean(),
    BizarreAppearance: Joi.boolean(),
    OtherAppearance: Joi.boolean(),
    OtherAppearanceDetails: Joi.string()
      .label("Other Appearance Comments")
      .when("OtherAppearance", { is: true, then: Joi.required() }),
    Cooperative: Joi.boolean(),
    Guarded: Joi.boolean(),
    Hyperactive: Joi.boolean(),
    Agitated: Joi.boolean(),
    Paranoid: Joi.boolean(),
    Tics: Joi.boolean(),
    Impulsive: Joi.boolean(),
    Aggressive: Joi.boolean(),
    Withdrawn: Joi.boolean(),
    BizarreBehavior: Joi.boolean(),
    Rigidity: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.string()
      .label("Other Behavior Comments")
      .when("OtherBehavior", { is: true, then: Joi.required() }),
    Normal: Joi.boolean(),
    Slurred: Joi.boolean(),
    Pressured: Joi.boolean(),
    Tangential: Joi.boolean(),
    Incoherent: Joi.boolean(),
    Stutters: Joi.boolean(),
    OtherSpeech: Joi.boolean(),
    OtherSpeechDetails: Joi.string()
      .label("Other Speech Comments")
      .when("OtherSpeech", { is: true, then: Joi.required() }),
    Euthymic: Joi.boolean(),
    Anxious: Joi.boolean(),
    Angry: Joi.boolean(),
    Depressed: Joi.boolean(),
    Euphoric: Joi.boolean(),
    Irritable: Joi.boolean(),
    Fearful: Joi.boolean(),
    OtherMood: Joi.boolean(),
    OtherMoodDetails: Joi.string()
      .label("Other Mood Comments")
      .when("OtherMood", { is: true, then: Joi.required() }),
    FullRange: Joi.boolean(),
    Restricted: Joi.boolean(),
    Blunted: Joi.boolean(),
    Flat: Joi.boolean(),
    Inappropriate: Joi.boolean(),
    OtherAffect: Joi.boolean(),
    OtherAffectDetails: Joi.string()
      .label("Other Affect Comments")
      .when("OtherAffect", { is: true, then: Joi.required() }),
    Logical: Joi.boolean(),
    Preoccupations: Joi.boolean(),
    Delusions: Joi.boolean(),
    Hallucinations: Joi.boolean(),
    Racing: Joi.boolean(),
    Disorganized: Joi.boolean(),
    Concrete: Joi.boolean(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    OtherPerception: Joi.boolean(),
    OtherPerceptionDetails: Joi.string()
      .label("Other Perception Comments")
      .when("OtherPerception", { is: true, then: Joi.required() }),
    NoImpairment: Joi.boolean(),
    ShortAttentionSpan: Joi.boolean(),
    DifficultyConcentrating: Joi.boolean(),
    Distractibility: Joi.boolean(),
    MemoryImpairment: Joi.boolean(),
    LowIntelligence: Joi.boolean(),
    OtherCognition: Joi.boolean(),
    OtherCognitionDetails: Joi.string()
      .label("Other Cognition Comments")
      .when("OtherCognition", { is: true, then: Joi.required() }),
    AppropriateInsight: Joi.boolean(),
    Fair: Joi.boolean(),
    Impaired: Joi.boolean(),
    OtherInsight: Joi.boolean(),
    OtherInsightDetails: Joi.string()
      .label("Other Insight Comments")
      .when("OtherInsight", { is: true, then: Joi.required() }),
    MentalStatusComments: Joi.string()
      .required()
      .label("Mental Status Comments"),
    LethalityNA: Joi.boolean(),
    SelfAbusiveBehavior: Joi.string()
      .label("Self-abusive behavior")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SelfAbusiveBehaviorDetails: Joi.string()
      .label("Self-abusive behavior details")
      .when("SelfAbusiveBehavior", { is: "Current", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "Last 30 Days", then: Joi.required() })
      .when("SelfAbusiveBehavior", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("SelfAbusiveBehavior", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    SuicidalThreats: Joi.string()
      .label("Suicidal threats")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicidalThreatsDetails: Joi.string()
      .label("Suicidal threats details")
      .when("SuicidalThreats", { is: "Current", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicidalThreats", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    SuicideAttempt: Joi.string()
      .label("Suicide attempt")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicideAttemptDetails: Joi.string()
      .label("Suicide attempt details")
      .when("SuicideAttempt", { is: "Current", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicideAttempt", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    PriorAttempt: Joi.boolean(),
    AccessToMeans: Joi.boolean(),
    HealthCondition: Joi.boolean(),
    MentalHealthDisorder: Joi.boolean(),
    FamilyHistory: Joi.boolean(),
    Exposure: Joi.boolean(),
    ElevatingBeliefs: Joi.boolean(),
    OtherRiskFactors: Joi.boolean(),
    OtherRiskFactorsDetails: Joi.string()
      .label("Risk Factors")
      .when("OtherRiskFactors", { is: true, then: Joi.required() }),
    NoRiskFactors: Joi.boolean(),
    RiskFactorsComments: Joi.string()
      .label("Risk Factors Comments")
      .when("SelfAbusiveBehavior", { is: "Current", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "Last 30 Days", then: Joi.required() })
      .when("SelfAbusiveBehavior", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("SelfAbusiveBehavior", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicidalThreats", { is: "Current", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicidalThreats", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicideAttempt", { is: "Current", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicideAttempt", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ClinicalCare: Joi.boolean(),
    Connected: Joi.boolean(),
    Skills: Joi.boolean(),
    CaregiverContacts: Joi.boolean(),
    DiscouragingBeliefs: Joi.boolean(),
    NoSelfHarmProtectiveFactors: Joi.boolean(),
    ProtectiveFactorsComments: Joi.string()
      .label("Protective Factors Comments")
      .when("SelfAbusiveBehavior", { is: "Current", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "Last 30 Days", then: Joi.required() })
      .when("SelfAbusiveBehavior", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("SelfAbusiveBehavior", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicidalThreats", { is: "Current", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicidalThreats", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicideAttempt", { is: "Current", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicideAttempt", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    Threatening: Joi.boolean(),
    SeekingMeans: Joi.boolean(),
    Hopelessness: Joi.boolean(),
    IncreasedSubstanceUse: Joi.boolean(),
    DramaticMoodChanges: Joi.boolean(),
    GivingAwayPossessions: Joi.boolean(),
    SayingGoodbye: Joi.boolean(),
    SocialWithdrawal: Joi.boolean(),
    RecklessBehavior: Joi.boolean(),
    Feelings: Joi.boolean(),
    NoWarningSigns: Joi.boolean(),
    WarningSignsComments: Joi.string()
      .label("Current Warning Signs Comments")
      .when("SelfAbusiveBehavior", { is: "Current", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "Last 30 Days", then: Joi.required() })
      .when("SelfAbusiveBehavior", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("SelfAbusiveBehavior", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicidalThreats", { is: "Current", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicidalThreats", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicideAttempt", { is: "Current", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicideAttempt", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    CaregiverConcernsOfSelfHarm: Joi.string()
      .label("Caregiver concerns of self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherConcernsOfSelfHarm: Joi.string()
      .label("Other concerns of self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SelfHarmSafetyPlanStatus: Joi.string()
      .label("Self-harm safety plan status")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentSelfHarmRisk: Joi.string()
      .label("Current Risk of Harm to Self")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentSelfHarmRiskComments: Joi.string()
      .label("Current Risk of Harm to Self Comments")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThreatsToHarmOthers: Joi.string()
      .label("Threats to harm others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThreatsToHarmOthersDetails: Joi.string()
      .label("Threats to harm others details")
      .when("ThreatsToHarmOthers", { is: "Current", then: Joi.required() })
      .when("ThreatsToHarmOthers", { is: "Last 30 Days", then: Joi.required() })
      .when("ThreatsToHarmOthers", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("ThreatsToHarmOthers", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ThoughtsOfHarm: Joi.string()
      .label("Thoughts of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThoughtsOfHarmDetails: Joi.string()
      .label("Thoughts of harming others details")
      .when("ThoughtsOfHarm", { is: "Current", then: Joi.required() })
      .when("ThoughtsOfHarm", { is: "Last 30 Days", then: Joi.required() })
      .when("ThoughtsOfHarm", { is: "Last 6 Months", then: Joi.required() })
      .when("ThoughtsOfHarm", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ActsOfHarm: Joi.string()
      .label("Acts of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarmDetails: Joi.string()
      .label("Acts of harming others details")
      .when("ActsOfHarm", { is: "Current", then: Joi.required() })
      .when("ActsOfHarm", { is: "Last 30 Days", then: Joi.required() })
      .when("ActsOfHarm", { is: "Last 6 Months", then: Joi.required() })
      .when("ActsOfHarm", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ActsOfHarmAnimals: Joi.string()
      .label("Acts of harming animals")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarmAnimalsDetails: Joi.string()
      .label("Acts of harming animals details")
      .when("ActsOfHarmAnimals", { is: "Current", then: Joi.required() })
      .when("ActsOfHarmAnimals", { is: "Last 30 Days", then: Joi.required() })
      .when("ActsOfHarmAnimals", { is: "Last 6 Months", then: Joi.required() })
      .when("ActsOfHarmAnimals", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ActsInvolvingWeapons: Joi.string()
      .label("Acts involving weapons")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsInvolvingWeaponsDetails: Joi.string()
      .label("Acts involving weapons details")
      .when("ActsInvolvingWeapons", { is: "Current", then: Joi.required() })
      .when("ActsInvolvingWeapons", {
        is: "Last 30 Days",
        then: Joi.required(),
      })
      .when("ActsInvolvingWeapons", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("ActsInvolvingWeapons", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    CaregiverConcernOfOtherHarm: Joi.string()
      .label("Caregiver concerns of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherConcernsOfOtherHarm: Joi.string()
      .label("Other concerns of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherHarmSafetyPlanStatus: Joi.string()
      .label("Harm to others safey plan status")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentOtherHarmRisk: Joi.string()
      .label("Current Risk of Harm to Others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentOtherHarmRiskDetails: Joi.string()
      .label("Current Risk Comments")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OMHASNA: Joi.boolean(),
    AgeGroup: Joi.string()
      .label("Age group")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    IntoxWithdrawalLevel: Joi.string()
      .label("Acute Intoxication Withdrawal Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    BiomedicalConditionsLevel: Joi.string()
      .label("Biomedical Conditions/ Complications Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    CognitiveConditionsLevel: Joi.string()
      .label(
        "Emotional/ Behavioral/ Cognitive Conditions and/or Complications Level of Care"
      )
      .when("OMHASNA", { is: false, then: Joi.required() }),
    ReadinessToChangeLevel: Joi.string()
      .label("Readiness to Change Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    RelapsePotentialLevel: Joi.string()
      .label("Relapse Potential Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    RecoveryEnvironmentLevel: Joi.string()
      .label("Recovery Environment Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    LevelOfCareRecommendedLevel: Joi.string()
      .label("Level of Care Recommended")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    LevelOfCarePlacedLevel: Joi.string()
      .label("Level of Care Placed")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    NotPlacedReason: Joi.string().label("Not place reason"),
    NotPlacedReasonDetails: Joi.string()
      .label("Other reason details")
      .when("NotPlacedReason", { is: "OTHER", then: Joi.required() }),
    OMHASComments: Joi.string()
      .label("OMHAS Comments")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    ClinicalNarrativeSummary: Joi.string()
      .required()
      .label("Clinical Narrative Summary"),
    DiagnosisDetails: Joi.string().required().label("At least one Diagnosis"),
    SkillsTraining: Joi.boolean(),
    SymptomManagementSkills: Joi.boolean(),
    DecisionMaking: Joi.boolean(),
    FinancialSupport: Joi.boolean(),
    CommunitySupport: Joi.boolean(),
    Mentoring: Joi.boolean(),
    FamilySupport: Joi.boolean(),
    FosterFamilySupport: Joi.boolean(),
    Respite: Joi.boolean(),
    MedicationManagement: Joi.boolean(),
    MedicalDentalVision: Joi.boolean(),
    HealthyHabits: Joi.boolean(),
    EducationSchool: Joi.boolean(),
    Vocational: Joi.boolean(),
    Occupational: Joi.boolean(),
    ProsocialActivities: Joi.boolean(),
    CaseManagement: Joi.boolean(),
    SocialSkills: Joi.boolean(),
    TreatmentNeedsComments: Joi.string()
      .required()
      .label("Assessed Needs Comments"),
    TreatmentRecommendations: Joi.string()
      .required()
      .label("At least one Treatment Recommendation"),
    MorePsychiatric: Joi.boolean(),
    MorePsychological: Joi.boolean(),
    MoreNeurological: Joi.boolean(),
    MoreEducational: Joi.boolean(),
    MoreMedical: Joi.boolean(),
    MoreDental: Joi.boolean(),
    MoreSubstanceUse: Joi.boolean(),
    MoreVocational: Joi.boolean(),
    MoreOccupational: Joi.boolean(),
    MoreVisualAuditory: Joi.boolean(),
    MoreNutritional: Joi.boolean(),
    MoreOther: Joi.boolean(),
    MoreOtherDetails: Joi.string()
      .label("Other Further Evaluation Needs details")
      .when("MoreOther", { is: true, then: Joi.required() }),
    DiagnosisEducation: Joi.string().required().label("Diagnosis education"),
    RecommendationEducation: Joi.string()
      .required()
      .label("Recommendation education"),
    ClientAgrees: Joi.string().required().label("Client in agreement"),
    FamilyAgress: Joi.string().required().label("Family in agreement"),
    SexAssignedAtBirth: Joi.string().label("Sex Assigned at Birth").required(),
    SexAssignedAtBirthDetails: Joi.string()
      .label("Sex Assigned at Birth Specifics")
      .when("SexAssignedAtBirth", {
        is: "Sex not listed",
        then: Joi.required(),
      }),
    Pronouns: Joi.string().label("Pronouns").required(),
    PronounsDescription: Joi.string()
      .label("Pronouns description")
      .when("Pronouns", {
        is: "Prefer to self-describe",
        then: Joi.required(),
      }),
    GenderIdentity: Joi.string().label("Gender Identity").required(),
    GenderIdentityDescription: Joi.string()
      .label("Gender Identity description")
      .when("GenderIdentity", {
        is: "Identity not listed",
        then: Joi.required(),
      }),
    SexualOrientationDetails: Joi.string()
      .label("Sexual Orientation specifics")
      .when("SexualOrientation", {
        is: "Orientation not listed",
        then: Joi.required(),
      }),
    TraumaSymptoms: Joi.boolean(),
    TraumaticExposure: Joi.boolean(),
    AvoidantTrauma: Joi.boolean(),
    HypervigilanceTrauma: Joi.boolean(),
    IntrusiveDreams: Joi.boolean(),
    NegativeThoughts: Joi.boolean(),
    CocentrationProblems: Joi.boolean(),
    RecklessBehaviorTrauma: Joi.boolean(),
    SleepDisturbancesTrauma: Joi.boolean(),
    OtherTrauma: Joi.boolean(),
    OtherTraumaDetails: Joi.string()
      .label("Other Trauma Symptom Details")
      .when("OtherTrauma", { is: true, then: Joi.required() }),
    TraumaSymptomsFrequency: Joi.string()
      .label("Trauma Symptoms Frequency")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsIntensity: Joi.string()
      .label("Trauma Symptoms Intensity")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsDuration: Joi.string()
      .label("Trauma Symptoms Duration")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsOnset: Joi.string()
      .label("Trauma Symptoms Onset")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    AnxietyDisorder: Joi.boolean(),
    AnxietyDisorderExcessWorry: Joi.boolean(),
    AnxietyDisorderEasilyFatigued: Joi.boolean(),
    MuscleTension: Joi.boolean(),
    Overworried: Joi.boolean(),
    AnxietyDisorderDifficultyConcentrating: Joi.boolean(),
    SleepDisturbancesAnxiety: Joi.boolean(),
    RestlessAnxiety: Joi.boolean(),
    Irritability: Joi.boolean(),
    OtherAnxiety: Joi.boolean(),
    OtherAnxietyDetails: Joi.string()
      .label("Other Anxiety Details")
      .when("OtherAnxiety", { is: true, then: Joi.required() }),
    AnxietyDisorderFrequency: Joi.string()
      .label("Anxiety Frequency")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    AnxietyDisorderIntensity: Joi.string()
      .label("Anxiety Intensity")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    AnxietyDisorderDuration: Joi.string()
      .label("Anxiety Duration")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    DepressionSymptoms: Joi.boolean(),
    DepressedMood: Joi.boolean(),
    SleepChanges: Joi.boolean(),
    Guilt: Joi.boolean(),
    DiminishedInterest: Joi.boolean(),
    PurposelessMovement: Joi.boolean(),
    DifficultyConcentratingDepression: Joi.boolean(),
    WeightChanges: Joi.boolean(),
    FatigueDepression: Joi.boolean(),
    ThoughtsOfDeath: Joi.boolean(),
    OtherDepression: Joi.boolean(),
    OtherDepressionDetails: Joi.string()
      .label("Other Depression Details")
      .when("OtherDepression", { is: true, then: Joi.required() }),
    DepressionFrequency: Joi.string()
      .label("Depression Frequency")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    DepressionIntensity: Joi.string()
      .label("Depression Intensity")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    DepressionDuration: Joi.string()
      .label("Depression Duration")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    AttentionHyperactivity: Joi.boolean(),
    AttentionHyperactivityEasilyDistracted: Joi.boolean(),
    DifficultyFollowThrough: Joi.boolean(),
    Forgetful: Joi.boolean(),
    DifficultyListening: Joi.boolean(),
    DisorganizedAttention: Joi.boolean(),
    Fidgety: Joi.boolean(),
    LackOfDetails: Joi.boolean(),
    LosesThings: Joi.boolean(),
    InterruptsOthers: Joi.boolean(),
    UnableToSitStill: Joi.boolean(),
    ExcessiveTalking: Joi.boolean(),
    DifficultyWaiting: Joi.boolean(),
    OtherAttention: Joi.boolean(),
    OtherAttentionDetails: Joi.string()
      .label("Other Attention Details")
      .when("OtherAttention", { is: true, then: Joi.required() }),
    AttentionHyperactivityFrequency: Joi.string()
      .label("Attention Frequency")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    AttentionHyperactivityIntensity: Joi.string()
      .label("Attention Intensity")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    AttentionHyperactivityDuration: Joi.string()
      .label("Attention Duration")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    SU: Joi.boolean(),
    PatternOfSubstanceUse: Joi.boolean(),
    DesiresCutDownUse: Joi.boolean(),
    TimeSpentObtaining: Joi.boolean(),
    Cravings: Joi.boolean(),
    FailureOfResponsibilities: Joi.boolean(),
    NegativeImpact: Joi.boolean(),
    AbandonsActivities: Joi.boolean(),
    Tolerance: Joi.boolean(),
    SUWithdrawal: Joi.boolean(),
    SUOther: Joi.boolean(),
    SUOtherDetails: Joi.string()
      .label("Other Substance Use Details")
      .when("SUOther", { is: true, then: Joi.required() }),
    SubstanceUseFrequency: Joi.string()
      .label("Substance Use Frequency")
      .when("SU", { is: true, then: Joi.required() }),
    SubstanceUseIntensity: Joi.string()
      .label("Substance Use Intensity")
      .when("SU", { is: true, then: Joi.required() }),
    SubstanceUseDuration: Joi.string()
      .label("Substance Use Duration")
      .when("SU", { is: true, then: Joi.required() }),
    DMDD: Joi.boolean(),
    Temper: Joi.boolean(),
    OutsideOutbursts: Joi.boolean(),
    FrequentOutbursts: Joi.boolean(),
    DMDDIrritable: Joi.boolean(),
    OutburstsAroundOthers: Joi.boolean(),
    DMDDOther: Joi.boolean(),
    DMDDOtherDetails: Joi.string()
      .label("Other Disruptive Mood Dysregulation Disorder Details")
      .when("DMDDOther", { is: true, then: Joi.required() }),
    DMDDFrequency: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Frequency")
      .when("DMDD", { is: true, then: Joi.required() }),
    DMDDIntensity: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Intensity")
      .when("DMDD", { is: true, then: Joi.required() }),
    DMDDDuration: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Duration")
      .when("DMDD", { is: true, then: Joi.required() }),
    ConductDisorder: Joi.boolean(),
    Aggression: Joi.boolean(),
    DestructionOfProperty: Joi.boolean(),
    Theft: Joi.boolean(),
    SeriousViolations: Joi.boolean(),
    OtherConductDisorder: Joi.boolean(),
    OtherConductDisorderDetails: Joi.string()
      .label("Other Conduct Disorder Details")
      .when("OtherConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderFrequency: Joi.string()
      .label("Conduct Disorder Frequency")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderIntensity: Joi.string()
      .label("Conduct Disorder Intensity")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderDuration: Joi.string()
      .label("Conduct Disorder Duration")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ODD: Joi.boolean(),
    IrritableODD: Joi.boolean(),
    Argumentative: Joi.boolean(),
    Vindictive: Joi.boolean(),
    OtherODD: Joi.boolean(),
    OtherODDDetails: Joi.string()
      .label("Other Oppositional Defiance Disorder Details")
      .when("OtherODD", { is: true, then: Joi.required() }),
    ODDFrequency: Joi.string()
      .label("Oppositional Defiance Disorder Frequency")
      .when("ODD", { is: true, then: Joi.required() }),
    ODDIntensity: Joi.string()
      .label("Oppositional Defiance Disorder Intensity")
      .when("ODD", { is: true, then: Joi.required() }),
    ODDDuration: Joi.string()
      .label("Oppositional Defiance Disorder Duration")
      .when("ODD", { is: true, then: Joi.required() }),
    OCD: Joi.boolean(),
    OCDPresence: Joi.boolean(),
    Obsessions: Joi.boolean(),
    TimeConsuming: Joi.boolean(),
    Compulsions: Joi.boolean(),
    ReduceAnxiety: Joi.boolean(),
    SuppressUrges: Joi.boolean(),
    OCDOther: Joi.boolean(),
    OCDOtherDetails: Joi.string()
      .label("Other Obsessive-Compulsive Disorder Details")
      .when("OCDOther", { is: true, then: Joi.required() }),
    OCDFrequency: Joi.string()
      .label("Obsessive-Compulsive Disorder Frequency")
      .when("OCD", { is: true, then: Joi.required() }),
    OCDIntensity: Joi.string()
      .label("Obsessive-Compulsive Disorder Intensity")
      .when("OCD", { is: true, then: Joi.required() }),
    OCDDuration: Joi.string()
      .label("Obsessive-Compulsive Disorder Duration")
      .when("OCD", { is: true, then: Joi.required() }),
    PanicDisorder: Joi.boolean(),
    PoundingHeart: Joi.boolean(),
    PanicDisorderSweating: Joi.boolean(),
    Trembling: Joi.boolean(),
    ShortnessOfBreath: Joi.boolean(),
    Choking: Joi.boolean(),
    ChestPain: Joi.boolean(),
    PanicDisorderNausea: Joi.boolean(),
    Dizzy: Joi.boolean(),
    Chills: Joi.boolean(),
    Derealization: Joi.boolean(),
    FearOfCrazy: Joi.boolean(),
    FearOfDying: Joi.boolean(),
    PanicDisorderOther: Joi.boolean(),
    PanicDisorderOtherDetails: Joi.string()
      .label("Other Panic Disorder Details")
      .when("PanicDisorderOther", { is: true, then: Joi.required() }),
    PanicDisorderFrequency: Joi.string()
      .label("Panic Disorder Frequency")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    PanicDisorderIntensity: Joi.string()
      .label("Panic Disorder Intensity")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    PanicDisorderDuration: Joi.string()
      .label("Panic Disorder Duration")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    Phobias: Joi.boolean(),
    PhobiasSpecificFear: Joi.boolean(),
    ImmediateFear: Joi.boolean(),
    PhobiasAvoidance: Joi.boolean(),
    FearExaggerated: Joi.boolean(),
    PhobiasOther: Joi.boolean(),
    PhobiasOtherDetails: Joi.string()
      .label("Other Phobia Details")
      .when("PhobiasOther", { is: true, then: Joi.required() }),
    PhobiasFrequency: Joi.string()
      .label("Phobia Frequency")
      .when("Phobias", { is: true, then: Joi.required() }),
    PhobiasIntensity: Joi.string()
      .label("Phobia Intensity")
      .when("Phobias", { is: true, then: Joi.required() }),
    PhobiasDuration: Joi.string()
      .label("Phobia Duration")
      .when("Phobias", { is: true, then: Joi.required() }),
    DI: Joi.boolean(),
    DILowIQ: Joi.boolean(),
    DISensoryImpairments: Joi.boolean(),
    DISpeechDelays: Joi.boolean(),
    DIMotorCoordinationDelays: Joi.boolean(),
    DILearningDisorder: Joi.boolean(),
    DISpatialDelays: Joi.boolean(),
    DevelopmentalImpairmentsOther: Joi.boolean(),
    DevelopmentalImpairmentsOtherDetails: Joi.string()
      .label("Other Developmental Impairments Details")
      .when("DevelopmentalImpairmentsOther", {
        is: true,
        then: Joi.required(),
      }),
    DevelopmentalImpairmentsDetails: Joi.string()
      .label("Developmental Impairments Description")
      .when("DILowIQ", { is: true, then: Joi.required() })
      .when("DISensoryImpairments", { is: true, then: Joi.required() })
      .when("DISpeechDelays", { is: true, then: Joi.required() })
      .when("DIMotorCoordinationDelays", { is: true, then: Joi.required() })
      .when("DILearningDisorder", { is: true, then: Joi.required() })
      .when("DISpatialDelays", { is: true, then: Joi.required() })
      .when("DevelopmentalImpairments", { is: true, then: Joi.required() }),
    OtherSymptoms: Joi.boolean(),
    OtherSymptomsDetails: Joi.string()
      .label("Other Symptom Details")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsFrequency: Joi.string()
      .label("Other Symptoms Frequency")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsIntensity: Joi.string()
      .label("Other Symptoms Intensity")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsDuration: Joi.string()
      .label("Other Symptoms Duration")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),

    // DEPRECATED FIELDS
    Depression: Joi.boolean(),
    DepressionDetails: Joi.string()
      .label("Depression details")
      .when("Depression", { is: true, then: Joi.required() }),
    Mania: Joi.boolean(),
    ManiaDetails: Joi.string()
      .label("Mania details")
      .when("Mania", { is: true, then: Joi.required() }),
    BipolarDetails: Joi.string()
      .label("Bipolar details")
      .when("Bipolar", { is: true, then: Joi.required() }),
    ObsessiveCompulsive: Joi.boolean(),
    ObsessiveCompulsiveDetails: Joi.string()
      .label("Obsessive Compulsive details")
      .when("ObsessiveCompulsive", { is: true, then: Joi.required() }),
    Psychosis: Joi.boolean(),
    PsychosisDetails: Joi.string()
      .label("Psychosis details")
      .when("Psychosis", { is: true, then: Joi.required() }),
    PTSD: Joi.boolean(),
    PTSDDetails: Joi.string()
      .label("PTSD details")
      .when("PTSD", { is: true, then: Joi.required() }),
    PanicAttacks: Joi.boolean(),
    PanicAttacksDetails: Joi.string()
      .label("Panic Attack details")
      .when("PanicAttacks", { is: true, then: Joi.required() }),
    Anxiety: Joi.boolean(),
    AnxietyDetails: Joi.string()
      .label("Anxiety details")
      .when("Anxiety", { is: true, then: Joi.required() }),
    Phobia: Joi.boolean(),
    PhobiaDetails: Joi.string()
      .label("Phobia details")
      .when("Phobia", { is: true, then: Joi.required() }),
    EatingDisorder: Joi.boolean(),
    EatingDisorderDetails: Joi.string()
      .label("Eating Disorder details")
      .when("EatingDisorder", { is: true, then: Joi.required() }),
    Elimination: Joi.boolean(),
    EliminationDetails: Joi.string()
      .label("Elimination details")
      .when("Elimination", { is: true, then: Joi.required() }),
    Conduct: Joi.boolean(),
    ConductDetails: Joi.string()
      .label("Conduct details")
      .when("Conduct", { is: true, then: Joi.required() }),
    Oppositional: Joi.boolean(),
    OppositionalDetails: Joi.string()
      .label("Oppositional Defiance details")
      .when("Oppositional", { is: true, then: Joi.required() }),
    Attention: Joi.boolean(),
    AttentionDetails: Joi.string()
      .label("Attention details")
      .when("Attention", { is: true, then: Joi.required() }),
    Adjustment: Joi.boolean(),
    AdjustmentDetails: Joi.string()
      .label("Adjustment details")
      .when("Adjustment", { is: true, then: Joi.required() }),
    Attachment: Joi.boolean(),
    AttachmentDetails: Joi.string()
      .label("Attachment details")
      .when("Attachment", { is: true, then: Joi.required() }),
    DevelopmentalImpairments: Joi.boolean(),
    SubstanceUse: Joi.boolean(),
    SubstanceUseDetails: Joi.string()
      .label("Substance Use details")
      .when("SubstanceUse", { is: true, then: Joi.required() }),
    OtherSymptom: Joi.boolean(),
    OtherSymptomDetails: Joi.string()
      .label("Other symptom details")
      .when("OtherSymptom", { is: true, then: Joi.required() }),
  },
  "5785C3F1-52AC-EC11-A99B-0050F21C6F69": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    SexAssignedAtBirth: Joi.string().label("Sex Assigned at Birth").required(),
    SexAssignedAtBirthDetails: Joi.string()
      .label("Sex Assigned at Birth Specifics")
      .when("SexAssignedAtBirth", {
        is: "Sex not listed",
        then: Joi.required(),
      }),
    Pronouns: Joi.string().label("Pronouns").required(),
    PronounsDescription: Joi.string()
      .label("Pronouns description")
      .when("Pronouns", {
        is: "Prefer to self-describe",
        then: Joi.required(),
      }),
    GenderIdentity: Joi.string().label("Gender Identity").required(),
    GenderIdentityDescription: Joi.string()
      .label("Gender Identity description")
      .when("GenderIdentity", {
        is: "Identity not listed",
        then: Joi.required(),
      }),
    DateCompleted: Joi.string().required().label("Date Completed"),
    Division: Joi.string().required().label("Division"),
    PSDType: Joi.string().required().label("Type of PSD"),
    ReviewReason: Joi.string()
      .label("Reason")
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ChangeInDiagnosis: Joi.string()
      .label("Change in Diagnosis?")
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    HouseholdMembers: Joi.string().required().label("Household Members"),
    ISClient: Joi.boolean(),
    ISParent: Joi.boolean(),
    ISFamily: Joi.boolean(),
    ISGuardian: Joi.boolean(),
    ISCaregiver: Joi.boolean(),
    ISPhysician: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISCPS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.string().allow(""),
    ReasonForReferral: Joi.string().required().label("Reason for Referral"),
    PresentingProblem: Joi.string().required().label("Presenting Problem"),
    ClientStrengths: Joi.string().required().label("Client strengths"),
    Supports: Joi.string().required().label("Client/Caregiver supports"),
    CurrentPlacement: Joi.string().required().label("Current placement"),
    PlacementHistory: Joi.string().required().label("Placement History"),
    AdditionalAssessment: Joi.string()
      .required()
      .label("Additional assessment"),
    FamilyHistoryUnknown: Joi.boolean(),
    FamilyHistoryDetails: Joi.string()
      .label("Family History")
      .when("FamilyHistoryUnknown", { is: false, then: Joi.required() }),
    CurrentConcernsOfDV: Joi.boolean(),
    PastConcernsOfDV: Joi.boolean(),
    UnknownConcernsOfDV: Joi.boolean(),
    NoReportedConcernsOfDV: Joi.boolean(),
    ConcernsOfDVVictim: Joi.boolean(),
    ConcernsOfDVWitness: Joi.boolean(),
    CurrentMaritalConflict: Joi.boolean(),
    PastMaritalConflict: Joi.boolean(),
    UnknownMaritalConflict: Joi.boolean(),
    NoReportedMaritalConflict: Joi.boolean(),
    MaritalConflictVictim: Joi.boolean(),
    MaritalConflictWitness: Joi.boolean(),
    CaregiverCooperation: Joi.string()
      .required()
      .label("Caregivers cooperating"),
    SupervisionDifficulties: Joi.string()
      .required()
      .label("Supervision difficulties"),
    DisciplinePracticesEffective: Joi.boolean(),
    DisciplinePracticesInconsistent: Joi.boolean(),
    DisciplinePracticesIneffective: Joi.boolean(),
    DisciplinePracticesNA: Joi.boolean(),
    FamilyHistoryComments: Joi.string()
      .required()
      .label("Family history comments"),
    RaceEthnicity: Joi.string().required().label("Race and ethnicity"),
    PlacesLived: Joi.string().required().label("Places lived"),
    SocioeconomicStatus: Joi.string().required().label("Socioeconomic status"),
    Religion: Joi.string().required().label("Religious information"),
    Traditions: Joi.string().required().label("Cultural events"),
    TraditionsComments: Joi.string()
      .label("Cultural events comments")
      .when("Traditions", { is: "Yes", then: Joi.required() }),
    MedicalBeliefs: Joi.string()
      .required()
      .label("Beliefs affect health decisions?"),
    MedicalBeliefsComments: Joi.string()
      .label("Beliefs affecting health decisions")
      .when("MedicalBeliefs", { is: "Yes", then: Joi.required() }),
    PHNoProblems: Joi.boolean(),
    PHPrenatalCare: Joi.string()
      .label("Prenatal care")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHExposure: Joi.string().label("Prenatal exposure").when("PHNoProblems", {
      is: false,
      then: Joi.required(),
    }),
    PHTrauma: Joi.string().label("Prenatal trauma").when("PHNoProblems", {
      is: false,
      then: Joi.required(),
    }),
    PHComplications: Joi.string()
      .label("Birth complications")
      .when("PHNoProblems", {
        is: false,
        then: Joi.required(),
      }),
    PHConcerns: Joi.string().label("Medical concerns").when("PHNoProblems", {
      is: false,
      then: Joi.required(),
    }),
    PHComments: Joi.string().label("Medical comments").when("PHNoProblems", {
      is: false,
      then: Joi.required(),
    }),
    SpecialNeeds: Joi.string().label("Special needs").required(),
    SpecialNeedsDetails: Joi.string()
      .label("Special needs details")
      .when("SpecialNeeds", {
        is: "Yes",
        then: Joi.required(),
      }),
    SpecializedServices: Joi.string().label("Specialized services").required(),
    SpecializedServicesDetails: Joi.string()
      .label("Specialized services details")
      .when("SpecializedServices", {
        is: "Yes",
        then: Joi.required(),
      }),
    EducationStatus: Joi.string().required().label("Education status"),
    EducationDetails: Joi.string()
      .label("Education details")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      }),
    EmploymentNA: Joi.boolean(),
    EmploymentDetails: Joi.string()
      .label("Employment details")
      .when("EmploymentNA", { is: false, then: Joi.required() }),
    ADLNA: Joi.boolean(),
    MoneyManagement: Joi.string()
      .label("Money management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MoneyManagementDetails: Joi.string()
      .label("Money management explanation")
      .when("MoneyManagement", { is: "Yes", then: Joi.required() }),
    FoodManagement: Joi.string()
      .label("Food management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    FoodManagementDetails: Joi.string()
      .label("Food management explanation")
      .when("FoodManagement", { is: "Yes", then: Joi.required() }),
    Hygiene: Joi.string()
      .label("Hygiene")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HygieneDetails: Joi.string()
      .label("Hygiene explanation")
      .when("Hygiene", { is: "Yes", then: Joi.required() }),
    Health: Joi.string()
      .label("Health")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HealthDetails: Joi.string()
      .label("Health explanation")
      .when("Health", { is: "Yes", then: Joi.required() }),
    Housekeeping: Joi.string()
      .label("Housekeeping")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HousekeepingDetails: Joi.string()
      .label("Housekeeping explanation")
      .when("Housekeeping", { is: "Yes", then: Joi.required() }),
    Transportation: Joi.string()
      .label("Transportation")
      .when("ADLNA", { is: false, then: Joi.required() }),
    TransportationDetails: Joi.string()
      .label("Transportation details")
      .when("Transportation", { is: "Yes", then: Joi.required() }),
    SafetySkills: Joi.string()
      .label("Emergency skills")
      .when("ADLNA", { is: false, then: Joi.required() }),
    SafetySkillsDetails: Joi.string()
      .label("Emergency skills explanation")
      .when("SafetySkills", { is: "Yes", then: Joi.required() }),
    ResourceKnowledge: Joi.string()
      .label("Resource knowledge")
      .when("ADLNA", { is: false, then: Joi.required() }),
    ResourceKnowledgeDetails: Joi.string()
      .label("Resource knowledge explanation")
      .when("ResourceKnowledge", { is: "Yes", then: Joi.required() }),
    TimeManagement: Joi.string()
      .label("Time management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    TimeManagementDetails: Joi.string()
      .label("Time management explaination")
      .when("TimeManagement", { is: "Yes", then: Joi.required() }),
    Interaction: Joi.string()
      .label("Interactions")
      .when("ADLNA", { is: false, then: Joi.required() }),
    InteractionDetails: Joi.string()
      .label("Interactions explanation")
      .when("Interaction", { is: "Yes", then: Joi.required() }),
    ReasonForInvolvement: Joi.string()
      .label("Reason for involvement")
      .when("LegalNA", { is: false, then: Joi.required() }),
    LegalNA: Joi.boolean(),
    LegalInvolvementDetails: Joi.string()
      .label("Legal involvement details")
      .when("LegalNA", { is: false, then: Joi.required() }),
    PCP: Joi.string()
      .label("Primary Care Physician")
      .when("PCPPhoneUnknown", { is: false, then: Joi.required() }),
    PCPPhone: Joi.string()
      .label("PCP Phone")
      .when("PCPPhoneUnknown", { is: false, then: Joi.required() }),
    PCPPhoneUnknown: Joi.boolean(),
    LastMedicalExamDate: Joi.string()
      .required()
      .label("Date of last medical exam"),
    LastDentalExamDate: Joi.string()
      .required()
      .label("Date of last dental exam"),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.string()
      .label("Allergies list")
      .when("Allergies", { is: true, then: Joi.required() }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.string()
      .label("Medical conditions list")
      .when("MedicalConditions", { is: true, then: Joi.required() }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.string()
      .label("Nutritional concerns list")
      .when("NutritionalConcerns", { is: true, then: Joi.required() }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.string()
      .label("Dental concerns list")
      .when("DentalConcerns", { is: true, then: Joi.required() }),
    Undiagnosed: Joi.string().required().label("Potential undiagnosed illness"),
    UndiagnosedDetails: Joi.string()
      .label("Potential undiagnosed illness details")
      .when("Undiagnosed", { is: "Yes", then: Joi.required() }),
    MedicalComments: Joi.string().label("Medical comments").required(),
    NoMedications: Joi.boolean(),
    CurrentMedicationDetails: Joi.string()
      .label("Current medications")
      .when("NoMedications", { is: false, then: Joi.required() }),
    MedicationCompliance: Joi.string()
      .label("Compliance with medication")
      .when("NoMedications", { is: false, then: Joi.required() }),
    SideEffects: Joi.string()
      .label("Side effects")
      .when("NoMedications", { is: false, then: Joi.required() }),
    SideEffectsDetails: Joi.string()
      .label("Side effects details")
      .when("SideEffects", { is: "Yes", then: Joi.required() }),
    PsychotropicMeds: Joi.string()
      .required()
      .label("Past psychotropic medications"),
    PsychotropicMedsDetails: Joi.string()
      .label("Past psychotropic medications list")
      .when("PsychotropicMeds", { is: "Yes", then: Joi.required() }),
    MedicationComments: Joi.string().allow(""),
    SexualHistoryNA: Joi.boolean(),
    SexualOrientation: Joi.string()
      .label("Sexual Orientation")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualOrientationDetails: Joi.string()
      .label("Sexual Orientation specifics")
      .when("SexualOrientation", {
        is: "Orientation not listed",
        then: Joi.required(),
      }),
    SexualBehavior: Joi.string()
      .label("Sexual behavior")
      .when("SexuallyActive", { is: "Yes", then: Joi.required() }),
    SexualAbuse: Joi.string()
      .label("Sexual abuse or perpetration")
      .when("SexualAbuseExists", { is: "Yes", then: Joi.required() }),
    EverBeenPregnant: Joi.string()
      .label("Has the client ever been pregnant?")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualRelationshipsEducation: Joi.string()
      .label("Sexual behavior/relationships education")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualHistoryComments: Joi.string()
      .label("Sexual history comments")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    MentalHealthNA: Joi.boolean(),
    PastMentalHealthTreatment: Joi.string()
      .label("Past mental health treatment")
      .required(),
    PastMentalHealthPlacement: Joi.string()
      .label("Past placement")
      .when("PastMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    PastMentalHealthDiagnosis: Joi.string()
      .label("Previous mental health diagnosis")
      .when("PastMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    MentalHealthComments: Joi.string()
      .label("MH comments")
      .when("PastMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    MentalHealthHistory: Joi.string()
      .label("MH placement history")
      .when("PastMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    PerspectiveOfTreatment: Joi.string()
      .label("Perspective of MH treatment")
      .when("PastMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    SubstanceUseNA: Joi.boolean(),
    PastSubstanceUse: Joi.string()
      .label("History of past drug or alcohol use")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    SubstanceUseHistory: Joi.string()
      .label("Current drug or alcohol use")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    PerspectiveOfSubstanceUse: Joi.string()
      .label("Perception of substance use")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    SubstanceUseComments: Joi.string()
      .label("Substance use comments")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    NoPastTreatment: Joi.boolean(),
    SubstanceUseTreatmentHistory: Joi.string()
      .label("Alcohol/Drug Treatment History")
      .when("NoPastTreatment", { is: false, then: Joi.required() }),
    PerspectiveOfSubstanceUseTreatment: Joi.string()
      .label("Perspective of treatment")
      .when("NoPastTreatment", { is: false, then: Joi.required() }),
    SubstanceUseTreatmentComments: Joi.string()
      .label("Alcohol/Drug Treatment History Comments")
      .when("NoPastTreatment", { is: false, then: Joi.required() }),
    TraumaNA: Joi.boolean(),
    TraumaHistory: Joi.string()
      .label("Trauma History")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    DistressingMemories: Joi.boolean(),
    LossOfMemories: Joi.boolean(),
    Nightmares: Joi.boolean(),
    Flashbacks: Joi.boolean(),
    RepetitivePlayOfEvents: Joi.boolean(),
    Dissocation: Joi.boolean(),
    BlockOut: Joi.boolean(),
    Hyperarousal: Joi.boolean(),
    Avoidant: Joi.boolean(),
    Detachment: Joi.boolean(),
    PsychologicalDistress: Joi.boolean(),
    NegativeCognitions: Joi.boolean(),
    Hypervigilance: Joi.boolean(),
    SleepDisturbances: Joi.boolean(),
    DifficultyConcentratingSymptom: Joi.boolean(),
    EmotionalDysregulation: Joi.boolean(),
    DiminishedInterests: Joi.boolean(),
    SocialWithdrawalSymptom: Joi.boolean(),
    PhysiologicalResponses: Joi.boolean(),
    DevelopmentalRegression: Joi.boolean(),
    UnhealthyBoundaries: Joi.boolean(),
    NoSymptoms: Joi.boolean(),
    SocialSupports: Joi.boolean(),
    InterpersonalSkills: Joi.boolean(),
    ValidatingExperiences: Joi.boolean(),
    Adaptability: Joi.boolean(),
    SenseOfMastery: Joi.boolean(),
    PositiveOutlook: Joi.boolean(),
    Resources: Joi.boolean(),
    SecureAttachments: Joi.boolean(),
    CaregiverStability: Joi.boolean(),
    PlacementStability: Joi.boolean(),
    TiesToExtendedFamily: Joi.boolean(),
    StrongCulturalIdentity: Joi.boolean(),
    StrongSpiritualBeliefs: Joi.boolean(),
    Resilience: Joi.boolean(),
    Pets: Joi.boolean(),
    NoTraumaProtectiveFactors: Joi.boolean(),
    CopingStrategies: Joi.string()
      .label("Coping strategies")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    TraumaSummary: Joi.string()
      .label("Trauma Impact Summary")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    AppropriateAppearance: Joi.boolean(),
    Neat: Joi.boolean(),
    Disheveled: Joi.boolean(),
    BizarreAppearance: Joi.boolean(),
    OtherAppearance: Joi.boolean(),
    OtherAppearanceDetails: Joi.string()
      .label("Other Appearance Comments")
      .when("OtherAppearance", { is: true, then: Joi.required() }),
    Cooperative: Joi.boolean(),
    Guarded: Joi.boolean(),
    Hyperactive: Joi.boolean(),
    Agitated: Joi.boolean(),
    Paranoid: Joi.boolean(),
    Tics: Joi.boolean(),
    Impulsive: Joi.boolean(),
    Aggressive: Joi.boolean(),
    Withdrawn: Joi.boolean(),
    BizarreBehavior: Joi.boolean(),
    Rigidity: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.string()
      .label("Other Behavior Comments")
      .when("OtherBehavior", { is: true, then: Joi.required() }),
    Normal: Joi.boolean(),
    Slurred: Joi.boolean(),
    Pressured: Joi.boolean(),
    Tangential: Joi.boolean(),
    Incoherent: Joi.boolean(),
    Stutters: Joi.boolean(),
    OtherSpeech: Joi.boolean(),
    OtherSpeechDetails: Joi.string()
      .label("Other Speech Comments")
      .when("OtherSpeech", { is: true, then: Joi.required() }),
    Euthymic: Joi.boolean(),
    Anxious: Joi.boolean(),
    Angry: Joi.boolean(),
    Depressed: Joi.boolean(),
    Euphoric: Joi.boolean(),
    Irritable: Joi.boolean(),
    Fearful: Joi.boolean(),
    OtherMood: Joi.boolean(),
    OtherMoodDetails: Joi.string()
      .label("Other Mood Comments")
      .when("OtherMood", { is: true, then: Joi.required() }),
    FullRange: Joi.boolean(),
    Restricted: Joi.boolean(),
    Blunted: Joi.boolean(),
    Flat: Joi.boolean(),
    Inappropriate: Joi.boolean(),
    OtherAffect: Joi.boolean(),
    OtherAffectDetails: Joi.string()
      .label("Other Affect Comments")
      .when("OtherAffect", { is: true, then: Joi.required() }),
    Logical: Joi.boolean(),
    Preoccupations: Joi.boolean(),
    Delusions: Joi.boolean(),
    Hallucinations: Joi.boolean(),
    Racing: Joi.boolean(),
    Disorganized: Joi.boolean(),
    Concrete: Joi.boolean(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    OtherPerception: Joi.boolean(),
    OtherPerceptionDetails: Joi.string()
      .label("Other Perception Comments")
      .when("OtherPerception", { is: true, then: Joi.required() }),
    NoImpairment: Joi.boolean(),
    ShortAttentionSpan: Joi.boolean(),
    DifficultyConcentrating: Joi.boolean(),
    Distractibility: Joi.boolean(),
    MemoryImpairment: Joi.boolean(),
    LowIntelligence: Joi.boolean(),
    OtherCognition: Joi.boolean(),
    OtherCognitionDetails: Joi.string()
      .label("Other Cognition Comments")
      .when("OtherCognition", { is: true, then: Joi.required() }),
    AppropriateInsight: Joi.boolean(),
    Fair: Joi.boolean(),
    Impaired: Joi.boolean(),
    OtherInsight: Joi.boolean(),
    OtherInsightDetails: Joi.string()
      .label("Other Insight Comments")
      .when("OtherInsight", { is: true, then: Joi.required() }),
    MentalStatusComments: Joi.string()
      .required()
      .label("Mental Status Comments"),
    LethalityNA: Joi.boolean(),
    SelfAbusiveBehavior: Joi.string()
      .label("Self-abusive behavior")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SelfAbusiveBehaviorDetails: Joi.string()
      .label("Self-abusive behavior details")
      .when("SelfAbusiveBehavior", { is: "Current", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "Last 30 Days", then: Joi.required() })
      .when("SelfAbusiveBehavior", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("SelfAbusiveBehavior", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    SuicidalThreats: Joi.string()
      .label("Suicidal threats")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicidalThreatsDetails: Joi.string()
      .label("Suicidal threats details")
      .when("SuicidalThreats", { is: "Current", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicidalThreats", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    SuicideAttempt: Joi.string()
      .label("Suicide attempt")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicideAttemptDetails: Joi.string()
      .label("Suicide attempt details")
      .when("SuicideAttempt", { is: "Current", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicideAttempt", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    PriorAttempt: Joi.boolean(),
    AccessToMeans: Joi.boolean(),
    HealthCondition: Joi.boolean(),
    MentalHealthDisorder: Joi.boolean(),
    FamilyHistory: Joi.boolean(),
    Exposure: Joi.boolean(),
    ElevatingBeliefs: Joi.boolean(),
    OtherRiskFactors: Joi.boolean(),
    OtherRiskFactorsDetails: Joi.string()
      .label("Risk Factors")
      .when("OtherRiskFactors", { is: true, then: Joi.required() }),
    NoRiskFactors: Joi.boolean(),
    RiskFactorsComments: Joi.string()
      .label("Risk Factors Comments")
      .when("SelfAbusiveBehavior", { is: "Current", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "Last 30 Days", then: Joi.required() })
      .when("SelfAbusiveBehavior", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("SelfAbusiveBehavior", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicidalThreats", { is: "Current", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicidalThreats", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicideAttempt", { is: "Current", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicideAttempt", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ClinicalCare: Joi.boolean(),
    Connected: Joi.boolean(),
    Skills: Joi.boolean(),
    CaregiverContacts: Joi.boolean(),
    DiscouragingBeliefs: Joi.boolean(),
    NoSelfHarmProtectiveFactors: Joi.boolean(),
    ProtectiveFactorsComments: Joi.string()
      .label("Protective Factors Comments")
      .when("SelfAbusiveBehavior", { is: "Current", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "Last 30 Days", then: Joi.required() })
      .when("SelfAbusiveBehavior", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("SelfAbusiveBehavior", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicidalThreats", { is: "Current", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicidalThreats", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicideAttempt", { is: "Current", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicideAttempt", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    Threatening: Joi.boolean(),
    SeekingMeans: Joi.boolean(),
    Hopelessness: Joi.boolean(),
    IncreasedSubstanceUse: Joi.boolean(),
    DramaticMoodChanges: Joi.boolean(),
    GivingAwayPossessions: Joi.boolean(),
    SayingGoodbye: Joi.boolean(),
    SocialWithdrawal: Joi.boolean(),
    RecklessBehavior: Joi.boolean(),
    Feelings: Joi.boolean(),
    NoWarningSigns: Joi.boolean(),
    WarningSignsComments: Joi.string()
      .label("Current Warning Signs Comments")
      .when("SelfAbusiveBehavior", { is: "Current", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "Last 30 Days", then: Joi.required() })
      .when("SelfAbusiveBehavior", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("SelfAbusiveBehavior", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicidalThreats", { is: "Current", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicidalThreats", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicideAttempt", { is: "Current", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicideAttempt", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    CaregiverConcernsOfSelfHarm: Joi.string()
      .label("Caregiver concerns of self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherConcernsOfSelfHarm: Joi.string()
      .label("Other concerns of self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SelfHarmSafetyPlanStatus: Joi.string()
      .label("Self-harm safety plan status")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentSelfHarmRisk: Joi.string()
      .label("Current Risk of Harm to Self")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentSelfHarmRiskComments: Joi.string()
      .label("Current Risk of Harm to Self Comments")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThreatsToHarmOthers: Joi.string()
      .label("Threats to harm others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThreatsToHarmOthersDetails: Joi.string()
      .label("Threats to harm others details")
      .when("ThreatsToHarmOthers", { is: "Current", then: Joi.required() })
      .when("ThreatsToHarmOthers", { is: "Last 30 Days", then: Joi.required() })
      .when("ThreatsToHarmOthers", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("ThreatsToHarmOthers", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ThoughtsOfHarm: Joi.string()
      .label("Thoughts of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThoughtsOfHarmDetails: Joi.string()
      .label("Thoughts of harming others details")
      .when("ThoughtsOfHarm", { is: "Current", then: Joi.required() })
      .when("ThoughtsOfHarm", { is: "Last 30 Days", then: Joi.required() })
      .when("ThoughtsOfHarm", { is: "Last 6 Months", then: Joi.required() })
      .when("ThoughtsOfHarm", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ActsOfHarm: Joi.string()
      .label("Acts of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarmDetails: Joi.string()
      .label("Acts of harming others details")
      .when("ActsOfHarm", { is: "Current", then: Joi.required() })
      .when("ActsOfHarm", { is: "Last 30 Days", then: Joi.required() })
      .when("ActsOfHarm", { is: "Last 6 Months", then: Joi.required() })
      .when("ActsOfHarm", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ActsOfHarmAnimals: Joi.string()
      .label("Acts of harming animals")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarmAnimalsDetails: Joi.string()
      .label("Acts of harming animals details")
      .when("ActsOfHarmAnimals", { is: "Current", then: Joi.required() })
      .when("ActsOfHarmAnimals", { is: "Last 30 Days", then: Joi.required() })
      .when("ActsOfHarmAnimals", { is: "Last 6 Months", then: Joi.required() })
      .when("ActsOfHarmAnimals", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ActsInvolvingWeapons: Joi.string()
      .label("Acts involving weapons")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsInvolvingWeaponsDetails: Joi.string()
      .label("Acts involving weapons details")
      .when("ActsInvolvingWeapons", { is: "Current", then: Joi.required() })
      .when("ActsInvolvingWeapons", {
        is: "Last 30 Days",
        then: Joi.required(),
      })
      .when("ActsInvolvingWeapons", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("ActsInvolvingWeapons", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    CaregiverConcernOfOtherHarm: Joi.string()
      .label("Caregiver concerns of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherConcernsOfOtherHarm: Joi.string()
      .label("Other concerns of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherHarmSafetyPlanStatus: Joi.string()
      .label("Harm to others safey plan status")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentOtherHarmRisk: Joi.string()
      .label("Current Risk of Harm to Others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentOtherHarmRiskDetails: Joi.string()
      .label("Current Risk Comments")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    TraumaSymptoms: Joi.boolean(),
    TraumaticExposure: Joi.boolean(),
    AvoidantTrauma: Joi.boolean(),
    HypervigilanceTrauma: Joi.boolean(),
    IntrusiveDreams: Joi.boolean(),
    NegativeThoughts: Joi.boolean(),
    CocentrationProblems: Joi.boolean(),
    RecklessBehaviorTrauma: Joi.boolean(),
    SleepDisturbancesTrauma: Joi.boolean(),
    OtherTrauma: Joi.boolean(),
    OtherTraumaDetails: Joi.string()
      .label("Other Trauma Details")
      .when("OtherTrauma", { is: true, then: Joi.required() }),
    TraumaSymptomsFrequency: Joi.string()
      .label("Trauma Symptoms Frequency")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsIntensity: Joi.string()
      .label("Trauma Symptoms Intensity")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsDuration: Joi.string()
      .label("Trauma Symptoms Duration")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsOnset: Joi.string()
      .label("Trauma Symptoms Onset")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    AnxietyDisorder: Joi.boolean(),
    AnxietyDisorderExcessWorry: Joi.boolean(),
    AnxietyDisorderEasilyFatigued: Joi.boolean(),
    MuscleTension: Joi.boolean(),
    Overworried: Joi.boolean(),
    AnxietyDisorderDifficultyConcentrating: Joi.boolean(),
    SleepDisturbancesAnxiety: Joi.boolean(),
    RestlessAnxiety: Joi.boolean(),
    Irritability: Joi.boolean(),
    OtherAnxiety: Joi.boolean(),
    OtherAnxietyDetails: Joi.string()
      .label("Other Anxiety Details")
      .when("OtherAnxiety", { is: true, then: Joi.required() }),
    AnxietyDisorderFrequency: Joi.string()
      .label("Anxiety Frequency")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    AnxietyDisorderIntensity: Joi.string()
      .label("Anxiety Intensity")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    AnxietyDisorderDuration: Joi.string()
      .label("Anxiety Duration")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    DepressionSymptoms: Joi.boolean(),
    DepressedMood: Joi.boolean(),
    SleepChanges: Joi.boolean(),
    Guilt: Joi.boolean(),
    DiminishedInterest: Joi.boolean(),
    PurposelessMovement: Joi.boolean(),
    DifficultyConcentratingDepression: Joi.boolean(),
    WeightChanges: Joi.boolean(),
    FatigueDepression: Joi.boolean(),
    ThoughtsOfDeath: Joi.boolean(),
    OtherDepression: Joi.boolean(),
    OtherDepressionDetails: Joi.string()
      .label("Other Depression Details")
      .when("OtherDepression", { is: true, then: Joi.required() }),
    DepressionFrequency: Joi.string()
      .label("Depression Frequency")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    DepressionIntensity: Joi.string()
      .label("Depression Intensity")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    DepressionDuration: Joi.string()
      .label("Depression Duration")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    AttentionHyperactivity: Joi.boolean(),
    AttentionHyperactivityEasilyDistracted: Joi.boolean(),
    DifficultyFollowThrough: Joi.boolean(),
    Forgetful: Joi.boolean(),
    DifficultyListening: Joi.boolean(),
    DisorganizedAttention: Joi.boolean(),
    Fidgety: Joi.boolean(),
    LackOfDetails: Joi.boolean(),
    LosesThings: Joi.boolean(),
    InterruptsOthers: Joi.boolean(),
    UnableToSitStill: Joi.boolean(),
    ExcessiveTalking: Joi.boolean(),
    DifficultyWaiting: Joi.boolean(),
    OtherAttention: Joi.boolean(),
    OtherAttentionDetails: Joi.string()
      .label("Other Attention Details")
      .when("OtherAttention", { is: true, then: Joi.required() }),
    AttentionHyperactivityFrequency: Joi.string()
      .label("Attention Frequency")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    AttentionHyperactivityIntensity: Joi.string()
      .label("Attention Intensity")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    AttentionHyperactivityDuration: Joi.string()
      .label("Attention Duration")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    SU: Joi.boolean(),
    PatternOfSubstanceUse: Joi.boolean(),
    DesiresCutDownUse: Joi.boolean(),
    TimeSpentObtaining: Joi.boolean(),
    Cravings: Joi.boolean(),
    FailureOfResponsibilities: Joi.boolean(),
    NegativeImpact: Joi.boolean(),
    AbandonsActivities: Joi.boolean(),
    Tolerance: Joi.boolean(),
    SUWithdrawal: Joi.boolean(),
    SUOther: Joi.boolean(),
    SUOtherDetails: Joi.string()
      .label("Other Substance Use Details")
      .when("SUOther", { is: true, then: Joi.required() }),
    SubstanceUseFrequency: Joi.string()
      .label("Substance Use Frequency")
      .when("SU", { is: true, then: Joi.required() }),
    SubstanceUseIntensity: Joi.string()
      .label("Substance Use Intensity")
      .when("SU", { is: true, then: Joi.required() }),
    SubstanceUseDuration: Joi.string()
      .label("Substance Use Duration")
      .when("SU", { is: true, then: Joi.required() }),
    DMDD: Joi.boolean(),
    Temper: Joi.boolean(),
    OutsideOutbursts: Joi.boolean(),
    FrequentOutbursts: Joi.boolean(),
    DMDDIrritable: Joi.boolean(),
    OutburstsAroundOthers: Joi.boolean(),
    DMDDOther: Joi.boolean(),
    DMDDOtherDetails: Joi.string()
      .label("Other Disruptive Mood Dysregulation Disorder Details")
      .when("DMDDOther", { is: true, then: Joi.required() }),
    DMDDFrequency: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Frequency")
      .when("DMDD", { is: true, then: Joi.required() }),
    DMDDIntensity: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Intensity")
      .when("DMDD", { is: true, then: Joi.required() }),
    DMDDDuration: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Duration")
      .when("DMDD", { is: true, then: Joi.required() }),
    ConductDisorder: Joi.boolean(),
    Aggression: Joi.boolean(),
    DestructionOfProperty: Joi.boolean(),
    Theft: Joi.boolean(),
    SeriousViolations: Joi.boolean(),
    OtherConductDisorder: Joi.boolean(),
    OtherConductDisorderDetails: Joi.string()
      .label("Other Conduct Disorder Details")
      .when("OtherConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderFrequency: Joi.string()
      .label("Conduct Disorder Frequency")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderIntensity: Joi.string()
      .label("Conduct Disorder Intensity")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderDuration: Joi.string()
      .label("Conduct Disorder Duration")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ODD: Joi.boolean(),
    IrritableODD: Joi.boolean(),
    Argumentative: Joi.boolean(),
    Vindictive: Joi.boolean(),
    OtherODD: Joi.boolean(),
    OtherODDDetails: Joi.string()
      .label("Other Oppositional Defiance Disorder Details")
      .when("OtherODD", { is: true, then: Joi.required() }),
    ODDFrequency: Joi.string()
      .label("Oppositional Defiance Disorder Frequency")
      .when("ODD", { is: true, then: Joi.required() }),
    ODDIntensity: Joi.string()
      .label("Oppositional Defiance Disorder Intensity")
      .when("ODD", { is: true, then: Joi.required() }),
    ODDDuration: Joi.string()
      .label("Oppositional Defiance Disorder Duration")
      .when("ODD", { is: true, then: Joi.required() }),
    OCD: Joi.boolean(),
    OCDPresence: Joi.boolean(),
    Obsessions: Joi.boolean(),
    TimeConsuming: Joi.boolean(),
    Compulsions: Joi.boolean(),
    ReduceAnxiety: Joi.boolean(),
    SuppressUrges: Joi.boolean(),
    OCDOther: Joi.boolean(),
    OCDOtherDetails: Joi.string()
      .label("Other Obsessive-Compulsive Disorder Details")
      .when("OCDOther", { is: true, then: Joi.required() }),
    OCDFrequency: Joi.string()
      .label("Obsessive-Compulsive Disorder Frequency")
      .when("OCD", { is: true, then: Joi.required() }),
    OCDIntensity: Joi.string()
      .label("Obsessive-Compulsive Disorder Intensity")
      .when("OCD", { is: true, then: Joi.required() }),
    OCDDuration: Joi.string()
      .label("Obsessive-Compulsive Disorder Duration")
      .when("OCD", { is: true, then: Joi.required() }),
    PanicDisorder: Joi.boolean(),
    PoundingHeart: Joi.boolean(),
    PanicDisorderSweating: Joi.boolean(),
    Trembling: Joi.boolean(),
    ShortnessOfBreath: Joi.boolean(),
    Choking: Joi.boolean(),
    ChestPain: Joi.boolean(),
    PanicDisorderNausea: Joi.boolean(),
    Dizzy: Joi.boolean(),
    Chills: Joi.boolean(),
    Derealization: Joi.boolean(),
    FearOfCrazy: Joi.boolean(),
    FearOfDying: Joi.boolean(),
    PanicDisorderOther: Joi.boolean(),
    PanicDisorderOtherDetails: Joi.string()
      .label("Other Panic Disorder Details")
      .when("PanicDisorderOther", { is: true, then: Joi.required() }),
    PanicDisorderFrequency: Joi.string()
      .label("Panic Disorder Frequency")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    PanicDisorderIntensity: Joi.string()
      .label("Panic Disorder Intensity")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    PanicDisorderDuration: Joi.string()
      .label("Panic Disorder Duration")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    Phobias: Joi.boolean(),
    PhobiasSpecificFear: Joi.boolean(),
    ImmediateFear: Joi.boolean(),
    PhobiasAvoidance: Joi.boolean(),
    FearExaggerated: Joi.boolean(),
    PhobiasOther: Joi.boolean(),
    PhobiasOtherDetails: Joi.string()
      .label("Other Phobia Details")
      .when("PhobiasOther", { is: true, then: Joi.required() }),
    PhobiasFrequency: Joi.string()
      .label("Phobia Frequency")
      .when("Phobias", { is: true, then: Joi.required() }),
    PhobiasIntensity: Joi.string()
      .label("Phobia Intensity")
      .when("Phobias", { is: true, then: Joi.required() }),
    PhobiasDuration: Joi.string()
      .label("Phobia Duration")
      .when("Phobias", { is: true, then: Joi.required() }),
    DI: Joi.boolean(),
    DILowIQ: Joi.boolean(),
    DISensoryImpairments: Joi.boolean(),
    DISpeechDelays: Joi.boolean(),
    DIMotorCoordinationDelays: Joi.boolean(),
    DILearningDisorder: Joi.boolean(),
    DISpatialDelays: Joi.boolean(),
    DevelopmentalImpairmentsOther: Joi.boolean(),
    DevelopmentalImpairmentsOtherDetails: Joi.string()
      .label("Other Developmental Impairments Details")
      .when("DevelopmentalImpairmentsOther", {
        is: true,
        then: Joi.required(),
      }),
    DevelopmentalImpairmentsDetails: Joi.string()
      .label("Developmental Impairments Description")
      .when("DILowIQ", { is: true, then: Joi.required() })
      .when("DISensoryImpairments", { is: true, then: Joi.required() })
      .when("DISpeechDelays", { is: true, then: Joi.required() })
      .when("DIMotorCoordinationDelays", { is: true, then: Joi.required() })
      .when("DILearningDisorder", { is: true, then: Joi.required() })
      .when("DISpatialDelays", { is: true, then: Joi.required() }),
    OtherSymptoms: Joi.boolean(),
    OtherSymptomsDetails: Joi.string()
      .label("Other Symptom Details")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsFrequency: Joi.string()
      .label("Other Symptoms Frequency")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsIntensity: Joi.string()
      .label("Other Symptoms Intensity")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsDuration: Joi.string()
      .label("Other Symptoms Duration")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OMHASNA: Joi.boolean(),
    AgeGroup: Joi.string()
      .label("Age group")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    IntoxWithdrawalLevel: Joi.string()
      .label("Acute Intoxication Withdrawal Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    BiomedicalConditionsLevel: Joi.string()
      .label("Biomedical Conditions/ Complications Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    CognitiveConditionsLevel: Joi.string()
      .label(
        "Emotional/ Behavioral/ Cognitive Conditions and/or Complications Level of Care"
      )
      .when("OMHASNA", { is: false, then: Joi.required() }),
    ReadinessToChangeLevel: Joi.string()
      .label("Readiness to Change Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    RelapsePotentialLevel: Joi.string()
      .label("Relapse Potential Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    RecoveryEnvironmentLevel: Joi.string()
      .label("Recovery Environment Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    LevelOfCareRecommendedLevel: Joi.string()
      .label("Level of Care Recommended")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    LevelOfCarePlacedLevel: Joi.string()
      .label("Level of Care Placed")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    NotPlacedReason: Joi.string().label("Not place reason"),
    NotPlacedReasonDetails: Joi.string()
      .label("Other reason details")
      .when("NotPlacedReason", { is: "OTHER", then: Joi.required() }),
    OMHASComments: Joi.string()
      .label("OMHAS Comments")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    ClinicalNarrativeSummary: Joi.string()
      .required()
      .label("Clinical Narrative Summary"),
    DiagnosisDetails: Joi.string().required().label("At least one Diagnosis"),
    SkillsTraining: Joi.boolean(),
    SymptomManagementSkills: Joi.boolean(),
    DecisionMaking: Joi.boolean(),
    FinancialSupport: Joi.boolean(),
    CommunitySupport: Joi.boolean(),
    Mentoring: Joi.boolean(),
    FamilySupport: Joi.boolean(),
    FosterFamilySupport: Joi.boolean(),
    Respite: Joi.boolean(),
    MedicationManagement: Joi.boolean(),
    MedicalDentalVision: Joi.boolean(),
    HealthyHabits: Joi.boolean(),
    EducationSchool: Joi.boolean(),
    Vocational: Joi.boolean(),
    Occupational: Joi.boolean(),
    ProsocialActivities: Joi.boolean(),
    CaseManagement: Joi.boolean(),
    SocialSkills: Joi.boolean(),
    TreatmentNeedsComments: Joi.string()
      .required()
      .label("Assessed Needs Comments"),
    TreatmentRecommendations: Joi.string()
      .required()
      .label("At least one Treatment Recommendation"),
    MorePsychiatric: Joi.boolean(),
    MorePsychological: Joi.boolean(),
    MoreNeurological: Joi.boolean(),
    MoreEducational: Joi.boolean(),
    MoreMedical: Joi.boolean(),
    MoreDental: Joi.boolean(),
    MoreSubstanceUse: Joi.boolean(),
    MoreVocational: Joi.boolean(),
    MoreOccupational: Joi.boolean(),
    MoreVisualAuditory: Joi.boolean(),
    MoreNutritional: Joi.boolean(),
    MoreOther: Joi.boolean(),
    MoreOtherDetails: Joi.string()
      .label("Other Further Evaluation Needs details")
      .when("MoreOther", { is: true, then: Joi.required() }),
    DiagnosisEducation: Joi.string().required().label("Diagnosis education"),
    RecommendationEducation: Joi.string()
      .required()
      .label("Recommendation education"),
    ClientAgrees: Joi.string().required().label("Client in agreement"),
    FamilyAgress: Joi.string().required().label("Family in agreement"),
  },
  "F7CD2C5F-90AF-EC11-A99B-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    ReportDate: Joi.string().label("Report Date").required(),
    RaceSex: Joi.string().label("Race/Sex").required(),
    CaseNumber: Joi.string().label("Case #").required(),
    DateOpened: Joi.string().label("Date Opened").required(),
    DateOfInitial: Joi.string().label("Date of Initial TX Plan/ISP").required(),
    DateOf30Day: Joi.string().label("Date of 30 Day TX Plan").required(),
    DateOf90Day: Joi.string().label("Date of 90 Day TX Plan").required(),
    SocialWorker: Joi.string().label("Social Worker").required(),
    CaseCoordinator: Joi.string().label("SAFY Case Coordinator").required(),
    ContactWithFamilyDetails: Joi.string()
      .label("Number and nature of contact with family")
      .required(),
    ContactWithProvidersDetails: Joi.string()
      .label("Number and nature of contact with other providers")
      .required(),
    StepsTaken: Joi.string().label("Steps taken").required(),
    AdvocacyEfforts: Joi.string()
      .label("Referral or advocacy efforts")
      .required(),
    FamilySupport: Joi.string().label("Family support").required(),
  },
  "12E92B0C-8CAF-EC11-A99B-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DHRCounty: Joi.string().label("DHR County").required(),
    NotVaxxed: Joi.boolean(),
    VaxDetails: Joi.string().label("Vaccination details"),
    NotTested: Joi.boolean(),
    TestingDetails: Joi.string().label("Testing details"),
  },
  "2B09A1A7-FBB4-EC11-A99B-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateOfDischarge: Joi.string()
      .allow("")
      .required()
      .label("Date of Discharge"),
    DischargeReason: Joi.string()
      .allow("")
      .required()
      .label("Reason for discharge"),
    BriefExplanation: Joi.string()
      .allow("")
      .label("Brief Explanation")
      .when("DischargeReason", {
        is: "186460008",
        then: Joi.required(),
      })
      .when("DischargeReason", {
        is: "186460005",
        then: Joi.required(),
      })
      .when("DischargeReason", {
        is: "186460006",
        then: Joi.required(),
      }),
    OutpatientMentalHealth: Joi.boolean(),
    OutpatientMentalHealthReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("OutpatientMentalHealth", {
        is: true,
        then: Joi.required(),
      }),
    OutpatientSubstanceAbuse: Joi.string()
      .allow("")
      .label("Outpatient Alcohol/Substance Abuse"),
    OutpatientSubstanceAbuseReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("OutpatientSubstanceAbuse", {
        is: true,
        then: Joi.required(),
      }),
    HousingAssistance: Joi.boolean(),
    HousingAssistanceReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("HousingAssistance", {
        is: true,
        then: Joi.required(),
      }),
    JobTraining: Joi.boolean(),
    JobTrainingReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("JobTraining", {
        is: true,
        then: Joi.required(),
      }),
    EducationServices: Joi.boolean(),
    EducationServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("EducationServices", {
        is: true,
        then: Joi.required(),
      }),
    Tutoring: Joi.boolean(),
    TutoringReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("Tutoring", { is: true, then: Joi.required() }),
    PsychiatricAppointment: Joi.boolean(),
    PsychiatricAppointmentReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("PsychiatricAppointment", {
        is: true,
        then: Joi.required(),
      }),
    Prescriptions: Joi.boolean(),
    PrescriptionsReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("Prescriptions", {
        is: true,
        then: Joi.required(),
      }),
    MedicalServices: Joi.boolean(),
    MedicalServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("MedicalServices", {
        is: true,
        then: Joi.required(),
      }),
    Probation: Joi.boolean(),
    ProbationReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("Probation", {
        is: true,
        then: Joi.required(),
      }),
    LegalServices: Joi.boolean(),
    LegalServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("LegalServices", {
        is: true,
        then: Joi.required(),
      }),
    PhysicianAppointment: Joi.boolean(),
    PhysicianAppointmentReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("PhysicianAppointment", {
        is: true,
        then: Joi.required(),
      }),
    WelfareSupport: Joi.boolean(),
    WelfareSupportReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("WelfareSupport", {
        is: true,
        then: Joi.required(),
      }),
    FinancialSupport: Joi.boolean(),
    FinancialSupportReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("FinancialSupport", {
        is: true,
        then: Joi.required(),
      }),
    InHomeServices: Joi.boolean(),
    InHomeServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("InHomeServices", {
        is: true,
        then: Joi.required(),
      }),
    CaseManagement: Joi.boolean(),
    CaseManagementReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("CaseManagement", {
        is: true,
        then: Joi.required(),
      }),
    OtherServices: Joi.boolean(),
    OtherServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("OtherServices", {
        is: true,
        then: Joi.required(),
      }),
    LocalCrisisCenter: Joi.string()
      .allow("")
      .required()
      .label("Local Crisis Center"),
    LocalCrisisCenterDetails: Joi.string()
      .allow("")
      .required()
      .label("Local Crisis Center Details"),
    PlacementHistory: Joi.string()
      .allow("")
      .required()
      .label("Placement History"),
    Behavior: Joi.string().required().label("Behavior"),
    SocialInteraction: Joi.string()
      .allow("")
      .required()
      .label("Social and Peer Interaction"),
    ResponseToCaregivers: Joi.string()
      .allow("")
      .required()
      .label("Response to Caregives or Redirection"),
    SchoolInformation: Joi.string()
      .allow("")
      .required()
      .label("School Information and Participation"),
    AdditionalAccomplishments: Joi.string()
      .allow("")
      .required()
      .label("Additional Accomplishments"),
    FollowUp: Joi.string()
      .allow("")
      .required()
      .label("Follow-up/Scheduled Appointments"),
    CopingSkills: Joi.string().required().label("Coping Skills"),
    SelfRegulate: Joi.string().required().label("Self-regulate"),
    Boundaries: Joi.string().required().label("Boundaries"),
    SchoolAttendance: Joi.string()
      .allow("")
      .required()
      .label("School Attendance"),
    NewCharges: Joi.string().required().label("New Charges"),
    ReducedContact: Joi.string()
      .allow("")
      .required()
      .label("Reduced hospital or police contact"),
    NavigateCrisis: Joi.string().required().label("Navigate crisis"),
    Advocate: Joi.string().required().label("Advocate for needs"),
    PositiveSupports: Joi.string()
      .allow("")
      .required()
      .label("Positive supports"),
    DecreasedSubstanceAbuse: Joi.string()
      .allow("")
      .required()
      .label("Decreased Substance Abuse"),
    OtherOutcomes: Joi.string().allow("").label("Other Outcomes"),
    CGTrauma: Joi.string().required().label("Understanding trauma"),
    CGNavigateCrisis: Joi.string()
      .allow("")
      .required()
      .label("Navigate crisis"),
    CGAttuned: Joi.string()
      .allow("")
      .required()
      .label("Attuned to child's needs"),
    CGRegulated: Joi.string().required().label("Regulated"),
    CGAdvocate: Joi.string().required().label("Advocate for family"),
    CGSupports: Joi.string().required().label("Natural supports"),
    CGSelfCare: Joi.string().required().label("Self-care"),
    CGSkills: Joi.string().required().label("Problem-solving skills"),
    CGTraumaInformed: Joi.string()
      .allow("")
      .required()
      .label("Trauma-informed skills"),
    CGResources: Joi.string().required().label("Find resources"),
    CGOtherOutcomes: Joi.string().allow("").label("Other Outcomes"),
  },
  "C679FD0E-F6B1-EC11-A99B-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DaytimeRespiteDetails: Joi.string()
      .allow("")
      .label("Daytime Respite details")
      .required(),
    OvernightRespiteDetails: Joi.string()
      .allow("")
      .label("Overnight Respite details")
      .required(),
    TwoCaregivers: Joi.boolean(),
    CaregiverName: Joi.string().label("First caregiver's name"),
    Sad: Joi.boolean(),
    Discouraged: Joi.boolean(),
    Failure: Joi.boolean(),
    SleepDisturbances: Joi.boolean(),
    Forgetful: Joi.boolean(),
    Unproductive: Joi.boolean(),
    Tired: Joi.boolean(),
    Pain: Joi.boolean(),
    EatingHabits: Joi.boolean(),
    Guilt: Joi.boolean(),
    Irritable: Joi.boolean(),
    Startle: Joi.boolean(),
    ProblemTrouble: Joi.boolean(),
    LoseInterest: Joi.boolean(),
    OtherSign: Joi.boolean(),
    OtherSignDetails: Joi.string()
      .label("Other sign details")
      .when("OtherSign", { is: true, then: Joi.required() }),
    PhysicalCareDetails: Joi.string().label(
      "Physical health self-care details"
    ),
    MentalCareDetails: Joi.string().label(
      "Mind/mental health self-care details"
    ),
    EmotionalCareDetails: Joi.string().label(
      "Emotional health self-care details"
    ),
    SpiritualCareDetails: Joi.string().label(
      "Spiritual health self-care details"
    ),
    RelationshipCareDetails: Joi.string().label(
      "Relationship self-care details"
    ),
    RoleCareDetails: Joi.string().label("Caregiver role self-care details"),
    CaregiverName2: Joi.string().label("Second caregiver's name"),
    Sad2: Joi.boolean(),
    Discouraged2: Joi.boolean(),
    Failure2: Joi.boolean(),
    SleepDisturbances2: Joi.boolean(),
    Forgetful2: Joi.boolean(),
    Unproductive2: Joi.boolean(),
    Tired2: Joi.boolean(),
    Pain2: Joi.boolean(),
    EatingHabits2: Joi.boolean(),
    Guilt2: Joi.boolean(),
    Irritable2: Joi.boolean(),
    Startle2: Joi.boolean(),
    ProblemTrouble2: Joi.boolean(),
    LoseInterest2: Joi.boolean(),
    OtherSign2: Joi.boolean(),
    OtherSignDetails2: Joi.string().label("Other sign details"),
    PhysicalCareDetails2: Joi.string().label(
      "Physical health self-care details"
    ),
    MentalCareDetails2: Joi.string().label(
      "Mind/mental health self-care details"
    ),
    EmotionalCareDetails2: Joi.string().label(
      "Emotional health self-care details"
    ),
    SpiritualCareDetails2: Joi.string().label(
      "Spiritual health self-care details"
    ),
    RelationshipCareDetails2: Joi.string().label(
      "Relationship self-care details"
    ),
    RoleCareDetails2: Joi.string().label("Caregiver role self-care details"),
  },
  "E25086F7-BAB5-EC11-A99B-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    PreferredName: Joi.string().label("Client's Preferred Name").required(),
    Pronouns: Joi.string().label("Client's Pronouns").required(),
    CaregiverNA: Joi.boolean(),
    CaregiverName: Joi.string()
      .label("Caregiver's Legal Name")
      .when("CaregiverNA", { is: false, then: Joi.required() }),
    CaregiverPreferredName: Joi.string()
      .label("Caregiver's Preferred Name")
      .when("CaregiverNA", { is: false, then: Joi.required() }),
    CaregiverDOB: Joi.string()
      .label("Caregiver's Date of Birth")
      .when("CaregiverNA", { is: false, then: Joi.required() }),
    CaregiverPronouns: Joi.string()
      .label("Caregiver's Pronouns")
      .when("CaregiverNA", { is: false, then: Joi.required() }),
    Involved: Joi.string().label("People involved in treatment").required(),
    ClientGoals: Joi.string().label("Client stated goals").required(),
    ClientMotivation: Joi.string().label("Client stated motivation").required(),
    StagesOfChange: Joi.string().label("Stages of Change").required(),
    PreviousRecurrence: Joi.boolean(),
    SubstanceUse: Joi.boolean(),
    PsychoticBehaviors: Joi.boolean(),
    ActiveSIHI: Joi.boolean(),
    OtherBehaviors: Joi.boolean(),
    OtherBehaviorsDetails: Joi.string()
      .label("Other behaviors explanation")
      .when("OtherBehaviors", { is: true, then: Joi.required() }),
    MeetConsistently: Joi.string()
      .label("Client willing to meet consistently")
      .required(),
    AdditionInformation: Joi.string()
      .label("Additional Information")
      .required(),
    GoalSupport: Joi.boolean(),
    OtherSupports: Joi.string().label("Other possible supports").required(),
  },
  "53A6D412-DCB5-EC11-A99B-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    ExcessWorrying: Joi.boolean(),
    Sleeping: Joi.boolean(),
    EatingHabits: Joi.boolean(),
    Depression: Joi.boolean(),
    Adjustment: Joi.boolean(),
    Anger: Joi.boolean(),
    Aggression: Joi.boolean(),
    Fear: Joi.boolean(),
    Listening: Joi.boolean(),
    Irritability: Joi.boolean(),
    Focus: Joi.boolean(),
    PanicAttacks: Joi.boolean(),
    OtherSymptom: Joi.boolean(),
    OtherSymptomDetails: Joi.string()
      .label("Other Symptom details")
      .when("OtherSymptom", { is: true, then: Joi.required() }),
    InterimDx: Joi.string().label("Interim diagnosis and code").required(),
    InterimDxOtherDetails: Joi.string()
      .label("Other diagnosis details")
      .when("InterimDx", { is: "Other", then: Joi.required() }),
  },
  "E953DA2C-03BC-EC11-997E-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    CoachName: Joi.string().required().label("Coach Name"),
    FosterHomeName: Joi.string().required().label("Foster Home Name"),
    Agency: Joi.string().required().label("Agency"),
    DateOfSession: Joi.string()
      .allow("")
      .required()
      .label("Date of Coaching Session"),
    FollowsDirections: Joi.boolean(),
    CompletesHomework: Joi.boolean(),
    FollowsRules: Joi.boolean(),
    GoodHygiene: Joi.boolean(),
    AppropriateTone: Joi.boolean(),
    TellsTruth: Joi.boolean(),
    PerformsWell: Joi.boolean(),
    RespectsProperty: Joi.boolean(),
    CompletesChores: Joi.boolean(),
    RespectsBoundaries: Joi.boolean(),
    ExpressesFeelings: Joi.boolean(),
    OtherPositive: Joi.boolean(),
    OtherPositiveDetails: Joi.string().allow(""),
    VerbalPraise: Joi.boolean(),
    NonVerbalPraise: Joi.boolean(),
    ReminderOfReward: Joi.boolean(),
    BehaviorContract: Joi.boolean(),
    NaturalConsequence: Joi.boolean(),
    Reward: Joi.boolean(),
    TrackPositiveBehavior: Joi.boolean(),
    OtherStrategy: Joi.boolean(),
    OtherStrategyDetails: Joi.string().allow(""),
    StrategiesWorking: Joi.string().allow(""),
    StrategiesToTry: Joi.string().allow(""),
    ProblematicBehaviors: Joi.string().allow(""),
    ProblemBehavior: Joi.string().allow(""),
    ProblemBehaviorDetails: Joi.string().allow(""),
    BehaviorFrequency: Joi.string().allow(""),
    BehaviorDuration: Joi.string().allow(""),
    BehaviorIntensity: Joi.string().allow(""),
    BehaviorAntecedent: Joi.string().allow(""),
    BehaviorConsequence: Joi.string().allow(""),
    InfluenceThoughts: Joi.string().allow(""),
    InterventionsToAvoid: Joi.string().allow(""),
    TimeIn: Joi.boolean(),
    TimeOut: Joi.boolean(),
    Restitution: Joi.boolean(),
    DirectionWithWarning: Joi.boolean(),
    ProblemSolving: Joi.boolean(),
    PrivilegeRemoval: Joi.boolean(),
    NaturalConsequenceReduce: Joi.boolean(),
    BehaviorContractReduce: Joi.boolean(),
    LogicalConsequence: Joi.boolean(),
    VerbalPraiseReduce: Joi.boolean(),
    RewardReduce: Joi.boolean(),
    OtherReduce: Joi.boolean(),
    OtherReduceDetails: Joi.string().allow(""),
    StrategiesWorkingReduce: Joi.string().allow(""),
    NewInterventions: Joi.string().allow(""),
    DailyCheckIns: Joi.string().allow(""),
    CheckInPositiveInfo: Joi.string().allow(""),
    CheckInConcerns: Joi.string().allow(""),
    FamilyMeeting: Joi.string().allow(""),
    FamilyMeetingReviewed: Joi.string().allow(""),
    FamilyFunTime: Joi.string().allow(""),
    YouthIdentity: Joi.string().allow(""),
    PowerStruggle: Joi.string().allow(""),
    PreTeaching: Joi.boolean(),
    IMessage: Joi.boolean(),
    Ignored: Joi.boolean(),
    Neutral: Joi.boolean(),
    NoButtons: Joi.boolean(),
    WalkedAway: Joi.boolean(),
    Concise: Joi.boolean(),
    RegainComposure: Joi.boolean(),
    NoArguing: Joi.boolean(),
    OtherPowerStruggleStrategy: Joi.boolean(),
    OtherPowerStruggleStrategyDetails: Joi.string().allow(""),
    FeelingToday: Joi.string().allow(""),
    FeelingLastMeeting: Joi.string().allow(""),
    Respite: Joi.boolean(),
    AloneTime: Joi.boolean(),
    DeepBreathing: Joi.boolean(),
    Meditation: Joi.boolean(),
    Exercise: Joi.boolean(),
    Reading: Joi.boolean(),
    NightAway: Joi.boolean(),
    Prayer: Joi.boolean(),
    Listening: Joi.boolean(),
    Hobby: Joi.boolean(),
    Support: Joi.boolean(),
    OtherSelfCare: Joi.boolean(),
    OtherSelfCareDetails: Joi.string().allow(""),
    SelfCareStrategies: Joi.string().allow(""),
    AdditionalComments: Joi.string().allow(""),
  },
  "F8AEC714-4CC6-EC11-997E-0050F21C653C": {
    SelectedProgram: Joi.string().label("Client Program").required(),
    SexAssignedAtBirth: Joi.string().label("Sex Assigned at Birth").required(),
    SexAssignedAtBirthDetails: Joi.string()
      .label("Sex Assigned at Birth Specifics")
      .when("SexAssignedAtBirth", {
        is: "Sex not listed",
        then: Joi.required(),
      }),
    Pronouns: Joi.string().label("Pronouns").required(),
    PronounsDescription: Joi.string()
      .label("Pronouns description")
      .when("Pronouns", {
        is: "Prefer to self-describe",
        then: Joi.required(),
      }),
    GenderIdentity: Joi.string().label("Gender Identity").required(),
    GenderIdentityDescription: Joi.string()
      .label("Gender Identity description")
      .when("GenderIdentity", {
        is: "Identity not listed",
        then: Joi.required(),
      }),
    DateCompleted: Joi.string().required().label("Date Completed"),
    PSDType: Joi.string().label("Type of PSD").required(),
    ReviewReason: Joi.string()
      .label("Reason")
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ReferralMembers: Joi.string()
      .label("Family Members on Referral")
      .required(),
    MaGIKCaseID: Joi.string().label("MaGIK Case ID").required(),
    Caseworker: Joi.string().label("Caseworker").required(),
    Division: Joi.string().label("SAFY Division").required(),
    County: Joi.string().label("County").required(),
    CountyDetails: Joi.string()
      .label("County")
      .when("County", { is: "Other", then: Joi.required() }),
    ISFamily: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISDCS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.string()
      .label("Other Information Source details")
      .when("ISOther", { is: true, then: Joi.required() }),
    ReferralReason: Joi.string().label("Reason for Referral").required(),
    PresentingProblem: Joi.string()
      .label("Description of the Problem(s)")
      .required(),
    ProtectiveFactors: Joi.string().label("Protective Factors").required(),
    CurrentHousehold: Joi.string().label("Current Household").required(),
    OtherFamilySupports: Joi.string().label("Other Family Supports").required(),
    CaregiverCooperation: Joi.string()
      .label("Cooperation between caregivers")
      .required(),
    CaregiverCooperationDetails: Joi.string()
      .label("Cooperation between caregivers details")
      .when("CaregiverCooperation", { is: "No", then: Joi.required() }),
    SupervisionDifficulties: Joi.string()
      .label("Difficulties with the supervision")
      .required(),
    SupervisionDifficultiesDetails: Joi.string()
      .label("Difficulties with the supervision details")
      .when("SupervisionDifficulties", { is: "Yes", then: Joi.required() }),
    DisciplinePractices: Joi.string().label("Discipline practices").required(),
    Interaction: Joi.string()
      .label("Interaction between caregivers and child(ren)")
      .required(),
    ExtendedFamilyHistory: Joi.string()
      .label("Extended Family History")
      .required(),
    PsychosocialFunctioning: Joi.string()
      .label("Psychosocial Functioning")
      .required(),
    CulturalGroup: Joi.string().label("Identified cultural group").required(),
    TraditionsComments: Joi.string()
      .label("Special cultural traditions/celebrations/rituals")
      .required(),
    LanguagesSpoken: Joi.string().label("Languages spoken").required(),
    Religion: Joi.string()
      .label("Identified religion/belief system")
      .required(),
    ReligionRole: Joi.string()
      .label("Role of faith in client's life")
      .required(),
    PCP: Joi.string().label("Primary Care Physician").required(),
    LastMedicalExamDates: Joi.string()
      .label("Date(s) of last medical exam for child(ren)")
      .required(),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.string()
      .label("Allergies details")
      .when("Allergies", { is: true, then: Joi.required() }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.string()
      .label("Medical Conditions Details")
      .when("MedicalConditions", { is: true, then: Joi.required() }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.string()
      .label("Nutritional Concerns Details")
      .when("NutritionalConcerns", { is: true, then: Joi.required() }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.string()
      .label("Dental Concerns Details")
      .when("DentalConcerns", { is: true, then: Joi.required() }),
    SleepConcerns: Joi.boolean(),
    SleepConcernsDetails: Joi.string()
      .label("Sleep Concerns Details")
      .when("SleepConcerns", { is: true, then: Joi.required() }),
    Hospitalizations: Joi.boolean(),
    HospitalizationsDetails: Joi.string()
      .label("Hospitalization Details")
      .when("Hospitalizations", { is: true, then: Joi.required() }),
    HeadInjury: Joi.boolean(),
    HeadInjuryDetails: Joi.string()
      .label("Head Injury Details")
      .when("HeadInjury", { is: true, then: Joi.required() }),
    Undiagnosed: Joi.string().label("Undiagnosed illness symptoms").required(),
    UndiagnosedComments: Joi.string()
      .label("Undiagnosed illness symptom details")
      .when("Undiagnosed", { is: "Yes", then: Joi.required() }),
    PregnancyHistory: Joi.string().label("Pregnancy History").required(),
    MilestonesMet: Joi.string()
      .label("Developmental milestones met on time")
      .required(),
    MilestonesMetDetails: Joi.string()
      .label("Milestone details")
      .when("MilestonesMet", { is: "No", then: Joi.required() }),
    SpecialNeeds: Joi.string()
      .label("Developmental delays or special needs")
      .required(),
    SpecialNeedsDetails: Joi.string()
      .label("Special needs details")
      .when("SpecialNeeds", { is: "Yes", then: Joi.required() }),
    SpecializedServices: Joi.string().label("Specialized Services").required(),
    SpecializedServicesDetails: Joi.string()
      .label("Specialized Services details")
      .when("SpecializedServices", { is: "Yes", then: Joi.required() }),
    GenderOrientation: Joi.string()
      .label("Gender identity & sexual orientation")
      .required(),
    NoMedications: Joi.boolean(),
    CurrentMedications: Joi.string()
      .label("Current Medications")
      .when("NoMedications", { is: false, then: Joi.required() }),
    PsychotropicMedications: Joi.string()
      .label("Past Psychotropic Medications")
      .when("NoMedications", { is: false, then: Joi.required() }),
    NoMentalHealthTreatment: Joi.boolean(),
    MentalHealthTreatment: Joi.string()
      .label("Mental Health Treatment")
      .when("NoMentalHealthTreatment", { is: false, then: Joi.required() }),
    NoSelfHarm: Joi.boolean(),
    SelfHarmDetails: Joi.string().label("Self Harm Details").required(),
    AllSelfHarmScreened: Joi.string()
      .label("All family members screened")
      .required(),
    NotAllSelfHarmScreenedDetails: Joi.string()
      .label("Not all family members screened details")
      .when("AllSelfHarmScreened", { is: "No", then: Joi.required() }),
    SelfHarmComments: Joi.string()
      .label("Comments/Action Taken")
      .when("NoSelfHarm", { is: false, then: Joi.required() }),
    NoHarmingOthers: Joi.boolean(),
    HarmingOthersDetails: Joi.string()
      .label("Harm to Others/Endangerment details")
      .required(),
    AllHarmOthersScreened: Joi.string()
      .label("All family members screened")
      .required(),
    NotAllHarmOthersScreenedDetails: Joi.string()
      .label("Not all family members screened details")
      .when("AllHarmOthersScreened", { is: "No", then: Joi.required() }),
    HarmingOthersComments: Joi.string()
      .label("Comments/Action Taken")
      .when("NoHarmingOthers", { is: false, then: Joi.required() }),
    EducationDetails: Joi.string().label("Education details").required(),
    NoneEmployed: Joi.boolean(),
    EmploymentDetails: Joi.string().label("Employment details").required(),
    MilitaryHistory: Joi.string()
      .label("Family members' military history")
      .required(),
    MilitaryHistoryDetails: Joi.string()
      .label("Military history details")
      .when("MilitaryHistory", { is: "Yes", then: Joi.required() }),
    NoSubstanceUse: Joi.boolean(),
    SubstanceUseHistory: Joi.string().label("Substance Use history").required(),
    TraumaHistory: Joi.string().label("Trauma history").required(),
    FamilyChanges: Joi.string()
      .label("Changes/transitions in family")
      .required(),
    FamilyChangesDetails: Joi.string()
      .label("Changes/transitions in family description")
      .when("FamilyChanges", { is: "Yes", then: Joi.required() }),
    RecentGrief: Joi.string()
      .label("Recent or significant deaths/grief issues")
      .required(),
    RecentGriefDetails: Joi.string()
      .label("Recent or significant deaths/grief issues details")
      .when("RecentGrief", { is: "Yes", then: Joi.required() }),
    SymptomsNA: Joi.boolean(),
    Symptoms: Joi.string()
      .label("Symptoms")
      .when("SymptomsNA", { is: false, then: Joi.required() }),
    SymptomsNAComments: Joi.string()
      .label("Comments")
      .when("SymptomsNA", { is: true, then: Joi.required() }),
    Hygiene: Joi.string().label("Personal appearance and hygiene").required(),
    HygieneFamilyMembers: Joi.string()
      .label("Personal appearance and hygiene Family Members")
      .when("Hygiene", { is: "Yes", then: Joi.required() }),
    HygieneDetails: Joi.string()
      .label("Personal appearance and hygiene Details")
      .when("Hygiene", { is: "Yes", then: Joi.required() }),
    MoneyManagement: Joi.string().label("Money management").required(),
    MoneyManagementFamilyMembers: Joi.string()
      .label("Money management Family Members")
      .when("MoneyManagement", { is: "Yes", then: Joi.required() }),
    MoneyManagementDetails: Joi.string()
      .label("Money management Details")
      .when("MoneyManagement", { is: "Yes", then: Joi.required() }),
    FoodManagement: Joi.string().label("Food management").required(),
    FoodManagementFamilyMembers: Joi.string()
      .label("Food management Family Members")
      .when("FoodManagement", { is: "Yes", then: Joi.required() }),
    FoodManagementDetails: Joi.string()
      .label("Food management Details")
      .when("FoodManagement", { is: "Yes", then: Joi.required() }),
    Health: Joi.string().label("Health").required(),
    HealthFamilyMembers: Joi.string()
      .label("Health Family Members")
      .when("Health", { is: "Yes", then: Joi.required() }),
    HealthDetails: Joi.string()
      .label("Health Details")
      .when("Health", { is: "Yes", then: Joi.required() }),
    Housekeeping: Joi.string().label("Housekeeping").required(),
    HousekeepingFamilyMembers: Joi.string()
      .label("Housekeeping Family Members")
      .when("Housekeeping", { is: "Yes", then: Joi.required() }),
    HousekeepingDetails: Joi.string()
      .label("Housekeeping Details")
      .when("Housekeeping", { is: "Yes", then: Joi.required() }),
    Transportation: Joi.string().label("Transportation").required(),
    TransportationFamilyMembers: Joi.string()
      .label("Transportation Family Members")
      .when("Transportation", { is: "Yes", then: Joi.required() }),
    TransportationDetails: Joi.string()
      .label("Transportation Details")
      .when("Transportation", { is: "Yes", then: Joi.required() }),
    SafetySkills: Joi.string().label("Safety Skills").required(),
    SafetySkillsFamilyMembers: Joi.string()
      .label("Safety Skills Family Members")
      .when("SafetySkills", { is: "Yes", then: Joi.required() }),
    SafetySkillsDetails: Joi.string()
      .label("Safety Skills Details")
      .when("SafetySkills", { is: "Yes", then: Joi.required() }),
    ResourceKnowledge: Joi.string().label("ResourceKnowledge").required(),
    ResourceKnowledgeFamilyMembers: Joi.string()
      .label("Resource Knowledge Family Members")
      .when("ResourceKnowledge", { is: "Yes", then: Joi.required() }),
    ResourceKnowledgeDetails: Joi.string()
      .label("Resource Knowledge Details")
      .when("ResourceKnowledge", { is: "Yes", then: Joi.required() }),
    TimeManagement: Joi.string().label("Time Management").required(),
    TimeManagementFamilyMembers: Joi.string()
      .label("Time Management Family Members")
      .when("TimeManagement", { is: "Yes", then: Joi.required() }),
    TimeManagementDetails: Joi.string()
      .label("Time Management Details")
      .when("TimeManagement", { is: "Yes", then: Joi.required() }),
    InteractionWithOthers: Joi.string().label("Interaction").required(),
    InteractionFamilyMembers: Joi.string()
      .label("Interaction Family Members")
      .when("InteractionWithOthers", { is: "Yes", then: Joi.required() }),
    InteractionDetails: Joi.string()
      .label("Interaction Details")
      .when("InteractionWithOthers", { is: "Yes", then: Joi.required() }),
    LegalInvolvement: Joi.string().label("Legal Involvement").required(),
    LegalInvolvementDetails: Joi.string()
      .label("Legal History")
      .when("LegalInvolvement", { is: "Yes", then: Joi.required() }),
    PFS2CompletionStatus: Joi.string()
      .label("PFS-2 completion status")
      .required(),
    Resilience: Joi.string()
      .label("Family Functioning/Resilience")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    Attachment: Joi.string()
      .label("Nurturing and Attachment")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    SocialSupports: Joi.string()
      .label("Social Supports")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    PractitionerRelationship: Joi.string()
      .label("Caregiver/Practitioner Relationship")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    ConcreteSupports: Joi.string()
      .label("Concrete Supports")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    OtherTools: Joi.string().label("Other tools used").required(),
    OtherToolsDetails: Joi.string()
      .label("Other tool details")
      .when("OtherTools", { is: "Yes", then: Joi.required() }),
    Interpretation: Joi.string()
      .label("Interpretation of Scores")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() })
      .when("OtherTools", { is: "Yes", then: Joi.required() }),
    ClinicalSummary: Joi.string()
      .label("Clinical Observations/Family Clinical Summary")
      .required(),
    ClinicalSummaryComments: Joi.string().label("Clinical Comments").required(),
    RiskFactors: Joi.string()
      .label("Areas of Concern/Risk Factors/Potential Barriers")
      .required(),
    ConcreteNeeds: Joi.string().label("Concrete Needs").required(),
    DischargePlan: Joi.string()
      .label("Family's Perspective/Plan for Discharge")
      .required(),
    DiagnosisDetails: Joi.string().label("Diagnosis Details").required(),
    TreatmentRecommendations: Joi.string()
      .label("Treatment Recommendations")
      .required(),
    AdditionalPsychiatric: Joi.boolean(),
    AdditionalPsychological: Joi.boolean(),
    AdditionalNeurological: Joi.boolean(),
    AdditionalEducational: Joi.boolean(),
    AdditionalMedical: Joi.boolean(),
    AdditionalDental: Joi.boolean(),
    AdditionalSubstanceAbuse: Joi.boolean(),
    AdditionalVocational: Joi.boolean(),
    AdditionalOccupational: Joi.boolean(),
    AdditionalNutritional: Joi.boolean(),
    AdditionalVisualAuditory: Joi.boolean(),
    AdditionalDomesticViolence: Joi.boolean(),
    AdditionalSexOffender: Joi.boolean(),
    AdditionalOther: Joi.boolean(),
    AdditionalOtherDetails: Joi.string()
      .label("Other Evaluations Needed details")
      .when("AdditionalOther", { is: true, then: Joi.required() }),
    MembersInNeed: Joi.string()
      .label("Family Member(s) in need of evaluation")
      .when("AdditionalPsychiatric", { is: true, then: Joi.required() })
      .when("AdditionalPsychological", { is: true, then: Joi.required() })
      .when("AdditionalNeurological", { is: true, then: Joi.required() })
      .when("AdditionalEducational", { is: true, then: Joi.required() })
      .when("AdditionalMedical", { is: true, then: Joi.required() })
      .when("AdditionalDental", { is: true, then: Joi.required() })
      .when("AdditionalSubstanceAbuse", { is: true, then: Joi.required() })
      .when("AdditionalVocational", { is: true, then: Joi.required() })
      .when("AdditionalOccupational", { is: true, then: Joi.required() })
      .when("AdditionalNutritional", { is: true, then: Joi.required() })
      .when("AdditionalVisualAuditory", { is: true, then: Joi.required() })
      .when("AdditionalDomesticViolence", { is: true, then: Joi.required() })
      .when("AdditionalSexOffender", { is: true, then: Joi.required() })
      .when("AdditionalOther", { is: true, then: Joi.required() }),
  },
  "0543B7AA-EFC7-EC11-997E-DC98408D5418": {
    SelectedProgram: Joi.string().label("Client Program").required(),
    DateOfDischarge: Joi.string().label("Date of Discharge").required(),
    DischargeReason: Joi.string().label("Reason for discharge").required(),
    DischargedTo: Joi.string().label("Discharged to").required(),
    DischargedToAddress: Joi.string().label("Discharged to address").required(),
    OutpatientMentalHealth: Joi.string().label("Outpatient Mental Health"),
    OutpatientMentalHealthReferredTo: Joi.string()
      .label("Outpatient Mental Health Referred To")
      .when("OutpatientMentalHealth", {
        is: "New Service",
        then: Joi.required(),
      })
      .when("OutpatientMentalHealth", {
        is: "Continue Service",
        then: Joi.required(),
      }),
    OutpatientSubstanceAbuse: Joi.string().label(
      "Outpatient Alcohol/Substance Abuse"
    ),
    OutpatientSubstanceAbuseReferredTo: Joi.string()
      .label("Outpatient Substance Abuse Referred To")
      .when("OutpatientSubstanceAbuse", {
        is: "New Service",
        then: Joi.required(),
      })
      .when("OutpatientSubstanceAbuse", {
        is: "Continue Service",
        then: Joi.required(),
      }),
    HousingAssistance: Joi.string().label("Housing Assistance"),
    HousingAssistanceReferredTo: Joi.string()
      .label("Housing Assistance Referred To")
      .when("HousingAssistance", { is: "New Service", then: Joi.required() })
      .when("HousingAssistance", {
        is: "Continue Service",
        then: Joi.required(),
      }),
    JobTraining: Joi.string().label("Job Training"),
    JobTrainingReferredTo: Joi.string()
      .label("Job Training Referred To")
      .when("JobTraining", { is: "New Service", then: Joi.required() })
      .when("JobTraining", { is: "Continue Service", then: Joi.required() }),
    EducationServices: Joi.string().label("Education Services"),
    EducationServicesReferredTo: Joi.string()
      .label("Education Services Referred To")
      .when("EducationServices", { is: "New Service", then: Joi.required() })
      .when("EducationServices", {
        is: "Continue Service",
        then: Joi.required(),
      }),
    Tutoring: Joi.string().label("Tutoring"),
    TutoringReferredTo: Joi.string()
      .label("Tutoring Referred To")
      .when("Tutoring", { is: "New Service", then: Joi.required() })
      .when("Tutoring", { is: "Continue Service", then: Joi.required() }),
    PsychiatricAppointment: Joi.string().label("Psychiatric Appointment"),
    PsychiatricAppointmentReferredTo: Joi.string()
      .label("Psychiatric Appointment Referred To")
      .when("PsychiatricAppointment", {
        is: "New Service",
        then: Joi.required(),
      })
      .when("PsychiatricAppointment", {
        is: "Continue Service",
        then: Joi.required(),
      }),
    Prescriptions: Joi.string().label("Prescriptions and/or Renewal"),
    PrescriptionsReferredTo: Joi.string()
      .label("Prescriptions Referred To")
      .when("Prescriptions", { is: "New Service", then: Joi.required() })
      .when("Prescriptions", { is: "Continue Service", then: Joi.required() }),
    MedicalServices: Joi.string().label("Medical Services"),
    MedicalServicesReferredTo: Joi.string()
      .label("Medical Services Referred To")
      .when("MedicalServices", { is: "New Service", then: Joi.required() })
      .when("MedicalServices", {
        is: "Continue Service",
        then: Joi.required(),
      }),
    Probation: Joi.string().label("Probation/Parole Officer Contact"),
    ProbationReferredTo: Joi.string()
      .label("Probation Referred To")
      .when("Probation", { is: "New Service", then: Joi.required() })
      .when("Probation", { is: "Continue Service", then: Joi.required() }),
    LegalServices: Joi.string().label("Legal Services"),
    LegalServicesReferredTo: Joi.string()
      .label("Legal Services Referred To")
      .when("LegalServices", { is: "New Service", then: Joi.required() })
      .when("LegalServices", { is: "Continue Service", then: Joi.required() }),
    PhysicianAppointment: Joi.string().label("Physician Appointment"),
    PhysicianAppointmentReferredTo: Joi.string()
      .label("Physician Appointment Referred To")
      .when("PhysicianAppointment", { is: "New Service", then: Joi.required() })
      .when("PhysicianAppointment", {
        is: "Continue Service",
        then: Joi.required(),
      }),
    WelfareSupport: Joi.string().label("Welfare Support"),
    WelfareSupportReferredTo: Joi.string()
      .label("Welfare Support Referred To")
      .when("WelfareSupport", { is: "New Service", then: Joi.required() })
      .when("WelfareSupport", { is: "Continue Service", then: Joi.required() }),
    FinancialSupport: Joi.string().label("Financial Support"),
    FinancialSupportReferredTo: Joi.string()
      .label("Financial Support Referred To")
      .when("FinancialSupport", { is: "New Service", then: Joi.required() })
      .when("FinancialSupport", {
        is: "Continue Service",
        then: Joi.required(),
      }),
    InHomeServices: Joi.string().label("In-home services"),
    InHomeServicesReferredTo: Joi.string()
      .label("In-Home Services Referred To")
      .when("InHomeServices", { is: "New Service", then: Joi.required() })
      .when("InHomeServices", { is: "Continue Service", then: Joi.required() }),
    OtherServices: Joi.string().label("Other"),
    OtherServicesReferredTo: Joi.string()
      .label("Other Services Referred To")
      .when("OtherServices", { is: "New Service", then: Joi.required() })
      .when("OtherServices", { is: "Continue Service", then: Joi.required() }),
    ServicesProvidedNarrative: Joi.string()
      .label("Narrative of Services Provided")
      .required(),
    PlacementHistory: Joi.string().label("Placement History").required(),
    Behavior: Joi.string().label("Behavior").required(),
    SocialInteraction: Joi.string()
      .label("Social and Peer Interaction")
      .required(),
    ResponseToCaregivers: Joi.string()
      .label("Response to Caregivers or Redirection")
      .required(),
    SchoolInformation: Joi.string()
      .label("School Information and Participation")
      .required(),
    AdditionalAccomplishments: Joi.string()
      .label("Additional Accomplishment")
      .required(),
    FollowUp: Joi.string().label("Follow-up").required(),
  },
  "FC699CA4-F9D2-EC11-997E-DC98408D5418": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    SexAssignedAtBirth: Joi.string().required(),
    SexAssignedAtBirthDetails: Joi.when("SexAssignedAtBirth", {
      is: "Sex not listed",
      then: Joi.string().required(),
    }),
    Pronouns: Joi.string().required(),
    PronounsDescription: Joi.when("Pronouns", {
      is: "Prefer to self-describe",
      then: Joi.required(),
    }),
    GenderIdentity: Joi.string().required(),
    GenderIdentityDescription: Joi.when("GenderIdentity", {
      is: "Identity not listed",
      then: Joi.string().required(),
    }),
    DateCompleted: Joi.string().required(),
    Division: Joi.string().required(),
    PSDType: Joi.string().required(),
    InitialDADate: Joi.when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.string().required(),
    }),
    UpdateSummary: Joi.when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.string().required(),
    }),
    UpdateRecommendations: Joi.when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.string().required(),
    }),
    ISClient: Joi.boolean(),
    ISParent: Joi.boolean(),
    ISGuardian: Joi.boolean(),
    ISCaregiver: Joi.boolean(),
    ISPhysician: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISCPS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.when("ISOther", {
      is: true,
      then: Joi.string().required(),
    }),
    ReasonForReferral: Joi.string().required(),
    ClientStrengths: Joi.string().required(),
    PresentingProblem: Joi.string().required(),
    HumanTrafficking: Joi.string().required(),
    CurrentPlacement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    OtherSupports: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CaregiverCooperation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    SupervisionDifficulties: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    DisciplinePracticesEffective: Joi.boolean(),
    DisciplinePracticesInconsistent: Joi.boolean(),
    DisciplinePracticesIneffective: Joi.boolean(),
    CurrentPlacementComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CaregiverCooperation", {
        is: "No",
        then: Joi.string().required(),
      })
        .when("SupervisionDifficulties", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("DisciplinePracticesInconsistent", {
          is: true,
          then: Joi.string().required(),
        })
        .when("DisciplinePracticesIneffective", {
          is: true,
          then: Joi.string().required(),
        }),
    }),
    FamilyHistoryDetails: Joi.string().required(),
    CurrentConcernsOfDV: Joi.boolean(),
    PastConcernsOfDV: Joi.boolean(),
    UnknownConcernsOfDV: Joi.boolean(),
    NoReportedConcernsOfDV: Joi.boolean(),
    CurrentMaritalConflict: Joi.boolean(),
    PastMaritalConflict: Joi.boolean(),
    UnknownMaritalConflict: Joi.boolean(),
    NoReportedMaritalConflict: Joi.boolean(),
    ConflictComments: Joi.when("CurrentConcernsOfDV", {
      is: true,
      then: Joi.string().required(),
    })
      .when("PastConcernsOfDV", { is: true, then: Joi.string().required() })
      .when("CurrentMaritalConflict", {
        is: true,
        then: Joi.string().required(),
      })
      .when("PastMaritalConflict", { is: true, then: Joi.string().required() }),
    CulturalGroup: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CulturalTraditions: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CulturalTraditionsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CulturalTraditions", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    NegativeCulturalExperiences: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    NegativeCulturalExperiencesDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("NegativeCulturalExperiences", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    CulturalMedicalBeliefs: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CulturalMedicalBeliefsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CulturalMedicalBeliefs", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    CulturalDifferencesDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    Religion: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    RoleOfFaith: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ReligiousTraditions: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DietaryNeeds: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    NegativeReligiousExperiences: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ReligiousMedicalBeliefs: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ReligiousDifferences: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    ReligiousComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ReligiousTraditions", {
        is: "Yes",
        then: Joi.string().required(),
      })
        .when("DietaryNeeds", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("NegativeReligiousExperiences", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("ReligiousMedicalBeliefs", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("ReligiousDifferences", {
          is: "Yes",
          then: Joi.string().required(),
        }),
    }),
    PHNoProblems: Joi.boolean(),
    PHPrenatalCare: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHExposure: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHTrauma: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHComplications: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHConcerns: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.when("PHPrenatalCare", {
          is: "Yes",
          then: Joi.string().required(),
        })
          .when("PHExposure", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("PHTrauma", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("PHComplications", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("PHConcerns", {
            is: "Yes",
            then: Joi.string().required(),
          }),
      }),
    }),
    SpecialNeeds: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    SpecializedServices: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    DHComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SpecialNeeds", {
        is: "Yes",
        then: Joi.string().required(),
      }).when("SpecializedServices", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    EducationStatus: Joi.string().required(),
    SchoolName: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    CurrentGrade: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    RegularClassroom: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    Active504Plan: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    ActiveIEP: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    SchoolExperience: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      }),
    }),
    EmploymentNA: Joi.boolean(),
    CurrentlyEmployed: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    EmployerAndTitle: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.when("CurrentlyEmployed", {
            is: "Yes",
            then: Joi.string().required(),
          }),
        }),
      }),
    }),
    EmploymentInterests: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.when("CurrentlyEmployed", {
            is: "N/A",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          }),
        }),
      }),
    }),
    MilitaryHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    MilitaryComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.when("MilitaryHistory", {
            is: "Yes",
            then: Joi.string().required(),
          }),
        }),
      }),
    }),
    ADLNA: Joi.boolean(),
    MoneyManagement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    MoneyManagementDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("MoneyManagement", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("MoneyManagement", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    FoodManagement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    FoodManagementDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("FoodManagement", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("FoodManagement", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    Hygiene: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    HygieneDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Hygiene", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Hygiene", { is: "Advanced", then: Joi.string().required() }),
      }),
    }),
    Health: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    HealthDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Health", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Health", { is: "Advanced", then: Joi.string().required() }),
      }),
    }),
    Housekeeping: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    HousekeepingDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Housekeeping", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Housekeeping", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    Transportation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    TransportationDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Transportation", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Transportation", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    SafetySkills: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SafetySkillsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("SafetySkills", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("SafetySkills", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    ResourceKnowledge: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    ResourceKnowledgeDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("ResourceKnowledge", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("ResourceKnowledge", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    TimeManagement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    TimeManagementDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("TimeManagement", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("TimeManagement", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    Interaction: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    InteractionDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Interaction", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Interaction", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    CoopSkills: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CoopSkillsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CoopSkills", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("CoopSkills", { is: "Advanced", then: Joi.string().required() }),
    }),
    CommunicationSkills: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CommunicationSkillsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CommunicationSkills", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("CommunicationSkills", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    EmotionalUnderstanding: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    EmotionalUnderstandingDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EmotionalUnderstanding", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("EmotionalUnderstanding", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    ProblemSolving: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    ProblemSolvingDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ProblemSolving", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("ProblemSolving", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    ConflictResolution: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    ConflictResolutionDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ConflictResolution", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("ConflictResolution", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    DecisionMakingSkills: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    DecisionMakingSkillsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("DecisionMakingSkills", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("DecisionMakingSkills", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    Bullied: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    Bully: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    AcceptedByPeers: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    NegativeAssociations: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    RelationshipComments: Joi.when("Bullied", {
      is: "Yes",
      then: Joi.string().required(),
    })
      .when("Bully", {
        is: "Yes",
        then: Joi.string().required(),
      })
      .when("AcceptedByPeers", {
        is: "No",
        then: Joi.string().required(),
      })
      .when("NegativeAssociations", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    LegalInvolvement: Joi.string().required(),
    CPSInvolvement: Joi.when("LegalInvolvement", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    TypeOfCPSInvolvement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("CPSInvolvement", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    CPSHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("CPSInvolvement", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    CPSCaseworker: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("CPSInvolvement", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    CPSCaseworkerName: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("CPSInvolvement", {
          is: "Yes",
          then: Joi.when("CPSCaseworker", {
            is: "Yes",
            then: Joi.string().required(),
          }),
        }),
      }),
    }),
    ProbationOfficer: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProbationOfficerName: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("ProbationOfficer", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    GALCASA: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    GALCASAName: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("GALCASA", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    LegalStatus: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    LegalHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("LegalStatus", {
          is: "None Reported",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        }),
      }),
    }),
    OtherLegalDetails: Joi.when("LegalInvolvement", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    PCPUnknown: Joi.boolean(),
    PCP: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PCPUnknown", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PCPPhone: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PCPUnknown", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    LastMedicalExamDate: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    LastDentalExamDate: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Allergies", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("MedicalConditions", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("NutritionalConcerns", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("DentalConcerns", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Undiagnosed: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    UndiagnosedDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Undiagnosed", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    NoMedications: Joi.boolean(),
    CurrentMedications: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    MedicationCompliance: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    SideEffects: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    SideEffectsDetails: Joi.when("NoMedications", {
      is: false,
      then: Joi.when("SideEffects", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    PsychotropicMeds: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    PsychotropicMedsDetails: Joi.when("NoMedications", {
      is: false,
      then: Joi.when("PsychotropicMeds", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualHistoryNA: Joi.boolean(),
    SexualOrientation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexualOrientationDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexualOrientation", {
          is: "Orientation not listed",
          then: Joi.string().required(),
        }).when("SexualOrientation", {
          is: "Unable to assess",
          then: Joi.string().required(),
        }),
      }),
    }),
    SexualRelationshipsEducation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexuallyActive: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    CaregiverAware: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    UseProtection: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    AwareOfRisks: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    Pregnancy: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    Children: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SexuallyActiveComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SexualAbuseVictim: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexualBehavior: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexuallyActingOut: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexuallyAbusive: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexualHistoryComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexualAbuseVictim", {
          is: "Yes",
          then: Joi.string().required(),
        })
          .when("SexualBehavior", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("SexuallyActingOut", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("SexuallyAbusive", {
            is: "Yes",
            then: Joi.string().required(),
          }),
      }),
    }),
    MHTreatmentNA: Joi.boolean(),
    PastMentalHealthTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    PastGroupHomePlacement: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    PastHospitalPlacement: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    InvoluntaryTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    PastMentalHealthDiagnosis: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    MHTreatmentComments: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.when("PastMentalHealthTreatment", {
        is: "Yes",
        then: Joi.string().required(),
      })
        .when("PastGroupHomePlacement", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("PastHospitalPlacement", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("InvoluntaryTreatment", {
          is: "Yes",
          then: Joi.string().required(),
        }),
    }),
    MHTreatmentHistory: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    MHClientPerspectiveOfTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    MHCaregiverPerspectiveOfTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    SUAge: Joi.boolean(),
    SubstanceUseNA: Joi.boolean(),
    SUClientDenies: Joi.boolean(),
    SUClientReportsCurrent: Joi.boolean(),
    SUClientReportsPast: Joi.boolean(),
    SUClientPeers: Joi.boolean(),
    SUCaregiverSuspects: Joi.boolean(),
    SUCaregiverEvidence: Joi.boolean(),
    SUComments: Joi.when("SubstanceUseNA", {
      is: false,
      then: Joi.when("SUClientDenies", { is: true, then: Joi.required() })
        .when("SUClientReportsCurrent", {
          is: true,
          then: Joi.string().required(),
        })
        .when("SUClientReportsPast", {
          is: true,
          then: Joi.string().required(),
        })
        .when("SUClientPeers", { is: true, then: Joi.string().required() })
        .when("SUCaregiverSuspects", {
          is: true,
          then: Joi.string().required(),
        })
        .when("SUCaregiverEvidence", {
          is: true,
          then: Joi.string().required(),
        }),
    }),
    SUHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    ClientPerceptionOfSubstanceUse: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    CaregiverPerceptionOfSubstanceUse: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    NoPastTreatment: Joi.boolean(),
    SUTreatmentHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.when("NoPastTreatment", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    SUClientPerspectiveOfTreatment: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.when("NoPastTreatment", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    SUCaregiverPerspectiveOfTreatment: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.when("NoPastTreatment", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    TraumaNA: Joi.boolean(),
    TraumaHistory: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    DistressingMemories: Joi.boolean(),
    BlockOut: Joi.boolean(),
    Hypervigilance: Joi.boolean(),
    PhysiologicalResponses: Joi.boolean(),
    LossOfMemories: Joi.boolean(),
    Hyperarousal: Joi.boolean(),
    SleepDisturbances: Joi.boolean(),
    DevelopmentalRegression: Joi.boolean(),
    Nightmares: Joi.boolean(),
    Avoidant: Joi.boolean(),
    DifficultyConcentratingSymptom: Joi.boolean(),
    UnhealthyBoundaries: Joi.boolean(),
    Flashbacks: Joi.boolean(),
    Detachment: Joi.boolean(),
    EmotionalDysregulation: Joi.boolean(),
    RepetitivePlayOfEvents: Joi.boolean(),
    PsychologicalDistress: Joi.boolean(),
    DiminishedInterests: Joi.boolean(),
    Dissocation: Joi.boolean(),
    NegativeCognitions: Joi.boolean(),
    SocialWithdrawalSymptom: Joi.boolean(),
    NoSymptoms: Joi.boolean(),
    SocialSupports: Joi.boolean(),
    SenseOfMastery: Joi.boolean(),
    CaregiverStability: Joi.boolean(),
    StrongSpiritualBeliefs: Joi.boolean(),
    InterpersonalSkills: Joi.boolean(),
    PositiveOutlook: Joi.boolean(),
    PlacementStability: Joi.boolean(),
    Pets: Joi.boolean(),
    ValidatingExperiences: Joi.boolean(),
    Resources: Joi.boolean(),
    TiesToExtendedFamily: Joi.boolean(),
    Adaptability: Joi.boolean(),
    SecureAttachments: Joi.boolean(),
    StrongCulturalIdentity: Joi.boolean(),
    Resilience: Joi.boolean(),
    NoTraumaProtectiveFactors: Joi.boolean(),
    CopingStrategies: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    ClientAwareOfTrauma: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    ClientPerspectiveOfTrauma: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    CaregiverPerspectiveOfTrauma: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    AppropriateAppearance: Joi.boolean(),
    Neat: Joi.boolean(),
    Disheveled: Joi.boolean(),
    BizarreAppearance: Joi.boolean(),
    OtherAppearance: Joi.boolean(),
    OtherAppearanceDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherAppearance", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Cooperative: Joi.boolean(),
    Guarded: Joi.boolean(),
    Hyperactive: Joi.boolean(),
    Agitated: Joi.boolean(),
    Paranoid: Joi.boolean(),
    Tics: Joi.boolean(),
    Impulsive: Joi.boolean(),
    Aggressive: Joi.boolean(),
    Withdrawn: Joi.boolean(),
    BizarreBehavior: Joi.boolean(),
    Rigidity: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherBehavior", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Normal: Joi.boolean(),
    Slurred: Joi.boolean(),
    Pressured: Joi.boolean(),
    Tangential: Joi.boolean(),
    Incoherent: Joi.boolean(),
    Stutters: Joi.boolean(),
    OtherSpeech: Joi.boolean(),
    OtherSpeechDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherSpeech", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Euthymic: Joi.boolean(),
    Anxious: Joi.boolean(),
    Angry: Joi.boolean(),
    Depressed: Joi.boolean(),
    Euphoric: Joi.boolean(),
    Irritable: Joi.boolean(),
    Fearful: Joi.boolean(),
    OtherMood: Joi.boolean(),
    OtherMoodDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherMood", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    FullRange: Joi.boolean(),
    Restricted: Joi.boolean(),
    Blunted: Joi.boolean(),
    Flat: Joi.boolean(),
    Inappropriate: Joi.boolean(),
    OtherAffect: Joi.boolean(),
    OtherAffectDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherAffect", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Logical: Joi.boolean(),
    Preoccupations: Joi.boolean(),
    Delusions: Joi.boolean(),
    Hallucinations: Joi.boolean(),
    Racing: Joi.boolean(),
    Disorganized: Joi.boolean(),
    Concrete: Joi.boolean(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    OtherPerception: Joi.boolean(),
    OtherPerceptionDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherPerception", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    NoImpairment: Joi.boolean(),
    ShortAttentionSpan: Joi.boolean(),
    DifficultyConcentrating: Joi.boolean(),
    Distractibility: Joi.boolean(),
    MemoryImpairment: Joi.boolean(),
    LowIntelligence: Joi.boolean(),
    OtherCognition: Joi.boolean(),
    OtherCognitionDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherCognition", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AppropriateInsight: Joi.boolean(),
    Fair: Joi.boolean(),
    Impaired: Joi.boolean(),
    OtherInsight: Joi.boolean(),
    OtherInsightDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherInsight", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    MentalStatusComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    LethalityNA: Joi.boolean(),
    SelfAbusiveBehavior: Joi.label("Self-abusive behavior").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    SuicidalThreats: Joi.label("Suicidal threats").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    SuicideAttempt: Joi.label("Suicide attempt").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    CaregiverConcernsOfSelfHarm: Joi.label(
      "Parent/Caregiver concerns of suicide/self-harm"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    OtherConcernsOfSelfHarm: Joi.label(
      "Other expressed concerns of suicide/self-harm"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    CurrentSelfHarmRisk: Joi.label("Current Risk of Harm to Self").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    SelfHarmComments: Joi.label("Current Risk of Harm to Self comments").when(
      "LethalityNA",
      {
        is: false,
        then: Joi.when("SelfAbusiveBehavior", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
          .when("SuicidalThreats", {
            is: "None/Never",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          })
          .when("SuicideAttempt", {
            is: "None/Never",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          })
          .when("CaregiverConcernsOfSelfHarm", {
            is: "No",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          })
          .when("OtherConcernsOfOtherHarm", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("CurrentSelfHarmRisk", {
            is: "None Noted",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          }),
      }
    ),
    ThreatsToHarmOthers: Joi.label(
      "Threats to intentionally harm/endanger others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    ThoughtsOfHarm: Joi.label(
      "Thoughts of intentionally harming/endangering others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    ActsOfHarm: Joi.label("Acts of intentionally harm/endangering others").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    ActsOfHarmAnimals: Joi.label(
      "Acts of intentionally harm/endangering animals"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    ActsInvolvingWeapons: Joi.label("Acts involving weapons").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    CaregiverConcernOfOtherHarm: Joi.label(
      "Parent/Caregiver concerns of harm/endangering others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    OtherConcernsOfOtherHarm: Joi.label(
      "Other expressed concerns of harm/endangering others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    CurrentOtherHarmRisk: Joi.label("Current Risk of Harm to Others").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    OtherHarmComments: Joi.label(
      "Current Risk of Harm to Others comments"
    ).when("LethalityNA", {
      is: false,
      then: Joi.when("ThreatsToHarmOthers", {
        is: "None/Never",
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      })
        .when("ThoughtsOfHarm", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("ActsOfHarm", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("ActsOfHarmAnimals", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("ActsInvolvingWeapons", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("CaregiverConcernOfOtherHarm", {
          is: "No",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("OtherConcernsOfOtherHarm", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("CurrentOtherHarmRisk", {
          is: "None Noted",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        }),
    }),
    SafetyPlanStatus: Joi.label("Safety Plan Status").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    LethalityComments: Joi.label("Comments/Plan").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    TraumaSymptoms: Joi.boolean(),
    TraumaticExposure: Joi.boolean(),
    AvoidantTrauma: Joi.boolean(),
    HypervigilanceTrauma: Joi.boolean(),
    IntrusiveDreams: Joi.boolean(),
    NegativeThoughts: Joi.boolean(),
    CocentrationProblems: Joi.boolean(),
    RecklessBehaviorTrauma: Joi.boolean(),
    SleepDisturbancesTrauma: Joi.boolean(),
    OtherTrauma: Joi.boolean(),
    OtherTraumaDetails: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.when("OtherTrauma", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    TraumaSymptomsFrequency: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    TraumaSymptomsIntensity: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    TraumaSymptomsDuration: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    TraumaSymptomsOnset: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    AnxietyDisorder: Joi.boolean(),
    AnxietyDisorderExcessWorry: Joi.boolean(),
    AnxietyDisorderEasilyFatigued: Joi.boolean(),
    MuscleTension: Joi.boolean(),
    Overworried: Joi.boolean(),
    AnxietyDisorderDifficultyConcentrating: Joi.boolean(),
    SleepDisturbancesAnxiety: Joi.boolean(),
    RestlessAnxiety: Joi.boolean(),
    Irritability: Joi.boolean(),
    OtherAnxiety: Joi.boolean(),
    OtherAnxietyDetails: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.when("OtherAnxiety", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AnxietyDisorderFrequency: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    AnxietyDisorderIntensity: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    AnxietyDisorderDuration: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    DepressionSymptoms: Joi.boolean(),
    DepressedMood: Joi.boolean(),
    SleepChanges: Joi.boolean(),
    Guilt: Joi.boolean(),
    DiminishedInterest: Joi.boolean(),
    PurposelessMovement: Joi.boolean(),
    DifficultyConcentratingDepression: Joi.boolean(),
    WeightChanges: Joi.boolean(),
    FatigueDepression: Joi.boolean(),
    ThoughtsOfDeath: Joi.boolean(),
    OtherDepression: Joi.boolean(),
    OtherDepressionDetails: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.when("OtherDepression", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DepressionFrequency: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    DepressionIntensity: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    DepressionDuration: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    AttentionHyperactivity: Joi.boolean(),
    AttentionHyperactivityEasilyDistracted: Joi.boolean(),
    DifficultyFollowThrough: Joi.boolean(),
    Forgetful: Joi.boolean(),
    DifficultyListening: Joi.boolean(),
    DisorganizedAttention: Joi.boolean(),
    Fidgety: Joi.boolean(),
    LackOfDetails: Joi.boolean(),
    LosesThings: Joi.boolean(),
    InterruptsOthers: Joi.boolean(),
    UnableToSitStill: Joi.boolean(),
    ExcessiveTalking: Joi.boolean(),
    DifficultyWaiting: Joi.boolean(),
    OtherAttention: Joi.boolean(),
    OtherAttentionDetails: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.when("OtherAttention", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AttentionHyperactivityFrequency: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.string().required(),
    }),
    AttentionHyperactivityIntensity: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.string().required(),
    }),
    AttentionHyperactivityDuration: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.string().required(),
    }),
    SU: Joi.boolean(),
    PatternOfSubstanceUse: Joi.boolean(),
    DesiresCutDownUse: Joi.boolean(),
    TimeSpentObtaining: Joi.boolean(),
    Cravings: Joi.boolean(),
    FailureOfResponsibilities: Joi.boolean(),
    NegativeImpact: Joi.boolean(),
    AbandonsActivities: Joi.boolean(),
    Tolerance: Joi.boolean(),
    SUWithdrawal: Joi.boolean(),
    SUOther: Joi.boolean(),
    SUOtherDetails: Joi.when("SU", {
      is: true,
      then: Joi.when("SUOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    SubstanceUseFrequency: Joi.when("SU", {
      is: true,
      then: Joi.string().required(),
    }),
    SubstanceUseIntensity: Joi.when("SU", {
      is: true,
      then: Joi.string().required(),
    }),
    SubstanceUseDuration: Joi.when("SU", {
      is: true,
      then: Joi.string().required(),
    }),
    DMDD: Joi.boolean(),
    Temper: Joi.boolean(),
    OutsideOutbursts: Joi.boolean(),
    FrequentOutbursts: Joi.boolean(),
    DMDDIrritable: Joi.boolean(),
    OutburstsAroundOthers: Joi.boolean(),
    DMDDOther: Joi.boolean(),
    DMDDOtherDetails: Joi.when("DMDD", {
      is: true,
      then: Joi.when("DMDDOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DMDDFrequency: Joi.when("DMDD", {
      is: true,
      then: Joi.string().required(),
    }),
    DMDDIntensity: Joi.when("DMDD", {
      is: true,
      then: Joi.string().required(),
    }),
    DMDDDuration: Joi.when("DMDD", { is: true, then: Joi.string().required() }),
    ConductDisorder: Joi.boolean(),
    Aggression: Joi.boolean(),
    DestructionOfProperty: Joi.boolean(),
    Theft: Joi.boolean(),
    SeriousViolations: Joi.boolean(),
    OtherConductDisorder: Joi.boolean(),
    OtherConductDisorderDetails: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.when("OtherConductDisorder", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    ConductDisorderFrequency: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    ConductDisorderIntensity: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    ConductDisorderDuration: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    ODD: Joi.boolean(),
    IrritableODD: Joi.boolean(),
    Argumentative: Joi.boolean(),
    Vindictive: Joi.boolean(),
    OtherODD: Joi.boolean(),
    OtherODDDetails: Joi.when("ODD", {
      is: true,
      then: Joi.when("OtherODD", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    ODDFrequency: Joi.when("ODD", { is: true, then: Joi.string().required() }),
    ODDIntensity: Joi.when("ODD", { is: true, then: Joi.string().required() }),
    ODDDuration: Joi.when("ODD", { is: true, then: Joi.string().required() }),
    OCD: Joi.boolean(),
    OCDPresence: Joi.boolean(),
    Obsessions: Joi.boolean(),
    TimeConsuming: Joi.boolean(),
    Compulsions: Joi.boolean(),
    ReduceAnxiety: Joi.boolean(),
    SuppressUrges: Joi.boolean(),
    OCDOther: Joi.boolean(),
    OCDOtherDetails: Joi.when("OCD", {
      is: true,
      then: Joi.when("OCDOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    OCDFrequency: Joi.when("OCD", { is: true, then: Joi.string().required() }),
    OCDIntensity: Joi.when("OCD", { is: true, then: Joi.string().required() }),
    OCDDuration: Joi.when("OCD", { is: true, then: Joi.string().required() }),
    PanicDisorder: Joi.boolean(),
    PoundingHeart: Joi.boolean(),
    PanicDisorderSweating: Joi.boolean(),
    Trembling: Joi.boolean(),
    ShortnessOfBreath: Joi.boolean(),
    Choking: Joi.boolean(),
    ChestPain: Joi.boolean(),
    PanicDisorderNausea: Joi.boolean(),
    Dizzy: Joi.boolean(),
    Chills: Joi.boolean(),
    Derealization: Joi.boolean(),
    FearOfCrazy: Joi.boolean(),
    FearOfDying: Joi.boolean(),
    PanicDisorderOther: Joi.boolean(),
    PanicDisorderOtherDetails: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.when("PanicDisorderOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    PanicDisorderFrequency: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    PanicDisorderIntensity: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    PanicDisorderDuration: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    Phobias: Joi.boolean(),
    PhobiasSpecificFear: Joi.boolean(),
    ImmediateFear: Joi.boolean(),
    PhobiasAvoidance: Joi.boolean(),
    FearExaggerated: Joi.boolean(),
    PhobiasOther: Joi.boolean(),
    PhobiasOtherDetails: Joi.when("Phobias", {
      is: true,
      then: Joi.when("PhobiasOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    PhobiasFrequency: Joi.when("Phobias", {
      is: true,
      then: Joi.string().required(),
    }),
    PhobiasIntensity: Joi.when("Phobias", {
      is: true,
      then: Joi.string().required(),
    }),
    PhobiasDuration: Joi.when("Phobias", {
      is: true,
      then: Joi.string().required(),
    }),
    DI: Joi.boolean(),
    DILowIQ: Joi.boolean(),
    DISensoryImpairments: Joi.boolean(),
    DISpeechDelays: Joi.boolean(),
    DIMotorCoordinationDelays: Joi.boolean(),
    DILearningDisorder: Joi.boolean(),
    DISpatialDelays: Joi.boolean(),
    DevelopmentalImpairmentsOther: Joi.boolean(),
    DevelopmentalImpairmentsOtherDetails: Joi.when("DI", {
      is: true,
      then: Joi.when("DevelopmentalImpairmentsOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DevelopmentalImpairmentsDetails: Joi.when("DI", {
      is: true,
      then: Joi.when("DILowIQ", { is: true, then: Joi.required() })
        .when("DISensoryImpairments", { is: true, then: Joi.required() })
        .when("DISpeechDelays", { is: true, then: Joi.required() })
        .when("DIMotorCoordinationDelays", { is: true, then: Joi.required() })
        .when("DILearningDisorder", { is: true, then: Joi.required() })
        .when("DISpatialDelays", { is: true, then: Joi.required() }),
    }),
    OtherSymptoms: Joi.boolean(),
    OtherSymptomsDetails: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    OtherSymptomsFrequency: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    OtherSymptomsIntensity: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    OtherSymptomsDuration: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    ClinicalNarrativeSummary: Joi.string().required(),
    ClinicalNarrativeSummaryComments: Joi.string().allow(null, ""),
    DiagnosisDetails: Joi.string().required(),
    SeriousDisturbance: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    NoAdditionalNeeds: Joi.boolean(),
    AdditionalNeeds: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("NoAdditionalNeeds", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    TreatmentRecommendations: Joi.string().required(),
    DiagnosisEducation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    RecommendationEducation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    ClientAgrees: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    FamilyAgress: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
  },
  "626F5D27-FAD5-EC11-997E-DC98408D5418": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SexAssignedAtBirth: Joi.string().label("Sex Assigned at Birth").required(),
    SexAssignedAtBirthDetails: Joi.string()
      .label("Sex Assigned at Birth Specifics")
      .when("SexAssignedAtBirth", {
        is: "Sex not listed",
        then: Joi.required(),
      }),
    Pronouns: Joi.string().label("Pronouns").required(),
    PronounsDescription: Joi.string()
      .label("Pronouns description")
      .when("Pronouns", {
        is: "Prefer to self-describe",
        then: Joi.required(),
      }),
    GenderIdentity: Joi.string().label("Gender Identity").required(),
    GenderIdentityDescription: Joi.string()
      .label("Gender Identity description")
      .when("GenderIdentity", {
        is: "Identity not listed",
        then: Joi.required(),
      }),
    DateCompleted: Joi.string().label("Date Completed").required(),
    PSDType: Joi.string().label("Type of PSD").required(),
    ReviewReason: Joi.string()
      .label("Review Reason")
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ISClient: Joi.boolean(),
    ISParent: Joi.boolean(),
    ISGuardian: Joi.boolean(),
    ISCaregiver: Joi.boolean(),
    ISPhysician: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISCPS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.string()
      .label("Other Information Source")
      .when("ISOther", { is: true, then: Joi.required() }),
    ReferralReason: Joi.string().label("Reason for Referral").required(),
    ReferralSource: Joi.string().label("Referral Source").required(),
    ReferralDate: Joi.string().label("Date of Referral").required(),
    AcceptDate: Joi.string().label("Date Accepted for Placement").required(),
    PresentingProblem: Joi.string()
      .label("Presenting Problem")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ClientProblem: Joi.string()
      .label("Client Description of Problem")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    CaregiverProblem: Joi.string()
      .label("Caregiver Description of Problem")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ClientStrengths: Joi.string()
      .label("Client Description of Strengths")
      .required(),
    ClientAbilities: Joi.string()
      .label("Client abilities, skills, and interests")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    FamilyVisitationNA: Joi.boolean(),
    MotherUnknown: Joi.boolean(),
    MotherName: Joi.label("Mother's Name").when("FamilyVisitationNA", {
      is: false,
      then: Joi.when("MotherUnknown", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    MotherPhone: Joi.label("Mother's Phone Number").when("FamilyVisitationNA", {
      is: false,
      then: Joi.when("MotherUnknown", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    MotherAddress: Joi.label("Mother's Address").when("FamilyVisitationNA", {
      is: false,
      then: Joi.when("MotherUnknown", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    MotherOtherContact: Joi.string().allow(""),
    MotherCulture: Joi.label("Mother's Religion/Culture").when(
      "FamilyVisitationNA",
      {
        is: false,
        then: Joi.when("MotherUnknown", {
          is: false,
          then: Joi.string().required(),
        }),
      }
    ),
    MotherContact: Joi.label("Type of Contact Allowed with Mother").when(
      "FamilyVisitationNA",
      {
        is: false,
        then: Joi.when("MotherUnknown", {
          is: false,
          then: Joi.string().required(),
        }),
      }
    ),
    MotherRestrictions: Joi.label("SAFY contact restrictions with Mother").when(
      "FamilyVisitationNA",
      {
        is: false,
        then: Joi.when("MotherUnknown", {
          is: false,
          then: Joi.string().required(),
        }),
      }
    ),
    FatherUnknown: Joi.boolean(),
    FatherName: Joi.label("Father's Name").when("FamilyVisitationNA", {
      is: false,
      then: Joi.when("FatherUnknown", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    FatherPhone: Joi.label("Father's Phone Number").when("FamilyVisitationNA", {
      is: false,
      then: Joi.when("FatherUnknown", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    FatherAddress: Joi.label("Father's Address").when("FamilyVisitationNA", {
      is: false,
      then: Joi.when("FatherUnknown", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    FatherOtherContact: Joi.string().allow(""),
    FatherCulture: Joi.label("Father's Religion/Culture").when(
      "FamilyVisitationNA",
      {
        is: false,
        then: Joi.when("FatherUnknown", {
          is: false,
          then: Joi.string().required(),
        }),
      }
    ),
    FatherContact: Joi.label("Type of Contact Allowed with Father").when(
      "FamilyVisitationNA",
      {
        is: false,
        then: Joi.when("FatherUnknown", {
          is: false,
          then: Joi.string().required(),
        }),
      }
    ),
    FatherRestrictions: Joi.label("SAFY contact restrictions with Father").when(
      "FamilyVisitationNA",
      {
        is: false,
        then: Joi.when("FatherUnknown", {
          is: false,
          then: Joi.string().required(),
        }),
      }
    ),
    SiblingsUnknown: Joi.boolean(),
    SiblingDetails: Joi.label("Siblings info").when("FamilyVisitationNA", {
      is: false,
      then: Joi.when("SiblingsUnknown", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    NoContact: Joi.string()
      .label("Anyone prohibited from contact")
      .when("FamilyVisitationNA", { is: false, then: Joi.required() }),
    NoContactPeople: Joi.string()
      .label("List of prohibited individuals")
      .when("NoContact", { is: "Yes", then: Joi.required() }),
    HaveVisitation: Joi.string()
      .label("Visitation with family")
      .when("FamilyVisitationNA", { is: false, then: Joi.required() }),
    VisitationDetails: Joi.string()
      .label("Visitation details")
      .when("HaveVisitation", { is: "Yes", then: Joi.required() }),
    OtherInfo: Joi.string()
      .label("Other visitation info")
      .when("FamilyVisitationNA", { is: false, then: Joi.required() }),
    PrimaryHouseholdType: Joi.string()
      .label("Primary Household Type")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    PrimaryHouseholdDetails: Joi.string()
      .label("Primary Household Details")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    PrimaryHouseholdDisciplinePracticesNA: Joi.boolean(),
    PrimaryHouseholdCaregiverCooperation: Joi.label("Cooperation").when(
      "PrimaryHouseholdDisciplinePracticesNA",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    PrimaryHouseholdSupervisionDifficulties: Joi.label(
      "Supervision difficulties"
    ).when("PrimaryHouseholdDisciplinePracticesNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    PrimaryHouseholdDisciplinePracticesDetails: Joi.label(
      "Discipline practices details"
    ).when("PrimaryHouseholdDisciplinePracticesNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    SecondaryHousehold: Joi.string()
      .label("Is there a secondary household?")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    SecondaryHouseholdType: Joi.string()
      .label("Secondary Household Type")
      .when("SecondaryHousehold", { is: "Yes", then: Joi.required() }),
    SecondaryHouseholdDetails: Joi.string()
      .label("Secondary Household Details")
      .when("SecondaryHousehold", { is: "Yes", then: Joi.required() }),
    SecondaryHouseholdDisciplinePracticesNA: Joi.boolean(),
    SecondaryHouseholdCaregiverCooperation: Joi.when("SecondaryHousehold", {
      is: "Yes",
      then: Joi.when("SecondaryHouseholdDisciplinePracticesNA", {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }),
    }),
    SecondaryHouseholdSupervisionDifficulties: Joi.when("SecondaryHousehold", {
      is: "Yes",
      then: Joi.when("SecondaryHouseholdDisciplinePracticesNA", {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }),
    }),
    SecondaryHouseholdDisciplinePracticesDetails: Joi.when(
      "SecondaryHousehold",
      {
        is: "Yes",
        then: Joi.when("SecondaryHouseholdDisciplinePracticesNA", {
          is: false,
          then: Joi.when("PSDType", {
            is: "Initial",
            then: Joi.string().required(),
          }).when("PSDType", {
            is: "Review/Update",
            then: Joi.string().required(),
          }),
        }),
      }
    ),
    AnySupportivePeople: Joi.string()
      .label("Are there any supportive people")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    SupportivePeopleDetails: Joi.string()
      .label("Supportive people details")
      .when("AnySupportivePeople", { is: "Yes", then: Joi.required() }),
    FamilyHistoryUnknown: Joi.boolean(),
    FamilyHistoryDetails: Joi.label("Family History").when(
      "FamilyHistoryUnknown",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    RemovedFromBioHome: Joi.string()
      .label("Has youth been removed from biological home")
      .required(),
    RemovedFromBioHomeFeelings: Joi.string()
      .label("Youth's feelings on being removed")
      .when("RemovedFromBioHome", { is: "Yes", then: Joi.required() }),
    CulturalGroup: Joi.string()
      .label("Identified cultural group")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    Traditions: Joi.string()
      .label("Special cultural traditions/celebrations/rituals")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    TraditionsComments: Joi.string()
      .label(
        "Comments regarding special cultural traditions/celebrations/rituals"
      )
      .when("Traditions", { is: "Yes", then: Joi.required() }),
    LanguagesSpoken: Joi.string().label("Languages spoken").required(),
    FamilyValues: Joi.string()
      .label("Family values")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    NegativeCulturalExperience: Joi.string()
      .label("Negative experiences due to customs/ethnicity/race/SES")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    NegativeCulturalExperienceComments: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("NegativeCulturalExperience", {
        is: "Yes",
        then: Joi.string().required().label("Negative experience comments"),
      }),
    }),
    InFosterCare: Joi.string().label("Youth in foster care?").required(),
    PlacesLived: Joi.string()
      .label("Places lived")
      .when("InFosterCare", { is: "Yes", then: Joi.required() }),
    CulturalDifferences: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.string().required().label("Cultural differences"),
    }),
    CulturalDifferencesComments: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("CulturalDifferences", {
        is: "Yes",
        then: Joi.string().required().label("Cultural differences comments"),
      }),
    }),
    PermanencyPlan: Joi.string()
      .label("Permanency Plan")
      .when("InFosterCare", { is: "Yes", then: Joi.required() }),
    PermanencyPlanOther: Joi.string()
      .label("Permanency Plan details")
      .when("PermanencyPlan", { is: "Other", then: Joi.required() }),
    Religious: Joi.string()
      .label("Religious or spiritual belief system")
      .required(),
    ReligiousComments: Joi.string()
      .label("Religious or spiritual belief system comments")
      .when("Religious", { is: "Yes", then: Joi.required() }),
    PHNoProblems: Joi.boolean(),
    PHPrenatalCare: Joi.label("Prenatal Care").when("PHNoProblems", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    PHPrenatalCareComments: Joi.string()
      .label("Prenatal Care comments")
      .when("PHPrenatalCare", { is: "No", then: Joi.required() }),
    PHExposure: Joi.label("Exposure to alcohol, tobacco, and other drugs").when(
      "PHNoProblems",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    PHExposureComments: Joi.string()
      .label(
        "Comments related to mother's exposure to alcohol, tobacco, and other drugs"
      )
      .when("PHExposure", { is: "Yes", then: Joi.required() }),
    PHTrauma: Joi.label("History of significant trauma during pregnancy").when(
      "PHNoProblems",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    PHTraumaComments: Joi.string()
      .label("History of significant trauma during pregnancy comments")
      .when("PHTrauma", { is: "Yes", then: Joi.required() }),
    PHComplications: Joi.label("Birth complications").when("PHNoProblems", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    PHComplicationsComments: Joi.string()
      .label("Birth complications comments")
      .when("PHComplications", { is: "Yes", then: Joi.required() }),
    PHConcerns: Joi.label("Medical concerns").when("PHNoProblems", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    PHConcernsComments: Joi.string()
      .label("Medical concerns comments")
      .when("PHConcerns", { is: "Yes", then: Joi.required() }),
    DevelopmentalDelays: Joi.string()
      .label("Developmental delays")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    DevelopmentalDelaysDetails: Joi.string()
      .label("Developmental Delays details")
      .when("DevelopmentalDelays", { is: "Yes", then: Joi.required() }),
    SpecializedServices: Joi.string()
      .label("Specialized Services")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    SpecializedServicesDetails: Joi.string()
      .label("Specialized Services details")
      .when("SpecializedServices", { is: "Yes", then: Joi.required() }),
    EducationStatus: Joi.string().label("Education status").required(),
    SchoolName: Joi.string().label("School Name").when("EducationStatus", {
      is: "Currently Enrolled in School/Client is School Aged",
      then: Joi.required(),
    }),
    CurrentGrade: Joi.string().label("Current Grade").when("EducationStatus", {
      is: "Currently Enrolled in School/Client is School Aged",
      then: Joi.required(),
    }),
    SchoolTransfer: Joi.string()
      .label("Will youth be transferred")
      .when("EducationStatus", {
        is: "Currently Enrolled in School/Client is School Aged",
        then: Joi.required(),
      }),
    BIDMeetingInfo: Joi.string()
      .label("BID Meeting info")
      .when("SchoolTransfer", {
        is: "BID Meeting Needed",
        then: Joi.required(),
      }),
    SchoolDecisionRights: Joi.string()
      .label("Educational decision rights")
      .when("EducationStatus", {
        is: "Currently Enrolled in School/Client is School Aged",
        then: Joi.required(),
      }),
    RegularClassroom: Joi.string()
      .label("Regular Classroom")
      .when("EducationStatus", {
        is: "Currently Enrolled in School/Client is School Aged",
        then: Joi.required(),
      }),
    Active504Plan: Joi.string()
      .label("Active 504 Plan")
      .when("EducationStatus", {
        is: "Currently Enrolled in School/Client is School Aged",
        then: Joi.required(),
      }),
    ActiveIEP: Joi.string().label("Active IEP").when("EducationStatus", {
      is: "Currently Enrolled in School/Client is School Aged",
      then: Joi.required(),
    }),
    DisciplineConcerns: Joi.string()
      .label("Discipline Concerns")
      .when("EducationStatus", {
        is: "Currently Enrolled in School/Client is School Aged",
        then: Joi.required(),
      }),
    DisciplineConcernsDetails: Joi.string()
      .label("Discipline concerns details")
      .when("DisciplineConcerns", { is: "Yes", then: Joi.required() }),
    Awards: Joi.string().label("Awards").when("EducationStatus", {
      is: "Currently Enrolled in School/Client is School Aged",
      then: Joi.required(),
    }),
    AwardsDetails: Joi.string()
      .label("Awards details")
      .when("Awards", { is: "Yes", then: Joi.required() }),
    SchoolAttitude: Joi.string()
      .label("Attitude toward school")
      .when("EducationStatus", {
        is: "Currently Enrolled in School/Client is School Aged",
        then: Joi.required(),
      }),
    CurrentlyEmployed: Joi.string()
      .label("Currently employed")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ADLNA: Joi.boolean(),
    MoneyManagement: Joi.label("Money management").when("ADLNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    FoodManagement: Joi.label("Food management").when("ADLNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    Hygiene: Joi.label("Personal appearance and hygiene").when("ADLNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    Health: Joi.label("Health awareness/Personal Health").when("ADLNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    Housekeeping: Joi.label("Housekeeping").when("ADLNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    ResourceKnowledge: Joi.label("Knowledge of community resources").when(
      "ADLNA",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    TimeManagement: Joi.label("Time Management").when("ADLNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    Interaction: Joi.label("Interactions with Others").when("ADLNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    SkillsComments: Joi.label("Skill comments").when("ADLNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    RelationshipsNA: Joi.boolean(),
    CoopSkills: Joi.label("Cooperative play skills").when("RelationshipsNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    CommunicationSkills: Joi.label("Communication and interaction skills").when(
      "RelationshipsNA",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    EmotionalUnderstanding: Joi.label(
      "Emotional understanding and self-regulation skills"
    ).when("RelationshipsNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    ProblemSolving: Joi.label("Social problem-solving skills").when(
      "RelationshipsNA",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    ConflictResolution: Joi.label("Conflict resolution skills").when(
      "RelationshipsNA",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    DecisionMakingSkills: Joi.label("Decision making skills").when(
      "RelationshipsNA",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    RelationshipSkillsComments: Joi.label("Relationship skills comments").when(
      "RelationshipsNA",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    Bullied: Joi.label("History of being bullied").when("RelationshipsNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    BulliedDetails: Joi.string()
      .label("Bullied comments")
      .when("Bullied", { is: "Yes", then: Joi.required() }),
    AcceptedByPeers: Joi.label("Accepted by peer group").when(
      "RelationshipsNA",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    AcceptedByPeersDetails: Joi.string()
      .label("Peer group comments")
      .when("AcceptedByPeers", { is: "No", then: Joi.required() }),
    NegativeAssociations: Joi.label("Negative peer group associations").when(
      "RelationshipsNA",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    NegativeAssociationsDetails: Joi.string()
      .label("Negative associations comments")
      .when("NegativeAssociations", { is: "Yes", then: Joi.required() }),
    LegalNA: Joi.boolean(),
    LegalInvolvement: Joi.label("Legal involvement").when("LegalNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    OnProbation: Joi.string()
      .label("On probation or parole")
      .when("LegalInvolvement", { is: "Yes", then: Joi.required() }),
    CPSInvolvement: Joi.label("CPS Involvement").when("LegalNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    CPSInvolvementDetails: Joi.string()
      .label("CPS Involvmenet details")
      .when("CPSInvolvement", { is: "Current", then: Joi.required() })
      .when("CPSInvolvement", { is: "Historical", then: Joi.required() }),
    CaseworkerName: Joi.string()
      .label("Caseworker Name")
      .when("LegalNA", { is: false, then: Joi.required() }),
    CaseworkerPhone: Joi.string()
      .label("Caseworker Phone Number")
      .when("LegalNA", { is: false, then: Joi.required() }),
    GALName: Joi.string()
      .label("GAL Name")
      .when("LegalNA", { is: false, then: Joi.required() }),
    GALPhone: Joi.string()
      .label("GAL Phone Number")
      .when("LegalNA", { is: false, then: Joi.required() }),
    FirstEntry: Joi.string().label("Is client's 1st entry").required(),
    MedicalDecisionRights: Joi.string()
      .label("Medical decision rights")
      .required(),
    PCP: Joi.string().label("Primary Care Physician").required(),
    PCPPhone: Joi.string().label("Primary Care Physician Phone").required(),
    LastMedicalExamDate: Joi.string()
      .label("Date of last medical exam")
      .required(),
    LastDentalExamDate: Joi.string()
      .label("Date of last dental exam")
      .required(),
    MedicalInfoReceived: Joi.string().label("Medical info received").required(),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.string()
      .label("Allergies")
      .when("Allergies", { is: true, then: Joi.required() }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.string()
      .label("Medical Conditions/Concerns")
      .when("MedicalConditions", { is: true, then: Joi.required() }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.string()
      .label("Nutritional Concerns")
      .when("NutritionalConcerns", { is: true, then: Joi.required() }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.string()
      .label("Dental Concerns")
      .when("DentalConcerns", { is: true, then: Joi.required() }),
    Concussions: Joi.boolean(),
    ConcussionsDetails: Joi.string()
      .label("Concussions or Head Injuries")
      .when("Concussions", { is: true, then: Joi.required() }),
    ConcernsAttention: Joi.boolean(),
    ConcernsAttentionDetails: Joi.string()
      .label("Health concerns details")
      .when("ConcernsAttention", { is: "Yes", then: Joi.required() }),
    Hospitalizations: Joi.boolean(),
    HospitalizationsDetails: Joi.string()
      .label("Hospitalization details")
      .when("Hospitalizations", { is: "Yes", then: Joi.required() }),
    Height: Joi.string().label("Height").required(),
    Weight: Joi.string().label("Weight").required(),
    HairColor: Joi.string().label("Hair Color").required(),
    EyeColor: Joi.string().label("Eye Color").required(),
    Undiagnosed: Joi.string().label("Undiagnosed medical illness").required(),
    UndiagnosedComments: Joi.string()
      .label("Undiagnosed medical illness comments")
      .when("Undiagnosed", { is: "Yes", then: Joi.required() }),
    MedicalComments: Joi.string().label("Medical comments").allow(null, ""),
    AdvanceDirectives: Joi.string()
      .label("Advance directives")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    NoMedications: Joi.boolean(),
    CurrentMedicationDetails: Joi.string()
      .label("Current Medications")
      .when("NoMedications", { is: false, then: Joi.required() }),
    MedicationCompliance: Joi.label("Compliance with medication").when(
      "NoMedications",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    SideEffects: Joi.label("Side effects").when("NoMedications", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    SideEffectsDetails: Joi.string()
      .label("Side effects details")
      .when("SideEffects", { is: "Yes", then: Joi.required() }),
    PsychotropicMeds: Joi.label("Past Psychotropic Medications").when(
      "NoMedications",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    PsychotropicMedsDetails: Joi.string()
      .label("Past Psychotropic Medications list")
      .when("PsychotropicMeds", { is: "Yes", then: Joi.required() }),
    SexualHistoryNA: Joi.boolean(),
    SexualOrientation: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required().label("Sexual orientation"),
      }),
    }),
    SexualOrientationDetails: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexualOrientation", {
          is: "Orientation not listed",
          then: Joi.string().required().label("Sexual Orientation specifics"),
        }),
      }),
    }),
    SexuallyActive: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required().label("Sexually active"),
      }),
    }),
    CaregiverAware: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string()
            .required()
            .label("Caregiver aware of sexual history"),
        }),
      }),
    }),
    CaregiverAwareComments: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.when("CaregiverAware", {
            is: "Yes",
            then: Joi.string().required().label("Caregiver comments"),
          }),
        }),
      }),
    }),
    UseProtection: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required().label("Use of protection"),
        }),
      }),
    }),
    UseProtectionComments: Joi.string()
      .label("Protection comments")
      .when("UseProtection", { is: "Yes", then: Joi.required() }),
    AwareOfRisks: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required().label("Awareness of sexual risks"),
        }),
      }),
    }),
    AwareOfRisksComments: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.when("AwareOfRisks", {
            is: "Yes",
            then: Joi.string().required().label("Sexual risks comments"),
          }),
        }),
      }),
    }),
    Pregnancy: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required().label("Pregnancy"),
        }),
      }),
    }),
    PregnancyComments: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.when("Pregnancy", {
            is: "Current",
            then: Joi.string().required().label("Pregnancy comments"),
          }),
        }),
      }),
    }),
    Children: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required().label("Children"),
        }),
      }),
    }),
    ChildrenComments: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.when("Children", {
            is: "Yes",
            then: Joi.string().required().label("Children comments"),
          }),
        }),
      }),
    }),
    SexualAbuseVictim: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required().label("Victim of sexual abuse"),
      }),
    }),
    SexualAbuseVictimComments: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexualAbuseVictim", {
          is: "Yes",
          then: Joi.string().required().label("Sexual abuse comments"),
        }),
      }),
    }),
    SexuallyActingOut: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string()
          .required()
          .label("Sexually acting out/reactive behavior"),
      }),
    }),
    SexuallyAbusive: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required().label("Sexually abusive"),
      }),
    }),
    SexuallyAbusiveComments: Joi.when("PSDType", {
      is: Joi.any().required().valid("Initial", "Review/Update"),
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActingOut", {
          is: "Yes",
          then: Joi.string().required().label("Sexually abusive comments"),
        }).when("SexuallyAbusive", {
          is: "Yes",
          then: Joi.string().required().label("Sexually abusive comments"),
        }),
      }),
    }),
    MentalHealthNA: Joi.boolean(),
    PastMentalHealthTreatment: Joi.label(
      "Past mental health counseling/treatment"
    ).when("MentalHealthNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    PastMentalHealthTreatmentComments: Joi.string()
      .label("Past mental health counseling/treatment comments")
      .when("PastMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    PastResidentialFacilityPlacement: Joi.label(
      "Past placement in a group home/residential treatment facility"
    ).when("MentalHealthNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    PastResidentialFacilityPlacementComments: Joi.string()
      .label("Past placement comments")
      .when("PastResidentialFacilityPlacement", {
        is: "Yes",
        then: Joi.required(),
      }),
    PastPsychiatricHospitalPlacement: Joi.label(
      "Past placement in a psychiatric hospital/unit"
    ).when("MentalHealthNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    PastPsychiatricHospitalPlacementComments: Joi.string()
      .label("Past placement comments")
      .when("PastPsychiatricHospitalPlacement", {
        is: "Yes",
        then: Joi.required(),
      }),
    InvoluntaryTreatment: Joi.label(
      "History of involuntary/court-ordered treatment"
    ).when("MentalHealthNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    InvoluntaryTreatmentComments: Joi.string()
      .label("Involuntary treatment comments")
      .when("InvoluntaryTreatment", { is: "Yes", then: Joi.required() }),
    MentalHealthDiagnosis: Joi.when("MentalHealthNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    SubstanceUseNA: Joi.boolean(),
    SubstanceUse: Joi.label("Current or past use of Alcohol/Drugs").when(
      "SubstanceUseNA",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    TobaccoUse: Joi.label("Tobacco related products").when("SubstanceUseNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    AlcoholUse: Joi.label("Alcohol").when("SubstanceUseNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    IllegalDrugUse: Joi.label("Illegal drugs").when("SubstanceUseNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    PrescriptionDrugUse: Joi.label("Prescription drugs").when(
      "SubstanceUseNA",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    SyntheticDrugUse: Joi.label("Synthetic drugs/substances").when(
      "SubstanceUseNA",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    SubstanceUseTreatmentHistory: Joi.label(
      "Medical treatment/hospitalization due to use"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    SubstanceUseWithdrawal: Joi.label("Withdrawal").when("SubstanceUseNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    DetoxSymptoms: Joi.label("Presenting detox issues").when("SubstanceUseNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    OverdoseHistory: Joi.label("Overdose history").when("SubstanceUseNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    SubstanceUseLegalInvolvement: Joi.label(
      "Legal charges/involvement due to use"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    SubstanceUseProblems: Joi.label(
      "Use has caused problems in different areas of your life"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    SubstanceUseHistoryComments: Joi.label(
      "Substance use history comments"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    SubstanceUseTreatment: Joi.label("Alcohol/drug related treatment").when(
      "SubstanceUseNA",
      {
        is: false,
        then: Joi.when("PSDType", {
          is: "Initial",
          then: Joi.string().required(),
        }).when("PSDType", {
          is: "Review/Update",
          then: Joi.string().required(),
        }),
      }
    ),
    SubstanceUseTreatmentComments: Joi.string()
      .label("Alcohol/drug related treatment comments")
      .when("SubstanceUseTreatment", { is: "Yes", then: Joi.required() }),
    AppropriateAppearance: Joi.boolean(),
    Neat: Joi.boolean(),
    Disheveled: Joi.boolean(),
    BizarreAppearance: Joi.boolean(),
    OtherAppearance: Joi.boolean(),
    OtherAppearanceDetails: Joi.string()
      .label("Other Appearance details")
      .when("OtherAppearance", { is: true, then: Joi.required() }),
    Cooperative: Joi.boolean(),
    Guarded: Joi.boolean(),
    Hyperactive: Joi.boolean(),
    Agitated: Joi.boolean(),
    Paranoid: Joi.boolean(),
    Tics: Joi.boolean(),
    Impulsive: Joi.boolean(),
    Aggressive: Joi.boolean(),
    Withdrawn: Joi.boolean(),
    BizarreBehavior: Joi.boolean(),
    Rigidity: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.string()
      .label("Other Behavior details")
      .when("OtherBehavior", { is: true, then: Joi.required() }),
    Normal: Joi.boolean(),
    Slurred: Joi.boolean(),
    Pressured: Joi.boolean(),
    Tangential: Joi.boolean(),
    Incoherent: Joi.boolean(),
    Stutters: Joi.boolean(),
    OtherSpeech: Joi.boolean(),
    OtherSpeechDetails: Joi.string()
      .label("Other Speech details")
      .when("OtherSpeech", { is: true, then: Joi.required() }),
    Euthymic: Joi.boolean(),
    Anxious: Joi.boolean(),
    Angry: Joi.boolean(),
    Depressed: Joi.boolean(),
    Euphoric: Joi.boolean(),
    Irritable: Joi.boolean(),
    Fearful: Joi.boolean(),
    OtherMood: Joi.boolean(),
    OtherMoodDetails: Joi.string()
      .label("Other Mood details")
      .when("OtherMood", { is: true, then: Joi.required() }),
    FullRange: Joi.boolean(),
    Restricted: Joi.boolean(),
    Blunted: Joi.boolean(),
    Flat: Joi.boolean(),
    Inappropriate: Joi.boolean(),
    OtherAffect: Joi.boolean(),
    OtherAffectDetails: Joi.string()
      .label("Other Affect details")
      .when("OtherAffect", { is: true, then: Joi.required() }),
    Logical: Joi.boolean(),
    Preoccupations: Joi.boolean(),
    Delusions: Joi.boolean(),
    Hallucinations: Joi.boolean(),
    Racing: Joi.boolean(),
    Disorganized: Joi.boolean(),
    Concrete: Joi.boolean(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    OtherPerception: Joi.boolean(),
    OtherPerceptionDetails: Joi.string()
      .label("Other Thought Process/Perception details")
      .when("OtherPerception", { is: true, then: Joi.required() }),
    NoImpairment: Joi.boolean(),
    ShortAttentionSpan: Joi.boolean(),
    DifficultyConcentrating: Joi.boolean(),
    Distractibility: Joi.boolean(),
    MemoryImpairment: Joi.boolean(),
    LowIntelligence: Joi.boolean(),
    OtherCognition: Joi.boolean(),
    OtherCognitionDetails: Joi.string()
      .label("Other Cognition/Intellectual Functioning details")
      .when("OtherCognition", { is: true, then: Joi.required() }),
    AppropriateInsight: Joi.boolean(),
    Fair: Joi.boolean(),
    Impaired: Joi.boolean(),
    OtherInsight: Joi.boolean(),
    OtherInsightDetails: Joi.string()
      .label("Other Insight/Judgment details")
      .when("OtherInsight", { is: true, then: Joi.required() }),
    MentalStatusComments: Joi.string()
      .label("Mental Status comments")
      .when("PSDType", { is: "Initial", then: Joi.required() })
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    Unsupervised: Joi.string().label("Youth left unsupervised").required(),
    UnsupervisedComments: Joi.string()
      .label("Unsupervised details")
      .when("Unsupervised", { is: "Yes", then: Joi.required() }),
    OtherSupervision: Joi.string().label("Other supervision needs"),
    LethalityNA: Joi.boolean(),
    SelfAbusiveBehavior: Joi.string()
      .label("Self-abusive behavior")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicidalThreats: Joi.string()
      .label("Suicidal threats")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicideAttempt: Joi.string()
      .label("Suicide attempt")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CaregiverConcernsOfSelfHarm: Joi.string()
      .label("Caregiver concerns of self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherConcernsOfSelfHarm: Joi.string()
      .label("Other concerns of self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentSelfHarmRisk: Joi.string()
      .label("Current Risk of Harm to Self")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SelfHarmComments: Joi.string()
      .label("Self-harm comments")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThreatsToHarmOthers: Joi.string()
      .label("Threats to harm others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThoughtsOfHarm: Joi.string()
      .label("Thoughts of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarm: Joi.string()
      .label("Acts of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarmAnimals: Joi.string()
      .label("Acts of harming animals")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsInvolvingWeapons: Joi.string()
      .label("Acts involving weapons")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CaregiverConcernOfOtherHarm: Joi.string()
      .label("Caregiver concerns of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherConcernsOfOtherHarm: Joi.string()
      .label("Other concerns of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentOtherHarmRisk: Joi.string()
      .label("Current Risk of Harm to Others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherHarmComments: Joi.string()
      .label("Threat to others comments")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    TraumaNA: Joi.boolean(),
    TraumaHistory: Joi.label("Trauma History").when("TraumaNA", {
      is: false,
      then: Joi.when("PSDType", {
        is: "Initial",
        then: Joi.string().required(),
      }).when("PSDType", {
        is: "Review/Update",
        then: Joi.string().required(),
      }),
    }),
    SocialSupports: Joi.boolean(),
    SenseOfMastery: Joi.boolean(),
    CaregiverStability: Joi.boolean(),
    StrongSpiritualBeliefs: Joi.boolean(),
    InterpersonalSkills: Joi.boolean(),
    PositiveOutlook: Joi.boolean(),
    PlacementStability: Joi.boolean(),
    Pets: Joi.boolean(),
    ValidatingExperiences: Joi.boolean(),
    Resources: Joi.boolean(),
    TiesToExtendedFamily: Joi.boolean(),
    Adaptability: Joi.boolean(),
    SecureAttachments: Joi.boolean(),
    StrongCulturalIdentity: Joi.boolean(),
    NoTraumaProtectiveFactors: Joi.boolean(),
    CopingStrategies: Joi.string()
      .label("Coping strategies")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    Triggers: Joi.string()
      .label("Triggers")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    TraumaSymptoms: Joi.boolean(),
    TraumaticExposure: Joi.boolean(),
    AvoidantTrauma: Joi.boolean(),
    HypervigilanceTrauma: Joi.boolean(),
    IntrusiveDreams: Joi.boolean(),
    NegativeThoughts: Joi.boolean(),
    CocentrationProblems: Joi.boolean(),
    RecklessBehaviorTrauma: Joi.boolean(),
    SleepDisturbancesTrauma: Joi.boolean(),
    OtherTrauma: Joi.boolean(),
    OtherTraumaDetails: Joi.string()
      .label("Other Trauma Details")
      .when("OtherTrauma", { is: true, then: Joi.required() }),
    TraumaSymptomsFrequency: Joi.string()
      .label("Trauma Symptoms Frequency")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsIntensity: Joi.string()
      .label("Trauma Symptoms Intensity")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsDuration: Joi.string()
      .label("Trauma Symptoms Duration")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsOnset: Joi.string()
      .label("Trauma Symptoms Onset")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    AnxietyDisorder: Joi.boolean(),
    AnxietyDisorderExcessWorry: Joi.boolean(),
    AnxietyDisorderEasilyFatigued: Joi.boolean(),
    MuscleTension: Joi.boolean(),
    Overworried: Joi.boolean(),
    AnxietyDisorderDifficultyConcentrating: Joi.boolean(),
    SleepDisturbancesAnxiety: Joi.boolean(),
    RestlessAnxiety: Joi.boolean(),
    Irritability: Joi.boolean(),
    OtherAnxiety: Joi.boolean(),
    OtherAnxietyDetails: Joi.string()
      .label("Other Anxiety Details")
      .when("OtherAnxiety", { is: true, then: Joi.required() }),
    AnxietyDisorderFrequency: Joi.string()
      .label("Anxiety Frequency")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    AnxietyDisorderIntensity: Joi.string()
      .label("Anxiety Intensity")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    AnxietyDisorderDuration: Joi.string()
      .label("Anxiety Duration")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    DepressionSymptoms: Joi.boolean(),
    DepressedMood: Joi.boolean(),
    SleepChanges: Joi.boolean(),
    Guilt: Joi.boolean(),
    DiminishedInterest: Joi.boolean(),
    PurposelessMovement: Joi.boolean(),
    DifficultyConcentratingDepression: Joi.boolean(),
    WeightChanges: Joi.boolean(),
    FatigueDepression: Joi.boolean(),
    ThoughtsOfDeath: Joi.boolean(),
    OtherDepression: Joi.boolean(),
    OtherDepressionDetails: Joi.string()
      .label("Other Depression Details")
      .when("OtherDepression", { is: true, then: Joi.required() }),
    DepressionFrequency: Joi.string()
      .label("Depression Frequency")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    DepressionIntensity: Joi.string()
      .label("Depression Intensity")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    DepressionDuration: Joi.string()
      .label("Depression Duration")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    AttentionHyperactivity: Joi.boolean(),
    AttentionHyperactivityEasilyDistracted: Joi.boolean(),
    DifficultyFollowThrough: Joi.boolean(),
    Forgetful: Joi.boolean(),
    DifficultyListening: Joi.boolean(),
    DisorganizedAttention: Joi.boolean(),
    Fidgety: Joi.boolean(),
    LackOfDetails: Joi.boolean(),
    LosesThings: Joi.boolean(),
    InterruptsOthers: Joi.boolean(),
    UnableToSitStill: Joi.boolean(),
    ExcessiveTalking: Joi.boolean(),
    DifficultyWaiting: Joi.boolean(),
    OtherAttention: Joi.boolean(),
    OtherAttentionDetails: Joi.string()
      .label("Other Attention Details")
      .when("OtherAttention", { is: true, then: Joi.required() }),
    AttentionHyperactivityFrequency: Joi.string()
      .label("Attention Frequency")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    AttentionHyperactivityIntensity: Joi.string()
      .label("Attention Intensity")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    AttentionHyperactivityDuration: Joi.string()
      .label("Attention Duration")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    SU: Joi.boolean(),
    PatternOfSubstanceUse: Joi.boolean(),
    DesiresCutDownUse: Joi.boolean(),
    TimeSpentObtaining: Joi.boolean(),
    Cravings: Joi.boolean(),
    FailureOfResponsibilities: Joi.boolean(),
    NegativeImpact: Joi.boolean(),
    AbandonsActivities: Joi.boolean(),
    Tolerance: Joi.boolean(),
    SUWithdrawal: Joi.boolean(),
    SUOther: Joi.boolean(),
    SUOtherDetails: Joi.string()
      .label("Other Substance Use Details")
      .when("SUOther", { is: true, then: Joi.required() }),
    SubstanceUseFrequency: Joi.string()
      .label("Substance Use Frequency")
      .when("SU", { is: true, then: Joi.required() }),
    SubstanceUseIntensity: Joi.string()
      .label("Substance Use Intensity")
      .when("SU", { is: true, then: Joi.required() }),
    SubstanceUseDuration: Joi.string()
      .label("Substance Use Duration")
      .when("SU", { is: true, then: Joi.required() }),
    DMDD: Joi.boolean(),
    Temper: Joi.boolean(),
    OutsideOutbursts: Joi.boolean(),
    FrequentOutbursts: Joi.boolean(),
    DMDDIrritable: Joi.boolean(),
    OutburstsAroundOthers: Joi.boolean(),
    DMDDOther: Joi.boolean(),
    DMDDOtherDetails: Joi.string()
      .label("Other Disruptive Mood Dysregulation Disorder Details")
      .when("DMDDOther", { is: true, then: Joi.required() }),
    DMDDFrequency: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Frequency")
      .when("DMDD", { is: true, then: Joi.required() }),
    DMDDIntensity: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Intensity")
      .when("DMDD", { is: true, then: Joi.required() }),
    DMDDDuration: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Duration")
      .when("DMDD", { is: true, then: Joi.required() }),
    ConductDisorder: Joi.boolean(),
    Aggression: Joi.boolean(),
    DestructionOfProperty: Joi.boolean(),
    Theft: Joi.boolean(),
    SeriousViolations: Joi.boolean(),
    OtherConductDisorder: Joi.boolean(),
    OtherConductDisorderDetails: Joi.string()
      .label("Other Conduct Disorder Details")
      .when("OtherConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderFrequency: Joi.string()
      .label("Conduct Disorder Frequency")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderIntensity: Joi.string()
      .label("Conduct Disorder Intensity")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderDuration: Joi.string()
      .label("Conduct Disorder Duration")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ODD: Joi.boolean(),
    IrritableODD: Joi.boolean(),
    Argumentative: Joi.boolean(),
    Vindictive: Joi.boolean(),
    OtherODD: Joi.boolean(),
    OtherODDDetails: Joi.string()
      .label("Other Oppositional Defiance Disorder Details")
      .when("OtherODD", { is: true, then: Joi.required() }),
    ODDFrequency: Joi.string()
      .label("Oppositional Defiance Disorder Frequency")
      .when("ODD", { is: true, then: Joi.required() }),
    ODDIntensity: Joi.string()
      .label("Oppositional Defiance Disorder Intensity")
      .when("ODD", { is: true, then: Joi.required() }),
    ODDDuration: Joi.string()
      .label("Oppositional Defiance Disorder Duration")
      .when("ODD", { is: true, then: Joi.required() }),
    OCD: Joi.boolean(),
    OCDPresence: Joi.boolean(),
    Obsessions: Joi.boolean(),
    TimeConsuming: Joi.boolean(),
    Compulsions: Joi.boolean(),
    ReduceAnxiety: Joi.boolean(),
    SuppressUrges: Joi.boolean(),
    OCDOther: Joi.boolean(),
    OCDOtherDetails: Joi.string()
      .label("Other Obsessive-Compulsive Disorder Details")
      .when("OCDOther", { is: true, then: Joi.required() }),
    OCDFrequency: Joi.string()
      .label("Obsessive-Compulsive Disorder Frequency")
      .when("OCD", { is: true, then: Joi.required() }),
    OCDIntensity: Joi.string()
      .label("Obsessive-Compulsive Disorder Intensity")
      .when("OCD", { is: true, then: Joi.required() }),
    OCDDuration: Joi.string()
      .label("Obsessive-Compulsive Disorder Duration")
      .when("OCD", { is: true, then: Joi.required() }),
    PanicDisorder: Joi.boolean(),
    PoundingHeart: Joi.boolean(),
    PanicDisorderSweating: Joi.boolean(),
    Trembling: Joi.boolean(),
    ShortnessOfBreath: Joi.boolean(),
    Choking: Joi.boolean(),
    ChestPain: Joi.boolean(),
    PanicDisorderNausea: Joi.boolean(),
    Dizzy: Joi.boolean(),
    Chills: Joi.boolean(),
    Derealization: Joi.boolean(),
    FearOfCrazy: Joi.boolean(),
    FearOfDying: Joi.boolean(),
    PanicDisorderOther: Joi.boolean(),
    PanicDisorderOtherDetails: Joi.string()
      .label("Other Panic Disorder Details")
      .when("PanicDisorderOther", { is: true, then: Joi.required() }),
    PanicDisorderFrequency: Joi.string()
      .label("Panic Disorder Frequency")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    PanicDisorderIntensity: Joi.string()
      .label("Panic Disorder Intensity")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    PanicDisorderDuration: Joi.string()
      .label("Panic Disorder Duration")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    Phobias: Joi.boolean(),
    PhobiasSpecificFear: Joi.boolean(),
    ImmediateFear: Joi.boolean(),
    PhobiasAvoidance: Joi.boolean(),
    FearExaggerated: Joi.boolean(),
    PhobiasOther: Joi.boolean(),
    PhobiasOtherDetails: Joi.string()
      .label("Other Phobia Details")
      .when("PhobiasOther", { is: true, then: Joi.required() }),
    PhobiasFrequency: Joi.string()
      .label("Phobia Frequency")
      .when("Phobias", { is: true, then: Joi.required() }),
    PhobiasIntensity: Joi.string()
      .label("Phobia Intensity")
      .when("Phobias", { is: true, then: Joi.required() }),
    PhobiasDuration: Joi.string()
      .label("Phobia Duration")
      .when("Phobias", { is: true, then: Joi.required() }),
    DI: Joi.boolean(),
    DILowIQ: Joi.boolean(),
    DISensoryImpairments: Joi.boolean(),
    DISpeechDelays: Joi.boolean(),
    DIMotorCoordinationDelays: Joi.boolean(),
    DILearningDisorder: Joi.boolean(),
    DISpatialDelays: Joi.boolean(),
    DevelopmentalImpairmentsOther: Joi.boolean(),
    DevelopmentalImpairmentsOtherDetails: Joi.string()
      .label("Other Developmental Impairments Details")
      .when("DevelopmentalImpairmentsOther", {
        is: true,
        then: Joi.required(),
      }),
    DevelopmentalImpairmentsDetails: Joi.string()
      .label("Developmental Impairments Description")
      .when("DILowIQ", { is: true, then: Joi.required() })
      .when("DISensoryImpairments", { is: true, then: Joi.required() })
      .when("DISpeechDelays", { is: true, then: Joi.required() })
      .when("DIMotorCoordinationDelays", { is: true, then: Joi.required() })
      .when("DILearningDisorder", { is: true, then: Joi.required() })
      .when("DISpatialDelays", { is: true, then: Joi.required() }),
    OtherSymptoms: Joi.boolean(),
    OtherSymptomsDetails: Joi.string()
      .label("Other Symptom Details")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsFrequency: Joi.string()
      .label("Other Symptoms Frequency")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsIntensity: Joi.string()
      .label("Other Symptoms Intensity")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsDuration: Joi.string()
      .label("Other Symptoms Duration")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    ClinicalNarrativeSummary: Joi.string()
      .label("Clinical Narrative Summary")
      .when("PSDType", { is: "Initial", then: Joi.string().required() })
      .when("PSDType", { is: "Review/Update", then: Joi.string().required() }),
    ClinicalNarrativeSummaryComments: Joi.string()
      .label("Clinical Narrative Summary")
      .allow(""),
    TraditionalFosterCare: Joi.string()
      .label("Traditional Foster Care")
      .when("PSDType", { is: "Initial", then: Joi.string().required() })
      .when("PSDType", { is: "Review/Update", then: Joi.string().required() }),
    DiagnosisDetails: Joi.string()
      .label("Diagnosis details")
      .when("TraditionalFosterCare", { is: "No", then: Joi.required() }),
    PlacementNotes: Joi.string()
      .label("Other Placement Considerations")
      .required(),
    PlacementNotesComments: Joi.string()
      .label("Placement Considerations details")
      .when("PlacementNotes", { is: "Yes", then: Joi.required() }),
    TreatmentRecommendations: Joi.string()
      .label("Treatment Recommendations")
      .when("PSDType", { is: "Initial", then: Joi.string().required() })
      .when("PSDType", { is: "Review/Update", then: Joi.string().required() }),
    DiagnosisEducation: Joi.string()
      .label("Diagnosis education")
      .when("PSDType", { is: "Initial", then: Joi.string().required() })
      .when("PSDType", { is: "Review/Update", then: Joi.string().required() }),
    RecommendationEducation: Joi.string()
      .label("Recommendation education")
      .when("PSDType", { is: "Initial", then: Joi.string().required() })
      .when("PSDType", { is: "Review/Update", then: Joi.string().required() }),
    ClientAgrees: Joi.string()
      .label("Client in agreement")
      .when("PSDType", { is: "Initial", then: Joi.string().required() })
      .when("PSDType", { is: "Review/Update", then: Joi.string().required() }),
    FamilyAgress: Joi.string()
      .label("Family in agreement")
      .when("PSDType", { is: "Initial", then: Joi.string().required() })
      .when("PSDType", { is: "Review/Update", then: Joi.string().required() }),
    Partnership: Joi.string()
      .label("Partnership with other systems")
      .when("PSDType", { is: "Initial", then: Joi.string().required() })
      .when("PSDType", { is: "Review/Update", then: Joi.string().required() }),
    NoPartnershipReason: Joi.string()
      .label("Reason for no partnership")
      .when("Partnership", { is: "No", then: Joi.required() }),
  },
  "0758CDCB-56E3-EC11-997E-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SexAssignedAtBirth: Joi.string().required(),
    SexAssignedAtBirthDetails: Joi.string().when("SexAssignedAtBirth", {
      is: "Sex not listed",
      then: Joi.required(),
    }),
    Pronouns: Joi.string().required(),
    PronounsDescription: Joi.string().when("Pronouns", {
      is: "Prefer to self-describe",
      then: Joi.required(),
    }),
    GenderIdentity: Joi.string().required(),
    GenderIdentityDescription: Joi.string().when("GenderIdentity", {
      is: "Identity not listed",
      then: Joi.required(),
    }),
    DateCompleted: Joi.string().required(),
    Division: Joi.string().required(),
    PSDType: Joi.string().required(),
    InitialDADate: Joi.string().when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.required(),
    }),
    UpdateSummary: Joi.string().when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.required(),
    }),
    UpdateRecommendations: Joi.string().when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.required(),
    }),
    ISClient: Joi.boolean(),
    ISParent: Joi.boolean(),
    ISGuardian: Joi.boolean(),
    ISCaregiver: Joi.boolean(),
    ISPhysician: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISCPS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.string().when("ISOther", {
      is: true,
      then: Joi.required(),
    }),
    ReasonForReferral: Joi.string().required(),
    ClientStrengths: Joi.string().required(),
    PresentingProblem: Joi.string().required(),
    HumanTrafficking: Joi.string().required(),
    NoSupports: Joi.boolean(),
    SupportsDetails: Joi.when("NoSupports", {
      is: false,
      then: Joi.string()
        .when("PSDType", {
          is: "Biopsychosocial Assessment",
          then: Joi.required(),
        })
        .when("PSDType", {
          is: "Addendum/Annual Update",
          then: Joi.required(),
        }),
    }),
    HasChildren: Joi.boolean(),
    HasCustody: Joi.string().when("HasChildren", {
      is: true,
      then: Joi.required(),
    }),
    NoCustodyDetails: Joi.string().when("HasCustody", {
      is: "No",
      then: Joi.required(),
    }),
    LivesWithChild: Joi.string().when("HasChildren", {
      is: true,
      then: Joi.required(),
    }),
    LivesWithoutChildDetails: Joi.string().when("LivesWithChild", {
      is: "No",
      then: Joi.required(),
    }),
    ChildHasNeeds: Joi.string().when("HasChildren", {
      is: true,
      then: Joi.required(),
    }),
    ChildHasNeedsDetails: Joi.string().when("ChildHasNeeds", {
      is: "Yes",
      then: Joi.required(),
    }),
    RelationshipWithChild: Joi.string().when("HasChildren", {
      is: true,
      then: Joi.required(),
    }),
    FamilyHistoryUnknown: Joi.boolean(),
    FamilyHistoryDetails: Joi.string().when("FamilyHistoryUnknown", {
      is: false,
      then: Joi.required(),
    }),
    CulturalGroup: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    CulturalTraditions: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    CulturalTraditionsDetails: Joi.string().when("CulturalTraditions", {
      is: "Yes",
      then: Joi.required(),
    }),
    NegativeCulturalExperiences: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    NegativeCulturalExperiencesDetails: Joi.string().when(
      "NegativeCulturalExperiences",
      {
        is: "Yes",
        then: Joi.required(),
      }
    ),
    CulturalMedicalBeliefs: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    CulturalMedicalBeliefsDetails: Joi.string().when("CulturalMedicalBeliefs", {
      is: "Yes",
      then: Joi.required(),
    }),
    CulturalDifferences: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    CulturalDifferencesDetails: Joi.string().when("CulturalDifferences", {
      is: "Yes",
      then: Joi.required(),
    }),
    Religion: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    UnknownReligionComments: Joi.string().when("Religion", {
      is: "Unknown",
      then: Joi.required(),
    }),
    RoleOfFaith: Joi.string().when("Religion", {
      is: "Yes",
      then: Joi.required(),
    }),
    ReligiousTraditions: Joi.string().when("Religion", {
      is: "Yes",
      then: Joi.required(),
    }),
    DietaryNeeds: Joi.string().when("Religion", {
      is: "Yes",
      then: Joi.required(),
    }),
    NegativeReligiousExperiences: Joi.string().when("Religion", {
      is: "Yes",
      then: Joi.required(),
    }),
    ReligiousMedicalBeliefs: Joi.string().when("Religion", {
      is: "Yes",
      then: Joi.required(),
    }),
    ReligiousComments: Joi.string()
      .when("Religion", {
        is: "Yes",
        then: Joi.required(),
      })
      .when("Religion", {
        is: "No",
        then: Joi.required(),
      })
      .when("Religion", {
        is: "None Reported",
        then: Joi.required(),
      }),
    PHUnknown: Joi.boolean(),
    PHNoProblems: Joi.boolean(),
    PHPrenatalCare: Joi.when("PHUnknown", {
      is: false,
      then: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string()
          .when("PSDType", {
            is: "Biopsychosocial Assessment",
            then: Joi.required(),
          })
          .when("PSDType", {
            is: "Addendum/Annual Update",
            then: Joi.required(),
          }),
      }),
    }),
    PHExposure: Joi.when("PHUnknown", {
      is: false,
      then: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string()
          .when("PSDType", {
            is: "Biopsychosocial Assessment",
            then: Joi.required(),
          })
          .when("PSDType", {
            is: "Addendum/Annual Update",
            then: Joi.required(),
          }),
      }),
    }),
    PHTrauma: Joi.when("PHUnknown", {
      is: false,
      then: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string()
          .when("PSDType", {
            is: "Biopsychosocial Assessment",
            then: Joi.required(),
          })
          .when("PSDType", {
            is: "Addendum/Annual Update",
            then: Joi.required(),
          }),
      }),
    }),
    PHComplications: Joi.when("PHUnknown", {
      is: false,
      then: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string()
          .when("PSDType", {
            is: "Biopsychosocial Assessment",
            then: Joi.required(),
          })
          .when("PSDType", {
            is: "Addendum/Annual Update",
            then: Joi.required(),
          }),
      }),
    }),
    PHConcerns: Joi.when("PHUnknown", {
      is: false,
      then: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string()
          .when("PSDType", {
            is: "Biopsychosocial Assessment",
            then: Joi.required(),
          })
          .when("PSDType", {
            is: "Addendum/Annual Update",
            then: Joi.required(),
          }),
      }),
    }),
    PHComments: Joi.when("PHUnknown", {
      is: false,
      then: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.when("PSDType", {
          is: "Biopsychosocial Assessment",
          then: Joi.string()
            .when("PHPrenatalCare", {
              is: "No",
              then: Joi.required(),
            })
            .when("PHExposure", {
              is: "Yes",
              then: Joi.required(),
            })
            .when("PHTrauma", {
              is: "Yes",
              then: Joi.required(),
            })
            .when("PHComplications", {
              is: "Yes",
              then: Joi.required(),
            })
            .when("PHConcerns", {
              is: "Yes",
              then: Joi.required(),
            }),
        }).when("PSDType", {
          is: "Addendum/Annual Update",
          then: Joi.string()
            .when("PHPrenatalCare", {
              is: "No",
              then: Joi.required(),
            })
            .when("PHExposure", {
              is: "Yes",
              then: Joi.required(),
            })
            .when("PHTrauma", {
              is: "Yes",
              then: Joi.required(),
            })
            .when("PHComplications", {
              is: "Yes",
              then: Joi.required(),
            })
            .when("PHConcerns", {
              is: "Yes",
              then: Joi.required(),
            }),
        }),
      }),
    }),
    SpecialNeeds: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    SpecializedServices: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    DHComments: Joi.when("PSDType", {
      is: "Biopsychosocial Assessment",
      then: Joi.string()
        .when("SpecialNeeds", {
          is: "Yes",
          then: Joi.required(),
        })
        .when("SpecializedServices", {
          is: "Yes",
          then: Joi.required(),
        }),
    }).when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.string()
        .when("SpecialNeeds", {
          is: "Yes",
          then: Joi.required(),
        })
        .when("SpecializedServices", {
          is: "Yes",
          then: Joi.required(),
        }),
    }),
    EducationStatus: Joi.string().required(),
    SchoolName: Joi.string().when("EducationStatus", {
      is: "Currently in school",
      then: Joi.required(),
    }),
    IEP: Joi.string().required(),
    IEPDetails: Joi.string().when("IEP", {
      is: "Yes",
      then: Joi.required(),
    }),
    AcademicGoals: Joi.string().required(),
    CurrentlyEmployed: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    Employer: Joi.string().when("CurrentlyEmployed", {
      is: "Yes",
      then: Joi.required(),
    }),
    JobTitle: Joi.string().when("CurrentlyEmployed", {
      is: "Yes",
      then: Joi.required(),
    }),
    JobLength: Joi.string().when("CurrentlyEmployed", {
      is: "Yes",
      then: Joi.required(),
    }),
    PreviousEmployment: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    EmploymentInterests: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    EmploymentIssues: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    MilitaryHistory: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    MilitaryComments: Joi.when("MilitaryHistory", {
      is: "Yes",
      then: Joi.string()
        .when("PSDType", {
          is: "Biopsychosocial Assessment",
          then: Joi.required(),
        })
        .when("PSDType", {
          is: "Addendum/Annual Update",
          then: Joi.required(),
        }),
    }),
    DailyLiving: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    DailyLivingDetails: Joi.string()
      .when("DailyLiving", { is: "Regressed", then: Joi.required() })
      .when("DailyLiving", { is: "Advanced", then: Joi.required() }),
    SelfCare: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    SelfCareDetails: Joi.string()
      .when("SelfCare", { is: "Regressed", then: Joi.required() })
      .when("SelfCare", { is: "Advanced", then: Joi.required() }),
    Housing: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    HousingDetails: Joi.string()
      .when("Housing", { is: "Regressed", then: Joi.required() })
      .when("Housing", { is: "Advanced", then: Joi.required() }),
    WorkStudyLife: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    WorkStudyLifeDetails: Joi.string()
      .when("WorkStudyLife", { is: "Regressed", then: Joi.required() })
      .when("WorkStudyLife", { is: "Advanced", then: Joi.required() }),
    CareerPlanning: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    CareerPlanningDetails: Joi.string()
      .when("CareerPlanning", { is: "Regressed", then: Joi.required() })
      .when("CareerPlanning", { is: "Advanced", then: Joi.required() }),
    CivicEngagement: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    CivicEngagementDetails: Joi.string()
      .when("CivicEngagement", { is: "Regressed", then: Joi.required() })
      .when("CivicEngagement", { is: "Advanced", then: Joi.required() }),
    WelfareSystem: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    WelfareSystemDetails: Joi.string()
      .when("WelfareSystem", { is: "Regressed", then: Joi.required() })
      .when("WelfareSystem", { is: "Advanced", then: Joi.required() }),
    LookingForward: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    LookingForwardDetails: Joi.string()
      .when("LookingForward", { is: "Regressed", then: Joi.required() })
      .when("LookingForward", { is: "Advanced", then: Joi.required() }),
    CommunicationSkills: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    CommunicationSkillsDetails: Joi.string()
      .when("CommunicationSkills", {
        is: "Significant Support Needed",
        then: Joi.required(),
      })
      .when("CommunicationSkills", {
        is: "Moderate Support Needed",
        then: Joi.required(),
      })
      .when("CommunicationSkills", {
        is: "Mild Support Needed",
        then: Joi.required(),
      }),
    EmotionalUnderstanding: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    EmotionalUnderstandingDetails: Joi.string()
      .when("EmotionalUnderstanding", {
        is: "Significant Support Needed",
        then: Joi.required(),
      })
      .when("EmotionalUnderstanding", {
        is: "Moderate Support Needed",
        then: Joi.required(),
      })
      .when("EmotionalUnderstanding", {
        is: "Mild Support Needed",
        then: Joi.required(),
      }),
    ProblemSolving: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    ProblemSolvingDetails: Joi.string()
      .when("ProblemSolving", {
        is: "Significant Support Needed",
        then: Joi.required(),
      })
      .when("ProblemSolving", {
        is: "Moderate Support Needed",
        then: Joi.required(),
      })
      .when("ProblemSolving", {
        is: "Mild Support Needed",
        then: Joi.required(),
      }),
    ConflictResolution: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    ConflictResolutionDetails: Joi.string()
      .when("ConflictResolution", {
        is: "Significant Support Needed",
        then: Joi.required(),
      })
      .when("ConflictResolution", {
        is: "Moderate Support Needed",
        then: Joi.required(),
      })
      .when("ConflictResolution", {
        is: "Mild Support Needed",
        then: Joi.required(),
      }),
    DecisionMakingSkills: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    DecisionMakingSkillsDetails: Joi.string()
      .when("DecisionMakingSkills", {
        is: "Significant Support Needed",
        then: Joi.required(),
      })
      .when("DecisionMakingSkills", {
        is: "Moderate Support Needed",
        then: Joi.required(),
      })
      .when("DecisionMakingSkills", {
        is: "Mild Support Needed",
        then: Joi.required(),
      }),
    HealthyRelations: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    HealthyRelationsDetails: Joi.string()
      .when("HealthyRelations", {
        is: "Significant Support Needed",
        then: Joi.required(),
      })
      .when("HealthyRelations", {
        is: "Moderate Support Needed",
        then: Joi.required(),
      })
      .when("HealthyRelations", {
        is: "Mild Support Needed",
        then: Joi.required(),
      }),
    PeerAssociations: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    CPSHistory: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    CPSCaseworkerInfo: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    GALCASA: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    GALCASAName: Joi.string().when("GALCASA", {
      is: "Yes",
      then: Joi.required(),
    }),
    LegalInvolvement: Joi.string().required(),
    LegalStatus: Joi.string().when("LegalInvolvement", {
      is: "Yes",
      then: Joi.required(),
    }),
    ProbationOfficer: Joi.string()
      .when("LegalStatus", { is: "Probation", then: Joi.required() })
      .when("LegalStatus", { is: "Parole", then: Joi.required() })
      .when("LegalStatus", { is: "Charges Pending", then: Joi.required() })
      .when("LegalStatus", { is: "Dependency Case", then: Joi.required() })
      .when("LegalStatus", {
        is: "Charges with no Court Supervision",
        then: Joi.required(),
      }),
    ProbationOfficerName: Joi.string().when("ProbationOfficer", {
      is: "Yes",
      then: Joi.required(),
    }),
    LegalHistory: Joi.string()
      .when("LegalStatus", { is: "Probation", then: Joi.required() })
      .when("LegalStatus", { is: "Parole", then: Joi.required() })
      .when("LegalStatus", { is: "Charges Pending", then: Joi.required() })
      .when("LegalStatus", { is: "Dependency Case", then: Joi.required() })
      .when("LegalStatus", {
        is: "Charges with no Court Supervision",
        then: Joi.required(),
      }),
    PCP: Joi.when("PCPUnknown", {
      is: false,
      then: Joi.string()
        .when("PSDType", {
          is: "Biopsychosocial Assessment",
          then: Joi.required(),
        })
        .when("PSDType", {
          is: "Addendum/Annual Update",
          then: Joi.required(),
        }),
    }),
    PCPPhone: Joi.when("PCPUnknown", {
      is: false,
      then: Joi.string()
        .when("PSDType", {
          is: "Biopsychosocial Assessment",
          then: Joi.required(),
        })
        .when("PSDType", {
          is: "Addendum/Annual Update",
          then: Joi.required(),
        }),
    }),
    PCPUnknown: Joi.boolean(),
    LastMedicalExamDate: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    LastDentalExamDate: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.string().when("Allergies", {
      is: true,
      then: Joi.required(),
    }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.string().when("MedicalConditions", {
      is: true,
      then: Joi.required(),
    }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.string().when("NutritionalConcerns", {
      is: true,
      then: Joi.required(),
    }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.string().when("DentalConcerns", {
      is: true,
      then: Joi.required(),
    }),
    Undiagnosed: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", {
        is: "Addendum/Annual Update",
        then: Joi.required(),
      }),
    UndiagnosedDetails: Joi.string().when("Undiagnosed", {
      is: "Yes",
      then: Joi.required(),
    }),
    NoMedications: Joi.boolean(),
    CurrentMedications: Joi.string().when("NoMedications", {
      is: false,
      then: Joi.required(),
    }),
    MedicationCompliance: Joi.string().when("NoMedications", {
      is: false,
      then: Joi.required(),
    }),
    SideEffects: Joi.string().when("NoMedications", {
      is: false,
      then: Joi.required(),
    }),
    SideEffectsDetails: Joi.string().when("SideEffects", {
      is: "Yes",
      then: Joi.required(),
    }),
    PsychotropicMeds: Joi.string().when("NoMedications", {
      is: false,
      then: Joi.required(),
    }),
    PsychotropicMedsDetails: Joi.string().when("PsychotropicMeds", {
      is: "Yes",
      then: Joi.required(),
    }),
    SexualHistoryNA: Joi.boolean(),
    SexualOrientation: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.string()
        .when("PSDType", {
          is: "Biopsychosocial Assessment",
          then: Joi.required(),
        })
        .when("PSDType", {
          is: "Addendum/Annual Update",
          then: Joi.required(),
        }),
    }),
    SexualOrientationDetails: Joi.string().when("SexualOrientation", {
      is: "Orientation not listed",
      then: Joi.required(),
    }),
    SexualRelationshipsEducation: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.string()
        .when("PSDType", {
          is: "Biopsychosocial Assessment",
          then: Joi.required(),
        })
        .when("PSDType", {
          is: "Addendum/Annual Update",
          then: Joi.required(),
        }),
    }),
    SexuallyActive: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.string()
        .when("PSDType", {
          is: "Biopsychosocial Assessment",
          then: Joi.required(),
        })
        .when("PSDType", {
          is: "Addendum/Annual Update",
          then: Joi.required(),
        }),
    }),
    UseProtection: Joi.string().when("SexuallyActive", {
      is: "Yes",
      then: Joi.required(),
    }),
    AwareOfRisks: Joi.string().when("SexuallyActive", {
      is: "Yes",
      then: Joi.required(),
    }),
    Pregnancy: Joi.string().when("SexuallyActive", {
      is: "Yes",
      then: Joi.required(),
    }),
    SexuallyActiveComments: Joi.string().when("SexuallyActive", {
      is: "Yes",
      then: Joi.required(),
    }),
    SexualAbuseVictim: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.string()
        .when("PSDType", {
          is: "Biopsychosocial Assessment",
          then: Joi.required(),
        })
        .when("PSDType", {
          is: "Addendum/Annual Update",
          then: Joi.required(),
        }),
    }),
    SexualBehavior: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.string()
        .when("PSDType", {
          is: "Biopsychosocial Assessment",
          then: Joi.required(),
        })
        .when("PSDType", {
          is: "Addendum/Annual Update",
          then: Joi.required(),
        }),
    }),
    SexuallyActingOut: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.string()
        .when("PSDType", {
          is: "Biopsychosocial Assessment",
          then: Joi.required(),
        })
        .when("PSDType", {
          is: "Addendum/Annual Update",
          then: Joi.required(),
        }),
    }),
    SexuallyAbusive: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.string()
        .when("PSDType", {
          is: "Biopsychosocial Assessment",
          then: Joi.required(),
        })
        .when("PSDType", {
          is: "Addendum/Annual Update",
          then: Joi.required(),
        }),
    }),
    SexualHistoryComments: Joi.string()
      .when("SexualAbuseVictim", {
        is: "Yes",
        then: Joi.required(),
      })
      .when("SexualBehavior", {
        is: "Yes",
        then: Joi.required(),
      })
      .when("SexuallyActingOut", {
        is: "Yes",
        then: Joi.required(),
      })
      .when("SexuallyAbusive", {
        is: "Yes",
        then: Joi.required(),
      }),
    MHTreatmentNA: Joi.boolean(),
    PastMentalHealthTreatment: Joi.string().when("MHTreatmentNA", {
      is: false,
      then: Joi.required(),
    }),
    PastGroupHomePlacement: Joi.string().when("MHTreatmentNA", {
      is: false,
      then: Joi.required(),
    }),
    PastHospitalPlacement: Joi.string().when("MHTreatmentNA", {
      is: false,
      then: Joi.required(),
    }),
    InvoluntaryTreatment: Joi.string().when("MHTreatmentNA", {
      is: false,
      then: Joi.required(),
    }),
    PastMentalHealthDiagnosis: Joi.string().when("MHTreatmentNA", {
      is: false,
      then: Joi.required(),
    }),
    MHTreatmentComments: Joi.string()
      .when("PastMentalHealthTreatment", { is: "Yes", then: Joi.required() })
      .when("PastGroupHomePlacement", { is: "Yes", then: Joi.required() })
      .when("PastHospitalPlacement", { is: "Yes", then: Joi.required() })
      .when("InvoluntaryTreatment", { is: "Yes", then: Joi.required() }),
    MHPerspectiveOfTreatment: Joi.string().required(),
    SubstanceUseNA: Joi.boolean(),
    SUClientDenies: Joi.boolean(),
    SUClientReportsCurrent: Joi.boolean(),
    SUClientReportsPast: Joi.boolean(),
    SUClientPeers: Joi.boolean(),
    SUDCBSNoReports: Joi.boolean(),
    SUDCBSReferralReports: Joi.boolean(),
    SUDCBSWorkerReports: Joi.boolean(),
    SUComments: Joi.string()
      .when("SUClientDenies", { is: true, then: Joi.required() })
      .when("SUClientReportsCurrent", { is: true, then: Joi.required() })
      .when("SUClientReportsPast", { is: true, then: Joi.required() })
      .when("SUClientPeers", { is: true, then: Joi.required() })
      .when("SUDCBSReferralReports", { is: true, then: Joi.required() })
      .when("SUDCBSWorkerReports", { is: true, then: Joi.required() }),
    SUUnknown: Joi.boolean(),
    SUHistory: Joi.when("SubstanceUseNA", {
      is: false,
      then: Joi.when("SUUnknown", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PerceptionOfSubstanceUse: Joi.when("SubstanceUseNA", {
      is: false,
      then: Joi.string()
        .when("PSDType", {
          is: "Biopsychosocial Assessment",
          then: Joi.required(),
        })
        .when("PSDType", {
          is: "Addendum/Annual Update",
          then: Joi.required(),
        }),
    }),
    PerspectiveOfTreatment: Joi.when("SubstanceUseNA", {
      is: false,
      then: Joi.string()
        .when("PSDType", {
          is: "Biopsychosocial Assessment",
          then: Joi.required(),
        })
        .when("PSDType", {
          is: "Addendum/Annual Update",
          then: Joi.required(),
        }),
    }),
    TraumaNA: Joi.boolean(),
    TraumaHistory: Joi.string().when("TraumaNA", {
      is: false,
      then: Joi.required(),
    }),
    DistressingMemories: Joi.boolean(),
    BlockOut: Joi.boolean(),
    Hypervigilance: Joi.boolean(),
    PhysiologicalResponses: Joi.boolean(),
    LossOfMemories: Joi.boolean(),
    Hyperarousal: Joi.boolean(),
    SleepDisturbances: Joi.boolean(),
    DevelopmentalRegression: Joi.boolean(),
    Nightmares: Joi.boolean(),
    Avoidant: Joi.boolean(),
    DifficultyConcentratingSymptom: Joi.boolean(),
    UnhealthyBoundaries: Joi.boolean(),
    Flashbacks: Joi.boolean(),
    Detachment: Joi.boolean(),
    EmotionalDysregulation: Joi.boolean(),
    RepetitivePlayOfEvents: Joi.boolean(),
    PsychologicalDistress: Joi.boolean(),
    DiminishedInterests: Joi.boolean(),
    Dissocation: Joi.boolean(),
    NegativeCognitions: Joi.boolean(),
    SocialWithdrawalSymptom: Joi.boolean(),
    NoSymptoms: Joi.boolean(),
    SocialSupports: Joi.boolean(),
    SenseOfMastery: Joi.boolean(),
    CaregiverStability: Joi.boolean(),
    StrongSpiritualBeliefs: Joi.boolean(),
    InterpersonalSkills: Joi.boolean(),
    PositiveOutlook: Joi.boolean(),
    PlacementStability: Joi.boolean(),
    Pets: Joi.boolean(),
    ValidatingExperiences: Joi.boolean(),
    Resources: Joi.boolean(),
    TiesToExtendedFamily: Joi.boolean(),
    Adaptability: Joi.boolean(),
    SecureAttachments: Joi.boolean(),
    StrongCulturalIdentity: Joi.boolean(),
    NoTraumaProtectiveFactors: Joi.boolean(),
    CopingStrategies: Joi.string().when("TraumaNA", {
      is: false,
      then: Joi.required(),
    }),
    ClientAwareOfTrauma: Joi.string().when("TraumaNA", {
      is: false,
      then: Joi.required(),
    }),
    ClientPerspectiveOfTrauma: Joi.string().when("TraumaNA", {
      is: false,
      then: Joi.required(),
    }),
    CaregiverPerspectiveOfTrauma: Joi.string().when("TraumaNA", {
      is: false,
      then: Joi.required(),
    }),
    AppropriateAppearance: Joi.boolean(),
    Neat: Joi.boolean(),
    Disheveled: Joi.boolean(),
    BizarreAppearance: Joi.boolean(),
    OtherAppearance: Joi.boolean(),
    OtherAppearanceDetails: Joi.string().when("OtherAppearance", {
      is: true,
      then: Joi.required(),
    }),
    Cooperative: Joi.boolean(),
    Guarded: Joi.boolean(),
    Hyperactive: Joi.boolean(),
    Agitated: Joi.boolean(),
    Paranoid: Joi.boolean(),
    Tics: Joi.boolean(),
    Impulsive: Joi.boolean(),
    Aggressive: Joi.boolean(),
    Withdrawn: Joi.boolean(),
    BizarreBehavior: Joi.boolean(),
    Rigidity: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.string().when("OtherBehavior", {
      is: true,
      then: Joi.required(),
    }),
    Normal: Joi.boolean(),
    Slurred: Joi.boolean(),
    Pressured: Joi.boolean(),
    Tangential: Joi.boolean(),
    Incoherent: Joi.boolean(),
    Stutters: Joi.boolean(),
    OtherSpeech: Joi.boolean(),
    OtherSpeechDetails: Joi.string().when("OtherSpeech", {
      is: true,
      then: Joi.required(),
    }),
    Euthymic: Joi.boolean(),
    Anxious: Joi.boolean(),
    Angry: Joi.boolean(),
    Depressed: Joi.boolean(),
    Euphoric: Joi.boolean(),
    Irritable: Joi.boolean(),
    Fearful: Joi.boolean(),
    OtherMood: Joi.boolean(),
    OtherMoodDetails: Joi.string().when("OtherMood", {
      is: true,
      then: Joi.required(),
    }),
    FullRange: Joi.boolean(),
    Restricted: Joi.boolean(),
    Blunted: Joi.boolean(),
    Flat: Joi.boolean(),
    Inappropriate: Joi.boolean(),
    OtherAffect: Joi.boolean(),
    OtherAffectDetails: Joi.string().when("OtherAffect", {
      is: true,
      then: Joi.required(),
    }),
    Logical: Joi.boolean(),
    Preoccupations: Joi.boolean(),
    Delusions: Joi.boolean(),
    Hallucinations: Joi.boolean(),
    Racing: Joi.boolean(),
    Disorganized: Joi.boolean(),
    Concrete: Joi.boolean(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    OtherPerception: Joi.boolean(),
    OtherPerceptionDetails: Joi.string().when("OtherPerception", {
      is: true,
      then: Joi.required(),
    }),
    NoImpairment: Joi.boolean(),
    ShortAttentionSpan: Joi.boolean(),
    DifficultyConcentrating: Joi.boolean(),
    Distractibility: Joi.boolean(),
    MemoryImpairment: Joi.boolean(),
    LowIntelligence: Joi.boolean(),
    OtherCognition: Joi.boolean(),
    OtherCognitionDetails: Joi.string().when("OtherCognition", {
      is: true,
      then: Joi.required(),
    }),
    AppropriateInsight: Joi.boolean(),
    Fair: Joi.boolean(),
    Impaired: Joi.boolean(),
    OtherInsight: Joi.boolean(),
    OtherInsightDetails: Joi.string().when("OtherInsight", {
      is: true,
      then: Joi.required(),
    }),
    MentalStatusComments: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    LethalityNA: Joi.boolean(),
    SelfAbusiveBehavior: Joi.string()
      .label("Self-abusive behavior")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicidalThreats: Joi.string()
      .label("Suicidal threats")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicideAttempt: Joi.string()
      .label("Suicide attempt")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CaregiverConcernsOfSelfHarm: Joi.string()
      .label("Parent/Caregiver concerns of suicide/self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherConcernsOfSelfHarm: Joi.string()
      .label("Other expressed concerns of suicide/self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentSelfHarmRisk: Joi.string()
      .label("Current Risk of Harm to Self")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SelfHarmComments: Joi.string().label(
      "Current Risk of Harm to Self comments"
    ),
    ThreatsToHarmOthers: Joi.string()
      .label("Threats to intentionally harm/endanger others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThoughtsOfHarm: Joi.string()
      .label("Thoughts of intentionally harming/endangering others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarm: Joi.string()
      .label("Acts of intentionally harm/endangering others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarmAnimals: Joi.string()
      .label("Acts of intentionally harm/endangering animals")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsInvolvingWeapons: Joi.string()
      .label("Acts involving weapons")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CaregiverConcernOfOtherHarm: Joi.string()
      .label("Parent/Caregiver concerns of harm/endangering others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherConcernsOfOtherHarm: Joi.string()
      .label("Other expressed concerns of harm/endangering others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentOtherHarmRisk: Joi.string()
      .label("Current Risk of Harm to Others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherHarmComments: Joi.string().label(
      "Current Risk of Harm to Others comments"
    ),
    SafetyPlanStatus: Joi.string()
      .label("Safety Plan Status")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    LethalityComments: Joi.string()
      .label("Comments/Plan")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    TraumaSymptoms: Joi.boolean(),
    TraumaticExposure: Joi.boolean(),
    AvoidantTrauma: Joi.boolean(),
    HypervigilanceTrauma: Joi.boolean(),
    IntrusiveDreams: Joi.boolean(),
    NegativeThoughts: Joi.boolean(),
    CocentrationProblems: Joi.boolean(),
    RecklessBehaviorTrauma: Joi.boolean(),
    SleepDisturbancesTrauma: Joi.boolean(),
    OtherTrauma: Joi.boolean(),
    OtherTraumaDetails: Joi.string().when("OtherTrauma", {
      is: true,
      then: Joi.required(),
    }),
    TraumaSymptomsFrequency: Joi.string().when("TraumaSymptoms", {
      is: true,
      then: Joi.required(),
    }),
    TraumaSymptomsIntensity: Joi.string().when("TraumaSymptoms", {
      is: true,
      then: Joi.required(),
    }),
    TraumaSymptomsDuration: Joi.string().when("TraumaSymptoms", {
      is: true,
      then: Joi.required(),
    }),
    TraumaSymptomsOnset: Joi.string().when("TraumaSymptoms", {
      is: true,
      then: Joi.required(),
    }),
    AnxietyDisorder: Joi.boolean(),
    AnxietyDisorderExcessWorry: Joi.boolean(),
    AnxietyDisorderEasilyFatigued: Joi.boolean(),
    MuscleTension: Joi.boolean(),
    Overworried: Joi.boolean(),
    AnxietyDisorderDifficultyConcentrating: Joi.boolean(),
    SleepDisturbancesAnxiety: Joi.boolean(),
    RestlessAnxiety: Joi.boolean(),
    Irritability: Joi.boolean(),
    OtherAnxiety: Joi.boolean(),
    OtherAnxietyDetails: Joi.string().when("OtherAnxiety", {
      is: true,
      then: Joi.required(),
    }),
    AnxietyDisorderFrequency: Joi.string().when("AnxietyDisorder", {
      is: true,
      then: Joi.required(),
    }),
    AnxietyDisorderIntensity: Joi.string().when("AnxietyDisorder", {
      is: true,
      then: Joi.required(),
    }),
    AnxietyDisorderDuration: Joi.string().when("AnxietyDisorder", {
      is: true,
      then: Joi.required(),
    }),
    DepressionSymptoms: Joi.boolean(),
    DepressedMood: Joi.boolean(),
    SleepChanges: Joi.boolean(),
    Guilt: Joi.boolean(),
    DiminishedInterest: Joi.boolean(),
    PurposelessMovement: Joi.boolean(),
    DifficultyConcentratingDepression: Joi.boolean(),
    WeightChanges: Joi.boolean(),
    FatigueDepression: Joi.boolean(),
    ThoughtsOfDeath: Joi.boolean(),
    OtherDepression: Joi.boolean(),
    OtherDepressionDetails: Joi.string().when("OtherDepression", {
      is: true,
      then: Joi.required(),
    }),
    DepressionFrequency: Joi.string().when("DepressionSymptoms", {
      is: true,
      then: Joi.required(),
    }),
    DepressionIntensity: Joi.string().when("DepressionSymptoms", {
      is: true,
      then: Joi.required(),
    }),
    DepressionDuration: Joi.string().when("DepressionSymptoms", {
      is: true,
      then: Joi.required(),
    }),
    AttentionHyperactivity: Joi.boolean(),
    AttentionHyperactivityEasilyDistracted: Joi.boolean(),
    DifficultyFollowThrough: Joi.boolean(),
    Forgetful: Joi.boolean(),
    DifficultyListening: Joi.boolean(),
    DisorganizedAttention: Joi.boolean(),
    Fidgety: Joi.boolean(),
    LackOfDetails: Joi.boolean(),
    LosesThings: Joi.boolean(),
    InterruptsOthers: Joi.boolean(),
    UnableToSitStill: Joi.boolean(),
    ExcessiveTalking: Joi.boolean(),
    DifficultyWaiting: Joi.boolean(),
    OtherAttention: Joi.boolean(),
    OtherAttentionDetails: Joi.string().when("OtherAttention", {
      is: true,
      then: Joi.required(),
    }),
    AttentionHyperactivityFrequency: Joi.string().when(
      "AttentionHyperactivity",
      { is: true, then: Joi.required() }
    ),
    AttentionHyperactivityIntensity: Joi.string().when(
      "AttentionHyperactivity",
      { is: true, then: Joi.required() }
    ),
    AttentionHyperactivityDuration: Joi.string().when(
      "AttentionHyperactivity",
      { is: true, then: Joi.required() }
    ),
    SU: Joi.boolean(),
    PatternOfSubstanceUse: Joi.boolean(),
    DesiresCutDownUse: Joi.boolean(),
    TimeSpentObtaining: Joi.boolean(),
    Cravings: Joi.boolean(),
    FailureOfResponsibilities: Joi.boolean(),
    NegativeImpact: Joi.boolean(),
    AbandonsActivities: Joi.boolean(),
    Tolerance: Joi.boolean(),
    SUWithdrawal: Joi.boolean(),
    SUOther: Joi.boolean(),
    SUOtherDetails: Joi.string().when("SUOther", {
      is: true,
      then: Joi.required(),
    }),
    SubstanceUseFrequency: Joi.string().when("SU", {
      is: true,
      then: Joi.required(),
    }),
    SubstanceUseIntensity: Joi.string().when("SU", {
      is: true,
      then: Joi.required(),
    }),
    SubstanceUseDuration: Joi.string().when("SU", {
      is: true,
      then: Joi.required(),
    }),
    DMDD: Joi.boolean(),
    Temper: Joi.boolean(),
    OutsideOutbursts: Joi.boolean(),
    FrequentOutbursts: Joi.boolean(),
    DMDDIrritable: Joi.boolean(),
    OutburstsAroundOthers: Joi.boolean(),
    DMDDOther: Joi.boolean(),
    DMDDOtherDetails: Joi.string().when("DMDDOther", {
      is: true,
      then: Joi.required(),
    }),
    DMDDFrequency: Joi.string().when("DMDD", {
      is: true,
      then: Joi.required(),
    }),
    DMDDIntensity: Joi.string().when("DMDD", {
      is: true,
      then: Joi.required(),
    }),
    DMDDDuration: Joi.string().when("DMDD", { is: true, then: Joi.required() }),
    ConductDisorder: Joi.boolean(),
    Aggression: Joi.boolean(),
    DestructionOfProperty: Joi.boolean(),
    Theft: Joi.boolean(),
    SeriousViolations: Joi.boolean(),
    OtherConductDisorder: Joi.boolean(),
    OtherConductDisorderDetails: Joi.string().when("OtherConductDisorder", {
      is: true,
      then: Joi.required(),
    }),
    ConductDisorderFrequency: Joi.string().when("ConductDisorder", {
      is: true,
      then: Joi.required(),
    }),
    ConductDisorderIntensity: Joi.string().when("ConductDisorder", {
      is: true,
      then: Joi.required(),
    }),
    ConductDisorderDuration: Joi.string().when("ConductDisorder", {
      is: true,
      then: Joi.required(),
    }),
    ODD: Joi.boolean(),
    IrritableODD: Joi.boolean(),
    Argumentative: Joi.boolean(),
    Vindictive: Joi.boolean(),
    OtherODD: Joi.boolean(),
    OtherODDDetails: Joi.string().when("OtherODD", {
      is: true,
      then: Joi.required(),
    }),
    ODDFrequency: Joi.string().when("ODD", { is: true, then: Joi.required() }),
    ODDIntensity: Joi.string().when("ODD", { is: true, then: Joi.required() }),
    ODDDuration: Joi.string().when("ODD", { is: true, then: Joi.required() }),
    OCD: Joi.boolean(),
    OCDPresence: Joi.boolean(),
    Obsessions: Joi.boolean(),
    TimeConsuming: Joi.boolean(),
    Compulsions: Joi.boolean(),
    ReduceAnxiety: Joi.boolean(),
    SuppressUrges: Joi.boolean(),
    OCDOther: Joi.boolean(),
    OCDOtherDetails: Joi.string().when("OCDOther", {
      is: true,
      then: Joi.required(),
    }),
    OCDFrequency: Joi.string().when("OCD", { is: true, then: Joi.required() }),
    OCDIntensity: Joi.string().when("OCD", { is: true, then: Joi.required() }),
    OCDDuration: Joi.string().when("OCD", { is: true, then: Joi.required() }),
    PanicDisorder: Joi.boolean(),
    PoundingHeart: Joi.boolean(),
    PanicDisorderSweating: Joi.boolean(),
    Trembling: Joi.boolean(),
    ShortnessOfBreath: Joi.boolean(),
    Choking: Joi.boolean(),
    ChestPain: Joi.boolean(),
    PanicDisorderNausea: Joi.boolean(),
    Dizzy: Joi.boolean(),
    Chills: Joi.boolean(),
    Derealization: Joi.boolean(),
    FearOfCrazy: Joi.boolean(),
    FearOfDying: Joi.boolean(),
    PanicDisorderOther: Joi.boolean(),
    PanicDisorderOtherDetails: Joi.string().when("PanicDisorderOther", {
      is: true,
      then: Joi.required(),
    }),
    PanicDisorderFrequency: Joi.string().when("PanicDisorder", {
      is: true,
      then: Joi.required(),
    }),
    PanicDisorderIntensity: Joi.string().when("PanicDisorder", {
      is: true,
      then: Joi.required(),
    }),
    PanicDisorderDuration: Joi.string().when("PanicDisorder", {
      is: true,
      then: Joi.required(),
    }),
    Phobias: Joi.boolean(),
    PhobiasSpecificFear: Joi.boolean(),
    ImmediateFear: Joi.boolean(),
    PhobiasAvoidance: Joi.boolean(),
    FearExaggerated: Joi.boolean(),
    PhobiasOther: Joi.boolean(),
    PhobiasOtherDetails: Joi.string().when("PhobiasOther", {
      is: true,
      then: Joi.required(),
    }),
    PhobiasFrequency: Joi.string().when("Phobias", {
      is: true,
      then: Joi.required(),
    }),
    PhobiasIntensity: Joi.string().when("Phobias", {
      is: true,
      then: Joi.required(),
    }),
    PhobiasDuration: Joi.string().when("Phobias", {
      is: true,
      then: Joi.required(),
    }),
    DI: Joi.boolean(),
    DILowIQ: Joi.boolean(),
    DISensoryImpairments: Joi.boolean(),
    DISpeechDelays: Joi.boolean(),
    DIMotorCoordinationDelays: Joi.boolean(),
    DILearningDisorder: Joi.boolean(),
    DISpatialDelays: Joi.boolean(),
    DevelopmentalImpairmentsOther: Joi.boolean(),
    DevelopmentalImpairmentsOtherDetails: Joi.string().when(
      "DevelopmentalImpairmentsOther",
      {
        is: true,
        then: Joi.required(),
      }
    ),
    DevelopmentalImpairmentsDetails: Joi.string()
      .when("DILowIQ", { is: true, then: Joi.required() })
      .when("DISensoryImpairments", { is: true, then: Joi.required() })
      .when("DISpeechDelays", { is: true, then: Joi.required() })
      .when("DIMotorCoordinationDelays", { is: true, then: Joi.required() })
      .when("DILearningDisorder", { is: true, then: Joi.required() })
      .when("DISpatialDelays", { is: true, then: Joi.required() }),
    Bipolar: Joi.boolean(),
    ManicEpisodes: Joi.boolean(),
    DepressiveEpisodes: Joi.boolean(),
    SignificantMoodChanges: Joi.boolean(),
    BipolarOther: Joi.boolean(),
    BipolarOtherDetails: Joi.string().when("BipolarOther", {
      is: true,
      then: Joi.required(),
    }),
    BipolarFrequency: Joi.string().when("Bipolar", {
      is: true,
      then: Joi.required(),
    }),
    BipolarIntensity: Joi.string().when("Bipolar", {
      is: true,
      then: Joi.required(),
    }),
    BipolarDuration: Joi.string().when("Bipolar", {
      is: true,
      then: Joi.required(),
    }),
    Borderline: Joi.boolean(),
    AvoidAbandonment: Joi.boolean(),
    UnstableRelationships: Joi.boolean(),
    IdentityDisturbances: Joi.boolean(),
    Impulsivity: Joi.boolean(),
    RecurrentSelfHarm: Joi.boolean(),
    AffectiveInstability: Joi.boolean(),
    Emptiness: Joi.boolean(),
    PoorAngerManagement: Joi.boolean(),
    ParanoidIdeation: Joi.boolean(),
    BorderlineOther: Joi.boolean(),
    BorderlineOtherDetails: Joi.string().when("BorderlineOther", {
      is: true,
      then: Joi.required(),
    }),
    BorderlineFrequency: Joi.string().when("Borderline", {
      is: true,
      then: Joi.required(),
    }),
    BorderlineIntensity: Joi.string().when("Borderline", {
      is: true,
      then: Joi.required(),
    }),
    BorderlineDuration: Joi.string().when("Borderline", {
      is: true,
      then: Joi.required(),
    }),
    OtherSymptoms: Joi.boolean(),
    OtherSymptomsDetails: Joi.string().when("OtherSymptoms", {
      is: true,
      then: Joi.required(),
    }),
    OtherSymptomsFrequency: Joi.string().when("OtherSymptoms", {
      is: true,
      then: Joi.required(),
    }),
    OtherSymptomsIntensity: Joi.string().when("OtherSymptoms", {
      is: true,
      then: Joi.required(),
    }),
    OtherSymptomsDuration: Joi.string().when("OtherSymptoms", {
      is: true,
      then: Joi.required(),
    }),
    ClinicalNarrativeSummary: Joi.string().required(),
    ClinicalNarrativeSummaryComments: Joi.string().allow(null, ""),
    DiagnosisDetails: Joi.string().required(),
    NoAdditionalNeeds: Joi.boolean(),
    AdditionalNeeds: Joi.when("NoAddtionalNeeds", {
      is: false,
      then: Joi.string()
        .when("PSDType", {
          is: "Biopsychosocial Assessment",
          then: Joi.required(),
        })
        .when("PSDType", {
          is: "Addendum/Annual Update",
          then: Joi.required(),
        }),
    }),
    TreatmentRecommendations: Joi.string().required(),
    DiagnosisEducation: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    RecommendationEducation: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
    ClientAgrees: Joi.string()
      .when("PSDType", {
        is: "Biopsychosocial Assessment",
        then: Joi.required(),
      })
      .when("PSDType", { is: "Addendum/Annual Update", then: Joi.required() }),
  },
  "8A46F2E9-A4E6-EC11-997E-0050F21C6F69": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    ReportDate: Joi.string().allow(""),
    Examiner: Joi.string().allow(""),
    ReferralReason: Joi.string().allow(""),
    BriefClinicalInterview: Joi.boolean(),
    ADOS2: Joi.boolean(),
    OtherProcedure: Joi.boolean(),
    OtherProcedureDetails: Joi.string().allow(""),
    AssessmentResults: Joi.string().allow(""),
    DiagnosticResults: Joi.string().allow(""),
    Diagnosis: Joi.string().allow(""),
    AdditionalSpecifiers: Joi.string().allow(""),
    Summary: Joi.string().allow(""),
  },
  "0F7E0BFB-A7E6-EC11-997E-0050F21C6F69": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    Calling: Joi.boolean(),
    Texting: Joi.boolean(),
    Contacts: Joi.boolean(),
    EmergencyCalling: Joi.boolean(),
    Information: Joi.boolean(),
    InternetSearch: Joi.boolean(),
    InternetPrivacy: Joi.boolean(),
    InternetSafety: Joi.boolean(),
    SocialNetworking: Joi.boolean(),
    PedestrianRules: Joi.boolean(),
    BicycleRules: Joi.boolean(),
    FoodPyramid: Joi.boolean(),
    FoodStorage: Joi.boolean(),
    KitchenSafety: Joi.boolean(),
    KitchenEmergencies: Joi.boolean(),
    RecipeTerms: Joi.boolean(),
    CleanKitchen: Joi.boolean(),
    CleanBathroom: Joi.boolean(),
    CleanBedroom: Joi.boolean(),
    ChangeBedding: Joi.boolean(),
    CleanGeneral: Joi.boolean(),
    Toothbrushing: Joi.boolean(),
    ShowerRoutine: Joi.boolean(),
    BodyCare: Joi.boolean(),
    CommonAilments: Joi.boolean(),
    Thermometer: Joi.boolean(),
    Puberty: Joi.boolean(),
    SafeSex: Joi.boolean(),
    PositiveSelfImage: Joi.boolean(),
    WeatherClothes: Joi.boolean(),
    PositiveAttitude: Joi.boolean(),
    InterpersonalRelationships: Joi.boolean(),
    Respect: Joi.boolean(),
    Etiquette: Joi.boolean(),
    Communication: Joi.boolean(),
    DecisionMaking: Joi.boolean(),
    ProblemsAndFeelings: Joi.boolean(),
    SelfControl: Joi.boolean(),
    FriendChoices: Joi.boolean(),
    HomeEntertainment: Joi.boolean(),
    OutsideActivities: Joi.boolean(),
    SavingMoney: Joi.boolean(),
    SavingOrSpending: Joi.boolean(),
    TotalCost: Joi.boolean(),
    Attendance: Joi.boolean(),
    Truancy: Joi.boolean(),
    AllBasicSkills: Joi.boolean(),
    AdvancedTexting: Joi.boolean(),
    AdvancedCellPlans: Joi.boolean(),
    AdvancedEmail: Joi.boolean(),
    AdvancedSocialNetworking: Joi.boolean(),
    AdvancedDownloading: Joi.boolean(),
    AdvancedJobSearch: Joi.boolean(),
    AdvancedTransportation: Joi.boolean(),
    AdvancedTaxis: Joi.boolean(),
    AdvancedSchedules: Joi.boolean(),
    AdvancedFastFood: Joi.boolean(),
    AdvancedMealPlanning: Joi.boolean(),
    AdvancedGroceries: Joi.boolean(),
    AdvancedCooking: Joi.boolean(),
    AdvancedIngredients: Joi.boolean(),
    AdvancedCookingMethods: Joi.boolean(),
    AdvancedMealPrep: Joi.boolean(),
    AdvancedBreakfast: Joi.boolean(),
    AdvancedLunch: Joi.boolean(),
    AdvancedDinner: Joi.boolean(),
    AdvancedTakeOut: Joi.boolean(),
    AdvancedSetTable: Joi.boolean(),
    AdvancedServeFood: Joi.boolean(),
    AdvancedEtiquette: Joi.boolean(),
    AdvancedEntertainGuests: Joi.boolean(),
    AdvancedCleaningSafety: Joi.boolean(),
    AdvancedFloorCare: Joi.boolean(),
    AdvancedLaundry: Joi.boolean(),
    AdvancedClothingRepair: Joi.boolean(),
    AdvancedHomeRepair: Joi.boolean(),
    AdvancedYardSafety: Joi.boolean(),
    AdvancedYardMaintenance: Joi.boolean(),
    AdvancedShaving: Joi.boolean(),
    AdvancedFirstAid: Joi.boolean(),
    AdvancedMedications: Joi.boolean(),
    AdvancedExerciseImportance: Joi.boolean(),
    AdvancedExerciseRoutine: Joi.boolean(),
    AdvancedPositiveSelfImage: Joi.boolean(),
    AdvancedExerciseImage: Joi.boolean(),
    AdvancedInteractions: Joi.boolean(),
    AdvancedResources: Joi.boolean(),
    AdvancedEntertainFriends: Joi.boolean(),
    AdvancedVolunteer: Joi.boolean(),
    AdvancedBudget: Joi.boolean(),
    AdvancedBankAccount: Joi.boolean(),
    AdvancedMoneyOrder: Joi.boolean(),
    AdvancedCredit: Joi.boolean(),
    AdvancedConsumerProblems: Joi.boolean(),
    AdvancedBills: Joi.boolean(),
    AdvancedReceipts: Joi.boolean(),
    AdvancedBalancing: Joi.boolean(),
    AdvancedPrivacy: Joi.boolean(),
    AdvancedNeeds: Joi.boolean(),
    AdvancedRoommate: Joi.boolean(),
    AdvancedRoommatePrivacy: Joi.boolean(),
    AdvancedFriendBreakup: Joi.boolean(),
    AdvancedMoving: Joi.boolean(),
    AdvancedPacking: Joi.boolean(),
    AdvancedHousingCosts: Joi.boolean(),
    AdvancedLease: Joi.boolean(),
    AdvancedRights: Joi.boolean(),
    AdvancedResume: Joi.boolean(),
    AdvancedCreateResume: Joi.boolean(),
    AdvancedJobApplication: Joi.boolean(),
    AdvancedJobDress: Joi.boolean(),
    AdvancedInterview: Joi.boolean(),
    AdvancedWorkPunctuality: Joi.boolean(),
    AdvancedTime: Joi.boolean(),
    AdvancedDirections: Joi.boolean(),
    AdvancedVolunteerNetwork: Joi.boolean(),
    AdvancedNetworkImportance: Joi.boolean(),
    AdvancedIDCard: Joi.boolean(),
    AdvancedSocialCard: Joi.boolean(),
    AdvancedSelectiveService: Joi.boolean(),
    AdvancedPersonalDocs: Joi.boolean(),
    AdvancedSEO: Joi.boolean(),
    AdvancedHD: Joi.boolean(),
    AdvancedPO: Joi.boolean(),
    AdvancedPL: Joi.boolean(),
    AdvancedED: Joi.boolean(),
    AdvancedPAO: Joi.boolean(),
    AdvancedSchools: Joi.boolean(),
    AdvancedSATACT: Joi.boolean(),
    AdvancedGraduateSchool: Joi.boolean(),
    AdvancedFAFSA: Joi.boolean(),
    AdvancedTuitionAssistance: Joi.boolean(),
    AdvancedAttendance: Joi.boolean(),
    AdvancedTruancy: Joi.boolean(),
    AdvancedHealthcare: Joi.boolean(),
    AdvancedDoctors: Joi.boolean(),
    AdvancedMedicalExams: Joi.boolean(),
    AdvancedInsurance: Joi.boolean(),
  },
  "10113EFF-25E8-EC11-997E-0050F21C6F69": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    SafetyPlanDate: Joi.string().required(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeations: Joi.boolean(),
    SelfHarm: Joi.boolean(),
    AWOL: Joi.boolean(),
    PropertyDestruction: Joi.boolean(),
    PhysicalAggression: Joi.boolean(),
    VerbalAggression: Joi.boolean(),
    SubstanceUse: Joi.boolean(),
    UnsafeSleepBehaviors: Joi.boolean(),
    UnsafeActsTowardsAnimals: Joi.boolean(),
    UnsafeSexualBehaviors: Joi.boolean(),
    HumanTraffickingVictim: Joi.boolean(),
    OtherBehaviors: Joi.boolean(),
    OtherBehaviorsDetails: Joi.string().when("OtherBehaviors", {
      is: true,
      then: Joi.required(),
    }),
    TriggerDetails: Joi.string().when("SubstanceUse", {
      is: true,
      then: Joi.required(),
    }),
    UnsafeActsDetails: Joi.string()
      .when("UnsafeSleepBehaviors", { is: true, then: Joi.required() })
      .when("UnsafeActsTowardsAnimals", { is: true, then: Joi.required() })
      .when("UnsafeSexualBehaviors", { is: true, then: Joi.required() }),
    ReasonsForLiving: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    FeelingToday: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    FeelingAtWorst: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    FeelingWorryPoint: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    CheckInFrequency: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    ScalingQuestion: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    Sweating: Joi.boolean(),
    BreathingHard: Joi.boolean(),
    RacingHeart: Joi.boolean(),
    ClenchingTeeth: Joi.boolean(),
    ClenchingFists: Joi.boolean(),
    RedFaced: Joi.boolean(),
    LoudVoice: Joi.boolean(),
    Rocking: Joi.boolean(),
    Fidgety: Joi.boolean(),
    Crying: Joi.boolean(),
    SleepingAlot: Joi.boolean(),
    DifficultySleeping: Joi.boolean(),
    Pacing: Joi.boolean(),
    Nauseous: Joi.boolean(),
    Alone: Joi.boolean(),
    RacingThoughts: Joi.boolean(),
    FallAsleep: Joi.boolean(),
    OtherSign: Joi.boolean(),
    OtherSignDetails: Joi.string().when("OtherSign", {
      is: true,
      then: Joi.required(),
    }),
    Yelling: Joi.boolean(),
    Reading: Joi.boolean(),
    Exercise: Joi.boolean(),
    Writing: Joi.boolean(),
    Drawing: Joi.boolean(),
    Watching: Joi.boolean(),
    Support: Joi.boolean(),
    Playing: Joi.boolean(),
    Shower: Joi.boolean(),
    Music: Joi.boolean(),
    Walking: Joi.boolean(),
    Blanket: Joi.boolean(),
    Animals: Joi.boolean(),
    OtherStrategy: Joi.boolean(),
    OtherStrategyDetails: Joi.string().when("OtherStrategy", {
      is: true,
      then: Joi.required(),
    }),
    MySupports: Joi.string().required(),
    SafetyPlan: Joi.string().required(),
    RestrictWeapons: Joi.boolean(),
    RestrictMedications: Joi.boolean(),
    RestrictSharps: Joi.boolean(),
    RestrictPoisons: Joi.boolean(),
    RestrictAlcohol: Joi.boolean(),
    RestrictLighters: Joi.boolean(),
    AlternativeTransportation: Joi.boolean(),
    OtherSteps: Joi.boolean(),
    OtherStepsDetails: Joi.string().when("OtherSteps", {
      is: true,
      then: Joi.required(),
    }),
    AdditionalSteps: Joi.string().allow(""),
    Hotline: Joi.string().required(),
    Hospital: Joi.string().required(),
    CrisisCenter: Joi.string().required(),
    OtherEmergency: Joi.string().allow(""),
    SAFYCrisisLine: Joi.string().required(),
  },
  "22CB830C-26E8-EC11-997E-0050F21C6F69": {
    SelectedProgram: Joi.string().required(),
    FamilyName: Joi.string().label("Family Name").required(),
    SafetyPlanDate: Joi.string().label("Date of Safety Plan").required(),
    Housing: Joi.boolean(),
    HousingDetails: Joi.string().allow(""),
    Food: Joi.boolean(),
    FoodDetails: Joi.string().allow(""),
    Clothing: Joi.boolean(),
    ClothingDetails: Joi.string().allow(""),
    Transportation: Joi.boolean(),
    TransportationDetails: Joi.string().allow(""),
    MedicalCare: Joi.boolean(),
    MedicalCareDetails: Joi.string().allow(""),
    Childcare: Joi.boolean(),
    ChildcareDetails: Joi.string().allow(""),
    Supervision: Joi.boolean(),
    SupervisionDetails: Joi.string().allow(""),
    DomesticViolence: Joi.boolean(),
    DomesticViolenceDetails: Joi.string().allow(""),
    FamilyConflict: Joi.boolean(),
    FamilyConflictDetails: Joi.string().allow(""),
    SubstanceAbuse: Joi.boolean(),
    SubstanceAbuseDetails: Joi.string().allow(""),
    Deescalation: Joi.boolean(),
    DeescalationDetails: Joi.string().allow(""),
    InfantSafety: Joi.boolean(),
    InfantSafetyDetails: Joi.string().allow(""),
    OtherConcerns: Joi.boolean(),
    OtherConcernsDetails: Joi.string().allow(""),
    FamilyStrengths: Joi.string()
      .label("What are the family's strengths? What is working right now?")
      .required(),
    PerspectiveOfRisk: Joi.string()
      .label("Caregiver/Family Perspective of Risk")
      .required(),
    SafetyNeeds: Joi.string()
      .label(
        "What needs to be in place to ensure the safety and wellbeing of everyone in the family?"
      )
      .required(),
    EnvironmentSteps: Joi.string()
      .label("What are steps the family can take to keep the environment safe?")
      .required(),
    MonitoringSteps: Joi.string()
      .label(
        "What are steps the family can take to have adequate monitoring/supervision?"
      )
      .required(),
    SupportForFamily: Joi.string()
      .label("Who can support the family in meeting their immediate needs?")
      .required(),
    PositiveInteractions: Joi.string()
      .label(
        "How can the family create positive interactions despite their immediate needs/crisis?"
      )
      .required(),
    AssessmentAndSteps: Joi.string()
      .label("Overall Assessment of Family Safety and Immediate Next Steps")
      .required(),
    Hotline: Joi.string().label("Hotline"),
    Hospital: Joi.string().label("Hospital/ED"),
    CrisisCenter: Joi.string().label("Crisis Center"),
    OtherEmergency: Joi.string().label("SAFY Crisis Line"),
    SAFYCrisisLine: Joi.string().label("Other"),
  },
  "F0985577-8EFC-EC11-B47A-0050F21C653C": {
    SelectedProgram: Joi.string().label("Client Program").required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    ParentName: Joi.string().required(),
    ChildName: Joi.string().required(),
    ReferralAgency: Joi.string().required(),
    ReferralAgencyDetails: Joi.string().when("ReferralAgency", {
      is: "Other",
      then: Joi.required(),
    }),
    CaseManager: Joi.string().required(),
    ServiceStandard: Joi.string().required(),
    ServiceProviders: Joi.string().required(),
    ReferralDate: Joi.string().required(),
    AuthorizedServiceUnits: Joi.number().required(),
    DeliveredServiceUnits: Joi.number().required(),
    ServiceDetails: Joi.string().required(),
    ReferralAcceptDate: Joi.string().required(),
    PhoneContact: Joi.string().required(),
    FaceToFaceContact: Joi.string().required(),
    ReferralReason: Joi.string().required(),
    Objectives: Joi.string().allow(null, ""),
    PerFamily: Joi.string().allow(null, ""),
    FamilyStrengths: Joi.string().required(),
    Recommendations: Joi.string().required(),
    CancelledByFamily: Joi.string().required(),
    CancelledByProvider: Joi.string().required(),
    NoShows: Joi.string().required(),
    ServiceGoals: Joi.string().allow(null, ""),
    ServiceGoalsNarrative: Joi.string().allow(null, ""),
  },
  "7C2C283D-7007-ED11-BD6E-DC98408D5418": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    ClientName: Joi.string().required(),
    PreferredName: Joi.string().required(),
    DOB: Joi.string().required(),
    SSNumber: Joi.string().required(),
    DateOfAdmission: Joi.string().required(),
    Sex: Joi.string().required(),
    Gender: Joi.string().required(),
    SexualOrientation: Joi.string().required(),
    Height: Joi.string().required(),
    Weight: Joi.string().required(),
    Agency: Joi.string().required(),
    ProgramName: Joi.string().required(),
    CompletedBy: Joi.string().required(),
    DateCompleted: Joi.string().required(),
    Telephone: Joi.string().required(),
    Extension: Joi.string().required(),
    Fax: Joi.string().required(),
    StartMonth: Joi.string().required(),
    StartDay: Joi.string().required(),
    StartYear: Joi.string().required(),
    EndMonth: Joi.string().required(),
    EndDay: Joi.string().required(),
    EndYear: Joi.string().required(),
    FosterCareNA: Joi.boolean(),
    FosterFamily: Joi.string().when("FosterCareNA", {
      is: false,
      then: Joi.required(),
    }),
    PlacementChangesNA: Joi.boolean(),
    PlacementChangesDetails: Joi.string().when("FosterCareNA", {
      is: false,
      then: Joi.required(),
    }),
    StateWorker: Joi.string().required(),
    County: Joi.string().required(),
    Strengths: Joi.string().required(),
    TreatmentPlanAttached: Joi.boolean(),
    CANSAttached: Joi.boolean(),
    PSDAttached: Joi.boolean(),
    RiskBehaviorsNA: Joi.boolean(),
    AnimalAbuseNA: Joi.boolean(),
    AnimalAbuseDates: Joi.string().when("AnimalAbuse", {
      is: false,
      then: Joi.required(),
    }),
    AnimalAbuseDetails: Joi.string().when("AnimalAbuse", {
      is: false,
      then: Joi.required(),
    }),
    BullyingNA: Joi.boolean(),
    BullyingDates: Joi.string().when("Bullying", {
      is: false,
      then: Joi.required(),
    }),
    BullyingDetails: Joi.string().when("Bullying", {
      is: false,
      then: Joi.required(),
    }),
    DelinquentNA: Joi.boolean(),
    DelinquentDates: Joi.string().when("DelinquentNA", {
      is: false,
      then: Joi.required(),
    }),
    DelinquentDetails: Joi.string().when("DelinquentNA", {
      is: false,
      then: Joi.required(),
    }),
    DestroyPropertyNA: Joi.boolean(),
    DestroyPropertyDates: Joi.string().when("DestroyPropertyNA", {
      is: false,
      then: Joi.required(),
    }),
    DestroyPropertyDetails: Joi.string().when("DestroyPropertyNA", {
      is: false,
      then: Joi.required(),
    }),
    ArsonistNA: Joi.boolean(),
    ArsonistDates: Joi.string().when("ArsonistNA", {
      is: false,
      then: Joi.required(),
    }),
    ArsonistDetails: Joi.string().when("ArsonistNA", {
      is: false,
      then: Joi.required(),
    }),
    GangAffiliationNA: Joi.boolean(),
    GangAffiliationDates: Joi.string().when("GangAffiliationNA", {
      is: false,
      then: Joi.required(),
    }),
    GangAffiliationDetails: Joi.string().when("GangAffiliationNA", {
      is: false,
      then: Joi.required(),
    }),
    HomicidalNA: Joi.boolean(),
    HomicidalDates: Joi.string().when("HomicidalNA", {
      is: false,
      then: Joi.required(),
    }),
    HomicidalDetails: Joi.string().when("HomicidalNA", {
      is: false,
      then: Joi.required(),
    }),
    NonCompliantNA: Joi.boolean(),
    NonCompliantDates: Joi.string().when("NonCompliantNA", {
      is: false,
      then: Joi.required(),
    }),
    NonCompliantDetails: Joi.string().when("NonCompliantNA", {
      is: false,
      then: Joi.required(),
    }),
    HarmOthersNA: Joi.boolean(),
    HarmOthersDates: Joi.string().when("HarmOthersNA", {
      is: false,
      then: Joi.required(),
    }),
    HarmOthersDetails: Joi.string().when("HarmOthersNA", {
      is: false,
      then: Joi.required(),
    }),
    RecklessNA: Joi.boolean(),
    RecklessDates: Joi.string().when("Reckless", {
      is: false,
      then: Joi.required(),
    }),
    RecklessDetails: Joi.string().when("Reckless", {
      is: false,
      then: Joi.required(),
    }),
    RunawayNA: Joi.boolean(),
    RunawayDates: Joi.string().when("Runaway", {
      is: false,
      then: Joi.required(),
    }),
    RunawayDetails: Joi.string().when("Runaway", {
      is: false,
      then: Joi.required(),
    }),
    SelfAbusiveNA: Joi.boolean(),
    SelfAbusiveDates: Joi.string().when("SelfAbusiveNA", {
      is: false,
      then: Joi.required(),
    }),
    SelfAbusiveDetails: Joi.string().when("SelfAbusiveNA", {
      is: false,
      then: Joi.required(),
    }),
    SexualBehaviorsNA: Joi.boolean(),
    SexualBehaviorsDates: Joi.string().when("SexualBehaviorsNA", {
      is: false,
      then: Joi.required(),
    }),
    SexualBehaviorsDetails: Joi.string().when("SexualBehaviorsNA", {
      is: false,
      then: Joi.required(),
    }),
    SubstanceAbuseNA: Joi.boolean(),
    SubstanceAbuseDates: Joi.string().when("SubstanceAbuseNA", {
      is: false,
      then: Joi.required(),
    }),
    SubstanceAbuseDetails: Joi.string().when("SubstanceAbuseNA", {
      is: false,
      then: Joi.required(),
    }),
    SuicidalNA: Joi.boolean(),
    SuicidalDates: Joi.string().when("SuicidalNA", {
      is: false,
      then: Joi.required(),
    }),
    SuicidalDetails: Joi.string().when("SuicidalNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherBehaviorNA: Joi.boolean(),
    OtherBehaviorDates: Joi.string().when("OtherBehaviorNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherBehaviorDetails: Joi.string().when("OtherBehaviorNA", {
      is: false,
      then: Joi.required(),
    }),
    SocialNA: Joi.boolean(),
    AngerControlNA: Joi.boolean(),
    AngerControlDetails: Joi.string().when("AngerControlNA", {
      is: false,
      then: Joi.required(),
    }),
    AnxietyNA: Joi.boolean(),
    AnxietyDetails: Joi.string().when("AnxietyNA", {
      is: false,
      then: Joi.required(),
    }),
    AttachmentNA: Joi.boolean(),
    AttachmentDetails: Joi.string().when("AttachmentNA", {
      is: false,
      then: Joi.required(),
    }),
    AttentionNA: Joi.boolean(),
    AttentionDetails: Joi.string().when("AttentionNA", {
      is: false,
      then: Joi.required(),
    }),
    DepressionNA: Joi.boolean(),
    DepressionDetails: Joi.string().when("DepressionNA", {
      is: false,
      then: Joi.required(),
    }),
    EatingDisturbancesNA: Joi.boolean(),
    EatingDisturbancesDetails: Joi.string().when("EatingDisturbancesNA", {
      is: false,
      then: Joi.required(),
    }),
    DefiantNA: Joi.boolean(),
    DefiantDetails: Joi.string().when("DefiantNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychosisNA: Joi.boolean(),
    PsychosisDetails: Joi.string().when("PsychosisNA", {
      is: false,
      then: Joi.required(),
    }),
    SomatizationNA: Joi.boolean(),
    SomatizationDetails: Joi.string().when("SomatizationNA", {
      is: false,
      then: Joi.required(),
    }),
    TantrumsNA: Joi.boolean(),
    TantrumsDetails: Joi.string().when("TantrumsNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherSocialNA: Joi.boolean(),
    OtherSocialDetails: Joi.string().when("OtherSocialNA", {
      is: false,
      then: Joi.required(),
    }),
    InterventionNA: Joi.boolean(),
    PsychiatricHospitalizationNA: Joi.boolean(),
    PsychiatricHospitalizationProvider: Joi.string().when(
      "PsychiatricHospitalizationNA",
      { is: false, then: Joi.required() }
    ),
    PsychiatricHospitalizationReason: Joi.string().when(
      "PsychiatricHospitalizationNA",
      { is: false, then: Joi.required() }
    ),
    PsychiatricHospitalizationDates: Joi.string().when(
      "PsychiatricHospitalizationNA",
      { is: false, then: Joi.required() }
    ),
    CrisisStabilizationNA: Joi.boolean(),
    CrisisStabilizationProvider: Joi.string().when("CrisisStabilizationNA", {
      is: false,
      then: Joi.required(),
    }),
    CrisisStabilizationReason: Joi.string().when("CrisisStabilizationNA", {
      is: false,
      then: Joi.required(),
    }),
    CrisisStabilizationDates: Joi.string().when("CrisisStabilizationNA", {
      is: false,
      then: Joi.required(),
    }),
    MedicalHospitalizationNA: Joi.boolean(),
    MedicalHospitalizationProvider: Joi.string().when(
      "MedicalHospitalizationNA",
      {
        is: false,
        then: Joi.required(),
      }
    ),
    MedicalHospitalizationReason: Joi.string().when(
      "MedicalHospitalizationNA",
      {
        is: false,
        then: Joi.required(),
      }
    ),
    MedicalHospitalizationDates: Joi.string().when("MedicalHospitalizationNA", {
      is: false,
      then: Joi.required(),
    }),
    TimeOutNA: Joi.boolean(),
    TimeOutReason: Joi.string().when("TimeOutNA", {
      is: false,
      then: Joi.required(),
    }),
    TimeOutUtilized: Joi.string().when("TimeOutNA", {
      is: false,
      then: Joi.required(),
    }),
    PhysicalManagementNA: Joi.boolean(),
    PhysicalManagementReason: Joi.string().when("PhysicalManagementNA", {
      is: false,
      then: Joi.required(),
    }),
    PhysicalManagementUtilized: Joi.string().when("PhysicalManagementNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherPhysicalInterventionNA: Joi.boolean(),
    OtherPhysicalInterventionReason: Joi.string().when(
      "OtherPhysicalInterventionNA",
      {
        is: false,
        then: Joi.required(),
      }
    ),
    OtherPhysicalInterventionUtilized: Joi.string().when(
      "OtherPhysicalInterventionNA",
      {
        is: false,
        then: Joi.required(),
      }
    ),
    AssistanceNA: Joi.boolean(),
    AssistanceReason: Joi.string().when("AssistanceNA", {
      is: false,
      then: Joi.required(),
    }),
    AssistanceUtilized: Joi.string().when("AssistanceNA", {
      is: false,
      then: Joi.required(),
    }),
    InvoluntaryConfinementNA: Joi.boolean(),
    InvoluntaryConfinementReason: Joi.string().when(
      "InvoluntaryConfinementNA",
      { is: false, then: Joi.required() }
    ),
    InvoluntaryConfinementUtilized: Joi.string().when(
      "InvoluntaryConfinementNA",
      {
        is: false,
        then: Joi.required(),
      }
    ),
    OtherInterventionNA: Joi.boolean(),
    OtherInterventionDetails: Joi.string().when("OtherInterventionNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherInterventionProvider: Joi.string().when("OtherInterventionNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherInterventionReason: Joi.string().when("OtherInterventionNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherInterventionUtilized: Joi.string().when("OtherInterventionNA", {
      is: false,
      then: Joi.required(),
    }),
    SupervisionDetails: Joi.string().required(),
    SupervisionPlan: Joi.string().required(),
    MedicalNA: Joi.boolean(),
    MedicalTreatment: Joi.string().when("MedicalNA", {
      is: false,
      then: Joi.required(),
    }),
    MedicationsNA: Joi.boolean(),
    Medications: Joi.string().when("MedicationsNA", {
      is: false,
      then: Joi.required(),
    }),
    MentalHealthNA: Joi.boolean(),
    CurrentDiagnoses: Joi.string().when("MentalHealthNA", {
      is: false,
      then: Joi.required(),
    }),
    ChangeInDiagnosis: Joi.string().when("MentalHealthNA", {
      is: false,
      then: Joi.required(),
    }),
    ReasonForChange: Joi.string().when("ChangeInDiagnosis", {
      is: "Yes",
      then: Joi.required(),
    }),
    TraumaNA: Joi.boolean(),
    TraumaReported: Joi.string().when("TraumaNA", {
      is: false,
      then: Joi.required(),
    }),
    TraumaReportDate: Joi.string().when("TraumaReported", {
      is: "Yes",
      then: Joi.required(),
    }),
    TraumaIssues: Joi.string().when("TraumaReported", {
      is: "Yes",
      then: Joi.required(),
    }),
    ServicesProvidedNA: Joi.boolean(),
    CaseManagementSessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    CaseManagementAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    CaseManagementProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    CaseManagementCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndividualTherapyContract: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndividualTherapySessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndividualTherapyAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndividualTherapyProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndividualTherapyCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndividualTherapyQMHPOnly: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    FamilyTherapyMembers: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    FamilyTherapySessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    FamilyTherapyAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    FamilyTherapyProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    FamilyTherapyCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    FamilyTherapyQMHPOnly: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    GroupTherapySessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    GroupTherapyAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    GroupTherapyProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    GroupTherapyCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    GroupTherapyQMHPOnly: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychoeducationTherapySessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychoeducationTherapyAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychoeducationTherapyProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychoeducationTherapyCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychiatricSessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychiatricAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychiatricProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychiatricCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SubstanceAbuseSessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SubstanceAbuseAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SubstanceAbuseProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SubstanceAbuseCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    ExploitationSessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    ExploitationAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    ExploitationProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    ExploitationCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SexualOffenderSessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SexualOffenderAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SexualOffenderProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SexualOffenderCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SexuallyReactiveSessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SexuallyReactiveAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SexuallyReactiveProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SexuallyReactiveCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndependentLivingSessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndependentLivingAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndependentLivingProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndependentLivingCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherServicesProvided: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherServicesProvidedSessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherServicesProvidedAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherServicesProvidedProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherServicesProvidedCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PCCAgreementNA: Joi.boolean(),
    PCCAgreementReason: Joi.string().when("PCCAgreement", {
      is: false,
      then: Joi.required(),
    }),
    TherapeuticException: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    TherapeuticExceptionDate: Joi.string().when("TherapeuticException", {
      is: "Y",
      then: Joi.required(),
    }),
    QMHPNA: Joi.boolean(),
    QMHPExplanation: Joi.when("ServicesProvidedNA", {
      is: false,
      then: Joi.string().when("QMHPNA", { is: false, then: Joi.required() }),
    }),
    SchoolAndDistrict: Joi.string().required(),
    CurrentGrade: Joi.string().required(),
    Preschool: Joi.boolean(),
    DayTreatment: Joi.boolean(),
    PrivateSchool: Joi.boolean(),
    College: Joi.boolean(),
    AlternativeSchool: Joi.boolean(),
    Vocational: Joi.boolean(),
    PublicSchool: Joi.boolean(),
    CampusOnsite: Joi.boolean(),
    PublicOffsite: Joi.boolean(),
    GED: Joi.boolean(),
    OtherSchoolSetting: Joi.boolean(),
    OtherSchoolSettingDetails: Joi.string().when("OtherSchoolSetting", {
      is: true,
      then: Joi.required(),
    }),
    SpecialEd: Joi.string().required(),
    SpecialEdServices: Joi.string().when("SpecialEd", {
      is: "Y",
      then: Joi.required(),
    }),
    SpecialEdDisability: Joi.string().when("SpecialEd", {
      is: "Y",
      then: Joi.required(),
    }),
    Grades: Joi.string().required(),
    SchoolBehavior: Joi.string().required(),
    OtherFunctioningDetails: Joi.string().required(),
    RelationshipDetails: Joi.string().required(),
    Responsibilities: Joi.string().required(),
    ReceiveILServices: Joi.string().required(),
    ILServicesDetails: Joi.string().when("ReceiveILServices", {
      is: "Yes",
      then: Joi.required(),
    }),
    DevelopmentalConcernsNA: Joi.boolean(),
    DevelopmentalConcerns: Joi.string().when("DevelopmentalConcernsNA", {
      is: false,
      then: Joi.required(),
    }),
    ParentingNA: Joi.boolean(),
    Pregnant: Joi.string().when("ParentingNA", {
      is: false,
      then: Joi.required(),
    }),
    DueDate: Joi.string().when("Pregnant", { is: "Yes", then: Joi.required() }),
    ChildrenDetails: Joi.string().when("ParentingNA", {
      is: false,
      then: Joi.required(),
    }),
    PregnancyComplications: Joi.when("ParentingNA", {
      is: false,
      then: Joi.when("Pregnant", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    ParentingSkills: Joi.string().when("ParentingNA", {
      is: false,
      then: Joi.required(),
    }),
    LegalNA: Joi.boolean(),
    LegalIssues: Joi.string().when("LegalNA", {
      is: false,
      then: Joi.required(),
    }),
    PermanencyGoal: Joi.string().required(),
    RightsNA: Joi.boolean(),
    RightsEndDate: Joi.string().when("RightsNA", {
      is: false,
      then: Joi.required(),
    }),
    PermanencyServices: Joi.string().required(),
    DischargePlan: Joi.string().required(),
    ProjectedDischargeDate: Joi.string().required(),
    VisitationNA: Joi.boolean(),
    FamilyEngagement: Joi.string().when("VisitationNA", {
      is: false,
      then: Joi.required(),
    }),
    FamilyProgress: Joi.string().when("VisitationNA", {
      is: false,
      then: Joi.required(),
    }),
    VisitationsDetails: Joi.string().when("VisitationNA", {
      is: false,
      then: Joi.required(),
    }),
    IndependentLivingNA: Joi.boolean(),
    SkillsLevelNA: Joi.boolean(),
    SkillsLevel: Joi.when("IndependentLivingNA", {
      is: false,
      then: Joi.string().when("SkillsLevelNA", {
        is: false,
        then: Joi.required(),
      }),
    }),
    EmploymentNA: Joi.boolean(),
    EmploymentDetails: Joi.when("IndependentLivingNA", {
      is: false,
      then: Joi.string().when("EmploymentNA", {
        is: false,
        then: Joi.required(),
      }),
    }),
    LivingArrangementNA: Joi.boolean(),
    LivingArrangement: Joi.when("IndependentLivingNA", {
      is: false,
      then: Joi.string().when("LivingArrangementNA", {
        is: false,
        then: Joi.required(),
      }),
    }),
    AdditionalConcernsNA: Joi.boolean(),
    AdditionalConcerns: Joi.string().when("AdditionalConcernsNA", {
      is: false,
      then: Joi.required(),
    }),
  },
  "DF81247E-120D-ED11-BD6E-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SSNumber: Joi.string().required(),
    PlanStatus: Joi.string().required(),
    PresentingProblems: Joi.string().required(),
    Diagnosis: Joi.string().required(),
    Summary: Joi.string().required(),
    TreatmentPlanning: Joi.boolean(),
    LivingSkills: Joi.boolean(),
    Therapy: Joi.boolean(),
    ServiceSpecifics: Joi.string().required(),
    ApprovedBy: Joi.string().required(),
    EffectiveDateNA: Joi.boolean(),
    EffectiveDate: Joi.when("EffectiveDateNA", {
      is: false,
      then: Joi.string().required(),
    }),
    WorkerName: Joi.string().required(),
    DCBSOffice: Joi.string().required(),
    WorkerAddress: Joi.string().required(),
    WorkerCityStateZip: Joi.string().required(),
    WorkerEmail: Joi.string().required(),
    WorkerTelephone: Joi.string().required(),
    Facility: Joi.string().required(),
    FacilityAddress: Joi.string().required(),
    FacilityCityStateZip: Joi.string().required(),
    FacilityTelephone: Joi.string().required(),
  },
  "C3439BF5-140D-ED11-BD6E-0050F21C653C": {
    SelectedProgram: Joi.string().label("Selected Program").required(),
    MonthEnding: Joi.string().required(),
    CaseManager: Joi.string().required(),
    SSNumber: Joi.string().required(),
    DateOfApproval: Joi.string().allow(""),
    DateOfReview: Joi.string().allow(""),
    ContactDate: Joi.string().required(),
    CAPNotes: Joi.string().required(),
    ContactLocation: Joi.string().required(),
    Evaluation: Joi.boolean(),
    IndependentLiving: Joi.boolean(),
    Placement: Joi.boolean(),
    Counseling: Joi.boolean(),
    Ongoing: Joi.boolean(),
    Transportation: Joi.boolean(),
    FamilyMeeting: Joi.boolean(),
    Visitation: Joi.boolean(),
    TreatmentPlan: Joi.string().required(),
    AttachmentIssues: Joi.string().required(),
    Education: Joi.string().required(),
    Permanency: Joi.string().required(),
    MedicalHealth: Joi.string().required(),
    IndependentLivingSkills: Joi.string().required(),
    Compliance: Joi.string().required(),
    Safety: Joi.string().required(),
    CompletedBy: Joi.string().required(),
    SupervisorName: Joi.string().required(),
  },
  "2C7175FD-140D-ED11-BD6E-0050F21C653C": {
    SelectedProgram: Joi.string().label("Selected Program").required(),
    MonthEnding: Joi.string().required(),
    CaseManager: Joi.string().required(),
    SSNumber: Joi.string().required(),
    DateOfApproval: Joi.string().allow(""),
    DateOfReview: Joi.string().allow(""),
    OverallGoals: Joi.string().required(),
    TreatmentPlan: Joi.string().required(),
    LivingSkills: Joi.string().required(),
    Therapy: Joi.string().required(),
    Adjustment: Joi.string().required(),
    Services: Joi.string().required(),
    ReturnProgress: Joi.string().required(),
    PermanencyGoal: Joi.string().required(),
    EmployedFullTime: Joi.boolean(),
    EnrolledFullTime: Joi.boolean(),
    EmployedEnrolledPartTime: Joi.boolean(),
    HighSchool: Joi.boolean(),
    College: Joi.boolean(),
    JobBarriers: Joi.boolean(),
    Incapable: Joi.boolean(),
    RequirementsNotMet: Joi.boolean(),
    Hours: Joi.string()
      .when("EmployedFullTime", { is: true, then: Joi.required() })
      .when("EmployedEnrolledPartTime", { is: true, then: Joi.required() }),
    IndependentLivingProgress: Joi.string().required(),
    CompletedBy: Joi.string().required(),
    SupervisorName: Joi.string().required(),
  },
  "D90D1048-6E17-ED11-BD6E-0050F21C653C": {
    SelectedProgram: Joi.string().label("Selected Program").required(),
    RSTTransported: Joi.string().required(),
    RSTPromises: Joi.string().required(),
    RSTLegalStatus: Joi.string().required(),
    RSTBought: Joi.string().required(),
    RSTHarm: Joi.string().required(),
    RSTDistrust: Joi.string().required(),
    RSTDocuments: Joi.string().required(),
    RSTIsolated: Joi.string().required(),
    RSTNoPayment: Joi.string().required(),
    RSTLabor: Joi.string().required(),
    RSTEvidence: Joi.string().required(),
    RSTDebt: Joi.string().required(),
    RSTCompleted: Joi.string().required(),
    RSTTVIT: Joi.string().required(),
    InterviewDate: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    ReferredHow: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    OtherReferralDetails: Joi.string()
      .when("ReferredHow", {
        is: "Other social service provider",
        then: Joi.required(),
      })
      .when("ReferredHow", {
        is: "Other law enforcement",
        then: Joi.required(),
      })
      .when("ReferredHow", {
        is: "Referred by someone else",
        then: Joi.required(),
      }),
    DeterminationKnown: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    Sex: Joi.string().when("RSTTVIT", { is: true, then: Joi.required() }),
    Language: Joi.string().when("RSTTVIT", { is: true, then: Joi.required() }),
    PreferredLanguage: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    EnglishProficiency: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    InterviewMode: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    ApproxAge: Joi.string().allow(""),
    ApproxAgeGroup: Joi.string().when("ApproxAge", {
      is: "",
      then: Joi.required(),
    }),
    YearsInSchool: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    YearsInSchoolOther: Joi.string().when("YearsInSchool", {
      is: "Other",
      then: Joi.required(),
    }),
    CountryBorn: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    OtherCitizen: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    OtherCitizenCountry: Joi.string().when("OtherCitizen", {
      is: "Yes",
      then: Joi.required(),
    }),
    MigrationNA: Joi.boolean(),
    ReasonForMigration: Joi.when("RSTTVIT", {
      is: true,
      then: Joi.when("MigrationNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    ReasonForMigrationOther: Joi.string().when("ReasonForMigration", {
      is: "Other",
      then: Joi.required(),
    }),
    LivePriorUS: Joi.when("RSTTVIT", {
      is: true,
      then: Joi.when("MigrationNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    MostRecentArrival: Joi.string().allow(""),
    OtherArrivals: Joi.string().allow(""),
    MostRecentArrivalApprox: Joi.when("RSTTVIT", {
      is: true,
      then: Joi.when("MostRecentArrival", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    ArrangedTravel: Joi.when("RSTTVIT", {
      is: true,
      then: Joi.when("MigrationNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    WhoArrangedTravel: Joi.string().when("ArrangedTravel", {
      is: "Yes",
      then: Joi.required(),
    }),
    WhatArrangedTravel: Joi.string().when("ArrangedTravel", {
      is: "Yes",
      then: Joi.required(),
    }),
    Pressure: Joi.when("RSTTVIT", {
      is: true,
      then: Joi.when("MigrationNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PressureFor: Joi.string().when("Pressure", {
      is: "Yes",
      then: Joi.required(),
    }),
    KnowCost: Joi.when("RSTTVIT", {
      is: true,
      then: Joi.when("MigrationNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    ApproxCost: Joi.string().when("KnowCost", {
      is: "Yes",
      then: Joi.required(),
    }),
    PaymentCover: Joi.string().when("KnowCost", {
      is: "Yes",
      then: Joi.required(),
    }),
    Debt: Joi.when("RSTTVIT", {
      is: true,
      then: Joi.when("MigrationNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    StillDebt: Joi.string().when("Debt", { is: "Yes", then: Joi.required() }),
    DebtDetails: Joi.string().when("Debt", { is: "Yes", then: Joi.required() }),
    PressuredCoercion: Joi.when("RSTTVIT", {
      is: true,
      then: Joi.when("MigrationNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PressuredActs: Joi.string().when("PressuredCoercion", {
      is: "Yes",
      then: Joi.required(),
    }),
    PressuredHow: Joi.string().when("PressuredCoercion", {
      is: "Yes",
      then: Joi.required(),
    }),
    OtherMigrationDetails: Joi.when("RSTTVIT", {
      is: true,
      then: Joi.when("MigrationNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    HowSupportSelf: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    WorkForPay: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    WorkDetails: Joi.string().when("WorkForPay", {
      is: "Yes",
      then: Joi.required(),
    }),
    WorkFound: Joi.string().when("WorkForPay", {
      is: "Yes",
      then: Joi.required(),
    }),
    NoPayment: Joi.string().when("RSTTVIT", { is: true, then: Joi.required() }),
    SameWork: Joi.string().when("NoPayment", {
      is: "Yes",
      then: Joi.required(),
    }),
    SideWorkDetails: Joi.string().when("SameWork", {
      is: "No",
      then: Joi.required(),
    }),
    SideWorkExpectedPay: Joi.string().when("SameWork", {
      is: "Yes",
      then: Joi.required(),
    }),
    SideWorkActualPay: Joi.string().when("SameWork", {
      is: "Yes",
      then: Joi.required(),
    }),
    WithholdPayment: Joi.boolean(),
    PaySomeoneElse: Joi.boolean(),
    ControlPayment: Joi.boolean(),
    NoPaymentIssues: Joi.boolean(),
    PaymentIssueDetails: Joi.when("RSTTVIT", {
      is: true,
      then: Joi.when("WithholdPayment", {
        is: true,
        then: Joi.string().required(),
      })
        .when("PaySomeoneElse", { is: true, then: Joi.string().required() })
        .when("ControlPayment", { is: true, then: Joi.string().required() }),
    }),
    SignDocument: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    SignDocumentDetails: Joi.string().when("SignDocument", {
      is: "Yes",
      then: Joi.required(),
    }),
    UnexpectedActivities: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    PromisedActivities: Joi.string().when("UnexpectedActivities", {
      is: "Yes",
      then: Joi.required(),
    }),
    ActualActivities: Joi.string().when("UnexpectedActivities", {
      is: "Yes",
      then: Joi.required(),
    }),
    FeelUnsafeWork: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    UnsafeWorkReason: Joi.string().when("FeelUnsafeWork", {
      is: "Yes",
      then: Joi.required(),
    }),
    HarmedYou: Joi.string().when("RSTTVIT", { is: true, then: Joi.required() }),
    HarmedYouDetails: Joi.string().when("HarmedYou", {
      is: "Yes",
      then: Joi.required(),
    }),
    HarmedOthers: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    HarmedOthersDetails: Joi.string().when("HarmedOthers", {
      is: "Yes",
      then: Joi.required(),
    }),
    AllowedBreaks: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    SickTime: Joi.string().when("AllowedBreaks", {
      is: "No",
      then: Joi.required(),
    }),
    BreakConsequences: Joi.string().when("AllowedBreaks", {
      is: "No",
      then: Joi.required(),
    }),
    AskForBreak: Joi.string().when("AllowedBreaks", {
      is: "Yes",
      then: Joi.required(),
    }),
    BreakNoPermission: Joi.string().when("AllowedBreaks", {
      is: "Yes",
      then: Joi.required(),
    }),
    WorkInjury: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    NoMedicalCare: Joi.string().when("WorkInjury", {
      is: "Yes",
      then: Joi.required(),
    }),
    WorkInjuryDetails: Joi.string().when("WorkInjury", {
      is: "Yes",
      then: Joi.required(),
    }),
    AdditionalWorkDetails: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    LivingSituation: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    LivingSituationDetails: Joi.string().when("LivingSituation", {
      is: "With others",
      then: Joi.required(),
    }),
    LivedAtWork: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    LivedAtWorkDetails: Joi.string().when("LivedAtWork", {
      is: "Yes",
      then: Joi.required(),
    }),
    UnableToLeave: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    UnableToLeaveReason: Joi.string().when("UnableToLeave", {
      is: "Yes",
      then: Joi.required(),
    }),
    LeaveConsequences: Joi.string().when("UnableToLeave", {
      is: "Yes",
      then: Joi.required(),
    }),
    Locks: Joi.string().when("RSTTVIT", { is: true, then: Joi.required() }),
    LocksDetails: Joi.string().when("Locks", {
      is: "Yes",
      then: Joi.required(),
    }),
    SupervisedContact: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    SupervisedContactDetails: Joi.string().when("SupervisedContact", {
      is: "Yes",
      then: Joi.required(),
    }),
    TakeID: Joi.string().when("RSTTVIT", { is: true, then: Joi.required() }),
    GetIDBack: Joi.string().when("TakeID", {
      is: "Yes",
      then: Joi.required(),
    }),
    FakeDocumentation: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    FakeDocumentationDetails: Joi.string().when("FakeDocumentation", {
      is: "Yes",
      then: Joi.required(),
    }),
    WorkLies: Joi.string().when("RSTTVIT", { is: true, then: Joi.required() }),
    WorkLiesDetails: Joi.string().when("WorkLies", {
      is: "Yes",
      then: Joi.required(),
    }),
    ReportThreats: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    ReportThreatsDetails: Joi.string().when("ReportThreats", {
      is: "Yes",
      then: Joi.required(),
    }),
    WitnessOtherHarm: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    WitnessOtherHarmDetails: Joi.string().when("WitnessOtherHarm", {
      is: "Yes",
      then: Joi.required(),
    }),
    WorkPressure: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    WorkPressureDetails: Joi.string().when("WorkPressure", {
      is: "Yes",
      then: Joi.required(),
    }),
    PhysicalPressure: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    PhysicalPressureDetails: Joi.string().when("PhysicalPressure", {
      is: "Yes",
      then: Joi.required(),
    }),
    UncomfortablePhotos: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    UncomfortablePhotosTakenBy: Joi.string().when("UncomfortablePhotos", {
      is: "Yes",
      then: Joi.required(),
    }),
    UncomfortablePhotosPlan: Joi.string().when("UncomfortablePhotos", {
      is: "Yes",
      then: Joi.required(),
    }),
    UncomfortablePhotosAgree: Joi.string().when("UncomfortablePhotos", {
      is: "Yes",
      then: Joi.required(),
    }),
    SexForValuables: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    SexForValuablesDetails: Joi.string().when("SexForValuables", {
      is: "Yes",
      then: Joi.required(),
    }),
    SexPressure: Joi.string().when("SexForValuables", {
      is: "Yes",
      then: Joi.required(),
    }),
    SexAsMinor: Joi.string().when("SexForValuables", {
      is: "Yes",
      then: Joi.required(),
    }),
    TakeMoney: Joi.string().when("RSTTVIT", { is: true, then: Joi.required() }),
    TakeMoneyAgree: Joi.string().when("TakeMoney", {
      is: "Yes",
      then: Joi.required(),
    }),
    TakeMoneyDetails: Joi.string().when("TakeMoney", {
      is: "Yes",
      then: Joi.required(),
    }),
    RationedFood: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    EnoughFood: Joi.string().when("RationedFood", {
      is: "Yes",
      then: Joi.required(),
    }),
    ControlledSleep: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    EnoughSleep: Joi.string().when("ControlledSleep", {
      is: "Yes",
      then: Joi.required(),
    }),
    LanguageBarriers: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    ConditionDetails: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    WantReferral: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    NonverbalIndicators: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    PotentialInaccuracies: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    Likelihood: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    Reasoning: Joi.string().when("RSTTVIT", { is: true, then: Joi.required() }),
    ServicesReferred: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
    AdditionalNotes: Joi.string().when("RSTTVIT", {
      is: true,
      then: Joi.required(),
    }),
  },
  "4C774EEA-EF17-ED11-BD6E-0050F21C653C": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    DateOfDischarge: Joi.string().required().label("Date of Discharge"),
    DischargeReason: Joi.string().required().label("Reason for discharge"),
    BriefExplanation: Joi.string()
      .label("Brief Explanation")
      .when("DischargeReason", { is: "186460008", then: Joi.required() })
      .when("DischargeReason", { is: "186460005", then: Joi.required() })
      .when("DischargeReason", { is: "186460006", then: Joi.required() }),
    OutpatientMentalHealth: Joi.boolean(),
    OutpatientMentalHealthReferredTo: Joi.string()
      .label("Referred To")
      .when("OutpatientMentalHealth", { is: true, then: Joi.required() }),
    OutpatientSubstanceAbuse: Joi.string().label(
      "Outpatient Alcohol/Substance Abuse"
    ),
    OutpatientSubstanceAbuseReferredTo: Joi.string()
      .label("Referred To")
      .when("OutpatientSubstanceAbuse", { is: true, then: Joi.required() }),
    HousingAssistance: Joi.boolean(),
    HousingAssistanceReferredTo: Joi.string()
      .label("Referred To")
      .when("HousingAssistance", { is: true, then: Joi.required() }),
    JobTraining: Joi.boolean(),
    JobTrainingReferredTo: Joi.string()
      .label("Referred To")
      .when("JobTraining", { is: true, then: Joi.required() }),
    EducationServices: Joi.boolean(),
    EducationServicesReferredTo: Joi.string()
      .label("Referred To")
      .when("EducationServices", { is: true, then: Joi.required() }),
    Tutoring: Joi.boolean(),
    TutoringReferredTo: Joi.string()
      .label("Referred To")
      .when("Tutoring", { is: true, then: Joi.required() }),
    PsychiatricAppointment: Joi.boolean(),
    PsychiatricAppointmentReferredTo: Joi.string()
      .label("Referred To")
      .when("PsychiatricAppointment", { is: true, then: Joi.required() }),
    Prescriptions: Joi.boolean(),
    PrescriptionsReferredTo: Joi.string()
      .label("Referred To")
      .when("Prescriptions", { is: true, then: Joi.required() }),
    MedicalServices: Joi.boolean(),
    MedicalServicesReferredTo: Joi.string()
      .label("Referred To")
      .when("MedicalServices", { is: true, then: Joi.required() }),
    Probation: Joi.boolean(),
    ProbationReferredTo: Joi.string()
      .label("Referred To")
      .when("Probation", { is: true, then: Joi.required() }),
    LegalServices: Joi.boolean(),
    LegalServicesReferredTo: Joi.string()
      .label("Referred To")
      .when("LegalServices", { is: true, then: Joi.required() }),
    PhysicianAppointment: Joi.boolean(),
    PhysicianAppointmentReferredTo: Joi.string()
      .label("Referred To")
      .when("PhysicianAppointment", { is: true, then: Joi.required() }),
    WelfareSupport: Joi.boolean(),
    WelfareSupportReferredTo: Joi.string()
      .label("Referred To")
      .when("WelfareSupport", { is: true, then: Joi.required() }),
    FinancialSupport: Joi.boolean(),
    FinancialSupportReferredTo: Joi.string()
      .label("Referred To")
      .when("FinancialSupport", { is: true, then: Joi.required() }),
    InHomeServices: Joi.boolean(),
    InHomeServicesReferredTo: Joi.string()
      .label("Referred To")
      .when("InHomeServices", { is: true, then: Joi.required() }),
    OtherServices: Joi.boolean(),
    OtherServicesReferredTo: Joi.string()
      .label("Referred To")
      .when("OtherServices", { is: true, then: Joi.required() }),
    LocalCrisisCenter: Joi.string().required().label("Local Crisis Center"),
    LocalCrisisCenterDetails: Joi.string()
      .required()
      .label("Local Crisis Center Details"),
    ServicesNarrative: Joi.string()
      .label("Narrative of Services Provided")
      .required(),
    Behavior: Joi.string().required().label("Behavior"),
    SocialInteraction: Joi.string()
      .required()
      .label("Social and Peer Interaction"),
    AdditionalAccomplishments: Joi.string()
      .required()
      .label("Additional Accomplishments"),
    FollowUp: Joi.string().required().label("Follow-up/Scheduled Appointments"),
    CopingSkills: Joi.string().required().label("Coping Skills"),
    SelfRegulate: Joi.string().required().label("Self-regulate"),
    Boundaries: Joi.string().required().label("Boundaries"),
    SchoolAttendance: Joi.string().required().label("School Attendance"),
    NewCharges: Joi.string().required().label("New Charges"),
    ReducedContact: Joi.string()
      .required()
      .label("Reduced hospital or police contact"),
    NavigateCrisis: Joi.string().required().label("Navigate crisis"),
    Advocate: Joi.string().required().label("Advocate for needs"),
    PositiveSupports: Joi.string().required().label("Positive supports"),
    DecreasedSubstanceAbuse: Joi.string()
      .required()
      .label("Decreased Substance Abuse"),
    OtherOutcomes: Joi.string().label("Other Outcomes"),
  },
  "A3DEC78C-8519-ED11-BD6E-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Medicaid: Joi.string().required(),
    AssessmentDate: Joi.string().required(),
    RBHSAdmissionDate: Joi.string().required(),
    Age: Joi.string().required(),
    DOB: Joi.string().required(),
    Phone: Joi.string().required(),
    Address: Joi.string().required(),
    Race: Joi.string().required(),
    LegalStatus: Joi.string().required(),
    MaritalStatus: Joi.string().required(),
    PhysicalAppearance: Joi.string().required(),
    PreferredLanguage: Joi.string().required(),
    PresentingProblem: Joi.string().required(),
    MSAppearance: Joi.string().required(),
    MSAttitude: Joi.string().required(),
    MSMotorActivity: Joi.string().required(),
    MSAffect: Joi.string().required(),
    MSMood: Joi.string().required(),
    MSSpeech: Joi.string().required(),
    MSThoughtContent: Joi.string().required(),
    PsychiatricTreatmentHistory: Joi.string().required(),
    CurrentDiagnosis: Joi.string().required(),
    DiagnosticImpressions: Joi.string().required(),
    MedicalHistory: Joi.string().required(),
    PCPNA: Joi.boolean(),
    PCPName: Joi.string().when("PCPNA", { is: false, then: Joi.required() }),
    OTCMedicationsNA: Joi.boolean(),
    OTCMedications: Joi.string().when("OTCMedicationsNA", {
      is: false,
      then: Joi.required(),
    }),
    AllergiesNA: Joi.boolean(),
    Allergies: Joi.string().when("AllergiesNA", {
      is: false,
      then: Joi.required(),
    }),
    CurrentMedicationsNA: Joi.boolean(),
    CurrentMedications: Joi.string().when("CurrentMedicationsNA", {
      is: false,
      then: Joi.required(),
    }),
    FamilyDisorders: Joi.string().required(),
    ViolentHistory: Joi.string().required(),
    IndicationsOfTrauma: Joi.string().required(),
    PsychosocialHistory: Joi.string().required(),
    ChildhoodHistory: Joi.string().required(),
    FamilyHistory: Joi.string().required(),
    PlacementHistory: Joi.string().required(),
    Environment: Joi.string().required(),
    Education: Joi.string().required(),
    MilitaryService: Joi.string().required(),
    MilitaryServiceDetails: Joi.string().when("MilitaryService", {
      is: "Yes",
      then: Joi.required(),
    }),
    EmploymentHistory: Joi.string().required(),
    EmploymentHistoryDetails: Joi.string().when("EmploymentHistory", {
      is: "Yes",
      then: Joi.required(),
    }),
    CurrentInvolvement: Joi.string().required(),
    LegalAssessment: Joi.string().required(),
    LegalDetails: Joi.string().when("LegalAssessment", {
      is: "Yes",
      then: Joi.required(),
    }),
    Religion: Joi.string().required(),
    Strengths: Joi.string().required(),
    Weaknesses: Joi.string().required(),
    ProblemBehaviors: Joi.string().required(),
    OverallEvaluation: Joi.string().required(),
    PsychologicalAssessment: Joi.string().required(),
    PsychiatricEvaluation: Joi.string().required(),
    SexualHistory: Joi.string().required(),
    SubstanceUseIssue: Joi.string().required(),
    SubstanceUseReferred: Joi.string().required(),
    SubstanceUseConcern: Joi.string().required(),
    PsychoactiveHistory: Joi.string()
      .when("SubstanceUseIssue", {
        is: "Yes",
        then: Joi.required(),
      })
      .when("SubstanceUseReferred", {
        is: "Yes",
        then: Joi.required(),
      })
      .when("SubstanceUseConcern", {
        is: "Yes",
        then: Joi.required(),
      }),
    SubstanceUseTreatmentHistory: Joi.string()
      .when("SubstanceUseIssue", {
        is: "Yes",
        then: Joi.required(),
      })
      .when("SubstanceUseReferred", {
        is: "Yes",
        then: Joi.required(),
      })
      .when("SubstanceUseConcern", {
        is: "Yes",
        then: Joi.required(),
      }),
    AssessmentSources: Joi.string().required(),
    BehavioralFunctioning: Joi.string().required(),
    CognitiveFunctioning: Joi.string().required(),
    EmotionalFunctioning: Joi.string().required(),
    Symptoms: Joi.string().required(),
    Factors: Joi.string().required(),
    AssessmentCompletedBy: Joi.string().required(),
    CoreDailyLivingTasks: Joi.boolean(),
    CorePersonalRelationships: Joi.boolean(),
    CoreWork: Joi.boolean(),
    CoreRecreation: Joi.boolean(),
    NoServices: Joi.boolean(),
    IndividualTherapy: Joi.boolean(),
    IndividualTherapyUnits: Joi.string().when("IndividualTherapy", {
      is: true,
      then: Joi.required(),
    }),
    IndividualTherapyFrequency: Joi.string().when("IndividualTherapy", {
      is: true,
      then: Joi.required(),
    }),
    FamilyTherapy: Joi.boolean(),
    FamilyTherapyUnits: Joi.string().when("FamilyTherapy", {
      is: true,
      then: Joi.required(),
    }),
    FamilyTherapyFrequency: Joi.string().when("FamilyTherapy", {
      is: true,
      then: Joi.required(),
    }),
    WithoutBeneficiary: Joi.boolean(),
    WithoutBeneficiaryUnits: Joi.string().when("WithoutBeneficiary", {
      is: true,
      then: Joi.required(),
    }),
    WithoutBeneficiaryFrequency: Joi.string().when("WithoutBeneficiary", {
      is: true,
      then: Joi.required(),
    }),
    CrisisManagement: Joi.boolean(),
    CrisisManagementUnits: Joi.string().when("CrisisManagement", {
      is: true,
      then: Joi.required(),
    }),
    CrisisManagementFrequency: Joi.string().when("CrisisManagement", {
      is: true,
      then: Joi.required(),
    }),
    ServicePlan: Joi.boolean(),
    ServicePlanUnits: Joi.string().when("ServicePlan", {
      is: true,
      then: Joi.required(),
    }),
    ServicePlanFrequency: Joi.string().when("ServicePlan", {
      is: true,
      then: Joi.required(),
    }),
    CommunityDailyLivingTasks: Joi.boolean(),
    CommunityPersonalRelationships: Joi.boolean(),
    CommunityWork: Joi.boolean(),
    CommunityRecreation: Joi.boolean(),
    NoCommunitySupport: Joi.boolean(),
    Psychosocial: Joi.boolean(),
    PsychosocialUnits: Joi.string().when("Psychosocial", {
      is: true,
      then: Joi.required(),
    }),
    PsychosocialFrequency: Joi.string().when("Psychosocial", {
      is: true,
      then: Joi.required(),
    }),
    FamilySupport: Joi.boolean(),
    FamilySupportUnits: Joi.string().when("FamilySupport", {
      is: true,
      then: Joi.required(),
    }),
    FamilySupportFrequency: Joi.string().when("FamilySupport", {
      is: true,
      then: Joi.required(),
    }),
    BehaviorModification: Joi.boolean(),
    BehaviorModificationUnits: Joi.string().when("BehaviorModification", {
      is: true,
      then: Joi.required(),
    }),
    BehaviorModificationFrequency: Joi.string().when("BehaviorModification", {
      is: true,
      then: Joi.required(),
    }),
    CommunityCrisisManagement: Joi.boolean(),
    CommunityCrisisManagementUnits: Joi.string().when(
      "CommunityCrisisManagement",
      { is: true, then: Joi.required() }
    ),
    CommunityCrisisManagementFrequency: Joi.string().when(
      "CommunityCrisisManagement",
      { is: true, then: Joi.required() }
    ),
    CommunityServicePlan: Joi.boolean(),
    CommunityServicePlanUnits: Joi.string().when("CommunityServicePlan", {
      is: true,
      then: Joi.required(),
    }),
    CommunityServicePlanFrequency: Joi.string().when("CommunityServicePlan", {
      is: true,
      then: Joi.required(),
    }),
    FosterCare: Joi.boolean(),
    FosterCareFrequency: Joi.string().allow(""),
  },
  "B81A59B9-8519-ED11-BD6E-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Medicaid: Joi.string().required(),
    FollowUpDate: Joi.string().required(),
    CurrentDiagnosis: Joi.string().required(),
    BehaviorChanges: Joi.string().required(),
    TreatmentProgress: Joi.string().required(),
    ReferralsNeeded: Joi.string().required(),
    ReferralsNeededDetails: Joi.string().when("ReferralsNeeded", {
      is: "Yes",
      then: Joi.required(),
    }),
    FollowUpCompletedBy: Joi.string().required(),
    CoreDailyLivingTasks: Joi.boolean(),
    CorePersonalRelationships: Joi.boolean(),
    CoreWork: Joi.boolean(),
    CoreRecreation: Joi.boolean(),
    NoServices: Joi.boolean(),
    IndividualTherapy: Joi.boolean(),
    IndividualTherapyUnits: Joi.string().when("IndividualTherapy", {
      is: true,
      then: Joi.required(),
    }),
    IndividualTherapyFrequency: Joi.string().when("IndividualTherapy", {
      is: true,
      then: Joi.required(),
    }),
    FamilyTherapy: Joi.boolean(),
    FamilyTherapyUnits: Joi.string().when("FamilyTherapy", {
      is: true,
      then: Joi.required(),
    }),
    FamilyTherapyFrequency: Joi.string().when("FamilyTherapy", {
      is: true,
      then: Joi.required(),
    }),
    WithoutBeneficiary: Joi.boolean(),
    WithoutBeneficiaryUnits: Joi.string().when("WithoutBeneficiary", {
      is: true,
      then: Joi.required(),
    }),
    WithoutBeneficiaryFrequency: Joi.string().when("WithoutBeneficiary", {
      is: true,
      then: Joi.required(),
    }),
    CrisisManagement: Joi.boolean(),
    CrisisManagementUnits: Joi.string().when("CrisisManagement", {
      is: true,
      then: Joi.required(),
    }),
    CrisisManagementFrequency: Joi.string().when("CrisisManagement", {
      is: true,
      then: Joi.required(),
    }),
    ServicePlan: Joi.boolean(),
    ServicePlanUnits: Joi.string().when("ServicePlan", {
      is: true,
      then: Joi.required(),
    }),
    ServicePlanFrequency: Joi.string().when("ServicePlan", {
      is: true,
      then: Joi.required(),
    }),
    CommunityDailyLivingTasks: Joi.boolean(),
    CommunityPersonalRelationships: Joi.boolean(),
    CommunityWork: Joi.boolean(),
    CommunityRecreation: Joi.boolean(),
    NoCommunitySupport: Joi.boolean(),
    Psychosocial: Joi.boolean(),
    PsychosocialUnits: Joi.string().when("Psychosocial", {
      is: true,
      then: Joi.required(),
    }),
    PsychosocialFrequency: Joi.string().when("Psychosocial", {
      is: true,
      then: Joi.required(),
    }),
    FamilySupport: Joi.boolean(),
    FamilySupportUnits: Joi.string().when("FamilySupport", {
      is: true,
      then: Joi.required(),
    }),
    FamilySupportFrequency: Joi.string().when("FamilySupport", {
      is: true,
      then: Joi.required(),
    }),
    BehaviorModification: Joi.boolean(),
    BehaviorModificationUnits: Joi.string().when("BehaviorModification", {
      is: true,
      then: Joi.required(),
    }),
    BehaviorModificationFrequency: Joi.string().when("BehaviorModification", {
      is: true,
      then: Joi.required(),
    }),
    CommunityCrisisManagement: Joi.boolean(),
    CommunityCrisisManagementUnits: Joi.string().when(
      "CommunityCrisisManagement",
      { is: true, then: Joi.required() }
    ),
    CommunityCrisisManagementFrequency: Joi.string().when(
      "CommunityCrisisManagement",
      { is: true, then: Joi.required() }
    ),
    CommunityServicePlan: Joi.boolean(),
    CommunityServicePlanUnits: Joi.string().when("CommunityServicePlan", {
      is: true,
      then: Joi.required(),
    }),
    CommunityServicePlanFrequency: Joi.string().when("CommunityServicePlan", {
      is: true,
      then: Joi.required(),
    }),
    FosterCare: Joi.boolean(),
    FosterCareFrequency: Joi.string().when("FosterCare", {
      is: true,
      then: Joi.required(),
    }),
  },
  "4ACBD9B9-BD19-ED11-BD6E-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Type: Joi.string().required(),
    Date: Joi.string().required(),
    LastDate: Joi.string()
      .when("Type", {
        is: "No Show, next appointment is scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "No Show, no more appointments scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, no more appointments scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, no appointment scheduled",
        then: Joi.required(),
      }),
    NextDate: Joi.string()
      .when("Type", {
        is: "No Show, next appointment is scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, next appointment scheduled",
        then: Joi.required(),
      }),
    Address: Joi.string().required(),
    Caregiver: Joi.string().required(),
    ClientFirst: Joi.string().required(),
    ClientLast: Joi.string().required(),
    ContactInfo: Joi.string().required(),
    Clinician: Joi.string().required(),
    General: Joi.string().when("Type", {
      is: "General Letter",
      then: Joi.required(),
    }),
  },
  "7599E2C2-BD19-ED11-BD6E-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Date: Joi.string().required(),
    Clinician: Joi.string().required(),
    Client: Joi.string().required(),
    Type: Joi.string().required(),
    LastDate: Joi.string()
      .when("Type", {
        is: "No Show, next appointment is scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "No Show, no more appointments scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, no more appointments scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, no appointment scheduled",
        then: Joi.required(),
      }),
    NextDate: Joi.string()
      .when("Type", {
        is: "No Show, next appointment is scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, next appointment scheduled",
        then: Joi.required(),
      }),
    Address: Joi.string().required(),
    ContactInfo: Joi.string().required(),
    General: Joi.string().when("Type", {
      is: "General Letter",
      then: Joi.required(),
    }),
  },
  "F46755CB-BD19-ED11-BD6E-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Date: Joi.string().required(),
    Address: Joi.string().required(),
    Caregiver: Joi.string().required(),
    ClientFirst: Joi.string().required(),
    ClientLast: Joi.string().required(),
    NextDate: Joi.string().required(),
    DueDate: Joi.string().required(),
    ContactInfo: Joi.string().required(),
    Therapist: Joi.string().required(),
  },
  "F36755CB-BD19-ED11-BD6E-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Date: Joi.string().required(),
    Address: Joi.string().required(),
    Client: Joi.string().required(),
    NextDate: Joi.string().required(),
    DueDate: Joi.string().required(),
    ContactInfo: Joi.string().required(),
    Therapist: Joi.string().required(),
  },
  "1CBDAF41-991D-ED11-BD6E-0050F21C6F69": {
    SelectedProgram: Joi.string().required(),
    DateCompleted: Joi.string().required(),
    Alcohol: Joi.string().required(),
    Marijuana: Joi.string().required(),
    OtherSubstance: Joi.string().required(),
    Car: Joi.string().required(),
    Relax: Joi.string()
      .when("Alcohol", { is: "Yes", then: Joi.required() })
      .when("Marijuana", { is: "Yes", then: Joi.required() })
      .when("OtherSubstance", { is: "Yes", then: Joi.required() }),
    Alone: Joi.string()
      .when("Alcohol", { is: "Yes", then: Joi.required() })
      .when("Marijuana", { is: "Yes", then: Joi.required() })
      .when("OtherSubstance", { is: "Yes", then: Joi.required() }),
    Forget: Joi.string()
      .when("Alcohol", { is: "Yes", then: Joi.required() })
      .when("Marijuana", { is: "Yes", then: Joi.required() })
      .when("OtherSubstance", { is: "Yes", then: Joi.required() }),
    Friends: Joi.string()
      .when("Alcohol", { is: "Yes", then: Joi.required() })
      .when("Marijuana", { is: "Yes", then: Joi.required() })
      .when("OtherSubstance", { is: "Yes", then: Joi.required() }),
    Trouble: Joi.string()
      .when("Alcohol", { is: "Yes", then: Joi.required() })
      .when("Marijuana", { is: "Yes", then: Joi.required() })
      .when("OtherSubstance", { is: "Yes", then: Joi.required() }),
  },
  "DC4982D5-381F-ED11-BD6E-0050F21C6F69": {
    SelectedProgram: Joi.string().required(),
    CaseNumber: Joi.string().required(),
    GradeLevel: Joi.string().required(),
    AdmissionDate: Joi.string().required(),
    DischargeDate: Joi.string().required(),
    AdmissionLevelOfCare: Joi.string().required(),
    BackgroundData: Joi.string().required(),
    DevelopmentalCapacity: Joi.string().required(),
    Diagnosis: Joi.string().required(),
    Goals: Joi.string().required(),
    Progress: Joi.string().required(),
    PastMedications: Joi.string().allow(""),
    Treatment: Joi.string().required(),
    Prognosis: Joi.string().required(),
    DischargeLevelOfCare: Joi.string().required(),
    CurrentMedications: Joi.string().required(),
    DischargedTo: Joi.string().required(),
    MeetPermanency: Joi.string().required(),
    AfterCarePlanNA: Joi.boolean(),
    AfterCarePlanDetails: Joi.string().when("AfterCarePlanNA", {
      is: false,
      then: Joi.required(),
    }),
    PhysicalExam: Joi.string().allow(""),
    DentalExam: Joi.string().allow(""),
    VisionExam: Joi.string().allow(""),
    OtherExam: Joi.string().allow(""),
    ScheduledAppointments: Joi.boolean(),
    ScheduledAppointmentsDetails: Joi.string().when("ScheduledAppointments", {
      is: true,
      then: Joi.required(),
    }),
    ScheduledMeetings: Joi.boolean(),
    ScheduledMeetingsDetails: Joi.string().when("ScheduledMeetings", {
      is: true,
      then: Joi.required(),
    }),
  },
  "D8121B55-1723-ED11-AE83-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    Date: Joi.string().required(),
    FindResources: Joi.number().min(1).max(5).required(),
    GetResources: Joi.number().min(1).max(5).required(),
    Safe: Joi.number().min(1).max(5).required(),
    Decisions: Joi.number().min(1).max(5).required(),
    Listen: Joi.number().min(1).max(5).required(),
    Support: Joi.number().min(1).max(5).required(),
    Communication: Joi.number().min(1).max(5).required(),
    Crisis: Joi.number().min(1).max(5).required(),
    Advocate: Joi.number().min(1).max(5).required(),
    Understand: Joi.number().min(1).max(5).required(),
    Comfortable: Joi.number().min(1).max(5).required(),
    Relationship: Joi.string().required(),
    Comments: Joi.string().allow(""),
  },
  "1BEB901E-1C23-ED11-AE83-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    Date: Joi.string().required(),
    FindResourcesEntry: Joi.number().allow(1, 2, 3, 4, 5),
    FindResourcesExit: Joi.number().allow(1, 2, 3, 4, 5).required(),
    GetResourcesEntry: Joi.number().allow(1, 2, 3, 4, 5),
    GetResourcesExit: Joi.number().allow(1, 2, 3, 4, 5).required(),
    SafeEntry: Joi.number().allow(1, 2, 3, 4, 5),
    SafeExit: Joi.number().allow(1, 2, 3, 4, 5).required(),
    DecisionsEntry: Joi.number().allow(1, 2, 3, 4, 5),
    DecisionsExit: Joi.number().allow(1, 2, 3, 4, 5).required(),
    ListenEntry: Joi.number().allow(1, 2, 3, 4, 5),
    ListenExit: Joi.number().allow(1, 2, 3, 4, 5).required(),
    SupportEntry: Joi.number().allow(1, 2, 3, 4, 5),
    SupportExit: Joi.number().allow(1, 2, 3, 4, 5).required(),
    CommunicationEntry: Joi.number().allow(1, 2, 3, 4, 5),
    CommunicationExit: Joi.number().allow(1, 2, 3, 4, 5).required(),
    CrisisEntry: Joi.number().allow(1, 2, 3, 4, 5),
    CrisisExit: Joi.number().allow(1, 2, 3, 4, 5).required(),
    AdvocateEntry: Joi.number().allow(1, 2, 3, 4, 5),
    AdvocateExit: Joi.number().allow(1, 2, 3, 4, 5).required(),
    UnderstandEntry: Joi.number().allow(1, 2, 3, 4, 5),
    UnderstandExit: Joi.number().allow(1, 2, 3, 4, 5).required(),
    ComfortableEntry: Joi.number().allow(1, 2, 3, 4, 5),
    ComfortableExit: Joi.number().allow(1, 2, 3, 4, 5).required(),
    Relationship: Joi.string().required(),
    Comments: Joi.string().allow(""),
  },
  "1CC09D3F-1F23-ED11-AE83-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    Parent: Joi.string().required(),
    Date: Joi.string().required(),
    Fulfill: Joi.string().required(),
    Visits: Joi.string().required(),
    OtherContact: Joi.string().required(),
    Advocated: Joi.string().required(),
    Encouraged: Joi.string().required(),
    Connected: Joi.string().required(),
    HelpConnect: Joi.string().required(),
    Communication: Joi.string().required(),
    Supported: Joi.string().required(),
    Coached: Joi.string().required(),
    Comments: Joi.string().required(),
    ConnectRelationship: Joi.string().required(),
    SupportRelationship: Joi.string().required(),
    DHSCommunication: Joi.string().required(),
    AttorneyCommunication: Joi.string().required(),
    Advocate: Joi.string().required(),
    Custody: Joi.string().required(),
    ReliableAppts: Joi.string().required(),
    FindResources: Joi.string().required(),
    NeedsContact: Joi.string().required(),
    Responsibility: Joi.string().required(),
    Willingness: Joi.string().required(),
    RatingComments: Joi.string()
      .when("ConnectRelationship", {
        is: "Significant Improvement",
        then: Joi.required(),
      })
      .when("ConnectRelationship", {
        is: "Remained the Same",
        then: Joi.required(),
      })
      .when("ConnectRelationship", { is: "Decreased", then: Joi.required() })
      .when("SupportRelationship", {
        is: "Significant Improvement",
        then: Joi.required(),
      })
      .when("SupportRelationship", {
        is: "Remained the Same",
        then: Joi.required(),
      })
      .when("SupportRelationship", { is: "Decreased", then: Joi.required() })
      .when("DHSCommunication", {
        is: "Significant Improvement",
        then: Joi.required(),
      })
      .when("DHSCommunication", {
        is: "Remained the Same",
        then: Joi.required(),
      })
      .when("DHSCommunication", { is: "Decreased", then: Joi.required() })
      .when("AttorneyCommunication", {
        is: "Significant Improvement",
        then: Joi.required(),
      })
      .when("AttorneyCommunication", {
        is: "Remained the Same",
        then: Joi.required(),
      })
      .when("AttorneyCommunication", { is: "Decreased", then: Joi.required() })
      .when("Advocate", { is: "Significant Improvement", then: Joi.required() })
      .when("Advocate", { is: "Remained the Same", then: Joi.required() })
      .when("Advocate", { is: "Decreased", then: Joi.required() })
      .when("Custody", { is: "Significant Improvement", then: Joi.required() })
      .when("Custody", { is: "Remained the Same", then: Joi.required() })
      .when("Custody", { is: "Decreased", then: Joi.required() })
      .when("ReliableAppts", {
        is: "Significant Improvement",
        then: Joi.required(),
      })
      .when("ReliableAppts", { is: "Remained the Same", then: Joi.required() })
      .when("ReliableAppts", { is: "Decreased", then: Joi.required() })
      .when("FindResources", {
        is: "Significant Improvement",
        then: Joi.required(),
      })
      .when("FindResources", { is: "Remained the Same", then: Joi.required() })
      .when("FindResources", { is: "Decreased", then: Joi.required() })
      .when("NeedsContact", {
        is: "Significant Improvement",
        then: Joi.required(),
      })
      .when("NeedsContact", { is: "Remained the Same", then: Joi.required() })
      .when("NeedsContact", { is: "Decreased", then: Joi.required() })
      .when("Responsibility", {
        is: "Significant Improvement",
        then: Joi.required(),
      })
      .when("Responsibility", { is: "Remained the Same", then: Joi.required() })
      .when("Responsibility", { is: "Decreased", then: Joi.required() })
      .when("Willingness", {
        is: "Significant Improvement",
        then: Joi.required(),
      })
      .when("Willingness", { is: "Remained the Same", then: Joi.required() })
      .when("Willingness", { is: "Decreased", then: Joi.required() }),
  },
  "19D27001-C224-ED11-AE83-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    Agency: Joi.string().required(),
    ServicesProvided: Joi.string().required(),
    Attendance: Joi.string().required(),
    AttendanceDetails: Joi.string().when("Attendance", {
      is: "Other",
      then: Joi.required(),
    }),
    Engagement: Joi.string().required(),
    EngagementDetails: Joi.string().when("Engagement", {
      is: "Other",
      then: Joi.required(),
    }),
    ReachOut: Joi.boolean(),
    Navigation: Joi.boolean(),
    Connected: Joi.boolean(),
    CasePlan: Joi.boolean(),
    Other: Joi.boolean(),
    OtherDetails: Joi.string().when("Other", {
      is: true,
      then: Joi.required(),
    }),
  },
  "72BF34FF-6928-ED11-AE83-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    ReferralSource: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    CaregiverName: Joi.string().allow(""),
    YouthName: Joi.string().allow(""),
    AttendedAllSessions: Joi.string().required(),
    MissedSessions: Joi.string().when("AttendedAllSessions", {
      is: "No",
      then: Joi.required(),
    }),
    MissedSessionsComments: Joi.string().allow(""),
    CaregiverProgress: Joi.string().allow(""),
    YouthProgress: Joi.string().allow(""),
    CaregiverNextSteps: Joi.string().allow(""),
    YouthNextSteps: Joi.string().allow(""),
    SAFYTeam: Joi.string().required(),
    SignOff: Joi.string().required(),
  },
  "0A217C6A-8C28-ED11-AE83-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    Name: Joi.string().required(),
    DischargeDate: Joi.string().required(),
    SuccessfulClosure: Joi.string().required(),
    DischargeReason: Joi.string().when("SuccessfulClosure", {
      is: "No",
      then: Joi.required(),
    }),
    AreasOfGrowth: Joi.string().required(),
    Recommendations: Joi.string().required(),
    SignOff: Joi.string().required(),
  },
  "6718A278-152B-ED11-AE83-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    FollowUpType: Joi.string().required(),
    ContactAttemptsSuccessful: Joi.string().required(),
    ContactAttempts: Joi.string().when("ContactAttemptsSuccessful", {
      is: "No",
      then: Joi.required(),
    }),
    DateCompleted: Joi.string().when("ContactAttemptsSuccessful", {
      is: "Yes",
      then: Joi.required(),
    }),
    FollowUpDate: Joi.when("ContactAttemptsSuccessful", {
      is: "Yes",
      then: Joi.when("FollowUpType", {
        is: "5 Day",
        then: Joi.string().required(),
      }),
    }),
    HigherLOC: Joi.string().when("ContactAttemptsSuccessful", {
      is: "Yes",
      then: Joi.required(),
    }),
    CrisisHotline: Joi.string().when("ContactAttemptsSuccessful", {
      is: "Yes",
      then: Joi.required(),
    }),
    OutpatientProgram: Joi.string().when("ContactAttemptsSuccessful", {
      is: "Yes",
      then: Joi.required(),
    }),
    Resources: Joi.string().when("ContactAttemptsSuccessful", {
      is: "Yes",
      then: Joi.required(),
    }),
    CopingSkills: Joi.string().when("ContactAttemptsSuccessful", {
      is: "Yes",
      then: Joi.required(),
    }),
    HealthCare: Joi.string().when("ContactAttemptsSuccessful", {
      is: "Yes",
      then: Joi.required(),
    }),
    Relationships: Joi.string().when("ContactAttemptsSuccessful", {
      is: "Yes",
      then: Joi.required(),
    }),
    Recommend: Joi.string().when("ContactAttemptsSuccessful", {
      is: "Yes",
      then: Joi.required(),
    }),
  },
  "46F05C21-2635-ED11-AE83-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    ReportMonth: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    ICWIS: Joi.string().required(),
    Permanency: Joi.string().required(),
    Connections: Joi.string().required(),
    ReferralDate: Joi.string().required(),
    ReferralReason: Joi.string().required(),
    PresentingProblem: Joi.string().required(),
    ServiceDetails: Joi.string().allow(""),
    ServiceGoals: Joi.string().allow(""),
    AuthorizationAttempts: Joi.string().required(),
    IncidentReports: Joi.string().allow(""),
    Progress: Joi.string().required(),
    DischargePlan: Joi.string().required(),
    ProjectedDischargeDate: Joi.string().required(),
  },
  "9F56E027-923E-ED11-A27C-0050F21C653C": {
    SelectedProgram: Joi.string().required().label("Client Program"),
    StaffAbuse: Joi.string().required(),
    NonStaffAbuse: Joi.string().required(),
    VisitationPlan: Joi.string().required(),
    VisitationFrequency: Joi.string().when("VisitationPlan", {
      is: "Yes",
      then: Joi.required(),
    }),
    VisitationGoal: Joi.string().when("VisitationPlan", {
      is: "Yes",
      then: Joi.required(),
    }),
    Runaway: Joi.string().required(),
    UnplannedDischarge: Joi.string().required(),
    LengthOfStay: Joi.string().when("UnplannedDischarge", {
      is: "Yes",
      then: Joi.required(),
    }),
    DSSRequest: Joi.string().required(),
  },
  "60752D59-5143-ED11-A27C-0050F21C653C": {
    SelectedProgram: Joi.string().label("Client Program").required(),
    DateCompleted: Joi.string().required().label("Date Completed"),
    PSDType: Joi.string().label("Type of PSD").required(),
    ReviewReason: Joi.string()
      .label("Reason")
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ReferralMembers: Joi.string()
      .label("Family Members on Referral")
      .required(),
    CaseMember: Joi.string()
      .label("Family Member listed under Case ID")
      .required(),
    MaGIKCaseID: Joi.string().label("MaGIK Case ID").required(),
    Caseworker: Joi.string().label("Caseworker").required(),
    Division: Joi.string().label("SAFY Division").required(),
    County: Joi.string().label("County").required(),
    CountyDetails: Joi.string()
      .label("County")
      .when("County", { is: "Other", then: Joi.required() }),
    ISFamily: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISDCS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.string()
      .label("Other Information Source details")
      .when("ISOther", { is: true, then: Joi.required() }),
    ReferralReason: Joi.string().label("Reason for Referral").required(),
    PresentingProblem: Joi.string()
      .label("Description of the Problem(s)")
      .required(),
    ProtectiveFactors: Joi.string().label("Protective Factors").required(),
    CurrentHousehold: Joi.string().label("Current Household").required(),
    OtherFamilySupports: Joi.string().label("Other Family Supports").required(),
    CaregiverCooperation: Joi.string()
      .label("Cooperation between caregivers")
      .required(),
    CaregiverCooperationDetails: Joi.string()
      .label("Cooperation between caregivers details")
      .when("CaregiverCooperation", { is: "No", then: Joi.required() }),
    SupervisionDifficulties: Joi.string()
      .label("Difficulties with the supervision")
      .required(),
    SupervisionDifficultiesDetails: Joi.string()
      .label("Difficulties with the supervision details")
      .when("SupervisionDifficulties", { is: "Yes", then: Joi.required() }),
    DisciplinePractices: Joi.string().label("Discipline practices").required(),
    Interaction: Joi.string()
      .label("Interaction between caregivers and child(ren)")
      .required(),
    FamilyHistoryUnknown: Joi.boolean(),
    FamilyHistoryDetails: Joi.string()
      .label("Extended Family History")
      .when("FamilyHistoryUnknown", { is: "false", then: Joi.required() }),
    CulturalGroup: Joi.string().label("Identified cultural group").required(),
    TraditionsComments: Joi.string()
      .label("Special cultural traditions/celebrations/rituals")
      .required(),
    LanguagesSpoken: Joi.string().label("Languages spoken").required(),
    Religion: Joi.string()
      .label("Identified religion/belief system")
      .required(),
    ReligionRole: Joi.string()
      .label("Role of faith in client's life")
      .required(),
    GenderOrientation: Joi.string()
      .label("Gender identity & sexual orientation")
      .required(),
    PCP: Joi.string().label("Primary Care Physician").required(),
    LastMedicalExamDates: Joi.string()
      .label("Date(s) of last medical exam for child(ren)")
      .required(),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.string()
      .label("Allergies details")
      .when("Allergies", { is: true, then: Joi.required() }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.string()
      .label("Medical Conditions Details")
      .when("MedicalConditions", { is: true, then: Joi.required() }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.string()
      .label("Nutritional Concerns Details")
      .when("NutritionalConcerns", { is: true, then: Joi.required() }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.string()
      .label("Dental Concerns Details")
      .when("DentalConcerns", { is: true, then: Joi.required() }),
    SleepConcerns: Joi.boolean(),
    SleepConcernsDetails: Joi.string()
      .label("Sleep Concerns Details")
      .when("SleepConcerns", { is: true, then: Joi.required() }),
    Hospitalizations: Joi.boolean(),
    HospitalizationsDetails: Joi.string()
      .label("Hospitalization Details")
      .when("Hospitalizations", { is: true, then: Joi.required() }),
    HeadInjury: Joi.boolean(),
    HeadInjuryDetails: Joi.string()
      .label("Head Injury Details")
      .when("HeadInjury", { is: true, then: Joi.required() }),
    Undiagnosed: Joi.string().label("Undiagnosed illness symptoms").required(),
    UndiagnosedComments: Joi.string()
      .label("Undiagnosed illness symptom details")
      .when("Undiagnosed", { is: "Yes", then: Joi.required() }),
    PregnancyHistory: Joi.string().label("Pregnancy History").required(),
    MilestonesMet: Joi.string()
      .label("Developmental milestones met on time")
      .required(),
    MilestonesMetDetails: Joi.string()
      .label("Milestone details")
      .when("MilestonesMet", { is: "No", then: Joi.required() }),
    SpecialNeeds: Joi.string()
      .label("Developmental delays or special needs")
      .required(),
    SpecialNeedsDetails: Joi.string()
      .label("Special needs details")
      .when("SpecialNeeds", { is: "Yes", then: Joi.required() }),
    SpecializedServices: Joi.string().label("Specialized Services").required(),
    SpecializedServicesDetails: Joi.string()
      .label("Specialized Services details")
      .when("SpecializedServices", { is: "Yes", then: Joi.required() }),
    HasMedications: Joi.string().required(),
    CurrentMedicationDetails: Joi.string()
      .label("Current Medications")
      .when("HasMedications", { is: "Yes", then: Joi.required() }),
    HadMedications: Joi.string().required(),
    PsychotropicMedications: Joi.string()
      .label("Past Psychotropic Medications")
      .when("HadMedications", { is: "Yes", then: Joi.required() }),
    HasMentalHealthTreatment: Joi.string().required(),
    MentalHealthTreatment: Joi.string()
      .label("Mental Health Treatment")
      .when("HasMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    NoSelfHarm: Joi.boolean(),
    SelfHarmDetails: Joi.string().label("Self Harm Details").required(),
    AllSelfHarmScreened: Joi.string()
      .label("All family members screened")
      .required(),
    NotAllSelfHarmScreenedDetails: Joi.string()
      .label("Not all family members screened details")
      .when("AllSelfHarmScreened", { is: "No", then: Joi.required() }),
    SelfHarmComments: Joi.string()
      .label("Comments/Action Taken")
      .when("NoSelfHarm", { is: false, then: Joi.required() }),
    NoHarmingOthers: Joi.boolean(),
    HarmingOthersDetails: Joi.string()
      .label("Harm to Others/Endangerment details")
      .required(),
    AllHarmOthersScreened: Joi.string()
      .label("All family members screened")
      .required(),
    NotAllHarmOthersScreenedDetails: Joi.string()
      .label("Not all family members screened details")
      .when("AllHarmOthersScreened", { is: "No", then: Joi.required() }),
    HarmingOthersComments: Joi.string()
      .label("Comments/Action Taken")
      .when("NoHarmingOthers", { is: false, then: Joi.required() }),
    EducationDetails: Joi.string().label("Education details").required(),
    NoneEmployed: Joi.boolean(),
    EmploymentDetails: Joi.string().label("Employment details").required(),
    MilitaryHistory: Joi.string()
      .label("Family members' military history")
      .required(),
    MilitaryHistoryDetails: Joi.string()
      .label("Military history details")
      .when("MilitaryHistory", { is: "Yes", then: Joi.required() }),
    NoSubstanceUse: Joi.boolean(),
    SubstanceUseHistory: Joi.string()
      .label("Substance Use history")
      .when("NoSubstanceUse", { is: false, then: Joi.required() }),
    HasSubstanceUseTreatment: Joi.string().required(),
    SUTreatmentHistory: Joi.string()
      .label("Substance Use Treatment history")
      .when("HasSubstanceUseTreatment", { is: "Yes", then: Joi.required() }),
    TraumaHistory: Joi.string().label("Trauma history").required(),
    FamilyChanges: Joi.string()
      .label("Changes/transitions in family")
      .required(),
    FamilyChangesDetails: Joi.string()
      .label("Changes/transitions in family description")
      .when("FamilyChanges", { is: "Yes", then: Joi.required() }),
    RecentGrief: Joi.string()
      .label("Recent or significant deaths/grief issues")
      .required(),
    RecentGriefDetails: Joi.string()
      .label("Recent or significant deaths/grief issues details")
      .when("RecentGrief", { is: "Yes", then: Joi.required() }),
    SymptomsNA: Joi.boolean(),
    Symptoms: Joi.string()
      .label("Symptoms")
      .when("SymptomsNA", { is: false, then: Joi.required() }),
    SymptomsNAComments: Joi.string()
      .label("Comments")
      .when("SymptomsNA", { is: true, then: Joi.required() }),
    Hygiene: Joi.string().label("Personal appearance and hygiene").required(),
    HygieneFamilyMembers: Joi.string()
      .label("Personal appearance and hygiene Family Members")
      .when("Hygiene", { is: "Yes", then: Joi.required() }),
    HygieneDetails: Joi.string()
      .label("Personal appearance and hygiene Details")
      .when("Hygiene", { is: "Yes", then: Joi.required() }),
    MoneyManagement: Joi.string().label("Money management").required(),
    MoneyManagementFamilyMembers: Joi.string()
      .label("Money management Family Members")
      .when("MoneyManagement", { is: "Yes", then: Joi.required() }),
    MoneyManagementDetails: Joi.string()
      .label("Money management Details")
      .when("MoneyManagement", { is: "Yes", then: Joi.required() }),
    FoodManagement: Joi.string().label("Food management").required(),
    FoodManagementFamilyMembers: Joi.string()
      .label("Food management Family Members")
      .when("FoodManagement", { is: "Yes", then: Joi.required() }),
    FoodManagementDetails: Joi.string()
      .label("Food management Details")
      .when("FoodManagement", { is: "Yes", then: Joi.required() }),
    Health: Joi.string().label("Health").required(),
    HealthFamilyMembers: Joi.string()
      .label("Health Family Members")
      .when("Health", { is: "Yes", then: Joi.required() }),
    HealthDetails: Joi.string()
      .label("Health Details")
      .when("Health", { is: "Yes", then: Joi.required() }),
    Housekeeping: Joi.string().label("Housekeeping").required(),
    HousekeepingFamilyMembers: Joi.string()
      .label("Housekeeping Family Members")
      .when("Housekeeping", { is: "Yes", then: Joi.required() }),
    HousekeepingDetails: Joi.string()
      .label("Housekeeping Details")
      .when("Housekeeping", { is: "Yes", then: Joi.required() }),
    Transportation: Joi.string().label("Transportation").required(),
    TransportationFamilyMembers: Joi.string()
      .label("Transportation Family Members")
      .when("Transportation", { is: "Yes", then: Joi.required() }),
    TransportationDetails: Joi.string()
      .label("Transportation Details")
      .when("Transportation", { is: "Yes", then: Joi.required() }),
    SafetySkills: Joi.string().label("Safety Skills").required(),
    SafetySkillsFamilyMembers: Joi.string()
      .label("Safety Skills Family Members")
      .when("SafetySkills", { is: "Yes", then: Joi.required() }),
    SafetySkillsDetails: Joi.string()
      .label("Safety Skills Details")
      .when("SafetySkills", { is: "Yes", then: Joi.required() }),
    ResourceKnowledge: Joi.string().label("ResourceKnowledge").required(),
    ResourceKnowledgeFamilyMembers: Joi.string()
      .label("Resource Knowledge Family Members")
      .when("ResourceKnowledge", { is: "Yes", then: Joi.required() }),
    ResourceKnowledgeDetails: Joi.string()
      .label("Resource Knowledge Details")
      .when("ResourceKnowledge", { is: "Yes", then: Joi.required() }),
    TimeManagement: Joi.string().label("Time Management").required(),
    TimeManagementFamilyMembers: Joi.string()
      .label("Time Management Family Members")
      .when("TimeManagement", { is: "Yes", then: Joi.required() }),
    TimeManagementDetails: Joi.string()
      .label("Time Management Details")
      .when("TimeManagement", { is: "Yes", then: Joi.required() }),
    InteractionWithOthers: Joi.string().label("Interaction").required(),
    InteractionFamilyMembers: Joi.string()
      .label("Interaction Family Members")
      .when("InteractionWithOthers", { is: "Yes", then: Joi.required() }),
    InteractionDetails: Joi.string()
      .label("Interaction Details")
      .when("InteractionWithOthers", { is: "Yes", then: Joi.required() }),
    PsychosocialFunctioning: Joi.string()
      .label("Psychosocial Functioning")
      .required(),
    LegalInvolvement: Joi.string().label("Legal Involvement").required(),
    LegalInvolvementDetails: Joi.string()
      .label("Legal History")
      .when("LegalInvolvement", { is: "Yes", then: Joi.required() }),
    CPSInvolvement: Joi.string().label("CPS Involvement").required(),
    CPSInvolvementDetails: Joi.string()
      .label("CPS History")
      .when("CPSInvolvement", { is: "Yes", then: Joi.required() }),
    PFS2CompletionStatus: Joi.string()
      .label("PFS-2 completion status")
      .required(),
    Resilience: Joi.string()
      .label("Family Functioning/Resilience")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    Attachment: Joi.string()
      .label("Nurturing and Attachment")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    SocialSupports: Joi.string()
      .label("Social Supports")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    PractitionerRelationship: Joi.string()
      .label("Caregiver/Practitioner Relationship")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    ConcreteSupports: Joi.string()
      .label("Concrete Supports")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    OtherTools: Joi.string().label("Other tools used").required(),
    OtherToolsDetails: Joi.string()
      .label("Other tool details")
      .when("OtherTools", { is: "Yes", then: Joi.required() }),
    Interpretation: Joi.string()
      .label("Interpretation of Scores")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() })
      .when("OtherTools", { is: "Yes", then: Joi.required() }),
    ClinicalSummary: Joi.string()
      .label("Clinical Observations/Family Clinical Summary")
      .required(),
    RiskFactors: Joi.string()
      .label("Areas of Concern/Risk Factors/Potential Barriers")
      .required(),
    ConcreteNeeds: Joi.string().label("Concrete Needs").required(),
    DischargePlan: Joi.string()
      .label("Family's Perspective/Plan for Discharge")
      .required(),
    DiagnosisDetails: Joi.string().label("Diagnosis Details").required(),
    TreatmentRecommendations: Joi.string()
      .label("Treatment Recommendations")
      .required(),
    AdditionalPsychiatric: Joi.boolean(),
    AdditionalPsychological: Joi.boolean(),
    AdditionalNeurological: Joi.boolean(),
    AdditionalEducational: Joi.boolean(),
    AdditionalMedical: Joi.boolean(),
    AdditionalDental: Joi.boolean(),
    AdditionalSubstanceAbuse: Joi.boolean(),
    AdditionalVocational: Joi.boolean(),
    AdditionalOccupational: Joi.boolean(),
    AdditionalNutritional: Joi.boolean(),
    AdditionalVisualAuditory: Joi.boolean(),
    AdditionalDomesticViolence: Joi.boolean(),
    AdditionalSexOffender: Joi.boolean(),
    AdditionalOther: Joi.boolean(),
    AdditionalOtherDetails: Joi.string()
      .label("Other Evaluations Needed details")
      .when("AdditionalOther", { is: true, then: Joi.required() }),
    MembersInNeed: Joi.string()
      .label("Family Member(s) in need of evaluation")
      .when("AdditionalPsychiatric", { is: true, then: Joi.required() })
      .when("AdditionalPsychological", { is: true, then: Joi.required() })
      .when("AdditionalNeurological", { is: true, then: Joi.required() })
      .when("AdditionalEducational", { is: true, then: Joi.required() })
      .when("AdditionalMedical", { is: true, then: Joi.required() })
      .when("AdditionalDental", { is: true, then: Joi.required() })
      .when("AdditionalSubstanceAbuse", { is: true, then: Joi.required() })
      .when("AdditionalVocational", { is: true, then: Joi.required() })
      .when("AdditionalOccupational", { is: true, then: Joi.required() })
      .when("AdditionalNutritional", { is: true, then: Joi.required() })
      .when("AdditionalVisualAuditory", { is: true, then: Joi.required() })
      .when("AdditionalDomesticViolence", { is: true, then: Joi.required() })
      .when("AdditionalSexOffender", { is: true, then: Joi.required() })
      .when("AdditionalOther", { is: true, then: Joi.required() }),
  },
  "DA72E30D-6346-ED11-A27C-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    Provider: Joi.string().required(),
    County: Joi.string().required(),
    Dates: Joi.string().required(),
    CurrentTier: Joi.string().required(),
    ChildIQ: Joi.string().required(),
    DatePlacedTFC: Joi.string().required(),
    DatePlacedCurrent: Joi.string().required(),
    DateLastISP: Joi.string().required(),
    PermanencyPlan: Joi.string().required(),
    ConcurrentPlan: Joi.string().required(),
    MedicaidWaiverStatus: Joi.string().required(),
    ReceiveSSI: Joi.string().required(),
    ReceiveSSIDetails: Joi.string().when("ReceiveSSI", {
      is: "Yes",
      then: Joi.required(),
    }),
    Diagnoses: Joi.string().required(),
    MedicalDiagnoses: Joi.string().required(),
    Goals: Joi.string().required(),
    Progress: Joi.string().required(),
    Barriers: Joi.string().required(),
    ADLNA: Joi.boolean(),
    Hygiene: Joi.string()
      .label("Personal Hygiene achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HygieneNeeded: Joi.string()
      .label("Personal Hygiene needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Housekeeping: Joi.string()
      .label("Housekeeping achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HousekeepingNeeded: Joi.string()
      .label("Housekeeping needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MedicationManagement: Joi.string()
      .label("Medication Management achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MedicationManagementNeeded: Joi.string()
      .label("Medication Management needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Transportation: Joi.string()
      .label("Transportation achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    TransportationNeeded: Joi.string()
      .label("Transportation needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    BehaviorEducation: Joi.string()
      .label("Behavior Education achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    BehaviorEducationNeeded: Joi.string()
      .label("Behavior Education needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    StressManagement: Joi.string()
      .label("Stress Management achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    StressManagementNeeded: Joi.string()
      .label("Stress Management needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HealthyLifestyle: Joi.string()
      .label("Healthy Lifestyle achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HealthyLifestyleNeeded: Joi.string()
      .label("Healthy Lifestyle needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Laundry: Joi.string()
      .label("Laundry achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    LaundryNeeded: Joi.string()
      .label("Laundry needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MealPrep: Joi.string()
      .label("Meal Prep achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MealPrepNeeded: Joi.string()
      .label("Meal Prep needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MoneyManagement: Joi.string()
      .label("Money Management achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MoneyManagementNeeded: Joi.string()
      .label("Money Management needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Shopping: Joi.string()
      .label("Shopping achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    ShoppingNeeded: Joi.string()
      .label("Shopping needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    BasicSkillsComments: Joi.string()
      .label("Basic Living Skills comments")
      .when("ADLNA", { is: false, then: Joi.required() }),
    RelationshipsNA: Joi.boolean(),
    CoopSkills: Joi.string()
      .label("Cooperative Play Skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    CoopSkillsDetails: Joi.string()
      .label("Cooperative Play Skills details")
      .when("CoopSkills", { is: "Problematic", then: Joi.required() }),
    CommunicationSkills: Joi.string()
      .label("Communication Skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    CommunicationSkillsDetails: Joi.string()
      .label("Communication Skills details")
      .when("CommunicationSkills", { is: "Problematic", then: Joi.required() }),
    EmotionalUnderstanding: Joi.string()
      .label("Emotional Understanding")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    EmotionalUnderstandingDetails: Joi.string()
      .label("Emotional Understanding Skills details")
      .when("EmotionalUnderstanding", {
        is: "Problematic",
        then: Joi.required(),
      }),
    ProblemSolving: Joi.string()
      .label("Problem Solving")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    ProblemSolvingDetails: Joi.string()
      .label("Problem Solving Skills details")
      .when("ProblemSolving", { is: "Problematic", then: Joi.required() }),
    ConflictResolution: Joi.string()
      .label("Conflict Resolution")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    ConflictResolutionDetails: Joi.string()
      .label("Conflict Resolution Skills details")
      .when("ConflictResolution", { is: "Problematic", then: Joi.required() }),
    DecisionMakingSkills: Joi.string()
      .label("Decision Making")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    DecisionMakingSkillsDetails: Joi.string()
      .label("Decision Making Skills details")
      .when("DecisionMakingSkills", {
        is: "Problematic",
        then: Joi.required(),
      }),
    Bullied: Joi.string()
      .label("Being bullied")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    BulliedDetails: Joi.string()
      .label("Being bullied details")
      .when("Bullied", { is: "Yes", then: Joi.required() }),
    Bully: Joi.string()
      .label("Bullying others")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    BullyDetails: Joi.string()
      .label("Bullying others details.")
      .when("Bully", { is: "Yes", then: Joi.required() }),
    AcceptedByPeers: Joi.string()
      .label("Accepted by peers")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    AcceptedByPeersDetails: Joi.string()
      .label("Not accepted by peers details")
      .when("AcceptedByPeers", { is: "No", then: Joi.required() }),
    NegativeAssociations: Joi.string()
      .label("Negative Associations")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    NegativeAssociationsDetails: Joi.string()
      .label("Negative Associations details")
      .when("NegativeAssociations", { is: "Yes", then: Joi.required() }),
    CostPlan: Joi.string().required(),
    NextSteps: Joi.string().required(),
  },
  "3A1C0F64-8346-ED11-A27C-DC98408D5418": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    ExcessWorrying: Joi.boolean(),
    Sleeping: Joi.boolean(),
    EatingHabits: Joi.boolean(),
    Depression: Joi.boolean(),
    Adjustment: Joi.boolean(),
    Anger: Joi.boolean(),
    Aggression: Joi.boolean(),
    Fear: Joi.boolean(),
    Listening: Joi.boolean(),
    Irritability: Joi.boolean(),
    Focus: Joi.boolean(),
    PanicAttacks: Joi.boolean(),
    OtherSymptom: Joi.boolean(),
    OtherSymptomDetails: Joi.string()
      .label("Other Symptom details")
      .when("OtherSymptom", { is: true, then: Joi.required() }),
    InterimDx: Joi.string().label("Interim diagnosis and code").required(),
    InterimDxOtherDetails: Joi.string()
      .label("Other diagnosis details")
      .when("InterimDx", { is: "Other", then: Joi.required() }),
    PlacedInStateHome: Joi.string().required(),
    Protection: Joi.boolean(),
    Employment: Joi.boolean(),
    Reunification: Joi.boolean(),
    PhysicalHealth: Joi.boolean(),
    Adoption: Joi.boolean(),
    SchoolSuccess: Joi.boolean(),
    MentalHealth: Joi.boolean(),
    IndependentLiving: Joi.boolean(),
    Relationships: Joi.boolean(),
    OtherGoals: Joi.boolean(),
    OtherGoalsDetails: Joi.string()
      .label("Other Goals details")
      .when("OtherGoals", { is: true, then: Joi.required() }),
    Supervision: Joi.boolean(),
    Help: Joi.boolean(),
    Transportation: Joi.boolean(),
    Knowledge: Joi.boolean(),
    SocialResources: Joi.boolean(),
    CommunitySafety: Joi.boolean(),
    PublicResources: Joi.boolean(),
    SafetyPlan: Joi.boolean(),
    AdaptiveLivingSkills: Joi.boolean(),
    OtherNeeds: Joi.boolean(),
    OtherNeedsDetails: Joi.string()
      .label("Other Needs details")
      .when("OtherNeeds", { is: true, then: Joi.required() }),
    ImmediateNeeds: Joi.when("PlacedInStateHome", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    ImmediateNeedsDetails: Joi.when("PlacedInStateHome", {
      is: "Yes",
      then: Joi.string()
        .label("Details")
        .when("ImmediateNeeds", { is: "Yes", then: Joi.required() }),
    }),
  },
  "6BFFF274-8D50-ED11-ADE6-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Name: Joi.string().required(),
    DischargeDate: Joi.string().required(),
    SuccessfulClosure: Joi.string().required(),
    DischargeReason: Joi.string().when("SuccessfulClosure", {
      is: "No",
      then: Joi.required(),
    }),
    AreasOfGrowth: Joi.string().required(),
    Recommendations: Joi.string().required(),
    SignOff: Joi.string().required(),
  },
  "51CC0E50-4751-ED11-ADE6-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Date: Joi.string().required(),
    Clinician: Joi.string().required(),
    Client: Joi.string().required(),
    Type: Joi.string().required(),
    LastDate: Joi.string()
      .when("Type", {
        is: "No Show, next appointment is scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "No Show, no more appointments scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, no more appointments scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, no appointment scheduled",
        then: Joi.required(),
      }),
    NextDate: Joi.string()
      .when("Type", {
        is: "No Show, next appointment is scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, next appointment scheduled",
        then: Joi.required(),
      }),
    Address: Joi.string().required(),
    ContactInfo: Joi.string().required(),
    General: Joi.string().when("Type", {
      is: "General Letter",
      then: Joi.required(),
    }),
  },
  "46CB4A4B-4F51-ED11-ADE6-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Type: Joi.string().required(),
    Date: Joi.string().required(),
    LastDate: Joi.string()
      .when("Type", {
        is: "No Show, next appointment is scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "No Show, no more appointments scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, no more appointments scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, no appointment scheduled",
        then: Joi.required(),
      }),
    NextDate: Joi.string()
      .when("Type", {
        is: "No Show, next appointment is scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, next appointment scheduled",
        then: Joi.required(),
      }),
    Address: Joi.string().required(),
    Caregiver: Joi.string().required(),
    ClientFirst: Joi.string().required(),
    ClientLast: Joi.string().required(),
    ContactInfo: Joi.string().required(),
    Clinician: Joi.string().required(),
    General: Joi.string().when("Type", {
      is: "General Letter",
      then: Joi.required(),
    }),
  },
  "207786A6-5C51-ED11-ADE6-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    NameOfHome: Joi.string().required(),
    EvaluationDate: Joi.string().required(),
    SmokeDetectors: Joi.string().required(),
    FirearmsStored: Joi.string().required(),
    SafeRooms: Joi.string().required(),
    MedsStored: Joi.string().required(),
    ChemicalsStored: Joi.string().required(),
    BedsForAll: Joi.string().required(),
    FullyFurnished: Joi.string().required(),
    PhoneWorks: Joi.string().required(),
    Maintained: Joi.string().required(),
    Utilities: Joi.string().required(),
    CarSeatUsed: Joi.string().required(),
    SafetyComments: Joi.string().required(),
    FinancialChanges: Joi.string().required(),
    FinancialChangesDetails: Joi.string().when("FinancialChanges", {
      is: "Yes",
      then: Joi.required(),
    }),
    PoliceInvolvement: Joi.string().required(),
    PoliceInvolvementDetails: Joi.string().when("PoliceInvolvement", {
      is: "Yes",
      then: Joi.required(),
    }),
    FamilyChange: Joi.string().required(),
    FamilyChangeDetails: Joi.string().when("FamilyChange", {
      is: "Yes",
      then: Joi.required(),
    }),
    MedicalEmergencies: Joi.string().required(),
    MedicalEmergenciesDetails: Joi.string().when("MedicalEmergencies", {
      is: "Yes",
      then: Joi.required(),
    }),
    NewInvestigation: Joi.string().required(),
    NewInvestigationDetails: Joi.string().when("NewInvestigation", {
      is: "Yes",
      then: Joi.required(),
    }),
    PlanToMove: Joi.string().required(),
    PlanToMoveDetails: Joi.string().when("PlanToMove", {
      is: "Yes",
      then: Joi.required(),
    }),
    UtilitiesPaid: Joi.string().required(),
    UtilitiesPaidDetails: Joi.string().when("UtilitiesPaid", {
      is: "No",
      then: Joi.required(),
    }),
    Comments: Joi.string().allow(""),
    Clinician: Joi.string().required(),
  },
  "4BFFAC1F-EA5E-ED11-ADE6-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    SessionDate: Joi.string().required(),
    SessionTime: Joi.string().required(),
    SessionLength: Joi.string().required(),
    ContactType: Joi.string().required(),
    ContactTypeOtherDetails: Joi.string().when("ContactType", {
      is: "Other",
      then: Joi.required(),
    }),
    IndividualsPresent: Joi.string().required(),
    SessionLocation: Joi.string().required(),
    ExpectedInAttendance: Joi.string().required(),
    IndividualsNotPresent: Joi.string().when("ExpectedInAttendance", {
      is: "No",
      then: Joi.required(),
    }),
    Therapist: Joi.string().required(),
    Videotaped: Joi.string().required(),
    SessionNumber: Joi.string().when("Videotaped", {
      is: "Yes",
      then: Joi.required(),
    }),
    SeatingMap: Joi.string().when("Videotaped", {
      is: "Yes",
      then: Joi.required(),
    }),
    AdditionalNotes: Joi.string().when("Videotaped", {
      is: "Yes",
      then: Joi.required(),
    }),
    PresentingProblem: Joi.string().when("ContactType", {
      is: "Therapy Session",
      then: Joi.required(),
    }),
    NextSessionScheduled: Joi.string().when("ContactType", {
      is: "Therapy Session",
      then: Joi.required(),
    }),
    Diagnoses: Joi.string().when("ContactType", {
      is: "Therapy Session",
      then: Joi.required(),
    }),
    ProgressNotes: Joi.string().allow(""),
  },
  "BAA763F2-EA5E-ED11-ADE6-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    SessionDate: Joi.string().required(),
    SessionTime: Joi.string().required(),
    SessionLength: Joi.string().required(),
    ContactType: Joi.string().required(),
    ContactTypeOtherDetails: Joi.string().when("ContactType", {
      is: "Other",
      then: Joi.required(),
    }),
    IndividualsPresent: Joi.string().required(),
    SessionLocation: Joi.string().required(),
    ExpectedInAttendance: Joi.string().required(),
    IndividualsNotPresent: Joi.string().when("ExpectedInAttendance", {
      is: "No",
      then: Joi.required(),
    }),
    Therapist: Joi.string().required(),
    Videotaped: Joi.string().required(),
    SessionNumber: Joi.string().when("Videotaped", {
      is: "Yes",
      then: Joi.required(),
    }),
    SeatingMap: Joi.string().when("Videotaped", {
      is: "Yes",
      then: Joi.required(),
    }),
    AdditionalNotes: Joi.string().when("Videotaped", {
      is: "Yes",
      then: Joi.required(),
    }),
    PresentingProblem: Joi.string().when("ContactType", {
      is: "Therapy Session",
      then: Joi.required(),
    }),
    NextSessionScheduled: Joi.string().when("ContactType", {
      is: "Therapy Session",
      then: Joi.required(),
    }),
    NotScheduledDetails: Joi.string().when("NextSessionScheduled", {
      is: "No",
      then: Joi.required(),
    }),
    Diagnoses: Joi.string().when("ContactType", {
      is: "Therapy Session",
      then: Joi.required(),
    }),
    ProgressNotes: Joi.string().when("ContactType", {
      is: "Therapy Session",
      then: Joi.required(),
    }),
    ProgressNotesNA: Joi.boolean(),
    SessionDescription: Joi.string().when("ProgressNotesNA", {
      is: true,
      then: Joi.required(),
    }),
  },
  "2B904F03-FA64-ED11-ADE6-0050F21C653C": {
    SelectedProgram: Joi.string().required().label("Client Program"),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    StaffAbuse: Joi.string().required(),
    NonStaffAbuse: Joi.string().required(),
    VisitationPlan: Joi.string().required(),
    VisitationFrequency: Joi.string().when("VisitationPlan", {
      is: "Yes",
      then: Joi.required(),
    }),
    VisitationGoal: Joi.string().when("VisitationPlan", {
      is: "Yes",
      then: Joi.required(),
    }),
    Runaway: Joi.string().required(),
    UnplannedDischarge: Joi.string().required(),
    LengthOfStay: Joi.string().when("UnplannedDischarge", {
      is: "Yes",
      then: Joi.required(),
    }),
    DSSRequest: Joi.string().required(),
  },
  "C31FB96C-0266-ED11-ADE6-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    SAFYWorker: Joi.string().required(),
    ReferralSigned: Joi.string().allow(""),
    InitialCarePlan: Joi.string().allow(""),
    CircleOfSupport: Joi.string().allow(""),
    FosterHomeDrillReport: Joi.string().allow(""),
    GiveFosterParents: Joi.string().allow(""),
    UploadPicture: Joi.string().allow(""),
    SendFCMROI: Joi.string().allow(""),
    CompletePSD: Joi.string().allow(""),
    DevelopTreatmentPlan: Joi.string().allow(""),
    CompleteLifeSkills: Joi.string().allow(""),
    ILPlan: Joi.string().allow(""),
    PrimaryFamily: Joi.string().allow(""),
    IARCA: Joi.string().allow(""),
    SendIntakePacket: Joi.string().allow(""),
    Physical: Joi.string().allow(""),
    Dental: Joi.string().allow(""),
    Hearing: Joi.string().allow(""),
    Vision: Joi.string().allow(""),
    UpdateFCM: Joi.string().allow(""),
    MonthlyReport: Joi.string().allow(""),
    UpdatePrimaryFamily: Joi.string().allow(""),
    GetFromFPS: Joi.string().allow(""),
    UpdateCarePlan: Joi.string().allow(""),
    DentalScreening: Joi.string().allow(""),
    AnnualTasks: Joi.string().allow(""),
    PsychotropicAuthorization: Joi.string().allow(""),
    DCSTreatmentAuthorization: Joi.string().allow(""),
    IncidentReports: Joi.string().allow(""),
    RespiteProviderPack: Joi.string().allow(""),
    RecordsUpToDate: Joi.string().allow(""),
    GiveNotice: Joi.string().allow(""),
    CompleteDischargePlan: Joi.string().allow(""),
    IARCADischarge: Joi.string().allow(""),
    MedicalPassport: Joi.string().allow(""),
    DischargeLifeSkills: Joi.string().allow(""),
    DischargeCircleOfSupport: Joi.string().allow(""),
    GetDischargeFromFP: Joi.string().allow(""),
  },
  "9FEAB0FA-8B67-ED11-ADE6-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    ReportDate: Joi.string().required(),
    FamilyTherapy: Joi.boolean(),
    IndividualTherapy: Joi.boolean(),
    CPST: Joi.boolean(),
    CrisisIntervention: Joi.boolean(),
    GroupTherapy: Joi.boolean(),
    MedicationMonitoring: Joi.boolean(),
    PsychiatricServices: Joi.boolean(),
    CaseCoordination: Joi.boolean(),
    TherapeuticBehavioralServices: Joi.boolean(),
    OtherServices: Joi.boolean(),
    OtherServicesDetails: Joi.string().when("OtherServices", {
      is: true,
      then: Joi.required(),
    }),
    Progress: Joi.string().required(),
    GuardianEngagement: Joi.string().required(),
    YouthEngagement: Joi.string().required(),
    AdultEngagement: Joi.string().required(),
    NeedForServices: Joi.string().required(),
    OtherComments: Joi.string().allow(""),
    SafetyPlanStatus: Joi.string().required(),
    ROIStatus: Joi.string().required(),
    SignOff: Joi.string().required(),
  },
  "B83A6049-366F-ED11-ADE6-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Date: Joi.string().required(),
    Clinician: Joi.string().required(),
    Client: Joi.string().required(),
    Type: Joi.string().required(),
    LastDate: Joi.string()
      .when("Type", {
        is: "No Show, next appointment is scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "No Show, no more appointments scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, no more appointments scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, no appointment scheduled",
        then: Joi.required(),
      }),
    NextDate: Joi.string()
      .when("Type", {
        is: "No Show, next appointment is scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, next appointment scheduled",
        then: Joi.required(),
      }),
    Address: Joi.string().required(),
    ContactInfo: Joi.string().required(),
    General: Joi.string().when("Type", {
      is: "General Letter",
      then: Joi.required(),
    }),
  },
  "19B84A67-366F-ED11-ADE6-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Type: Joi.string().required(),
    Date: Joi.string().required(),
    LastDate: Joi.string()
      .when("Type", {
        is: "No Show, next appointment is scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "No Show, no more appointments scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, no more appointments scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, no appointment scheduled",
        then: Joi.required(),
      }),
    NextDate: Joi.string()
      .when("Type", {
        is: "No Show, next appointment is scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, next appointment scheduled",
        then: Joi.required(),
      }),
    Address: Joi.string().required(),
    Caregiver: Joi.string().required(),
    ClientFirst: Joi.string().required(),
    ClientLast: Joi.string().required(),
    ContactInfo: Joi.string().required(),
    Clinician: Joi.string().required(),
    General: Joi.string().when("Type", {
      is: "General Letter",
      then: Joi.required(),
    }),
  },
  "54CE2889-366F-ED11-ADE6-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Name: Joi.string().required(),
    DischargeDate: Joi.string().required(),
    SuccessfulClosure: Joi.string().required(),
    DischargeReason: Joi.string().when("SuccessfulClosure", {
      is: "No",
      then: Joi.required(),
    }),
    AreasOfGrowth: Joi.string().required(),
    Recommendations: Joi.string().required(),
    SignOff: Joi.string().required(),
  },
  "FDCCE0E6-2070-ED11-ADE6-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Type: Joi.string().required(),
    NCNSFeeStatus: Joi.string().required(),
    Date: Joi.string().required(),
    LastDate: Joi.string()
      .when("Type", {
        is: "No Show, next appointment is scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "No Show, no more appointments scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, no more appointments scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, no appointment scheduled",
        then: Joi.required(),
      }),
    NextDate: Joi.string()
      .when("Type", {
        is: "No Show, next appointment is scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, next appointment scheduled",
        then: Joi.required(),
      }),
    Address: Joi.string().required(),
    Caregiver: Joi.string().required(),
    ClientFirst: Joi.string().required(),
    ClientLast: Joi.string().required(),
    ContactInfo: Joi.string().required(),
    Clinician: Joi.string().required(),
    General: Joi.string().when("Type", {
      is: "General Letter",
      then: Joi.required(),
    }),
  },
  "C8CE61BE-3370-ED11-ADE6-0050F21C6F69": {
    SelectedProgram: Joi.string().required(),
    Type: Joi.string().required(),
    FPContactedForMeeting: Joi.boolean(),
    Date: Joi.string().required(),
    LastDate: Joi.string()
      .when("Type", {
        is: "No Show, next appointment is scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "No Show, no more appointments scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, no more appointments scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, no appointment scheduled",
        then: Joi.required(),
      }),
    NextDate: Joi.string()
      .when("Type", {
        is: "No Show, next appointment is scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Frequent Cancellations, next appointment scheduled",
        then: Joi.required(),
      })
      .when("Type", {
        is: "Hasn't been seen in 30+ days, next appointment scheduled",
        then: Joi.required(),
      }),
    Address: Joi.string().required(),
    Caregiver: Joi.string().required(),
    ClientFirst: Joi.string().required(),
    ClientLast: Joi.string().required(),
    ContactInfo: Joi.string().required(),
    Clinician: Joi.string().required(),
    General: Joi.string().when("Type", {
      is: "General Letter",
      then: Joi.required(),
    }),
  },
  "844D386D-6372-ED11-AC20-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    ClientName: Joi.string().required(),
    CarePlanDueDate: Joi.string().required(),
    PollLink: Joi.string().required(),
    ClinicianDetails: Joi.string().required(),
  },
  "88CE4349-6472-ED11-AC20-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    CareTeam: Joi.string().allow(""),
    Diagnoses: Joi.string().allow(""),
    PresentingProblem: Joi.string().allow(""),
    ContactPlan: Joi.string().allow(""),
    CulturalNarrative: Joi.string().allow(""),
    SafetyPlan: Joi.string().allow(""),
    PlanReviewed: Joi.string().allow(""),
    ContractType: Joi.string().allow(""),
    NextCarePlanDate: Joi.string().allow(""),
    BioVisits: Joi.string().allow(""),
    BioVisitsDetails: Joi.string().allow(""),
    Medications: Joi.string().allow(""),
    Psychiatrist: Joi.string().allow(""),
    PsychiatristName: Joi.string().allow(""),
    UpcomingAppts: Joi.string().allow(""),
    SchoolInfo: Joi.string().allow(""),
    Triggers: Joi.string().allow(""),
    DeescalateTechniques: Joi.string().allow(""),
    UnnoticedBehaviors: Joi.string().allow(""),
    FPPositives: Joi.string().allow(""),
    FPTechniques: Joi.string().allow(""),
  },
  "6B45306C-1477-ED11-AC20-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    AdultPhysicalAssault: Joi.boolean(),
    AdultSexualAssault: Joi.boolean(),
    AdultSexuallyAbused: Joi.boolean(),
    Arson: Joi.boolean(),
    Bullying: Joi.boolean(),
    Burglary: Joi.boolean(),
    ChildPhysicalAbuse: Joi.boolean(),
    ChildPornography: Joi.boolean(),
    ChildSexualAbuse: Joi.boolean(),
    DomesticViolence: Joi.boolean(),
    DUIIncident: Joi.boolean(),
    ElderAbuse: Joi.boolean(),
    HateCrime: Joi.boolean(),
    HateCrimeOther: Joi.boolean(),
    HateCrimeOtherDetails: Joi.string().when("HateCrimeOther", {
      is: true,
      then: Joi.required(),
    }),
    LaborTrafficking: Joi.boolean(),
    SexTrafficking: Joi.boolean(),
    IdentityTheft: Joi.boolean(),
    Kidnapping: Joi.boolean(),
    KidnappingCustodial: Joi.boolean(),
    MassViolence: Joi.boolean(),
    VehicularVictim: Joi.boolean(),
    Robbery: Joi.boolean(),
    Stalking: Joi.boolean(),
    HomicideSurvivor: Joi.boolean(),
    TeenDating: Joi.boolean(),
    Terrorism: Joi.boolean(),
    OtherVictim: Joi.boolean(),
    OtherVictimDetails: Joi.string().when("OtherVictim", {
      is: true,
      then: Joi.required(),
    }),
    MultipleTypes: Joi.boolean(),
    Deaf: Joi.boolean(),
    Homeless: Joi.boolean(),
    Immigrant: Joi.boolean(),
    LGBTQ: Joi.boolean(),
    Veteran: Joi.boolean(),
    Disabilities: Joi.boolean(),
    LimitedEnglish: Joi.boolean(),
    OtherClassification: Joi.boolean(),
    OtherClassificationDetails: Joi.string().when("OtherClassification", {
      is: true,
      then: Joi.required(),
    }),
  },
  "8D57CDBC-307B-ED11-AC20-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    DateCompleted: Joi.string().required(),
    ReasonForPlacement: Joi.string().required(),
    YouthStrengths: Joi.string().required(),
    PresentingIssues: Joi.string().required(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalBehaviors: Joi.boolean(),
    SelfHarm: Joi.boolean(),
    AWOL: Joi.boolean(),
    PropertyDestruction: Joi.boolean(),
    PhysicalAggression: Joi.boolean(),
    VerbalAggression: Joi.boolean(),
    SubstanceUse: Joi.boolean(),
    UnsafeSleep: Joi.boolean(),
    UnsafeActsAnimals: Joi.boolean(),
    UnsafeSexualBehaviors: Joi.boolean(),
    TraffickingVictim: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.string().when("OtherBehavior", {
      is: true,
      then: Joi.required(),
    }),
    Goal1: Joi.string().required(),
    Objectives1: Joi.string().required(),
    Actions1: Joi.string().required(),
    Outcomes1: Joi.string().required(),
    Goal2: Joi.string().required(),
    Objectives2: Joi.string().required(),
    Actions2: Joi.string().required(),
    Outcomes2: Joi.string().required(),
    Goal3: Joi.string().required(),
    Objectives3: Joi.string().required(),
    Actions3: Joi.string().required(),
    Outcomes3: Joi.string().required(),
    Strategies: Joi.string().required(),
    SupervisionNeeds: Joi.string().required(),
    DischargePlanning: Joi.string().required(),
  },
  "AD07FCE2-E87B-ED11-AC20-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    DischargeDate: Joi.string().required(),
    DischargedFrom: Joi.string().required(),
    DischargedTo: Joi.string().required(),
    DischargeOutcome: Joi.string().required(),
    DischargeReason: Joi.string()
      .when("DischargeOutcome", {
        is: "Higher level of care (hospitalized, residential treatment center, etc.)",
        then: Joi.required(),
      })
      .when("DischargeOutcome", {
        is: "Returned to custodial agency",
        then: Joi.required(),
      }),
    TWISTReason: Joi.string().required(),
  },
  "BE70589F-967C-ED11-AC20-0050F21C653C": {
    SelectedProgram: Joi.string().required().label("Client Program"),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    StaffAbuse: Joi.string().required(),
    NonStaffAbuse: Joi.string().required(),
    VisitationPlan: Joi.string().required(),
    VisitationFrequency: Joi.string().when("VisitationPlan", {
      is: "Yes",
      then: Joi.required(),
    }),
    VisitationGoal: Joi.string().when("VisitationPlan", {
      is: "Yes",
      then: Joi.required(),
    }),
    Runaway: Joi.string().required(),
    StableEducation: Joi.string().required(),
    FPAbility: Joi.string().required(),
    DecreasedNeeds: Joi.string().required(),
    UnplannedDischarge: Joi.string().required(),
    LengthOfStay: Joi.string().when("UnplannedDischarge", {
      is: "Yes",
      then: Joi.required(),
    }),
    DSSRequest: Joi.string().required(),
  },
  "2F3EB420-8C88-ED11-AC20-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    DateOfAssessment: Joi.string().required(),
    HasWished: Joi.string().required(),
    HasSuicidalThoughts: Joi.string().required(),
    HasPlans: Joi.string()
      .when("HasWished", { is: "Yes", then: Joi.required() })
      .when("HasSuicidalThoughts", { is: "Yes", then: Joi.required() }),
    HasIntent: Joi.string()
      .when("HasWished", { is: "Yes", then: Joi.required() })
      .when("HasSuicidalThoughts", { is: "Yes", then: Joi.required() }),
    HasDetails: Joi.string()
      .when("HasWished", { is: "Yes", then: Joi.required() })
      .when("HasSuicidalThoughts", { is: "Yes", then: Joi.required() }),
    InProgress: Joi.when("HasWished", {
      is: "No",
      then: Joi.when("HasSuicidalThoughts", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    RiskLevel: Joi.string().required(),
  },
  "2E895C6D-B596-ED11-BF7A-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Date: Joi.string().required(),
    Address: Joi.string().required(),
    InsuranceCompany: Joi.string().required(),
    CostOfService: Joi.string().required(),
    CostPerHour: Joi.string().required(),
    CostBreakdown: Joi.string().required(),
    CopayAmount: Joi.when("CostBreakdown", {
      is: "Co-Pay",
      then: Joi.string().required(),
    }),
    Percentage: Joi.when("CostBreakdown", {
      is: "Percentage",
      then: Joi.number().required().min(0).max(100),
    }),
    SignOff: Joi.string().required(),
    LetterType: Joi.string().required(),
    AdultName: Joi.string().required(),
    YouthName: Joi.string().when("LetterType", {
      is: "Youth",
      then: Joi.required(),
    }),
  },
  "1A9C25B9-6E97-ED11-BF7A-0050F21C653C": {
    RequestType: Joi.string().required(),
    RequestName: Joi.string().required(),
    ProgramEffectiveDate: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramName: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramDivisions: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramTeamMembers: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramType: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramBedRequirement: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramCarePlanning: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramCarePlanCustomized: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanWiley: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanConfigNarrative: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanProblemLabel: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanProblemReviewRequired: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanGoalLabel: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanGoalReviewRequired: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanGoalProgressRequired: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanObjectiveLabel: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanObjectiveReviewRequired: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanInterventionLabel: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanInterventionReviewRequired: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanInterventionProgressRequired: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequencyInitial: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequency30Day: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequency60Day: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequency90Day: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequency6Months: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequency180Days: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequency270Days: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequencyAnnual: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequencyUpdate: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequencyDischarge: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanMaximumReviewInterval: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramAssessments: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramReportingNeeds: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramPayor: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ModalityRequestType: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.string().required(),
    }).when("RequestType", { is: "Modality", then: Joi.string().required() }),
    ModalityNewDetails: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ModalityRequestType", {
        is: "Adding a new modality",
        then: Joi.string().required(),
      }),
    }).when("RequestType", {
      is: "Modality",
      then: Joi.when("ModalityRequestType", {
        is: "Adding a new modality",
        then: Joi.string().required(),
      }),
    }),
    ModalityNameToExpire: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ModalityRequestType", {
        is: "Expiring an existing modality",
        then: Joi.string().required(),
      }),
    }).when("RequestType", {
      is: "Modality",
      then: Joi.when("ModalityRequestType", {
        is: "Expiring an existing modality",
        then: Joi.string().required(),
      }),
    }),
    ModalityProgramsToExpire: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ModalityRequestType", {
        is: "Expiring an existing modality",
        then: Joi.string().required(),
      }),
    }).when("RequestType", {
      is: "Modality",
      then: Joi.when("ModalityRequestType", {
        is: "Expiring an existing modality",
        then: Joi.string().required(),
      }),
    }),
    ModalityExpirationDate: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ModalityRequestType", {
        is: "Expiring an existing modality",
        then: Joi.string().required(),
      }),
    }).when("RequestType", {
      is: "Modality",
      then: Joi.when("ModalityRequestType", {
        is: "Expiring an existing modality",
        then: Joi.string().required(),
      }),
    }),
    ServiceItemNeeded: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.string().required(),
    }),
    CurrentServiceItems: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ServiceItemNeeded", {
        is: "Using Current Service Item(s)",
        then: Joi.string().required(),
      }),
    }),
    ServiceItems: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ServiceItemNeeded", {
        is: "Adding Service Item(s)",
        then: Joi.string().required(),
      }),
    }).when("RequestType", { is: "Service", then: Joi.string().required() }),
    ProgressNoteTemplates: Joi.when("RequestType", {
      is: "Progress Note Templates",
      then: Joi.string().required(),
    }).when("RequestType", { is: "Service", then: Joi.string().required() }),
    EnhancementRequest: Joi.string().when("RequestType", {
      is: "System Enhancement",
      then: Joi.required(),
    }),
  },
  "C30465D5-CB9D-ED11-BF7A-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    FamilyName: Joi.string().label("Family Name").required(),
    SafetyPlanDate: Joi.string().label("Date of Safety Plan").required(),
    Housing: Joi.boolean(),
    HousingDetails: Joi.string().allow(""),
    Food: Joi.boolean(),
    FoodDetails: Joi.string().allow(""),
    Clothing: Joi.boolean(),
    ClothingDetails: Joi.string().allow(""),
    Transportation: Joi.boolean(),
    TransportationDetails: Joi.string().allow(""),
    MedicalCare: Joi.boolean(),
    MedicalCareDetails: Joi.string().allow(""),
    Childcare: Joi.boolean(),
    ChildcareDetails: Joi.string().allow(""),
    Supervision: Joi.boolean(),
    SupervisionDetails: Joi.string().allow(""),
    DomesticViolence: Joi.boolean(),
    DomesticViolenceDetails: Joi.string().allow(""),
    FamilyConflict: Joi.boolean(),
    FamilyConflictDetails: Joi.string().allow(""),
    SubstanceAbuse: Joi.boolean(),
    SubstanceAbuseDetails: Joi.string().allow(""),
    Deescalation: Joi.boolean(),
    DeescalationDetails: Joi.string().allow(""),
    InfantSafety: Joi.boolean(),
    InfantSafetyDetails: Joi.string().allow(""),
    OtherConcerns: Joi.boolean(),
    OtherConcernsDetails: Joi.string().allow(""),
    FamilyStrengths: Joi.string()
      .label("What are the family's strengths? What is working right now?")
      .required(),
    PerspectiveOfRisk: Joi.string()
      .label("Caregiver/Family Perspective of Risk")
      .required(),
    SafetyNeeds: Joi.string()
      .label(
        "What needs to be in place to ensure the safety and wellbeing of everyone in the family?"
      )
      .required(),
    EnvironmentSteps: Joi.string()
      .label("What are steps the family can take to keep the environment safe?")
      .required(),
    MonitoringSteps: Joi.string()
      .label(
        "What are steps the family can take to have adequate monitoring/supervision?"
      )
      .required(),
    SupportForFamily: Joi.string()
      .label("Who can support the family in meeting their immediate needs?")
      .required(),
    PositiveInteractions: Joi.string()
      .label(
        "How can the family create positive interactions despite their immediate needs/crisis?"
      )
      .required(),
    AssessmentAndSteps: Joi.string()
      .label("Overall Assessment of Family Safety and Immediate Next Steps")
      .required(),
    AdditionalComments: Joi.string().label("Additional Comments"),
    Hotline: Joi.string().label("Hotline"),
    Hospital: Joi.string().label("Hospital/ED"),
    CrisisCenter: Joi.string().label("Crisis Center"),
    OtherEmergency: Joi.string().label("SAFY Crisis Line"),
    SAFYCrisisLine: Joi.string().label("Other"),
  },
  "EC5D0CEC-4E9E-ED11-BF7A-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SafetyPlanDate: Joi.string().required(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    SelfHarm: Joi.boolean(),
    AWOL: Joi.boolean(),
    PropertyDestruction: Joi.boolean(),
    PhysicalAggression: Joi.boolean(),
    VerbalAggression: Joi.boolean(),
    SubstanceUse: Joi.boolean(),
    UnsafeSleepBehaviors: Joi.boolean(),
    UnsafeActsTowardsAnimals: Joi.boolean(),
    UnsafeSchoolBehaviors: Joi.boolean(),
    UnsafeSexualBehaviors: Joi.boolean(),
    HumanTraffickingVictim: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.string().allow(""),
    TriggerDetails: Joi.string().allow(""),
    BehaviorDetails: Joi.string().allow(""),
    ReasonsToLive: Joi.string().allow(""),
    FeelingToday: Joi.string().allow(""),
    FeelingAtWorst: Joi.string().allow(""),
    WorryPoint: Joi.string().allow(""),
    CheckInFrequency: Joi.string().allow(""),
    ScalingQuestion: Joi.string().allow(""),
    Sweating: Joi.boolean(),
    BreathingHard: Joi.boolean(),
    RacingHeart: Joi.boolean(),
    ClenchingTeeth: Joi.boolean(),
    ClenchingFists: Joi.boolean(),
    RedFaced: Joi.boolean(),
    LoudVoice: Joi.boolean(),
    Rocking: Joi.boolean(),
    Fidgety: Joi.boolean(),
    Crying: Joi.boolean(),
    SleepingAlot: Joi.boolean(),
    DifficultySleeping: Joi.boolean(),
    Pacing: Joi.boolean(),
    Nauseous: Joi.boolean(),
    Alone: Joi.boolean(),
    RacingThoughts: Joi.boolean(),
    FallAsleep: Joi.boolean(),
    OtherSign: Joi.boolean(),
    OtherSignDetails: Joi.string().allow(""),
    Yelling: Joi.boolean(),
    ReadingHome: Joi.boolean(),
    ExerciseHome: Joi.boolean(),
    WritingHome: Joi.boolean(),
    DrawingHome: Joi.boolean(),
    Watching: Joi.boolean(),
    SupportHome: Joi.boolean(),
    Playing: Joi.boolean(),
    Shower: Joi.boolean(),
    MusicHome: Joi.boolean(),
    WalkingHome: Joi.boolean(),
    BlanketHome: Joi.boolean(),
    AnimalsHome: Joi.boolean(),
    OtherHomeStrategy: Joi.boolean(),
    OtherHomeStrategyDetails: Joi.string().allow(""),
    ReadingSchool: Joi.boolean(),
    ExerciseSchool: Joi.boolean(),
    WritingSchool: Joi.boolean(),
    DrawingSchool: Joi.boolean(),
    SupportSchool: Joi.boolean(),
    SupportTeacher: Joi.boolean(),
    MusicSchool: Joi.boolean(),
    WalkingSchool: Joi.boolean(),
    BlanketSchool: Joi.boolean(),
    AnimalsSchool: Joi.boolean(),
    OtherSchoolStrategy: Joi.boolean(),
    OtherSchoolStrategyDetails: Joi.string().allow(""),
    MySupportsHome: Joi.string().allow(""),
    MySupportsSchool: Joi.string().allow(""),
    SafetyPlan: Joi.string().allow(""),
    TriggersAndWarnings: Joi.string().allow(""),
    TriggersAndWarningsResponse: Joi.string().allow(""),
    Visible: Joi.boolean(),
    SameRoom: Joi.boolean(),
    RestrictedOutings: Joi.boolean(),
    RoomSearch: Joi.boolean(),
    ReviewPhone: Joi.boolean(),
    Cameras: Joi.boolean(),
    RemoveDoors: Joi.boolean(),
    CheckingIn: Joi.boolean(),
    TrackFriendInfo: Joi.boolean(),
    PlanActivities: Joi.boolean(),
    OtherMonitoring: Joi.boolean(),
    OtherMonitoringDetails: Joi.string().allow(""),
    LockupWeapons: Joi.boolean(),
    LockupMeds: Joi.boolean(),
    LockupSharps: Joi.boolean(),
    LockupPoisons: Joi.boolean(),
    DoorWindowAlarms: Joi.boolean(),
    RestrictAlcohol: Joi.boolean(),
    ParkOutside: Joi.boolean(),
    LockupFireStarters: Joi.boolean(),
    KeepKeys: Joi.boolean(),
    OtherSafeStep: Joi.boolean(),
    OtherSafeStepDetails: Joi.string().allow(""),
    SupportChild: Joi.string().allow(""),
    SupportSelf: Joi.string().allow(""),
    AdditionalComments: Joi.string().allow(""),
    Hotline: Joi.string().allow(""),
    Hospital: Joi.string().allow(""),
    CrisisCenter: Joi.string().allow(""),
    Other: Joi.string().allow(""),
    SAFYCrisisCenter: Joi.string().allow(""),
  },
  "0B9C20FB-4E9E-ED11-BF7A-0050F21C653C": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    SafetyPlanDate: Joi.string().required(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeations: Joi.boolean(),
    SelfHarm: Joi.boolean(),
    AWOL: Joi.boolean(),
    PropertyDestruction: Joi.boolean(),
    PhysicalAggression: Joi.boolean(),
    VerbalAggression: Joi.boolean(),
    SubstanceUse: Joi.boolean(),
    UnsafeSleepBehaviors: Joi.boolean(),
    UnsafeActsTowardsAnimals: Joi.boolean(),
    UnsafeSexualBehaviors: Joi.boolean(),
    HumanTraffickingVictim: Joi.boolean(),
    OtherBehaviors: Joi.boolean(),
    OtherBehaviorsDetails: Joi.string().when("OtherBehaviors", {
      is: true,
      then: Joi.required(),
    }),
    TriggerDetails: Joi.string().when("SubstanceUse", {
      is: true,
      then: Joi.required(),
    }),
    UnsafeActsDetails: Joi.string()
      .when("UnsafeSleepBehaviors", { is: true, then: Joi.required() })
      .when("UnsafeActsTowardsAnimals", { is: true, then: Joi.required() })
      .when("UnsafeSexualBehaviors", { is: true, then: Joi.required() }),
    ReasonsForLiving: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    FeelingToday: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    FeelingAtWorst: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    FeelingWorryPoint: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    CheckInFrequency: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    ScalingQuestion: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    Sweating: Joi.boolean(),
    BreathingHard: Joi.boolean(),
    RacingHeart: Joi.boolean(),
    ClenchingTeeth: Joi.boolean(),
    ClenchingFists: Joi.boolean(),
    RedFaced: Joi.boolean(),
    LoudVoice: Joi.boolean(),
    Rocking: Joi.boolean(),
    Fidgety: Joi.boolean(),
    Crying: Joi.boolean(),
    SleepingAlot: Joi.boolean(),
    DifficultySleeping: Joi.boolean(),
    Pacing: Joi.boolean(),
    Nauseous: Joi.boolean(),
    Alone: Joi.boolean(),
    RacingThoughts: Joi.boolean(),
    FallAsleep: Joi.boolean(),
    OtherSign: Joi.boolean(),
    OtherSignDetails: Joi.string().when("OtherSign", {
      is: true,
      then: Joi.required(),
    }),
    Yelling: Joi.boolean(),
    Reading: Joi.boolean(),
    Exercise: Joi.boolean(),
    Writing: Joi.boolean(),
    Drawing: Joi.boolean(),
    Watching: Joi.boolean(),
    Support: Joi.boolean(),
    Playing: Joi.boolean(),
    Shower: Joi.boolean(),
    Music: Joi.boolean(),
    Walking: Joi.boolean(),
    Blanket: Joi.boolean(),
    Animals: Joi.boolean(),
    OtherStrategy: Joi.boolean(),
    OtherStrategyDetails: Joi.string().when("OtherStrategy", {
      is: true,
      then: Joi.required(),
    }),
    MySupports: Joi.string().required(),
    SafetyPlan: Joi.string().required(),
    RestrictWeapons: Joi.boolean(),
    RestrictMedications: Joi.boolean(),
    RestrictSharps: Joi.boolean(),
    RestrictPoisons: Joi.boolean(),
    RestrictAlcohol: Joi.boolean(),
    RestrictLighters: Joi.boolean(),
    AlternativeTransportation: Joi.boolean(),
    OtherSteps: Joi.boolean(),
    OtherStepsDetails: Joi.string().when("OtherSteps", {
      is: true,
      then: Joi.required(),
    }),
    AdditionalSteps: Joi.string().allow(""),
    AdditionalComments: Joi.string().allow(""),
    Hotline: Joi.string().required(),
    Hospital: Joi.string().required(),
    CrisisCenter: Joi.string().required(),
    OtherEmergency: Joi.string().allow(""),
    SAFYCrisisLine: Joi.string().required(),
  },
  "8A4CD093-8F9E-ED11-BF7A-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    CurrentHome: Joi.string().required(),
    CurrentMedications: Joi.string().required(),
    MedicaidNumber: Joi.string().required(),
    Height: Joi.string().required(),
    Weight: Joi.string().required(),
    EyeColor: Joi.string().required(),
    HairColor: Joi.string().required(),
    IdentifyingMarks: Joi.string().required(),
    WorkerName: Joi.string().required(),
    Phone: Joi.string().required(),
    AfterHoursPhone: Joi.string().required(),
    AfterHoursPhoneDetails: Joi.string().when("AfterHoursPhone", {
      is: "Other",
      then: Joi.required(),
    }),
    ReferringAgency: Joi.string().required(),
    ReferringPhone: Joi.string().required(),
    ReferringAfterHoursPhone: Joi.string().required(),
    MedicalInfo: Joi.string().required(),
    AdditionalInfo: Joi.string().required(),
  },
  "B34E6A6B-C4A0-ED11-BF7A-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Provider: Joi.string().required(),
    County: Joi.string().required(),
    Dates: Joi.string().required(),
    CurrentTier: Joi.string().required(),
    ChildIQ: Joi.string().required(),
    DatePlacedTFC: Joi.string().required(),
    DatePlacedCurrent: Joi.string().required(),
    DateLastISP: Joi.string().required(),
    PermanencyPlan: Joi.string().required(),
    ConcurrentPlan: Joi.string().required(),
    MedicaidWaiverStatus: Joi.string().required(),
    ReceiveSSI: Joi.string().required(),
    ReceiveSSIDetails: Joi.string().when("ReceiveSSI", {
      is: "Yes",
      then: Joi.required(),
    }),
    Diagnoses: Joi.string().required(),
    MedicalDiagnoses: Joi.string().required(),
    Goals: Joi.string().required(),
    Progress: Joi.string().required(),
    Barriers: Joi.string().required(),
    ADLNA: Joi.boolean(),
    Hygiene: Joi.string()
      .label("Personal Hygiene achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HygieneNeeded: Joi.string()
      .label("Personal Hygiene needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Housekeeping: Joi.string()
      .label("Housekeeping achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HousekeepingNeeded: Joi.string()
      .label("Housekeeping needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MedicationManagement: Joi.string()
      .label("Medication Management achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MedicationManagementNeeded: Joi.string()
      .label("Medication Management needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Transportation: Joi.string()
      .label("Transportation achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    TransportationNeeded: Joi.string()
      .label("Transportation needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    BehaviorEducation: Joi.string()
      .label("Behavior Education achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    BehaviorEducationNeeded: Joi.string()
      .label("Behavior Education needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    StressManagement: Joi.string()
      .label("Stress Management achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    StressManagementNeeded: Joi.string()
      .label("Stress Management needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HealthyLifestyle: Joi.string()
      .label("Healthy Lifestyle achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HealthyLifestyleNeeded: Joi.string()
      .label("Healthy Lifestyle needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Laundry: Joi.string()
      .label("Laundry achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    LaundryNeeded: Joi.string()
      .label("Laundry needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MealPrep: Joi.string()
      .label("Meal Prep achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MealPrepNeeded: Joi.string()
      .label("Meal Prep needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MoneyManagement: Joi.string()
      .label("Money Management achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MoneyManagementNeeded: Joi.string()
      .label("Money Management needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Shopping: Joi.string()
      .label("Shopping achieved")
      .when("ADLNA", { is: false, then: Joi.required() }),
    ShoppingNeeded: Joi.string()
      .label("Shopping needed")
      .when("ADLNA", { is: false, then: Joi.required() }),
    BasicSkillsComments: Joi.string()
      .label("Basic Living Skills comments")
      .when("ADLNA", { is: false, then: Joi.required() }),
    RelationshipsNA: Joi.boolean(),
    CoopSkills: Joi.string()
      .label("Cooperative Play Skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    CoopSkillsDetails: Joi.string()
      .label("Cooperative Play Skills details")
      .when("CoopSkills", { is: "Problematic", then: Joi.required() }),
    CommunicationSkills: Joi.string()
      .label("Communication Skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    CommunicationSkillsDetails: Joi.string()
      .label("Communication Skills details")
      .when("CommunicationSkills", { is: "Problematic", then: Joi.required() }),
    EmotionalUnderstanding: Joi.string()
      .label("Emotional Understanding")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    EmotionalUnderstandingDetails: Joi.string()
      .label("Emotional Understanding Skills details")
      .when("EmotionalUnderstanding", {
        is: "Problematic",
        then: Joi.required(),
      }),
    ProblemSolving: Joi.string()
      .label("Problem Solving")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    ProblemSolvingDetails: Joi.string()
      .label("Problem Solving Skills details")
      .when("ProblemSolving", { is: "Problematic", then: Joi.required() }),
    ConflictResolution: Joi.string()
      .label("Conflict Resolution")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    ConflictResolutionDetails: Joi.string()
      .label("Conflict Resolution Skills details")
      .when("ConflictResolution", { is: "Problematic", then: Joi.required() }),
    DecisionMakingSkills: Joi.string()
      .label("Decision Making")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    DecisionMakingSkillsDetails: Joi.string()
      .label("Decision Making Skills details")
      .when("DecisionMakingSkills", {
        is: "Problematic",
        then: Joi.required(),
      }),
    CostPlan: Joi.string().required(),
    NextSteps: Joi.string().required(),
  },
  "95D9771B-00A4-ED11-BF7A-0050F21C653C": {
    SelectedProgram: Joi.string().label("Client Program").required(),
    DateCompleted: Joi.string().required().label("Date Completed"),
    PSDType: Joi.string().label("Type of PSD").required(),
    ReviewReason: Joi.string()
      .label("Reason")
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ReferralMembers: Joi.string()
      .label("Family Members on Referral")
      .required(),
    CaseMember: Joi.string()
      .label("Family Member listed under Case ID")
      .required(),
    MaGIKCaseID: Joi.string().label("MaGIK Case ID").required(),
    Caseworker: Joi.string().label("Caseworker").required(),
    Division: Joi.string().label("SAFY Division").required(),
    County: Joi.string().label("County").required(),
    CountyDetails: Joi.string()
      .label("County")
      .when("County", { is: "Other", then: Joi.required() }),
    ISFamily: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISDCS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.string()
      .label("Other Information Source details")
      .when("ISOther", { is: true, then: Joi.required() }),
    ReferralReason: Joi.string().label("Reason for Referral").required(),
    PresentingProblem: Joi.string()
      .label("Description of the Problem(s)")
      .required(),
    ProtectiveFactors: Joi.string().label("Protective Factors").required(),
    CurrentHousehold: Joi.string().label("Current Household").required(),
    OtherFamilySupports: Joi.string().label("Other Family Supports").required(),
    CaregiverCooperation: Joi.string()
      .label("Cooperation between caregivers")
      .required(),
    CaregiverCooperationDetails: Joi.string()
      .label("Cooperation between caregivers details")
      .when("CaregiverCooperation", { is: "No", then: Joi.required() }),
    SupervisionDifficulties: Joi.string()
      .label("Difficulties with the supervision")
      .required(),
    SupervisionDifficultiesDetails: Joi.string()
      .label("Difficulties with the supervision details")
      .when("SupervisionDifficulties", { is: "Yes", then: Joi.required() }),
    DisciplinePractices: Joi.string().label("Discipline practices").required(),
    Interaction: Joi.string()
      .label("Interaction between caregivers and child(ren)")
      .required(),
    FamilyHistoryUnknown: Joi.boolean(),
    FamilyHistoryDetails: Joi.string()
      .label("Extended Family History")
      .when("FamilyHistoryUnknown", { is: "false", then: Joi.required() }),
    CulturalGroup: Joi.string().label("Identified cultural group").required(),
    TraditionsComments: Joi.string()
      .label("Special cultural traditions/celebrations/rituals")
      .required(),
    LanguagesSpoken: Joi.string().label("Languages spoken").required(),
    Religion: Joi.string()
      .label("Identified religion/belief system")
      .required(),
    ReligionRole: Joi.string()
      .label("Role of faith in client's life")
      .required(),
    GenderOrientation: Joi.string()
      .label("Gender identity & sexual orientation")
      .required(),
    PCP: Joi.string().label("Primary Care Physician").required(),
    LastMedicalExamDates: Joi.string()
      .label("Date(s) of last medical exam for child(ren)")
      .required(),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.string()
      .label("Allergies details")
      .when("Allergies", { is: true, then: Joi.required() }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.string()
      .label("Medical Conditions Details")
      .when("MedicalConditions", { is: true, then: Joi.required() }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.string()
      .label("Nutritional Concerns Details")
      .when("NutritionalConcerns", { is: true, then: Joi.required() }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.string()
      .label("Dental Concerns Details")
      .when("DentalConcerns", { is: true, then: Joi.required() }),
    SleepConcerns: Joi.boolean(),
    SleepConcernsDetails: Joi.string()
      .label("Sleep Concerns Details")
      .when("SleepConcerns", { is: true, then: Joi.required() }),
    Hospitalizations: Joi.boolean(),
    HospitalizationsDetails: Joi.string()
      .label("Hospitalization Details")
      .when("Hospitalizations", { is: true, then: Joi.required() }),
    HeadInjury: Joi.boolean(),
    HeadInjuryDetails: Joi.string()
      .label("Head Injury Details")
      .when("HeadInjury", { is: true, then: Joi.required() }),
    Undiagnosed: Joi.string().label("Undiagnosed illness symptoms").required(),
    UndiagnosedComments: Joi.string()
      .label("Undiagnosed illness symptom details")
      .when("Undiagnosed", { is: "Yes", then: Joi.required() }),
    PregnancyHistory: Joi.string().label("Pregnancy History").required(),
    MilestonesMet: Joi.string()
      .label("Developmental milestones met on time")
      .required(),
    MilestonesMetDetails: Joi.string()
      .label("Milestone details")
      .when("MilestonesMet", { is: "No", then: Joi.required() }),
    SpecialNeeds: Joi.string()
      .label("Developmental delays or special needs")
      .required(),
    SpecialNeedsDetails: Joi.string()
      .label("Special needs details")
      .when("SpecialNeeds", { is: "Yes", then: Joi.required() }),
    SpecializedServices: Joi.string().label("Specialized Services").required(),
    SpecializedServicesDetails: Joi.string()
      .label("Specialized Services details")
      .when("SpecializedServices", { is: "Yes", then: Joi.required() }),
    HasMedications: Joi.string().required(),
    CurrentMedicationDetails: Joi.string()
      .label("Current Medications")
      .when("HasMedications", { is: "Yes", then: Joi.required() }),
    HadMedications: Joi.string().required(),
    PsychotropicMedications: Joi.string()
      .label("Past Psychotropic Medications")
      .when("HadMedications", { is: "Yes", then: Joi.required() }),
    SexualHistoryDetails: Joi.string().required(),
    HasMentalHealthTreatment: Joi.string().required(),
    MentalHealthTreatment: Joi.string()
      .label("Mental Health Treatment")
      .when("HasMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    NoSelfHarm: Joi.boolean(),
    SelfHarmDetails: Joi.string().label("Self Harm Details").required(),
    AllSelfHarmScreened: Joi.string()
      .label("All family members screened")
      .required(),
    NotAllSelfHarmScreenedDetails: Joi.string()
      .label("Not all family members screened details")
      .when("AllSelfHarmScreened", { is: "No", then: Joi.required() }),
    SelfHarmComments: Joi.string()
      .label("Comments/Action Taken")
      .when("NoSelfHarm", { is: false, then: Joi.required() }),
    NoHarmingOthers: Joi.boolean(),
    HarmingOthersDetails: Joi.string()
      .label("Harm to Others/Endangerment details")
      .required(),
    AllHarmOthersScreened: Joi.string()
      .label("All family members screened")
      .required(),
    NotAllHarmOthersScreenedDetails: Joi.string()
      .label("Not all family members screened details")
      .when("AllHarmOthersScreened", { is: "No", then: Joi.required() }),
    HarmingOthersComments: Joi.string()
      .label("Comments/Action Taken")
      .when("NoHarmingOthers", { is: false, then: Joi.required() }),
    EducationDetails: Joi.string().label("Education details").required(),
    NoneEmployed: Joi.boolean(),
    EmploymentDetails: Joi.string().label("Employment details").required(),
    MilitaryHistory: Joi.string()
      .label("Family members' military history")
      .required(),
    MilitaryHistoryDetails: Joi.string()
      .label("Military history details")
      .when("MilitaryHistory", { is: "Yes", then: Joi.required() }),
    NoSubstanceUse: Joi.boolean(),
    SubstanceUseHistory: Joi.string()
      .label("Substance Use history")
      .when("NoSubstanceUse", { is: false, then: Joi.required() }),
    HasSubstanceUseTreatment: Joi.string().required(),
    SUTreatmentHistory: Joi.string()
      .label("Substance Use Treatment history")
      .when("HasSubstanceUseTreatment", { is: "Yes", then: Joi.required() }),
    TraumaHistory: Joi.string().label("Trauma history").required(),
    FamilyChanges: Joi.string()
      .label("Changes/transitions in family")
      .required(),
    FamilyChangesDetails: Joi.string()
      .label("Changes/transitions in family description")
      .when("FamilyChanges", { is: "Yes", then: Joi.required() }),
    RecentGrief: Joi.string()
      .label("Recent or significant deaths/grief issues")
      .required(),
    RecentGriefDetails: Joi.string()
      .label("Recent or significant deaths/grief issues details")
      .when("RecentGrief", { is: "Yes", then: Joi.required() }),
    MentalStatusNA: Joi.boolean(),
    MentalStatusDetails: Joi.string()
      .label("Mental Status")
      .when("MentalStatusNA", { is: false, then: Joi.required() }),
    SymptomsNA: Joi.boolean(),
    Symptoms: Joi.string()
      .label("Symptoms")
      .when("SymptomsNA", { is: false, then: Joi.required() }),
    SymptomsNAComments: Joi.string()
      .label("Comments")
      .when("SymptomsNA", { is: true, then: Joi.required() }),
    Hygiene: Joi.string().label("Personal appearance and hygiene").required(),
    HygieneFamilyMembers: Joi.string()
      .label("Personal appearance and hygiene Family Members")
      .when("Hygiene", { is: "Yes", then: Joi.required() }),
    HygieneDetails: Joi.string()
      .label("Personal appearance and hygiene Details")
      .when("Hygiene", { is: "Yes", then: Joi.required() }),
    MoneyManagement: Joi.string().label("Money management").required(),
    MoneyManagementFamilyMembers: Joi.string()
      .label("Money management Family Members")
      .when("MoneyManagement", { is: "Yes", then: Joi.required() }),
    MoneyManagementDetails: Joi.string()
      .label("Money management Details")
      .when("MoneyManagement", { is: "Yes", then: Joi.required() }),
    FoodManagement: Joi.string().label("Food management").required(),
    FoodManagementFamilyMembers: Joi.string()
      .label("Food management Family Members")
      .when("FoodManagement", { is: "Yes", then: Joi.required() }),
    FoodManagementDetails: Joi.string()
      .label("Food management Details")
      .when("FoodManagement", { is: "Yes", then: Joi.required() }),
    Health: Joi.string().label("Health").required(),
    HealthFamilyMembers: Joi.string()
      .label("Health Family Members")
      .when("Health", { is: "Yes", then: Joi.required() }),
    HealthDetails: Joi.string()
      .label("Health Details")
      .when("Health", { is: "Yes", then: Joi.required() }),
    Housekeeping: Joi.string().label("Housekeeping").required(),
    HousekeepingFamilyMembers: Joi.string()
      .label("Housekeeping Family Members")
      .when("Housekeeping", { is: "Yes", then: Joi.required() }),
    HousekeepingDetails: Joi.string()
      .label("Housekeeping Details")
      .when("Housekeeping", { is: "Yes", then: Joi.required() }),
    Transportation: Joi.string().label("Transportation").required(),
    TransportationFamilyMembers: Joi.string()
      .label("Transportation Family Members")
      .when("Transportation", { is: "Yes", then: Joi.required() }),
    TransportationDetails: Joi.string()
      .label("Transportation Details")
      .when("Transportation", { is: "Yes", then: Joi.required() }),
    SafetySkills: Joi.string().label("Safety Skills").required(),
    SafetySkillsFamilyMembers: Joi.string()
      .label("Safety Skills Family Members")
      .when("SafetySkills", { is: "Yes", then: Joi.required() }),
    SafetySkillsDetails: Joi.string()
      .label("Safety Skills Details")
      .when("SafetySkills", { is: "Yes", then: Joi.required() }),
    ResourceKnowledge: Joi.string().label("ResourceKnowledge").required(),
    ResourceKnowledgeFamilyMembers: Joi.string()
      .label("Resource Knowledge Family Members")
      .when("ResourceKnowledge", { is: "Yes", then: Joi.required() }),
    ResourceKnowledgeDetails: Joi.string()
      .label("Resource Knowledge Details")
      .when("ResourceKnowledge", { is: "Yes", then: Joi.required() }),
    TimeManagement: Joi.string().label("Time Management").required(),
    TimeManagementFamilyMembers: Joi.string()
      .label("Time Management Family Members")
      .when("TimeManagement", { is: "Yes", then: Joi.required() }),
    TimeManagementDetails: Joi.string()
      .label("Time Management Details")
      .when("TimeManagement", { is: "Yes", then: Joi.required() }),
    InteractionWithOthers: Joi.string().label("Interaction").required(),
    InteractionFamilyMembers: Joi.string()
      .label("Interaction Family Members")
      .when("InteractionWithOthers", { is: "Yes", then: Joi.required() }),
    InteractionDetails: Joi.string()
      .label("Interaction Details")
      .when("InteractionWithOthers", { is: "Yes", then: Joi.required() }),
    PsychosocialFunctioning: Joi.string()
      .label("Psychosocial Functioning")
      .required(),
    LegalInvolvement: Joi.string().label("Legal Involvement").required(),
    LegalInvolvementDetails: Joi.string()
      .label("Legal History")
      .when("LegalInvolvement", { is: "Yes", then: Joi.required() }),
    CPSInvolvement: Joi.string().label("CPS Involvement").required(),
    CPSInvolvementDetails: Joi.string()
      .label("CPS History")
      .when("CPSInvolvement", { is: "Yes", then: Joi.required() }),
    PFS2CompletionStatus: Joi.string()
      .label("PFS-2 completion status")
      .required(),
    Resilience: Joi.string()
      .label("Family Functioning/Resilience")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    Attachment: Joi.string()
      .label("Nurturing and Attachment")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    SocialSupports: Joi.string()
      .label("Social Supports")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    PractitionerRelationship: Joi.string()
      .label("Caregiver/Practitioner Relationship")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    ConcreteSupports: Joi.string()
      .label("Concrete Supports")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    OtherTools: Joi.string().label("Other tools used").required(),
    OtherToolsDetails: Joi.string()
      .label("Other tool details")
      .when("OtherTools", { is: "Yes", then: Joi.required() }),
    Interpretation: Joi.string()
      .label("Interpretation of Scores")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() })
      .when("OtherTools", { is: "Yes", then: Joi.required() }),
    ClinicalSummary: Joi.string()
      .label("Clinical Observations/Family Clinical Summary")
      .required(),
    RiskFactors: Joi.string()
      .label("Areas of Concern/Risk Factors/Potential Barriers")
      .required(),
    ConcreteNeeds: Joi.string().label("Concrete Needs").required(),
    DischargePlan: Joi.string()
      .label("Family's Perspective/Plan for Discharge")
      .required(),
    DiagnosisDetails: Joi.string().label("Diagnosis Details").required(),
    TreatmentRecommendations: Joi.string()
      .label("Treatment Recommendations")
      .required(),
    AdditionalPsychiatric: Joi.boolean(),
    AdditionalPsychological: Joi.boolean(),
    AdditionalNeurological: Joi.boolean(),
    AdditionalEducational: Joi.boolean(),
    AdditionalMedical: Joi.boolean(),
    AdditionalDental: Joi.boolean(),
    AdditionalSubstanceAbuse: Joi.boolean(),
    AdditionalVocational: Joi.boolean(),
    AdditionalOccupational: Joi.boolean(),
    AdditionalNutritional: Joi.boolean(),
    AdditionalVisualAuditory: Joi.boolean(),
    AdditionalDomesticViolence: Joi.boolean(),
    AdditionalSexOffender: Joi.boolean(),
    AdditionalOther: Joi.boolean(),
    AdditionalOtherDetails: Joi.string()
      .label("Other Evaluations Needed details")
      .when("AdditionalOther", { is: true, then: Joi.required() }),
    MembersInNeed: Joi.string()
      .label("Family Member(s) in need of evaluation")
      .when("AdditionalPsychiatric", { is: true, then: Joi.required() })
      .when("AdditionalPsychological", { is: true, then: Joi.required() })
      .when("AdditionalNeurological", { is: true, then: Joi.required() })
      .when("AdditionalEducational", { is: true, then: Joi.required() })
      .when("AdditionalMedical", { is: true, then: Joi.required() })
      .when("AdditionalDental", { is: true, then: Joi.required() })
      .when("AdditionalSubstanceAbuse", { is: true, then: Joi.required() })
      .when("AdditionalVocational", { is: true, then: Joi.required() })
      .when("AdditionalOccupational", { is: true, then: Joi.required() })
      .when("AdditionalNutritional", { is: true, then: Joi.required() })
      .when("AdditionalVisualAuditory", { is: true, then: Joi.required() })
      .when("AdditionalDomesticViolence", { is: true, then: Joi.required() })
      .when("AdditionalSexOffender", { is: true, then: Joi.required() })
      .when("AdditionalOther", { is: true, then: Joi.required() }),
  },
  "9FD89BEA-21A7-ED11-BF7A-0050F21C6F69": {
    SelectedProgram: Joi.string().label("Client Program").required(),
    DateCompleted: Joi.string().required().label("Date Completed"),
    PSDType: Joi.string().label("Type of PSD").required(),
    ReviewReason: Joi.string()
      .label("Reason")
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ReferralMembers: Joi.string()
      .label("Family Members on Referral")
      .required(),
    CaseMember: Joi.string()
      .label("Family Member listed under Case ID")
      .required(),
    MaGIKCaseID: Joi.string().label("MaGIK Case ID").required(),
    Caseworker: Joi.string().label("Caseworker").required(),
    Division: Joi.string().label("SAFY Division").required(),
    County: Joi.string().label("County").required(),
    CountyDetails: Joi.string()
      .label("County")
      .when("County", { is: "Other", then: Joi.required() }),
    ISFamily: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISDCS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.string()
      .label("Other Information Source details")
      .when("ISOther", { is: true, then: Joi.required() }),
    ReferralReason: Joi.string().label("Reason for Referral").required(),
    PresentingProblem: Joi.string()
      .label("Description of the Problem(s)")
      .required(),
    ProtectiveFactors: Joi.string().label("Protective Factors").required(),
    CurrentHousehold: Joi.string().label("Current Household").required(),
    OtherFamilySupports: Joi.string().label("Other Family Supports").required(),
    CaregiverCooperation: Joi.string()
      .label("Cooperation between caregivers")
      .required(),
    CaregiverCooperationDetails: Joi.string()
      .label("Cooperation between caregivers details")
      .when("CaregiverCooperation", { is: "No", then: Joi.required() }),
    SupervisionDifficulties: Joi.string()
      .label("Difficulties with the supervision")
      .required(),
    SupervisionDifficultiesDetails: Joi.string()
      .label("Difficulties with the supervision details")
      .when("SupervisionDifficulties", { is: "Yes", then: Joi.required() }),
    DisciplinePractices: Joi.string().label("Discipline practices").required(),
    Interaction: Joi.string()
      .label("Interaction between caregivers and child(ren)")
      .required(),
    FamilyHistoryUnknown: Joi.boolean(),
    FamilyHistoryDetails: Joi.string()
      .label("Extended Family History")
      .when("FamilyHistoryUnknown", { is: "false", then: Joi.required() }),
    CulturalGroup: Joi.string().label("Identified cultural group").required(),
    TraditionsComments: Joi.string()
      .label("Special cultural traditions/celebrations/rituals")
      .required(),
    LanguagesSpoken: Joi.string().label("Languages spoken").required(),
    Religion: Joi.string()
      .label("Identified religion/belief system")
      .required(),
    ReligionRole: Joi.string()
      .label("Role of faith in client's life")
      .required(),
    GenderOrientation: Joi.string()
      .label("Gender identity & sexual orientation")
      .required(),
    PCP: Joi.string().label("Primary Care Physician").required(),
    LastMedicalExamDates: Joi.string()
      .label("Date(s) of last medical exam for child(ren)")
      .required(),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.string()
      .label("Allergies details")
      .when("Allergies", { is: true, then: Joi.required() }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.string()
      .label("Medical Conditions Details")
      .when("MedicalConditions", { is: true, then: Joi.required() }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.string()
      .label("Nutritional Concerns Details")
      .when("NutritionalConcerns", { is: true, then: Joi.required() }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.string()
      .label("Dental Concerns Details")
      .when("DentalConcerns", { is: true, then: Joi.required() }),
    SleepConcerns: Joi.boolean(),
    SleepConcernsDetails: Joi.string()
      .label("Sleep Concerns Details")
      .when("SleepConcerns", { is: true, then: Joi.required() }),
    Hospitalizations: Joi.boolean(),
    HospitalizationsDetails: Joi.string()
      .label("Hospitalization Details")
      .when("Hospitalizations", { is: true, then: Joi.required() }),
    HeadInjury: Joi.boolean(),
    HeadInjuryDetails: Joi.string()
      .label("Head Injury Details")
      .when("HeadInjury", { is: true, then: Joi.required() }),
    Undiagnosed: Joi.string().label("Undiagnosed illness symptoms").required(),
    UndiagnosedComments: Joi.string()
      .label("Undiagnosed illness symptom details")
      .when("Undiagnosed", { is: "Yes", then: Joi.required() }),
    PregnancyHistory: Joi.string().label("Pregnancy History").required(),
    MilestonesMet: Joi.string()
      .label("Developmental milestones met on time")
      .required(),
    MilestonesMetDetails: Joi.string()
      .label("Milestone details")
      .when("MilestonesMet", { is: "No", then: Joi.required() }),
    SpecialNeeds: Joi.string()
      .label("Developmental delays or special needs")
      .required(),
    SpecialNeedsDetails: Joi.string()
      .label("Special needs details")
      .when("SpecialNeeds", { is: "Yes", then: Joi.required() }),
    SpecializedServices: Joi.string().label("Specialized Services").required(),
    SpecializedServicesDetails: Joi.string()
      .label("Specialized Services details")
      .when("SpecializedServices", { is: "Yes", then: Joi.required() }),
    HasMedications: Joi.string().required(),
    CurrentMedicationDetails: Joi.string()
      .label("Current Medications")
      .when("HasMedications", { is: "Yes", then: Joi.required() }),
    HadMedications: Joi.string().required(),
    PsychotropicMedications: Joi.string()
      .label("Past Psychotropic Medications")
      .when("HadMedications", { is: "Yes", then: Joi.required() }),
    SexualHistoryDetails: Joi.string().required(),
    HasMentalHealthTreatment: Joi.string().required(),
    MentalHealthTreatment: Joi.string()
      .label("Mental Health Treatment")
      .when("HasMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    NoSelfHarm: Joi.boolean(),
    SelfHarmDetails: Joi.string().label("Self Harm Details").required(),
    AllSelfHarmScreened: Joi.string()
      .label("All family members screened")
      .required(),
    NotAllSelfHarmScreenedDetails: Joi.string()
      .label("Not all family members screened details")
      .when("AllSelfHarmScreened", { is: "No", then: Joi.required() }),
    SelfHarmComments: Joi.string()
      .label("Comments/Action Taken")
      .when("NoSelfHarm", { is: false, then: Joi.required() }),
    NoHarmingOthers: Joi.boolean(),
    HarmingOthersDetails: Joi.string()
      .label("Harm to Others/Endangerment details")
      .required(),
    AllHarmOthersScreened: Joi.string()
      .label("All family members screened")
      .required(),
    NotAllHarmOthersScreenedDetails: Joi.string()
      .label("Not all family members screened details")
      .when("AllHarmOthersScreened", { is: "No", then: Joi.required() }),
    HarmingOthersComments: Joi.string()
      .label("Comments/Action Taken")
      .when("NoHarmingOthers", { is: false, then: Joi.required() }),
    EducationDetails: Joi.string().label("Education details").required(),
    NoneEmployed: Joi.boolean(),
    EmploymentDetails: Joi.string().label("Employment details").required(),
    MilitaryHistory: Joi.string()
      .label("Family members' military history")
      .required(),
    MilitaryHistoryDetails: Joi.string()
      .label("Military history details")
      .when("MilitaryHistory", { is: "Yes", then: Joi.required() }),
    NoSubstanceUse: Joi.boolean(),
    SubstanceUseHistory: Joi.string()
      .label("Substance Use history")
      .when("NoSubstanceUse", { is: false, then: Joi.required() }),
    HasSubstanceUseTreatment: Joi.string().required(),
    SUTreatmentHistory: Joi.string()
      .label("Substance Use Treatment history")
      .when("HasSubstanceUseTreatment", { is: "Yes", then: Joi.required() }),
    TraumaHistory: Joi.string().label("Trauma history").required(),
    FamilyChanges: Joi.string()
      .label("Changes/transitions in family")
      .required(),
    FamilyChangesDetails: Joi.string()
      .label("Changes/transitions in family description")
      .when("FamilyChanges", { is: "Yes", then: Joi.required() }),
    RecentGrief: Joi.string()
      .label("Recent or significant deaths/grief issues")
      .required(),
    RecentGriefDetails: Joi.string()
      .label("Recent or significant deaths/grief issues details")
      .when("RecentGrief", { is: "Yes", then: Joi.required() }),
    MentalStatusNA: Joi.boolean(),
    MentalStatusDetails: Joi.string()
      .label("Mental Status")
      .when("MentalStatusNA", { is: false, then: Joi.required() }),
    SymptomsNA: Joi.boolean(),
    Symptoms: Joi.string()
      .label("Symptoms")
      .when("SymptomsNA", { is: false, then: Joi.required() }),
    SymptomsNAComments: Joi.string()
      .label("Comments")
      .when("SymptomsNA", { is: true, then: Joi.required() }),
    Hygiene: Joi.string().label("Personal appearance and hygiene").required(),
    HygieneFamilyMembers: Joi.string()
      .label("Personal appearance and hygiene Family Members")
      .when("Hygiene", { is: "Yes", then: Joi.required() }),
    HygieneDetails: Joi.string()
      .label("Personal appearance and hygiene Details")
      .when("Hygiene", { is: "Yes", then: Joi.required() }),
    MoneyManagement: Joi.string().label("Money management").required(),
    MoneyManagementFamilyMembers: Joi.string()
      .label("Money management Family Members")
      .when("MoneyManagement", { is: "Yes", then: Joi.required() }),
    MoneyManagementDetails: Joi.string()
      .label("Money management Details")
      .when("MoneyManagement", { is: "Yes", then: Joi.required() }),
    FoodManagement: Joi.string().label("Food management").required(),
    FoodManagementFamilyMembers: Joi.string()
      .label("Food management Family Members")
      .when("FoodManagement", { is: "Yes", then: Joi.required() }),
    FoodManagementDetails: Joi.string()
      .label("Food management Details")
      .when("FoodManagement", { is: "Yes", then: Joi.required() }),
    Health: Joi.string().label("Health").required(),
    HealthFamilyMembers: Joi.string()
      .label("Health Family Members")
      .when("Health", { is: "Yes", then: Joi.required() }),
    HealthDetails: Joi.string()
      .label("Health Details")
      .when("Health", { is: "Yes", then: Joi.required() }),
    Housekeeping: Joi.string().label("Housekeeping").required(),
    HousekeepingFamilyMembers: Joi.string()
      .label("Housekeeping Family Members")
      .when("Housekeeping", { is: "Yes", then: Joi.required() }),
    HousekeepingDetails: Joi.string()
      .label("Housekeeping Details")
      .when("Housekeeping", { is: "Yes", then: Joi.required() }),
    Transportation: Joi.string().label("Transportation").required(),
    TransportationFamilyMembers: Joi.string()
      .label("Transportation Family Members")
      .when("Transportation", { is: "Yes", then: Joi.required() }),
    TransportationDetails: Joi.string()
      .label("Transportation Details")
      .when("Transportation", { is: "Yes", then: Joi.required() }),
    SafetySkills: Joi.string().label("Safety Skills").required(),
    SafetySkillsFamilyMembers: Joi.string()
      .label("Safety Skills Family Members")
      .when("SafetySkills", { is: "Yes", then: Joi.required() }),
    SafetySkillsDetails: Joi.string()
      .label("Safety Skills Details")
      .when("SafetySkills", { is: "Yes", then: Joi.required() }),
    ResourceKnowledge: Joi.string().label("ResourceKnowledge").required(),
    ResourceKnowledgeFamilyMembers: Joi.string()
      .label("Resource Knowledge Family Members")
      .when("ResourceKnowledge", { is: "Yes", then: Joi.required() }),
    ResourceKnowledgeDetails: Joi.string()
      .label("Resource Knowledge Details")
      .when("ResourceKnowledge", { is: "Yes", then: Joi.required() }),
    TimeManagement: Joi.string().label("Time Management").required(),
    TimeManagementFamilyMembers: Joi.string()
      .label("Time Management Family Members")
      .when("TimeManagement", { is: "Yes", then: Joi.required() }),
    TimeManagementDetails: Joi.string()
      .label("Time Management Details")
      .when("TimeManagement", { is: "Yes", then: Joi.required() }),
    InteractionWithOthers: Joi.string().label("Interaction").required(),
    InteractionFamilyMembers: Joi.string()
      .label("Interaction Family Members")
      .when("InteractionWithOthers", { is: "Yes", then: Joi.required() }),
    InteractionDetails: Joi.string()
      .label("Interaction Details")
      .when("InteractionWithOthers", { is: "Yes", then: Joi.required() }),
    PsychosocialFunctioning: Joi.string()
      .label("Psychosocial Functioning")
      .required(),
    LegalInvolvement: Joi.string().label("Legal Involvement").required(),
    LegalInvolvementDetails: Joi.string()
      .label("Legal History")
      .when("LegalInvolvement", { is: "Yes", then: Joi.required() }),
    CPSInvolvement: Joi.string().label("CPS Involvement").required(),
    CPSInvolvementDetails: Joi.string()
      .label("CPS History")
      .when("CPSInvolvement", { is: "Yes", then: Joi.required() }),
    PFS2CompletionStatus: Joi.string()
      .label("PFS-2 completion status")
      .required(),
    Resilience: Joi.string()
      .label("Family Functioning/Resilience")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    Attachment: Joi.string()
      .label("Nurturing and Attachment")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    SocialSupports: Joi.string()
      .label("Social Supports")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    PractitionerRelationship: Joi.string()
      .label("Caregiver/Practitioner Relationship")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    ConcreteSupports: Joi.string()
      .label("Concrete Supports")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    OtherTools: Joi.string().label("Other tools used").required(),
    OtherToolsDetails: Joi.string()
      .label("Other tool details")
      .when("OtherTools", { is: "Yes", then: Joi.required() }),
    Interpretation: Joi.string()
      .label("Interpretation of Scores")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() })
      .when("OtherTools", { is: "Yes", then: Joi.required() }),
    ClinicalSummary: Joi.string()
      .label("Clinical Observations/Family Clinical Summary")
      .required(),
    RiskFactors: Joi.string()
      .label("Areas of Concern/Risk Factors/Potential Barriers")
      .required(),
    ConcreteNeeds: Joi.string().label("Concrete Needs").required(),
    DischargePlan: Joi.string()
      .label("Family's Perspective/Plan for Discharge")
      .required(),
    DiagnosisDetails: Joi.string().label("Diagnosis Details").required(),
    TreatmentRecommendations: Joi.string()
      .label("Treatment Recommendations")
      .required(),
    AdditionalPsychiatric: Joi.boolean(),
    AdditionalPsychological: Joi.boolean(),
    AdditionalNeurological: Joi.boolean(),
    AdditionalEducational: Joi.boolean(),
    AdditionalMedical: Joi.boolean(),
    AdditionalDental: Joi.boolean(),
    AdditionalSubstanceAbuse: Joi.boolean(),
    AdditionalVocational: Joi.boolean(),
    AdditionalOccupational: Joi.boolean(),
    AdditionalNutritional: Joi.boolean(),
    AdditionalVisualAuditory: Joi.boolean(),
    AdditionalDomesticViolence: Joi.boolean(),
    AdditionalSexOffender: Joi.boolean(),
    AdditionalOther: Joi.boolean(),
    AdditionalOtherDetails: Joi.string()
      .label("Other Evaluations Needed details")
      .when("AdditionalOther", { is: true, then: Joi.required() }),
    MembersInNeed: Joi.string()
      .label("Family Member(s) in need of evaluation")
      .when("AdditionalPsychiatric", { is: true, then: Joi.required() })
      .when("AdditionalPsychological", { is: true, then: Joi.required() })
      .when("AdditionalNeurological", { is: true, then: Joi.required() })
      .when("AdditionalEducational", { is: true, then: Joi.required() })
      .when("AdditionalMedical", { is: true, then: Joi.required() })
      .when("AdditionalDental", { is: true, then: Joi.required() })
      .when("AdditionalSubstanceAbuse", { is: true, then: Joi.required() })
      .when("AdditionalVocational", { is: true, then: Joi.required() })
      .when("AdditionalOccupational", { is: true, then: Joi.required() })
      .when("AdditionalNutritional", { is: true, then: Joi.required() })
      .when("AdditionalVisualAuditory", { is: true, then: Joi.required() })
      .when("AdditionalDomesticViolence", { is: true, then: Joi.required() })
      .when("AdditionalSexOffender", { is: true, then: Joi.required() })
      .when("AdditionalOther", { is: true, then: Joi.required() }),
  },
  "96D36A50-93A8-ED11-BF7A-0050F21C653C": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    DateCompleted: Joi.string().required().label("Date Completed"),
    Division: Joi.string().required().label("Division"),
    PSDType: Joi.string().required().label("Type of PSD"),
    ReviewReason: Joi.string()
      .label("Reason")
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ChangeInDiagnosis: Joi.string()
      .label("Change In Diagnosis")
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ISClient: Joi.boolean(),
    ISParent: Joi.boolean(),
    ISFamily: Joi.boolean(),
    ISGuardian: Joi.boolean(),
    ISCaregiver: Joi.boolean(),
    ISPhysician: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISCPS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.string().allow(""),
    PresentingProblem: Joi.string().required().label("Presenting Problem"),
    ClientStrengths: Joi.string().required().label("Client strengths"),
    Supports: Joi.string().required().label("Client/Caregiver supports"),
    CurrentPlacement: Joi.string().required().label("Current placement"),
    PlacementHistory: Joi.string().required().label("Placement History"),
    AdditionalAssessment: Joi.string()
      .required()
      .label("Additional assessment"),
    FamilyHistoryUnknown: Joi.boolean(),
    FamilyHistoryDetails: Joi.string()
      .label("Family History")
      .when("FamilyHistoryUnknown", { is: false, then: Joi.required() }),
    CurrentConcernsOfDV: Joi.boolean(),
    PastConcernsOfDV: Joi.boolean(),
    UnknownConcernsOfDV: Joi.boolean(),
    NoReportedConcernsOfDV: Joi.boolean(),
    CurrentMaritalConflict: Joi.boolean(),
    PastMaritalConflict: Joi.boolean(),
    UnknownMaritalConflict: Joi.boolean(),
    NoReportedMaritalConflict: Joi.boolean(),
    CaregiverCooperation: Joi.string()
      .required()
      .label("Caregivers cooperating"),
    SupervisionDifficulties: Joi.string()
      .required()
      .label("Supervision difficulties"),
    DisciplinePracticesEffective: Joi.boolean(),
    DisciplinePracticesInconsistent: Joi.boolean(),
    DisciplinePracticesIneffective: Joi.boolean(),
    DisciplinePracticesNA: Joi.boolean(),
    FamilyHistoryComments: Joi.string()
      .required()
      .label("Family history comments"),
    RaceEthnicity: Joi.string().required().label("Race and ethnicity"),
    PlacesLived: Joi.string().required().label("Places lived"),
    SocioeconomicStatus: Joi.string().required().label("Socioeconomic status"),
    Religion: Joi.string().required().label("Religious information"),
    Traditions: Joi.string().required().label("Cultural events"),
    TraditionsComments: Joi.string()
      .label("Cultural events comments")
      .when("Traditions", { is: "Yes", then: Joi.required() }),
    MedicalBeliefs: Joi.string()
      .required()
      .label("Beliefs affect health decisions?"),
    MedicalBeliefsComments: Joi.string()
      .label("Beliefs affecting health decisions")
      .when("MedicalBeliefs", { is: "Yes", then: Joi.required() }),
    InFosterCare: Joi.string().required().label("In foster care?"),
    CulturalDifferences: Joi.string()
      .label("Cultural differences?")
      .when("InFosterCare", { is: "Yes", then: Joi.required() }),
    CulturalDifferencesComments: Joi.string()
      .label("Cultural differences comments")
      .when("CulturalDifferences", { is: "Yes", then: Joi.required() }),
    PHNoProblems: Joi.boolean(),
    PHPrenatalCare: Joi.string()
      .label("Prenatal care")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHExposure: Joi.string().label("Prenatal exposure").when("PHNoProblems", {
      is: false,
      then: Joi.required(),
    }),
    PHTrauma: Joi.string().label("Prenatal trauma").when("PHNoProblems", {
      is: false,
      then: Joi.required(),
    }),
    PHComplications: Joi.string()
      .label("Birth complications")
      .when("PHNoProblems", {
        is: false,
        then: Joi.required(),
      }),
    PHConcerns: Joi.string().label("Medical concerns").when("PHNoProblems", {
      is: false,
      then: Joi.required(),
    }),
    PHComments: Joi.string().label("Medical comments").when("PHNoProblems", {
      is: false,
      then: Joi.required(),
    }),
    SpecialNeeds: Joi.string().label("Special needs").required(),
    SpecialNeedsDetails: Joi.string()
      .label("Special needs details")
      .when("SpecialNeeds", {
        is: "Yes",
        then: Joi.required(),
      }),
    SpecializedServices: Joi.string().label("Specialized services").required(),
    SpecializedServicesDetails: Joi.string()
      .label("Specialized services details")
      .when("SpecializedServices", {
        is: "Yes",
        then: Joi.required(),
      }),
    EducationStatus: Joi.string().required().label("Education status"),
    SchoolName: Joi.string().label("School Name").when("EducationStatus", {
      is: "Currently enrolled in school",
      then: Joi.required(),
    }),
    CurrentGrade: Joi.string().label("Current Grade").when("EducationStatus", {
      is: "Currently enrolled in school",
      then: Joi.required(),
    }),
    RegularClassroom: Joi.string()
      .label("Regular Classroom")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      }),
    Active504Plan: Joi.string()
      .label("Active 504 Plan")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      }),
    ActiveIEP: Joi.string().label("Active IEP").when("EducationStatus", {
      is: "Currently enrolled in school",
      then: Joi.required(),
    }),
    IEPClassification: Joi.string()
      .label("IEP Classification")
      .when("ActiveIEP", { is: "Yes", then: Joi.required() }),
    SchoolExperience: Joi.string()
      .label("School Experience")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      })
      .when("EducationStatus", { is: "Graduated", then: Joi.required() })
      .when("EducationStatus", { is: "GED", then: Joi.required() })
      .when("EducationStatus", {
        is: "Dropout/Did not complete",
        then: Joi.required(),
      }),
    CurrentlyEmployed: Joi.string()
      .label("Currently Employed")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      })
      .when("EducationStatus", { is: "Graduated", then: Joi.required() })
      .when("EducationStatus", { is: "GED", then: Joi.required() })
      .when("EducationStatus", {
        is: "Dropout/Did not complete",
        then: Joi.required(),
      }),
    EmployerAndTitle: Joi.string()
      .label("Employer name & title")
      .when("CurrentlyEmployed", { is: "Yes", then: Joi.required() }),
    EmploymentInterests: Joi.string()
      .label("Employer name & title")
      .when("CurrentlyEmployed", { is: "Yes", then: Joi.required() })
      .when("CurrentlyEmployed", { is: "No", then: Joi.required() }),
    MilitaryHistory: Joi.string()
      .label("Military History")
      .when("EducationStatus", {
        is: "Currently enrolled in school",
        then: Joi.required(),
      })
      .when("EducationStatus", { is: "Graduated", then: Joi.required() })
      .when("EducationStatus", { is: "GED", then: Joi.required() })
      .when("EducationStatus", {
        is: "Dropout/Did not complete",
        then: Joi.required(),
      }),
    EmploymentComments: Joi.string()
      .label("Military History comments")
      .when("MilitaryHistory", { is: "Yes", then: Joi.required() }),
    ADLNA: Joi.boolean(),
    MoneyManagement: Joi.string()
      .label("Money management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    MoneyManagementDetails: Joi.string()
      .label("Money management explanation")
      .when("MoneyManagement", { is: "Yes", then: Joi.required() }),
    FoodManagement: Joi.string()
      .label("Food management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    FoodManagementDetails: Joi.string()
      .label("Food management explanation")
      .when("FoodManagement", { is: "Yes", then: Joi.required() }),
    Hygiene: Joi.string()
      .label("Hygiene")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HygieneDetails: Joi.string()
      .label("Hygiene explanation")
      .when("Hygiene", { is: "Yes", then: Joi.required() }),
    Health: Joi.string()
      .label("Health")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HealthDetails: Joi.string()
      .label("Health explanation")
      .when("Health", { is: "Yes", then: Joi.required() }),
    Housekeeping: Joi.string()
      .label("Housekeeping")
      .when("ADLNA", { is: false, then: Joi.required() }),
    HousekeepingDetails: Joi.string()
      .label("Housekeeping explanation")
      .when("Housekeeping", { is: "Yes", then: Joi.required() }),
    Transportation: Joi.string()
      .label("Transportation")
      .when("ADLNA", { is: false, then: Joi.required() }),
    TransportationDetails: Joi.string()
      .label("Transportation details")
      .when("Transportation", { is: "Yes", then: Joi.required() }),
    SafetySkills: Joi.string()
      .label("Emergency skills")
      .when("ADLNA", { is: false, then: Joi.required() }),
    SafetySkillsDetails: Joi.string()
      .label("Emergency skills explanation")
      .when("SafetySkills", { is: "Yes", then: Joi.required() }),
    ResourceKnowledge: Joi.string()
      .label("Resource knowledge")
      .when("ADLNA", { is: false, then: Joi.required() }),
    ResourceKnowledgeDetails: Joi.string()
      .label("Resource knowledge explanation")
      .when("ResourceKnowledge", { is: "Yes", then: Joi.required() }),
    TimeManagement: Joi.string()
      .label("Time management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    TimeManagementDetails: Joi.string()
      .label("Time management explaination")
      .when("TimeManagement", { is: "Yes", then: Joi.required() }),
    Interaction: Joi.string()
      .label("Interactions")
      .when("ADLNA", { is: false, then: Joi.required() }),
    InteractionDetails: Joi.string()
      .label("Interactions explanation")
      .when("Interaction", { is: "Yes", then: Joi.required() }),
    RelationshipsNA: Joi.boolean(),
    CoopSkills: Joi.string()
      .label("Cooperative play skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    CommunicationSkills: Joi.string()
      .label("Communication skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    EmotionalUnderstanding: Joi.string()
      .label("Emotional understanding")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    ProblemSolving: Joi.string()
      .label("Problem-solving skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    ConflictResolution: Joi.string()
      .label("Conflict resolution skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    DecisionMakingSkills: Joi.string()
      .label("Decision making skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    Bullied: Joi.string()
      .label("History of being bullied")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    Bully: Joi.string()
      .label("History of bullying others")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    RelationshipsSummary: Joi.string()
      .label("Friendship Summary Narrative")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    LegalNA: Joi.boolean(),
    LegalInvolvement: Joi.string()
      .label("Legal involvement")
      .when("LegalNA", { is: false, then: Joi.required() }),
    LegalInvolvementDetails: Joi.string()
      .label("Legal involvement details")
      .when("LegalInvolvement", { is: "Yes", then: Joi.required() }),
    CPSInvolvement: Joi.string()
      .label("CPS involvement")
      .when("LegalNA", { is: false, then: Joi.required() }),
    CPSInvolvementDetails: Joi.string()
      .label("CPS involvement details")
      .when("CPSInvolvement", { is: "Yes", then: Joi.required() }),
    CPSCaseworker: Joi.string()
      .label("CPS Caseworker")
      .when("LegalNA", { is: false, then: Joi.required() }),
    CPSCaseworkerName: Joi.string()
      .label("CPS Caseworker name")
      .when("CPSCaseworker", { is: "Yes", then: Joi.required() }),
    ProbationOfficer: Joi.string()
      .label("Probation/Parole Officer")
      .when("LegalNA", { is: false, then: Joi.required() }),
    ProbationOfficerName: Joi.string()
      .label("Probation/Parole Officer name")
      .when("ProbationOfficer", { is: "Yes", then: Joi.required() }),
    GALCASA: Joi.string()
      .label("GAL/CASA")
      .when("LegalNA", { is: false, then: Joi.required() }),
    OtherLegalDetails: Joi.string().allow(""),
    PCP: Joi.string()
      .label("Primary Care Physician")
      .when("PCPPhoneUnknown", { is: false, then: Joi.required() }),
    PCPPhone: Joi.string()
      .label("PCP Phone")
      .when("PCPPhoneUnknown", { is: false, then: Joi.required() }),
    PCPPhoneUnknown: Joi.boolean(),
    LastMedicalExamDate: Joi.string()
      .required()
      .label("Date of last medical exam"),
    LastDentalExamDate: Joi.string()
      .required()
      .label("Date of last dental exam"),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.string()
      .label("Allergies list")
      .when("Allergies", { is: true, then: Joi.required() }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.string()
      .label("Medical conditions list")
      .when("MedicalConditions", { is: true, then: Joi.required() }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.string()
      .label("Nutritional concerns list")
      .when("NutritionalConcerns", { is: true, then: Joi.required() }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.string()
      .label("Dental concerns list")
      .when("DentalConcerns", { is: true, then: Joi.required() }),
    Undiagnosed: Joi.string().required().label("Potential undiagnosed illness"),
    MedicalComments: Joi.string().required().label("Medical comments"),
    NoMedications: Joi.boolean(),
    CurrentMedicationDetails: Joi.string()
      .label("Current medications")
      .when("NoMedications", { is: false, then: Joi.required() }),
    MedicationCompliance: Joi.string()
      .label("Compliance with medication")
      .when("NoMedications", { is: false, then: Joi.required() }),
    SideEffects: Joi.string()
      .label("Side effects")
      .when("NoMedications", { is: false, then: Joi.required() }),
    SideEffectsDetails: Joi.string()
      .label("Side effects details")
      .when("SideEffects", { is: "Yes", then: Joi.required() }),
    PsychotropicMeds: Joi.string()
      .required()
      .label("Past psychotropic medications"),
    PsychotropicMedsDetails: Joi.string()
      .label("Past psychotropic medications list")
      .when("PsychotropicMeds", { is: "Yes", then: Joi.required() }),
    MedicationComments: Joi.string().required().label("Medication comments"),
    SexualHistoryNA: Joi.boolean(),
    SexualOrientation: Joi.string()
      .label("Sexual orientation")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualBehavior: Joi.string()
      .label("Sexual behavior")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualAbuse: Joi.string()
      .label("Sexual abuse or perpetration")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualRelationshipsEducation: Joi.string()
      .label("Sexual behavior/relationships education")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualHistoryComments: Joi.string()
      .label("Sexual history comments")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    MentalHealthNA: Joi.boolean(),
    PastMentalHealthTreatment: Joi.string()
      .label("Past mental health treatment")
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    PastMentalHealthPlacement: Joi.string()
      .label("Past placement")
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    PastMentalHealthDiagnosis: Joi.string()
      .label("Previous mental health diagnosis")
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    MentalHealthComments: Joi.string()
      .label("MH treatment placement details")
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    MentalHealthHistory: Joi.string()
      .label("MH placement history")
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    PerspectiveOfTreatment: Joi.string()
      .label("Perspective of MH treatment")
      .when("MentalHealthNA", { is: false, then: Joi.required() }),
    SubstanceUseNA: Joi.boolean(),
    PastSubstanceUse: Joi.string()
      .label("History of past drug or alcohol use")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    SubstanceUseHistory: Joi.string()
      .label("Current drug or alcohol use")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    PerspectiveOfSubstanceUse: Joi.string()
      .label("Perception of substance use")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    SubstanceUseComments: Joi.string()
      .label("Substance use comments")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    NoPastTreatment: Joi.boolean(),
    SubstanceUseTreatmentHistory: Joi.string()
      .label("Alcohol/Drug Treatment History")
      .when("NoPastTreatment", { is: false, then: Joi.required() }),
    PerspectiveOfSubstanceUseTreatment: Joi.string()
      .label("Perspective of treatment")
      .when("NoPastTreatment", { is: false, then: Joi.required() }),
    SubstanceUseTreatmentComments: Joi.string()
      .label("Alcohol/Drug Treatment History Comments")
      .when("NoPastTreatment", { is: false, then: Joi.required() }),
    TraumaNA: Joi.boolean(),
    TraumaHistory: Joi.string()
      .label("Trauma History")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    DistressingMemories: Joi.boolean(),
    BlockOut: Joi.boolean(),
    Hypervigilance: Joi.boolean(),
    PhysiologicalResponses: Joi.boolean(),
    LossOfMemories: Joi.boolean(),
    Hyperarousal: Joi.boolean(),
    SleepDisturbances: Joi.boolean(),
    DevelopmentalRegression: Joi.boolean(),
    Nightmares: Joi.boolean(),
    Avoidant: Joi.boolean(),
    DifficultyConcentratingSymptom: Joi.boolean(),
    UnhealthyBoundaries: Joi.boolean(),
    Flashbacks: Joi.boolean(),
    Detachment: Joi.boolean(),
    EmotionalDysregulation: Joi.boolean(),
    RepetitivePlayOfEvents: Joi.boolean(),
    PsychologicalDistress: Joi.boolean(),
    DiminishedInterests: Joi.boolean(),
    Dissocation: Joi.boolean(),
    NegativeCognitions: Joi.boolean(),
    SocialWithdrawalSymptom: Joi.boolean(),
    NoSymptoms: Joi.boolean(),
    SocialSupports: Joi.boolean(),
    InterpersonalSkills: Joi.boolean(),
    ValidatingExperiences: Joi.boolean(),
    Adaptability: Joi.boolean(),
    SenseOfMastery: Joi.boolean(),
    PositiveOutlook: Joi.boolean(),
    Resources: Joi.boolean(),
    SecureAttachments: Joi.boolean(),
    CaregiverStability: Joi.boolean(),
    PlacementStability: Joi.boolean(),
    TiesToExtendedFamily: Joi.boolean(),
    StrongCulturalIdentity: Joi.boolean(),
    StrongSpiritualBeliefs: Joi.boolean(),
    Pets: Joi.boolean(),
    NoTraumaProtectiveFactors: Joi.boolean(),
    CopingStrategies: Joi.string()
      .label("Coping strategies")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    TraumaSummary: Joi.string()
      .label("Trauma Impact Summary")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    AppropriateAppearance: Joi.boolean(),
    Neat: Joi.boolean(),
    Disheveled: Joi.boolean(),
    BizarreAppearance: Joi.boolean(),
    OtherAppearance: Joi.boolean(),
    OtherAppearanceDetails: Joi.string()
      .label("Other Appearance Comments")
      .when("OtherAppearance", { is: true, then: Joi.required() }),
    Cooperative: Joi.boolean(),
    Guarded: Joi.boolean(),
    Hyperactive: Joi.boolean(),
    Agitated: Joi.boolean(),
    Paranoid: Joi.boolean(),
    Tics: Joi.boolean(),
    Impulsive: Joi.boolean(),
    Aggressive: Joi.boolean(),
    Withdrawn: Joi.boolean(),
    BizarreBehavior: Joi.boolean(),
    Rigidity: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.string()
      .label("Other Behavior Comments")
      .when("OtherBehavior", { is: true, then: Joi.required() }),
    Normal: Joi.boolean(),
    Slurred: Joi.boolean(),
    Pressured: Joi.boolean(),
    Tangential: Joi.boolean(),
    Incoherent: Joi.boolean(),
    Stutters: Joi.boolean(),
    OtherSpeech: Joi.boolean(),
    OtherSpeechDetails: Joi.string()
      .label("Other Speech Comments")
      .when("OtherSpeech", { is: true, then: Joi.required() }),
    Euthymic: Joi.boolean(),
    Anxious: Joi.boolean(),
    Angry: Joi.boolean(),
    Depressed: Joi.boolean(),
    Euphoric: Joi.boolean(),
    Irritable: Joi.boolean(),
    Fearful: Joi.boolean(),
    OtherMood: Joi.boolean(),
    OtherMoodDetails: Joi.string()
      .label("Other Mood Comments")
      .when("OtherMood", { is: true, then: Joi.required() }),
    FullRange: Joi.boolean(),
    Restricted: Joi.boolean(),
    Blunted: Joi.boolean(),
    Flat: Joi.boolean(),
    Inappropriate: Joi.boolean(),
    OtherAffect: Joi.boolean(),
    OtherAffectDetails: Joi.string()
      .label("Other Affect Comments")
      .when("OtherAffect", { is: true, then: Joi.required() }),
    Logical: Joi.boolean(),
    Preoccupations: Joi.boolean(),
    Delusions: Joi.boolean(),
    Hallucinations: Joi.boolean(),
    Racing: Joi.boolean(),
    Disorganized: Joi.boolean(),
    Concrete: Joi.boolean(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    OtherPerception: Joi.boolean(),
    OtherPerceptionDetails: Joi.string()
      .label("Other Perception Comments")
      .when("OtherPerception", { is: true, then: Joi.required() }),
    NoImpairment: Joi.boolean(),
    ShortAttentionSpan: Joi.boolean(),
    DifficultyConcentrating: Joi.boolean(),
    Distractibility: Joi.boolean(),
    MemoryImpairment: Joi.boolean(),
    LowIntelligence: Joi.boolean(),
    OtherCognition: Joi.boolean(),
    OtherCognitionDetails: Joi.string()
      .label("Other Cognition Comments")
      .when("OtherCognition", { is: true, then: Joi.required() }),
    AppropriateInsight: Joi.boolean(),
    Fair: Joi.boolean(),
    Impaired: Joi.boolean(),
    OtherInsight: Joi.boolean(),
    OtherInsightDetails: Joi.string()
      .label("Other Insight Comments")
      .when("OtherInsight", { is: true, then: Joi.required() }),
    MentalStatusComments: Joi.string()
      .required()
      .label("Mental Status Comments"),
    LethalityNA: Joi.boolean(),
    SelfAbusiveBehavior: Joi.string()
      .label("Self-abusive behavior")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SelfAbusiveBehaviorDetails: Joi.string()
      .label("Self-abusive behavior details")
      .when("SelfAbusiveBehavior", { is: "Current", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "Last 30 Days", then: Joi.required() })
      .when("SelfAbusiveBehavior", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("SelfAbusiveBehavior", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    SuicidalThreats: Joi.string()
      .label("Suicidal threats")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicidalThreatsDetails: Joi.string()
      .label("Suicidal threats details")
      .when("SuicidalThreats", { is: "Current", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicidalThreats", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    SuicideAttempt: Joi.string()
      .label("Suicide attempt")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicideAttemptDetails: Joi.string()
      .label("Suicide attempt details")
      .when("SuicideAttempt", { is: "Current", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicideAttempt", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    PriorAttempt: Joi.boolean(),
    AccessToMeans: Joi.boolean(),
    HealthCondition: Joi.boolean(),
    MentalHealthDisorder: Joi.boolean(),
    FamilyHistory: Joi.boolean(),
    Exposure: Joi.boolean(),
    ElevatingBeliefs: Joi.boolean(),
    OtherRiskFactors: Joi.boolean(),
    OtherRiskFactorsDetails: Joi.string()
      .label("Risk Factors")
      .when("OtherRiskFactors", { is: true, then: Joi.required() }),
    NoRiskFactors: Joi.boolean(),
    RiskFactorsComments: Joi.string()
      .label("Risk Factors Comments")
      .when("SelfAbusiveBehavior", { is: "Current", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "Last 30 Days", then: Joi.required() })
      .when("SelfAbusiveBehavior", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("SelfAbusiveBehavior", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicidalThreats", { is: "Current", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicidalThreats", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicideAttempt", { is: "Current", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicideAttempt", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ClinicalCare: Joi.boolean(),
    Connected: Joi.boolean(),
    Skills: Joi.boolean(),
    CaregiverContacts: Joi.boolean(),
    DiscouragingBeliefs: Joi.boolean(),
    NoSelfHarmProtectiveFactors: Joi.boolean(),
    ProtectiveFactorsComments: Joi.string()
      .label("Protective Factors Comments")
      .when("SelfAbusiveBehavior", { is: "Current", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "Last 30 Days", then: Joi.required() })
      .when("SelfAbusiveBehavior", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("SelfAbusiveBehavior", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicidalThreats", { is: "Current", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicidalThreats", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicideAttempt", { is: "Current", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicideAttempt", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    Threatening: Joi.boolean(),
    SeekingMeans: Joi.boolean(),
    Hopelessness: Joi.boolean(),
    IncreasedSubstanceUse: Joi.boolean(),
    DramaticMoodChanges: Joi.boolean(),
    GivingAwayPossessions: Joi.boolean(),
    SayingGoodbye: Joi.boolean(),
    SocialWithdrawal: Joi.boolean(),
    RecklessBehavior: Joi.boolean(),
    Feelings: Joi.boolean(),
    NoWarningSigns: Joi.boolean(),
    WarningSignsComments: Joi.string()
      .label("Current Warning Signs Comments")
      .when("SelfAbusiveBehavior", { is: "Current", then: Joi.required() })
      .when("SelfAbusiveBehavior", { is: "Last 30 Days", then: Joi.required() })
      .when("SelfAbusiveBehavior", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("SelfAbusiveBehavior", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicidalThreats", { is: "Current", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicidalThreats", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicidalThreats", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      })
      .when("SuicideAttempt", { is: "Current", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 30 Days", then: Joi.required() })
      .when("SuicideAttempt", { is: "Last 6 Months", then: Joi.required() })
      .when("SuicideAttempt", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    CaregiverConcernsOfSelfHarm: Joi.string()
      .label("Caregiver concerns of self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherConcernsOfSelfHarm: Joi.string()
      .label("Other concerns of self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SelfHarmSafetyPlanStatus: Joi.string()
      .label("Self-harm safety plan status")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentSelfHarmRisk: Joi.string()
      .label("Current Risk of Harm to Self")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentSelfHarmRiskComments: Joi.string()
      .label("Current Risk of Harm to Self Comments")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThreatsToHarmOthers: Joi.string()
      .label("Threats to harm others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThreatsToHarmOthersDetails: Joi.string()
      .label("Threats to harm others details")
      .when("ThreatsToHarmOthers", { is: "Current", then: Joi.required() })
      .when("ThreatsToHarmOthers", { is: "Last 30 Days", then: Joi.required() })
      .when("ThreatsToHarmOthers", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("ThreatsToHarmOthers", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ThoughtsOfHarm: Joi.string()
      .label("Thoughts of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThoughtsOfHarmDetails: Joi.string()
      .label("Thoughts of harming others details")
      .when("ThoughtsOfHarm", { is: "Current", then: Joi.required() })
      .when("ThoughtsOfHarm", { is: "Last 30 Days", then: Joi.required() })
      .when("ThoughtsOfHarm", { is: "Last 6 Months", then: Joi.required() })
      .when("ThoughtsOfHarm", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ActsOfHarm: Joi.string()
      .label("Acts of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarmDetails: Joi.string()
      .label("Acts of harming others details")
      .when("ActsOfHarm", { is: "Current", then: Joi.required() })
      .when("ActsOfHarm", { is: "Last 30 Days", then: Joi.required() })
      .when("ActsOfHarm", { is: "Last 6 Months", then: Joi.required() })
      .when("ActsOfHarm", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ActsOfHarmAnimals: Joi.string()
      .label("Acts of harming animals")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarmAnimalsDetails: Joi.string()
      .label("Acts of harming animals details")
      .when("ActsOfHarmAnimals", { is: "Current", then: Joi.required() })
      .when("ActsOfHarmAnimals", { is: "Last 30 Days", then: Joi.required() })
      .when("ActsOfHarmAnimals", { is: "Last 6 Months", then: Joi.required() })
      .when("ActsOfHarmAnimals", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    ActsInvolvingWeapons: Joi.string()
      .label("Acts involving weapons")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsInvolvingWeaponsDetails: Joi.string()
      .label("Acts involving weapons details")
      .when("ActsInvolvingWeapons", { is: "Current", then: Joi.required() })
      .when("ActsInvolvingWeapons", {
        is: "Last 30 Days",
        then: Joi.required(),
      })
      .when("ActsInvolvingWeapons", {
        is: "Last 6 Months",
        then: Joi.required(),
      })
      .when("ActsInvolvingWeapons", {
        is: "More Than 6 Months Ago",
        then: Joi.required(),
      }),
    CaregiverConcernOfOtherHarm: Joi.string()
      .required()
      .label("Caregiver concerns of harming others"),
    OtherConcernsOfOtherHarm: Joi.string()
      .required()
      .label("Other concerns of harming others"),
    OtherHarmSafetyPlanStatus: Joi.string()
      .required()
      .label("Harm to others safey plan status"),
    CurrentOtherHarmRisk: Joi.string()
      .required()
      .label("Current Risk of Harm to Others"),
    CurrentOtherHarmRiskDetails: Joi.string()
      .required()
      .label("Current Risk Comments"),
    OMHASNA: Joi.boolean(),
    AgeGroup: Joi.string()
      .label("Age group")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    IntoxWithdrawalLevel: Joi.string()
      .label("Acute Intoxication Withdrawal Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    BiomedicalConditionsLevel: Joi.string()
      .label("Biomedical Conditions/ Complications Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    CognitiveConditionsLevel: Joi.string()
      .label(
        "Emotional/ Behavioral/ Cognitive Conditions and/or Complications Level of Care"
      )
      .when("OMHASNA", { is: false, then: Joi.required() }),
    ReadinessToChangeLevel: Joi.string()
      .label("Readiness to Change Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    RelapsePotentialLevel: Joi.string()
      .label("Relapse Potential Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    RecoveryEnvironmentLevel: Joi.string()
      .label("Recovery Environment Level of Care")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    LevelOfCareRecommendedLevel: Joi.string()
      .label("Level of Care Recommended")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    LevelOfCarePlacedLevel: Joi.string()
      .label("Level of Care Placed")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    NotPlacedReason: Joi.string().allow(""),
    NotPlacedReasonDetails: Joi.string()
      .label("Other reason details")
      .when("NotPlacedReason", { is: "7", then: Joi.required() }),
    OMHASComments: Joi.string()
      .label("OMHAS Comments")
      .when("OMHASNA", { is: false, then: Joi.required() }),
    ClinicalNarrativeSummary: Joi.string()
      .required()
      .label("Clinical Narrative Summary"),
    ClinicalNarrativeSummaryComments: Joi.string()
      .required()
      .label("Clinical Narrative Summary Comments"),
    DiagnosisDetails: Joi.string().required().label("At least one Diagnosis"),
    SkillsTraining: Joi.boolean(),
    SymptomManagementSkills: Joi.boolean(),
    DecisionMaking: Joi.boolean(),
    FinancialSupport: Joi.boolean(),
    CommunitySupport: Joi.boolean(),
    Mentoring: Joi.boolean(),
    FamilySupport: Joi.boolean(),
    FosterFamilySupport: Joi.boolean(),
    Respite: Joi.boolean(),
    MedicationManagement: Joi.boolean(),
    MedicalDentalVision: Joi.boolean(),
    HealthyHabits: Joi.boolean(),
    EducationSchool: Joi.boolean(),
    Vocational: Joi.boolean(),
    Occupational: Joi.boolean(),
    ProsocialActivities: Joi.boolean(),
    CaseManagement: Joi.boolean(),
    SocialSkills: Joi.boolean(),
    TreatmentNeedsComments: Joi.string()
      .required()
      .label("Assessed Needs Comments"),
    TreatmentRecommendations: Joi.string()
      .required()
      .label("At least one Treatment Recommendation"),
    MorePsychiatric: Joi.boolean(),
    MorePsychological: Joi.boolean(),
    MoreNeurological: Joi.boolean(),
    MoreEducational: Joi.boolean(),
    MoreMedical: Joi.boolean(),
    MoreDental: Joi.boolean(),
    MoreSubstanceUse: Joi.boolean(),
    MoreVocational: Joi.boolean(),
    MoreOccupational: Joi.boolean(),
    MoreVisualAuditory: Joi.boolean(),
    MoreNutritional: Joi.boolean(),
    MoreOther: Joi.boolean(),
    MoreOtherDetails: Joi.string()
      .label("Other Further Evaluation Needs details")
      .when("MoreOther", { is: true, then: Joi.required() }),
    HardinSchools: Joi.string().allow(""),
    TreatmentGOI: Joi.string()
      .label("Treatment Goal(s), Objective(s), Intervention(s)")
      .when("HardinSchools", { is: "Yes", then: Joi.required() }),
    DiagnosisEducation: Joi.string().required().label("Diagnosis education"),
    RecommendationEducation: Joi.string()
      .required()
      .label("Recommendation education"),
    ClientAgrees: Joi.string().required().label("Client in agreement"),
    FamilyAgress: Joi.string().required().label("Family in agreement"),
    SexAssignedAtBirth: Joi.string().label("Sex Assigned at Birth").required(),
    SexAssignedAtBirthDetails: Joi.string()
      .label("Sex Assigned at Birth Specifics")
      .when("SexAssignedAtBirth", {
        is: "Sex not listed",
        then: Joi.required(),
      }),
    Pronouns: Joi.string().label("Pronouns").required(),
    PronounsDescription: Joi.string()
      .label("Pronouns description")
      .when("Pronouns", {
        is: "Prefer to self-describe",
        then: Joi.required(),
      }),
    GenderIdentity: Joi.string().label("Gender Identity").required(),
    GenderIdentityDescription: Joi.string()
      .label("Gender Identity description")
      .when("GenderIdentity", {
        is: "Identity not listed",
        then: Joi.required(),
      }),
    SexualOrientationDetails: Joi.string()
      .label("Sexual Orientation specifics")
      .when("SexualOrientation", {
        is: "Orientation not listed",
        then: Joi.required(),
      }),
    TraumaSymptoms: Joi.boolean(),
    TraumaticExposure: Joi.boolean(),
    AvoidantTrauma: Joi.boolean(),
    HypervigilanceTrauma: Joi.boolean(),
    IntrusiveDreams: Joi.boolean(),
    NegativeThoughts: Joi.boolean(),
    CocentrationProblems: Joi.boolean(),
    RecklessBehaviorTrauma: Joi.boolean(),
    SleepDisturbancesTrauma: Joi.boolean(),
    OtherTrauma: Joi.boolean(),
    OtherTraumaDetails: Joi.string()
      .label("Other Trauma Details")
      .when("OtherTrauma", { is: true, then: Joi.required() }),
    TraumaSymptomsFrequency: Joi.string()
      .label("Trauma Symptoms Frequency")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsIntensity: Joi.string()
      .label("Trauma Symptoms Intensity")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsDuration: Joi.string()
      .label("Trauma Symptoms Duration")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsOnset: Joi.string()
      .label("Trauma Symptoms Onset")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    AnxietyDisorder: Joi.boolean(),
    AnxietyDisorderExcessWorry: Joi.boolean(),
    AnxietyDisorderEasilyFatigued: Joi.boolean(),
    MuscleTension: Joi.boolean(),
    Overworried: Joi.boolean(),
    AnxietyDisorderDifficultyConcentrating: Joi.boolean(),
    SleepDisturbancesAnxiety: Joi.boolean(),
    RestlessAnxiety: Joi.boolean(),
    Irritability: Joi.boolean(),
    OtherAnxiety: Joi.boolean(),
    OtherAnxietyDetails: Joi.string()
      .label("Other Anxiety Details")
      .when("OtherAnxiety", { is: true, then: Joi.required() }),
    AnxietyDisorderFrequency: Joi.string()
      .label("Anxiety Frequency")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    AnxietyDisorderIntensity: Joi.string()
      .label("Anxiety Intensity")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    AnxietyDisorderDuration: Joi.string()
      .label("Anxiety Duration")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    DepressionSymptoms: Joi.boolean(),
    DepressedMood: Joi.boolean(),
    SleepChanges: Joi.boolean(),
    Guilt: Joi.boolean(),
    DiminishedInterest: Joi.boolean(),
    PurposelessMovement: Joi.boolean(),
    DifficultyConcentratingDepression: Joi.boolean(),
    WeightChanges: Joi.boolean(),
    FatigueDepression: Joi.boolean(),
    ThoughtsOfDeath: Joi.boolean(),
    OtherDepression: Joi.boolean(),
    OtherDepressionDetails: Joi.string()
      .label("Other Depression Details")
      .when("OtherDepression", { is: true, then: Joi.required() }),
    DepressionFrequency: Joi.string()
      .label("Depression Frequency")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    DepressionIntensity: Joi.string()
      .label("Depression Intensity")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    DepressionDuration: Joi.string()
      .label("Depression Duration")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    AttentionHyperactivity: Joi.boolean(),
    AttentionHyperactivityEasilyDistracted: Joi.boolean(),
    DifficultyFollowThrough: Joi.boolean(),
    Forgetful: Joi.boolean(),
    DifficultyListening: Joi.boolean(),
    DisorganizedAttention: Joi.boolean(),
    Fidgety: Joi.boolean(),
    LackOfDetails: Joi.boolean(),
    LosesThings: Joi.boolean(),
    InterruptsOthers: Joi.boolean(),
    UnableToSitStill: Joi.boolean(),
    ExcessiveTalking: Joi.boolean(),
    DifficultyWaiting: Joi.boolean(),
    OtherAttention: Joi.boolean(),
    OtherAttentionDetails: Joi.string()
      .label("Other Attention Details")
      .when("OtherAttention", { is: true, then: Joi.required() }),
    AttentionHyperactivityFrequency: Joi.string()
      .label("Attention Frequency")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    AttentionHyperactivityIntensity: Joi.string()
      .label("Attention Intensity")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    AttentionHyperactivityDuration: Joi.string()
      .label("Attention Duration")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    SU: Joi.boolean(),
    PatternOfSubstanceUse: Joi.boolean(),
    DesiresCutDownUse: Joi.boolean(),
    TimeSpentObtaining: Joi.boolean(),
    Cravings: Joi.boolean(),
    FailureOfResponsibilities: Joi.boolean(),
    NegativeImpact: Joi.boolean(),
    AbandonsActivities: Joi.boolean(),
    Tolerance: Joi.boolean(),
    SUWithdrawal: Joi.boolean(),
    SUOther: Joi.boolean(),
    SUOtherDetails: Joi.string()
      .label("Other Substance Use Details")
      .when("SUOther", { is: true, then: Joi.required() }),
    SubstanceUseFrequency: Joi.string()
      .label("Substance Use Frequency")
      .when("SU", { is: true, then: Joi.required() }),
    SubstanceUseIntensity: Joi.string()
      .label("Substance Use Intensity")
      .when("SU", { is: true, then: Joi.required() }),
    SubstanceUseDuration: Joi.string()
      .label("Substance Use Duration")
      .when("SU", { is: true, then: Joi.required() }),
    DMDD: Joi.boolean(),
    Temper: Joi.boolean(),
    OutsideOutbursts: Joi.boolean(),
    FrequentOutbursts: Joi.boolean(),
    DMDDIrritable: Joi.boolean(),
    OutburstsAroundOthers: Joi.boolean(),
    DMDDOther: Joi.boolean(),
    DMDDOtherDetails: Joi.string()
      .label("Other Disruptive Mood Dysregulation Disorder Details")
      .when("DMDDOther", { is: true, then: Joi.required() }),
    DMDDFrequency: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Frequency")
      .when("DMDD", { is: true, then: Joi.required() }),
    DMDDIntensity: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Intensity")
      .when("DMDD", { is: true, then: Joi.required() }),
    DMDDDuration: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Duration")
      .when("DMDD", { is: true, then: Joi.required() }),
    ConductDisorder: Joi.boolean(),
    Aggression: Joi.boolean(),
    DestructionOfProperty: Joi.boolean(),
    Theft: Joi.boolean(),
    SeriousViolations: Joi.boolean(),
    OtherConductDisorder: Joi.boolean(),
    OtherConductDisorderDetails: Joi.string()
      .label("Other Conduct Disorder Details")
      .when("OtherConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderFrequency: Joi.string()
      .label("Conduct Disorder Frequency")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderIntensity: Joi.string()
      .label("Conduct Disorder Intensity")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderDuration: Joi.string()
      .label("Conduct Disorder Duration")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ODD: Joi.boolean(),
    IrritableODD: Joi.boolean(),
    Argumentative: Joi.boolean(),
    Vindictive: Joi.boolean(),
    OtherODD: Joi.boolean(),
    OtherODDDetails: Joi.string()
      .label("Other Oppositional Defiance Disorder Details")
      .when("OtherODD", { is: true, then: Joi.required() }),
    ODDFrequency: Joi.string()
      .label("Oppositional Defiance Disorder Frequency")
      .when("ODD", { is: true, then: Joi.required() }),
    ODDIntensity: Joi.string()
      .label("Oppositional Defiance Disorder Intensity")
      .when("ODD", { is: true, then: Joi.required() }),
    ODDDuration: Joi.string()
      .label("Oppositional Defiance Disorder Duration")
      .when("ODD", { is: true, then: Joi.required() }),
    OCD: Joi.boolean(),
    OCDPresence: Joi.boolean(),
    Obsessions: Joi.boolean(),
    TimeConsuming: Joi.boolean(),
    Compulsions: Joi.boolean(),
    ReduceAnxiety: Joi.boolean(),
    SuppressUrges: Joi.boolean(),
    OCDOther: Joi.boolean(),
    OCDOtherDetails: Joi.string()
      .label("Other Obsessive-Compulsive Disorder Details")
      .when("OCDOther", { is: true, then: Joi.required() }),
    OCDFrequency: Joi.string()
      .label("Obsessive-Compulsive Disorder Frequency")
      .when("OCD", { is: true, then: Joi.required() }),
    OCDIntensity: Joi.string()
      .label("Obsessive-Compulsive Disorder Intensity")
      .when("OCD", { is: true, then: Joi.required() }),
    OCDDuration: Joi.string()
      .label("Obsessive-Compulsive Disorder Duration")
      .when("OCD", { is: true, then: Joi.required() }),
    PanicDisorder: Joi.boolean(),
    PoundingHeart: Joi.boolean(),
    PanicDisorderSweating: Joi.boolean(),
    Trembling: Joi.boolean(),
    ShortnessOfBreath: Joi.boolean(),
    Choking: Joi.boolean(),
    ChestPain: Joi.boolean(),
    PanicDisorderNausea: Joi.boolean(),
    Dizzy: Joi.boolean(),
    Chills: Joi.boolean(),
    Derealization: Joi.boolean(),
    FearOfCrazy: Joi.boolean(),
    FearOfDying: Joi.boolean(),
    PanicDisorderOther: Joi.boolean(),
    PanicDisorderOtherDetails: Joi.string()
      .label("Other Panic Disorder Details")
      .when("PanicDisorderOther", { is: true, then: Joi.required() }),
    PanicDisorderFrequency: Joi.string()
      .label("Panic Disorder Frequency")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    PanicDisorderIntensity: Joi.string()
      .label("Panic Disorder Intensity")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    PanicDisorderDuration: Joi.string()
      .label("Panic Disorder Duration")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    Phobias: Joi.boolean(),
    PhobiasSpecificFear: Joi.boolean(),
    ImmediateFear: Joi.boolean(),
    PhobiasAvoidance: Joi.boolean(),
    FearExaggerated: Joi.boolean(),
    PhobiasOther: Joi.boolean(),
    PhobiasOtherDetails: Joi.string()
      .label("Other Phobia Details")
      .when("PhobiasOther", { is: true, then: Joi.required() }),
    PhobiasFrequency: Joi.string()
      .label("Phobia Frequency")
      .when("Phobias", { is: true, then: Joi.required() }),
    PhobiasIntensity: Joi.string()
      .label("Phobia Intensity")
      .when("Phobias", { is: true, then: Joi.required() }),
    PhobiasDuration: Joi.string()
      .label("Phobia Duration")
      .when("Phobias", { is: true, then: Joi.required() }),
    DI: Joi.boolean(),
    DILowIQ: Joi.boolean(),
    DISensoryImpairments: Joi.boolean(),
    DISpeechDelays: Joi.boolean(),
    DIMotorCoordinationDelays: Joi.boolean(),
    DILearningDisorder: Joi.boolean(),
    DISpatialDelays: Joi.boolean(),
    DevelopmentalImpairmentsOther: Joi.boolean(),
    DevelopmentalImpairmentsOtherDetails: Joi.string()
      .label("Other Developmental Impairments Details")
      .when("DevelopmentalImpairmentsOther", {
        is: true,
        then: Joi.required(),
      }),
    DevelopmentalImpairmentsDetails: Joi.string()
      .label("Developmental Impairments Description")
      .when("DILowIQ", { is: true, then: Joi.required() })
      .when("DISensoryImpairments", { is: true, then: Joi.required() })
      .when("DISpeechDelays", { is: true, then: Joi.required() })
      .when("DIMotorCoordinationDelays", { is: true, then: Joi.required() })
      .when("DILearningDisorder", { is: true, then: Joi.required() })
      .when("DISpatialDelays", { is: true, then: Joi.required() }),
    Bipolar: Joi.boolean(),
    ManicEpisodes: Joi.boolean(),
    DepressiveEpisodes: Joi.boolean(),
    SignificantMoodChanges: Joi.boolean(),
    BipolarOther: Joi.boolean(),
    BipolarOtherDetails: Joi.string().when("BipolarOther", {
      is: true,
      then: Joi.required(),
    }),
    BipolarFrequency: Joi.string().when("Bipolar", {
      is: true,
      then: Joi.required(),
    }),
    BipolarIntensity: Joi.string().when("Bipolar", {
      is: true,
      then: Joi.required(),
    }),
    BipolarDuration: Joi.string().when("Bipolar", {
      is: true,
      then: Joi.required(),
    }),
    Borderline: Joi.boolean(),
    AvoidAbandonment: Joi.boolean(),
    UnstableRelationships: Joi.boolean(),
    IdentityDisturbances: Joi.boolean(),
    Impulsivity: Joi.boolean(),
    RecurrentSelfHarm: Joi.boolean(),
    AffectiveInstability: Joi.boolean(),
    Emptiness: Joi.boolean(),
    PoorAngerManagement: Joi.boolean(),
    ParanoidIdeation: Joi.boolean(),
    BorderlineOther: Joi.boolean(),
    BorderlineOtherDetails: Joi.string().when("BorderlineOther", {
      is: true,
      then: Joi.required(),
    }),
    BorderlineFrequency: Joi.string().when("Borderline", {
      is: true,
      then: Joi.required(),
    }),
    BorderlineIntensity: Joi.string().when("Borderline", {
      is: true,
      then: Joi.required(),
    }),
    BorderlineDuration: Joi.string().when("Borderline", {
      is: true,
      then: Joi.required(),
    }),
    OtherSymptoms: Joi.boolean(),
    OtherSymptomsDetails: Joi.string()
      .label("Other Symptom Details")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsFrequency: Joi.string()
      .label("Other Symptoms Frequency")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsIntensity: Joi.string()
      .label("Other Symptoms Intensity")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsDuration: Joi.string()
      .label("Other Symptoms Duration")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
  },
  "2D0FADFA-83AC-ED11-BF7A-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Salutation: Joi.string().required(),
    Name: Joi.string().required(),
    DischargeDate: Joi.string().required(),
    SuccessfulClosure: Joi.string().required(),
    DischargeReason: Joi.string().when("SuccessfulClosure", {
      is: "No",
      then: Joi.required(),
    }),
    PostRecommendationsNeeded: Joi.string().required(),
    AreasOfGrowth: Joi.string().required(),
    Recommendations: Joi.string().required(),
    MentalHealthServices: Joi.string().required(),
    SignOff: Joi.string().required(),
  },
  "AD7AD76E-11AE-ED11-BF7A-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    CaseNumber: Joi.string().required(),
    GradeLevel: Joi.string().required(),
    AdmissionDate: Joi.string().required(),
    DischargeDate: Joi.string().required(),
    AdmissionLevelOfCare: Joi.string().required(),
    ReasonForAdmission: Joi.string().required(),
    PastPlacements: Joi.string().required(),
    PlacementDisruptions: Joi.string().required(),
    CurrentLivingSituation: Joi.string().required(),
    TypeOfAttachment: Joi.string().required(),
    Siblings: Joi.string().required(),
    HistoryOfAbuse: Joi.string().required(),
    PerpetratorName: Joi.string().allow(""),
    VictimName: Joi.string().allow(""),
    RiskOfHarm: Joi.string().required(),
    SubstanceAbuse: Joi.string().required(),
    LegalInvolvement: Joi.string().required(),
    FunctioningLevel: Joi.string().required(),
    Strengths: Joi.string().required(),
    Challenges: Joi.string().required(),
    SpecialNeeds: Joi.string().required(),
    IQScore: Joi.string().required(),
    PhysicalHealth: Joi.string().required(),
    Hygiene: Joi.string().required(),
    SocialFunctioning: Joi.string().required(),
    SchoolFunctioning: Joi.string().required(),
    CommunicationFunctioning: Joi.string().required(),
    ADLSkills: Joi.string().required(),
    ILSkills: Joi.string().required(),
    Diagnosis: Joi.string().required(),
    DeferredDiagnosis: Joi.string().required(),
    Goals: Joi.string().required(),
    Progress: Joi.string().required(),
    PastMedications: Joi.string().allow(""),
    PracticesUsed: Joi.string().required(),
    EffectiveInterventions: Joi.string().required(),
    Barriers: Joi.string().required(),
    Prognosis: Joi.string().required(),
    DischargeLevelOfCare: Joi.string().required(),
    CurrentMedications: Joi.string().required(),
    DischargedTo: Joi.string().required(),
    MeetPermanency: Joi.string().required(),
    AfterCarePlanNA: Joi.boolean(),
    AfterCarePlanDetails: Joi.string().when("AfterCarePlanNA", {
      is: false,
      then: Joi.required(),
    }),
    PhysicalExam: Joi.string().allow(""),
    DentalExam: Joi.string().allow(""),
    VisionExam: Joi.string().allow(""),
    OtherExam: Joi.string().allow(""),
    ScheduledAppointments: Joi.boolean(),
    ScheduledAppointmentsDetails: Joi.string().when("ScheduledAppointments", {
      is: true,
      then: Joi.required(),
    }),
    ScheduledMeetings: Joi.boolean(),
    ScheduledMeetingsDetails: Joi.string().when("ScheduledMeetings", {
      is: true,
      then: Joi.required(),
    }),
  },
  "80CBB1F7-58B4-ED11-BA77-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SAFYContact: Joi.string().label("SAFY contact").required(),
    DischargeReason: Joi.string().allow("Discharge/transition reason"),
    TimeFrame: Joi.string().allow("Time frame"),
    TransitioningTo: Joi.string().allow("Transition destination"),
    EmotionalDetails: Joi.string().allow("Emotional/behavioral needs"),
    EmotionalPerson: Joi.string().allow(
      "Person assigned to emotional/behavioral needs"
    ),
    EmotionalDone: Joi.boolean(),
    PhysicalDetails: Joi.string().allow("Physical needs"),
    PhysicalPerson: Joi.string().allow("Person assigned to physical needs"),
    PhysicalDone: Joi.boolean(),
    AppointmentsDetails: Joi.string().allow("Appointment needs"),
    AppointmentsPerson: Joi.string().allow(
      "Person assigned to emotional/behavioral needs"
    ),
    AppointmentsDone: Joi.boolean(),
    HotlineDetails: Joi.string().allow("Hotline"),
    HotlinePerson: Joi.string().allow(
      "Person assigned to emotional/behavioral needs"
    ),
    HotlineDone: Joi.boolean(),
    InitialTransportDetails: Joi.string().label(
      "Person transporting child to initial visit"
    ),
    WhereVisitDetails: Joi.string().label("Visit location"),
    VisitLengthDetails: Joi.string().label("Visit duration"),
    TeamMemberPresentDetails: Joi.string().label("Team Member present?"),
    FirstVisitPerson: Joi.string().label("Person assigned to first visit"),
    VisitDone: Joi.boolean(),
    ContactsDetails: Joi.string().label("Number of contacts"),
    OvernightsDetails: Joi.string().label("Are overnights allowed"),
    SubsequentVisitsPerson: Joi.string().label(
      "Person assigned to subsequenct visits"
    ),
    SubsequentVisitsDone: Joi.boolean(),
    WhenInformed: Joi.string().label("When child was informed"),
    WhenInformedPerson: Joi.string().label(
      "Person assigned to informing child"
    ),
    WhenInformedDone: Joi.boolean(),
    TransitionNeedsDetails: Joi.string().label("Transition needs"),
    TransitionNeedsPerson: Joi.string().label(
      "Person assigned to transition needs"
    ),
    TransitionNeedsDone: Joi.boolean(),
    RoutineDetails: Joi.string().label("Routine needs"),
    RoutinePerson: Joi.string().label("Routine helper"),
    RoutineDone: Joi.boolean(),
    WhoHelpsPackDetails: Joi.string().label("Packing helper"),
    WhoHelpsPackPerson: Joi.string().label("Person assigned to packing"),
    WhoHelpsPackDone: Joi.boolean(),
    HelpGoodbyeDetails: Joi.string().label("Farewells helper"),
    HelpGoodbyePerson: Joi.string().label("Person assigned to farewells"),
    HelpGoodbyeDone: Joi.boolean(),
    TransportDetails: Joi.string().label("Transport helper"),
    TransportPerson: Joi.string().label("Person assigned to transportation"),
    TransportDone: Joi.boolean(),
    ChildVisitDetails: Joi.string().label("Contact previous caregiver"),
    RespiteDetails: Joi.string().label("Respite possible"),
    ContactPerson: Joi.string().label(
      "Person assigned to contact with previous caregiver"
    ),
    ContactDone: Joi.boolean(),
    DocumentsDetails: Joi.string().label("Documents provided"),
    DocumentsPerson: Joi.string().label("Person assigned to documents"),
    DocumentsDone: Joi.boolean(),
    EmailDFSDetails: Joi.string().label("Email DFS"),
    EmailDFSPerson: Joi.string().label("Person assigned to email DFS"),
    EmailDFSDone: Joi.boolean(),
    EmailCensusDetails: Joi.string().label("Email NV Census"),
    EmailCensusPerson: Joi.string().label("Person assigned to email NV Census"),
    EmailCensusDone: Joi.boolean(),
  },
  "6B925729-89BF-ED11-BA77-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    DischargeDate: Joi.string().required(),
    DischargeReason: Joi.string().required(),
    PlacementHistory: Joi.string().required(),
    Behavior: Joi.string().required(),
    SocialInteraction: Joi.string().required(),
    ResponseToAuthority: Joi.string().required(),
    SchoolInformation: Joi.string().required(),
    Appointments: Joi.string().required(),
    Summary: Joi.string().required(),
    Recommendations: Joi.string().required(),
    ContactAttempts: Joi.string().allow(""),
  },
  "F5012707-B3C9-ED11-BA77-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    Level: Joi.string().required(),
    DischargeDate: Joi.string().allow(""),
    ContactWithYouth: Joi.string().required(),
    PhoneContactWithFP: Joi.string().required(),
    ContactWithFP: Joi.string().required(),
    PermanencyIssues: Joi.string().required(),
    SummaryOfServices: Joi.string().required(),
    Interventions: Joi.string().required(),
    BehavioralSkills: Joi.string().required(),
    AgeAppropriateBehavior: Joi.string().required(),
    AgeAppropriateBehaviorDetails: Joi.string().when("AgeAppropriateBehavior", {
      is: "No",
      then: Joi.required(),
    }),
    AppropriateInteraction: Joi.string().required(),
    AppropriateInteractionDetails: Joi.string().when("AppropriateInteraction", {
      is: "No",
      then: Joi.required(),
    }),
    IndependentLivingAge: Joi.string().required(),
    Employed: Joi.string().when("IndependentLivingAge", {
      is: "Yes",
      then: Joi.required(),
    }),
    StablePlacement: Joi.string().required(),
    RiskOfDisruption: Joi.string().required(),
    AppropriatePlacement: Joi.string().required(),
    AppropriatePlacementDetails: Joi.string().when("AppropriatePlacement", {
      is: "No",
      then: Joi.required(),
    }),
    HealthConcerns: Joi.string().required(),
    HealthConcernsDetails: Joi.string().when("HealthConcerns", {
      is: "Yes",
      then: Joi.required(),
    }),
    TherapyAppointments: Joi.string().required(),
    DoctorVisits: Joi.string().required(),
    OtherAppointments: Joi.string().required(),
    CurrentMedications: Joi.string().required(),
    CriticalIncident: Joi.string().required(),
    AWOLDates: Joi.string().allow(""),
    AWOLDetails: Joi.string().allow(""),
    AttemptedSuicideDates: Joi.string().allow(""),
    AttemptedSuicideDetails: Joi.string().allow(""),
    EmergencyPlacementDates: Joi.string().allow(""),
    EmergencyPlacementDetails: Joi.string().allow(""),
    EmergencyAssessmentDates: Joi.string().allow(""),
    EmergencyAssessmentDetails: Joi.string().allow(""),
    EmergencyTreatmentDates: Joi.string().allow(""),
    EmergencyTreatmentDetails: Joi.string().allow(""),
    WeaponPossessionDates: Joi.string().allow(""),
    WeaponPossessionDetails: Joi.string().allow(""),
    SubstancePossessionDates: Joi.string().allow(""),
    SubstancePossessionDetails: Joi.string().allow(""),
    SchoolRemovalDates: Joi.string().allow(""),
    SchoolRemovalDetails: Joi.string().allow(""),
    OutsideAgencyDates: Joi.string().allow(""),
    OutsideAgencyDetails: Joi.string().allow(""),
    OtherIssues: Joi.string().required(),
    GradeLevel: Joi.string().required(),
    IEP504Plan: Joi.string().required(),
    IEP504PlanNeeded: Joi.string().when("IEP504Plan", {
      is: "No",
      then: Joi.required(),
    }),
    BehavioralIssues: Joi.string().required(),
    Expulsion: Joi.string().when("BehavioralIssues", {
      is: "Yes",
      then: Joi.required(),
    }),
    OtherInformation: Joi.string().required(),
    StaffAbuse: Joi.string().required(),
    NonStaffAbuse: Joi.string().required(),
    VisitationPlan: Joi.string().required(),
    VisitationFrequency: Joi.string().when("VisitationPlan", {
      is: "Yes",
      then: Joi.required(),
    }),
    VisitationGoal: Joi.string().when("VisitationPlan", {
      is: "Yes",
      then: Joi.required(),
    }),
    Runaway: Joi.string().required(),
    StableEducation: Joi.string().required(),
    FPAbility: Joi.string().required(),
    DecreasedNeeds: Joi.string().required(),
    UnplannedDischarge: Joi.string().required(),
    LengthOfStay: Joi.string().when("UnplannedDischarge", {
      is: "Yes",
      then: Joi.required(),
    }),
    DSSRequest: Joi.string().required(),
    Acknowledged: Joi.boolean(),
    AcknowledgedDateTime: Joi.string().when("Acknowledged", {
      is: "true",
      then: Joi.required(),
    }),
  },
  "3AA58652-53D9-ED11-800F-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    SessionDate: Joi.string().required(),
    SessionTime: Joi.string().required(),
    SessionLength: Joi.string().required(),
    ContactType: Joi.string().required(),
    ContactTypeOtherDetails: Joi.string().when("ContactType", {
      is: "Other",
      then: Joi.required(),
    }),
    IndividualsPresent: Joi.string().required(),
    SessionLocation: Joi.string().required(),
    ExpectedInAttendance: Joi.string().required(),
    IndividualsNotPresent: Joi.string().when("ExpectedInAttendance", {
      is: "No",
      then: Joi.required(),
    }),
    Therapist: Joi.string().required(),
    Videotaped: Joi.string().required(),
    SessionNumber: Joi.string().when("Videotaped", {
      is: "Yes",
      then: Joi.required(),
    }),
    SeatingMap: Joi.string().when("Videotaped", {
      is: "Yes",
      then: Joi.required(),
    }),
    AdditionalNotes: Joi.string().when("Videotaped", {
      is: "Yes",
      then: Joi.required(),
    }),
    PresentingProblem: Joi.string().when("ContactType", {
      is: "Therapy Session",
      then: Joi.required(),
    }),
    NextSessionScheduled: Joi.string().when("ContactType", {
      is: "Therapy Session",
      then: Joi.required(),
    }),
    NotScheduledDetails: Joi.string().when("NextSessionScheduled", {
      is: "No",
      then: Joi.required(),
    }),
    Diagnoses: Joi.when("ContactType", {
      is: "Therapy Session",
      then: Joi.array().items(
        Joi.object({
          _id: Joi.any(),
          CodeType: Joi.string().required(),
          CodeValue: Joi.string().required(),
          CodeText: Joi.string().required(),
          Severity: Joi.string().required(),
          Focus: Joi.string().required(),
          TreatmentPlan: Joi.string().required(),
          Errors: Joi.any(),
          IsEditable: Joi.boolean(),
        })
      ),
    }),
    ProgressNotesNA: Joi.boolean(),
    ProgressNotes: Joi.when("ContactType", {
      is: "Therapy Session",
      then: Joi.when("ProgressNotesNA", {
        is: false,
        then: Joi.array()
          .min(1)
          .items(
            Joi.object({
              _id: Joi.any(),
              Interaction: Joi.string().required(),
              Highlight: Joi.string().required(),
              Reframe: Joi.string().required(),
              Task: Joi.string().required(),
              Changes: Joi.string().required(),
              Errors: Joi.any(),
              IsEditable: Joi.boolean(),
            })
          ),
      }),
    }),
    SessionDescription: Joi.string().when("ProgressNotesNA", {
      is: true,
      then: Joi.required(),
    }),
    AdditionalComments: Joi.string().allow(""),
  },
  "70A70874-92E0-ED11-800F-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    FosterFamilyName: Joi.string().required(),
    DateOfAssessment: Joi.string().required(),
    VocationalEmployed: Joi.boolean(),
    VocationalTemporary: Joi.boolean(),
    VocationalUnemployed: Joi.boolean(),
    VocationalUnable: Joi.boolean(),
    VocationalNotes: Joi.string().allow(""),
    SupportSystemReliable: Joi.boolean(),
    SupportSystemQuestionable: Joi.boolean(),
    SupportSystemDuringCrisis: Joi.boolean(),
    SupportSystemNone: Joi.boolean(),
    SupportSystemNotes: Joi.string().allow(""),
    PhysicalHealthAsymptomatic: Joi.boolean(),
    PhysicalHealthMinimal: Joi.boolean(),
    PhysicalHealthModerate: Joi.boolean(),
    PhysicalHealthSignificant: Joi.boolean(),
    PhysicalHealthNotes: Joi.string().allow(""),
    NutritionPoor: Joi.boolean(),
    NutritionFair: Joi.boolean(),
    NutritionWellBalanced: Joi.boolean(),
    NutritionHealthy: Joi.boolean(),
    NutritionNotes: Joi.string().allow(""),
    TraumaNoneReported: Joi.boolean(),
    TraumaMinimal: Joi.boolean(),
    TraumaModerate: Joi.boolean(),
    TraumaSignificant: Joi.boolean(),
    TraumaNotes: Joi.string().allow(""),
    MentalHealthNoHistory: Joi.boolean(),
    MentalHealthTreatment: Joi.boolean(),
    MentalHealthFailedTreatment: Joi.boolean(),
    MentalHealthSerious: Joi.boolean(),
    MentalHealthNotes: Joi.string().allow(""),
    SubstanceAbuseNever: Joi.boolean(),
    SubstanceAbusePriorTreatment: Joi.boolean(),
    SubstanceAbusePeriodic: Joi.boolean(),
    SubstanceAbuseFrequent: Joi.boolean(),
    SubstanceAbuseNotes: Joi.string().allow(""),
    SchoolIssuesNone: Joi.boolean(),
    SchoolIssuesMinimal: Joi.boolean(),
    SchoolIssuesModerate: Joi.boolean(),
    SchoolIssuesSignificant: Joi.boolean(),
    SchoolIssuesNotes: Joi.string().allow(""),
    BasicNeedsIndependent: Joi.boolean(),
    BasicNeedsSomeAssistance: Joi.boolean(),
    BasicNeedsLimited: Joi.boolean(),
    BasicNeedsUnable: Joi.boolean(),
    BasicNeedsNotes: Joi.string().allow(""),
    OtherAgencyLinkagesNone: Joi.boolean(),
    OtherAgencyLinkagesInadequate: Joi.boolean(),
    OtherAgencyLinkagesBarriers: Joi.boolean(),
    OtherAgencyLinkagesProblems: Joi.boolean(),
    OtherAgencyLinkagesNotes: Joi.string().allow(""),
    OtherDimension: Joi.string().allow(""),
    OtherDimensionNotes: Joi.string().allow(""),
    Diagnosis: Joi.string().required(),
    Allergies: Joi.string().allow(""),
    Medications: Joi.string().allow(""),
    PermanencyPlan: Joi.string().required(),
    Needs: Joi.string().required(),
  },
  "53F1063F-A3E3-ED11-800F-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    AdmissionDate: Joi.string().required(),
    DischargeDate: Joi.string().required(),
    PlacementSummary: Joi.string().required(),
    FollowUpAppointments: Joi.string().allow(""),
    BeneficiarySummary: Joi.string().required(),
    ContactAttempts: Joi.string().allow(""),
    DischargeReason: Joi.string().required(),
  },
  "84FA7717-95BF-ED11-BA77-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    Month: Joi.string().required(),
    Year: Joi.string().required(),
    DateOfDischarge: Joi.string().allow(""),
    ContactWithYouth: Joi.string().required(),
    PhoneContactWithFP: Joi.string().required(),
    ContactWithFP: Joi.string().required(),
    PermanencyActivity: Joi.string().required(),
    PermanencyActivityDetails: Joi.string().when("PermanencyActivity", {
      is: "Yes",
      then: Joi.required(),
    }),
    AgeAppropriateBehavior: Joi.string().required(),
    AgeAppropriateBehaviorDetails: Joi.string().when("AgeAppropriateBehavior", {
      is: "No",
      then: Joi.required(),
    }),
    AppropriateInteraction: Joi.string().required(),
    AppropriateInteractionDetails: Joi.string().when("AppropriateInteraction", {
      is: "No",
      then: Joi.required(),
    }),
    IndependentLivingAge: Joi.string().required(),
    ILGoal: Joi.string().when("IndependentLivingAge", {
      is: "Yes",
      then: Joi.required(),
    }),
    StablePlacement: Joi.string().required(),
    RiskOfDisruption: Joi.string().required(),
    HealthConcerns: Joi.string().required(),
    HealthConcernsDetails: Joi.string().when("HealthConcerns", {
      is: "Yes",
      then: Joi.required(),
    }),
    TherapyAppointments: Joi.string().required(),
    DoctorVisits: Joi.string().required(),
    OtherAppointments: Joi.string().required(),
    CurrentMedications: Joi.string().required(),
    CriticalIncident: Joi.string().required(),
    AWOLDates: Joi.string().allow(""),
    AWOLDetails: Joi.string().allow(""),
    AttemptedSuicideDates: Joi.string().allow(""),
    AttemptedSuicideDetails: Joi.string().allow(""),
    EmergencyPlacementDates: Joi.string().allow(""),
    EmergencyPlacementDetails: Joi.string().allow(""),
    EmergencyAssessmentDates: Joi.string().allow(""),
    EmergencyAssessmentDetails: Joi.string().allow(""),
    EmergencyTreatmentDates: Joi.string().allow(""),
    EmergencyTreatmentDetails: Joi.string().allow(""),
    WeaponPossessionDates: Joi.string().allow(""),
    WeaponPossessionDetails: Joi.string().allow(""),
    SubstancePossessionDates: Joi.string().allow(""),
    SubstancePossessionDetails: Joi.string().allow(""),
    SchoolRemovalDates: Joi.string().allow(""),
    SchoolRemovalDetails: Joi.string().allow(""),
    OutsideAgencyDates: Joi.string().allow(""),
    OutsideAgencyDetails: Joi.string().allow(""),
    OtherIssues: Joi.string().required(),
    GradeLevel: Joi.string().required(),
    IEP504Plan: Joi.string().required(),
    IEP504PlanNeeded: Joi.string().when("IEP504Plan", {
      is: "No",
      then: Joi.required(),
    }),
    BehavioralIssues: Joi.string().required(),
    Expulsion: Joi.string().required(),
    OtherInformation: Joi.string().required(),
  },
  "68AE877C-ECF8-ED11-800F-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    CareTeam: Joi.string().allow(""),
    Diagnoses: Joi.string().allow(""),
    PresentingProblem: Joi.string().allow(""),
    ContactPlan: Joi.string().allow(""),
    CulturalNarrative: Joi.string().allow(""),
    SafetyPlan: Joi.string().allow(""),
    PlanReviewed: Joi.string().allow(""),
    ContractType: Joi.string().allow(""),
    NextCarePlanDate: Joi.string().allow(""),
    BioVisits: Joi.string().allow(""),
    BioVisitsDetails: Joi.string().allow(""),
    MedicalIssues: Joi.string().allow(""),
    Medications: Joi.string().allow(""),
    Psychiatrist: Joi.string().allow(""),
    PsychiatristName: Joi.string().allow(""),
    UpcomingAppts: Joi.string().allow(""),
    SchoolInfo: Joi.string().allow(""),
    Triggers: Joi.string().allow(""),
    DeescalateTechniques: Joi.string().allow(""),
    UnnoticedBehaviors: Joi.string().allow(""),
    FPPositives: Joi.string().allow(""),
    FPTechniques: Joi.string().allow(""),
  },
  "7475B2EF-4AFA-ED11-800F-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    ClientName: Joi.string().required(),
    PreferredName: Joi.string().required(),
    DOB: Joi.string().required(),
    SSNumber: Joi.string().required(),
    DateOfAdmission: Joi.string().required(),
    Sex: Joi.string().required(),
    Gender: Joi.string().required(),
    SexualOrientation: Joi.string().required(),
    Height: Joi.string().required(),
    Weight: Joi.string().required(),
    Agency: Joi.string().required(),
    ProgramName: Joi.string().required(),
    CompletedBy: Joi.string().required(),
    DateCompleted: Joi.string().required(),
    Telephone: Joi.string().required(),
    Extension: Joi.string().required(),
    Email: Joi.string().required(),
    StartMonth: Joi.string().required(),
    StartDay: Joi.string().required(),
    StartYear: Joi.string().required(),
    EndMonth: Joi.string().required(),
    EndDay: Joi.string().required(),
    EndYear: Joi.string().required(),
    FosterCareNA: Joi.boolean(),
    FosterFamily: Joi.string().when("FosterCareNA", {
      is: false,
      then: Joi.required(),
    }),
    PlacementChangesNA: Joi.boolean(),
    PlacementChangesDetails: Joi.string().when("FosterCareNA", {
      is: false,
      then: Joi.required(),
    }),
    StateWorker: Joi.string().required(),
    County: Joi.string().required(),
    Strengths: Joi.string().required(),
    TreatmentPlanAttached: Joi.boolean(),
    CANSAttached: Joi.boolean(),
    PSDAttached: Joi.boolean(),
    RiskBehaviorsNA: Joi.boolean(),
    AnimalAbuseNA: Joi.boolean(),
    AnimalAbuseDates: Joi.string().when("AnimalAbuse", {
      is: false,
      then: Joi.required(),
    }),
    AnimalAbuseDetails: Joi.string().when("AnimalAbuse", {
      is: false,
      then: Joi.required(),
    }),
    BullyingNA: Joi.boolean(),
    BullyingDates: Joi.string().when("Bullying", {
      is: false,
      then: Joi.required(),
    }),
    BullyingDetails: Joi.string().when("Bullying", {
      is: false,
      then: Joi.required(),
    }),
    DelinquentNA: Joi.boolean(),
    DelinquentDates: Joi.string().when("DelinquentNA", {
      is: false,
      then: Joi.required(),
    }),
    DelinquentDetails: Joi.string().when("DelinquentNA", {
      is: false,
      then: Joi.required(),
    }),
    DestroyPropertyNA: Joi.boolean(),
    DestroyPropertyDates: Joi.string().when("DestroyPropertyNA", {
      is: false,
      then: Joi.required(),
    }),
    DestroyPropertyDetails: Joi.string().when("DestroyPropertyNA", {
      is: false,
      then: Joi.required(),
    }),
    ArsonistNA: Joi.boolean(),
    ArsonistDates: Joi.string().when("ArsonistNA", {
      is: false,
      then: Joi.required(),
    }),
    ArsonistDetails: Joi.string().when("ArsonistNA", {
      is: false,
      then: Joi.required(),
    }),
    GangAffiliationNA: Joi.boolean(),
    GangAffiliationDates: Joi.string().when("GangAffiliationNA", {
      is: false,
      then: Joi.required(),
    }),
    GangAffiliationDetails: Joi.string().when("GangAffiliationNA", {
      is: false,
      then: Joi.required(),
    }),
    HomicidalNA: Joi.boolean(),
    HomicidalDates: Joi.string().when("HomicidalNA", {
      is: false,
      then: Joi.required(),
    }),
    HomicidalDetails: Joi.string().when("HomicidalNA", {
      is: false,
      then: Joi.required(),
    }),
    NonCompliantNA: Joi.boolean(),
    NonCompliantDates: Joi.string().when("NonCompliantNA", {
      is: false,
      then: Joi.required(),
    }),
    NonCompliantDetails: Joi.string().when("NonCompliantNA", {
      is: false,
      then: Joi.required(),
    }),
    HarmOthersNA: Joi.boolean(),
    HarmOthersDates: Joi.string().when("HarmOthersNA", {
      is: false,
      then: Joi.required(),
    }),
    HarmOthersDetails: Joi.string().when("HarmOthersNA", {
      is: false,
      then: Joi.required(),
    }),
    RecklessNA: Joi.boolean(),
    RecklessDates: Joi.string().when("Reckless", {
      is: false,
      then: Joi.required(),
    }),
    RecklessDetails: Joi.string().when("Reckless", {
      is: false,
      then: Joi.required(),
    }),
    RunawayNA: Joi.boolean(),
    RunawayDates: Joi.string().when("Runaway", {
      is: false,
      then: Joi.required(),
    }),
    RunawayDetails: Joi.string().when("Runaway", {
      is: false,
      then: Joi.required(),
    }),
    SelfAbusiveNA: Joi.boolean(),
    SelfAbusiveDates: Joi.string().when("SelfAbusiveNA", {
      is: false,
      then: Joi.required(),
    }),
    SelfAbusiveDetails: Joi.string().when("SelfAbusiveNA", {
      is: false,
      then: Joi.required(),
    }),
    SexualBehaviorsNA: Joi.boolean(),
    SexualBehaviorsDates: Joi.string().when("SexualBehaviorsNA", {
      is: false,
      then: Joi.required(),
    }),
    SexualBehaviorsDetails: Joi.string().when("SexualBehaviorsNA", {
      is: false,
      then: Joi.required(),
    }),
    SubstanceAbuseNA: Joi.boolean(),
    SubstanceAbuseDates: Joi.string().when("SubstanceAbuseNA", {
      is: false,
      then: Joi.required(),
    }),
    SubstanceAbuseDetails: Joi.string().when("SubstanceAbuseNA", {
      is: false,
      then: Joi.required(),
    }),
    SuicidalNA: Joi.boolean(),
    SuicidalDates: Joi.string().when("SuicidalNA", {
      is: false,
      then: Joi.required(),
    }),
    SuicidalDetails: Joi.string().when("SuicidalNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherBehaviorNA: Joi.boolean(),
    OtherBehaviorDates: Joi.string().when("OtherBehaviorNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherBehaviorDetails: Joi.string().when("OtherBehaviorNA", {
      is: false,
      then: Joi.required(),
    }),
    SocialNA: Joi.boolean(),
    AngerControlNA: Joi.boolean(),
    AngerControlDetails: Joi.string().when("AngerControlNA", {
      is: false,
      then: Joi.required(),
    }),
    AnxietyNA: Joi.boolean(),
    AnxietyDetails: Joi.string().when("AnxietyNA", {
      is: false,
      then: Joi.required(),
    }),
    AttachmentNA: Joi.boolean(),
    AttachmentDetails: Joi.string().when("AttachmentNA", {
      is: false,
      then: Joi.required(),
    }),
    AttentionNA: Joi.boolean(),
    AttentionDetails: Joi.string().when("AttentionNA", {
      is: false,
      then: Joi.required(),
    }),
    DepressionNA: Joi.boolean(),
    DepressionDetails: Joi.string().when("DepressionNA", {
      is: false,
      then: Joi.required(),
    }),
    EatingDisturbancesNA: Joi.boolean(),
    EatingDisturbancesDetails: Joi.string().when("EatingDisturbancesNA", {
      is: false,
      then: Joi.required(),
    }),
    DefiantNA: Joi.boolean(),
    DefiantDetails: Joi.string().when("DefiantNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychosisNA: Joi.boolean(),
    PsychosisDetails: Joi.string().when("PsychosisNA", {
      is: false,
      then: Joi.required(),
    }),
    SomatizationNA: Joi.boolean(),
    SomatizationDetails: Joi.string().when("SomatizationNA", {
      is: false,
      then: Joi.required(),
    }),
    TantrumsNA: Joi.boolean(),
    TantrumsDetails: Joi.string().when("TantrumsNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherSocialNA: Joi.boolean(),
    OtherSocialDetails: Joi.string().when("OtherSocialNA", {
      is: false,
      then: Joi.required(),
    }),
    InterventionNA: Joi.boolean(),
    PsychiatricHospitalizationNA: Joi.boolean(),
    PsychiatricHospitalizationProvider: Joi.string().when(
      "PsychiatricHospitalizationNA",
      { is: false, then: Joi.required() }
    ),
    PsychiatricHospitalizationReason: Joi.string().when(
      "PsychiatricHospitalizationNA",
      { is: false, then: Joi.required() }
    ),
    PsychiatricHospitalizationDates: Joi.string().when(
      "PsychiatricHospitalizationNA",
      { is: false, then: Joi.required() }
    ),
    CrisisStabilizationNA: Joi.boolean(),
    CrisisStabilizationProvider: Joi.string().when("CrisisStabilizationNA", {
      is: false,
      then: Joi.required(),
    }),
    CrisisStabilizationReason: Joi.string().when("CrisisStabilizationNA", {
      is: false,
      then: Joi.required(),
    }),
    CrisisStabilizationDates: Joi.string().when("CrisisStabilizationNA", {
      is: false,
      then: Joi.required(),
    }),
    MedicalHospitalizationNA: Joi.boolean(),
    MedicalHospitalizationProvider: Joi.string().when(
      "MedicalHospitalizationNA",
      {
        is: false,
        then: Joi.required(),
      }
    ),
    MedicalHospitalizationReason: Joi.string().when(
      "MedicalHospitalizationNA",
      {
        is: false,
        then: Joi.required(),
      }
    ),
    MedicalHospitalizationDates: Joi.string().when("MedicalHospitalizationNA", {
      is: false,
      then: Joi.required(),
    }),
    TimeOutNA: Joi.boolean(),
    TimeOutReason: Joi.string().when("TimeOutNA", {
      is: false,
      then: Joi.required(),
    }),
    TimeOutUtilized: Joi.string().when("TimeOutNA", {
      is: false,
      then: Joi.required(),
    }),
    PhysicalManagementNA: Joi.boolean(),
    PhysicalManagementReason: Joi.string().when("PhysicalManagementNA", {
      is: false,
      then: Joi.required(),
    }),
    PhysicalManagementUtilized: Joi.string().when("PhysicalManagementNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherPhysicalInterventionNA: Joi.boolean(),
    OtherPhysicalInterventionReason: Joi.string().when(
      "OtherPhysicalInterventionNA",
      {
        is: false,
        then: Joi.required(),
      }
    ),
    OtherPhysicalInterventionUtilized: Joi.string().when(
      "OtherPhysicalInterventionNA",
      {
        is: false,
        then: Joi.required(),
      }
    ),
    AssistanceNA: Joi.boolean(),
    AssistanceReason: Joi.string().when("AssistanceNA", {
      is: false,
      then: Joi.required(),
    }),
    AssistanceUtilized: Joi.string().when("AssistanceNA", {
      is: false,
      then: Joi.required(),
    }),
    InvoluntaryConfinementNA: Joi.boolean(),
    InvoluntaryConfinementReason: Joi.string().when(
      "InvoluntaryConfinementNA",
      { is: false, then: Joi.required() }
    ),
    InvoluntaryConfinementUtilized: Joi.string().when(
      "InvoluntaryConfinementNA",
      {
        is: false,
        then: Joi.required(),
      }
    ),
    OtherInterventionNA: Joi.boolean(),
    OtherInterventionDetails: Joi.string().when("OtherInterventionNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherInterventionProvider: Joi.string().when("OtherInterventionNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherInterventionReason: Joi.string().when("OtherInterventionNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherInterventionUtilized: Joi.string().when("OtherInterventionNA", {
      is: false,
      then: Joi.required(),
    }),
    SupervisionDetails: Joi.string().required(),
    SupervisionPlan: Joi.string().required(),
    MedicalNA: Joi.boolean(),
    MedicalTreatment: Joi.string().when("MedicalNA", {
      is: false,
      then: Joi.required(),
    }),
    MedicationsNA: Joi.boolean(),
    Medications: Joi.string().when("MedicationsNA", {
      is: false,
      then: Joi.required(),
    }),
    MentalHealthNA: Joi.boolean(),
    CurrentDiagnoses: Joi.string().when("MentalHealthNA", {
      is: false,
      then: Joi.required(),
    }),
    ChangeInDiagnosis: Joi.string().when("MentalHealthNA", {
      is: false,
      then: Joi.required(),
    }),
    ReasonForChange: Joi.string().when("ChangeInDiagnosis", {
      is: "Yes",
      then: Joi.required(),
    }),
    TraumaNA: Joi.boolean(),
    TraumaReported: Joi.string().when("TraumaNA", {
      is: false,
      then: Joi.required(),
    }),
    TraumaReportDate: Joi.string().when("TraumaReported", {
      is: "Yes",
      then: Joi.required(),
    }),
    TraumaIssues: Joi.string().when("TraumaReported", {
      is: "Yes",
      then: Joi.required(),
    }),
    ServicesProvidedNA: Joi.boolean(),
    CaseManagementSessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    CaseManagementAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    CaseManagementProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    CaseManagementCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndividualTherapyContract: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndividualTherapySessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndividualTherapyAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndividualTherapyProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndividualTherapyCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndividualTherapyQMHPOnly: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    FamilyTherapyMembers: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    FamilyTherapySessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    FamilyTherapyAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    FamilyTherapyProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    FamilyTherapyCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    FamilyTherapyQMHPOnly: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    GroupTherapySessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    GroupTherapyAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    GroupTherapyProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    GroupTherapyCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    GroupTherapyQMHPOnly: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychoeducationTherapySessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychoeducationTherapyAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychoeducationTherapyProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychoeducationTherapyCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychiatricSessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychiatricAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychiatricProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PsychiatricCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SubstanceAbuseSessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SubstanceAbuseAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SubstanceAbuseProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SubstanceAbuseCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    ExploitationSessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    ExploitationAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    ExploitationProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    ExploitationCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SexualOffenderSessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SexualOffenderAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SexualOffenderProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SexualOffenderCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SexuallyReactiveSessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SexuallyReactiveAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SexuallyReactiveProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    SexuallyReactiveCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndependentLivingSessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndependentLivingAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndependentLivingProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    IndependentLivingCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherServicesProvided: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherServicesProvidedSessions: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherServicesProvidedAgency: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherServicesProvidedProvider: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    OtherServicesProvidedCredentials: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    PCCAgreementNA: Joi.boolean(),
    PCCAgreementReason: Joi.string().when("PCCAgreement", {
      is: false,
      then: Joi.required(),
    }),
    TherapeuticException: Joi.string().when("ServicesProvidedNA", {
      is: false,
      then: Joi.required(),
    }),
    TherapeuticExceptionDate: Joi.string().when("TherapeuticException", {
      is: "Y",
      then: Joi.required(),
    }),
    QMHPNA: Joi.boolean(),
    QMHPExplanation: Joi.when("ServicesProvidedNA", {
      is: false,
      then: Joi.string().when("QMHPNA", { is: false, then: Joi.required() }),
    }),
    SchoolAndDistrict: Joi.string().required(),
    CurrentGrade: Joi.string().required(),
    Preschool: Joi.boolean(),
    DayTreatment: Joi.boolean(),
    PrivateSchool: Joi.boolean(),
    College: Joi.boolean(),
    AlternativeSchool: Joi.boolean(),
    Vocational: Joi.boolean(),
    PublicSchool: Joi.boolean(),
    CampusOnsite: Joi.boolean(),
    PublicOffsite: Joi.boolean(),
    GED: Joi.boolean(),
    OtherSchoolSetting: Joi.boolean(),
    OtherSchoolSettingDetails: Joi.string().when("OtherSchoolSetting", {
      is: true,
      then: Joi.required(),
    }),
    SpecialEd: Joi.string().required(),
    SpecialEdServices: Joi.string().when("SpecialEd", {
      is: "Y",
      then: Joi.required(),
    }),
    SpecialEdDisability: Joi.string().when("SpecialEd", {
      is: "Y",
      then: Joi.required(),
    }),
    Grades: Joi.string().required(),
    SchoolBehavior: Joi.string().required(),
    OtherFunctioningDetails: Joi.string().required(),
    RelationshipDetails: Joi.string().required(),
    Responsibilities: Joi.string().required(),
    ReceiveILServices: Joi.string().required(),
    ILServicesDetails: Joi.string().when("ReceiveILServices", {
      is: "Yes",
      then: Joi.required(),
    }),
    DevelopmentalConcernsNA: Joi.boolean(),
    DevelopmentalConcerns: Joi.string().when("DevelopmentalConcernsNA", {
      is: false,
      then: Joi.required(),
    }),
    ParentingNA: Joi.boolean(),
    Pregnant: Joi.string().when("ParentingNA", {
      is: false,
      then: Joi.required(),
    }),
    DueDate: Joi.string().when("Pregnant", { is: "Yes", then: Joi.required() }),
    ChildrenDetails: Joi.string().when("ParentingNA", {
      is: false,
      then: Joi.required(),
    }),
    PregnancyComplications: Joi.when("ParentingNA", {
      is: false,
      then: Joi.when("Pregnant", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    ParentingSkills: Joi.string().when("ParentingNA", {
      is: false,
      then: Joi.required(),
    }),
    LegalNA: Joi.boolean(),
    LegalIssues: Joi.string().when("LegalNA", {
      is: false,
      then: Joi.required(),
    }),
    PermanencyGoal: Joi.string().required(),
    RightsNA: Joi.boolean(),
    RightsEndDate: Joi.string().when("RightsNA", {
      is: false,
      then: Joi.required(),
    }),
    PermanencyServices: Joi.string().required(),
    DischargePlan: Joi.string().required(),
    ProjectedDischargeDate: Joi.string().required(),
    VisitationNA: Joi.boolean(),
    FamilyEngagement: Joi.string().when("VisitationNA", {
      is: false,
      then: Joi.required(),
    }),
    FamilyProgress: Joi.string().when("VisitationNA", {
      is: false,
      then: Joi.required(),
    }),
    VisitationsDetails: Joi.string().when("VisitationNA", {
      is: false,
      then: Joi.required(),
    }),
    IndependentLivingNA: Joi.boolean(),
    SkillsLevelNA: Joi.boolean(),
    SkillsLevel: Joi.when("IndependentLivingNA", {
      is: false,
      then: Joi.string().when("SkillsLevelNA", {
        is: false,
        then: Joi.required(),
      }),
    }),
    EmploymentNA: Joi.boolean(),
    EmploymentDetails: Joi.when("IndependentLivingNA", {
      is: false,
      then: Joi.string().when("EmploymentNA", {
        is: false,
        then: Joi.required(),
      }),
    }),
    LivingArrangementNA: Joi.boolean(),
    LivingArrangement: Joi.when("IndependentLivingNA", {
      is: false,
      then: Joi.string().when("LivingArrangementNA", {
        is: false,
        then: Joi.required(),
      }),
    }),
    AdditionalConcernsNA: Joi.boolean(),
    AdditionalConcerns: Joi.string().when("AdditionalConcernsNA", {
      is: false,
      then: Joi.required(),
    }),
  },
  "D9776A73-63FA-ED11-800F-0050F21C653C": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    AssessmentDetails: Joi.string().required(),
  },
  "E9D4CD69-63FA-ED11-800F-0050F21C653C": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    AssessmentDetails: Joi.string().required(),
  },
  "A7C97FD2-2DFF-ED11-800F-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    DateOfIncident: Joi.string().required(),
    TimeOfIncident: Joi.string().required(),
    FosterHome: Joi.string().required(),
    NotifiedOn: Joi.string().required(),
    NotifiedBy: Joi.string().required(),
    NotifiedByOther: Joi.when("NotifiedBy", {
      is: "Other",
      then: Joi.string().required(),
    }),
    NotifiedMethod: Joi.string().required(),
    NotifiedMethodOther: Joi.when("NotifiedMethod", {
      is: "Other",
      then: Joi.string().required(),
    }),
    TypeOfIncident: Joi.string().required(),
    AbuseInHomeAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.when("AbuseInHomeAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseInHomeAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeNA: Joi.boolean(),
    AbuseInHomeDate: Joi.string().allow(""),
    AbuseInHomeTime: Joi.string().allow(""),
    AbuseInHomeNotes: Joi.string().allow(""),
    AbuseInHomeNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.when("AbuseInHomeNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseInHomeStepsTaken: Joi.string().allow(""),
    AbuseInHomeOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.when("AbuseOutsideHomeAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseOutsideHomeAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeNA: Joi.boolean(),
    AbuseOutsideHomeDate: Joi.string().allow(""),
    AbuseOutsideHomeTime: Joi.string().allow(""),
    AbuseOutsideHomeNotes: Joi.string().allow(""),
    AbuseOutsideHomeNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.when("AbuseOutsideHomeNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseOutsideHomeStepsTaken: Joi.string().allow(""),
    AbuseOutsideHomeOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AWOLDescription: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLLocated: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLPoliceReport: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    AWOLDepartment: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLReportNumber: Joi.string().allow(""),
    AWOLOfficer: Joi.string().allow(""),
    AWOLNoReportReason: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLOutcome: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathClient: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWho: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathClient", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathInvestigation: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhere: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhereOther: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    DeathDescription: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathPoliceReport: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathReportedBy: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathReportInfo: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathNoReportReason: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathStepsTaken: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastDate: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastTime: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjury: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("HomicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsNA: Joi.boolean(),
    HomicidalThoughtsDate: Joi.string().allow(""),
    HomicidalThoughtsTime: Joi.string().allow(""),
    RestraintAppliedBy: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintAppliedByOther: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintAppliedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    RestraintLength: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintType: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintDescription: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInterventions: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInjury: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInjuryDetails: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    RestraintWellbeing: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintFollowup: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintModifications: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintObservation: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInvestigation: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintOutcome: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    MedicationRefusalDescription: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalSymptoms: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalSymptomDescription: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.when("MedicationRefusalSymptoms", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationRefusalChronic: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.when("MedicationRefusalChronic", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorType: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorResponsible: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorResponsibleOther: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.when("MedicationErrorResponsible", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorDescription: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorSymptoms: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorSymptomDescription: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.when("MedicationErrorSymptoms", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorInvestigation: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyDescription: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyOutcome: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencySafetyPlan: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    PsychiatricEmergencyNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("PsychiatricEmergencySafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    PsychiatricEmergencyNA: Joi.boolean(),
    PsychiatricEmergencyDate: Joi.string().allow(""),
    PsychiatricEmergencyTime: Joi.string().allow(""),
    MedicalAttentionDescription: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionOutcome: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.when("MedicalAttentionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicalAttentionNA: Joi.boolean(),
    MedicalAttentionDate: Joi.string().allow(""),
    MedicalAttentionTime: Joi.string().allow(""),
    MedicalAttentionChronic: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.when("MedicalAttentionChronic", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsWhere: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsWhereOther: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsStepsTaken: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistory: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsFollowUp: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsOutcome: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsWhere: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsWhereOther: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsIEP: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsPrevention: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsIEP", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsSupport: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsIEP", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsOutcomeDetention: Joi.boolean(),
    ProblematicBehaviorsOutcomeSuspension: Joi.boolean(),
    ProblematicBehaviorsOutcomeExpulsion: Joi.boolean(),
    ProblematicBehaviorsOutcomeSafetyPlan: Joi.boolean(),
    ProblematicBehaviorsOutcomeIEP: Joi.boolean(),
    ProblematicBehaviorsOutcomeOther: Joi.boolean(),
    ProblematicBehaviorsOutcomeOtherDetails: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsOutcomeOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsSuicidal: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.string().required(),
    }),
    SelfHarmBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjury: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsInjury", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsChronic: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsChronic", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsCSSRs: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsNoCSSRsReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsCSSRs", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsNA: Joi.boolean(),
    SuicidalThoughtsDate: Joi.string().allow(""),
    SuicidalThoughtsTime: Joi.string().allow(""),
    SuicideAttemptDescription: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptExistingSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptNoExistingSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptExistingSafetyPlan", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptOutcome: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicideAttemptSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicideAttemptNA: Joi.boolean(),
    SuicideAttemptDate: Joi.string().allow(""),
    SuicideAttemptTime: Joi.string().allow(""),
    COVIDPositiveMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.string().required(),
    }),
    COVIDPositiveMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.when("COVIDPositiveMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    COVIDPositiveMedications: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.string().required(),
    }),
    COVIDPositiveMedicationDetails: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.when("COVIDPositiveMedications", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    COVIDPositiveNA: Joi.boolean(),
    COVIDPositiveDate: Joi.string().allow(""),
    COVIDPositiveTime: Joi.string().allow(""),
    IllegalBehaviorWhere: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorWhereOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorDescription: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorStepsTaken: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistory: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorFollowUp: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorArrested: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcome: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionWhere: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionWhereOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionDescription: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnown: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnownDetails: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionKnown", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    AggressionFollowUp: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcome: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    CarAccidentDescription: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicationAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.when("CarAccidentMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    VictimWhere: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimWhereOther: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.when("VictimWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    VictimDescription: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimStepsTaken: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimFollowUp: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    OtherTypeDescription: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeStepsTaken: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcome: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcomeOther: Joi.when("OtherTypeOutcome", {
      is: "Other",
      then: Joi.string().required(),
    }),
    CountyNotified: Joi.string().required(),
    CountyNotifiedName: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    CountyNotifiedWhen: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    CountyNotifiedComments: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    NotNotifiedDetails: Joi.when("CountyNotified", {
      is: "No",
      then: Joi.string().required(),
    }),
    OtherNotificationsNeeded: Joi.string().required(),
    OtherNotifiedName: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedWhen: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedComments: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    ResolutionAmendments: Joi.string().allow(""),
  },
  "4CD03A4A-5F05-EE11-800F-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    ReportMonth: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    ICWIS: Joi.string().required(),
    Permanency: Joi.string().required(),
    Connections: Joi.string().required(),
    ReferralDate: Joi.string().required(),
    ReferralReason: Joi.string().required(),
    PresentingProblem: Joi.string().required(),
    ServiceDetails: Joi.string().allow(""),
    ServiceGoals: Joi.string().allow(""),
    AuthorizationAttempts: Joi.string().required(),
    IncidentReports: Joi.string().allow(""),
    SAFYTransportation: Joi.string().required(),
    ActivitiesInvolvement: Joi.string().required(),
    Progress: Joi.string().required(),
    DischargePlan: Joi.string().required(),
    ProjectedDischargeDate: Joi.string().required(),
  },
  "6F65A7B5-6509-EE11-87DD-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    AdultPhysicalAssault: Joi.boolean(),
    AdultSexualAssault: Joi.boolean(),
    AdultSexuallyAbused: Joi.boolean(),
    Arson: Joi.boolean(),
    Bullying: Joi.boolean(),
    Burglary: Joi.boolean(),
    ChildPhysicalAbuse: Joi.boolean(),
    ChildPornography: Joi.boolean(),
    ChildSexualAbuse: Joi.boolean(),
    DomesticViolence: Joi.boolean(),
    DUIIncident: Joi.boolean(),
    ElderAbuse: Joi.boolean(),
    HateCrime: Joi.boolean(),
    HateCrimeOther: Joi.boolean(),
    HateCrimeOtherDetails: Joi.string().when("HateCrimeOther", {
      is: true,
      then: Joi.required(),
    }),
    LaborTrafficking: Joi.boolean(),
    SexTrafficking: Joi.boolean(),
    IdentityTheft: Joi.boolean(),
    Kidnapping: Joi.boolean(),
    KidnappingCustodial: Joi.boolean(),
    MassViolence: Joi.boolean(),
    VehicularVictim: Joi.boolean(),
    Robbery: Joi.boolean(),
    Stalking: Joi.boolean(),
    HomicideSurvivor: Joi.boolean(),
    TeenDating: Joi.boolean(),
    Terrorism: Joi.boolean(),
    OtherVictim: Joi.boolean(),
    OtherVictimDetails: Joi.string().when("OtherVictim", {
      is: true,
      then: Joi.required(),
    }),
    MultipleTypes: Joi.boolean(),
    Deaf: Joi.boolean(),
    Homeless: Joi.boolean(),
    Immigrant: Joi.boolean(),
    LGBTQ: Joi.boolean(),
    Veteran: Joi.boolean(),
    Disabilities: Joi.boolean(),
    LimitedEnglish: Joi.boolean(),
    OtherClassification: Joi.boolean(),
    OtherClassificationDetails: Joi.string().when("OtherClassification", {
      is: true,
      then: Joi.required(),
    }),
  },
  "5B7379E7-8105-EE11-87DD-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    Therapy: Joi.string().required(),
    DecreasedSymptoms: Joi.string().when("Therapy", {
      is: "Yes",
      then: Joi.required(),
    }),
    Maltreatment: Joi.string().required(),
    FirstIncident: Joi.string().when("Maltreatment", {
      is: "Yes",
      then: Joi.required(),
    }),
    OutsideKinship: Joi.string().required(),
    TypeOfCare: Joi.string().when("OutsideKinship", {
      is: "Yes",
      then: Joi.required(),
    }),
    TypeOfCareDetails: Joi.string().when("TypeOfCare", {
      is: "Other",
      then: Joi.required(),
    }),
    Discharged: Joi.string().required(),
    AchievedMajority: Joi.string().when("Discharged", {
      is: "Yes",
      then: Joi.required(),
    }),
    Permanency: Joi.string().when("Discharged", {
      is: "Yes",
      then: Joi.required(),
    }),
    PermanencyType: Joi.string().when("Permanency", {
      is: "Yes",
      then: Joi.required(),
    }),
  },
  "29EEDCF8-2CFF-ED11-800F-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    DateOfIncident: Joi.string().required(),
    TimeOfIncident: Joi.string().required(),
    NotifiedOn: Joi.string().required(),
    NotifiedBy: Joi.string().required(),
    NotifiedByOther: Joi.when("NotifiedBy", {
      is: "Other",
      then: Joi.string().required(),
    }),
    NotifiedMethod: Joi.string().required(),
    NotifiedMethodOther: Joi.when("NotifiedMethod", {
      is: "Other",
      then: Joi.string().required(),
    }),
    TypeOfIncident: Joi.string().required(),
    AbuseAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.when("AbuseAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseNA: Joi.boolean(),
    AbuseDate: Joi.string().allow(""),
    AbuseTime: Joi.string().allow(""),
    AbuseNotes: Joi.string().allow(""),
    AbuseNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.when("AbuseNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseStepsTaken: Joi.string().allow(""),
    AbuseOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    DeathClient: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWho: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathClient", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathInvestigation: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhere: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhereOther: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    DeathDescription: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathPoliceReport: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathReportedBy: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathReportInfo: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathNoReportReason: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathStepsTaken: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastDate: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastTime: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjury: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("HomicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsNA: Joi.boolean(),
    HomicidalThoughtsDate: Joi.string().allow(""),
    HomicidalThoughtsTime: Joi.string().allow(""),
    PsychiatricEmergencyDescription: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyOutcome: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencySafetyPlan: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    PsychiatricEmergencyNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("PsychiatricEmergencySafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    PsychiatricEmergencyNA: Joi.boolean(),
    PsychiatricEmergencyDate: Joi.string().allow(""),
    PsychiatricEmergencyTime: Joi.string().allow(""),
    SelfHarmBehaviorsSuicidal: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.string().required(),
    }),
    SelfHarmBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjury: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsInjury", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsChronic: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsChronic", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsCSSRs: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsNoCSSRsReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsCSSRs", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsSafetyPlan", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsNA: Joi.boolean(),
    SuicidalThoughtsDate: Joi.string().allow(""),
    SuicidalThoughtsTime: Joi.string().allow(""),
    SuicideAttemptDescription: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptExistingSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptNoExistingSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptExistingSafetyPlan", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptOutcome: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicideAttemptSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicideAttemptNA: Joi.boolean(),
    SuicideAttemptDate: Joi.string().allow(""),
    SuicideAttemptTime: Joi.string().allow(""),
    IllegalBehaviorWhere: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorWhereOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorDescription: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistory: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorFollowUp: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorArrested: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcome: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionWhere: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards SAFY Employee/SAFY Property",
      then: Joi.string().required(),
    }),
    AggressionWhereOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards SAFY Employee/SAFY Property",
      then: Joi.when("AggressionWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionDescription: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards SAFY Employee/SAFY Property",
      then: Joi.string().required(),
    }),
    AggressionKnown: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards SAFY Employee/SAFY Property",
      then: Joi.string().required(),
    }),
    AggressionKnownDetails: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards SAFY Employee/SAFY Property",
      then: Joi.when("AggressionKnown", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    AggressionFollowUp: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards SAFY Employee/SAFY Property",
      then: Joi.string().required(),
    }),
    AggressionOutcome: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards SAFY Employee/SAFY Property",
      then: Joi.string().required(),
    }),
    AggressionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards SAFY Employee/SAFY Property",
      then: Joi.when("AggressionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    CarAccidentDescription: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicationAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.when("CarAccidentMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    OtherTypeDescription: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeStepsTaken: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcome: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.when("OtherTypeOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    OtherNotificationsNeeded: Joi.string().required(),
    OtherNotifiedName: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedWhen: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedComments: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    ResolutionAmendments: Joi.string().allow(""),
  },
  "9736A7E9-2CFF-ED11-800F-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    DateOfIncident: Joi.string().required(),
    TimeOfIncident: Joi.string().required(),
    NotifiedOn: Joi.string().required(),
    NotifiedBy: Joi.string().required(),
    NotifiedByOther: Joi.when("NotifiedBy", {
      is: "Other",
      then: Joi.string().required(),
    }),
    NotifiedMethod: Joi.required(),
    NotifiedMethodOther: Joi.when("NotifiedMethod", {
      is: "Other",
      then: Joi.string().required(),
    }),
    TypeOfIncident: Joi.string().required(),
    AbuseAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.when("AbuseAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseNA: Joi.boolean(),
    AbuseNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.when("AbuseNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseDate: Joi.string().allow(""),
    AbuseTime: Joi.string().allow(""),
    AbuseNotes: Joi.string().allow(""),
    AbuseStepsTaken: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AWOLDescription: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLLocated: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLPoliceReport: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    AWOLDepartment: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLReportNumber: Joi.string().allow(""),
    AWOLOfficer: Joi.string().allow(""),
    AWOLNoReportReason: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLOutcome: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathClient: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWho: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathClient", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathInvestigation: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhere: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhereOther: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    DeathDescription: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathPoliceReport: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathReportedBy: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathReportInfo: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathNoReportReason: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathStepsTaken: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastDate: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastTime: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjury: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("HomicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsNA: Joi.boolean(),
    HomicidalThoughtsDate: Joi.string().allow(""),
    HomicidalThoughtsTime: Joi.string().allow(""),
    PsychiatricEmergencyDescription: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyOutcome: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencySafetyPlan: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    PsychiatricEmergencyNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("PsychiatricEmergencySafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    PsychiatricEmergencyNA: Joi.boolean(),
    PsychiatricEmergencyDate: Joi.string().allow(""),
    PsychiatricEmergencyTime: Joi.string().allow(""),
    SexualizedBehaviorsWhere: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsWhereOther: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsStepsTaken: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistory: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsFollowUp: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsOutcome: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SelfHarmBehaviorsSuicidal: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.string().required(),
    }),
    SelfHarmBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjury: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsInjury", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsChronic: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsChronic", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsCSSRs: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsNoCSSRsReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsCSSRs", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsNA: Joi.boolean(),
    SuicidalThoughtsDate: Joi.string().allow(""),
    SuicidalThoughtsTime: Joi.string().allow(""),
    SuicideAttemptDescription: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptExistingSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptNoExistingSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptExistingSafetyPlan", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptOutcome: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicideAttemptSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicideAttemptNA: Joi.boolean(),
    SuicideAttemptDate: Joi.string().allow(""),
    SuicideAttemptTime: Joi.string().allow(""),
    IllegalBehaviorWhere: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorWhereOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorDescription: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorStepsTaken: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistory: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorFollowUp: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorArrested: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcome: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionWhere: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionWhereOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionDescription: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnown: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnownDetails: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionKnown", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    AggressionFollowUp: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcome: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    CarAccidentDescription: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicationAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.when("CarAccidentMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    VictimWhere: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimWhereOther: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.when("VictimWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    VictimDescription: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimStepsTaken: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimFollowUp: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    OtherTypeDescription: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeStepsTaken: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcome: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.when("OtherTypeOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    OtherNotificationsNeeded: Joi.string().required(),
    OtherNotifiedName: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedWhen: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedComments: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    ResolutionAmendments: Joi.string().allow(""),
  },
  "2AEEDCF8-2CFF-ED11-800F-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    DateOfIncident: Joi.string().required(),
    TimeOfIncident: Joi.string().required(),
    NotifiedOn: Joi.string().required(),
    NotifiedBy: Joi.string().required(),
    NotifiedByOther: Joi.when("NotifiedBy", {
      is: "Other",
      then: Joi.string().required(),
    }),
    NotifiedMethod: Joi.string().required(),
    NotifiedMethodOther: Joi.when("NotifiedMethod", {
      is: "Other",
      then: Joi.string().required(),
    }),
    TypeOfIncident: Joi.string().required(),
    AbuseAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.when("AbuseAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseNA: Joi.boolean(),
    AbuseDate: Joi.string().allow(""),
    AbuseTime: Joi.string().allow(""),
    AbuseNotes: Joi.string().allow(""),
    AbuseNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.when("AbuseNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseStepsTaken: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AWOLDescription: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLLocated: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLPoliceReport: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    AWOLDepartment: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLReportNumber: Joi.string().allow(""),
    AWOLOfficer: Joi.string().allow(""),
    AWOLNoReportReason: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLOutcome: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathClient: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWho: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathClient", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathInvestigation: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhere: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhereOther: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    DeathDescription: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathPoliceReport: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathReportedBy: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathReportInfo: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathNoReportReason: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathStepsTaken: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastDate: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastTime: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjury: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("HomicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsNA: Joi.boolean(),
    HomicidalThoughtsDate: Joi.string().allow(""),
    HomicidalThoughtsTime: Joi.string().allow(""),
    PsychiatricEmergencyDescription: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyOutcome: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencySafetyPlan: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    PsychiatricEmergencyNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("PsychiatricEmergencySafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    PsychiatricEmergencyNA: Joi.boolean(),
    PsychiatricEmergencyDate: Joi.string().allow(""),
    PsychiatricEmergencyTime: Joi.string().allow(""),
    SexualizedBehaviorsWhere: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsWhereOther: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsStepsTaken: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistory: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsFollowUp: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsOutcome: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SelfHarmBehaviorsSuicidal: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.string().required(),
    }),
    SelfHarmBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjury: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsInjury", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsChronic: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsChronic", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsCSSRs: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsNoCSSRsReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsCSSRs", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsNA: Joi.boolean(),
    SuicidalThoughtsDate: Joi.string().allow(""),
    SuicidalThoughtsTime: Joi.string().allow(""),
    SuicideAttemptDescription: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptExistingSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptNoExistingSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptExistingSafetyPlan", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptOutcome: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicideAttemptSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicideAttemptNA: Joi.boolean(),
    SuicideAttemptDate: Joi.string().allow(""),
    SuicideAttemptTime: Joi.string().allow(""),
    IllegalBehaviorWhere: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorWhereOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorDescription: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorStepsTaken: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistory: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorFollowUp: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorArrested: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcome: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionWhere: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionWhereOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionDescription: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnown: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnownDetails: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionKnown", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    AggressionFollowUp: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcome: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    VictimWhere: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimWhereOther: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.when("VictimWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    VictimDescription: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimStepsTaken: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimFollowUp: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    OtherTypeDescription: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeStepsTaken: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcome: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.when("OtherTypeOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    OtherNotificationsNeeded: Joi.string().required(),
    OtherNotifiedName: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedWhen: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedComments: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    ResolutionAmendments: Joi.string().allow(""),
  },
  "51B535EC-1B11-EE11-87DD-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    DateCompleted: Joi.string().required(),
    PhysicallyAbused: Joi.string().required(),
    SexuallyAbused: Joi.string().required(),
    GroupHome: Joi.string().required(),
    Hospitalized: Joi.string().required(),
    HighestTFC: Joi.string().required(),
    PastPsychotropicMeds: Joi.string().required(),
    AttemptedSuicide: Joi.string().required(),
    AnimalCruelty: Joi.string().required(),
    Sabotage: Joi.string().required(),
    ManyPlacements: Joi.string().required(),
    Expelled: Joi.string().required(),
    PoorMomRelationship: Joi.string().required(),
    PoorDadRelationship: Joi.string().required(),
    FamilyPhobia: Joi.string().required(),
    RunsAway: Joi.string().required(),
    Steals: Joi.string().required(),
    Lies: Joi.string().required(),
    Violent: Joi.string().required(),
    CurrentPsychotropicMeds: Joi.string().required(),
    Depressed: Joi.string().required(),
    Hyperactive: Joi.string().required(),
    ThreatensSuicide: Joi.string().required(),
    FailureToLearn: Joi.string().required(),
    SubstanceAbuse: Joi.string().required(),
    Fights: Joi.string().required(),
    DelinquentActs: Joi.string().required(),
    Alienates: Joi.string().required(),
    BehaviorProblems: Joi.string().required(),
    AssaultiveBehavior: Joi.string().required(),
    WeaponObsession: Joi.string().required(),
    SiblingPlacement: Joi.string().required(),
    NoRespite: Joi.string().required(),
    AssaultiveToAdults: Joi.string().required(),
    RiskFactorsScore: Joi.string().required(),
    PositiveRelationships: Joi.string().required(),
    SelfEntertainment: Joi.string().required(),
    SenseOfBelonging: Joi.string().required(),
    GetsAlong: Joi.string().required(),
    LearnsFromMistakes: Joi.string().required(),
    VolunteerWork: Joi.string().required(),
    HealthyAttachment: Joi.string().required(),
    StrengthsScore: Joi.string().required(),
    RiskLevel: Joi.string().required(),
  },
  "907FC923-6022-EE11-87DD-0050F21C653C": {
    UserBintiId: Joi.string().required(),
    SelectedState: Joi.string().required(),
    SelectedRecipients: Joi.string().required(),
    Date: Joi.string().required(),
    Type: Joi.string().required(),
    Subject: Joi.string().required(),
    ContactMethod: Joi.string()
      .when("Type", { is: "case_update", then: Joi.required() })
      .when("Type", { is: "next_planned_contact", then: Joi.required() })
      .when("Type", { is: "other", then: Joi.required() })
      .when("Type", { is: "recruiting", then: Joi.required() })
      .when("Type", { is: "family_evaluation", then: Joi.required() }),
    EstimatedApprovalDate: Joi.string().when("Type", {
      is: "approval_date_estimate",
      then: Joi.required(),
    }),
    Body: Joi.string().required(),
    ProcessRecipients: Joi.string().allow(""),
    BulkProcessed: Joi.string().allow(""),
    ProcessErrors: Joi.string().allow(""),
  },
  "53D751F6-782A-EE11-87DD-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    PersonNotified: Joi.string().required(),
    DateNotified: Joi.string().required(),
    FosterParents: Joi.string().required(),
    Division: Joi.string().required(),
    SAFYWorker: Joi.string().required(),
    ReferringAgency: Joi.string().required(),
    LicenseNumber: Joi.string().required(),
    LicenseDate: Joi.string().required(),
    LicenseSex: Joi.string().required(),
    LicenseAgeRange: Joi.string().required(),
    LicenseAmendment: Joi.string().required(),
    AmendmentDate: Joi.string().when("LicenseAmendment", {
      is: "Yes",
      then: Joi.required(),
    }),
    Siblings: Joi.boolean(),
    SiblingsDetails: Joi.string().when("Siblings", {
      is: "Yes",
      then: Joi.required(),
    }),
    Skills: Joi.boolean(),
    SkillsDetails: Joi.string().when("Skills", {
      is: "Yes",
      then: Joi.required(),
    }),
    Returning: Joi.boolean(),
    ReturningDetails: Joi.string().when("Returning", {
      is: "Yes",
      then: Joi.required(),
    }),
  },
  "F94CD7BF-082B-EE11-87DD-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Date: Joi.string().required(),
    FosterParents: Joi.string().required(),
    CaseManager: Joi.string().required(),
    CaseManagerPhone: Joi.string().required(),
    SAFYSupervisor: Joi.string().required(),
    SAFYSupervisorPhone: Joi.string().required(),
    CaseWorker: Joi.string().required(),
    CaseWorkerPhone: Joi.string().required(),
  },
  "CC1A3951-E12B-EE11-87DD-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    CurrentFacility: Joi.string().required(),
    CurrentMedications: Joi.string().required(),
    ReportDate: Joi.string().required(),
    ContactDetails: Joi.string().required(),
    VulnerabilitiesNone: Joi.boolean(),
    VulnerabilitiesCommunication: Joi.boolean(),
    VulnerabilitiesSelfProtection: Joi.boolean(),
    VulnerabilitiesAbuse: Joi.boolean(),
    VulnerabilitiesHelpers: Joi.boolean(),
    VulnerabilitiesAge: Joi.boolean(),
    VulnerabilitiesEmotionalNeeds: Joi.boolean(),
    VulnerabilitiesDevelopmental: Joi.boolean(),
    VulnerabilitiesAppearance: Joi.boolean(),
    VulnerabilitiesSpecialNeeds: Joi.boolean(),
    VulnerabilitiesVictimization: Joi.boolean(),
    VulnerabilitiesProvocative: Joi.boolean(),
    VulnerabilitiesResilience: Joi.boolean(),
    VulnerabilitiesRole: Joi.boolean(),
    VulnerabilitiesVisibility: Joi.boolean(),
    VulnerabilitiesDetails: Joi.string().required(),
    ProtectionNeeds: Joi.boolean(),
    ProtectionIntervene: Joi.boolean(),
    ProtectionBond: Joi.boolean(),
    ProtectionProvides: Joi.boolean(),
    ProtectionResponds: Joi.boolean(),
    ProtectionDiscipline: Joi.boolean(),
    ProtectionPositive: Joi.boolean(),
    ProtectionDetails: Joi.string().required(),
    ChangesMarital: Joi.boolean(),
    ChangesHealth: Joi.boolean(),
    ChangesPlacement: Joi.boolean(),
    ChangesBirth: Joi.boolean(),
    ChangesDeath: Joi.boolean(),
    ChangesCrime: Joi.boolean(),
    ChangesMembers: Joi.boolean(),
    ChangesRelocation: Joi.boolean(),
    ChangesActivities: Joi.boolean(),
    ChangesEmployment: Joi.boolean(),
    ChangesDetails: Joi.string()
      .when("ChangesMarital", { is: true, then: Joi.required() })
      .when("ChangesHealth", { is: true, then: Joi.required() })
      .when("ChangesPlacement", { is: true, then: Joi.required() })
      .when("ChangesBirth", { is: true, then: Joi.required() })
      .when("ChangesDeath", { is: true, then: Joi.required() })
      .when("ChangesCrime", { is: true, then: Joi.required() })
      .when("ChangesMembers", { is: true, then: Joi.required() })
      .when("ChangesRelocation", { is: true, then: Joi.required() })
      .when("ChangesActivities", { is: true, then: Joi.required() })
      .when("ChangesEmployment", { is: true, then: Joi.required() }),
    ObjectiveProgress: Joi.string().allow(""),
    GoalProgress: Joi.string().required(),
    PermanencyAdoption: Joi.boolean(),
    PermanencyConcurrentPlan: Joi.boolean(),
    PermanencyIndependent: Joi.boolean(),
    PermanencyCustody: Joi.boolean(),
    PermanencyMaintain: Joi.boolean(),
    PermanencyReunification: Joi.boolean(),
    CollaborationDetails: Joi.string().allow(""),
    SupportiveAcademic: Joi.boolean(),
    SupportiveCounseling: Joi.boolean(),
    SupportiveGrow: Joi.boolean(),
    SupportiveIndependent: Joi.boolean(),
    SupportiveMedical: Joi.boolean(),
    SupportiveMentor: Joi.boolean(),
    SupportiveOccupational: Joi.boolean(),
    SupportivePhysical: Joi.boolean(),
    SupportiveRecreation: Joi.boolean(),
    SupportiveRespite: Joi.boolean(),
    SupportiveSpeech: Joi.boolean(),
    SupportiveTransportation: Joi.boolean(),
    SupportiveOther: Joi.string().allow(""),
    EmotionalFunctioning: Joi.string().required(),
    SchoolProgress: Joi.string().required(),
    AdditionalServices: Joi.string().allow(""),
    LastPhysical: Joi.string().required(),
    LastDental: Joi.string().required(),
    LastVision: Joi.string().required(),
    AdditionalMedical: Joi.string().allow(""),
    ActionPlan: Joi.string().required(),
    SenecaCounty: Joi.string().required(),
    Marks: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    Hygiene: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    DevelopmentalIssues: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    Adjustment: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    Visitation: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    Counseling: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    LifeBook: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    IndependentLiving: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    Interaction: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    NextVisit: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
  },
  "13DB44C2-8330-EE11-87DD-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Date: Joi.string().required(),
    SACWISID: Joi.string().required(),
    LOC: Joi.string().required(),
    PermanencyGoal: Joi.string().required(),
    CaseworkerName: Joi.string().required(),
    ProviderSignature: Joi.string().required(),
    FPName: Joi.string().required(),
    FPAddress: Joi.string().required(),
    CurrentDiagnosis: Joi.string().required(),
    CurrentMedications: Joi.string().required(),
    PrescribingProvider: Joi.string().required(),
    MHSContent: Joi.string().required(),
    TherapistName: Joi.string().required(),
    AgencyName: Joi.string().required(),
    TherapyDates: Joi.string().required(),
    TreatmentPlanProgress: Joi.string().required(),
    SchoolAdjustment: Joi.string().required(),
    PeerRelations: Joi.string().required(),
    HealthIssues: Joi.string().required(),
    PhysicalDetails: Joi.string().required(),
    DentalDetails: Joi.string().required(),
    VisionDetails: Joi.string().required(),
    CourtInvolvement: Joi.string().required(),
    Safety: Joi.string().required(),
    FamilyInvolvement: Joi.string().required(),
    PermanencyPlanning: Joi.string().required(),
    ChildAdjustmentSummary: Joi.string().required(),
    ContactDetails: Joi.string().required(),
    PrimaryCaretaker: Joi.string().required(),
    SecondaryCaretaker: Joi.string().allow(""),
    FormCompletedBy: Joi.string().required(),
    DateOfHomeVisit: Joi.string().required(),
    TimeOfHomeVisit: Joi.string().required(),
    VisitType: Joi.string().required(),
    PrimaryCaretakerPresent: Joi.string().required(),
    SecondaryCaretakerPresent: Joi.string().required(),
    ChildPresent: Joi.string().required(),
    OtherPresent: Joi.string().required(),
    OtherPresentDetails: Joi.string().when("OtherPresent", {
      is: "Yes",
      then: Joi.required(),
    }),
    SummaryOfChildInterview: Joi.string().required(),
    VulnerabilitiesNone: Joi.boolean(),
    VulnerabilitiesCommunication: Joi.boolean(),
    VulnerabilitiesSelfProtection: Joi.boolean(),
    VulnerabilitiesAbuse: Joi.boolean(),
    VulnerabilitiesHelpers: Joi.boolean(),
    VulnerabilitiesAge: Joi.boolean(),
    VulnerabilitiesEmotionalNeeds: Joi.boolean(),
    VulnerabilitiesDevelopmental: Joi.boolean(),
    VulnerabilitiesAppearance: Joi.boolean(),
    VulnerabilitiesSpecialNeeds: Joi.boolean(),
    VulnerabilitiesVictimization: Joi.boolean(),
    VulnerabilitiesProvocative: Joi.boolean(),
    VulnerabilitiesResilience: Joi.boolean(),
    VulnerabilitiesRole: Joi.boolean(),
    VulnerabilitiesVisibility: Joi.boolean(),
    VulnerabilitiesDetails: Joi.string().required(),
    ProtectionNeeds: Joi.boolean(),
    ProtectionIntervene: Joi.boolean(),
    ProtectionBond: Joi.boolean(),
    ProtectionProvides: Joi.boolean(),
    ProtectionResponds: Joi.boolean(),
    ProtectionDiscipline: Joi.boolean(),
    ProtectionPositive: Joi.boolean(),
    ProtectionDetails: Joi.string().required(),
    ChangesWillingness: Joi.boolean(),
    ChangesWillingnessDetails: Joi.string().when("ChangesWillingness", {
      is: true,
      then: Joi.required(),
    }),
    ChangesAbility: Joi.boolean(),
    ChangesAbilityDetails: Joi.string().when("ChangesAbility", {
      is: true,
      then: Joi.required(),
    }),
    ChangesMarital: Joi.boolean(),
    ChangesMaritalDetails: Joi.string().when("ChangesMarital", {
      is: true,
      then: Joi.required(),
    }),
    ChangesHealth: Joi.boolean(),
    ChangesHealthDetails: Joi.string().when("ChangesHealth", {
      is: true,
      then: Joi.required(),
    }),
    ChangesPlacement: Joi.boolean(),
    ChangesPlacementDetails: Joi.string().when("ChangesPlacement", {
      is: true,
      then: Joi.required(),
    }),
    ChangesBirth: Joi.boolean(),
    ChangesBirthDetails: Joi.string().when("ChangesBirth", {
      is: true,
      then: Joi.required(),
    }),
    ChangesDeath: Joi.boolean(),
    ChangesDeathDetails: Joi.string().when("ChangesDeath", {
      is: true,
      then: Joi.required(),
    }),
    ChangesCrime: Joi.boolean(),
    ChangesCrimeDetails: Joi.string().when("ChangesCrime", {
      is: true,
      then: Joi.required(),
    }),
    ChangesMembers: Joi.boolean(),
    ChangesMembersDetails: Joi.string().when("ChangesMembers", {
      is: true,
      then: Joi.required(),
    }),
    ChangesRelocation: Joi.boolean(),
    ChangesRelocationDetails: Joi.string().when("ChangesRelocation", {
      is: true,
      then: Joi.required(),
    }),
    ChangesActivities: Joi.boolean(),
    ChangesActivitiesDetails: Joi.string().when("ChangesActivities", {
      is: true,
      then: Joi.required(),
    }),
    ChangesEmployment: Joi.boolean(),
    ChangesEmploymentDetails: Joi.string().when("ChangesEmployment", {
      is: true,
      then: Joi.required(),
    }),
    ChangesRespite: Joi.boolean(),
    ChangesRespiteDetails: Joi.string().when("ChangesRespite", {
      is: true,
      then: Joi.required(),
    }),
    SupportiveServicesNeeded: Joi.string().required(),
    CasePlanProgress: Joi.string().required(),
  },
  "AE87EDDF-5531-EE11-87DD-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    CurrentFacility: Joi.string().required(),
    PrimaryCaregiver: Joi.string().required(),
    SecondaryCaregiver: Joi.string().allow(""),
    DateOfVisit: Joi.string().required(),
    TimeOfVisit: Joi.string().required(),
    PrimaryPresent: Joi.boolean(),
    SecondaryPresent: Joi.boolean(),
    ChildPresent: Joi.boolean(),
    OthersPresent: Joi.boolean(),
    OthersPresentDetails: Joi.string().when("OthersPresent", {
      is: true,
      then: Joi.required(),
    }),
    Changes: Joi.string().required(),
    SummaryOfChildInterview: Joi.string().required(),
    ChildCondition: Joi.string().required(),
    VulnerabilitiesNone: Joi.boolean(),
    VulnerabilitiesCommunication: Joi.boolean(),
    VulnerabilitiesSelfProtection: Joi.boolean(),
    VulnerabilitiesAbuse: Joi.boolean(),
    VulnerabilitiesHelpers: Joi.boolean(),
    VulnerabilitiesAge: Joi.boolean(),
    VulnerabilitiesEmotionalNeeds: Joi.boolean(),
    VulnerabilitiesDevelopmental: Joi.boolean(),
    VulnerabilitiesAppearance: Joi.boolean(),
    VulnerabilitiesSpecialNeeds: Joi.boolean(),
    VulnerabilitiesVictimization: Joi.boolean(),
    VulnerabilitiesProvocative: Joi.boolean(),
    VulnerabilitiesResilience: Joi.boolean(),
    VulnerabilitiesRole: Joi.boolean(),
    VulnerabilitiesVisibility: Joi.boolean(),
    VulnerabilitiesDetails: Joi.string().required(),
    Strengths: Joi.string().required(),
    ProtectionNeeds: Joi.boolean(),
    ProtectionIntervene: Joi.boolean(),
    ProtectionBond: Joi.boolean(),
    ProtectionProvides: Joi.boolean(),
    ProtectionResponds: Joi.boolean(),
    ProtectionDiscipline: Joi.boolean(),
    ProtectionPositive: Joi.boolean(),
    ProtectionDetails: Joi.string().required(),
    ChangesMarital: Joi.boolean(),
    ChangesHealth: Joi.boolean(),
    ChangesPlacement: Joi.boolean(),
    ChangesBirth: Joi.boolean(),
    ChangesDeath: Joi.boolean(),
    ChangesCrime: Joi.boolean(),
    ChangesMembers: Joi.boolean(),
    ChangesRelocation: Joi.boolean(),
    ChangesActivities: Joi.boolean(),
    ChangesEmployment: Joi.boolean(),
    SupportiveServices: Joi.string().required(),
    GoalProgress: Joi.string().required(),
    PermanencyPlan: Joi.string().required(),
    Comments: Joi.string().allow(""),
  },
  "11DC18DA-0036-EE11-87DD-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Outcome: Joi.string().required(),
    AdmissionPermanencyPlan: Joi.string().when("Outcome", {
      is: "Adoption",
      then: Joi.required(),
    }),
    PriorLocation: Joi.string().when("Outcome", {
      is: "Adoption",
      then: Joi.required(),
    }),
    CommunityInvolvement: Joi.string().when("Outcome", {
      is: "Adoption",
      then: Joi.required(),
    }),
    LawEnforcement: Joi.string().when("Outcome", {
      is: "Adoption",
      then: Joi.required(),
    }),
    SchoolAttendance: Joi.string().when("Outcome", {
      is: "Adoption",
      then: Joi.required(),
    }),
    SchoolPerformance: Joi.string().when("Outcome", {
      is: "Adoption",
      then: Joi.required(),
    }),
    SchoolBehavior: Joi.string().when("Outcome", {
      is: "Adoption",
      then: Joi.required(),
    }),
    EmploymentStatus: Joi.string().when("Outcome", {
      is: "Adoption",
      then: Joi.required(),
    }),
    DischargeReason: Joi.string().when("Outcome", {
      is: "Discharge",
      then: Joi.required(),
    }),
    DischargeLocation: Joi.string().when("Outcome", {
      is: "Discharge",
      then: Joi.required(),
    }),
    CustodialReason: Joi.string().allow(""),
    DischargePermanencyPlan: Joi.string().when("Outcome", {
      is: "Discharge",
      then: Joi.required(),
    }),
    LastPlanPermanency: Joi.string().when("Outcome", {
      is: "Discharge",
      then: Joi.required(),
    }),
    OverallProgress: Joi.string().when("Outcome", {
      is: "Discharge",
      then: Joi.required(),
    }),
  },
  "15A1D8C7-2B36-EE11-87DD-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Date: Joi.string().required(),
    MembersPresent: Joi.string().required(),
    CFTGoals: Joi.string().required(),
    StrengthsComments: Joi.string().required(),
    StrengthsSteps: Joi.string().required(),
    WellbeingComments: Joi.string().required(),
    WellbeingSteps: Joi.string().required(),
    MedicalComments: Joi.string().required(),
    MedicalSteps: Joi.string().required(),
    BehaviorsComments: Joi.string().required(),
    BehaviorsSteps: Joi.string().required(),
    PlacementComments: Joi.string().required(),
    PlacementSteps: Joi.string().required(),
    EducationalComments: Joi.string().required(),
    EducationalSteps: Joi.string().required(),
    MentalHealthComments: Joi.string().required(),
    MentalHealthSteps: Joi.string().required(),
    TransitionalLivingComments: Joi.string().required(),
    TransitionalLivingSteps: Joi.string().required(),
    VisitationComments: Joi.string().required(),
    VisitationSteps: Joi.string().required(),
    LegalComments: Joi.string().required(),
    LegalSteps: Joi.string().required(),
    OtherComments: Joi.string().required(),
    OtherSteps: Joi.string().required(),
  },
  "5F4C9929-CC36-EE11-87DD-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    CurrentFacility: Joi.string().required(),
    PrimaryCaregiver: Joi.string().required(),
    SecondaryCaregiver: Joi.string().required(),
    DateOfVisit: Joi.string().required(),
    TimeOfVisit: Joi.string().required(),
    PrimaryPresent: Joi.boolean(),
    SecondaryPresent: Joi.boolean(),
    ChildPresent: Joi.boolean(),
    OthersPresent: Joi.boolean(),
    OthersPresentDetails: Joi.string().when("OthersPresent", {
      is: true,
      then: Joi.required(),
    }),
    CurrentBehaviors: Joi.string().required(),
    EmotionalFunctioning: Joi.string().required(),
    SocialFunctioning: Joi.string().required(),
    DailyActivities: Joi.string().required(),
    ChildAdjustment: Joi.string().required(),
    PlanReviewed: Joi.string().required(),
    FamilyUpdate: Joi.string().required(),
    PermanencyPlan: Joi.string().required(),
    LifeBookUpdate: Joi.string().required(),
    ChildNeeds: Joi.string().required(),
    SafetyConcerns: Joi.string().required(),
    IRUpdate: Joi.string().required(),
    IRReviewed: Joi.string().required(),
    MedicationLogReviewed: Joi.string().required(),
    MonthlyApptReviewed: Joi.string().required(),
    MonthlyMedicalApptReviewed: Joi.string().required(),
    ChangesMarital: Joi.boolean(),
    ChangesHealth: Joi.boolean(),
    ChangesPlacement: Joi.boolean(),
    ChangesBirth: Joi.boolean(),
    ChangesDeath: Joi.boolean(),
    ChangesCrime: Joi.boolean(),
    ChangesMembers: Joi.boolean(),
    ChangesRelocation: Joi.boolean(),
    ChangesEmployment: Joi.boolean(),
    ChangesDetails: Joi.string()
      .when("ChangesMarital", { is: true, then: Joi.required() })
      .when("ChangesHealth", { is: true, then: Joi.required() })
      .when("ChangesPlacement", { is: true, then: Joi.required() })
      .when("ChangesBirth", { is: true, then: Joi.required() })
      .when("ChangesDeath", { is: true, then: Joi.required() })
      .when("ChangesCrime", { is: true, then: Joi.required() })
      .when("ChangesMembers", { is: true, then: Joi.required() })
      .when("ChangesRelocation", { is: true, then: Joi.required() })
      .when("ChangesEmployment", { is: true, then: Joi.required() }),
    FamilyAdjustment: Joi.string().required(),
    ITPReviewed: Joi.string().required(),
    FamilyNeeds: Joi.string().required(),
    SupportProvided: Joi.string().required(),
    EmergingIssues: Joi.string().required(),
    UpcomingEvents: Joi.string().required(),
  },
  "96F1ADB6-FF3D-EE11-8457-DC98408D5418": {
    RequestType: Joi.string().required(),
    RequestName: Joi.string().required(),
    ProgramEffectiveDate: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramName: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramDivisions: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramTeamMembers: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramType: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramBedRequirement: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramCarePlanning: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramCarePlanCustomized: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanWiley: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanConfigNarrative: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanProblemLabel: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanProblemReviewRequired: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanGoalLabel: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanGoalReviewRequired: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanGoalProgressRequired: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanObjectiveLabel: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanObjectiveReviewRequired: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanInterventionLabel: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanInterventionReviewRequired: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanInterventionProgressRequired: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequencyInitial: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequency30Day: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequency60Day: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequency90Day: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequency6Months: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequency180Days: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequency270Days: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequencyAnnual: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequencyUpdate: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanFrequencyDischarge: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramCarePlanMaximumReviewInterval: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ProgramCarePlanning", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProgramAssessments: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramReportingNeeds: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramPayor: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ProgramNotes: Joi.string().when("RequestType", {
      is: "New Program",
      then: Joi.required(),
    }),
    ModalityRequestType: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.string().required(),
    }).when("RequestType", { is: "Modality", then: Joi.string().required() }),
    ModalityNewDetails: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ModalityRequestType", {
        is: "Adding a new modality",
        then: Joi.string().required(),
      }),
    }).when("RequestType", {
      is: "Modality",
      then: Joi.when("ModalityRequestType", {
        is: "Adding a new modality",
        then: Joi.string().required(),
      }),
    }),
    CurrentModalities: Joi.string().allow(""),
    ModalityNameToExpire: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ModalityRequestType", {
        is: "Expiring an existing modality",
        then: Joi.string().required(),
      }),
    }).when("RequestType", {
      is: "Modality",
      then: Joi.when("ModalityRequestType", {
        is: "Expiring an existing modality",
        then: Joi.string().required(),
      }),
    }),
    ModalityProgramsToExpire: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ModalityRequestType", {
        is: "Expiring an existing modality",
        then: Joi.string().required(),
      }),
    }).when("RequestType", {
      is: "Modality",
      then: Joi.when("ModalityRequestType", {
        is: "Expiring an existing modality",
        then: Joi.string().required(),
      }),
    }),
    ModalityExpirationDate: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ModalityRequestType", {
        is: "Expiring an existing modality",
        then: Joi.string().required(),
      }),
    }).when("RequestType", {
      is: "Modality",
      then: Joi.when("ModalityRequestType", {
        is: "Expiring an existing modality",
        then: Joi.string().required(),
      }),
    }),
    ModalityNotes: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.string().required(),
    }).when("RequestType", { is: "Modality", then: Joi.string().required() }),
    ServiceItemNeeded: Joi.boolean(),
    CurrentServiceItems: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ServiceItemNeeded", {
        is: "Using Current Service Item(s)",
        then: Joi.string().required(),
      }),
    }),
    ServiceItems: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ServiceItemNeeded", {
        is: "Adding Service Item(s)",
        then: Joi.string().required(),
      }),
    }).when("RequestType", { is: "Service", then: Joi.string().required() }),
    ServiceItemNotes: Joi.when("RequestType", {
      is: "New Program",
      then: Joi.when("ServiceItemNeeded", {
        is: "Adding Service Item(s)",
        then: Joi.string().required(),
      }),
    }).when("RequestType", { is: "Service", then: Joi.string().required() }),
    ProgressNoteTemplates: Joi.when("RequestType", {
      is: "Progress Note Templates",
      then: Joi.string().required(),
    }).when("RequestType", { is: "Service", then: Joi.string().required() }),
    EnhancementRequest: Joi.string().when("RequestType", {
      is: "System Enhancement",
      then: Joi.required(),
    }),
  },
  "4B09BEC6-7847-EE11-8457-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    Date: Joi.string().required(),
    SACWISID: Joi.string().required(),
    LOC: Joi.string().required(),
    PermanencyGoal: Joi.string().required(),
    CaseworkerName: Joi.string().required(),
    ProviderSignature: Joi.string().required(),
    FPName: Joi.string().required(),
    FPAddress: Joi.string().required(),
    ReportSent: Joi.string().required(),
    ReportSentDetails: Joi.string().required(),
    CurrentDiagnosis: Joi.string().required(),
    CurrentMedications: Joi.string().required(),
    PrescribingProvider: Joi.string().required(),
    MHSContent: Joi.string().required(),
    TherapistName: Joi.string().required(),
    AgencyName: Joi.string().required(),
    TherapyDates: Joi.string().required(),
    SchoolAdjustment: Joi.string().required(),
    GradeLevel: Joi.string().required(),
    PeerRelations: Joi.string().required(),
    Activities: Joi.string().required(),
    HealthIssues: Joi.string().required(),
    PhysicalDetails: Joi.string().required(),
    DentalDetails: Joi.string().required(),
    VisionDetails: Joi.string().required(),
    CourtInvolvement: Joi.string().required(),
    Safety: Joi.string().required(),
    FamilyInvolvement: Joi.string().required(),
    PermanencyPlanning: Joi.string().required(),
    FinancialStatus: Joi.string().required(),
    ChildAdjustmentSummary: Joi.string().required(),
    TreatmentPlan: Joi.string().required(),
    ContactDetails: Joi.string().required(),
    FHMembers: Joi.string().required(),
    DateTimeOfHomeVisit: Joi.string().required(),
    VisitType: Joi.string().required(),
    PartiesPresent: Joi.string().required(),
    Relationships: Joi.string().required(),
    SummaryOfChildInterview: Joi.string().required(),
    Vulnerabilities: Joi.string().required(),
    ProtectiveCapacities: Joi.string().required(),
    ChangesWillingness: Joi.boolean(),
    ChangesWillingnessDetails: Joi.string().when("ChangesWillingness", {
      is: true,
      then: Joi.required(),
    }),
    ChangesAbility: Joi.boolean(),
    ChangesAbilityDetails: Joi.string().when("ChangesAbility", {
      is: true,
      then: Joi.required(),
    }),
    ChangesMarital: Joi.boolean(),
    ChangesMaritalDetails: Joi.string().when("ChangesMarital", {
      is: true,
      then: Joi.required(),
    }),
    ChangesHealth: Joi.boolean(),
    ChangesHealthDetails: Joi.string().when("ChangesHealth", {
      is: true,
      then: Joi.required(),
    }),
    ChangesPlacement: Joi.boolean(),
    ChangesPlacementDetails: Joi.string().when("ChangesPlacement", {
      is: true,
      then: Joi.required(),
    }),
    ChangesBirth: Joi.boolean(),
    ChangesBirthDetails: Joi.string().when("ChangesBirth", {
      is: true,
      then: Joi.required(),
    }),
    ChangesDeath: Joi.boolean(),
    ChangesDeathDetails: Joi.string().when("ChangesDeath", {
      is: true,
      then: Joi.required(),
    }),
    ChangesCrime: Joi.boolean(),
    ChangesCrimeDetails: Joi.string().when("ChangesCrime", {
      is: true,
      then: Joi.required(),
    }),
    ChangesMembers: Joi.boolean(),
    ChangesMembersDetails: Joi.string().when("ChangesMembers", {
      is: true,
      then: Joi.required(),
    }),
    ChangesRelocation: Joi.boolean(),
    ChangesRelocationDetails: Joi.string().when("ChangesRelocation", {
      is: true,
      then: Joi.required(),
    }),
    ChangesActivities: Joi.boolean(),
    ChangesActivitiesDetails: Joi.string().when("ChangesActivities", {
      is: true,
      then: Joi.required(),
    }),
    ChangesEmployment: Joi.boolean(),
    ChangesEmploymentDetails: Joi.string().when("ChangesEmployment", {
      is: true,
      then: Joi.required(),
    }),
    ChangesRespite: Joi.boolean(),
    ChangesRespiteDetails: Joi.string().when("ChangesRespite", {
      is: true,
      then: Joi.required(),
    }),
    CasePlanProgress: Joi.string().required(),
    SupportiveServicesNeeded: Joi.string().required(),
    Comments: Joi.string().required(),
  },
  "4C09BEC6-7847-EE11-8457-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    ProviderSACWIS: Joi.string().required(),
    Date: Joi.string().required(),
    SACWISID: Joi.string().required(),
    LOC: Joi.string().required(),
    PermanencyGoal: Joi.string().required(),
    CaseworkerName: Joi.string().required(),
    ProviderSignature: Joi.string().required(),
    FPName: Joi.string().required(),
    FPAddress: Joi.string().required(),
    ReportSent: Joi.string().required(),
    CurrentDiagnosis: Joi.string().required(),
    CurrentMedications: Joi.string().required(),
    PrescribingProvider: Joi.string().required(),
    MHSContent: Joi.string().required(),
    TherapistName: Joi.string().required(),
    AgencyName: Joi.string().required(),
    TherapyDates: Joi.string().required(),
    SchoolAdjustment: Joi.string().required(),
    GradeLevel: Joi.string().required(),
    PeerRelations: Joi.string().required(),
    Activities: Joi.string().required(),
    HealthIssues: Joi.string().required(),
    PhysicalDetails: Joi.string().required(),
    DentalDetails: Joi.string().required(),
    VisionDetails: Joi.string().required(),
    CourtInvolvement: Joi.string().required(),
    Safety: Joi.string().required(),
    FamilyInvolvement: Joi.string().required(),
    PermanencyPlanning: Joi.string().required(),
    FinancialStatus: Joi.string().required(),
    ChildAdjustmentSummary: Joi.string().required(),
    TreatmentPlanProgress: Joi.string().required(),
    TreatmentTeam: Joi.string().required(),
    ContactDetails: Joi.string().required(),
    PermanencyGoal2: Joi.string().required(),
    FHMembers: Joi.string().required(),
    DateTimeOfHomeVisit: Joi.string().required(),
    VisitType: Joi.string().required(),
    PartiesPresent: Joi.string().required(),
    Relationships: Joi.string().required(),
    SummaryOfChildInterview: Joi.string().required(),
    Vulnerabilities: Joi.string().required(),
    ProtectiveCapacities: Joi.string().required(),
    ChangesWillingness: Joi.boolean(),
    ChangesWillingnessDetails: Joi.string().when("ChangesWillingness", {
      is: true,
      then: Joi.required(),
    }),
    ChangesAbility: Joi.boolean(),
    ChangesAbilityDetails: Joi.string().when("ChangesAbility", {
      is: true,
      then: Joi.required(),
    }),
    ChangesMarital: Joi.boolean(),
    ChangesMaritalDetails: Joi.string().when("ChangesMarital", {
      is: true,
      then: Joi.required(),
    }),
    ChangesHealth: Joi.boolean(),
    ChangesHealthDetails: Joi.string().when("ChangesHealth", {
      is: true,
      then: Joi.required(),
    }),
    ChangesPlacement: Joi.boolean(),
    ChangesPlacementDetails: Joi.string().when("ChangesPlacement", {
      is: true,
      then: Joi.required(),
    }),
    ChangesBirth: Joi.boolean(),
    ChangesBirthDetails: Joi.string().when("ChangesBirth", {
      is: true,
      then: Joi.required(),
    }),
    ChangesDeath: Joi.boolean(),
    ChangesDeathDetails: Joi.string().when("ChangesDeath", {
      is: true,
      then: Joi.required(),
    }),
    ChangesCrime: Joi.boolean(),
    ChangesCrimeDetails: Joi.string().when("ChangesCrime", {
      is: true,
      then: Joi.required(),
    }),
    ChangesMembers: Joi.boolean(),
    ChangesMembersDetails: Joi.string().when("ChangesMembers", {
      is: true,
      then: Joi.required(),
    }),
    ChangesRelocation: Joi.boolean(),
    ChangesRelocationDetails: Joi.string().when("ChangesRelocation", {
      is: true,
      then: Joi.required(),
    }),
    ChangesActivities: Joi.boolean(),
    ChangesActivitiesDetails: Joi.string().when("ChangesActivities", {
      is: true,
      then: Joi.required(),
    }),
    ChangesEmployment: Joi.boolean(),
    ChangesEmploymentDetails: Joi.string().when("ChangesEmployment", {
      is: true,
      then: Joi.required(),
    }),
    ChangesRespite: Joi.boolean(),
    ChangesRespiteDetails: Joi.string().when("ChangesRespite", {
      is: true,
      then: Joi.required(),
    }),
    CasePlanProgress: Joi.string().required(),
    Comments: Joi.string().required(),
  },
  "4C5B17DC-7767-EE11-830D-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    DateOfIncident: Joi.string().required(),
    TimeOfIncident: Joi.string().required(),
    FosterHome: Joi.string().required(),
    NotifiedOn: Joi.string().required(),
    NotifiedBy: Joi.string().required(),
    NotifiedByOther: Joi.when("NotifiedBy", {
      is: "Other",
      then: Joi.string().required(),
    }),
    NotifiedMethod: Joi.string().required(),
    NotifiedMethodOther: Joi.when("NotifiedMethod", {
      is: "Other",
      then: Joi.string().required(),
    }),
    TypeOfIncident: Joi.string().required(),
    AbuseInHomeAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.when("AbuseInHomeAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseInHomeAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeNA: Joi.boolean(),
    AbuseInHomeDate: Joi.string().allow(""),
    AbuseInHomeTime: Joi.string().allow(""),
    AbuseInHomeNotes: Joi.string().allow(""),
    AbuseInHomeNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.when("AbuseInHomeNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseInHomeStepsTaken: Joi.string().allow(""),
    AbuseInHomeOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.when("AbuseOutsideHomeAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseOutsideHomeAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeNA: Joi.boolean(),
    AbuseOutsideHomeDate: Joi.string().allow(""),
    AbuseOutsideHomeTime: Joi.string().allow(""),
    AbuseOutsideHomeNotes: Joi.string().allow(""),
    AbuseOutsideHomeNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.when("AbuseOutsideHomeNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseOutsideHomeStepsTaken: Joi.string().allow(""),
    AbuseOutsideHomeOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AWOLDescription: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLLocated: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLPoliceReport: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    AWOLDepartment: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLReportNumber: Joi.string().allow(""),
    AWOLOfficer: Joi.string().allow(""),
    AWOLNoReportReason: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLOutcome: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathClient: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWho: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathClient", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathInvestigation: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhere: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhereOther: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    DeathDescription: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathPoliceReport: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathReportedBy: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathReportInfo: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathNoReportReason: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathStepsTaken: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastDate: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastTime: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjury: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsWeapons: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsGuns: Joi.boolean(),
    HomicidalThoughtsKnives: Joi.boolean(),
    HomicidalThoughtsOtherWeapon: Joi.boolean(),
    HomicidalThoughtsOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsWeapons", {
        is: "Yes",
        then: Joi.when("HomicidalThoughtsOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("HomicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsNA: Joi.boolean(),
    HomicidalThoughtsDate: Joi.string().allow(""),
    HomicidalThoughtsTime: Joi.string().allow(""),
    RestraintAppliedBy: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintAppliedByOther: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintAppliedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    RestraintLength: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintType: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintDescription: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInterventions: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInjury: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInjuryDetails: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    RestraintWellbeing: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintFollowup: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintModifications: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintObservation: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInvestigation: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintOutcome: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintOutcomeOther: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicationRefusalDescription: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalSymptoms: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalSymptomDescription: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.when("MedicationRefusalSymptoms", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationRefusalChronic: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.when("MedicationRefusalChronic", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorType: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorResponsible: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorResponsibleOther: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.when("MedicationErrorResponsible", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorDescription: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorSymptoms: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorSymptomDescription: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.when("MedicationErrorSymptoms", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorInvestigation: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyDescription: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyOutcome: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencySafetyPlan: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    PsychiatricEmergencyNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("PsychiatricEmergencySafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    PsychiatricEmergencyNA: Joi.boolean(),
    PsychiatricEmergencyDate: Joi.string().allow(""),
    PsychiatricEmergencyTime: Joi.string().allow(""),
    MedicalAttentionDrugReaction: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionDescription: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionOutcome: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.when("MedicalAttentionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicalAttentionNA: Joi.boolean(),
    MedicalAttentionDate: Joi.string().allow(""),
    MedicalAttentionTime: Joi.string().allow(""),
    MedicalAttentionChronic: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.when("MedicalAttentionChronic", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsWhere: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsWhereOther: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsStepsTaken: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistory: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsFollowUp: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsOutcome: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsWhere: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsWhereOther: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsIEP: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsPrevention: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsIEP", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsSupport: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsIEP", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsOutcomeDetention: Joi.boolean(),
    ProblematicBehaviorsOutcomeSuspension: Joi.boolean(),
    ProblematicBehaviorsOutcomeExpulsion: Joi.boolean(),
    ProblematicBehaviorsOutcomeSafetyPlan: Joi.boolean(),
    ProblematicBehaviorsOutcomeIEP: Joi.boolean(),
    ProblematicBehaviorsOutcomeOther: Joi.boolean(),
    ProblematicBehaviorsOutcomeOtherDetails: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsOutcomeOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsSuicidal: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.string().required(),
    }),
    SelfHarmBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjury: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsInjury", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsChronic: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsChronic", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsCSSRs: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsNoCSSRsReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsCSSRs", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsNA: Joi.boolean(),
    SuicidalThoughtsDate: Joi.string().allow(""),
    SuicidalThoughtsTime: Joi.string().allow(""),
    SuicideAttemptDescription: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptExistingSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptNoExistingSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptExistingSafetyPlan", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptOutcome: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicideAttemptSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicideAttemptNA: Joi.boolean(),
    SuicideAttemptDate: Joi.string().allow(""),
    SuicideAttemptTime: Joi.string().allow(""),
    COVIDPositiveMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.string().required(),
    }),
    COVIDPositiveMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.when("COVIDPositiveMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    COVIDPositiveMedications: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.string().required(),
    }),
    COVIDPositiveMedicationDetails: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.when("COVIDPositiveMedications", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    COVIDPositiveDate: Joi.string().allow(""),
    COVIDPositiveTime: Joi.string().allow(""),
    COVIDPositiveNA: Joi.boolean(),
    IllegalBehaviorWhere: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorWhereOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorWeapons: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorGuns: Joi.boolean(),
    IllegalBehaviorKnives: Joi.boolean(),
    IllegalBehaviorOtherWeapon: Joi.boolean(),
    IllegalBehaviorOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorWeapons", {
        is: "Yes",
        then: Joi.when("IllegalBehaviorOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    IllegalBehaviorSubstances: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorAlcohol: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorDescription: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorStepsTaken: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistory: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorFollowUp: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorArrested: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcome: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionWhere: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionWhereOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionDescription: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnown: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnownDetails: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionKnown", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    AggressionFollowUp: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcome: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    CarAccidentDescription: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicationAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.when("CarAccidentMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    VictimWhere: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimWhereOther: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.when("VictimWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    VictimDescription: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimWeapons: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimGuns: Joi.boolean(),
    VictimKnives: Joi.boolean(),
    VictimOtherWeapon: Joi.boolean(),
    VictimOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.when("VictimWeapons", {
        is: "Yes",
        then: Joi.when("VictimOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    VictimStepsTaken: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimFollowUp: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    OtherTypeDescription: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeWeapons: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeGuns: Joi.boolean(),
    OtherTypeKnives: Joi.boolean(),
    OtherTypeOtherWeapon: Joi.boolean(),
    OtherTypeOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.when("OtherTypeWeapons", {
        is: "Yes",
        then: Joi.when("OtherTypeOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    OtherTypeStepsTaken: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcome: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.when("OtherTypeOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    CountyNotified: Joi.string().required(),
    CountyNotifiedName: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    CountyNotifiedWhen: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    CountyNotifiedComments: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    NotNotifiedDetails: Joi.when("CountyNotified", {
      is: "No",
      then: Joi.string().required(),
    }),
    OtherNotificationsNeeded: Joi.string().required(),
    OtherNotifiedName: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedWhen: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedComments: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    ResolutionAmendments: Joi.string().allow(""),
  },
  "4A1022F8-656C-EE11-826A-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    DischargeType: Joi.string().required(),
    TransferTo: Joi.string().when("DischargeType", {
      is: "Transfer To:",
      then: Joi.required(),
    }),
    SACWIS: Joi.string().required(),
    DischargeDate: Joi.string().required(),
    PresentingProblemsICCA: Joi.string().required(),
    PresentingProblemsFH: Joi.string().required(),
    DischargeReason: Joi.string().required(),
    DiagnosisAtAdmission: Joi.string().required(),
    DiagnosisAtDischarge: Joi.string().required(),
    PermanencyGoal: Joi.string().required(),
    ILGoal: Joi.string().required(),
    TherapeuticGoal: Joi.string().required(),
    OtherGoal: Joi.string().required(),
    OverallProgress: Joi.string().required(),
    NarrativeSummary: Joi.string().required(),
    TypesOfServices: Joi.string().required(),
    CurrentMedications: Joi.string().required(),
    ClientResponse: Joi.string().required(),
    DischargePlan: Joi.string().required(),
    NewLocation: Joi.string().required(),
    CustodianName: Joi.string().required(),
    SummaryProvided: Joi.string().required(),
    CompletedBy: Joi.string().required(),
    CompletedByCredentials: Joi.string().required(),
    CompletedDate: Joi.string().required(),
  },
  "E66FF96E-F778-EE11-826A-0050F21C6F69": {
    SelectedProgram: Joi.string().required(),
    Date: Joi.string().required(),
    A1: Joi.string().required(),
    A2: Joi.string().required(),
    A3: Joi.string().required(),
    A4: Joi.string().required(),
    A5: Joi.string().required(),
    A6: Joi.string().required(),
    B7: Joi.string().required(),
    B8: Joi.string().required(),
    B9: Joi.string().required(),
    B10: Joi.string().required(),
    B11: Joi.string().required(),
    B12: Joi.string().required(),
    B13: Joi.string().required(),
    B14: Joi.string().required(),
    B15: Joi.string().required(),
    C16: Joi.string().required(),
    C17: Joi.string().required(),
    C18: Joi.string().required(),
    C19: Joi.string().required(),
    C20: Joi.string().required(),
    C21: Joi.string().required(),
    C22: Joi.string().required(),
    AssessmentNeeded: Joi.string().allow(""),
  },
  "9AADDE42-3D7F-EE11-AD36-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    AdultPhysicalAssault: Joi.boolean(),
    AdultSexualAssault: Joi.boolean(),
    AdultSexuallyAbused: Joi.boolean(),
    Arson: Joi.boolean(),
    Bullying: Joi.boolean(),
    Burglary: Joi.boolean(),
    ChildPhysicalAbuse: Joi.boolean(),
    ChildPornography: Joi.boolean(),
    ChildSexualAbuse: Joi.boolean(),
    DomesticViolence: Joi.boolean(),
    DUIIncident: Joi.boolean(),
    ElderAbuse: Joi.boolean(),
    HateCrime: Joi.boolean(),
    HateCrimeOther: Joi.boolean(),
    HateCrimeOtherDetails: Joi.string().when("HateCrimeOther", {
      is: true,
      then: Joi.required(),
    }),
    LaborTrafficking: Joi.boolean(),
    SexTrafficking: Joi.boolean(),
    IdentityTheft: Joi.boolean(),
    Kidnapping: Joi.boolean(),
    KidnappingCustodial: Joi.boolean(),
    MassViolence: Joi.boolean(),
    VehicularVictim: Joi.boolean(),
    Robbery: Joi.boolean(),
    Stalking: Joi.boolean(),
    HomicideSurvivor: Joi.boolean(),
    TeenDating: Joi.boolean(),
    Terrorism: Joi.boolean(),
    OtherVictim: Joi.boolean(),
    OtherVictimDetails: Joi.string().when("OtherVictim", {
      is: true,
      then: Joi.required(),
    }),
    MultipleTypes: Joi.boolean(),
    Deaf: Joi.boolean(),
    Homeless: Joi.boolean(),
    Immigrant: Joi.boolean(),
    LGBTQ: Joi.boolean(),
    Veteran: Joi.boolean(),
    Disabilities: Joi.boolean(),
    LimitedEnglish: Joi.boolean(),
    OtherClassification: Joi.boolean(),
    OtherClassificationDetails: Joi.string().when("OtherClassification", {
      is: true,
      then: Joi.required(),
    }),
    ESLAccommodations: Joi.string().required(),
    ESLAccommodationsDetails: Joi.when("ESLAccommodations", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    Medicaid: Joi.string().required(),
    Counseling: Joi.string().required(),
    CounselingDetails: Joi.when("Counseling", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    Crisis: Joi.string().required(),
    CrisisDetails: Joi.when("Crisis", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    Deodorant: Joi.boolean(),
    Shampoo: Joi.boolean(),
    Conditioner: Joi.boolean(),
    Soap: Joi.boolean(),
    Lotion: Joi.boolean(),
    Toothpaste: Joi.boolean(),
    Toothbrush: Joi.boolean(),
    Pads: Joi.boolean(),
    Tampons: Joi.boolean(),
    Backpack: Joi.boolean(),
    Pencils: Joi.boolean(),
    Pens: Joi.boolean(),
    Folders: Joi.boolean(),
    Notebook: Joi.boolean(),
    Crayons: Joi.boolean(),
    PencilSharpener: Joi.boolean(),
    Notecards: Joi.boolean(),
    Socks: Joi.boolean(),
    Underwear: Joi.boolean(),
    TShirts: Joi.boolean(),
    Gloves: Joi.boolean(),
    HatScarf: Joi.boolean(),
    BusRoute: Joi.boolean(),
    BusPass: Joi.boolean(),
    CabNumber: Joi.boolean(),
    Therapist: Joi.boolean(),
    Pantry: Joi.boolean(),
    CaseMgmt: Joi.boolean(),
    Employment: Joi.boolean(),
    AODServices: Joi.boolean(),
    ChildrenServices: Joi.boolean(),
    CrimeVictimServices: Joi.boolean(),
    Shelters: Joi.boolean(),
    OtherNeeds: Joi.string().allow(""),
    ItemsDistributed: Joi.string().required(),
    NotDistributedReason: Joi.when("ItemsDistributed", {
      is: "No",
      then: Joi.string().required(),
    }),
  },
  "267B02BE-6E7F-EE11-AD36-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    CurrentFacility: Joi.string().required(),
    CurrentMedications: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    ContactDetails: Joi.string().required(),
    VulnerabilitiesNone: Joi.boolean(),
    VulnerabilitiesCommunication: Joi.boolean(),
    VulnerabilitiesSelfProtection: Joi.boolean(),
    VulnerabilitiesAbuse: Joi.boolean(),
    VulnerabilitiesHelpers: Joi.boolean(),
    VulnerabilitiesAge: Joi.boolean(),
    VulnerabilitiesEmotionalNeeds: Joi.boolean(),
    VulnerabilitiesDevelopmental: Joi.boolean(),
    VulnerabilitiesAppearance: Joi.boolean(),
    VulnerabilitiesSpecialNeeds: Joi.boolean(),
    VulnerabilitiesVictimization: Joi.boolean(),
    VulnerabilitiesProvocative: Joi.boolean(),
    VulnerabilitiesResilience: Joi.boolean(),
    VulnerabilitiesRole: Joi.boolean(),
    VulnerabilitiesVisibility: Joi.boolean(),
    VulnerabilitiesDetails: Joi.string().required(),
    ProtectionNeeds: Joi.boolean(),
    ProtectionIntervene: Joi.boolean(),
    ProtectionBond: Joi.boolean(),
    ProtectionProvides: Joi.boolean(),
    ProtectionResponds: Joi.boolean(),
    ProtectionDiscipline: Joi.boolean(),
    ProtectionPositive: Joi.boolean(),
    ProtectionDetails: Joi.string().required(),
    ChangesMarital: Joi.boolean(),
    ChangesHealth: Joi.boolean(),
    ChangesPlacement: Joi.boolean(),
    ChangesBirth: Joi.boolean(),
    ChangesDeath: Joi.boolean(),
    ChangesCrime: Joi.boolean(),
    ChangesMembers: Joi.boolean(),
    ChangesRelocation: Joi.boolean(),
    ChangesActivities: Joi.boolean(),
    ChangesEmployment: Joi.boolean(),
    ChangesDetails: Joi.string()
      .when("ChangesMarital", { is: true, then: Joi.required() })
      .when("ChangesHealth", { is: true, then: Joi.required() })
      .when("ChangesPlacement", { is: true, then: Joi.required() })
      .when("ChangesBirth", { is: true, then: Joi.required() })
      .when("ChangesDeath", { is: true, then: Joi.required() })
      .when("ChangesCrime", { is: true, then: Joi.required() })
      .when("ChangesMembers", { is: true, then: Joi.required() })
      .when("ChangesRelocation", { is: true, then: Joi.required() })
      .when("ChangesActivities", { is: true, then: Joi.required() })
      .when("ChangesEmployment", { is: true, then: Joi.required() }),
    ObjectiveProgress: Joi.string().allow(""),
    GoalProgress: Joi.string().required(),
    PermanencyAdoption: Joi.boolean(),
    PermanencyConcurrentPlan: Joi.boolean(),
    PermanencyIndependent: Joi.boolean(),
    PermanencyCustody: Joi.boolean(),
    PermanencyMaintain: Joi.boolean(),
    PermanencyReunification: Joi.boolean(),
    CollaborationDetails: Joi.string().allow(""),
    SupportiveAcademic: Joi.boolean(),
    SupportiveCounseling: Joi.boolean(),
    SupportiveGrow: Joi.boolean(),
    SupportiveIndependent: Joi.boolean(),
    SupportiveMedical: Joi.boolean(),
    SupportiveMentor: Joi.boolean(),
    SupportiveOccupational: Joi.boolean(),
    SupportivePhysical: Joi.boolean(),
    SupportiveRecreation: Joi.boolean(),
    SupportiveRespite: Joi.boolean(),
    SupportiveSpeech: Joi.boolean(),
    SupportiveTransportation: Joi.boolean(),
    SupportiveOther: Joi.string().allow(""),
    EmotionalFunctioning: Joi.string().required(),
    SchoolProgress: Joi.string().required(),
    AdditionalServices: Joi.string().allow(""),
    LastPhysical: Joi.string().required(),
    LastDental: Joi.string().required(),
    LastVision: Joi.string().required(),
    AdditionalMedical: Joi.string().allow(""),
    ActionPlan: Joi.string().required(),
    SenecaCounty: Joi.string().required(),
    Marks: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    Hygiene: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    DevelopmentalIssues: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    Adjustment: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    Visitation: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    Counseling: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    LifeBook: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    IndependentLiving: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    Interaction: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    NextVisit: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
  },
  "D358B947-0A42-EE11-8457-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    ReasonForCompletion: Joi.string().required(),
    DateOfCompletion: Joi.string().required(),
    PhysicalNeedsMet: Joi.string().required(),
    MentalNeedsMet: Joi.string().required(),
    SupportAccess: Joi.string().required(),
    EducationalNeedsMet: Joi.string().required(),
    ActiveParticipant: Joi.string().required(),
    Comments: Joi.string().allow(""),
  },
  "0E0A0EBD-148E-EE11-AD37-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Completed: Joi.boolean(),
    SiblingInitials: Joi.when("Completed", {
      is: true,
      then: Joi.string().required(),
    }),
    Date: Joi.when("Completed", { is: false, then: Joi.string().required() }),
    MembersPresent: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    CFTGoals: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    StrengthsComments: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    StrengthsSteps: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    WellbeingComments: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    WellbeingSteps: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    MedicalComments: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    MedicalSteps: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    BehaviorsComments: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    BehaviorsSteps: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    PlacementComments: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    PlacementSteps: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    EducationalComments: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    EducationalSteps: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    MentalHealthComments: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    MentalHealthSteps: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    TransitionalLivingComments: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    TransitionalLivingSteps: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    VisitationComments: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    VisitationSteps: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    LegalComments: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    LegalSteps: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    OtherComments: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
    OtherSteps: Joi.when("Completed", {
      is: false,
      then: Joi.string().required(),
    }),
  },
  "87116EFB-900A-EC11-B563-0050F21C6F69": {
    SelectedProgram: Joi.string().required(),
    Acknowledged: Joi.boolean(),
  },
  "4429E2E9-3278-EE11-826A-0050F21C6F69": {
    SelectedProgram: Joi.string().required(),
    LOC: Joi.string().allow(""),
    IncidentDate: Joi.date().required(),
    IncidentTime: Joi.string().required(),
    FosterHome: Joi.string().allow(""),
    StaffDetails: Joi.string().required(),
    ClientDeath: Joi.boolean(),
    SuicideAttempt: Joi.boolean(),
    Emergency: Joi.boolean(),
    EmergencyType: Joi.when("Emergency", {
      is: true,
      then: Joi.string().required(),
    }),
    AWOL: Joi.boolean(),
    AWOLReturnDate: Joi.when("AWOL", {
      is: true,
      then: Joi.string().required(),
    }),
    SeriousInjury: Joi.boolean(),
    SuicideGesture: Joi.boolean(),
    MedicationError: Joi.boolean(),
    OffsiteTreatment: Joi.boolean(),
    OffsiteEmergencyTreatmentLocation: Joi.when("OffsiteTreatment", {
      is: true,
      then: Joi.string().required(),
    }),
    OffsiteAssessment: Joi.boolean(),
    OffsiteEmergencyAssessmentLocation: Joi.when("OffsiteAssessment", {
      is: true,
      then: Joi.string().required(),
    }),
    Weapon: Joi.boolean(),
    WeaponType: Joi.when("Weapon", {
      is: true,
      then: Joi.string().required(),
    }),
    Substance: Joi.boolean(),
    SubstanceType: Joi.when("Substance", {
      is: true,
      then: Joi.string().required(),
    }),
    SchoolRemoval: Joi.boolean(),
    SchoolRemovalType: Joi.when("SchoolRemoval", {
      is: true,
      then: Joi.string().required(),
    }),
    OutsideAgency: Joi.boolean(),
    AgencyInvolved: Joi.when("OutsideAgency", {
      is: true,
      then: Joi.string().required(),
    }),
    Restrained: Joi.boolean(),
    PlacementChange: Joi.boolean(),
    PlacementChangeType: Joi.when("PlacementChange", {
      is: true,
      then: Joi.string().required(),
    }),
    SexTrafficking: Joi.boolean(),
    IncidentDescription: Joi.string().required(),
    PrecipitatingFactors: Joi.string().required(),
    Interventions: Joi.string().required(),
    FollowUpActions: Joi.string().required(),
    NotificationDetails: Joi.array().when("IncidentDate", {
      is: Joi.exist(),
      then: Joi.array().items(
        Joi.object({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          Role: Joi.string().required(),
          Notified: Joi.string().allow(""),
          NotifiedBy: Joi.string().when("Notified", {
            is: Joi.exist(),
            then: Joi.string().required(),
          }),
          Time: Joi.string()
            .regex(/^([0-9]{2}):([0-9]{2})$/)
            .when("Notified", {
              is: Joi.exist(),
              then: Joi.string().required(),
            }),
          Date: Joi.date().when("Notified", {
            is: Joi.exist(),
            then: Joi.date().max("now").required(),
          }),
        })
      ),
    }),
    CompletedBy: Joi.boolean(),
    ClinicalReviewer: Joi.boolean(),
    AdministrativeReviewer: Joi.boolean(),
    CopyDetails: Joi.array().items(
      Joi.object({
        _id: Joi.any(),
        IsEditable: Joi.boolean(),
        Name: Joi.string().allow(""),
        Date: Joi.string().when("Name", {
          is: Joi.exist(),
          then: Joi.string().required(),
        }),
        Time: Joi.string().when("Name", {
          is: Joi.exist(),
          then: Joi.string().required(),
        }),
        Method: Joi.string().when("Name", {
          is: Joi.exist(),
          then: Joi.string().required(),
        }),
      })
    ),
    SAFYTypeOfIncident: Joi.string().allow(""),
  },
  "A71F15E0-DD95-EE11-AD37-0050F21C6F69": {
    SelectedProgram: Joi.string().required(),
    FosterHome: Joi.string().allow(""),
    CaseManagers: Joi.string().allow(""),
    Therapist: Joi.string().allow(""),
    PlacementWorker: Joi.string().required(),
    WorkerPresent: Joi.boolean(),
    BinderGiven: Joi.boolean(),
    CallCompleted: Joi.boolean(),
    TDCheckInDate: Joi.string().required(),
    TDCheckInDetails: Joi.string().required(),
    F2FVisitDate: Joi.string().required(),
    AssessmentDate: Joi.string().required(),
    AssessmentDetails: Joi.string().required(),
    TDCheckIn2Date: Joi.string().required(),
    TDCheckIn2Details: Joi.string().required(),
    StablePlanDate: Joi.string().required(),
    StablePlanDetails: Joi.string().required(),
    PaperworkDate: Joi.string().required(),
  },
  "8EDAC919-C09E-EE11-AD37-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    AgencyId: Joi.string().allow(""),
    ParticipantId: Joi.string().allow(""),
    ProgramStartDate: Joi.string().allow(""),
    DateCompleted: Joi.string().required(),
    TestType: Joi.string().allow(""),
    ProgramDateCompleted: Joi.string().allow(""),
    SurveyMethod: Joi.string().allow(""),
    ReferralSource: Joi.string().allow(""),
    ReportedToCPS: Joi.string().allow(""),
    ReportedToCPSWhen: Joi.when("ReportedToCPS", {
      is: "B. Yes",
      then: Joi.string().required(),
    }),
    ReportSubstantiated: Joi.when("ReportedToCPS", {
      is: "B. Yes",
      then: Joi.string().required(),
    }),
    ProgramAdvocacy: Joi.boolean(),
    ProgramRelationships: Joi.boolean(),
    ProgramVisiting: Joi.boolean(),
    ProgramHousing: Joi.boolean(),
    ProgramEducation: Joi.boolean(),
    ProgramInteraction: Joi.boolean(),
    ProgramSupport: Joi.boolean(),
    ProgramRespite: Joi.boolean(),
    ProgramResources: Joi.boolean(),
    ProgramSkills: Joi.boolean(),
    ProgramOther: Joi.boolean(),
    ProgramOtherDetails: Joi.when("ProgramOther", {
      is: true,
      then: Joi.string().required(),
    }),
    PreTestAttendance: Joi.string().allow(""),
    PostTestAttendance: Joi.string().allow(""),
    GoodFuture: Joi.string().required(),
    FamilyListens: Joi.string().required(),
    SpecialMoments: Joi.string().required(),
    IntentToMisbehave: Joi.string().required(),
    ConstantStop: Joi.string().required(),
    PowerStruggles: Joi.string().required(),
    EmotionalResponse: Joi.string().required(),
    BeliefInMe: Joi.string().required(),
    LifeAdvice: Joi.string().required(),
    SupportiveFriends: Joi.string().required(),
    ShortNotice: Joi.string().required(),
    AdviceMoney: Joi.boolean(),
    AdviceRelationships: Joi.boolean(),
    AdviceFood: Joi.boolean(),
    AdviceStress: Joi.boolean(),
    AdviceParenting: Joi.boolean(),
    AdviceNone: Joi.boolean(),
    StaffUnderstands: Joi.string().required(),
    NoBelief: Joi.string().required(),
    Misunderstood: Joi.string().required(),
    PayRent: Joi.boolean(),
    PayUtilities: Joi.boolean(),
    PayGroceries: Joi.boolean(),
    PayDaycare: Joi.boolean(),
    PayMedical: Joi.boolean(),
    PayBasic: Joi.boolean(),
    PayTransportation: Joi.boolean(),
    PayAll: Joi.boolean(),
    PastDelay: Joi.boolean(),
    PastEvicted: Joi.boolean(),
    PastShelter: Joi.boolean(),
    PastRoommate: Joi.boolean(),
    PastTransporation: Joi.boolean(),
    PastUnemployment: Joi.boolean(),
    PastNone: Joi.boolean(),
    TroubleAffording: Joi.string().required(),
    AffordFood: Joi.string().required(),
    Child1Sex: Joi.string().allow(""),
    Child1Age: Joi.string().allow(""),
    Child1InHome: Joi.string().allow(""),
    Child1Relationship: Joi.string().allow(""),
    Child2Sex: Joi.string().allow(""),
    Child2Age: Joi.string().allow(""),
    Child2InHome: Joi.string().allow(""),
    Child2Relationship: Joi.string().allow(""),
    Child3Sex: Joi.string().allow(""),
    Child3Age: Joi.string().allow(""),
    Child3InHome: Joi.string().allow(""),
    Child3Relationship: Joi.string().allow(""),
    Child4Sex: Joi.string().allow(""),
    Child4Age: Joi.string().allow(""),
    Child4InHome: Joi.string().allow(""),
    Child4Relationship: Joi.string().allow(""),
    ParentGender: Joi.string().allow(""),
    ParentAge: Joi.string().allow(""),
    ParentLanguage: Joi.string().allow(""),
    ParentOtherLanguage: Joi.string().allow(""),
    NativeAmerican: Joi.boolean(),
    Hispanic: Joi.boolean(),
    MultiRacial: Joi.boolean(),
    Asian: Joi.boolean(),
    MiddleEastern: Joi.boolean(),
    OtherRace: Joi.boolean(),
    OtherRaceDetails: Joi.string().allow(""),
    AfricanAmerican: Joi.boolean(),
    NativeHawaiian: Joi.boolean(),
    AfricanNational: Joi.boolean(),
    White: Joi.boolean(),
    ParentRelationship: Joi.string().allow(""),
    FamilyHousing: Joi.string().allow(""),
    FamilyIncome: Joi.string().allow(""),
    FamilyEducation: Joi.string().allow(""),
    ReceiveSNAP: Joi.boolean(),
    ReceiveSSDI: Joi.boolean(),
    ReceiveMedicaid: Joi.boolean(),
    ReceiveEITC: Joi.boolean(),
    ReceiveTANF: Joi.boolean(),
    ReceiveHeadStart: Joi.boolean(),
    ReceiveUnemployment: Joi.boolean(),
    ReceiveStateInsurance: Joi.boolean(),
    ReceiveSSI: Joi.boolean(),
    ReceiveNone: Joi.boolean(),
    ReceiveOther: Joi.boolean(),
  },
  "9E1DB96F-DCA0-EE11-AD37-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    Agency: Joi.string().required(),
    ServicesProvided: Joi.string().required(),
    Attendance: Joi.string().required(),
    AttendanceDetails: Joi.string().when("Attendance", {
      is: "Other",
      then: Joi.required(),
    }),
    Engagement: Joi.string().required(),
    EngagementDetails: Joi.string().when("Engagement", {
      is: "Other",
      then: Joi.required(),
    }),
    ReachOut: Joi.boolean(),
    Navigation: Joi.boolean(),
    Connected: Joi.boolean(),
    CasePlan: Joi.boolean(),
    Other: Joi.boolean(),
    OtherDetails: Joi.string().when("Other", {
      is: true,
      then: Joi.required(),
    }),
    Discharged: Joi.string().required(),
    DischargeReason: Joi.when("Discharged", {
      is: "Yes",
      then: Joi.string().required(),
    }),
  },
  "007F3095-15A1-EE11-AD37-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    ReportMonth: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    PeopleInvolved: Joi.string().required(),
    ChildPrep: Joi.boolean(),
    ChildPrepInHome: Joi.when("ChildPrep", {
      is: true,
      then: Joi.string().required(),
    }),
    FamilyPrep: Joi.boolean(),
    DaysSinceAdmission: Joi.when("FamilyPrep", {
      is: true,
      then: Joi.string().required(),
    }),
    HomeStudyComplete: Joi.when("FamilyPrep", {
      is: true,
      then: Joi.string().required(),
    }),
    SentToIAC: Joi.when("FamilyPrep", {
      is: true,
      then: Joi.when("HomeStudyComplete", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    UnderstandsNeeds: Joi.when("FamilyPrep", {
      is: true,
      then: Joi.string().required(),
    }),
    UnderstandsProcess: Joi.when("FamilyPrep", {
      is: true,
      then: Joi.string().required(),
    }),
    AwareOfPostServices: Joi.when("FamilyPrep", {
      is: true,
      then: Joi.string().required(),
    }),
    HomebasedCasework: Joi.boolean(),
    HomebasedTherapy: Joi.boolean(),
    Reunification: Joi.when("HomebasedCasework", {
      is: true,
      then: Joi.string().required(),
    }).when("HomebasedTherapy", { is: true, then: Joi.string().required() }),
    ParentEducation: Joi.boolean(),
    ServiceDetails: Joi.string().required(),
    Recommendations: Joi.string().required(),
    Progress: Joi.string().required(),
  },
  "EE66740C-7B59-EE11-830D-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    SDHRReportedDate: Joi.string().required().label("SDHR Submit Date"),
    CountyWorkerReportedDate: Joi.string()
      .required()
      .label("County Worker Submit Date"),
    CountySubmitted: Joi.string().required().label("County Submitted to"),
    CountyWorkerName: Joi.string().required().label("Worker Name"),
    CountySubmissionMethod: Joi.string().required().label("Submission Method"),
    InternalReportRecipient: Joi.string()
      .required()
      .label("Internal Report Submitted to"),
    ChildRace: Joi.string().required().label("Child's Race"),
    ChildGender: Joi.string().required().label("Child's Gender"),
    ChildDiagnosis: Joi.string()
      .required()
      .label("Child's Disability/DSM V Diagnosis"),
    DateOfIncident: Joi.string().required().label("Date of Incident"),
    TimeOfIncident: Joi.string().required().label("Time of Incident"),
    ProviderName: Joi.string().required().label("Provider Name"),
    ProviderAddress: Joi.string().required().label("Provider Address"),
    CompletedBy: Joi.string()
      .required()
      .label("Name/Title of Person Completing Form"),
    ProviderContactInfo: Joi.string()
      .required()
      .label("Provider Contact Information"),
    StaffInvolved: Joi.string()
      .required()
      .label("Name of Staff Involved in Incident"),
    Location: Joi.string().required().label("Location of the Incident"),
    PrecipitatingEvent: Joi.string().required().label("Precipitating Event"),
    PrecipitatingEventOther: Joi.when("PrecipitatingEvent", {
      is: "Other",
      then: Joi.string().required().label("Other Precipitating Event details"),
    }),
    ResponseFirstAid: Joi.boolean(),
    ResponseMedication: Joi.boolean(),
    ResponseUrgentCare: Joi.boolean(),
    ResponseSeclusion: Joi.boolean(),
    ResponseRestraint: Joi.boolean(),
    ResponseRoomChanged: Joi.boolean(),
    ResponseLevelReduction: Joi.boolean(),
    ResponseProcessed: Joi.boolean(),
    ResponseProcessedTherapist: Joi.boolean(),
    ResponseAgressionPrecautions: Joi.boolean(),
    ResponseSuspended: Joi.boolean(),
    ResponseSuicidePrecaution: Joi.boolean(),
    HospitalAssessmentCompleted: Joi.boolean(),
    DoctorAssessmentCompleted: Joi.boolean(),
    ResponseLawEnforcement: Joi.boolean(),
    ResponseOther: Joi.boolean(),
    ResponseOtherDetails: Joi.when("ResponseOther", {
      is: true,
      then: Joi.string().required().label("Other Staff Response details"),
    }),
    IncidentType: Joi.string().required().label("Incident Type"),
    MedicationErrorType: Joi.when("IncidentType", {
      is: "Medication Error",
      then: Joi.string().required().label("Medication Error Type"),
    }),
    ClientInjuryType: Joi.when("IncidentType", {
      is: "Client Injury",
      then: Joi.string().required().label("Client Injury Type"),
    }),
    SeclusionLengthHours: Joi.when("IncidentType", {
      is: "Seclusion",
      then: Joi.string().required().label("HOURS"),
    }),
    SeclusionLengthMinutes: Joi.when("IncidentType", {
      is: "Seclusion",
      then: Joi.string().required().label("MINUTES"),
    }),
    RestraintType: Joi.when("IncidentType", {
      is: "Restraint",
      then: Joi.string().required().label("Type of Restraint Method"),
    }),
    RestraintHours: Joi.when("IncidentType", {
      is: "Restraint",
      then: Joi.string().required().label("HOURS"),
    }),
    RestraintMinutes: Joi.when("IncidentType", {
      is: "Restraint",
      then: Joi.string().required().label("MINUTES"),
    }),
    MedicalAttentionRequired: Joi.string()
      .required()
      .label("Medical Attention Required"),
    ChildInjuryDescription: Joi.when("IncidentType", {
      is: "Client Injury",
      then: Joi.string().required().label("Description of Child's Injuries"),
    }),
    MedicalAttentionLocation: Joi.when("MedicalAttentionRequired", {
      is: "Yes",
      then: Joi.string().required().label("Medical Attention Received at"),
    }),
    PoliceReport: Joi.string().required().label("Reported to Police"),
    PoliceReportRecipient: Joi.when("PoliceReport", {
      is: "Yes",
      then: Joi.string().required().label("Police Reported to"),
    }),
    PoliceReportDate: Joi.when("PoliceReport", {
      is: "Yes",
      then: Joi.string().required().label("Date Reported to Police"),
    }),
    Sent1593: Joi.string().required().label("1593 Sent to County DHR"),
    Sent1593County: Joi.string().when("Sent1593", {
      is: "Yes",
      then: Joi.string().required().label("County 1593 Sent to"),
    }),
    Sent1593Date: Joi.string().when("Sent1593", {
      is: "Yes",
      then: Joi.string().required().label("Date 1593 Sent to County DHR"),
    }),
    Sent1593Method: Joi.string().when("Sent1593", {
      is: "Yes",
      then: Joi.string().required().label("Method 1593 Sent to County DHR"),
    }),
    IncidentDescription: Joi.string().required().label("Incident Description"),
    SAFYIncidentType: Joi.string().allow(""),
  },
  "FDF159DC-21A9-EE11-AD37-DC98408D5418": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    SafetyPlanDate: Joi.string().required(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeations: Joi.boolean(),
    SelfHarm: Joi.boolean(),
    AWOL: Joi.boolean(),
    PropertyDestruction: Joi.boolean(),
    PhysicalAggression: Joi.boolean(),
    VerbalAggression: Joi.boolean(),
    SubstanceUse: Joi.boolean(),
    UnsafeSleepBehaviors: Joi.boolean(),
    UnsafeActsTowardsAnimals: Joi.boolean(),
    UnsafeSexualBehaviors: Joi.boolean(),
    HumanTraffickingVictim: Joi.boolean(),
    OtherBehaviors: Joi.boolean(),
    OtherBehaviorsDetails: Joi.string().when("OtherBehaviors", {
      is: true,
      then: Joi.required(),
    }),
    TriggerDetails: Joi.string().when("SubstanceUse", {
      is: true,
      then: Joi.required(),
    }),
    UnsafeActsDetails: Joi.string()
      .when("UnsafeSleepBehaviors", { is: true, then: Joi.required() })
      .when("UnsafeActsTowardsAnimals", { is: true, then: Joi.required() })
      .when("UnsafeSexualBehaviors", { is: true, then: Joi.required() }),
    ReasonsForLiving: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    FeelingToday: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    FeelingAtWorst: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    FeelingWorryPoint: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    CheckInFrequency: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    ScalingQuestion: Joi.string().when("SuicidalIdeation", {
      is: true,
      then: Joi.required(),
    }),
    Sweating: Joi.boolean(),
    BreathingHard: Joi.boolean(),
    RacingHeart: Joi.boolean(),
    ClenchingTeeth: Joi.boolean(),
    ClenchingFists: Joi.boolean(),
    RedFaced: Joi.boolean(),
    LoudVoice: Joi.boolean(),
    Rocking: Joi.boolean(),
    Fidgety: Joi.boolean(),
    Crying: Joi.boolean(),
    SleepingAlot: Joi.boolean(),
    DifficultySleeping: Joi.boolean(),
    Pacing: Joi.boolean(),
    Nauseous: Joi.boolean(),
    Alone: Joi.boolean(),
    RacingThoughts: Joi.boolean(),
    FallAsleep: Joi.boolean(),
    OtherSign: Joi.boolean(),
    OtherSignDetails: Joi.string().when("OtherSign", {
      is: true,
      then: Joi.required(),
    }),
    Yelling: Joi.boolean(),
    Reading: Joi.boolean(),
    Exercise: Joi.boolean(),
    Writing: Joi.boolean(),
    Drawing: Joi.boolean(),
    Watching: Joi.boolean(),
    Support: Joi.boolean(),
    Playing: Joi.boolean(),
    Shower: Joi.boolean(),
    Music: Joi.boolean(),
    Walking: Joi.boolean(),
    Blanket: Joi.boolean(),
    Animals: Joi.boolean(),
    OtherStrategy: Joi.boolean(),
    OtherStrategyDetails: Joi.string().when("OtherStrategy", {
      is: true,
      then: Joi.required(),
    }),
    MySupports: Joi.string().required(),
    SafetyPlan: Joi.string().required(),
    RestrictWeapons: Joi.boolean(),
    RestrictMedications: Joi.boolean(),
    RestrictSharps: Joi.boolean(),
    RestrictPoisons: Joi.boolean(),
    RestrictAlcohol: Joi.boolean(),
    RestrictLighters: Joi.boolean(),
    AlternativeTransportation: Joi.boolean(),
    OtherSteps: Joi.boolean(),
    OtherStepsDetails: Joi.string().when("OtherSteps", {
      is: true,
      then: Joi.required(),
    }),
    AdditionalSteps: Joi.string().allow(""),
    AdditionalComments: Joi.string().allow(""),
    Hotline: Joi.string().required(),
    Hospital: Joi.string().required(),
    CrisisCenter: Joi.string().required(),
    OtherEmergency: Joi.string().allow(""),
    SAFYCrisisLine: Joi.string().required(),
    Amendments: Joi.string().allow(""),
  },
  "5CA3CED4-21A9-EE11-AD37-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    FamilyName: Joi.string().label("Family Name").required(),
    SafetyPlanDate: Joi.string().label("Date of Safety Plan").required(),
    Housing: Joi.boolean(),
    HousingDetails: Joi.string().allow(""),
    Food: Joi.boolean(),
    FoodDetails: Joi.string().allow(""),
    Clothing: Joi.boolean(),
    ClothingDetails: Joi.string().allow(""),
    Transportation: Joi.boolean(),
    TransportationDetails: Joi.string().allow(""),
    MedicalCare: Joi.boolean(),
    MedicalCareDetails: Joi.string().allow(""),
    Childcare: Joi.boolean(),
    ChildcareDetails: Joi.string().allow(""),
    Supervision: Joi.boolean(),
    SupervisionDetails: Joi.string().allow(""),
    DomesticViolence: Joi.boolean(),
    DomesticViolenceDetails: Joi.string().allow(""),
    FamilyConflict: Joi.boolean(),
    FamilyConflictDetails: Joi.string().allow(""),
    SubstanceAbuse: Joi.boolean(),
    SubstanceAbuseDetails: Joi.string().allow(""),
    Deescalation: Joi.boolean(),
    DeescalationDetails: Joi.string().allow(""),
    InfantSafety: Joi.boolean(),
    InfantSafetyDetails: Joi.string().allow(""),
    OtherConcerns: Joi.boolean(),
    OtherConcernsDetails: Joi.string().allow(""),
    FamilyStrengths: Joi.string()
      .label("What are the family's strengths? What is working right now?")
      .required(),
    PerspectiveOfRisk: Joi.string()
      .label("Caregiver/Family Perspective of Risk")
      .required(),
    SafetyNeeds: Joi.string()
      .label(
        "What needs to be in place to ensure the safety and wellbeing of everyone in the family?"
      )
      .required(),
    EnvironmentSteps: Joi.string()
      .label("What are steps the family can take to keep the environment safe?")
      .required(),
    MonitoringSteps: Joi.string()
      .label(
        "What are steps the family can take to have adequate monitoring/supervision?"
      )
      .required(),
    SupportForFamily: Joi.string()
      .label("Who can support the family in meeting their immediate needs?")
      .required(),
    PositiveInteractions: Joi.string()
      .label(
        "How can the family create positive interactions despite their immediate needs/crisis?"
      )
      .required(),
    AssessmentAndSteps: Joi.string()
      .label("Overall Assessment of Family Safety and Immediate Next Steps")
      .required(),
    AdditionalComments: Joi.string().label("Additional Comments"),
    Hotline: Joi.string().label("Hotline"),
    Hospital: Joi.string().label("Hospital/ED"),
    CrisisCenter: Joi.string().label("Crisis Center"),
    OtherEmergency: Joi.string().label("SAFY Crisis Line"),
    SAFYCrisisLine: Joi.string().label("Other"),
    Amendments: Joi.string().allow(""),
  },
  "5BA3CED4-21A9-EE11-AD37-DC98408D5418": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SafetyPlanDate: Joi.string().required(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    SelfHarm: Joi.boolean(),
    AWOL: Joi.boolean(),
    PropertyDestruction: Joi.boolean(),
    PhysicalAggression: Joi.boolean(),
    VerbalAggression: Joi.boolean(),
    SubstanceUse: Joi.boolean(),
    UnsafeSleepBehaviors: Joi.boolean(),
    UnsafeActsTowardsAnimals: Joi.boolean(),
    UnsafeSchoolBehaviors: Joi.boolean(),
    UnsafeSexualBehaviors: Joi.boolean(),
    HumanTraffickingVictim: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.string().allow(""),
    TriggerDetails: Joi.string().allow(""),
    BehaviorDetails: Joi.string().allow(""),
    ReasonsToLive: Joi.string().allow(""),
    FeelingToday: Joi.string().allow(""),
    FeelingAtWorst: Joi.string().allow(""),
    WorryPoint: Joi.string().allow(""),
    CheckInFrequency: Joi.string().allow(""),
    ScalingQuestion: Joi.string().allow(""),
    Sweating: Joi.boolean(),
    BreathingHard: Joi.boolean(),
    RacingHeart: Joi.boolean(),
    ClenchingTeeth: Joi.boolean(),
    ClenchingFists: Joi.boolean(),
    RedFaced: Joi.boolean(),
    LoudVoice: Joi.boolean(),
    Rocking: Joi.boolean(),
    Fidgety: Joi.boolean(),
    Crying: Joi.boolean(),
    SleepingAlot: Joi.boolean(),
    DifficultySleeping: Joi.boolean(),
    Pacing: Joi.boolean(),
    Nauseous: Joi.boolean(),
    Alone: Joi.boolean(),
    RacingThoughts: Joi.boolean(),
    FallAsleep: Joi.boolean(),
    OtherSign: Joi.boolean(),
    OtherSignDetails: Joi.string().allow(""),
    Yelling: Joi.boolean(),
    ReadingHome: Joi.boolean(),
    ExerciseHome: Joi.boolean(),
    WritingHome: Joi.boolean(),
    DrawingHome: Joi.boolean(),
    Watching: Joi.boolean(),
    SupportHome: Joi.boolean(),
    Playing: Joi.boolean(),
    Shower: Joi.boolean(),
    MusicHome: Joi.boolean(),
    WalkingHome: Joi.boolean(),
    BlanketHome: Joi.boolean(),
    AnimalsHome: Joi.boolean(),
    OtherHomeStrategy: Joi.boolean(),
    OtherHomeStrategyDetails: Joi.string().allow(""),
    ReadingSchool: Joi.boolean(),
    ExerciseSchool: Joi.boolean(),
    WritingSchool: Joi.boolean(),
    DrawingSchool: Joi.boolean(),
    SupportSchool: Joi.boolean(),
    SupportTeacher: Joi.boolean(),
    MusicSchool: Joi.boolean(),
    WalkingSchool: Joi.boolean(),
    BlanketSchool: Joi.boolean(),
    AnimalsSchool: Joi.boolean(),
    OtherSchoolStrategy: Joi.boolean(),
    OtherSchoolStrategyDetails: Joi.string().allow(""),
    MySupportsHome: Joi.string().allow(""),
    MySupportsSchool: Joi.string().allow(""),
    SafetyPlan: Joi.string().allow(""),
    TriggersAndWarnings: Joi.string().allow(""),
    TriggersAndWarningsResponse: Joi.string().allow(""),
    Visible: Joi.boolean(),
    SameRoom: Joi.boolean(),
    RestrictedOutings: Joi.boolean(),
    RoomSearch: Joi.boolean(),
    ReviewPhone: Joi.boolean(),
    Cameras: Joi.boolean(),
    RemoveDoors: Joi.boolean(),
    CheckingIn: Joi.boolean(),
    TrackFriendInfo: Joi.boolean(),
    PlanActivities: Joi.boolean(),
    OtherMonitoring: Joi.boolean(),
    OtherMonitoringDetails: Joi.string().allow(""),
    LockupWeapons: Joi.boolean(),
    LockupMeds: Joi.boolean(),
    LockupSharps: Joi.boolean(),
    LockupPoisons: Joi.boolean(),
    DoorWindowAlarms: Joi.boolean(),
    RestrictAlcohol: Joi.boolean(),
    ParkOutside: Joi.boolean(),
    LockupFireStarters: Joi.boolean(),
    KeepKeys: Joi.boolean(),
    OtherSafeStep: Joi.boolean(),
    OtherSafeStepDetails: Joi.string().allow(""),
    SupportChild: Joi.string().allow(""),
    SupportSelf: Joi.string().allow(""),
    AdditionalComments: Joi.string().allow(""),
    Hotline: Joi.string().allow(""),
    Hospital: Joi.string().allow(""),
    CrisisCenter: Joi.string().allow(""),
    Other: Joi.string().allow(""),
    SAFYCrisisCenter: Joi.string().allow(""),
    ResolutionAmendments: Joi.string().allow(""),
  },
  "957CE30D-90A9-EE11-AD37-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    LetterType: Joi.string().required(),
    Date: Joi.string().required(),
    Address: Joi.string().required(),
    Client: Joi.string().required(),
    NextDate: Joi.string().required(),
    DueDate: Joi.string().required(),
    ContactInfo: Joi.string().required(),
    Therapist: Joi.string().required(),
  },
  "BB5CF52F-90A9-EE11-AD37-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    LetterType: Joi.string().required(),
    Date: Joi.string().required(),
    Address: Joi.string().required(),
    Caregiver: Joi.string().required(),
    ClientFirst: Joi.string().required(),
    ClientLast: Joi.string().required(),
    NextDate: Joi.string().required(),
    DueDate: Joi.string().required(),
    ContactInfo: Joi.string().required(),
    Therapist: Joi.string().required(),
  },
  "384407BD-DCAB-EE11-AD37-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    ReasonForCompletion: Joi.string().required(),
    DateOfCompletion: Joi.string().required(),
    PhysicalNeedsMet: Joi.string().required(),
    MentalNeedsMet: Joi.string().required(),
    SupportAccess: Joi.string().required(),
    EducationalNeedsMet: Joi.string().required(),
    ActiveParticipant: Joi.string().required(),
  },
  "C1071278-43AF-EE11-AD37-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    CurrentFacility: Joi.string().required(),
    PrimaryCaregiver: Joi.string().required(),
    SecondaryCaregiver: Joi.string().allow(""),
    ReportMonth: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    ContactDetails: Joi.string().required(),
    Changes: Joi.string().required(),
    SummaryOfChildInterview: Joi.string().required(),
    ChildCondition: Joi.string().required(),
    VulnerabilitiesNone: Joi.boolean(),
    VulnerabilitiesCommunication: Joi.boolean(),
    VulnerabilitiesSelfProtection: Joi.boolean(),
    VulnerabilitiesAbuse: Joi.boolean(),
    VulnerabilitiesHelpers: Joi.boolean(),
    VulnerabilitiesAge: Joi.boolean(),
    VulnerabilitiesEmotionalNeeds: Joi.boolean(),
    VulnerabilitiesDevelopmental: Joi.boolean(),
    VulnerabilitiesAppearance: Joi.boolean(),
    VulnerabilitiesSpecialNeeds: Joi.boolean(),
    VulnerabilitiesVictimization: Joi.boolean(),
    VulnerabilitiesProvocative: Joi.boolean(),
    VulnerabilitiesResilience: Joi.boolean(),
    VulnerabilitiesRole: Joi.boolean(),
    VulnerabilitiesVisibility: Joi.boolean(),
    VulnerabilitiesDetails: Joi.string().required(),
    Strengths: Joi.string().required(),
    ProtectionNeeds: Joi.boolean(),
    ProtectionIntervene: Joi.boolean(),
    ProtectionBond: Joi.boolean(),
    ProtectionProvides: Joi.boolean(),
    ProtectionResponds: Joi.boolean(),
    ProtectionDiscipline: Joi.boolean(),
    ProtectionPositive: Joi.boolean(),
    ProtectionDetails: Joi.string().required(),
    ChangesMarital: Joi.boolean(),
    ChangesHealth: Joi.boolean(),
    ChangesPlacement: Joi.boolean(),
    ChangesBirth: Joi.boolean(),
    ChangesDeath: Joi.boolean(),
    ChangesCrime: Joi.boolean(),
    ChangesMembers: Joi.boolean(),
    ChangesRelocation: Joi.boolean(),
    ChangesActivities: Joi.boolean(),
    ChangesEmployment: Joi.boolean(),
    SupportiveServices: Joi.string().required(),
    GoalProgress: Joi.string().required(),
    PermanencyPlan: Joi.string().required(),
    Comments: Joi.string().allow(""),
  },
  "1355D917-FFAF-EE11-AD37-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    CurrentFacility: Joi.string().required(),
    CurrentMedications: Joi.string().required(),
    ReportMonth: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    ContactDetails: Joi.string().required(),
    VulnerabilitiesNone: Joi.boolean(),
    VulnerabilitiesCommunication: Joi.boolean(),
    VulnerabilitiesSelfProtection: Joi.boolean(),
    VulnerabilitiesAbuse: Joi.boolean(),
    VulnerabilitiesHelpers: Joi.boolean(),
    VulnerabilitiesAge: Joi.boolean(),
    VulnerabilitiesEmotionalNeeds: Joi.boolean(),
    VulnerabilitiesDevelopmental: Joi.boolean(),
    VulnerabilitiesAppearance: Joi.boolean(),
    VulnerabilitiesSpecialNeeds: Joi.boolean(),
    VulnerabilitiesVictimization: Joi.boolean(),
    VulnerabilitiesProvocative: Joi.boolean(),
    VulnerabilitiesResilience: Joi.boolean(),
    VulnerabilitiesRole: Joi.boolean(),
    VulnerabilitiesVisibility: Joi.boolean(),
    VulnerabilitiesDetails: Joi.string().required(),
    ProtectionNeeds: Joi.boolean(),
    ProtectionIntervene: Joi.boolean(),
    ProtectionBond: Joi.boolean(),
    ProtectionProvides: Joi.boolean(),
    ProtectionResponds: Joi.boolean(),
    ProtectionDiscipline: Joi.boolean(),
    ProtectionPositive: Joi.boolean(),
    ProtectionDetails: Joi.string().required(),
    ChangesMarital: Joi.boolean(),
    ChangesHealth: Joi.boolean(),
    ChangesPlacement: Joi.boolean(),
    ChangesBirth: Joi.boolean(),
    ChangesDeath: Joi.boolean(),
    ChangesCrime: Joi.boolean(),
    ChangesMembers: Joi.boolean(),
    ChangesRelocation: Joi.boolean(),
    ChangesActivities: Joi.boolean(),
    ChangesEmployment: Joi.boolean(),
    ChangesDetails: Joi.string()
      .when("ChangesMarital", { is: true, then: Joi.required() })
      .when("ChangesHealth", { is: true, then: Joi.required() })
      .when("ChangesPlacement", { is: true, then: Joi.required() })
      .when("ChangesBirth", { is: true, then: Joi.required() })
      .when("ChangesDeath", { is: true, then: Joi.required() })
      .when("ChangesCrime", { is: true, then: Joi.required() })
      .when("ChangesMembers", { is: true, then: Joi.required() })
      .when("ChangesRelocation", { is: true, then: Joi.required() })
      .when("ChangesActivities", { is: true, then: Joi.required() })
      .when("ChangesEmployment", { is: true, then: Joi.required() }),
    ObjectiveProgress: Joi.string().allow(""),
    GoalProgress: Joi.string().required(),
    PermanencyAdoption: Joi.boolean(),
    PermanencyConcurrentPlan: Joi.boolean(),
    PermanencyIndependent: Joi.boolean(),
    PermanencyCustody: Joi.boolean(),
    PermanencyMaintain: Joi.boolean(),
    PermanencyReunification: Joi.boolean(),
    CollaborationDetails: Joi.string().allow(""),
    SupportiveAcademic: Joi.boolean(),
    SupportiveCounseling: Joi.boolean(),
    SupportiveGrow: Joi.boolean(),
    SupportiveIndependent: Joi.boolean(),
    SupportiveMedical: Joi.boolean(),
    SupportiveMentor: Joi.boolean(),
    SupportiveOccupational: Joi.boolean(),
    SupportivePhysical: Joi.boolean(),
    SupportiveRecreation: Joi.boolean(),
    SupportiveRespite: Joi.boolean(),
    SupportiveSpeech: Joi.boolean(),
    SupportiveTransportation: Joi.boolean(),
    SupportiveOther: Joi.string().allow(""),
    EmotionalFunctioning: Joi.string().required(),
    SchoolProgress: Joi.string().required(),
    AdditionalServices: Joi.string().allow(""),
    LastPhysical: Joi.string().required(),
    LastDental: Joi.string().required(),
    LastVision: Joi.string().required(),
    AdditionalMedical: Joi.string().allow(""),
    ActionPlan: Joi.string().required(),
    SenecaCounty: Joi.string().required(),
    Marks: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    Hygiene: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    DevelopmentalIssues: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    Adjustment: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    Visitation: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    Counseling: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    LifeBook: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    IndependentLiving: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    Interaction: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
    NextVisit: Joi.string().when("SenecaCounty", {
      is: "Yes",
      then: Joi.required(),
    }),
  },
  "040097C3-43AF-EE11-AD37-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    CurrentFacility: Joi.string().required(),
    PrimaryCaregiver: Joi.string().required(),
    SecondaryCaregiver: Joi.string().required(),
    ReportMonth: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    ContactDetails: Joi.string().required(),
    CurrentBehaviors: Joi.string().required(),
    EmotionalFunctioning: Joi.string().required(),
    SocialFunctioning: Joi.string().required(),
    DailyActivities: Joi.string().required(),
    ChildAdjustment: Joi.string().required(),
    PlanReviewed: Joi.string().required(),
    FamilyUpdate: Joi.string().required(),
    PermanencyPlan: Joi.string().required(),
    LifeBookUpdate: Joi.string().required(),
    ChildNeeds: Joi.string().required(),
    SafetyConcerns: Joi.string().required(),
    IRUpdate: Joi.string().required(),
    IRReviewed: Joi.string().required(),
    MedicationLogReviewed: Joi.string().required(),
    MonthlyApptReviewed: Joi.string().required(),
    MonthlyMedicalApptReviewed: Joi.string().required(),
    ChangesMarital: Joi.boolean(),
    ChangesHealth: Joi.boolean(),
    ChangesPlacement: Joi.boolean(),
    ChangesBirth: Joi.boolean(),
    ChangesDeath: Joi.boolean(),
    ChangesCrime: Joi.boolean(),
    ChangesMembers: Joi.boolean(),
    ChangesRelocation: Joi.boolean(),
    ChangesEmployment: Joi.boolean(),
    ChangesDetails: Joi.string()
      .when("ChangesMarital", { is: true, then: Joi.required() })
      .when("ChangesHealth", { is: true, then: Joi.required() })
      .when("ChangesPlacement", { is: true, then: Joi.required() })
      .when("ChangesBirth", { is: true, then: Joi.required() })
      .when("ChangesDeath", { is: true, then: Joi.required() })
      .when("ChangesCrime", { is: true, then: Joi.required() })
      .when("ChangesMembers", { is: true, then: Joi.required() })
      .when("ChangesRelocation", { is: true, then: Joi.required() })
      .when("ChangesEmployment", { is: true, then: Joi.required() }),
    FamilyAdjustment: Joi.string().required(),
    ITPReviewed: Joi.string().required(),
    FamilyNeeds: Joi.string().required(),
    SupportProvided: Joi.string().required(),
    EmergingIssues: Joi.string().required(),
    UpcomingEvents: Joi.string().required(),
  },
  "6BA8133B-0DB0-EE11-AD37-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    Ethnicity: Joi.string().required(),
    ReportMonth: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    ContactDetails: Joi.string().required(),
    ProgressSummary: Joi.string().required(),
    ActivitiesProvided: Joi.string().required(),
    InterventionsUsed: Joi.string().required(),
    ResourceSpecialistObservations: Joi.string().required(),
    FamilyObservations: Joi.string().required(),
  },
  "A1EC49A6-54B6-EE11-AD37-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    ReasonForCompletion: Joi.string().required(),
    DateOfCompletion: Joi.string().required(),
    PhysicalNeedsMet: Joi.string().required(),
    MentalNeedsMet: Joi.string().required(),
    SupportAccess: Joi.string().required(),
    EducationalNeedsMet: Joi.string().required(),
    ActiveParticipant: Joi.string().required(),
    StaffAbuse: Joi.string().required(),
    NonStaffAbuse: Joi.string().required(),
    VisitationPlan: Joi.string().required(),
    VisitationFrequency: Joi.string().when("VisitationPlan", {
      is: "Yes",
      then: Joi.required(),
    }),
    VisitationGoal: Joi.string().when("VisitationPlan", {
      is: "Yes",
      then: Joi.required(),
    }),
    Runaway: Joi.string().required(),
    StableEducation: Joi.string().required(),
    FPAbility: Joi.string().required(),
    DecreasedNeeds: Joi.string().required(),
    UnplannedDischarge: Joi.when("ReasonForCompletion", {
      is: "Discharge",
      then: Joi.string().required(),
    }),
    LengthOfStay: Joi.when("ReasonForCompletion", {
      is: "Discharge",
      then: Joi.string().when("UnplannedDischarge", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DSSRequest: Joi.string().when("ReasonForCompletion", {
      is: "Discharge",
      then: Joi.string().required(),
    }),
  },
  "A935E260-2EB6-EE11-AD37-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    Therapy: Joi.string().required(),
    DecreasedSymptoms: Joi.string().when("Therapy", {
      is: "Yes",
      then: Joi.required(),
    }),
    Maltreatment: Joi.string().required(),
    FirstIncident: Joi.string().when("Maltreatment", {
      is: "Yes",
      then: Joi.required(),
    }),
    OutsideKinship: Joi.string().required(),
    TypeOfCare: Joi.string().when("OutsideKinship", {
      is: "Yes",
      then: Joi.required(),
    }),
    TypeOfCareDetails: Joi.string().when("TypeOfCare", {
      is: "Other",
      then: Joi.required(),
    }),
    Discharged: Joi.string().required(),
    AchievedMajority: Joi.string().when("Discharged", {
      is: "Yes",
      then: Joi.required(),
    }),
    Permanency: Joi.string().when("Discharged", {
      is: "Yes",
      then: Joi.required(),
    }),
    PermanencyType: Joi.string().when("Permanency", {
      is: "Yes",
      then: Joi.required(),
    }),
    PrimaryFamilyContact: Joi.string().required(),
    ProgressSummary: Joi.string().allow(""),
    Concerns: Joi.string().allow(""),
  },
  "1113B547-07B7-EE11-AD37-DC98408D5418": {
    SelectedProgram: Joi.string().label("Client Program").required(),
    DateCompleted: Joi.string().required().label("Date Completed"),
    PSDType: Joi.string().label("Type of PSD").required(),
    ReviewReason: Joi.string()
      .label("Reason")
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ReferralMembers: Joi.string()
      .label("Family Members on Referral")
      .required(),
    CaseMember: Joi.string()
      .label("Family Member listed under Case ID")
      .required(),
    MaGIKCaseID: Joi.string().label("MaGIK Case ID").required(),
    Caseworker: Joi.string().label("Caseworker").required(),
    Division: Joi.string().label("SAFY Division").required(),
    County: Joi.string().label("County").required(),
    CountyDetails: Joi.string()
      .label("County")
      .when("County", { is: "Other", then: Joi.required() }),
    ISFamily: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISDCS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.string()
      .label("Other Information Source details")
      .when("ISOther", { is: true, then: Joi.required() }),
    ReferralReason: Joi.string().label("Reason for Referral").required(),
    PresentingProblem: Joi.string()
      .label("Description of the Problem(s)")
      .required(),
    ProtectiveFactors: Joi.string().label("Protective Factors").required(),
    CurrentHousehold: Joi.string().label("Current Household").required(),
    OtherFamilySupports: Joi.string().label("Other Family Supports").required(),
    CaregiverCooperation: Joi.string()
      .label("Cooperation between caregivers")
      .required(),
    CaregiverCooperationDetails: Joi.string()
      .label("Cooperation between caregivers details")
      .when("CaregiverCooperation", { is: "No", then: Joi.required() }),
    SupervisionDifficulties: Joi.string()
      .label("Difficulties with the supervision")
      .required(),
    SupervisionDifficultiesDetails: Joi.string()
      .label("Difficulties with the supervision details")
      .when("SupervisionDifficulties", { is: "Yes", then: Joi.required() }),
    DisciplinePractices: Joi.string().label("Discipline practices").required(),
    Interaction: Joi.string()
      .label("Interaction between caregivers and child(ren)")
      .required(),
    FamilyHistoryUnknown: Joi.boolean(),
    FamilyHistoryDetails: Joi.string()
      .label("Extended Family History")
      .when("FamilyHistoryUnknown", { is: "false", then: Joi.required() }),
    CulturalGroup: Joi.string().label("Identified cultural group").required(),
    TraditionsComments: Joi.string()
      .label("Special cultural traditions/celebrations/rituals")
      .required(),
    LanguagesSpoken: Joi.string().label("Languages spoken").required(),
    Religion: Joi.string()
      .label("Identified religion/belief system")
      .required(),
    ReligionRole: Joi.string()
      .label("Role of faith in client's life")
      .required(),
    GenderOrientation: Joi.string()
      .label("Gender identity & sexual orientation")
      .required(),
    PCP: Joi.string().label("Primary Care Physician").required(),
    LastMedicalExamDates: Joi.string()
      .label("Date(s) of last medical exam for child(ren)")
      .required(),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.string()
      .label("Allergies details")
      .when("Allergies", { is: true, then: Joi.required() }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.string()
      .label("Medical Conditions Details")
      .when("MedicalConditions", { is: true, then: Joi.required() }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.string()
      .label("Nutritional Concerns Details")
      .when("NutritionalConcerns", { is: true, then: Joi.required() }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.string()
      .label("Dental Concerns Details")
      .when("DentalConcerns", { is: true, then: Joi.required() }),
    SleepConcerns: Joi.boolean(),
    SleepConcernsDetails: Joi.string()
      .label("Sleep Concerns Details")
      .when("SleepConcerns", { is: true, then: Joi.required() }),
    Hospitalizations: Joi.boolean(),
    HospitalizationsDetails: Joi.string()
      .label("Hospitalization Details")
      .when("Hospitalizations", { is: true, then: Joi.required() }),
    HeadInjury: Joi.boolean(),
    HeadInjuryDetails: Joi.string()
      .label("Head Injury Details")
      .when("HeadInjury", { is: true, then: Joi.required() }),
    Undiagnosed: Joi.string().label("Undiagnosed illness symptoms").required(),
    UndiagnosedComments: Joi.string()
      .label("Undiagnosed illness symptom details")
      .when("Undiagnosed", { is: "Yes", then: Joi.required() }),
    PregnancyHistory: Joi.string().label("Pregnancy History").required(),
    MilestonesMet: Joi.string()
      .label("Developmental milestones met on time")
      .required(),
    MilestonesMetDetails: Joi.string()
      .label("Milestone details")
      .when("MilestonesMet", { is: "No", then: Joi.required() }),
    SpecialNeeds: Joi.string()
      .label("Developmental delays or special needs")
      .required(),
    SpecialNeedsDetails: Joi.string()
      .label("Special needs details")
      .when("SpecialNeeds", { is: "Yes", then: Joi.required() }),
    SpecializedServices: Joi.string().label("Specialized Services").required(),
    SpecializedServicesDetails: Joi.string()
      .label("Specialized Services details")
      .when("SpecializedServices", { is: "Yes", then: Joi.required() }),
    HasMedications: Joi.string().required(),
    CurrentMedicationDetails: Joi.string()
      .label("Current Medications")
      .when("HasMedications", { is: "Yes", then: Joi.required() }),
    HadMedications: Joi.string().required(),
    PsychotropicMedications: Joi.string()
      .label("Past Psychotropic Medications")
      .when("HadMedications", { is: "Yes", then: Joi.required() }),
    SexualHistoryDetails: Joi.string().required(),
    HasMentalHealthTreatment: Joi.string().required(),
    MentalHealthTreatment: Joi.string()
      .label("Mental Health Treatment")
      .when("HasMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    NoSelfHarm: Joi.boolean(),
    SelfHarmDetails: Joi.string().label("Self Harm Details").required(),
    AllSelfHarmScreened: Joi.string()
      .label("All family members screened")
      .required(),
    NotAllSelfHarmScreenedDetails: Joi.string()
      .label("Not all family members screened details")
      .when("AllSelfHarmScreened", { is: "No", then: Joi.required() }),
    SelfHarmComments: Joi.string()
      .label("Comments/Action Taken")
      .when("NoSelfHarm", { is: false, then: Joi.required() }),
    NoHarmingOthers: Joi.boolean(),
    HarmingOthersDetails: Joi.string()
      .label("Harm to Others/Endangerment details")
      .required(),
    AllHarmOthersScreened: Joi.string()
      .label("All family members screened")
      .required(),
    NotAllHarmOthersScreenedDetails: Joi.string()
      .label("Not all family members screened details")
      .when("AllHarmOthersScreened", { is: "No", then: Joi.required() }),
    HarmingOthersComments: Joi.string()
      .label("Comments/Action Taken")
      .when("NoHarmingOthers", { is: false, then: Joi.required() }),
    EducationDetails: Joi.string().label("Education details").required(),
    NoneEmployed: Joi.boolean(),
    EmploymentDetails: Joi.string().label("Employment details").required(),
    MilitaryHistory: Joi.string()
      .label("Family members' military history")
      .required(),
    MilitaryHistoryDetails: Joi.string()
      .label("Military history details")
      .when("MilitaryHistory", { is: "Yes", then: Joi.required() }),
    NoSubstanceUse: Joi.boolean(),
    SubstanceUseHistory: Joi.string()
      .label("Substance Use history")
      .when("NoSubstanceUse", { is: false, then: Joi.required() }),
    HasSubstanceUseTreatment: Joi.string().required(),
    SUTreatmentHistory: Joi.string()
      .label("Substance Use Treatment history")
      .when("HasSubstanceUseTreatment", { is: "Yes", then: Joi.required() }),
    TraumaHistory: Joi.string().label("Trauma history").required(),
    FamilyChanges: Joi.string()
      .label("Changes/transitions in family")
      .required(),
    FamilyChangesDetails: Joi.string()
      .label("Changes/transitions in family description")
      .when("FamilyChanges", { is: "Yes", then: Joi.required() }),
    RecentGrief: Joi.string()
      .label("Recent or significant deaths/grief issues")
      .required(),
    RecentGriefDetails: Joi.string()
      .label("Recent or significant deaths/grief issues details")
      .when("RecentGrief", { is: "Yes", then: Joi.required() }),
    MentalStatusNA: Joi.boolean(),
    MentalStatusDetails: Joi.string()
      .label("Mental Status")
      .when("MentalStatusNA", { is: false, then: Joi.required() }),
    SymptomsNA: Joi.boolean(),
    Symptoms: Joi.string()
      .label("Symptoms")
      .when("SymptomsNA", { is: false, then: Joi.required() }),
    SymptomsNAComments: Joi.string()
      .label("Comments")
      .when("SymptomsNA", { is: true, then: Joi.required() }),
    Hygiene: Joi.string().label("Personal appearance and hygiene").required(),
    HygieneFamilyMembers: Joi.string()
      .label("Personal appearance and hygiene Family Members")
      .when("Hygiene", { is: "Yes", then: Joi.required() }),
    HygieneDetails: Joi.string()
      .label("Personal appearance and hygiene Details")
      .when("Hygiene", { is: "Yes", then: Joi.required() }),
    MoneyManagement: Joi.string().label("Money management").required(),
    MoneyManagementFamilyMembers: Joi.string()
      .label("Money management Family Members")
      .when("MoneyManagement", { is: "Yes", then: Joi.required() }),
    MoneyManagementDetails: Joi.string()
      .label("Money management Details")
      .when("MoneyManagement", { is: "Yes", then: Joi.required() }),
    FoodManagement: Joi.string().label("Food management").required(),
    FoodManagementFamilyMembers: Joi.string()
      .label("Food management Family Members")
      .when("FoodManagement", { is: "Yes", then: Joi.required() }),
    FoodManagementDetails: Joi.string()
      .label("Food management Details")
      .when("FoodManagement", { is: "Yes", then: Joi.required() }),
    Health: Joi.string().label("Health").required(),
    HealthFamilyMembers: Joi.string()
      .label("Health Family Members")
      .when("Health", { is: "Yes", then: Joi.required() }),
    HealthDetails: Joi.string()
      .label("Health Details")
      .when("Health", { is: "Yes", then: Joi.required() }),
    Housekeeping: Joi.string().label("Housekeeping").required(),
    HousekeepingFamilyMembers: Joi.string()
      .label("Housekeeping Family Members")
      .when("Housekeeping", { is: "Yes", then: Joi.required() }),
    HousekeepingDetails: Joi.string()
      .label("Housekeeping Details")
      .when("Housekeeping", { is: "Yes", then: Joi.required() }),
    Transportation: Joi.string().label("Transportation").required(),
    TransportationFamilyMembers: Joi.string()
      .label("Transportation Family Members")
      .when("Transportation", { is: "Yes", then: Joi.required() }),
    TransportationDetails: Joi.string()
      .label("Transportation Details")
      .when("Transportation", { is: "Yes", then: Joi.required() }),
    SafetySkills: Joi.string().label("Safety Skills").required(),
    SafetySkillsFamilyMembers: Joi.string()
      .label("Safety Skills Family Members")
      .when("SafetySkills", { is: "Yes", then: Joi.required() }),
    SafetySkillsDetails: Joi.string()
      .label("Safety Skills Details")
      .when("SafetySkills", { is: "Yes", then: Joi.required() }),
    ResourceKnowledge: Joi.string().label("ResourceKnowledge").required(),
    ResourceKnowledgeFamilyMembers: Joi.string()
      .label("Resource Knowledge Family Members")
      .when("ResourceKnowledge", { is: "Yes", then: Joi.required() }),
    ResourceKnowledgeDetails: Joi.string()
      .label("Resource Knowledge Details")
      .when("ResourceKnowledge", { is: "Yes", then: Joi.required() }),
    TimeManagement: Joi.string().label("Time Management").required(),
    TimeManagementFamilyMembers: Joi.string()
      .label("Time Management Family Members")
      .when("TimeManagement", { is: "Yes", then: Joi.required() }),
    TimeManagementDetails: Joi.string()
      .label("Time Management Details")
      .when("TimeManagement", { is: "Yes", then: Joi.required() }),
    InteractionWithOthers: Joi.string().label("Interaction").required(),
    InteractionFamilyMembers: Joi.string()
      .label("Interaction Family Members")
      .when("InteractionWithOthers", { is: "Yes", then: Joi.required() }),
    InteractionDetails: Joi.string()
      .label("Interaction Details")
      .when("InteractionWithOthers", { is: "Yes", then: Joi.required() }),
    PsychosocialFunctioning: Joi.string()
      .label("Psychosocial Functioning")
      .required(),
    LegalInvolvement: Joi.string().label("Legal Involvement").required(),
    LegalInvolvementDetails: Joi.string()
      .label("Legal History")
      .when("LegalInvolvement", { is: "Yes", then: Joi.required() }),
    CPSInvolvement: Joi.string().label("CPS Involvement").required(),
    CPSInvolvementDetails: Joi.string()
      .label("CPS History")
      .when("CPSInvolvement", { is: "Yes", then: Joi.required() }),
    PFS2CompletionStatus: Joi.string()
      .label("PFS-2 completion status")
      .required(),
    Resilience: Joi.string()
      .label("Family Functioning/Resilience")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    Attachment: Joi.string()
      .label("Nurturing and Attachment")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    SocialSupports: Joi.string()
      .label("Social Supports")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    PractitionerRelationship: Joi.string()
      .label("Caregiver/Practitioner Relationship")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    ConcreteSupports: Joi.string()
      .label("Concrete Supports")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() }),
    OtherTools: Joi.string().label("Other tools used").required(),
    OtherToolsDetails: Joi.string()
      .label("Other tool details")
      .when("OtherTools", { is: "Yes", then: Joi.required() }),
    Interpretation: Joi.string()
      .label("Interpretation of Scores")
      .when("PFS2CompletionStatus", { is: "Completed", then: Joi.required() })
      .when("OtherTools", { is: "Yes", then: Joi.required() }),
    ClinicalSummary: Joi.string()
      .label("Clinical Observations/Family Clinical Summary")
      .required(),
    RiskFactors: Joi.string()
      .label("Areas of Concern/Risk Factors/Potential Barriers")
      .required(),
    ConcreteNeeds: Joi.string().label("Concrete Needs").required(),
    DischargePlan: Joi.string()
      .label("Family's Perspective/Plan for Discharge")
      .required(),
    DiagnosisDetails: Joi.string().label("Diagnosis Details").required(),
    TreatmentRecommendations: Joi.string()
      .label("Treatment Recommendations")
      .required(),
    AdditionalPsychiatric: Joi.boolean(),
    AdditionalPsychological: Joi.boolean(),
    AdditionalNeurological: Joi.boolean(),
    AdditionalEducational: Joi.boolean(),
    AdditionalMedical: Joi.boolean(),
    AdditionalDental: Joi.boolean(),
    AdditionalSubstanceAbuse: Joi.boolean(),
    AdditionalVocational: Joi.boolean(),
    AdditionalOccupational: Joi.boolean(),
    AdditionalNutritional: Joi.boolean(),
    AdditionalVisualAuditory: Joi.boolean(),
    AdditionalDomesticViolence: Joi.boolean(),
    AdditionalSexOffender: Joi.boolean(),
    AdditionalOther: Joi.boolean(),
    AdditionalOtherDetails: Joi.string()
      .label("Other Evaluations Needed details")
      .when("AdditionalOther", { is: true, then: Joi.required() }),
    MembersInNeed: Joi.string()
      .label("Family Member(s) in need of evaluation")
      .when("AdditionalPsychiatric", { is: true, then: Joi.required() })
      .when("AdditionalPsychological", { is: true, then: Joi.required() })
      .when("AdditionalNeurological", { is: true, then: Joi.required() })
      .when("AdditionalEducational", { is: true, then: Joi.required() })
      .when("AdditionalMedical", { is: true, then: Joi.required() })
      .when("AdditionalDental", { is: true, then: Joi.required() })
      .when("AdditionalSubstanceAbuse", { is: true, then: Joi.required() })
      .when("AdditionalVocational", { is: true, then: Joi.required() })
      .when("AdditionalOccupational", { is: true, then: Joi.required() })
      .when("AdditionalNutritional", { is: true, then: Joi.required() })
      .when("AdditionalVisualAuditory", { is: true, then: Joi.required() })
      .when("AdditionalDomesticViolence", { is: true, then: Joi.required() })
      .when("AdditionalSexOffender", { is: true, then: Joi.required() })
      .when("AdditionalOther", { is: true, then: Joi.required() }),
  },
  "8288357B-46C1-EE11-AD37-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    DateCompleted: Joi.string().required(),
    PreviousDateCompleted: Joi.string().allow(""),
    AssessmentType: Joi.string().required(),
    AssessorName: Joi.string().required(),
    TotalScore: Joi.number().required(),
    SettingScaleScore: Joi.number().required(),
    BehavioralScaleScore: Joi.number().required(),
    WakingChild: Joi.number().required().min(0).max(100),
    HelpingBathe: Joi.number().required().min(0).max(100),
    GoingToDoctor: Joi.number().required().min(0).max(100),
    ChildReadyToLeave: Joi.number().required().min(0).max(100),
    ChildReadyToToilet: Joi.number().required().min(0).max(100),
    ShoppingWithChild: Joi.number().required().min(0).max(100),
    TravelingByCar: Joi.number().required().min(0).max(100),
    Daycare: Joi.number().required().min(0).max(100),
    VisitingFriends: Joi.number().required().min(0).max(100),
    HavingVisitors: Joi.number().required().min(0).max(100),
    InConversation: Joi.number().required().min(0).max(100),
    OnTelephone: Joi.number().required().min(0).max(100),
    PreparingMeals: Joi.number().required().min(0).max(100),
    BusyWithChores: Joi.number().required().min(0).max(100),
    RefusesCommands: Joi.number().required().min(0).max(100),
    UpsetWhenDisappointed: Joi.number().required().min(0).max(100),
    DefiantBehavior: Joi.number().required().min(0).max(100),
    Tantrums: Joi.number().required().min(0).max(100),
    Yelling: Joi.number().required().min(0).max(100),
    AnswersBack: Joi.number().required().min(0).max(100),
    Whines: Joi.number().required().min(0).max(100),
    Interrupts: Joi.number().required().min(0).max(100),
    RefusesFood: Joi.number().required().min(0).max(100),
    RefusesChores: Joi.number().required().min(0).max(100),
    ArguesAboutRules: Joi.number().required().min(0).max(100),
    SeeksAttention: Joi.number().required().min(0).max(100),
    TooLongDressing: Joi.number().required().min(0).max(100),
    TooLongEating: Joi.number().required().min(0).max(100),
    PreviousTotalScore: Joi.number(),
    PreviousSettingScaleScore: Joi.number(),
    PreviousBehavioralScaleScore: Joi.number(),
    PreviousWakingChild: Joi.number(),
    PreviousHelpingBathe: Joi.number(),
    PreviousGoingToDoctor: Joi.number(),
    PreviousChildReadyToLeave: Joi.number(),
    PreviousChildReadyToToilet: Joi.number(),
    PreviousShoppingWithChild: Joi.number(),
    PreviousTravelingByCar: Joi.number(),
    PreviousDaycare: Joi.number(),
    PreviousVisitingFriends: Joi.number(),
    PreviousHavingVisitors: Joi.number(),
    PreviousInConversation: Joi.number(),
    PreviousOnTelephone: Joi.number(),
    PreviousPreparingMeals: Joi.number(),
    PreviousBusyWithChores: Joi.number(),
    PreviousRefusesCommands: Joi.number(),
    PreviousUpsetWhenDisappointed: Joi.number(),
    PreviousDefiantBehavior: Joi.number(),
    PreviousTantrums: Joi.number(),
    PreviousYelling: Joi.number(),
    PreviousAnswersBack: Joi.number(),
    PreviousWhines: Joi.number(),
    PreviousInterrupts: Joi.number(),
    PreviousRefusesFood: Joi.number(),
    PreviousRefusesChores: Joi.number(),
    PreviousArguesAboutRules: Joi.number(),
    PreviousSeeksAttention: Joi.number(),
    PreviousTooLongDressing: Joi.number(),
    PreviousTooLongEating: Joi.number(),
  },
  "0E13DC65-03C6-EE11-9F01-0050F21C6F69": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateOfDischarge: Joi.string()
      .allow("")
      .required()
      .label("Date of Discharge"),
    DischargedTo: Joi.string()
      .allow("")
      .required()
      .label("Person/Agency to which client has been discharged"),
    DischargedToAddress: Joi.string()
      .allow("")
      .required()
      .label("Address of where client has been discharged"),
    DischargeReason: Joi.string()
      .allow("")
      .required()
      .label("Reason for discharge"),
    BriefExplanation: Joi.string()
      .allow("")
      .label("Brief Explanation")
      .when("DischargeReason", {
        is: "186460008",
        then: Joi.required(),
      })
      .when("DischargeReason", {
        is: "186460005",
        then: Joi.required(),
      })
      .when("DischargeReason", {
        is: "186460006",
        then: Joi.required(),
      }),
    OutpatientMentalHealth: Joi.boolean(),
    OutpatientMentalHealthReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("OutpatientMentalHealth", {
        is: true,
        then: Joi.required(),
      }),
    OutpatientSubstanceAbuse: Joi.string()
      .allow("")
      .label("Outpatient Alcohol/Substance Abuse"),
    OutpatientSubstanceAbuseReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("OutpatientSubstanceAbuse", {
        is: true,
        then: Joi.required(),
      }),
    HousingAssistance: Joi.boolean(),
    HousingAssistanceReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("HousingAssistance", {
        is: true,
        then: Joi.required(),
      }),
    JobTraining: Joi.boolean(),
    JobTrainingReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("JobTraining", {
        is: true,
        then: Joi.required(),
      }),
    EducationServices: Joi.boolean(),
    EducationServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("EducationServices", {
        is: true,
        then: Joi.required(),
      }),
    Tutoring: Joi.boolean(),
    TutoringReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("Tutoring", { is: true, then: Joi.required() }),
    PsychiatricAppointment: Joi.boolean(),
    PsychiatricAppointmentReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("PsychiatricAppointment", {
        is: true,
        then: Joi.required(),
      }),
    Prescriptions: Joi.boolean(),
    PrescriptionsReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("Prescriptions", {
        is: true,
        then: Joi.required(),
      }),
    MedicalServices: Joi.boolean(),
    MedicalServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("MedicalServices", {
        is: true,
        then: Joi.required(),
      }),
    Probation: Joi.boolean(),
    ProbationReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("Probation", {
        is: true,
        then: Joi.required(),
      }),
    LegalServices: Joi.boolean(),
    LegalServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("LegalServices", {
        is: true,
        then: Joi.required(),
      }),
    PhysicianAppointment: Joi.boolean(),
    PhysicianAppointmentReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("PhysicianAppointment", {
        is: true,
        then: Joi.required(),
      }),
    WelfareSupport: Joi.boolean(),
    WelfareSupportReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("WelfareSupport", {
        is: true,
        then: Joi.required(),
      }),
    FinancialSupport: Joi.boolean(),
    FinancialSupportReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("FinancialSupport", {
        is: true,
        then: Joi.required(),
      }),
    InHomeServices: Joi.boolean(),
    InHomeServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("InHomeServices", {
        is: true,
        then: Joi.required(),
      }),
    OtherServices: Joi.boolean(),
    OtherServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("OtherServices", {
        is: true,
        then: Joi.required(),
      }),
    LocalCrisisCenter: Joi.string()
      .allow("")
      .required()
      .label("Local Crisis Center"),
    LocalCrisisCenterDetails: Joi.string()
      .allow("")
      .required()
      .label("Local Crisis Center Details"),
    ServicesNarrative: Joi.string()
      .allow("")
      .required()
      .label("Services Narrative"),
    PlacementHistory: Joi.string()
      .allow("")
      .required()
      .label("Placement History"),
    Behavior: Joi.string().required().label("Behavior"),
    SocialInteraction: Joi.string()
      .allow("")
      .required()
      .label("Social and Peer Interaction"),
    ResponseToCaregivers: Joi.string()
      .allow("")
      .required()
      .label("Response to Caregives or Redirection"),
    SchoolInformation: Joi.string()
      .allow("")
      .required()
      .label("School Information and Participation"),
    AdditionalAccomplishments: Joi.string()
      .allow("")
      .required()
      .label("Additional Accomplishments"),
    FollowUp: Joi.string()
      .allow("")
      .required()
      .label("Follow-up/Scheduled Appointments"),
  },
  "8E4BF385-D1C6-EE11-9F01-0050F21C6F69": {
    SelectedProgram: Joi.string().required(),
    PlanType: Joi.string().required(),
    PlanDate: Joi.string().required(),
    NextReviewDate: Joi.string().required(),
    StrengthsAndNeeds: Joi.string().required(),
    ServicesAndProviders: Joi.string().required(),
    PlanParticipants: Joi.string().required(),
    FocusAdvocacy: Joi.boolean(),
    FocusCaregiverHealth: Joi.boolean(),
    FocusEmotionalSupport: Joi.boolean(),
    FocusChildHealth: Joi.boolean(),
    FocusGeneralParenting: Joi.boolean(),
    FocusHomemaker: Joi.boolean(),
    FocusCareerExploration: Joi.boolean(),
    FocusParentEducation: Joi.boolean(),
    FocusReferrals: Joi.boolean(),
    FocusSkillBuilding: Joi.boolean(),
    FocusChildEducation: Joi.boolean(),
    FocusTransportation: Joi.boolean(),
    FocusOther: Joi.boolean(),
    FocusOtherDetails: Joi.when("FocusOther", {
      is: true,
      then: Joi.string().required(),
    }),
    FamilyUnitNeeds: Joi.string().required(),
    FamilyUnitDomainGoals: Joi.string().required(),
    CaregiverGoals: Joi.string().required(),
    ChildGoals: Joi.string().required(),
    ReportMonth: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    ContactDetails: Joi.string().required(),
  },
  "FD002518-E9CA-EE11-9F01-0050F21C6F69": {
    SelectedProgram: Joi.string().required(),
    Ethnicity: Joi.string().required(),
    Consent: Joi.string().required(),
    SessionCount: Joi.string().required(),
    LastSessionDate: Joi.string().required(),
    DSSInvolved: Joi.string().required(),
    SummaryNarrative: Joi.string().required(),
    FamilyFunctioningDomain: Joi.string().required(),
    CaregiverFunctioningDomain: Joi.string().required(),
    ChildFunctioningDomain: Joi.string().required(),
    AftercarePlan: Joi.string().required(),
    Recommendations: Joi.string().allow(""),
    FastAssessment: Joi.string().required(),
    FamilyServicePlanDate: Joi.string().required(),
    FamilyServicePlanGoals: Joi.string()
      .required()
      .label("Family Service Plan with Discharge type"),
  },
  "D744BFD3-58B5-EE11-AD37-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    DateCompleted: Joi.string().required(),
    AssessmentType: Joi.string().required(),
    AssessorName: Joi.string().required(),
    FamilyConflict: Joi.number().required().min(0).max(3),
    FamilyRoleAppropriateness: Joi.number().required().min(0).max(3),
    FamilySafety: Joi.number().required().min(0).max(3),
    FinancialResources: Joi.number().required().min(0).max(3),
    ResidentialStability: Joi.number().required().min(0).max(3),
    FamilySocialIdentity: Joi.number().required().min(0).max(3),
    FamilyCollaboration: Joi.number().required().min(0).max(3),
    SiblingRelationships: Joi.number().required().min(0).max(3),
    ExtendedRelationships: Joi.number().required().min(0).max(3),
    NaturalSupports: Joi.number().required().min(0).max(3),
    FamilyTraditions: Joi.number().required().min(0).max(3),
    KnowledgeOfNeeds: Joi.number().required().min(0).max(4),
    KnowledgeOfOptions: Joi.number().required().min(0).max(4),
    KnowledgeOfRights: Joi.number().required().min(0).max(4),
    AbilityToListen: Joi.number().required().min(0).max(4),
    AbilityToCommunicate: Joi.number().required().min(0).max(4),
    FamilyLanguage: Joi.number().required().min(0).max(3),
    FamilyCulturalStress: Joi.number().required().min(0).max(3),
    FamilyRationale: Joi.string().required(),
    CaregiverAssessments: Joi.array()
      .min(1)
      .items(
        Joi.object({
          _id: Joi.any(),
          Name: Joi.string().required(),
          Monitoring: Joi.number().required().min(0).max(3),
          Knowledge: Joi.number().required().min(0).max(3),
          Boundaries: Joi.number().required().min(0).max(3),
          Discipline: Joi.number().required().min(0).max(3),
          Medical: Joi.number().required().min(0).max(3),
          MentalHealth: Joi.number().required().min(0).max(3),
          Developmental: Joi.number().required().min(0).max(3),
          SubstanceUse: Joi.number().required().min(0).max(3),
          TraumaticReaction: Joi.number().required().min(0).max(3),
          Psychosis: Joi.when("MentalHealth", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          MoodDisturbance: Joi.when("MentalHealth", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          Depression: Joi.when("MentalHealth", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          ImpulseControl: Joi.when("MentalHealth", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          Anxiety: Joi.when("MentalHealth", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          Problems: Joi.when("MentalHealth", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          Antisocial: Joi.when("MentalHealth", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          Anger: Joi.when("MentalHealth", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          EatingDisturbance: Joi.when("MentalHealth", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          SUSeverity: Joi.when("SubstanceUse", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          SUDuration: Joi.when("SubstanceUse", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          RecoveryStage: Joi.when("SubstanceUse", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          PeerInfluences: Joi.when("SubstanceUse", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          EnvInfluences: Joi.when("SubstanceUse", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          RecoverySupport: Joi.when("SubstanceUse", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          AcuteIntoxication: Joi.when("SubstanceUse", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          WithdrawalHistory: Joi.when("SubstanceUse", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          WithdrawalRisks: Joi.when("SubstanceUse", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          TriggerAwareness: Joi.when("SubstanceUse", {
            is: Joi.number().greater(0),
            then: Joi.number().required().min(0).max(3),
          }),
          SexualAbuse: Joi.when("TraumaticReaction", {
            is: Joi.number().greater(0),
            then: Joi.string().required(),
          }),
          PhysicalAbuse: Joi.when("TraumaticReaction", {
            is: Joi.number().greater(0),
            then: Joi.string().required(),
          }),
          Neglect: Joi.when("TraumaticReaction", {
            is: Joi.number().greater(0),
            then: Joi.string().required(),
          }),
          EmotionalAbuse: Joi.when("TraumaticReaction", {
            is: Joi.number().greater(0),
            then: Joi.string().required(),
          }),
          MedicalTrauma: Joi.when("TraumaticReaction", {
            is: Joi.number().greater(0),
            then: Joi.string().required(),
          }),
          DisasterTrauma: Joi.when("TraumaticReaction", {
            is: Joi.number().greater(0),
            then: Joi.string().required(),
          }),
          FamilyViolence: Joi.when("TraumaticReaction", {
            is: Joi.number().greater(0),
            then: Joi.string().required(),
          }),
          SchoolViolence: Joi.when("TraumaticReaction", {
            is: Joi.number().greater(0),
            then: Joi.string().required(),
          }),
          WarTrauma: Joi.when("TraumaticReaction", {
            is: Joi.number().greater(0),
            then: Joi.string().required(),
          }),
          CriminalActsTrauma: Joi.when("TraumaticReaction", {
            is: Joi.number().greater(0),
            then: Joi.string().required(),
          }),
          ParentalCriminalTrauma: Joi.when("TraumaticReaction", {
            is: Joi.number().greater(0),
            then: Joi.string().required(),
          }),
          AttachmentTrauma: Joi.when("TraumaticReaction", {
            is: Joi.number().greater(0),
            then: Joi.string().required(),
          }),
          NeedsRationale: Joi.string().allow(""),
          Involvement: Joi.number().required().min(0).max(3),
          Responsiveness: Joi.number().required().min(0).max(3),
          Organization: Joi.number().required().min(0).max(3),
          StrengthsRationale: Joi.string().required(),
          Errors: Joi.any(),
          IsEditable: Joi.boolean(),
        })
      ),
    ToddlerAssessmentsNA: Joi.boolean(),
    ToddlerAssessments: Joi.when("ToddlerAssessmentsNA", {
      is: true,
      then: Joi.any(),
      otherwise: Joi.array()
        .items(
          Joi.object({
            _id: Joi.any(),
            Name: Joi.string().required(),
            EarlyEducation: Joi.number().required().min(0).max(3),
            SocialFunctioning: Joi.number().required().min(0).max(3),
            Developmental: Joi.number().required().min(0).max(3),
            Medical: Joi.number().required().min(0).max(3),
            FunctioningRationale: Joi.string().allow(""),
            FamilyStrengths: Joi.number().required().min(0).max(3),
            Interpersonal: Joi.number().required().min(0).max(3),
            Playfulness: Joi.number().required().min(0).max(3),
            Adaptability: Joi.number().required().min(0).max(3),
            StrengthsRationale: Joi.string().allow(""),
            Errors: Joi.any(),
            IsEditable: Joi.boolean(),
          })
        )
        .min(1),
    }),
    ChildAssessmentsNA: Joi.boolean(),
    ChildAssessments: Joi.when("ChildAssessmentsNA", {
      is: true,
      then: Joi.any(),
      otherwise: Joi.array()
        .min(1)
        .items(
          Joi.object({
            _id: Joi.any(),
            Name: Joi.string().required(),
            SocialFuntioning: Joi.number().required().min(0).max(3),
            Medical: Joi.number().required().min(0).max(3),
            Sleep: Joi.number().required().min(0).max(3),
            Developmental: Joi.number().required().min(0).max(3),
            SexualDevelopment: Joi.number().required().min(0).max(3),
            School: Joi.number().required().min(0).max(3),
            Behavioral: Joi.number().required().min(0).max(3),
            RiskBehaviors: Joi.number().required().min(0).max(3),
            Adjustment: Joi.number().required().min(0).max(3),
            Psychosis: Joi.when("Behavioral", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            Impulsivity: Joi.when("Behavioral", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            Depression: Joi.when("Behavioral", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            Anxiety: Joi.when("Behavioral", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            Oppositional: Joi.when("Behavioral", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            Conduct: Joi.when("Behavioral", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            SubstanceUse: Joi.when("Behavioral", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            EatingDisturbance: Joi.when("Behavioral", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            Anger: Joi.when("Behavioral", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            SuicideRisk: Joi.when("RiskBehaviors", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            SelfInjurious: Joi.when("RiskBehaviors", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            Recklessness: Joi.when("RiskBehaviors", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            DangerToOthers: Joi.when("RiskBehaviors", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            SexualAggression: Joi.when("RiskBehaviors", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            Runaway: Joi.when("RiskBehaviors", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            Delinquent: Joi.when("RiskBehaviors", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            FireSetting: Joi.when("RiskBehaviors", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            Misbehavior: Joi.when("RiskBehaviors", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            Bullying: Joi.when("RiskBehaviors", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            Exploitation: Joi.when("RiskBehaviors", {
              is: Joi.number().greater(0),
              then: Joi.number().required().min(0).max(3),
            }),
            SexualAbuse: Joi.when("Adjustment", {
              is: Joi.number().greater(0),
              then: Joi.string().required(),
            }),
            PhysicalAbuse: Joi.when("Adjustment", {
              is: Joi.number().greater(0),
              then: Joi.string().required(),
            }),
            Neglect: Joi.when("Adjustment", {
              is: Joi.number().greater(0),
              then: Joi.string().required(),
            }),
            EmotionalAbuse: Joi.when("Adjustment", {
              is: Joi.number().greater(0),
              then: Joi.string().required(),
            }),
            MedicalTrauma: Joi.when("Adjustment", {
              is: Joi.number().greater(0),
              then: Joi.string().required(),
            }),
            DisasterTrauma: Joi.when("Adjustment", {
              is: Joi.number().greater(0),
              then: Joi.string().required(),
            }),
            FamilyViolence: Joi.when("Adjustment", {
              is: Joi.number().greater(0),
              then: Joi.string().required(),
            }),
            SchoolViolence: Joi.when("Adjustment", {
              is: Joi.number().greater(0),
              then: Joi.string().required(),
            }),
            WarTrauma: Joi.when("Adjustment", {
              is: Joi.number().greater(0),
              then: Joi.string().required(),
            }),
            CriminalActsTrauma: Joi.when("Adjustment", {
              is: Joi.number().greater(0),
              then: Joi.string().required(),
            }),
            ParentalCriminalTrauma: Joi.when("Adjustment", {
              is: Joi.number().greater(0),
              then: Joi.string().required(),
            }),
            AttachmentTrauma: Joi.when("Adjustment", {
              is: Joi.number().greater(0),
              then: Joi.string().required(),
            }),
            NeedsRationale: Joi.string().allow(""),
            FamilyStrengths: Joi.number().required().min(0).max(3),
            CommunityLife: Joi.number().required().min(0).max(3),
            Talents: Joi.number().required().min(0).max(3),
            Optimism: Joi.number().required().min(0).max(3),
            StrengthsRationale: Joi.string().required(),
            Errors: Joi.any(),
            IsEditable: Joi.boolean(),
          })
        )
        .min(1),
    }),
  },
  "CC4C35F6-7BDA-EE11-9F01-0050F21C6F69": {
    SelectedProgram: Joi.string().label("Selected Program").required(),
    Age: Joi.number(),
    MonthEnding: Joi.string().required(),
    CaseManager: Joi.string().required(),
    SSNumber: Joi.string().required(),
    DateOfApproval: Joi.string().allow(""),
    DateOfReview: Joi.string().allow(""),
    OverallGoals: Joi.string().required(),
    TreatmentPlan: Joi.string().required(),
    LivingSkills: Joi.string().required(),
    Therapy: Joi.string().required(),
    Adjustment: Joi.string().required(),
    Services: Joi.string().required(),
    ReturnProgress: Joi.string().required(),
    PermanencyGoal: Joi.string().required(),
    EmployedFullTime: Joi.boolean(),
    EnrolledFullTime: Joi.boolean(),
    EmployedEnrolledPartTime: Joi.boolean(),
    HighSchool: Joi.boolean(),
    College: Joi.boolean(),
    JobBarriers: Joi.boolean(),
    Incapable: Joi.boolean(),
    RequirementsNotMet: Joi.boolean(),
    Hours: Joi.when("Age", {
      is: Joi.number().greater(18),
      then: Joi.when("EmployedFullTime", {
        is: true,
        then: Joi.string().required(),
      }).when("EmployedEnrolledPartTime", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    IndependentLivingProgress: Joi.when("Age", {
      is: Joi.number().greater(18),
      then: Joi.string().required(),
    }),
    HispanicLatino: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    RecognizedTribe: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    AmericanNative: Joi.boolean(),
    Asian: Joi.boolean(),
    Black: Joi.boolean(),
    White: Joi.boolean(),
    PacificIslander: Joi.boolean(),
    ReceivedOtherState: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    ReceivedOtherStateName: Joi.when("ReceivedOtherState", {
      is: false,
      then: Joi.string().allow(""),
    }),
    AdoptedOtherState: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    AdoptedOtherStateName: Joi.when("AdoptedOtherState", {
      is: false,
      then: Joi.string().allow(""),
    }),
    SupervisedIL: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    Delinquent: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    DOJJServices: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    SpecialEdServices: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    LastCompletedGrade: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    LastCompletedSchool: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    CurrentGrade: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    CurrentSchool: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    LastCompletedILAssessment: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    AcademicSupportNA: Joi.boolean(),
    AcademicSupportDetails: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.when("AcademicSupportNA", {
        is: true,
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      }),
    }),
    AcademicCounseling: Joi.boolean(),
    LiteracyTraining: Joi.boolean(),
    ResourcesHelp: Joi.boolean(),
    GEDPrep: Joi.boolean(),
    HomeworkHelp: Joi.boolean(),
    StudySkillsTraining: Joi.boolean(),
    PostSecEdSupportNA: Joi.boolean(),
    PostSecEdSupportDetails: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.when("PostSecEdSupportNA", {
        is: true,
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      }),
    }),
    TestPrep: Joi.boolean(),
    FinancialAid: Joi.boolean(),
    CollegeCounseling: Joi.boolean(),
    CollegeTutoring: Joi.boolean(),
    CompletingApplications: Joi.boolean(),
    CareerPrepNA: Joi.boolean(),
    CareerPrepDetails: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.when("CareerPrepNA", {
        is: true,
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      }),
    }),
    ResumeWritingAssistance: Joi.boolean(),
    InterviewAssistance: Joi.boolean(),
    CareerInterest: Joi.boolean(),
    VocationalGoals: Joi.boolean(),
    JobSearch: Joi.boolean(),
    JobShadowing: Joi.boolean(),
    TeamworkTraining: Joi.boolean(),
    JobReferrals: Joi.boolean(),
    RetentionSupport: Joi.boolean(),
    WorkPermits: Joi.boolean(),
    CustomerRelations: Joi.boolean(),
    EmployeeBenefits: Joi.boolean(),
    WorkplaceValues: Joi.boolean(),
    CareerResourceLibraries: Joi.boolean(),
    VocationalAssessment: Joi.boolean(),
    VocationalTrainingNA: Joi.boolean(),
    VocationalTrainingDetails: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.when("VocationalTrainingNA", {
        is: true,
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      }),
    }),
    Internship: Joi.boolean(),
    TradePrograms: Joi.boolean(),
    OccupationalClasses: Joi.boolean(),
    FinancialTrainingNA: Joi.boolean(),
    FinancialTrainingDetails: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.when("FinancialTrainingNA", {
        is: true,
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      }),
    }),
    CreditInformation: Joi.boolean(),
    LoansAndTaxes: Joi.boolean(),
    BalancingChackbook: Joi.boolean(),
    UsingBankAccounts: Joi.boolean(),
    CompletingTaxForms: Joi.boolean(),
    BudgetLivingTraining: Joi.boolean(),
    ConsumerAwareness: Joi.boolean(),
    FinancialCounseling: Joi.boolean(),
    HomeManagementTrainingNA: Joi.boolean(),
    HomeManagementTrainingDetails: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.when("HomeManagementTrainingNA", {
        is: true,
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      }),
    }),
    Maintenance: Joi.boolean(),
    SecurityDeposits: Joi.boolean(),
    HousingAssistance: Joi.boolean(),
    CooperativeLiving: Joi.boolean(),
    RentalApplications: Joi.boolean(),
    MealPlanning: Joi.boolean(),
    LandlordComplaints: Joi.boolean(),
    SafeHomeTraining: Joi.boolean(),
    TenantsRights: Joi.boolean(),
    RiskPreventionTrainingNA: Joi.boolean(),
    RiskPreventionTrainingDetails: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.when("RiskPreventionTrainingNA", {
        is: true,
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      }),
    }),
    SupplementalAssistance: Joi.boolean(),
    FirstAid: Joi.boolean(),
    PowerOfAttorney: Joi.boolean(),
    HealthCareResources: Joi.boolean(),
    HealthCareProxy: Joi.boolean(),
    STDPrevention: Joi.boolean(),
    HealthInsuranceOptions: Joi.boolean(),
    HealthyLivingInfo: Joi.boolean(),
    SexEducation: Joi.boolean(),
    MedicalDental: Joi.boolean(),
    SubstanceAbuse: Joi.boolean(),
    PregnancyPlanning: Joi.boolean(),
    HealthyMarriageNA: Joi.boolean(),
    HealthyMarriageDetails: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.when("HealthyMarriageNA", {
        is: true,
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      }),
    }),
    ChildcareSkills: Joi.boolean(),
    ViolencePrevention: Joi.boolean(),
    StableFamilyInfo: Joi.boolean(),
    Communication: Joi.boolean(),
    Responsibility: Joi.boolean(),
    MentoringFromMurray: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    MentoringFromOther: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    MentoringFromOtherName: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.when("MentoringFromOther", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MentorName: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.when("MentoringFromMurray", {
        is: "Yes",
        then: Joi.string().required(),
      }).when("MentoringFromOther", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MentorDates: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.when("MentoringFromMurray", {
        is: "Yes",
        then: Joi.string().required(),
      }).when("MentoringFromOther", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MentorAddress: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.when("MentoringFromMurray", {
        is: "Yes",
        then: Joi.string().required(),
      }).when("MentoringFromOther", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    HousingAuthorityAssistance: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    OtherAgencyRoomAssistance: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    OtherAgencyRoomAssitanceName: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.when("OtherAgencyRoomAssistance", {
        is: "Yes",
        then: Joi.string().allow(""),
      }),
    }),
    TuitionWaiver: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    EducationalVoucher: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    OtherAgencyFinancialAssistance: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    OtherAgencyFinancialAssitanceName: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.when("OtherAgencyFinancialAssistance", {
        is: "Yes",
        then: Joi.string().allow(""),
      }),
    }),
    OtherFinancialAssistance: Joi.when("Age", {
      is: Joi.number().greater(16),
      then: Joi.string().required(),
    }),
    CompletedBy: Joi.string().required(),
    SupervisorName: Joi.string().required(),
  },
  "00D58351-3FE2-EE11-9F01-0050F21C6F69": {
    SelectedProgram: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    Agency: Joi.string().required(),
    ServicesProvided: Joi.string().required(),
    Attendance: Joi.string().required(),
    AttendanceDetails: Joi.string().when("Attendance", {
      is: "Other",
      then: Joi.required(),
    }),
    Engagement: Joi.string().required(),
    EngagementDetails: Joi.string().when("Engagement", {
      is: "Other",
      then: Joi.required(),
    }),
    ReachOut: Joi.boolean(),
    Navigation: Joi.boolean(),
    Connected: Joi.boolean(),
    CasePlan: Joi.boolean(),
    Other: Joi.boolean(),
    OtherDetails: Joi.string().when("Other", {
      is: true,
      then: Joi.required(),
    }),
    Discharged: Joi.string().required(),
    DischargeReason: Joi.when("Discharged", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    AftercareSupportDate: Joi.when("Discharged", {
      is: "Yes",
      then: Joi.when("DischargeReason", {
        is: "Reunification/Aftercare",
        then: Joi.string().required(),
      }),
    }),
  },
  "BE2DB4E6-FBE5-EE11-8076-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    MeetingDate: Joi.string().required(),
    Medicaid: Joi.string().allow(""),
    TreatmentTeam: Joi.array()
      .min(1)
      .items(
        Joi.object({
          _id: Joi.any(),
          Name: Joi.string().required(),
          Relationship: Joi.string().required(),
          AttendedMeeting: Joi.string().required(),
          DateSigned: Joi.string().allow(""),
          Comments: Joi.string().allow(""),
          Errors: Joi.any(),
          IsEditable: Joi.boolean(),
        })
      ),
    Invited: Joi.array().items(
      Joi.object({
        _id: Joi.any(),
        Name: Joi.string().required(),
        Relationship: Joi.string().required(),
        Reason: Joi.string().required(),
        Errors: Joi.any(),
        IsEditable: Joi.boolean(),
      })
    ),
  },
  "A787D86D-86F3-EE11-8076-0050F21C6F69": {
    SelectedProgram: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    FamilyMembers: Joi.string().required(),
    Maltreatment: Joi.string().required(),
    FirstIncident: Joi.string().when("Maltreatment", {
      is: "Yes",
      then: Joi.required(),
    }),
    OutsideKinship: Joi.string().required(),
    TypeOfCare: Joi.string().when("OutsideKinship", {
      is: "Yes",
      then: Joi.required(),
    }),
    TypeOfCareDetails: Joi.string().when("TypeOfCare", {
      is: "Other",
      then: Joi.required(),
    }),
    PrimaryFamilyContact: Joi.string().required(),
    CaregiversAttended: Joi.string().required(),
    CaregiversCount: Joi.when("CaregiversAttended", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    ProgressSummary: Joi.string().allow(""),
    Concerns: Joi.string().allow(""),
  },
  "323F6B61-3C12-EF11-8076-DC98408D5418": {
    SelectedProgram: Joi.string().required(),
    DateOfIncident: Joi.string().required(),
    TimeOfIncident: Joi.string().required(),
    FosterHome: Joi.string().required(),
    NotifiedOn: Joi.string().required(),
    NotifiedBy: Joi.string().required(),
    NotifiedByOther: Joi.when("NotifiedBy", {
      is: "Other",
      then: Joi.string().required(),
    }),
    NotifiedMethod: Joi.string().required(),
    NotifiedMethodOther: Joi.when("NotifiedMethod", {
      is: "Other",
      then: Joi.string().required(),
    }),
    TypeOfIncident: Joi.string().required(),
    AbuseInHomeAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.when("AbuseInHomeAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseInHomeAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeNA: Joi.boolean(),
    AbuseInHomeDate: Joi.string().allow(""),
    AbuseInHomeTime: Joi.string().allow(""),
    AbuseInHomeNotes: Joi.string().allow(""),
    AbuseInHomeNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.when("AbuseInHomeNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseInHomeStepsTaken: Joi.string().allow(""),
    AbuseInHomeOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.when("AbuseOutsideHomeAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseOutsideHomeAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeNA: Joi.boolean(),
    AbuseOutsideHomeDate: Joi.string().allow(""),
    AbuseOutsideHomeTime: Joi.string().allow(""),
    AbuseOutsideHomeNotes: Joi.string().allow(""),
    AbuseOutsideHomeNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.when("AbuseOutsideHomeNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseOutsideHomeStepsTaken: Joi.string().allow(""),
    AbuseOutsideHomeOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AWOLDescription: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLLocated: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLPoliceReport: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    AWOLDepartment: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLReportNumber: Joi.string().allow(""),
    AWOLOfficer: Joi.string().allow(""),
    AWOLNoReportReason: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLOutcome: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathClient: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWho: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathClient", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathInvestigation: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhere: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhereOther: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    DeathDescription: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathPoliceReport: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathReportedBy: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathReportInfo: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathNoReportReason: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathStepsTaken: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastDate: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastTime: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjury: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsWeapons: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsGuns: Joi.boolean(),
    HomicidalThoughtsKnives: Joi.boolean(),
    HomicidalThoughtsOtherWeapon: Joi.boolean(),
    HomicidalThoughtsOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsWeapons", {
        is: "Yes",
        then: Joi.when("HomicidalThoughtsOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("HomicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsNA: Joi.boolean(),
    HomicidalThoughtsDate: Joi.string().allow(""),
    HomicidalThoughtsTime: Joi.string().allow(""),
    RestraintAppliedBy: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintAppliedByOther: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintAppliedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    RestraintLength: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintType: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintDescription: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInterventions: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInjury: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInjuryDetails: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    RestraintWellbeing: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintFollowup: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintModifications: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintObservation: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInvestigation: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintOutcome: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintOutcomeOther: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicationRefusalDescription: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalSymptoms: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalSymptomDescription: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.when("MedicationRefusalSymptoms", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationRefusalChronic: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.when("MedicationRefusalChronic", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorType: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorResponsible: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorResponsibleOther: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.when("MedicationErrorResponsible", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorDescription: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorSymptoms: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorSymptomDescription: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.when("MedicationErrorSymptoms", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorInvestigation: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyDescription: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyOutcome: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencySafetyPlan: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    PsychiatricEmergencyNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("PsychiatricEmergencySafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    PsychiatricEmergencyNA: Joi.boolean(),
    PsychiatricEmergencyDate: Joi.string().allow(""),
    PsychiatricEmergencyTime: Joi.string().allow(""),
    MedicalAttentionDescription: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionOutcome: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.when("MedicalAttentionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicalAttentionNA: Joi.boolean(),
    MedicalAttentionDate: Joi.string().allow(""),
    MedicalAttentionTime: Joi.string().allow(""),
    MedicalAttentionChronic: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.when("MedicalAttentionChronic", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsWhere: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsWhereOther: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsStepsTaken: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistory: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsFollowUp: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsOutcome: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsWhere: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsWhereOther: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsIEP: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsPrevention: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsIEP", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsSupport: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsIEP", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsOutcomeDetention: Joi.boolean(),
    ProblematicBehaviorsOutcomeSuspension: Joi.boolean(),
    ProblematicBehaviorsOutcomeExpulsion: Joi.boolean(),
    ProblematicBehaviorsOutcomeSafetyPlan: Joi.boolean(),
    ProblematicBehaviorsOutcomeIEP: Joi.boolean(),
    ProblematicBehaviorsOutcomeOther: Joi.boolean(),
    ProblematicBehaviorsOutcomeOtherDetails: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsOutcomeOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsSuicidal: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.string().required(),
    }),
    SelfHarmBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjury: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsInjury", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsChronic: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsChronic", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsCSSRs: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsNoCSSRsReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsCSSRs", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsNA: Joi.boolean(),
    SuicidalThoughtsDate: Joi.string().allow(""),
    SuicidalThoughtsTime: Joi.string().allow(""),
    SuicideAttemptDescription: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptExistingSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptNoExistingSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptExistingSafetyPlan", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptOutcome: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicideAttemptSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicideAttemptNA: Joi.boolean(),
    SuicideAttemptDate: Joi.string().allow(""),
    SuicideAttemptTime: Joi.string().allow(""),
    COVIDPositiveMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.string().required(),
    }),
    COVIDPositiveMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.when("COVIDPositiveMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    COVIDPositiveMedications: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.string().required(),
    }),
    COVIDPositiveMedicationDetails: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.when("COVIDPositiveMedications", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    COVIDPositiveDate: Joi.string().allow(""),
    COVIDPositiveTime: Joi.string().allow(""),
    COVIDPositiveNA: Joi.boolean(),
    IllegalBehaviorWhere: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorWhereOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorWeapons: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorGuns: Joi.boolean(),
    IllegalBehaviorKnives: Joi.boolean(),
    IllegalBehaviorOtherWeapon: Joi.boolean(),
    IllegalBehaviorOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorOtherWeapon", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorDescription: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorStepsTaken: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistory: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorFollowUp: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorArrested: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcome: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionWhere: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionWhereOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionDescription: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnown: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnownDetails: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionKnown", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    AggressionFollowUp: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcome: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    CarAccidentDescription: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicationAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.when("CarAccidentMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    VictimWhere: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimWhereOther: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.when("VictimWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    VictimDescription: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimWeapons: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimGuns: Joi.boolean(),
    VictimKnives: Joi.boolean(),
    VictimOtherWeapon: Joi.boolean(),
    VictimOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.when("VictimWeapons", {
        is: "Yes",
        then: Joi.when("VictimOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    VictimStepsTaken: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimFollowUp: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    OtherTypeDescription: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeWeapons: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeGuns: Joi.boolean(),
    OtherTypeKnives: Joi.boolean(),
    OtherTypeOtherWeapon: Joi.boolean(),
    OtherTypeOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.when("OtherTypeWeapons", {
        is: "Yes",
        then: Joi.when("OtherTypeOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    OtherTypeStepsTaken: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcome: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcomeOther: Joi.when("OtherTypeOutcome", {
      is: "Other",
      then: Joi.string().required(),
    }),
    CountyNotified: Joi.string().required(),
    CountyNotifiedName: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    CountyNotifiedWhen: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    CountyNotifiedComments: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    NotNotifiedDetails: Joi.when("CountyNotified", {
      is: "No",
      then: Joi.string().required(),
    }),
    OtherNotificationsNeeded: Joi.string().required(),
    OtherNotifiedName: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedWhen: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedComments: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    ResolutionAmendments: Joi.string().allow(""),
  },
  "95FA3A4C-EB42-EF11-9361-0050F21C6F69": {
    SelectedProgram: Joi.string().required(),
    PlanType: Joi.string().required().label("Plan Type"),
    CrisisPlanDate: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().required().label("Date of Plan"),
    }),
    Participants: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().required().label("Participants"),
    }),
    YouthName: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Youth Name"),
    }),
    FileNumber: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Wrap File #"),
    }),
    DateCompleted: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.date().max("now").required().label("Date"),
    }),
    DateOfBirth: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.date().max("now").required().label("Date of Birth"),
    }),
    GuardianName: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Guardian Name"),
    }),
    GuardianPhone: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Guardian Phone"),
    }),
    GuardianAddress: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Guardian Address"),
    }),
    PlanStartDate: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.date().required().label("Start Date"),
    }),
    PlanTargetDate: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.date().required().label("Target Completion Date"),
    }),
    FamilyVision: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.array()
        .items({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          Vision: Joi.string().required().label("Vision"),
          Rating: Joi.string()
            .when("PlanType", {
              is: "Review",
              then: Joi.string().required().label("Rating"),
            })
            .when("PlanType", {
              is: "Discharge",
              then: Joi.string().required().label("Rating"),
            }),
          EndDate: Joi.alternatives([
            Joi.date().allow(null),
            Joi.string().valid(""),
          ]).label("End Date"),
        })
        .min(1)
        .label("Family Vision"),
    }),
    TeamMission: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.array()
        .items({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          Mission: Joi.string().required().label("Mission"),
          Rating: Joi.string()
            .when("PlanType", {
              is: "Review",
              then: Joi.string().required().label("Rating"),
            })
            .when("PlanType", {
              is: "Discharge",
              then: Joi.string().required().label("Rating"),
            }),
          EndDate: Joi.alternatives([
            Joi.date().allow(null),
            Joi.string().valid(""),
          ]).label("End Date"),
        })
        .min(1)
        .label("Team Mission"),
    }),
    IndividualStrengths: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.array()
        .items({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          Name: Joi.string().required().label("Name"),
          Strengths: Joi.string().required().label("Strengths"),
        })
        .min(1)
        .label("Strengths"),
    }),
    Diagnosis: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Diagnosis"),
    }),
    Medications: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Medications"),
    }),
    Symptoms: Joi.string().required().label("Symptoms"),
    BriefHistory: Joi.string().required().label("Brief History"),
    Triggers: Joi.string().required().label("Triggers"),
    PotentialCrisis: Joi.string().required().label("Potential Crisis"),
    ActionSteps: Joi.string().required().label("Action Steps"),
    ResponsibleParties: Joi.string().required().label("Responsible Parties"),
    NeedsStrategies: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow("", null),
      otherwise: Joi.array()
        .items({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          NeedsStatement: Joi.string().required().label("Needs Statement"),
          StartDate: Joi.date().required().label("Start Date"),
          EndDate: Joi.alternatives([
            Joi.date().allow(null),
            Joi.string().valid(""),
          ]).label("End Date"),
          NeedProgress: Joi.when("PlanType", {
            is: "Review",
            then: Joi.string().required().label("Need Progress"),
          }).when("PlanType", {
            is: "Discharge",
            then: Joi.string().required().label("Need Progress"),
          }),
          Outcome: Joi.string().required().label("Outcome"),
          OutcomeProgress: Joi.when("PlanType", {
            is: "Review",
            then: Joi.string().required().label("Outcome Progress"),
          }).when("PlanType", {
            is: "Discharge",
            then: Joi.string().required().label("Outcome Progress"),
          }),
          ProblemImpact: Joi.string().required().label("Problem Significance"),
          Family: Joi.boolean(),
          Residence: Joi.boolean(),
          Social: Joi.boolean(),
          Education: Joi.boolean(),
          Medical: Joi.boolean(),
          Community: Joi.boolean(),
          Psychological: Joi.boolean(),
          Safety: Joi.boolean(),
          Strategies: Joi.array()
            .items({
              _id: Joi.any(),
              Strategy: Joi.string().required(),
              Completed: Joi.boolean(),
              DateCompleted: Joi.alternatives([
                Joi.date().allow(null),
                Joi.string().valid(""),
              ]).label("End Date"),
            })
            .min(1)
            .label("Strategies"),
        })
        .min(1),
    }),
    TeamContacts: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.array()
        .items({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          SupportName: Joi.string().required().label("Support Name"),
          Contact: Joi.string().required().label("Contact and Organization"),
          Role: Joi.string().required().label("Role"),
        })
        .min(1),
    }),
    SupportSummary: Joi.when("PlanType", {
      is: "Discharge",
      then: Joi.string().required().label("Support Summary"),
    }),
    Recommendations: Joi.when("PlanType", {
      is: "Discharge",
      then: Joi.string().required().label("Further Recommendations"),
    }),
  },
  "FDF82E10-1445-EF11-9361-0050F21C6F69": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    SexAssignedAtBirth: Joi.string().required(),
    SexAssignedAtBirthDetails: Joi.when("SexAssignedAtBirth", {
      is: "Sex not listed",
      then: Joi.string().required(),
    }),
    Pronouns: Joi.string().required(),
    PronounsDescription: Joi.when("Pronouns", {
      is: "Prefer to self-describe",
      then: Joi.required(),
    }),
    GenderIdentity: Joi.string().required(),
    GenderIdentityDescription: Joi.when("GenderIdentity", {
      is: "Identity not listed",
      then: Joi.string().required(),
    }),
    DateCompleted: Joi.string().required(),
    Division: Joi.string().required(),
    PSDType: Joi.string().required(),
    InitialDADate: Joi.when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.string().required(),
    }),
    UpdateSummary: Joi.when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.string().required(),
    }),
    UpdateRecommendations: Joi.when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.string().required(),
    }),
    ISClient: Joi.boolean(),
    ISParent: Joi.boolean(),
    ISGuardian: Joi.boolean(),
    ISCaregiver: Joi.boolean(),
    ISPhysician: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISCPS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.when("ISOther", {
      is: true,
      then: Joi.string().required(),
    }),
    ReasonForReferral: Joi.string().required(),
    ClientStrengths: Joi.string().required(),
    PresentingProblem: Joi.string().required(),
    HumanTrafficking: Joi.string().required(),
    CurrentPlacement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    OtherSupports: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CaregiverCooperation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    SupervisionDifficulties: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    DisciplinePracticesEffective: Joi.boolean(),
    DisciplinePracticesInconsistent: Joi.boolean(),
    DisciplinePracticesIneffective: Joi.boolean(),
    CurrentPlacementComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CaregiverCooperation", {
        is: "No",
        then: Joi.string().required(),
      })
        .when("SupervisionDifficulties", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("DisciplinePracticesInconsistent", {
          is: true,
          then: Joi.string().required(),
        })
        .when("DisciplinePracticesIneffective", {
          is: true,
          then: Joi.string().required(),
        }),
    }),
    FamilyHistoryDetails: Joi.string().required(),
    CurrentConcernsOfDV: Joi.boolean(),
    PastConcernsOfDV: Joi.boolean(),
    UnknownConcernsOfDV: Joi.boolean(),
    NoReportedConcernsOfDV: Joi.boolean(),
    CurrentMaritalConflict: Joi.boolean(),
    PastMaritalConflict: Joi.boolean(),
    UnknownMaritalConflict: Joi.boolean(),
    NoReportedMaritalConflict: Joi.boolean(),
    ConflictComments: Joi.when("CurrentConcernsOfDV", {
      is: true,
      then: Joi.string().required(),
    })
      .when("PastConcernsOfDV", { is: true, then: Joi.string().required() })
      .when("CurrentMaritalConflict", {
        is: true,
        then: Joi.string().required(),
      })
      .when("PastMaritalConflict", { is: true, then: Joi.string().required() }),
    CulturalGroup: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CulturalTraditions: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CulturalTraditionsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CulturalTraditions", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    NegativeCulturalExperiences: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    NegativeCulturalExperiencesDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("NegativeCulturalExperiences", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    CulturalMedicalBeliefs: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CulturalMedicalBeliefsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CulturalMedicalBeliefs", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    Religion: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    RoleOfFaith: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ReligiousTraditions: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DietaryNeeds: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    NegativeReligiousExperiences: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ReligiousMedicalBeliefs: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ReligiousComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ReligiousTraditions", {
        is: "Yes",
        then: Joi.string().required(),
      })
        .when("DietaryNeeds", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("NegativeReligiousExperiences", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("ReligiousMedicalBeliefs", {
          is: "Yes",
          then: Joi.string().required(),
        }),
    }),
    PHNoProblems: Joi.boolean(),
    PHPrenatalCare: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHExposure: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHTrauma: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHComplications: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHConcerns: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.when("PHPrenatalCare", {
          is: "Yes",
          then: Joi.string().required(),
        })
          .when("PHExposure", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("PHTrauma", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("PHComplications", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("PHConcerns", {
            is: "Yes",
            then: Joi.string().required(),
          }),
      }),
    }),
    SpecialNeeds: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().required(),
    }),
    SpecializedServices: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().required(),
    }),
    DHComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.when("SpecialNeeds", {
        is: "Yes",
        then: Joi.string().required(),
      }).when("SpecializedServices", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    EducationStatus: Joi.string().required(),
    SchoolName: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    CurrentGrade: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    RegularClassroom: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    Active504Plan: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    ActiveIEP: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    SchoolExperience: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      }),
    }),
    EmploymentNA: Joi.boolean(),
    CurrentlyEmployed: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    EmployerAndTitle: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.when("CurrentlyEmployed", {
            is: "Yes",
            then: Joi.string().required(),
          }),
        }),
      }),
    }),
    EmploymentInterests: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.when("CurrentlyEmployed", {
            is: "N/A",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          }),
        }),
      }),
    }),
    MilitaryHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    MilitaryComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.when("MilitaryHistory", {
            is: "Yes",
            then: Joi.string().required(),
          }),
        }),
      }),
    }),
    ADLNA: Joi.boolean(),
    MoneyManagement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    MoneyManagementDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("MoneyManagement", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("MoneyManagement", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    FoodManagement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    FoodManagementDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("FoodManagement", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("FoodManagement", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    Hygiene: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    HygieneDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Hygiene", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Hygiene", { is: "Advanced", then: Joi.string().required() }),
      }),
    }),
    Health: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    HealthDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Health", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Health", { is: "Advanced", then: Joi.string().required() }),
      }),
    }),
    Housekeeping: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    HousekeepingDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Housekeeping", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Housekeeping", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    Transportation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    TransportationDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Transportation", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Transportation", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    SafetySkills: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SafetySkillsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("SafetySkills", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("SafetySkills", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    ResourceKnowledge: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    ResourceKnowledgeDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("ResourceKnowledge", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("ResourceKnowledge", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    TimeManagement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    TimeManagementDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("TimeManagement", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("TimeManagement", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    Interaction: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    InteractionDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Interaction", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Interaction", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    CoopSkills: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CoopSkillsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CoopSkills", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("CoopSkills", { is: "Advanced", then: Joi.string().required() }),
    }),
    CommunicationSkills: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CommunicationSkillsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CommunicationSkills", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("CommunicationSkills", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    EmotionalUnderstanding: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    EmotionalUnderstandingDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EmotionalUnderstanding", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("EmotionalUnderstanding", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    ProblemSolving: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    ProblemSolvingDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ProblemSolving", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("ProblemSolving", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    ConflictResolution: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    ConflictResolutionDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ConflictResolution", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("ConflictResolution", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    DecisionMakingSkills: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    DecisionMakingSkillsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("DecisionMakingSkills", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("DecisionMakingSkills", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    Bullied: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    Bully: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    AcceptedByPeers: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    NegativeAssociations: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    RelationshipComments: Joi.when("Bullied", {
      is: "Yes",
      then: Joi.string().required(),
    })
      .when("Bully", {
        is: "Yes",
        then: Joi.string().required(),
      })
      .when("AcceptedByPeers", {
        is: "No",
        then: Joi.string().required(),
      })
      .when("NegativeAssociations", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    LegalInvolvement: Joi.string().required(),
    CPSInvolvement: Joi.when("LegalInvolvement", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    TypeOfCPSInvolvement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("CPSInvolvement", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    CPSHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("CPSInvolvement", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    CPSCaseworker: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("CPSInvolvement", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    CPSCaseworkerName: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("CPSInvolvement", {
          is: "Yes",
          then: Joi.when("CPSCaseworker", {
            is: "Yes",
            then: Joi.string().required(),
          }),
        }),
      }),
    }),
    ProbationOfficer: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProbationOfficerName: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("ProbationOfficer", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    GALCASA: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    GALCASAName: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("GALCASA", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    LegalStatus: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    LegalHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("LegalStatus", {
          is: "None Reported",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        }),
      }),
    }),
    OtherLegalDetails: Joi.when("LegalInvolvement", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    PCP: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.when("PCPUnknown", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PCPPhone: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.when("PCPUnknown", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PCPUnknown: Joi.boolean(),
    LastMedicalExamDate: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    LastDentalExamDate: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Allergies", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("MedicalConditions", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("NutritionalConcerns", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("DentalConcerns", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Undiagnosed: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    UndiagnosedDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Undiagnosed", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    NoMedications: Joi.boolean(),
    CurrentMedications: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    MedicationCompliance: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    SideEffects: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    SideEffectsDetails: Joi.when("NoMedications", {
      is: false,
      then: Joi.when("SideEffects", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    PsychotropicMeds: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    PsychotropicMedsDetails: Joi.when("NoMedications", {
      is: false,
      then: Joi.when("PsychotropicMeds", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualHistoryNA: Joi.boolean(),
    SexualOrientation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexualOrientationDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexualOrientation", {
          is: "Orientation not listed",
          then: Joi.string().required(),
        }).when("SexualOrientation", {
          is: "Unable to assess",
          then: Joi.string().required(),
        }),
      }),
    }),
    SexualRelationshipsEducation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexuallyActive: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    CaregiverAware: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    UseProtection: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    AwareOfRisks: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    Pregnancy: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    Children: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SexuallyActiveComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SexualAbuseVictim: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexualBehavior: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexuallyActingOut: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexuallyAbusive: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexualHistoryComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexualAbuseVictim", {
          is: "Yes",
          then: Joi.string().required(),
        })
          .when("SexualBehavior", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("SexuallyActingOut", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("SexuallyAbusive", {
            is: "Yes",
            then: Joi.string().required(),
          }),
      }),
    }),
    MHTreatmentNA: Joi.boolean(),
    PastMentalHealthTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    PastGroupHomePlacement: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    PastHospitalPlacement: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    InvoluntaryTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    PastMentalHealthDiagnosis: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    MHTreatmentComments: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.when("PastMentalHealthTreatment", {
        is: "Yes",
        then: Joi.string().required(),
      })
        .when("PastGroupHomePlacement", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("PastHospitalPlacement", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("InvoluntaryTreatment", {
          is: "Yes",
          then: Joi.string().required(),
        }),
    }),
    MHTreatmentHistory: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    MHClientPerspectiveOfTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    MHCaregiverPerspectiveOfTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    SUAge: Joi.boolean(),
    SubstanceUseNA: Joi.boolean(),
    SUClientDenies: Joi.boolean(),
    SUClientReportsCurrent: Joi.boolean(),
    SUClientReportsPast: Joi.boolean(),
    SUClientPeers: Joi.boolean(),
    SUCaregiverSuspects: Joi.boolean(),
    SUCaregiverEvidence: Joi.boolean(),
    SUComments: Joi.when("SubstanceUseNA", {
      is: false,
      then: Joi.when("SUClientDenies", { is: true, then: Joi.required() })
        .when("SUClientReportsCurrent", {
          is: true,
          then: Joi.string().required(),
        })
        .when("SUClientReportsPast", {
          is: true,
          then: Joi.string().required(),
        })
        .when("SUClientPeers", { is: true, then: Joi.string().required() })
        .when("SUCaregiverSuspects", {
          is: true,
          then: Joi.string().required(),
        })
        .when("SUCaregiverEvidence", {
          is: true,
          then: Joi.string().required(),
        }),
    }),
    SUHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    ClientPerceptionOfSubstanceUse: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    CaregiverPerceptionOfSubstanceUse: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    NoPastTreatment: Joi.boolean(),
    SUTreatmentHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.when("NoPastTreatment", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    SUClientPerspectiveOfTreatment: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.when("NoPastTreatment", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    SUCaregiverPerspectiveOfTreatment: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.when("NoPastTreatment", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    TraumaNA: Joi.boolean(),
    TraumaHistory: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    DistressingMemories: Joi.boolean(),
    BlockOut: Joi.boolean(),
    Hypervigilance: Joi.boolean(),
    PhysiologicalResponses: Joi.boolean(),
    LossOfMemories: Joi.boolean(),
    Hyperarousal: Joi.boolean(),
    SleepDisturbances: Joi.boolean(),
    DevelopmentalRegression: Joi.boolean(),
    Nightmares: Joi.boolean(),
    Avoidant: Joi.boolean(),
    DifficultyConcentratingSymptom: Joi.boolean(),
    UnhealthyBoundaries: Joi.boolean(),
    Flashbacks: Joi.boolean(),
    Detachment: Joi.boolean(),
    EmotionalDysregulation: Joi.boolean(),
    RepetitivePlayOfEvents: Joi.boolean(),
    PsychologicalDistress: Joi.boolean(),
    DiminishedInterests: Joi.boolean(),
    Dissocation: Joi.boolean(),
    NegativeCognitions: Joi.boolean(),
    SocialWithdrawalSymptom: Joi.boolean(),
    NoSymptoms: Joi.boolean(),
    SocialSupports: Joi.boolean(),
    SenseOfMastery: Joi.boolean(),
    CaregiverStability: Joi.boolean(),
    StrongSpiritualBeliefs: Joi.boolean(),
    InterpersonalSkills: Joi.boolean(),
    PositiveOutlook: Joi.boolean(),
    PlacementStability: Joi.boolean(),
    Pets: Joi.boolean(),
    ValidatingExperiences: Joi.boolean(),
    Resources: Joi.boolean(),
    TiesToExtendedFamily: Joi.boolean(),
    Adaptability: Joi.boolean(),
    SecureAttachments: Joi.boolean(),
    StrongCulturalIdentity: Joi.boolean(),
    Resilience: Joi.boolean(),
    NoTraumaProtectiveFactors: Joi.boolean(),
    CopingStrategies: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    ClientAwareOfTrauma: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    ClientPerspectiveOfTrauma: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    CaregiverPerspectiveOfTrauma: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    AppropriateAppearance: Joi.boolean(),
    Neat: Joi.boolean(),
    Disheveled: Joi.boolean(),
    BizarreAppearance: Joi.boolean(),
    OtherAppearance: Joi.boolean(),
    OtherAppearanceDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherAppearance", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Cooperative: Joi.boolean(),
    Guarded: Joi.boolean(),
    Hyperactive: Joi.boolean(),
    Agitated: Joi.boolean(),
    Paranoid: Joi.boolean(),
    Tics: Joi.boolean(),
    Impulsive: Joi.boolean(),
    Aggressive: Joi.boolean(),
    Withdrawn: Joi.boolean(),
    BizarreBehavior: Joi.boolean(),
    Rigidity: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherBehavior", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Normal: Joi.boolean(),
    Slurred: Joi.boolean(),
    Pressured: Joi.boolean(),
    Tangential: Joi.boolean(),
    Incoherent: Joi.boolean(),
    Stutters: Joi.boolean(),
    OtherSpeech: Joi.boolean(),
    OtherSpeechDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherSpeech", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Euthymic: Joi.boolean(),
    Anxious: Joi.boolean(),
    Angry: Joi.boolean(),
    Depressed: Joi.boolean(),
    Euphoric: Joi.boolean(),
    Irritable: Joi.boolean(),
    Fearful: Joi.boolean(),
    OtherMood: Joi.boolean(),
    OtherMoodDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherMood", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    FullRange: Joi.boolean(),
    Restricted: Joi.boolean(),
    Blunted: Joi.boolean(),
    Flat: Joi.boolean(),
    Inappropriate: Joi.boolean(),
    OtherAffect: Joi.boolean(),
    OtherAffectDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherAffect", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Logical: Joi.boolean(),
    Preoccupations: Joi.boolean(),
    Delusions: Joi.boolean(),
    Hallucinations: Joi.boolean(),
    Racing: Joi.boolean(),
    Disorganized: Joi.boolean(),
    Concrete: Joi.boolean(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    OtherPerception: Joi.boolean(),
    OtherPerceptionDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherPerception", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    NoImpairment: Joi.boolean(),
    ShortAttentionSpan: Joi.boolean(),
    DifficultyConcentrating: Joi.boolean(),
    Distractibility: Joi.boolean(),
    MemoryImpairment: Joi.boolean(),
    LowIntelligence: Joi.boolean(),
    OtherCognition: Joi.boolean(),
    OtherCognitionDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherCognition", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AppropriateInsight: Joi.boolean(),
    Fair: Joi.boolean(),
    Impaired: Joi.boolean(),
    OtherInsight: Joi.boolean(),
    OtherInsightDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherInsight", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    MentalStatusComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    LethalityNA: Joi.boolean(),
    SelfAbusiveBehavior: Joi.label("Self-abusive behavior").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    SuicidalThreats: Joi.label("Suicidal threats").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    SuicideAttempt: Joi.label("Suicide attempt").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    CaregiverConcernsOfSelfHarm: Joi.label(
      "Parent/Caregiver concerns of suicide/self-harm"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    OtherConcernsOfSelfHarm: Joi.label(
      "Other expressed concerns of suicide/self-harm"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    CurrentSelfHarmRisk: Joi.label("Current Risk of Harm to Self").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    SelfHarmComments: Joi.label("Current Risk of Harm to Self comments").when(
      "LethalityNA",
      {
        is: false,
        then: Joi.when("SelfAbusiveBehavior", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
          .when("SuicidalThreats", {
            is: "None/Never",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          })
          .when("SuicideAttempt", {
            is: "None/Never",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          })
          .when("CaregiverConcernsOfSelfHarm", {
            is: "No",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          })
          .when("OtherConcernsOfOtherHarm", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("CurrentSelfHarmRisk", {
            is: "None Noted",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          }),
      }
    ),
    ThreatsToHarmOthers: Joi.label(
      "Threats to intentionally harm/endanger others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    ThoughtsOfHarm: Joi.label(
      "Thoughts of intentionally harming/endangering others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    ActsOfHarm: Joi.label("Acts of intentionally harm/endangering others").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    ActsOfHarmAnimals: Joi.label(
      "Acts of intentionally harm/endangering animals"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    ActsInvolvingWeapons: Joi.label("Acts involving weapons").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    CaregiverConcernOfOtherHarm: Joi.label(
      "Parent/Caregiver concerns of harm/endangering others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    OtherConcernsOfOtherHarm: Joi.label(
      "Other expressed concerns of harm/endangering others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    CurrentOtherHarmRisk: Joi.label("Current Risk of Harm to Others").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    OtherHarmComments: Joi.label(
      "Current Risk of Harm to Others comments"
    ).when("LethalityNA", {
      is: false,
      then: Joi.when("ThreatsToHarmOthers", {
        is: "None/Never",
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      })
        .when("ThoughtsOfHarm", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("ActsOfHarm", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("ActsOfHarmAnimals", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("ActsInvolvingWeapons", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("CaregiverConcernOfOtherHarm", {
          is: "No",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("OtherConcernsOfOtherHarm", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("CurrentOtherHarmRisk", {
          is: "None Noted",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        }),
    }),
    SafetyPlanStatus: Joi.label("Safety Plan Status").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    LethalityComments: Joi.label("Comments/Plan").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    TraumaSymptoms: Joi.boolean(),
    TraumaticExposure: Joi.boolean(),
    AvoidantTrauma: Joi.boolean(),
    HypervigilanceTrauma: Joi.boolean(),
    IntrusiveDreams: Joi.boolean(),
    NegativeThoughts: Joi.boolean(),
    CocentrationProblems: Joi.boolean(),
    RecklessBehaviorTrauma: Joi.boolean(),
    SleepDisturbancesTrauma: Joi.boolean(),
    OtherTrauma: Joi.boolean(),
    OtherTraumaDetails: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.when("OtherTrauma", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    TraumaSymptomsFrequency: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    TraumaSymptomsIntensity: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    TraumaSymptomsDuration: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    TraumaSymptomsOnset: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    AnxietyDisorder: Joi.boolean(),
    AnxietyDisorderExcessWorry: Joi.boolean(),
    AnxietyDisorderEasilyFatigued: Joi.boolean(),
    MuscleTension: Joi.boolean(),
    Overworried: Joi.boolean(),
    AnxietyDisorderDifficultyConcentrating: Joi.boolean(),
    SleepDisturbancesAnxiety: Joi.boolean(),
    RestlessAnxiety: Joi.boolean(),
    Irritability: Joi.boolean(),
    OtherAnxiety: Joi.boolean(),
    OtherAnxietyDetails: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.when("OtherAnxiety", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AnxietyDisorderFrequency: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    AnxietyDisorderIntensity: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    AnxietyDisorderDuration: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    DepressionSymptoms: Joi.boolean(),
    DepressedMood: Joi.boolean(),
    SleepChanges: Joi.boolean(),
    Guilt: Joi.boolean(),
    DiminishedInterest: Joi.boolean(),
    PurposelessMovement: Joi.boolean(),
    DifficultyConcentratingDepression: Joi.boolean(),
    WeightChanges: Joi.boolean(),
    FatigueDepression: Joi.boolean(),
    ThoughtsOfDeath: Joi.boolean(),
    OtherDepression: Joi.boolean(),
    OtherDepressionDetails: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.when("OtherDepression", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DepressionFrequency: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    DepressionIntensity: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    DepressionDuration: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    AttentionHyperactivity: Joi.boolean(),
    AttentionHyperactivityEasilyDistracted: Joi.boolean(),
    DifficultyFollowThrough: Joi.boolean(),
    Forgetful: Joi.boolean(),
    DifficultyListening: Joi.boolean(),
    DisorganizedAttention: Joi.boolean(),
    Fidgety: Joi.boolean(),
    LackOfDetails: Joi.boolean(),
    LosesThings: Joi.boolean(),
    InterruptsOthers: Joi.boolean(),
    UnableToSitStill: Joi.boolean(),
    ExcessiveTalking: Joi.boolean(),
    DifficultyWaiting: Joi.boolean(),
    OtherAttention: Joi.boolean(),
    OtherAttentionDetails: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.when("OtherAttention", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AttentionHyperactivityFrequency: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.string().required(),
    }),
    AttentionHyperactivityIntensity: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.string().required(),
    }),
    AttentionHyperactivityDuration: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.string().required(),
    }),
    SU: Joi.boolean(),
    PatternOfSubstanceUse: Joi.boolean(),
    DesiresCutDownUse: Joi.boolean(),
    TimeSpentObtaining: Joi.boolean(),
    Cravings: Joi.boolean(),
    FailureOfResponsibilities: Joi.boolean(),
    NegativeImpact: Joi.boolean(),
    AbandonsActivities: Joi.boolean(),
    Tolerance: Joi.boolean(),
    SUWithdrawal: Joi.boolean(),
    SUOther: Joi.boolean(),
    SUOtherDetails: Joi.when("SU", {
      is: true,
      then: Joi.when("SUOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    SubstanceUseFrequency: Joi.when("SU", {
      is: true,
      then: Joi.string().required(),
    }),
    SubstanceUseIntensity: Joi.when("SU", {
      is: true,
      then: Joi.string().required(),
    }),
    SubstanceUseDuration: Joi.when("SU", {
      is: true,
      then: Joi.string().required(),
    }),
    DMDD: Joi.boolean(),
    Temper: Joi.boolean(),
    OutsideOutbursts: Joi.boolean(),
    FrequentOutbursts: Joi.boolean(),
    DMDDIrritable: Joi.boolean(),
    OutburstsAroundOthers: Joi.boolean(),
    DMDDOther: Joi.boolean(),
    DMDDOtherDetails: Joi.when("DMDD", {
      is: true,
      then: Joi.when("DMDDOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DMDDFrequency: Joi.when("DMDD", {
      is: true,
      then: Joi.string().required(),
    }),
    DMDDIntensity: Joi.when("DMDD", {
      is: true,
      then: Joi.string().required(),
    }),
    DMDDDuration: Joi.when("DMDD", { is: true, then: Joi.string().required() }),
    ConductDisorder: Joi.boolean(),
    Aggression: Joi.boolean(),
    DestructionOfProperty: Joi.boolean(),
    Theft: Joi.boolean(),
    SeriousViolations: Joi.boolean(),
    OtherConductDisorder: Joi.boolean(),
    OtherConductDisorderDetails: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.when("OtherConductDisorder", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    ConductDisorderFrequency: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    ConductDisorderIntensity: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    ConductDisorderDuration: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    ODD: Joi.boolean(),
    IrritableODD: Joi.boolean(),
    Argumentative: Joi.boolean(),
    Vindictive: Joi.boolean(),
    OtherODD: Joi.boolean(),
    OtherODDDetails: Joi.when("ODD", {
      is: true,
      then: Joi.when("OtherODD", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    ODDFrequency: Joi.when("ODD", { is: true, then: Joi.string().required() }),
    ODDIntensity: Joi.when("ODD", { is: true, then: Joi.string().required() }),
    ODDDuration: Joi.when("ODD", { is: true, then: Joi.string().required() }),
    OCD: Joi.boolean(),
    OCDPresence: Joi.boolean(),
    Obsessions: Joi.boolean(),
    TimeConsuming: Joi.boolean(),
    Compulsions: Joi.boolean(),
    ReduceAnxiety: Joi.boolean(),
    SuppressUrges: Joi.boolean(),
    OCDOther: Joi.boolean(),
    OCDOtherDetails: Joi.when("OCD", {
      is: true,
      then: Joi.when("OCDOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    OCDFrequency: Joi.when("OCD", { is: true, then: Joi.string().required() }),
    OCDIntensity: Joi.when("OCD", { is: true, then: Joi.string().required() }),
    OCDDuration: Joi.when("OCD", { is: true, then: Joi.string().required() }),
    PanicDisorder: Joi.boolean(),
    PoundingHeart: Joi.boolean(),
    PanicDisorderSweating: Joi.boolean(),
    Trembling: Joi.boolean(),
    ShortnessOfBreath: Joi.boolean(),
    Choking: Joi.boolean(),
    ChestPain: Joi.boolean(),
    PanicDisorderNausea: Joi.boolean(),
    Dizzy: Joi.boolean(),
    Chills: Joi.boolean(),
    Derealization: Joi.boolean(),
    FearOfCrazy: Joi.boolean(),
    FearOfDying: Joi.boolean(),
    PanicDisorderOther: Joi.boolean(),
    PanicDisorderOtherDetails: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.when("PanicDisorderOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    PanicDisorderFrequency: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    PanicDisorderIntensity: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    PanicDisorderDuration: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    Phobias: Joi.boolean(),
    PhobiasSpecificFear: Joi.boolean(),
    ImmediateFear: Joi.boolean(),
    PhobiasAvoidance: Joi.boolean(),
    FearExaggerated: Joi.boolean(),
    PhobiasOther: Joi.boolean(),
    PhobiasOtherDetails: Joi.when("Phobias", {
      is: true,
      then: Joi.when("PhobiasOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    PhobiasFrequency: Joi.when("Phobias", {
      is: true,
      then: Joi.string().required(),
    }),
    PhobiasIntensity: Joi.when("Phobias", {
      is: true,
      then: Joi.string().required(),
    }),
    PhobiasDuration: Joi.when("Phobias", {
      is: true,
      then: Joi.string().required(),
    }),
    DI: Joi.boolean(),
    DILowIQ: Joi.boolean(),
    DISensoryImpairments: Joi.boolean(),
    DISpeechDelays: Joi.boolean(),
    DIMotorCoordinationDelays: Joi.boolean(),
    DILearningDisorder: Joi.boolean(),
    DISpatialDelays: Joi.boolean(),
    DevelopmentalImpairmentsOther: Joi.boolean(),
    DevelopmentalImpairmentsOtherDetails: Joi.when("DI", {
      is: true,
      then: Joi.when("DevelopmentalImpairmentsOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DevelopmentalImpairmentsDetails: Joi.when("DI", {
      is: true,
      then: Joi.when("DILowIQ", { is: true, then: Joi.required() })
        .when("DISensoryImpairments", { is: true, then: Joi.required() })
        .when("DISpeechDelays", { is: true, then: Joi.required() })
        .when("DIMotorCoordinationDelays", { is: true, then: Joi.required() })
        .when("DILearningDisorder", { is: true, then: Joi.required() })
        .when("DISpatialDelays", { is: true, then: Joi.required() }),
    }),
    OtherSymptoms: Joi.boolean(),
    OtherSymptomsDetails: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    OtherSymptomsFrequency: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    OtherSymptomsIntensity: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    OtherSymptomsDuration: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    ClinicalNarrativeSummary: Joi.string().required(),
    ClinicalNarrativeSummaryComments: Joi.string().allow(null, ""),
    DiagnosisDetails: Joi.string().required(),
    SeriousDisturbance: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    NoAdditionalNeeds: Joi.boolean(),
    AdditionalNeeds: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("NoAdditionalNeeds", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    TreatmentRecommendations: Joi.string().required(),
    DiagnosisEducation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    RecommendationEducation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    ClientAgrees: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    FamilyAgress: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
  },
  "469B0963-4545-EF11-9361-0050F21C6F69": {
    SelectedProgram: Joi.string().required(),
    StartDate: Joi.string().required().label("Start Date"),
    EndDate: Joi.string().required().label("End Date"),
    CaregiverNames: Joi.string().required().label("Caregiver Name(s)"),
    CaregiverProgress: Joi.string().required().label("Caregiver Progress"),
    YouthName: Joi.string().required().label("Youth Name"),
    YouthProgress: Joi.string().required().label("Caregiver Progress"),
    AssessmentNCFAS: Joi.boolean(),
    AssessmentPSD: Joi.boolean(),
    AssessmentCSSRs: Joi.boolean(),
    AssessmentOther: Joi.boolean(),
    AssessmentOtherDetails: Joi.string().when("AssessmentOther", {
      is: true,
      then: Joi.string().required().label("Details for other assessments"),
    }),
    AssessmentNone: Joi.boolean(),
    ResourcesChildcare: Joi.boolean(),
    ResourcesClothing: Joi.boolean(),
    ResourcesActivities: Joi.boolean(),
    ResourcesGovernment: Joi.boolean(),
    ResourcesCrisis: Joi.boolean(),
    ResourcesEducation: Joi.boolean(),
    ResourcesFood: Joi.boolean(),
    ResourcesHealthcare: Joi.boolean(),
    ResourcesHousing: Joi.boolean(),
    ResourcesParenting: Joi.boolean(),
    ResourcesSubstanceUse: Joi.boolean(),
    ResourcesTransportation: Joi.boolean(),
    ResourcesUtilities: Joi.boolean(),
    ResourcesOther: Joi.boolean(),
    ResourcesOtherDetails: Joi.string().when("ResourcesOther", {
      is: true,
      then: Joi.string().required().label("Details for other resources"),
    }),
    ResourcesNone: Joi.boolean(),
    NoContact: Joi.boolean(),
    NoContactDetails: Joi.string().when("NoContact", {
      is: true,
      then: Joi.string().required().label("Reason for no contact"),
    }),
    ContactDetails: Joi.when("NoContact", {
      is: true,
      then: Joi.array(),
      otherwise: Joi.array()
        .items({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          VisitDate: Joi.string().allow(""),
          VisitDuration: Joi.number(),
          ServiceType: Joi.string().allow(""),
          FullStartDate: Joi.string().allow(""),
          FullEndDate: Joi.string().allow(""),
        })
        .min(1)
        .label("Family Contact Details"),
    }),
    SignOff: Joi.string().required().label("Sign Off"),
  },
  "48287DD1-2754-EF11-9361-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateCompleted: Joi.string().allow(""),
    ReportStartDate: Joi.string().allow(""),
    ReportEndDate: Joi.string().allow(""),
    Month: Joi.string().required().label("Month"),
    Year: Joi.string().required().label("Year"),
    SocialInteraction: Joi.string()
      .allow("")
      .required()
      .label("Social Interaction / Skills"),
    Activities: Joi.string()
      .allow("")
      .required()
      .label("Community and Family Activities by Child and Foster Family"),
    Legal: Joi.string().required().label("Legal"),
    Education: Joi.string().required().label("Education"),
    Facility: Joi.string().required().label("Facility"),
    IndependentLiving: Joi.string()
      .allow("")
      .required()
      .label("Independent Living"),
    Health: Joi.string()
      .allow("")
      .required()
      .label("Physical Health, Disabilities and Medication"),
    Behavior: Joi.string().required().label("Behavior and Growth"),
    PrimaryFamily: Joi.string()
      .allow("")
      .required()
      .label("Primary Family Contact/Visitation"),
    Therapy: Joi.string()
      .allow("")
      .required()
      .label("Individual or Group Therapy"),
    Recommendations: Joi.string()
      .allow("")
      .required()
      .label("Recommendations and Next Steps"),
    ContactsVisits: Joi.string()
      .allow("")
      .required()
      .label("Contacts / Visits"),
    Interventions: Joi.string()
      .allow("")
      .required()
      .label("Interventions Between Recipient, SAFY Staff and Foster Parents"),
    IncidentReports: Joi.string().allow("").label("Incident Reports"),
    ServiceGoals: Joi.string().required().label("Service Goals"),
    ReportOfStaffAbuse: Joi.string().required().label("Reports of staff abuse"),
    ReportOfNonStaffAbuse: Joi.string()
      .required()
      .label("Reports of non-staff abuse"),
    UnplannedDischarge: Joi.string().required().label("Unplanned discharge"),
    LengthOfStay: Joi.string()
      .allow("")
      .label("Length of stay")
      .when("UnplannedDischarge", {
        is: "1",
        then: Joi.required(),
      }),
    VisitationPlan: Joi.string().label("Visitation plan"),
    VisitationFrequency: Joi.string()
      .allow("")
      .label("Visitation frequency")
      .when("VisitationPlan", {
        is: "1",
        then: Joi.required(),
      }),
    VisitationGoal: Joi.string()
      .label("Achieved visitation goal")
      .when("VisitationPlan", {
        is: "1",
        then: Joi.required(),
      }),
    Runaway: Joi.string().required().label("Runaway"),
    DSSRequest: Joi.string().allow(""),
    DHRRequest: Joi.string().allow(""),
  },
  "BFA51351-2954-EF11-9361-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    DateOfIncident: Joi.string().required(),
    TimeOfIncident: Joi.string().required(),
    FosterHome: Joi.string().required(),
    NotifiedOn: Joi.string().required(),
    NotifiedBy: Joi.string().required(),
    NotifiedByOther: Joi.when("NotifiedBy", {
      is: "Other",
      then: Joi.string().required(),
    }),
    NotifiedMethod: Joi.string().required(),
    NotifiedMethodOther: Joi.when("NotifiedMethod", {
      is: "Other",
      then: Joi.string().required(),
    }),
    TypeOfIncident: Joi.string().required(),
    AbuseInHomeAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.when("AbuseInHomeAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseInHomeAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeNA: Joi.boolean(),
    AbuseInHomeDate: Joi.string().allow(""),
    AbuseInHomeTime: Joi.string().allow(""),
    AbuseInHomeNotes: Joi.string().allow(""),
    AbuseInHomeNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.when("AbuseInHomeNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseInHomeStepsTaken: Joi.string().allow(""),
    AbuseInHomeOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.when("AbuseOutsideHomeAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseOutsideHomeAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeNA: Joi.boolean(),
    AbuseOutsideHomeDate: Joi.string().allow(""),
    AbuseOutsideHomeTime: Joi.string().allow(""),
    AbuseOutsideHomeNotes: Joi.string().allow(""),
    AbuseOutsideHomeNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.when("AbuseOutsideHomeNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseOutsideHomeStepsTaken: Joi.string().allow(""),
    AbuseOutsideHomeOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AWOLDescription: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLLocated: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLPoliceReport: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    AWOLDepartment: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLReportNumber: Joi.string().allow(""),
    AWOLOfficer: Joi.string().allow(""),
    AWOLNoReportReason: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLOutcome: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathClient: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWho: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathClient", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathInvestigation: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhere: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhereOther: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    DeathDescription: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathPoliceReport: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathReportedBy: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathReportInfo: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathNoReportReason: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathStepsTaken: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastDate: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastTime: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjury: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsWeapons: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsGuns: Joi.boolean(),
    HomicidalThoughtsKnives: Joi.boolean(),
    HomicidalThoughtsOtherWeapon: Joi.boolean(),
    HomicidalThoughtsOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsWeapons", {
        is: "Yes",
        then: Joi.when("HomicidalThoughtsOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("HomicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsNA: Joi.boolean(),
    HomicidalThoughtsDate: Joi.string().allow(""),
    HomicidalThoughtsTime: Joi.string().allow(""),
    RestraintAppliedBy: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintAppliedByOther: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintAppliedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    RestraintLength: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintType: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintDescription: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInterventions: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInjury: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInjuryDetails: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    RestraintWellbeing: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintFollowup: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintModifications: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintObservation: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInvestigation: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintOutcome: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintOutcomeOther: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicationRefusalDescription: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalSymptoms: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalSymptomDescription: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.when("MedicationRefusalSymptoms", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationRefusalChronic: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.when("MedicationRefusalChronic", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorType: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorResponsible: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorResponsibleOther: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.when("MedicationErrorResponsible", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorDescription: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorSymptoms: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorSymptomDescription: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.when("MedicationErrorSymptoms", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorInvestigation: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyDescription: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyOutcome: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencySafetyPlan: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    PsychiatricEmergencyNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("PsychiatricEmergencySafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    PsychiatricEmergencyNA: Joi.boolean(),
    PsychiatricEmergencyDate: Joi.string().allow(""),
    PsychiatricEmergencyTime: Joi.string().allow(""),
    MedicalAttentionDescription: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionOutcome: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.when("MedicalAttentionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicalAttentionNA: Joi.boolean(),
    MedicalAttentionDate: Joi.string().allow(""),
    MedicalAttentionTime: Joi.string().allow(""),
    MedicalAttentionChronic: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.when("MedicalAttentionChronic", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsWhere: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsWhereOther: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsStepsTaken: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistory: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsFollowUp: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsOutcome: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsWhere: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsWhereOther: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsIEP: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsPrevention: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsIEP", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsSupport: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsIEP", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsOutcomeDetention: Joi.boolean(),
    ProblematicBehaviorsOutcomeSuspension: Joi.boolean(),
    ProblematicBehaviorsOutcomeExpulsion: Joi.boolean(),
    ProblematicBehaviorsOutcomeSafetyPlan: Joi.boolean(),
    ProblematicBehaviorsOutcomeIEP: Joi.boolean(),
    ProblematicBehaviorsOutcomeOther: Joi.boolean(),
    ProblematicBehaviorsOutcomeOtherDetails: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsOutcomeOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsSuicidal: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.string().required(),
    }),
    SelfHarmBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjury: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsInjury", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsChronic: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsChronic", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsCSSRs: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsNoCSSRsReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsCSSRs", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsNA: Joi.boolean(),
    SuicidalThoughtsDate: Joi.string().allow(""),
    SuicidalThoughtsTime: Joi.string().allow(""),
    SuicideAttemptDescription: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptExistingSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptNoExistingSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptExistingSafetyPlan", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptOutcome: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicideAttemptSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicideAttemptNA: Joi.boolean(),
    SuicideAttemptDate: Joi.string().allow(""),
    SuicideAttemptTime: Joi.string().allow(""),
    COVIDPositiveMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.string().required(),
    }),
    COVIDPositiveMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.when("COVIDPositiveMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    COVIDPositiveMedications: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.string().required(),
    }),
    COVIDPositiveMedicationDetails: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.when("COVIDPositiveMedications", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    COVIDPositiveDate: Joi.string().allow(""),
    COVIDPositiveTime: Joi.string().allow(""),
    COVIDPositiveNA: Joi.boolean(),
    IllegalBehaviorWhere: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorWhereOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorWeapons: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorGuns: Joi.boolean(),
    IllegalBehaviorKnives: Joi.boolean(),
    IllegalBehaviorOtherWeapon: Joi.boolean(),
    IllegalBehaviorOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorOtherWeapon", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorDescription: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorStepsTaken: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistory: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorFollowUp: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorArrested: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcome: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionWhere: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionWhereOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionDescription: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnown: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnownDetails: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionKnown", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    AggressionFollowUp: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcome: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    CarAccidentDescription: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicationAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.when("CarAccidentMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    VictimWhere: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimWhereOther: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.when("VictimWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    VictimDescription: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimWeapons: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimGuns: Joi.boolean(),
    VictimKnives: Joi.boolean(),
    VictimOtherWeapon: Joi.boolean(),
    VictimOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.when("VictimOtherWeapon", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    VictimStepsTaken: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimFollowUp: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    OtherTypeDescription: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeWeapons: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeGuns: Joi.boolean(),
    OtherTypeKnives: Joi.boolean(),
    OtherTypeOtherWeapon: Joi.boolean(),
    OtherTypeOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.when("OtherTypeOtherWeapon", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    OtherTypeStepsTaken: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcome: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.when("OtherTypeOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    ResolvedStatus: Joi.string().required().label("Resolved Status"),
    CountyNotified: Joi.string().required(),
    CountyNotifiedName: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    CountyNotifiedWhen: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    CountyNotifiedComments: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    NotNotifiedDetails: Joi.when("CountyNotified", {
      is: "No",
      then: Joi.string().required(),
    }),
    OtherNotificationsNeeded: Joi.string().required(),
    OtherNotifiedName: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedWhen: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedComments: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    ResolutionAmendments: Joi.string().allow(""),
  },
  "479B82F3-2854-EF11-9361-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    DateOfIncident: Joi.string().required(),
    TimeOfIncident: Joi.string().required(),
    NotifiedOn: Joi.string().required(),
    NotifiedBy: Joi.string().required(),
    NotifiedByOther: Joi.when("NotifiedBy", {
      is: "Other",
      then: Joi.string().required(),
    }),
    NotifiedMethod: Joi.string().required(),
    NotifiedMethodOther: Joi.when("NotifiedMethod", {
      is: "Other",
      then: Joi.string().required(),
    }),
    TypeOfIncident: Joi.string().required(),
    AbuseAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.when("AbuseAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseNA: Joi.boolean(),
    AbuseDate: Joi.string().allow(""),
    AbuseTime: Joi.string().allow(""),
    AbuseNotes: Joi.string().allow(""),
    AbuseNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.when("AbuseNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseStepsTaken: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AWOLDescription: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLLocated: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLPoliceReport: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    AWOLDepartment: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLReportNumber: Joi.string().allow(""),
    AWOLOfficer: Joi.string().allow(""),
    AWOLNoReportReason: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLOutcome: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathClient: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWho: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathClient", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathInvestigation: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhere: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhereOther: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    DeathDescription: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathPoliceReport: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathReportedBy: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathReportInfo: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathNoReportReason: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathStepsTaken: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastDate: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastTime: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjury: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("HomicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsNA: Joi.boolean(),
    HomicidalThoughtsDate: Joi.string().allow(""),
    HomicidalThoughtsTime: Joi.string().allow(""),
    PsychiatricEmergencyDescription: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyOutcome: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencySafetyPlan: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    PsychiatricEmergencyNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("PsychiatricEmergencySafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    PsychiatricEmergencyNA: Joi.boolean(),
    PsychiatricEmergencyDate: Joi.string().allow(""),
    PsychiatricEmergencyTime: Joi.string().allow(""),
    SexualizedBehaviorsWhere: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsWhereOther: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsStepsTaken: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistory: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsFollowUp: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsOutcome: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SelfHarmBehaviorsSuicidal: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.string().required(),
    }),
    SelfHarmBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjury: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsInjury", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsChronic: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsChronic", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsCSSRs: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsNoCSSRsReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsCSSRs", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsNA: Joi.boolean(),
    SuicidalThoughtsDate: Joi.string().allow(""),
    SuicidalThoughtsTime: Joi.string().allow(""),
    SuicideAttemptDescription: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptExistingSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptNoExistingSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptExistingSafetyPlan", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptOutcome: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicideAttemptSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicideAttemptNA: Joi.boolean(),
    SuicideAttemptDate: Joi.string().allow(""),
    SuicideAttemptTime: Joi.string().allow(""),
    IllegalBehaviorWhere: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorWhereOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorDescription: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorStepsTaken: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistory: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorFollowUp: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorArrested: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcome: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionWhere: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionWhereOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionDescription: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnown: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnownDetails: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionKnown", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    AggressionFollowUp: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcome: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    VictimWhere: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimWhereOther: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.when("VictimWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    VictimDescription: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimStepsTaken: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimFollowUp: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    OtherTypeDescription: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeStepsTaken: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcome: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.when("OtherTypeOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    ResolvedStatus: Joi.string().required().label("Resolved Status"),
    OtherNotificationsNeeded: Joi.string().required(),
    OtherNotifiedName: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedWhen: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedComments: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    ResolutionAmendments: Joi.string().allow(""),
  },
  "36C24CE7-2854-EF11-9361-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    DateOfIncident: Joi.string().required(),
    TimeOfIncident: Joi.string().required(),
    NotifiedOn: Joi.string().required(),
    NotifiedBy: Joi.string().required(),
    NotifiedByOther: Joi.when("NotifiedBy", {
      is: "Other",
      then: Joi.string().required(),
    }),
    NotifiedMethod: Joi.string().required(),
    NotifiedMethodOther: Joi.when("NotifiedMethod", {
      is: "Other",
      then: Joi.string().required(),
    }),
    TypeOfIncident: Joi.string().required(),
    AbuseAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.when("AbuseAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseNA: Joi.boolean(),
    AbuseDate: Joi.string().allow(""),
    AbuseTime: Joi.string().allow(""),
    AbuseNotes: Joi.string().allow(""),
    AbuseNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.when("AbuseNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseStepsTaken: Joi.string().allow(""),
    AbuseOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    DeathClient: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWho: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathClient", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathInvestigation: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhere: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhereOther: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    DeathDescription: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathPoliceReport: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathReportedBy: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathReportInfo: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathNoReportReason: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathStepsTaken: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastDate: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastTime: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjury: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("HomicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsNA: Joi.boolean(),
    HomicidalThoughtsDate: Joi.string().allow(""),
    HomicidalThoughtsTime: Joi.string().allow(""),
    PsychiatricEmergencyDescription: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyOutcome: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencySafetyPlan: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    PsychiatricEmergencyNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("PsychiatricEmergencySafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    PsychiatricEmergencyNA: Joi.boolean(),
    PsychiatricEmergencyDate: Joi.string().allow(""),
    PsychiatricEmergencyTime: Joi.string().allow(""),
    SelfHarmBehaviorsSuicidal: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.string().required(),
    }),
    SelfHarmBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjury: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsInjury", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsChronic: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsChronic", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsCSSRs: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsNoCSSRsReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsCSSRs", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsNA: Joi.boolean(),
    SuicidalThoughtsDate: Joi.string().allow(""),
    SuicidalThoughtsTime: Joi.string().allow(""),
    SuicideAttemptDescription: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptExistingSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptNoExistingSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptExistingSafetyPlan", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptOutcome: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicideAttemptSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicideAttemptNA: Joi.boolean(),
    SuicideAttemptDate: Joi.string().allow(""),
    SuicideAttemptTime: Joi.string().allow(""),
    IllegalBehaviorWhere: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorWhereOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorDescription: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistory: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorFollowUp: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorArrested: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcome: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionWhere: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards SAFY Employee/SAFY Property",
      then: Joi.string().required(),
    }),
    AggressionWhereOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards SAFY Employee/SAFY Property",
      then: Joi.when("AggressionWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionDescription: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards SAFY Employee/SAFY Property",
      then: Joi.string().required(),
    }),
    AggressionKnown: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards SAFY Employee/SAFY Property",
      then: Joi.string().required(),
    }),
    AggressionKnownDetails: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards SAFY Employee/SAFY Property",
      then: Joi.when("AggressionKnown", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    AggressionFollowUp: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards SAFY Employee/SAFY Property",
      then: Joi.string().required(),
    }),
    AggressionOutcome: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards SAFY Employee/SAFY Property",
      then: Joi.string().required(),
    }),
    AggressionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards SAFY Employee/SAFY Property",
      then: Joi.when("AggressionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    CarAccidentDescription: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicationAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.when("CarAccidentMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    OtherTypeDescription: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeStepsTaken: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcome: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.when("OtherTypeOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    ResolvedStatus: Joi.string().required().label("Resolved Status"),
    OtherNotificationsNeeded: Joi.string().required(),
    OtherNotifiedName: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedWhen: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedComments: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    ResolutionAmendments: Joi.string().allow(""),
  },
  "441049D0-2854-EF11-9361-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    DateOfIncident: Joi.string().required(),
    TimeOfIncident: Joi.string().required(),
    NotifiedOn: Joi.string().required(),
    NotifiedBy: Joi.string().required(),
    NotifiedByOther: Joi.when("NotifiedBy", {
      is: "Other",
      then: Joi.string().required(),
    }),
    NotifiedMethod: Joi.required(),
    NotifiedMethodOther: Joi.when("NotifiedMethod", {
      is: "Other",
      then: Joi.string().required(),
    }),
    TypeOfIncident: Joi.string().required(),
    AbuseAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.when("AbuseAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseNA: Joi.boolean(),
    AbuseDate: Joi.string().allow(""),
    AbuseTime: Joi.string().allow(""),
    AbuseNotes: Joi.string().allow(""),
    AbuseNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.when("AbuseNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseStepsTaken: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AbuseOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation",
      then: Joi.string().required(),
    }),
    AWOLDescription: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLLocated: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLPoliceReport: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    AWOLDepartment: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLReportNumber: Joi.string().allow(""),
    AWOLOfficer: Joi.string().allow(""),
    AWOLNoReportReason: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLOutcome: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathClient: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWho: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathClient", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathInvestigation: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhere: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhereOther: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    DeathDescription: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathPoliceReport: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathReportedBy: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathReportInfo: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathNoReportReason: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathStepsTaken: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastDate: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastTime: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjury: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("HomicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsNA: Joi.boolean(),
    HomicidalThoughtsDate: Joi.string().allow(""),
    HomicidalThoughtsTime: Joi.string().allow(""),
    PsychiatricEmergencyDescription: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyOutcome: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencySafetyPlan: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    PsychiatricEmergencyNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("PsychiatricEmergencySafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    PsychiatricEmergencyNA: Joi.boolean(),
    PsychiatricEmergencyDate: Joi.string().allow(""),
    PsychiatricEmergencyTime: Joi.string().allow(""),
    SexualizedBehaviorsWhere: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsWhereOther: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsStepsTaken: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistory: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsFollowUp: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsOutcome: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SelfHarmBehaviorsSuicidal: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.string().required(),
    }),
    SelfHarmBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjury: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsInjury", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsChronic: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsChronic", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsCSSRs: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsNoCSSRsReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsCSSRs", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsNA: Joi.boolean(),
    SuicidalThoughtsDate: Joi.string().allow(""),
    SuicidalThoughtsTime: Joi.string().allow(""),
    SuicideAttemptDescription: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptExistingSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptNoExistingSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptExistingSafetyPlan", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptOutcome: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicideAttemptSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicideAttemptNA: Joi.boolean(),
    SuicideAttemptDate: Joi.string().allow(""),
    SuicideAttemptTime: Joi.string().allow(""),
    IllegalBehaviorWhere: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorWhereOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorDescription: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorStepsTaken: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistory: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorFollowUp: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorArrested: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcome: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionWhere: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionWhereOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionDescription: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnown: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnownDetails: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionKnown", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    AggressionFollowUp: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcome: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    CarAccidentDescription: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicationAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.when("CarAccidentMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    VictimWhere: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimWhereOther: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.when("VictimWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    VictimDescription: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimStepsTaken: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimFollowUp: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    OtherTypeDescription: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeStepsTaken: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcome: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.when("OtherTypeOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    ResolvedStatus: Joi.string().required().label("Resolved Status"),
    OtherNotificationsNeeded: Joi.string().required(),
    OtherNotifiedName: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedWhen: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedComments: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    ResolutionAmendments: Joi.string().allow(""),
  },
  "44956CD8-C754-EF11-9361-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    SDHRReportedDate: Joi.string().required().label("SDHR Submit Date"),
    CountyWorkerReportedDate: Joi.string()
      .required()
      .label("County Worker Submit Date"),
    CountySubmitted: Joi.string().required().label("County Submitted to"),
    CountyWorkerName: Joi.string().required().label("Worker Name"),
    CountySubmissionMethod: Joi.string().required().label("Submission Method"),
    InternalReportRecipient: Joi.string()
      .required()
      .label("Internal Report Submitted to"),
    ChildRace: Joi.string().required().label("Child's Race"),
    ChildGender: Joi.string().required().label("Child's Gender"),
    ChildDiagnosis: Joi.string()
      .required()
      .label("Child's Disability/DSM V Diagnosis"),
    DateOfIncident: Joi.string().required().label("Date of Incident"),
    TimeOfIncident: Joi.string().required().label("Time of Incident"),
    ProviderName: Joi.string().required().label("Provider Name"),
    ProviderAddress: Joi.string().required().label("Provider Address"),
    CompletedBy: Joi.string()
      .required()
      .label("Name/Title of Person Completing Form"),
    ProviderContactInfo: Joi.string()
      .required()
      .label("Provider Contact Information"),
    StaffInvolved: Joi.string()
      .required()
      .label("Name of Staff Involved in Incident"),
    Location: Joi.string().required().label("Location of the Incident"),
    PrecipitatingEvent: Joi.string().required().label("Precipitating Event"),
    PrecipitatingEventOther: Joi.when("PrecipitatingEvent", {
      is: "Other",
      then: Joi.string().required().label("Other Precipitating Event details"),
    }),
    ResponseFirstAid: Joi.boolean(),
    ResponseMedication: Joi.boolean(),
    ResponseUrgentCare: Joi.boolean(),
    ResponseSeclusion: Joi.boolean(),
    ResponseRestraint: Joi.boolean(),
    ResponseRoomChanged: Joi.boolean(),
    ResponseLevelReduction: Joi.boolean(),
    ResponseProcessed: Joi.boolean(),
    ResponseProcessedTherapist: Joi.boolean(),
    ResponseAgressionPrecautions: Joi.boolean(),
    ResponseSuspended: Joi.boolean(),
    ResponseSuicidePrecaution: Joi.boolean(),
    HospitalAssessmentCompleted: Joi.boolean(),
    DoctorAssessmentCompleted: Joi.boolean(),
    ResponseLawEnforcement: Joi.boolean(),
    ResponseOther: Joi.boolean(),
    ResponseOtherDetails: Joi.when("ResponseOther", {
      is: true,
      then: Joi.string().required().label("Other Staff Response details"),
    }),
    IncidentType: Joi.string().required().label("Incident Type"),
    MedicationErrorType: Joi.when("IncidentType", {
      is: "Medication Error",
      then: Joi.string().required().label("Medication Error Type"),
    }),
    ClientInjuryType: Joi.when("IncidentType", {
      is: "Client Injury",
      then: Joi.string().required().label("Client Injury Type"),
    }),
    SeclusionLengthHours: Joi.when("IncidentType", {
      is: "Seclusion",
      then: Joi.string().required().label("HOURS"),
    }),
    SeclusionLengthMinutes: Joi.when("IncidentType", {
      is: "Seclusion",
      then: Joi.string().required().label("MINUTES"),
    }),
    RestraintType: Joi.when("IncidentType", {
      is: "Restraint",
      then: Joi.string().required().label("Type of Restraint Method"),
    }),
    RestraintHours: Joi.when("IncidentType", {
      is: "Restraint",
      then: Joi.string().required().label("HOURS"),
    }),
    RestraintMinutes: Joi.when("IncidentType", {
      is: "Restraint",
      then: Joi.string().required().label("MINUTES"),
    }),
    MedicalAttentionRequired: Joi.string()
      .required()
      .label("Medical Attention Required"),
    ChildInjuryDescription: Joi.when("IncidentType", {
      is: "Client Injury",
      then: Joi.string().required().label("Description of Child's Injuries"),
    }),
    MedicalAttentionLocation: Joi.when("MedicalAttentionRequired", {
      is: "Yes",
      then: Joi.string().required().label("Medical Attention Received at"),
    }),
    PoliceReport: Joi.string().required().label("Reported to Police"),
    PoliceReportRecipient: Joi.when("PoliceReport", {
      is: "Yes",
      then: Joi.string().required().label("Police Reported to"),
    }),
    PoliceReportDate: Joi.when("PoliceReport", {
      is: "Yes",
      then: Joi.string().required().label("Date Reported to Police"),
    }),
    Sent1593: Joi.string().required().label("1593 Sent to County DHR"),
    Sent1593County: Joi.string().when("Sent1593", {
      is: "Yes",
      then: Joi.string().required().label("County 1593 Sent to"),
    }),
    Sent1593Date: Joi.string().when("Sent1593", {
      is: "Yes",
      then: Joi.string().required().label("Date 1593 Sent to County DHR"),
    }),
    Sent1593Method: Joi.string().when("Sent1593", {
      is: "Yes",
      then: Joi.string().required().label("Method 1593 Sent to County DHR"),
    }),
    ResolvedStatus: Joi.string().required().label("Resolved Status"),
    FosterHome: Joi.string().required().label("Foster Home"),
    IncidentDescription: Joi.string().required().label("Incident Description"),
    SAFYIncidentType: Joi.string().allow(""),
    SAFYAWOLLocated: Joi.string().allow(""),
    SAFYOutcome: Joi.string().allow(""),
    SAFYProblematicBehaviorsOutcomeDetention: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeSuspension: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeExpulsion: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeSafetyPlan: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeIEP: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeOther: Joi.boolean(),
  },
  "1C8A3ABA-D254-EF11-9361-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    DateOfIncident: Joi.string().required(),
    TimeOfIncident: Joi.string().required(),
    FosterHome: Joi.string().required(),
    NotifiedOn: Joi.string().required(),
    NotifiedBy: Joi.string().required(),
    NotifiedByOther: Joi.when("NotifiedBy", {
      is: "Other",
      then: Joi.string().required(),
    }),
    NotifiedMethod: Joi.string().required(),
    NotifiedMethodOther: Joi.when("NotifiedMethod", {
      is: "Other",
      then: Joi.string().required(),
    }),
    TypeOfIncident: Joi.string().required(),
    AbuseInHomeAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.when("AbuseInHomeAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseInHomeAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeNA: Joi.boolean(),
    AbuseInHomeDate: Joi.string().allow(""),
    AbuseInHomeTime: Joi.string().allow(""),
    AbuseInHomeNotes: Joi.string().allow(""),
    AbuseInHomeNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.when("AbuseInHomeNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseInHomeStepsTaken: Joi.string().allow(""),
    AbuseInHomeOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.when("AbuseOutsideHomeAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseOutsideHomeAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeNA: Joi.boolean(),
    AbuseOutsideHomeDate: Joi.string().allow(""),
    AbuseOutsideHomeTime: Joi.string().allow(""),
    AbuseOutsideHomeNotes: Joi.string().allow(""),
    AbuseOutsideHomeNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.when("AbuseOutsideHomeNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseOutsideHomeStepsTaken: Joi.string().allow(""),
    AbuseOutsideHomeOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AWOLDescription: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLLocated: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLPoliceReport: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    AWOLDepartment: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLReportNumber: Joi.string().allow(""),
    AWOLOfficer: Joi.string().allow(""),
    AWOLNoReportReason: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLOutcome: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathClient: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWho: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathClient", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathInvestigation: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhere: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhereOther: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    DeathDescription: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathPoliceReport: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathReportedBy: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathReportInfo: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathNoReportReason: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathStepsTaken: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastDate: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastTime: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjury: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsWeapons: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsGuns: Joi.boolean(),
    HomicidalThoughtsKnives: Joi.boolean(),
    HomicidalThoughtsOtherWeapon: Joi.boolean(),
    HomicidalThoughtsOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsWeapons", {
        is: "Yes",
        then: Joi.when("HomicidalThoughtsOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("HomicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsNA: Joi.boolean(),
    HomicidalThoughtsDate: Joi.string().allow(""),
    HomicidalThoughtsTime: Joi.string().allow(""),
    RestraintAppliedBy: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintAppliedByOther: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintAppliedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    RestraintLength: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintType: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintDescription: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInterventions: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInjury: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInjuryDetails: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    RestraintWellbeing: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintFollowup: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintModifications: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintObservation: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInvestigation: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintOutcome: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintOutcomeOther: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicationRefusalDescription: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalSymptoms: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalSymptomDescription: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.when("MedicationRefusalSymptoms", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationRefusalChronic: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.when("MedicationRefusalChronic", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorType: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorResponsible: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorResponsibleOther: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.when("MedicationErrorResponsible", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorDescription: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorSymptoms: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorSymptomDescription: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.when("MedicationErrorSymptoms", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorInvestigation: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyDescription: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyOutcome: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencySafetyPlan: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    PsychiatricEmergencyNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("PsychiatricEmergencySafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    PsychiatricEmergencyNA: Joi.boolean(),
    PsychiatricEmergencyDate: Joi.string().allow(""),
    PsychiatricEmergencyTime: Joi.string().allow(""),
    MedicalAttentionDrugReaction: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionDescription: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionOutcome: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.when("MedicalAttentionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicalAttentionNA: Joi.boolean(),
    MedicalAttentionDate: Joi.string().allow(""),
    MedicalAttentionTime: Joi.string().allow(""),
    MedicalAttentionChronic: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.when("MedicalAttentionChronic", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsWhere: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsWhereOther: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsStepsTaken: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistory: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsFollowUp: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsOutcome: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsWhere: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsWhereOther: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsIEP: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsPrevention: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsIEP", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsSupport: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsIEP", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsOutcomeDetention: Joi.boolean(),
    ProblematicBehaviorsOutcomeSuspension: Joi.boolean(),
    ProblematicBehaviorsOutcomeExpulsion: Joi.boolean(),
    ProblematicBehaviorsOutcomeSafetyPlan: Joi.boolean(),
    ProblematicBehaviorsOutcomeIEP: Joi.boolean(),
    ProblematicBehaviorsOutcomeOther: Joi.boolean(),
    ProblematicBehaviorsOutcomeOtherDetails: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsOutcomeOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsSuicidal: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.string().required(),
    }),
    SelfHarmBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjury: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsInjury", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsChronic: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsChronic", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsCSSRs: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsNoCSSRsReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsCSSRs", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsNA: Joi.boolean(),
    SuicidalThoughtsDate: Joi.string().allow(""),
    SuicidalThoughtsTime: Joi.string().allow(""),
    SuicideAttemptDescription: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptExistingSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptNoExistingSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptExistingSafetyPlan", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptOutcome: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicideAttemptSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicideAttemptNA: Joi.boolean(),
    SuicideAttemptDate: Joi.string().allow(""),
    SuicideAttemptTime: Joi.string().allow(""),
    COVIDPositiveMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.string().required(),
    }),
    COVIDPositiveMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.when("COVIDPositiveMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    COVIDPositiveMedications: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.string().required(),
    }),
    COVIDPositiveMedicationDetails: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.when("COVIDPositiveMedications", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    COVIDPositiveDate: Joi.string().allow(""),
    COVIDPositiveTime: Joi.string().allow(""),
    COVIDPositiveNA: Joi.boolean(),
    IllegalBehaviorWhere: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorWhereOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorWeapons: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorGuns: Joi.boolean(),
    IllegalBehaviorKnives: Joi.boolean(),
    IllegalBehaviorOtherWeapon: Joi.boolean(),
    IllegalBehaviorOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorWeapons", {
        is: "Yes",
        then: Joi.when("IllegalBehaviorOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    IllegalBehaviorSubstances: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorAlcohol: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorDescription: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorStepsTaken: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistory: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorFollowUp: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorArrested: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcome: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionWhere: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionWhereOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionDescription: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnown: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnownDetails: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionKnown", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    AggressionFollowUp: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcome: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    CarAccidentDescription: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicationAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.when("CarAccidentMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    VictimWhere: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimWhereOther: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.when("VictimWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    VictimDescription: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimWeapons: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimGuns: Joi.boolean(),
    VictimKnives: Joi.boolean(),
    VictimOtherWeapon: Joi.boolean(),
    VictimOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.when("VictimWeapons", {
        is: "Yes",
        then: Joi.when("VictimOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    VictimStepsTaken: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimFollowUp: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    OtherTypeDescription: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeWeapons: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeGuns: Joi.boolean(),
    OtherTypeKnives: Joi.boolean(),
    OtherTypeOtherWeapon: Joi.boolean(),
    OtherTypeOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.when("OtherTypeWeapons", {
        is: "Yes",
        then: Joi.when("OtherTypeOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    OtherTypeStepsTaken: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcome: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.when("OtherTypeOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    ResolvedStatus: Joi.string().required().label("Resolved Status"),
    FollowUp: Joi.array()
      .items(Joi.string().required())
      .min(1)
      .required()
      .label("Plan of Prevention/Follow-Up"),
    CountyNotified: Joi.string().required(),
    CountyNotifiedName: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    CountyNotifiedWhen: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    CountyNotifiedComments: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    NotNotifiedDetails: Joi.when("CountyNotified", {
      is: "No",
      then: Joi.string().required(),
    }),
    OtherNotificationsNeeded: Joi.string().required(),
    OtherNotifiedName: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedWhen: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedComments: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    ResolutionAmendments: Joi.string().allow(""),
  },
  "6658E4EB-D254-EF11-9361-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    LOC: Joi.string().allow(""),
    IncidentDate: Joi.date().required(),
    IncidentTime: Joi.string().required(),
    FosterHome: Joi.string().allow(""),
    StaffDetails: Joi.string().required(),
    ClientDeath: Joi.boolean(),
    SuicideAttempt: Joi.boolean(),
    Emergency: Joi.boolean(),
    EmergencyType: Joi.when("Emergency", {
      is: true,
      then: Joi.string().required(),
    }),
    AWOL: Joi.boolean(),
    AWOLReturnDate: Joi.when("AWOL", {
      is: true,
      then: Joi.string().required(),
    }),
    SeriousInjury: Joi.boolean(),
    SuicideGesture: Joi.boolean(),
    MedicationError: Joi.boolean(),
    OffsiteTreatment: Joi.boolean(),
    OffsiteEmergencyTreatmentLocation: Joi.when("OffsiteTreatment", {
      is: true,
      then: Joi.string().required(),
    }),
    OffsiteAssessment: Joi.boolean(),
    OffsiteEmergencyAssessmentLocation: Joi.when("OffsiteAssessment", {
      is: true,
      then: Joi.string().required(),
    }),
    Weapon: Joi.boolean(),
    WeaponType: Joi.when("Weapon", {
      is: true,
      then: Joi.string().required(),
    }),
    Substance: Joi.boolean(),
    SubstanceType: Joi.when("Substance", {
      is: true,
      then: Joi.string().required(),
    }),
    SchoolRemoval: Joi.boolean(),
    SchoolRemovalType: Joi.when("SchoolRemoval", {
      is: true,
      then: Joi.string().required(),
    }),
    OutsideAgency: Joi.boolean(),
    AgencyInvolved: Joi.when("OutsideAgency", {
      is: true,
      then: Joi.string().required(),
    }),
    Restrained: Joi.boolean(),
    PlacementChange: Joi.boolean(),
    PlacementChangeType: Joi.when("PlacementChange", {
      is: true,
      then: Joi.string().required(),
    }),
    SexTrafficking: Joi.boolean(),
    IncidentDescription: Joi.string().required(),
    PrecipitatingFactors: Joi.string().required(),
    Interventions: Joi.string().required(),
    FollowUpActions: Joi.string().required(),
    NotificationDetails: Joi.array().when("IncidentDate", {
      is: Joi.exist(),
      then: Joi.array().items(
        Joi.object({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          Role: Joi.string().required(),
          Notified: Joi.string().allow(""),
          NotifiedBy: Joi.string().when("Notified", {
            is: Joi.exist(),
            then: Joi.string().required(),
          }),
          Time: Joi.string()
            .regex(/^([0-9]{2}):([0-9]{2})$/)
            .when("Notified", {
              is: Joi.exist(),
              then: Joi.string().required(),
            }),
          Date: Joi.date().when("Notified", {
            is: Joi.exist(),
            then: Joi.date().max("now").required(),
          }),
        })
      ),
    }),
    ResolvedStatus: Joi.string().required().label("Resolved Status"),
    CompletedBy: Joi.boolean(),
    ClinicalReviewer: Joi.boolean(),
    AdministrativeReviewer: Joi.boolean(),
    CopyDetails: Joi.array().items(
      Joi.object({
        _id: Joi.any(),
        IsEditable: Joi.boolean(),
        Name: Joi.string().allow(""),
        Date: Joi.string().when("Name", {
          is: Joi.exist(),
          then: Joi.string().required(),
        }),
        Time: Joi.string().when("Name", {
          is: Joi.exist(),
          then: Joi.string().required(),
        }),
        Method: Joi.string().when("Name", {
          is: Joi.exist(),
          then: Joi.string().required(),
        }),
      })
    ),
    SAFYTypeOfIncident: Joi.string().allow(""),
  },
  "7A5115F5-9C55-EF11-9361-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    IncidentDate: Joi.date().required().label("Incident Date"),
    SAFYTypeOfIncident: Joi.string().allow(""),
    SAFYAWOLLocated: Joi.string().allow(""),
    SAFYOutcome: Joi.string().allow(""),
    SAFYProblematicBehaviorsOutcomeDetention: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeSuspension: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeExpulsion: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeSafetyPlan: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeIEP: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeOther: Joi.boolean(),
  },
  "14BDB8BE-A555-EF11-9361-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    IncidentDate: Joi.date().required().label("Incident Date"),
    SAFYTypeOfIncident: Joi.string().allow(""),
    SAFYAWOLLocated: Joi.string().allow(""),
    SAFYOutcome: Joi.string().allow(""),
    SAFYProblematicBehaviorsOutcomeDetention: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeSuspension: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeExpulsion: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeSafetyPlan: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeIEP: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeOther: Joi.boolean(),
  },
  "EE90ADB5-EA5B-EF11-9361-0050F21C653C": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    FosterParents: Joi.string().required().label("Foster Parents"),
    DateOfPlacement: Joi.string().required().label("Date of Placement"),
    PerDiem: Joi.string().required().label("Per Diem"),
  },
  "1A984383-EE5B-EF11-9361-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    Date: Joi.string().required(),
    Address: Joi.string().required(),
    Clinician: Joi.string().required(),
    ContactInfo: Joi.string().required(),
  },
  "E1F40008-9D60-EF11-991A-9B83D80529EF": {
    SelectedProgram: Joi.string().required(),
    LOC: Joi.string().allow(""),
    IncidentDate: Joi.date().required(),
    IncidentTime: Joi.string().required(),
    FosterHome: Joi.string().allow(""),
    StaffDetails: Joi.string().required(),
    ClientDeath: Joi.boolean(),
    SuicideAttempt: Joi.boolean(),
    Emergency: Joi.boolean(),
    EmergencyType: Joi.when("Emergency", {
      is: true,
      then: Joi.string().required(),
    }),
    AWOL: Joi.boolean(),
    AWOLReturnDate: Joi.when("AWOL", {
      is: true,
      then: Joi.string().required(),
    }),
    SeriousInjury: Joi.boolean(),
    SuicideGesture: Joi.boolean(),
    MedicationError: Joi.boolean(),
    OffsiteTreatment: Joi.boolean(),
    OffsiteEmergencyTreatmentLocation: Joi.when("OffsiteTreatment", {
      is: true,
      then: Joi.string().required(),
    }),
    OffsiteEmergencyAssessmentLocation: Joi.when("OffsiteAssessment", {
      is: true,
      then: Joi.string().required(),
    }),
    OffsiteAssessment: Joi.boolean(),
    Weapon: Joi.boolean(),
    WeaponType: Joi.when("Weapon", {
      is: true,
      then: Joi.string().required(),
    }),
    Substance: Joi.boolean(),
    SubstanceType: Joi.when("Substance", {
      is: true,
      then: Joi.string().required(),
    }),
    SchoolRemoval: Joi.boolean(),
    SchoolRemovalType: Joi.when("SchoolRemoval", {
      is: true,
      then: Joi.string().required(),
    }),
    OutsideAgency: Joi.boolean(),
    AgencyInvolved: Joi.when("OutsideAgency", {
      is: true,
      then: Joi.string().required(),
    }),
    Restrained: Joi.boolean(),
    PlacementChange: Joi.boolean(),
    PlacementChangeType: Joi.when("PlacementChange", {
      is: true,
      then: Joi.string().required(),
    }),
    SexTrafficking: Joi.boolean(),
    IncidentDescription: Joi.string().required(),
    PrecipitatingFactors: Joi.string().required(),
    Interventions: Joi.string().required(),
    FollowUpActions: Joi.string().required(),
    NotificationDetails: Joi.array().when("IncidentDate", {
      is: Joi.exist(),
      then: Joi.array().items(
        Joi.object({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          Role: Joi.string().required(),
          Notified: Joi.string().allow(""),
          NotifiedBy: Joi.string().when("Notified", {
            is: Joi.string().trim().exist().invalid(""),
            then: Joi.string().required(),
          }),
          Time: Joi.string()
            .regex(/^([0-9]{2}):([0-9]{2})$/)
            .when("Notified", {
              is: Joi.string().trim().exist().invalid(""),
              then: Joi.string().required(),
            }),
          Date: Joi.date().when("Notified", {
            is: Joi.string().trim().exist().invalid(""),
            then: Joi.date().max("now").required(),
          }),
        })
      ),
    }),
    ResolvedStatus: Joi.string().required().label("Resolved Status"),
    CompletedBy: Joi.boolean(),
    ClinicalReviewer: Joi.boolean(),
    AdministrativeReviewer: Joi.boolean(),
    CopyDetails: Joi.array().items(
      Joi.object({
        _id: Joi.any(),
        IsEditable: Joi.boolean(),
        Name: Joi.string().allow(""),
        Date: Joi.string().when("Name", {
          is: Joi.string().trim().exist().invalid(""),
          then: Joi.string().required(),
        }),
        Time: Joi.string().when("Name", {
          is: Joi.string().trim().exist().invalid(""),
          then: Joi.string().required(),
        }),
        Method: Joi.string().when("Name", {
          is: Joi.string().trim().exist().invalid(""),
          then: Joi.string().required(),
        }),
      })
    ),
    SAFYTypeOfIncident: Joi.string().allow(""),
    SAFYAWOLLocated: Joi.string().allow(""),
    SAFYOutcome: Joi.string().allow(""),
    SAFYProblematicBehaviorsOutcomeDetention: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeSuspension: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeExpulsion: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeSafetyPlan: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeIEP: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeOther: Joi.boolean(),
    ResolutionAmendments: Joi.string().allow(""),
  },
  "805A41DD-A960-EF11-991A-9B83D80529EF": {
    SelectedProgram: Joi.string().required(),
    ReportMonth: Joi.string().required().label("Report Month"),
    EndDate: Joi.date().max("now").required().label("End Date"),
    StartDate: Joi.date()
      .less(Joi.ref("EndDate"))
      .required()
      .label("Start Date"),
    ServiceDetails: Joi.array()
      .items(
        Joi.object({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          RecordId: Joi.string().allow(""),
          RecipientCode: Joi.string().required().label("Recipient Code"),
          Method: Joi.string().required().label("Delivery Method"),
          Location: Joi.string().required().label("Place of Service"),
          FullStartDate: Joi.string().allow(""),
          FullEndDate: Joi.string().allow(""),
          ContactDate: Joi.date(),
          StartTime: Joi.string().allow(""),
          EndTime: Joi.string().allow(""),
        })
      )
      .min(1)
      .required()
      .label("Contact Details"),
    Progress: Joi.string().required().label("Overall assessment"),
    Interventions: Joi.array().items(Joi.string()),
    OtherInterventions: Joi.when("Interventions", {
      is: Joi.array()
        .items(
          Joi.string().valid("Case Coordination", "Other").required(),
          Joi.any()
        )
        .min(1)
        .required(),
      then: Joi.string().required().label("Other Intervention Specifics"),
    }),
    DischargeRecommendations: Joi.string()
      .required()
      .label("Discharge Plan Recommendation"),
    Comments: Joi.string().allow(""),
    AftercarePlan: Joi.array()
      .items(
        Joi.object({
          _id: Joi.any(),
          Service: Joi.string().allow(""),
          Recommendation: Joi.when("Service", {
            is: "Still Assessing",
            then: Joi.any(),
            otherwise: Joi.string().required(),
          }),
        })
      )
      .min(1)
      .required(),
    Assessments: Joi.array().items(Joi.string()).required(),
    FollowUp: Joi.string().label("Follow up appointments"),
    Medications: Joi.string().label("Medications"),
  },
  "6ED299CF-EB63-EF11-991A-9B83D80529EF": {
    SelectedProgram: Joi.string().required(),
    PlanType: Joi.string().required().label("Plan Type"),
    CrisisPlanDate: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().required().label("Date of Plan"),
    }),
    Participants: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().required().label("Participants"),
    }),
    YouthName: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Youth Name"),
    }),
    FileNumber: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Wrap File #"),
    }),
    DateCompleted: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.date().max("now").required().label("Date"),
    }),
    DateOfBirth: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.date().max("now").required().label("Date of Birth"),
    }),
    GuardianName: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Guardian Name"),
    }),
    GuardianPhone: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Guardian Phone"),
    }),
    GuardianAddress: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Guardian Address"),
    }),
    PlanStartDate: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.date().required().label("Start Date"),
    }),
    PlanTargetDate: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.date().required().label("Target Completion Date"),
    }),
    FamilyVision: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.array()
        .items({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          Vision: Joi.string().required().label("Vision"),
          Rating: Joi.string()
            .when("PlanType", {
              is: "Review",
              then: Joi.string().required().label("Rating"),
            })
            .when("PlanType", {
              is: "Discharge",
              then: Joi.string().required().label("Rating"),
            }),
          EndDate: Joi.alternatives([
            Joi.date().allow(null),
            Joi.string().valid(""),
          ]).label("End Date"),
        })
        .min(1)
        .label("Family Vision"),
    }),
    TeamMission: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.array()
        .items({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          Mission: Joi.string().required().label("Mission"),
          Rating: Joi.string()
            .when("PlanType", {
              is: "Review",
              then: Joi.string().required().label("Rating"),
            })
            .when("PlanType", {
              is: "Discharge",
              then: Joi.string().required().label("Rating"),
            }),
          EndDate: Joi.alternatives([
            Joi.date().allow(null),
            Joi.string().valid(""),
          ]).label("End Date"),
        })
        .min(1)
        .label("Team Mission"),
    }),
    IndividualStrengths: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.array()
        .items({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          Name: Joi.string().required().label("Name"),
          Strengths: Joi.string().required().label("Strengths"),
        })
        .min(1)
        .label("Strengths"),
    }),
    Diagnosis: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Diagnosis"),
    }),
    Medications: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Medications"),
    }),
    Symptoms: Joi.string().required().label("Symptoms"),
    BriefHistory: Joi.string().required().label("Brief History"),
    Triggers: Joi.string().required().label("Triggers"),
    PotentialCrisis: Joi.string().required().label("Potential Crisis"),
    ActionSteps: Joi.string().required().label("Action Steps"),
    ResponsibleParties: Joi.string().required().label("Responsible Parties"),
    AtRiskCount: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.number()
        .min(0)
        .max(10)
        .required()
        .label("Number of youth at risk of removal"),
    }),
    AtRiskRemaining: Joi.when("PlanType", {
      is: "Discharge",
      then: Joi.number()
        .min(0)
        .max(10)
        .required()
        .label("Number of at risk youth remaining"),
    }),
    NeedsStrategies: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow("", null),
      otherwise: Joi.array()
        .items({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          NeedsStatement: Joi.string().required().label("Needs Statement"),
          StartDate: Joi.date().required().label("Start Date"),
          EndDate: Joi.alternatives([
            Joi.date().allow(null),
            Joi.string().valid(""),
          ]).label("End Date"),
          NeedProgress: Joi.when("PlanType", {
            is: "Review",
            then: Joi.string().required().label("Need Progress"),
          }).when("PlanType", {
            is: "Discharge",
            then: Joi.string().required().label("Need Progress"),
          }),
          Outcome: Joi.string().required().label("Outcome"),
          OutcomeProgress: Joi.when("PlanType", {
            is: "Review",
            then: Joi.string().required().label("Outcome Progress"),
          }).when("PlanType", {
            is: "Discharge",
            then: Joi.string().required().label("Outcome Progress"),
          }),
          ProblemImpact: Joi.string().required().label("Problem Significance"),
          Family: Joi.boolean(),
          Residence: Joi.boolean(),
          Social: Joi.boolean(),
          Education: Joi.boolean(),
          Medical: Joi.boolean(),
          Community: Joi.boolean(),
          Psychological: Joi.boolean(),
          Safety: Joi.boolean(),
          Strategies: Joi.array()
            .items({
              _id: Joi.any(),
              Strategy: Joi.string().required(),
              Completed: Joi.boolean(),
              DateCompleted: Joi.alternatives([
                Joi.date().allow(null),
                Joi.string().valid(""),
              ]).label("End Date"),
            })
            .min(1)
            .label("Strategies"),
        })
        .min(1),
    }),
    TeamContacts: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.array()
        .items({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          SupportName: Joi.string().required().label("Support Name"),
          Contact: Joi.string().required().label("Contact and Organization"),
          Role: Joi.string().required().label("Role"),
        })
        .min(1),
    }),
    SupportSummary: Joi.when("PlanType", {
      is: "Discharge",
      then: Joi.string().required().label("Support Summary"),
    }),
    Recommendations: Joi.when("PlanType", {
      is: "Discharge",
      then: Joi.string().required().label("Further Recommendations"),
    }),
  },
  "74F0495E-FC6A-EF11-991A-9B83D80529EF": {
    SelectedProgram: Joi.string().required(),
    DateOfAssessment: Joi.date().required().label("Date of Assessment"),
    FeelingNervous: Joi.number().required().min(0).max(3).label("1"),
    WorryingControl: Joi.number().required().min(0).max(3).label("2"),
    WorryingTooMuch: Joi.number().required().min(0).max(3).label("3"),
    TroubleRelaxing: Joi.number().required().min(0).max(3).label("4"),
    BeingRestless: Joi.number().required().min(0).max(3).label("5"),
    EasilyAnnoyed: Joi.number().required().min(0).max(3).label("6"),
    FeelingAfraid: Joi.number().required().min(0).max(3).label("7"),
    DifficultyLevel: Joi.number().required().min(0).max(3).label("8"),
    TotalScore: Joi.number(),
  },
  "361B1F8C-FC6A-EF11-991A-9B83D80529EF": {
    SelectedProgram: Joi.string().required(),
    DateOfAssessment: Joi.date().required().label("Date of Assessment"),
    LittleInterest: Joi.number().required().min(0).max(3).label("1"),
    FeelingDown: Joi.number().required().min(0).max(3).label("2"),
    TroubleSleeping: Joi.number().required().min(0).max(3).label("3"),
    FeelingTired: Joi.number().required().min(0).max(3).label("4"),
    PoorAppetite: Joi.number().required().min(0).max(3).label("5"),
    FeelingBad: Joi.number().required().min(0).max(3).label("6"),
    TroubleConcentrating: Joi.number().required().min(0).max(3).label("7"),
    MovementChanges: Joi.number().required().min(0).max(3).label("8"),
    SelfHarmThoughts: Joi.number().required().min(0).max(3).label("9"),
    DifficultyLevel: Joi.number().required().min(0).max(3).label("8"),
    TotalScore: Joi.number(),
  },
  "1F160FF9-F679-EF11-991A-C66FF475DD83": {
    UserBintiId: Joi.string().required(),
    SelectedState: Joi.string().required(),
    SelectedRecipients: Joi.string().required(),
    Date: Joi.string().required(),
    Type: Joi.string().required(),
    Subject: Joi.string().required(),
    ContactMethod: Joi.string()
      .when("Type", { is: "case_update", then: Joi.required() })
      .when("Type", { is: "next_planned_contact", then: Joi.required() })
      .when("Type", { is: "other", then: Joi.required() })
      .when("Type", { is: "recruiting", then: Joi.required() })
      .when("Type", { is: "family_evaluation", then: Joi.required() }),
    EstimatedApprovalDate: Joi.string().when("Type", {
      is: "approval_date_estimate",
      then: Joi.required(),
    }),
    Body: Joi.string().required(),
    NeedNext: Joi.boolean(),
    NextContactDate: Joi.when("NeedNext", {
      is: true,
      then: Joi.string().required(),
    }),
    NextContactSubject: Joi.when("NeedNext", {
      is: true,
      then: Joi.string().required(),
    }),
    NextContactMethod: Joi.when("NeedNext", {
      is: true,
      then: Joi.string().required(),
    }),
    NextContactBody: Joi.when("NeedNext", {
      is: true,
      then: Joi.string().required(),
    }),
    ProcessRecipients: Joi.string().allow(""),
    BulkProcessed: Joi.string().allow(""),
    ProcessErrors: Joi.string().allow(""),
  },
  "48096295-8E7A-EF11-991A-C66FF475DD83": {
    SelectedProgram: Joi.string().required(),
    DateOfAssessment: Joi.string().required(),
    TypeOfAssessment: Joi.string().required(),
    AssessorName: Joi.string().required(),
    GenderIdentity: Joi.string().required(),
    GenderIdentityOther: Joi.when("GenderIdentity", {
      is: "Other",
      then: Joi.string().required(),
    }),
    SexualOrientation: Joi.string().required(),
    SexualOrientationOther: Joi.when("SexualOrientation", {
      is: "Other",
      then: Joi.string().required(),
    }),
    PrefPronouns: Joi.string().required(),
    PrefPronounsOther: Joi.when("PrefPronouns", {
      is: "Other",
      then: Joi.string().required(),
    }),
    Race: Joi.string().required(),
    RaceOther: Joi.when("Race", { is: "Other", then: Joi.string().required() }),
    Latinx: Joi.string().required(),
    LatinxOther: Joi.when("Latinx", {
      is: "Other",
      then: Joi.string().required(),
    }),
    Religion: Joi.string().required(),
    ReligionOther: Joi.when("Religion", {
      is: "Other",
      then: Joi.string().required(),
    }),
    PrimLang: Joi.string().required(),
    PrimLangOther: Joi.when("PrimLang", {
      is: "Other",
      then: Joi.string().required(),
    }),
    SecLang: Joi.string().required(),
    SecLangOther: Joi.when("SecLang", {
      is: "Other",
      then: Joi.string().required(),
    }),
    Disability: Joi.string().required(),
    DLSDocuments: Joi.string().allow(""),
    DLSUseEmail: Joi.string().allow(""),
    DLSInternet: Joi.string().allow(""),
    DLSPhishing: Joi.string().allow(""),
    DLSMeetingRisks: Joi.string().allow(""),
    DLSSharingRisks: Joi.string().allow(""),
    DLSThinkBeforePosting: Joi.string().allow(""),
    DLSReachOut: Joi.string().allow(""),
    DLSShopping: Joi.string().allow(""),
    DLSHealthyMeals: Joi.string().allow(""),
    DLSLeftovers: Joi.string().allow(""),
    DLSImportance: Joi.string().allow(""),
    DLSFoodLabels: Joi.string().allow(""),
    DLSFoodDates: Joi.string().allow(""),
    DLSLaundry: Joi.string().allow(""),
    DLSKeepTidy: Joi.string().allow(""),
    DLSCleaning: Joi.string().allow(""),
    DLSExtinguisher: Joi.string().allow(""),
    SCSPersonalHygiene: Joi.string().allow(""),
    SCSMenstrualCycleCare: Joi.string().allow(""),
    SCSMinorInjuriesCare: Joi.string().allow(""),
    SCSRegularAppointments: Joi.string().allow(""),
    SCSMedicalDentalAppointments: Joi.string().allow(""),
    SCSProviderUrgentCareER: Joi.string().allow(""),
    SCSAccessTelehealth: Joi.string().allow(""),
    SCSEligibilityForBenefits: Joi.string().allow(""),
    SCSManageMentalHealth: Joi.string().allow(""),
    SCSStepAwayFromStress: Joi.string().allow(""),
    SCSMentalHealthCrisis: Joi.string().allow(""),
    SCSAccessMentalHealthProfessional: Joi.string().allow(""),
    SCSPracticeSafeSex: Joi.string().allow(""),
    SCSPreventPregnancy: Joi.string().allow(""),
    SCSReliableSafeSexInfo: Joi.string().allow(""),
    SCSProtectFromSTDs: Joi.string().allow(""),
    SCSGetTestedForSTDs: Joi.string().allow(""),
    SCSFamilyMedicalHistory: Joi.string().allow(""),
    RCConfidentSpeakingUp: Joi.string().allow(""),
    RCChoicesConsequences: Joi.string().allow(""),
    RCCopeFrustration: Joi.string().allow(""),
    RCBehaveAroundPeers: Joi.string().allow(""),
    RCBehaveAtWork: Joi.string().allow(""),
    RCRespectBeliefs: Joi.string().allow(""),
    RCRacialIdentity: Joi.string().allow(""),
    RCExploreGender: Joi.string().allow(""),
    RCValuedRelationships: Joi.string().allow(""),
    RCGivingConsent: Joi.string().allow(""),
    RCIdentifyAbuse: Joi.string().allow(""),
    RCFamilyInfo: Joi.string().allow(""),
    RCShowAffection: Joi.string().allow(""),
    RCNewRelationships: Joi.string().allow(""),
    HMMTDailyBudget: Joi.string().allow(""),
    HMMTCreditPayments: Joi.string().allow(""),
    HMMTCreditScoreImportance: Joi.string().allow(""),
    HMMTGetCreditScore: Joi.string().allow(""),
    HMMTManageBankAccount: Joi.string().allow(""),
    HMMTSaveMoney: Joi.string().allow(""),
    HMMTOnlineBanking: Joi.string().allow(""),
    HMMTMoneyTransferApps: Joi.string().allow(""),
    HMMTCheckCashingRisks: Joi.string().allow(""),
    HMMTFindHousing: Joi.string().allow(""),
    HMMTLeaseChecklist: Joi.string().allow(""),
    HMMTPlanMovingCosts: Joi.string().allow(""),
    HMMTRentalApplication: Joi.string().allow(""),
    HMMTUtilityResources: Joi.string().allow(""),
    HMMTRentersInsurance: Joi.string().allow(""),
    HMMTMonthlyBills: Joi.string().allow(""),
    HMMTDriversLicense: Joi.string().allow(""),
    HMMTGetLicense: Joi.string().allow(""),
    HMMTCarBudget: Joi.string().allow(""),
    HMMTPublicTransport: Joi.string().allow(""),
    WSLResumeDevelopment: Joi.string().allow(""),
    WSLJobApplication: Joi.string().allow(""),
    WSLJobInterviewPrep: Joi.string().allow(""),
    WSLJobHelp: Joi.string().allow(""),
    WSLPaystubInfo: Joi.string().allow(""),
    WSLWorkDocuments: Joi.string().allow(""),
    WSLW4Form: Joi.string().allow(""),
    WSLEmployerBenefits: Joi.string().allow(""),
    WSLTaxHelp: Joi.string().allow(""),
    WSLSexualHarassment: Joi.string().allow(""),
    WSLWorkplaceDiscrimination: Joi.string().allow(""),
    WSLCounselingHelp: Joi.string().allow(""),
    WSLFeedbackImprovement: Joi.string().allow(""),
    WSLExamPrep: Joi.string().allow(""),
    WSLTutoringHelp: Joi.string().allow(""),
    WSLReviewWork: Joi.string().allow(""),
    WSLOnTimeWork: Joi.string().allow(""),
    WSLPlannerUse: Joi.string().allow(""),
    WSLEmployeeRights: Joi.string().allow(""),
    CEPFindInternships: Joi.string().allow(""),
    CEPJobTrainingInfo: Joi.string().allow(""),
    CEPJobAppResources: Joi.string().allow(""),
    CEPVolunteerBenefits: Joi.string().allow(""),
    CEPCareerMentor: Joi.string().allow(""),
    CEPFindEduMentor: Joi.string().allow(""),
    CEPFafsaFamiliar: Joi.string().allow(""),
    CEPEduPlansAdvisor: Joi.string().allow(""),
    CEPLoanSupport: Joi.string().allow(""),
    CEGGroupBelonging: Joi.string().allow(""),
    CEGVolunteerTime: Joi.string().allow(""),
    CEGBeliefDecisions: Joi.string().allow(""),
    CEGCommunityWork: Joi.string().allow(""),
    CEGSupportNeighbors: Joi.string().allow(""),
    CEGAdvocateIssues: Joi.string().allow(""),
    CEGShareViews: Joi.string().allow(""),
    CEGExpressOpinion: Joi.string().allow(""),
    CEGRegisterVote: Joi.string().allow(""),
    CEGResearchInfo: Joi.string().allow(""),
    CWSPermanencyGoal: Joi.string().allow(""),
    CWSSeeRecords: Joi.string().allow(""),
    CWSContactOmbudsperson: Joi.string().allow(""),
    CWSRightToLawyer: Joi.string().allow(""),
    CWSCourtNotifications: Joi.string().allow(""),
    CWSParticipateInCourt: Joi.string().allow(""),
    CWSUnderstandTerms: Joi.string().allow(""),
    CWSSharePlans: Joi.string().allow(""),
    CWSUnderstandCASA: Joi.string().allow(""),
    CWSExtendedFosterCare: Joi.string().allow(""),
    LFPositiveOutlook: Joi.string().allow(""),
    LFSeeSuccess: Joi.string().allow(""),
    LFMentorYouth: Joi.string().allow(""),
    LFSupportSystem: Joi.string().allow(""),
    LFFeelConfident: Joi.string().allow(""),
    LFFeelProud: Joi.string().allow(""),
    LFExcitedNextPhase: Joi.string().allow(""),
  },
  "3C2C3F4F-F484-EF11-9C36-F2196B5B1C94": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SAFYOfficeAddress: Joi.string()
      .allow("")
      .required()
      .label("SAFY Office Address"),
    SAFYOfficeContactNumber: Joi.string()
      .allow("")
      .required()
      .label("SAFY Office Contact Number"),
    CustodialAgencyName: Joi.string()
      .allow("")
      .required()
      .label("Custodial Agency Name"),
    CustodialAgencyAddress: Joi.string()
      .allow("")
      .required()
      .label("Custodial Agency Address"),
    CustodialAgencyContactNumber: Joi.string()
      .allow("")
      .required()
      .label("Custodial Agency Contact Number"),
    CustodialCaseworkerName: Joi.string()
      .allow("")
      .required()
      .label("Caseworker Name"),
    CustodialCaseworkerAddress: Joi.string()
      .allow("")
      .required()
      .label("Custodial Caseworker Address"),
    CustodialCaseworkerContactNumber: Joi.string()
      .allow("")
      .required()
      .label("Custodial Caseworker Contact Number"),
    CustodialCaseworkerEmail: Joi.string()
      .allow("")
      .required()
      .label("Custodial Caseworker Email Address"),
    CaregiverName: Joi.string().required().label("Caregiver Name"),
    CaregiverAddress: Joi.string()
      .allow("")
      .required()
      .label("Caregiver Address"),
    ReasonForPlacement: Joi.string()
      .allow("")
      .required()
      .label("Reason for placement"),
    PermanencyPlan: Joi.string().required().label("Permanency plan"),
    SpecialNeeds: Joi.string().required().label("Special needs"),
    History: Joi.string().required().label("History"),
    Procedures: Joi.string().required().label("Procedures"),
    PotentialHarm: Joi.string().required().label("Potential risk"),
    OutOfControlAntecedents: Joi.string()
      .allow("")
      .required()
      .label("Antecedents"),
    PreviousInterventions: Joi.string()
      .allow("")
      .required()
      .label("Previous interventions"),
    PsychologicalFactors: Joi.string()
      .allow("")
      .required()
      .label("Psychological factors"),
    MedicalFactors: Joi.string().required().label("Medical factors"),
    BehaviorManagementInterventions: Joi.string()
      .allow("")
      .required()
      .label("Behavior management interventions"),
    Height: Joi.string().required().label("Height"),
    Weight: Joi.string().required().label("Weight"),
    HairColor: Joi.string().required().label("Hair color"),
    EyeColor: Joi.string().required().label("Eye color"),
    Allergies: Joi.string().allow("").label("Allergies"),
    Reactions: Joi.string().allow(""),
    EpiPenRequired: Joi.string().allow(""),
    RecentSurgeries: Joi.string().allow("").label("Hospital stays"),
    SurgeryComplications: Joi.string()
      .allow("")
      .required()
      .label("Surgery complications"),
    ComplicationsDetails: Joi.string()
      .allow("")
      .label("Surgery complication details")
      .when("SurgeryComplications", {
        is: "1",
        then: Joi.required(),
      }),
    Treated: Joi.string().required().label("Treated"),
    TreatedDetails: Joi.string()
      .allow("")
      .label("Treated Details")
      .when("Treated", { is: "1", then: Joi.required() }),
    LastDoctorVisit: Joi.string()
      .allow("")
      .required()
      .label("Last doctor visit"),
    ReasonForDoctorVisit: Joi.string()
      .allow("")
      .required()
      .label("Reason for doctor visit"),
    SafyContactFamily: Joi.string()
      .allow("")
      .required()
      .label("SAFY family contact"),
    SafyContactRestrictions: Joi.string()
      .allow("")
      .label("SAFY contact restrictions")
      .when("SafyContactFamily", {
        is: "1",
        then: Joi.required(),
      }),
    SafyNoContactDetails: Joi.string()
      .allow("")
      .label("SAFY no contact details")
      .when("SafyContactFamily", {
        is: "0",
        then: Joi.required(),
      }),
    FamilyContactName: Joi.string()
      .allow("")
      .label("Family contact name")
      .when("SafyContactFamily", {
        is: "1",
        then: Joi.required(),
      }),
    FamilyContactPhoneNumber: Joi.string()
      .allow("")
      .label("Family contact phone number")
      .when("SafyContactFamily", {
        is: "1",
        then: Joi.required(),
      }),
    FamilyContactAddress: Joi.string()
      .allow("")
      .label("Family contact address")
      .when("SafyContactFamily", {
        is: "1",
        then: Joi.required(),
      }),
    InitialEntry: Joi.string().required().label("Initial entry"),
    HealthScreening: Joi.string()
      .allow("")
      .label("Health screening")
      .when("InitialEntry", {
        is: "1",
        then: Joi.required(),
      }),
    HealthScreeningDate: Joi.string()
      .allow("")
      .label("Health screening date")
      .when("HealthScreening", {
        is: "1",
        then: Joi.required(),
      }),
    HealthConcerns: Joi.string().required().label("Health concerns"),
    HealthConcernsDetails: Joi.string()
      .allow("")
      .label("Health concerns details")
      .when("HealthConcerns", {
        is: "1",
        then: Joi.required(),
      }),
    MentalHealthServices: Joi.string()
      .allow("")
      .required()
      .label("Mental health services"),
    MentalHealthServicesDetails: Joi.string()
      .allow("")
      .label("Mental health services details")
      .when("MentalHealthServices", {
        is: "1",
        then: Joi.required(),
      }),
    RecipientSmokes: Joi.string()
      .allow("")
      .required()
      .label("Recipient smokes"),
    PermissionToSmoke: Joi.string()
      .allow("")
      .required()
      .label("Permission to smoke"),
    Unsupervised: Joi.string().required().label("Unsupervised"),
    UnsupervisedDetails: Joi.string()
      .allow("")
      .label("Unsupervised details")
      .when("Unsupervised", {
        is: "1",
        then: Joi.required(),
      }),
    GALCASAWorkerName: Joi.string().allow("").label("GAL name"),
    GALCASAWorkerPhoneNumber: Joi.string().allow("").label("GAL phone number"),
    GALCASAWorkerEmail: Joi.string().allow("").label("GAL worker email"),
    CASAWorkerName: Joi.string().allow("").label("CASA worker name"),
    CASAWorkerPhoneNumber: Joi.string()
      .allow("")
      .label("CASA worker phone number"),
    CASAWorkerEmail: Joi.string().allow("").label("CASA worker email"),
    DriversLicense: Joi.string().required().label("Driver's license"),
    PermissionToDrive: Joi.string()
      .allow("")
      .required()
      .label("Permission to drive"),
    StayWithFriend: Joi.string()
      .allow("")
      .required()
      .label("Permission to stay with friend"),
    RideWithUnderEighteen: Joi.string()
      .allow("")
      .required()
      .label("Permission to ride with under 18"),
    EducationProviders: Joi.string()
      .allow("")
      .required()
      .label("Education providers"),
    LastGrade: Joi.string().required().label("Last grade"),
    VisitationPlan: Joi.string().required().label("Visitation plan"),
    VisitationFrequency: Joi.string()
      .allow("")
      .required()
      .label("Visitation frequency"),
    VisitationLocation: Joi.string()
      .allow("")
      .required()
      .label("Visitation location"),
    VisitationDuration: Joi.string()
      .allow("")
      .required()
      .label("Visitation duration"),
    VisitationLimitations: Joi.string()
      .allow("")
      .required()
      .label("Visitation limitations"),
    VisitationCourtOrders: Joi.string()
      .allow("")
      .required()
      .label("Visitation court orders"),
    VisitationTransportation: Joi.string()
      .allow("")
      .required()
      .label("Visitation transportation"),
    EvacuationPlan: Joi.string().required().label("Evacuation plan"),
    SpecificRules: Joi.string().required().label("Specific rules"),
    PrivacyPractices: Joi.string()
      .allow("")
      .required()
      .label("Privacy practices"),
    SexEd: Joi.string()
      .allow("")
      .required()
      .label("HIV/AIDS and Pregnancy Prevention Education"),
    ClientRights: Joi.string()
      .allow("")
      .required()
      .label("Client Rights and Grievance"),
    TeenMomSIDS: Joi.string().allow(""),
  },
  "7208B2D9-F784-EF11-9C36-F2196B5B1C94": {
    SelectedProgram: Joi.string().required(),
    PlanType: Joi.string().required().label("Plan Type"),
    CrisisPlanDate: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().required().label("Date of Plan"),
    }),
    Participants: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().required().label("Participants"),
    }),
    YouthName: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Youth Name"),
    }),
    FileNumber: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Wrap File #"),
    }),
    DateCompleted: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.date().max("now").required().label("Date"),
    }),
    DateOfBirth: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.date().max("now").required().label("Date of Birth"),
    }),
    GuardianName: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Guardian Name"),
    }),
    GuardianPhone: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Guardian Phone"),
    }),
    GuardianAddress: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Guardian Address"),
    }),
    PlanStartDate: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.date().required().label("Start Date"),
    }),
    PlanTargetDate: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.date().required().label("Target Completion Date"),
    }),
    FamilyVision: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.array()
        .items({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          Vision: Joi.string().required().label("Vision"),
          Rating: Joi.string()
            .when("PlanType", {
              is: "Review",
              then: Joi.string().required().label("Rating"),
            })
            .when("PlanType", {
              is: "Discharge",
              then: Joi.string().required().label("Rating"),
            }),
          EndDate: Joi.alternatives([
            Joi.date().allow(null),
            Joi.string().valid(""),
          ]).label("End Date"),
        })
        .min(1)
        .label("Family Vision"),
    }),
    TeamMission: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.array()
        .items({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          Mission: Joi.string().required().label("Mission"),
          Rating: Joi.string()
            .when("PlanType", {
              is: "Review",
              then: Joi.string().required().label("Rating"),
            })
            .when("PlanType", {
              is: "Discharge",
              then: Joi.string().required().label("Rating"),
            }),
          EndDate: Joi.alternatives([
            Joi.date().allow(null),
            Joi.string().valid(""),
          ]).label("End Date"),
        })
        .min(1)
        .label("Team Mission"),
    }),
    IndividualStrengths: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.array()
        .items({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          Name: Joi.string().required().label("Name"),
          Strengths: Joi.string().required().label("Strengths"),
        })
        .min(1)
        .label("Strengths"),
    }),
    Diagnosis: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Diagnosis"),
    }),
    Medications: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required().label("Medications"),
    }),
    Symptoms: Joi.string().required().label("Symptoms"),
    BriefHistory: Joi.string().required().label("Brief History"),
    Triggers: Joi.string().required().label("Triggers"),
    PotentialCrisis: Joi.string().required().label("Potential Crisis"),
    ActionSteps: Joi.string().required().label("Action Steps"),
    ResponsibleParties: Joi.string().required().label("Responsible Parties"),
    YoungCount: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.number()
        .min(0)
        .max(10)
        .required()
        .label("Number of youth in home"),
    }),
    AtRiskCount: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.number()
        .min(0)
        .max(10)
        .required()
        .label("Number of youth at risk of removal"),
    }),
    YoungRemaining: Joi.when("PlanType", {
      is: "Discharge",
      then: Joi.number()
        .min(0)
        .max(10)
        .required()
        .label("Number of youth in home at time of closure"),
    }),
    AtRiskRemaining: Joi.when("PlanType", {
      is: "Discharge",
      then: Joi.number()
        .min(0)
        .max(10)
        .required()
        .label("Number of at risk youth remaining"),
    }),
    NeedsStrategies: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow("", null),
      otherwise: Joi.array()
        .items({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          NeedsStatement: Joi.string().required().label("Needs Statement"),
          StartDate: Joi.date().required().label("Start Date"),
          EndDate: Joi.alternatives([
            Joi.date().allow(null),
            Joi.string().valid(""),
          ]).label("End Date"),
          NeedProgress: Joi.when("PlanType", {
            is: "Review",
            then: Joi.string().required().label("Need Progress"),
          }).when("PlanType", {
            is: "Discharge",
            then: Joi.string().required().label("Need Progress"),
          }),
          Outcome: Joi.string().required().label("Outcome"),
          OutcomeProgress: Joi.when("PlanType", {
            is: "Review",
            then: Joi.string().required().label("Outcome Progress"),
          }).when("PlanType", {
            is: "Discharge",
            then: Joi.string().required().label("Outcome Progress"),
          }),
          ProblemImpact: Joi.string().required().label("Problem Significance"),
          Family: Joi.boolean(),
          Residence: Joi.boolean(),
          Social: Joi.boolean(),
          Education: Joi.boolean(),
          Medical: Joi.boolean(),
          Community: Joi.boolean(),
          Psychological: Joi.boolean(),
          Safety: Joi.boolean(),
          Strategies: Joi.array()
            .items({
              _id: Joi.any(),
              Strategy: Joi.string().required(),
              Completed: Joi.boolean(),
              DateCompleted: Joi.alternatives([
                Joi.date().allow(null),
                Joi.string().valid(""),
              ]).label("End Date"),
            })
            .min(1)
            .label("Strategies"),
        })
        .min(1),
    }),
    TeamContacts: Joi.when("PlanType", {
      is: "Crisis Plan",
      then: Joi.string().allow(""),
      otherwise: Joi.array()
        .items({
          _id: Joi.any(),
          IsEditable: Joi.boolean(),
          SupportName: Joi.string().required().label("Support Name"),
          Contact: Joi.string().required().label("Contact and Organization"),
          Role: Joi.string().required().label("Role"),
        })
        .min(1),
    }),
    SupportSummary: Joi.when("PlanType", {
      is: "Discharge",
      then: Joi.string().required().label("Support Summary"),
    }),
    Recommendations: Joi.when("PlanType", {
      is: "Discharge",
      then: Joi.string().required().label("Further Recommendations"),
    }),
  },
  "9D8FC9AA-8285-EF11-9C36-F2196B5B1C94": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    FosterParents: Joi.string().required().label("Foster Parents"),
    DateOfPlacement: Joi.string().required().label("Date of Placement"),
    PerDiem: Joi.string().required().label("Per Diem"),
  },
  "15493BFC-7E86-EF11-9C36-F2196B5B1C94": {
    SelectedProgram: Joi.string().required(),
    DateOfAssessment: Joi.string().required(),
    TypeOfAssessment: Joi.string().required(),
    AssessorName: Joi.string().required(),
    AENVStability: Joi.string().allow(""),
    AENVSafety: Joi.string().allow(""),
    AENVRisks: Joi.string().allow(""),
    AENVHabitability: Joi.string().allow(""),
    AENVLearning: Joi.string().allow(""),
    AENVOverall: Joi.string().required(),
    AENVComments: Joi.string().allow(""),
    BPCSupervision: Joi.string().allow(""),
    BPCDisciplinaries: Joi.string().allow(""),
    BPCOpportunities: Joi.string().allow(""),
    BPCDrugs: Joi.string().allow(""),
    BPCEducation: Joi.string().allow(""),
    BPCLiteracy: Joi.string().allow(""),
    BPCResilience: Joi.string().allow(""),
    BPCOverall: Joi.string().required(),
    BPCComments: Joi.string().allow(""),
    CFIBonding: Joi.string().allow(""),
    CFICommunication: Joi.string().allow(""),
    CFIExpectations: Joi.string().allow(""),
    CFISupport: Joi.string().allow(""),
    CFIParents: Joi.string().allow(""),
    CFIRoutines: Joi.string().allow(""),
    CFIRecreation: Joi.string().allow(""),
    CFIOverall: Joi.string().required(),
    CFIComments: Joi.string().allow(""),
    DFSViolence: Joi.string().allow(""),
    DFSConflict: Joi.string().allow(""),
    DFSPhysical: Joi.string().allow(""),
    DFSEmotional: Joi.string().allow(""),
    DFSSexual: Joi.string().allow(""),
    DFSNeglect: Joi.string().allow(""),
    DFSWeapons: Joi.string().allow(""),
    DFSOverall: Joi.string().required(),
    DFSComments: Joi.string().allow(""),
    ECWBehavior: Joi.string().allow(""),
    ECWSchoolPerformance: Joi.string().allow(""),
    ECWChildParent: Joi.string().allow(""),
    ECWChildPeers: Joi.string().allow(""),
    ECWMaintain: Joi.string().allow(""),
    ECWSubstances: Joi.string().allow(""),
    ECWCompetence: Joi.string().allow(""),
    ECWOverall: Joi.string().allow(""),
    ECWComments: Joi.string().allow(""),
    FYWBehavior: Joi.string().allow(""),
    FYWSchoolPerformance: Joi.string().allow(""),
    FYWChildParent: Joi.string().allow(""),
    FYWChildPeers: Joi.string().allow(""),
    FYWMaintain: Joi.string().allow(""),
    FYWSubstances: Joi.string().allow(""),
    FYWCompetence: Joi.string().allow(""),
    FYWOverall: Joi.string().allow(""),
    FYWComments: Joi.string().allow(""),
    GSCLSocial: Joi.string().allow(""),
    GSCLSchool: Joi.string().allow(""),
    GSCLCommunity: Joi.string().allow(""),
    GSCLSpiritual: Joi.string().allow(""),
    GSCLHelp: Joi.string().allow(""),
    GSCLOverall: Joi.string().required(),
    GSCLComments: Joi.string().allow(""),
    HSSEmployment: Joi.string().allow(""),
    HSSIncome: Joi.string().allow(""),
    HSSBudgeting: Joi.string().allow(""),
    HSSNutrition: Joi.string().allow(""),
    HSSTransport: Joi.string().allow(""),
    HSSOverall: Joi.string().required(),
    HSSComments: Joi.string().allow(""),
    IFHPPhysical: Joi.string().allow(""),
    IFHPDisability: Joi.string().allow(""),
    IFHPMental: Joi.string().allow(""),
    IFHCPhysical: Joi.string().allow(""),
    IFHCDisability: Joi.string().allow(""),
    IFHCMental: Joi.string().allow(""),
    IFHAccess: Joi.string().allow(""),
    IFHOverall: Joi.string().required(),
    IFHComments: Joi.string().allow(""),
    JCCAParent: Joi.string().allow(""),
    JCCAChild: Joi.string().allow(""),
    JCCASub: Joi.string().allow(""),
    JCCAAttachment: Joi.string().allow(""),
    JCCAVisits: Joi.string().allow(""),
    JCCAOverall: Joi.string().required(),
    JCCAComments: Joi.string().allow(""),
    KRRNA: Joi.boolean(),
    KRRCPSRisk: Joi.string().allow(""),
    KRRPlans: Joi.string().allow(""),
    KRRLegal: Joi.string().allow(""),
    KRRNeeds: Joi.string().allow(""),
    KRRBackupPlans: Joi.string().allow(""),
    KRROverall: Joi.string().allow(""),
    KRRComments: Joi.string().allow(""),
    LTNA: Joi.boolean(),
    LTSexual: Joi.string().allow(""),
    LTPhysical: Joi.string().allow(""),
    LTNeglect: Joi.string().allow(""),
    LTEmotional: Joi.string().allow(""),
    LTTrauma: Joi.string().allow(""),
    LTOverall: Joi.string().allow(""),
    LTComments: Joi.string().allow(""),
    MPTNA: Joi.boolean(),
    MPTPhysical: Joi.string().allow(""),
    MPTEmotional: Joi.string().allow(""),
    MPTSocial: Joi.string().allow(""),
    MPTSupport: Joi.string().allow(""),
    MPTParents: Joi.string().allow(""),
    MPTOverall: Joi.string().allow(""),
    MPTComments: Joi.string().allow(""),
  },
  "DBBD9199-328B-EF11-9C36-F2196B5B1C94": {
    SelectedProgram: Joi.string().allow(""),
    DateOfAssessment: Joi.string().allow(""),
    TypeOfAssessment: Joi.string().allow(""),
    CompletedBy: Joi.string().allow(""),
    CaregiverName: Joi.string().allow(""),
    NaturalDisaster: Joi.string().allow(""),
    Accident: Joi.string().allow(""),
    ThreatenFamily: Joi.string().allow(""),
    ThreatenCommunity: Joi.string().allow(""),
    Attacked: Joi.string().allow(""),
    ThreatenFamilyWitness: Joi.string().allow(""),
    ThreatenCommuntiyWitness: Joi.string().allow(""),
    SexualAbuse: Joi.string().allow(""),
    SexualAbuseOnline: Joi.string().allow(""),
    BulliedInPerson: Joi.string().allow(""),
    BulliedOnline: Joi.string().allow(""),
    RecentDeath: Joi.string().allow(""),
    MedicalProcedure: Joi.string().allow(""),
    AffectedByWar: Joi.string().allow(""),
    OtherEvent: Joi.string().allow(""),
    OtherEventDetails: Joi.string().allow(""),
    UpsettingThoughts: Joi.string().allow(""),
    BadDreams: Joi.string().allow(""),
    EventNow: Joi.string().allow(""),
    UpsetReminder: Joi.string().allow(""),
    PhysicalReactions: Joi.string().allow(""),
    RepressedFeelings: Joi.string().allow(""),
    AvoidingReminders: Joi.string().allow(""),
    ForgetPart: Joi.string().allow(""),
    NegativeOutlook: Joi.string().allow(""),
    EventCausedWrong: Joi.string().allow(""),
    MoreNegativity: Joi.string().allow(""),
    LossOfInterest: Joi.string().allow(""),
    SocialWithdrawal: Joi.string().allow(""),
    LessPositivity: Joi.string().allow(""),
    Irritability: Joi.string().allow(""),
    RiskyBehavior: Joi.string().allow(""),
    HyperAware: Joi.string().allow(""),
    EasilyStartled: Joi.string().allow(""),
    LessConcentration: Joi.string().allow(""),
    SleepProblems: Joi.string().allow(""),
    GettingAlong: Joi.string().allow(""),
    Hobbies: Joi.string().allow(""),
    SchoolWork: Joi.string().allow(""),
    Relationships: Joi.string().allow(""),
    Happiness: Joi.string().allow(""),
  },
  "1D96F40B-652C-EC11-AE72-0050F21C653C": {
    SelectedProgram: Joi.string().required(),
    DateOfAssessment: Joi.string().required().label("Date of Assessment"),
    TypeOfAssessment: Joi.string().required().label("Type of Assessment"),
    AssessorName: Joi.string().required().label("Assessor Name"),
    LFDFamily: Joi.string().required(),
    LFDSituation: Joi.string().required(),
    LFDSocial: Joi.string().required(),
    LFDRecreational: Joi.string().required(),
    LFDDevelopmental: Joi.string().required(),
    LFDJob: Joi.string().required(),
    LFDLegal: Joi.string().required(),
    LFDMedical: Joi.string().required(),
    LFDSexual: Joi.string().required(),
    LFDSleep: Joi.string().required(),
    LFDBehavior: Joi.string().required(),
    LFDAttendance: Joi.string().required(),
    LFDAchievement: Joi.string().required(),
    LFDDecisions: Joi.string().required(),
    LFDComments: Joi.string().allow(""),
    SDFamily: Joi.string().required(),
    SDInterpersonal: Joi.string().required(),
    SDOptimism: Joi.string().required(),
    SDEducational: Joi.string().required(),
    SDVocational: Joi.string().required(),
    SDTalents: Joi.string().required(),
    SDReligious: Joi.string().required(),
    SDCommunity: Joi.string().required(),
    SDRelationships: Joi.string().required(),
    SDResilience: Joi.string().required(),
    SDResourcefulness: Joi.string().required(),
    SDIdentity: Joi.string().required(),
    SDSupports: Joi.string().required(),
    SDComments: Joi.string().allow(""),
    CFDLanguage: Joi.string().required(),
    CFDTraditions: Joi.string().required(),
    CFDStress: Joi.string().required(),
    CFDComments: Joi.string().allow(""),
    CNRDSupervision: Joi.string().required(),
    CNRDInvolvement: Joi.string().required(),
    CNRDKnowledge: Joi.string().required(),
    CNRDOrganization: Joi.string().required(),
    CNRDResources: Joi.string().required(),
    CNRDStability: Joi.string().required(),
    CNRDMedical: Joi.string().required(),
    CNRDMental: Joi.string().required(),
    CNRDSubstances: Joi.string().required(),
    CNRDDevelopmental: Joi.string().required(),
    CNRDSafety: Joi.string().required(),
    CNRDComments: Joi.string().allow(""),
    BENDPsychosis: Joi.string().required(),
    BENDImpulsivity: Joi.string().required(),
    BENDDepression: Joi.string().required(),
    BENDAnxiety: Joi.string().required(),
    BENDOppositional: Joi.string().required(),
    BENDConduct: Joi.string().required(),
    BENDAdjustment: Joi.string().required(),
    BENDAttachment: Joi.string().required(),
    BENDAnger: Joi.string().required(),
    BENDSubstances: Joi.string().required(),
    BENDComments: Joi.string().allow(""),
    YRBDSuicide: Joi.string().required(),
    YRBDInjurious: Joi.string().required(),
    YRBDRecklessness: Joi.string().required(),
    YRBDDanger: Joi.string().required(),
    YRBDSexual: Joi.string().required(),
    YRBDRunaway: Joi.string().required(),
    YRBDDelinquent: Joi.string().required(),
    YRBDArson: Joi.string().required(),
    YRBDMisbehavior: Joi.string().required(),
    YRBDComments: Joi.string().allow(""),
    DNMCognitive: Joi.string().when("LFDDevelopmental", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    DNMCommunication: Joi.string().when("LFDDevelopmental", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    DNMDevelopmental: Joi.string().when("LFDDevelopmental", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    DNMSkills: Joi.string().when("LFDDevelopmental", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    DNMComments: Joi.string().allow(""),
    TMSexual: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMPhysical: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMNeglect: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMEmotional: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMMedical: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMDisaster: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMFamily: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMCommunity: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMCriminal: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMWarAffected: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMDisruptions: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMParental: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMCloseness: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMFrequency: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMDuration: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMForce: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMReaction: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMDysregulation: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMIntrusions: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMHyperarousal: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMGrief: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMNumbing: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMDissociation: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMAvoidance: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMComments: Joi.string().allow(""),
    SUDMSeverity: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMDuration: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMStage: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMPeer: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMParental: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMEnvironmental: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMComments: Joi.string().allow(""),
    VMPhysical: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMHistory: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMDomestic: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMEnvironmental: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMBullying: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMFrustration: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMHostility: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMParanoia: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMGains: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMViolent: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMAwareness: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMResponse: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMCommitment: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMTreatment: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMComments: Joi.string().allow(""),
    SABMRelationship: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMThreat: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMPlanning: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMAge: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMType: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMResponse: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMConsistency: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMHistory: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMSeverity: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMPrior: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMComments: Joi.string().allow(""),
    RMFrequency: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMConsistency: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMSafety: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMIllegal: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMReturn: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMInvolvement: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMExpectations: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMPlanning: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMComments: Joi.string().allow(""),
    JJMHistory: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMSeriousness: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMPlanning: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMSafety: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMPeers: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMParental: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMEnvironmental: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMComments: Joi.string().allow(""),
    FSMHistory: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMSeriousness: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMPlanning: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMAccelerants: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMIntention: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMSafety: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMResponse: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMRemorse: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMFuture: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMComments: Joi.string().allow(""),
  },
  "7C3AD111-1296-EF11-9C36-F2196B5B1C94": {
    SelectedProgram: Joi.string().required(),
    DateOfAssessment: Joi.date().required().label("Date of Assessment"),
    TypeOfAssessment: Joi.string().required().label("Type of Assessment"),
    FeelingNervous: Joi.number().required().min(0).max(3).label("1"),
    WorryingControl: Joi.number().required().min(0).max(3).label("2"),
    WorryingTooMuch: Joi.number().required().min(0).max(3).label("3"),
    TroubleRelaxing: Joi.number().required().min(0).max(3).label("4"),
    BeingRestless: Joi.number().required().min(0).max(3).label("5"),
    EasilyAnnoyed: Joi.number().required().min(0).max(3).label("6"),
    FeelingAfraid: Joi.number().required().min(0).max(3).label("7"),
    DifficultyLevel: Joi.number().required().min(0).max(3).label("8"),
    TotalScore: Joi.number(),
  },
  "0FF60CD2-979B-EF11-88D0-A022DA911E48": {
    SelectedProgram: Joi.string().required(),
    DateOfAssessment: Joi.date().required().label("Date of Assessment"),
    TypeOfAssessment: Joi.string().required().label("Type of Assessment"),
    LittleInterest: Joi.number().required().min(0).max(3).label("1"),
    FeelingDown: Joi.number().required().min(0).max(3).label("2"),
    TroubleSleeping: Joi.number().required().min(0).max(3).label("3"),
    FeelingTired: Joi.number().required().min(0).max(3).label("4"),
    PoorAppetite: Joi.number().required().min(0).max(3).label("5"),
    FeelingBad: Joi.number().required().min(0).max(3).label("6"),
    TroubleConcentrating: Joi.number().required().min(0).max(3).label("7"),
    MovementChanges: Joi.number().required().min(0).max(3).label("8"),
    SelfHarmThoughts: Joi.number().required().min(0).max(3).label("9"),
    DifficultyLevel: Joi.number().required().min(0).max(3).label("8"),
    TotalScore: Joi.number(),
  },
  "E5266890-DE9A-EF11-88D0-A022DA911E48": {
    SelectedProgram: Joi.string().required(),
    CompletedBy: Joi.string().required(),
    DateCompleted: Joi.string().required(),
    ECAbandonment: Joi.boolean(),
    ECAggression: Joi.boolean(),
    ECAlcohol: Joi.boolean(),
    ECBehavior: Joi.boolean(),
    ECDelinquency: Joi.boolean(),
    ECDevelopmental: Joi.boolean(),
    ECMental: Joi.boolean(),
    ECDrugUse: Joi.boolean(),
    ECEmotional: Joi.boolean(),
    ECConflict: Joi.boolean(),
    ECFinancial: Joi.boolean(),
    ECHousing: Joi.boolean(),
    ECLearning: Joi.boolean(),
    ECLegal: Joi.boolean(),
    ECMedical: Joi.boolean(),
    ECNeglect: Joi.boolean(),
    ECPhysical: Joi.boolean(),
    ECRisky: Joi.boolean(),
    ECRunning: Joi.boolean(),
    ECSchool: Joi.boolean(),
    ECSexual: Joi.boolean(),
    ECThoughts: Joi.boolean(),
    ECOther: Joi.boolean(),
    RiskOfRemoval: Joi.string().allow(""),
    RiskLikely: Joi.string().allow(""),
    OtherServices: Joi.string().allow(""),
    OtherServicesDetails: Joi.string().allow(""),
    Willing: Joi.string().allow(""),
    Familiar: Joi.string().allow(""),
    CarePlan: Joi.string().allow(""),
    Interested: Joi.string().allow(""),
    Comments: Joi.string().allow(""),
    Decision: Joi.string().required(),
    Results: Joi.string().when("Decision", { is: "Yes", then: Joi.required() }),
  },
  "387F55F5-289D-EF11-88D0-A022DA911E48": {
    SelectedProgram: Joi.string().required(),
    DateOfAssessment: Joi.string().required().label("Date of Assessment"),
    TypeOfAssessment: Joi.string().required().label("Type of Assessment"),
    AssessorName: Joi.string().required().label("Assessor Name"),
    LFDFamily: Joi.string().required(),
    LFDSituation: Joi.string().required(),
    LFDSocial: Joi.string().required(),
    LFDRecreational: Joi.string().required(),
    LFDDevelopmental: Joi.string().required(),
    LFDJob: Joi.string().required(),
    LFDLegal: Joi.string().required(),
    LFDMedical: Joi.string().required(),
    LFDSexual: Joi.string().required(),
    LFDSleep: Joi.string().required(),
    LFDBehavior: Joi.string().required(),
    LFDAttendance: Joi.string().required(),
    LFDAchievement: Joi.string().required(),
    LFDDecisions: Joi.string().required(),
    LFDComments: Joi.string().allow(""),
    SDFamily: Joi.string().required(),
    SDInterpersonal: Joi.string().required(),
    SDOptimism: Joi.string().required(),
    SDEducational: Joi.string().required(),
    SDVocational: Joi.string().required(),
    SDTalents: Joi.string().required(),
    SDReligious: Joi.string().required(),
    SDCommunity: Joi.string().required(),
    SDRelationships: Joi.string().required(),
    SDResilience: Joi.string().required(),
    SDResourcefulness: Joi.string().required(),
    SDIdentity: Joi.string().required(),
    SDSupports: Joi.string().required(),
    SDComments: Joi.string().allow(""),
    CFDLanguage: Joi.string().required(),
    CFDTraditions: Joi.string().required(),
    CFDStress: Joi.string().required(),
    CFDComments: Joi.string().allow(""),
    CNRDSupervision: Joi.string().required(),
    CNRDInvolvement: Joi.string().required(),
    CNRDKnowledge: Joi.string().required(),
    CNRDOrganization: Joi.string().required(),
    CNRDResources: Joi.string().required(),
    CNRDStability: Joi.string().required(),
    CNRDMedical: Joi.string().required(),
    CNRDMental: Joi.string().required(),
    CNRDSubstances: Joi.string().required(),
    CNRDDevelopmental: Joi.string().required(),
    CNRDSafety: Joi.string().required(),
    CNRDComments: Joi.string().allow(""),
    BENDPsychosis: Joi.string().required(),
    BENDImpulsivity: Joi.string().required(),
    BENDDepression: Joi.string().required(),
    BENDAnxiety: Joi.string().required(),
    BENDOppositional: Joi.string().required(),
    BENDConduct: Joi.string().required(),
    BENDAdjustment: Joi.string().required(),
    BENDAttachment: Joi.string().required(),
    BENDAnger: Joi.string().required(),
    BENDSubstances: Joi.string().required(),
    BENDComments: Joi.string().allow(""),
    YRBDSuicide: Joi.string().required(),
    YRBDInjurious: Joi.string().required(),
    YRBDRecklessness: Joi.string().required(),
    YRBDDanger: Joi.string().required(),
    YRBDSexual: Joi.string().required(),
    YRBDRunaway: Joi.string().required(),
    YRBDDelinquent: Joi.string().required(),
    YRBDArson: Joi.string().required(),
    YRBDMisbehavior: Joi.string().required(),
    YRBDComments: Joi.string().allow(""),
    DNMCognitive: Joi.string().when("LFDDevelopmental", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    DNMCommunication: Joi.string().when("LFDDevelopmental", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    DNMDevelopmental: Joi.string().when("LFDDevelopmental", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    DNMSkills: Joi.string().when("LFDDevelopmental", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    DNMComments: Joi.string().allow(""),
    TMSexual: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMPhysical: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMNeglect: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMEmotional: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMMedical: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMDisaster: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMFamily: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMCommunity: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMCriminal: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMWarAffected: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMDisruptions: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMParental: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMDysregulation: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMIntrusions: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMHyperarousal: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMGrief: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMNumbing: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMDissociation: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMAvoidance: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMComments: Joi.string().allow(""),
    SUDMSeverity: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMDuration: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMStage: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMPeer: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMParental: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMEnvironmental: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMComments: Joi.string().allow(""),
    VMPhysical: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMHistory: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMDomestic: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMEnvironmental: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMBullying: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMFrustration: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMHostility: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMParanoia: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMGains: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMViolent: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMAwareness: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMResponse: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMCommitment: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMTreatment: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMComments: Joi.string().allow(""),
    SABMRelationship: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMThreat: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMPlanning: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMAge: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMType: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMResponse: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMConsistency: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMHistory: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMSeverity: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMPrior: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMComments: Joi.string().allow(""),
    RMFrequency: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMConsistency: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMSafety: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMIllegal: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMReturn: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMInvolvement: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMExpectations: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMPlanning: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMComments: Joi.string().allow(""),
    JJMHistory: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMSeriousness: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMPlanning: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMSafety: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMPeers: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMParental: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMEnvironmental: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMComments: Joi.string().allow(""),
    FSMHistory: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMSeriousness: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMPlanning: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMAccelerants: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMIntention: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMSafety: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMResponse: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMRemorse: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMFuture: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMComments: Joi.string().allow(""),
  },
  "B8023952-4A9D-EF11-88D0-A022DA911E48": {
    SelectedProgram: Joi.string().required(),
    SAFYOfficeAddress: Joi.string().required(),
    Client1Initial: Joi.string().required(),
    Client1Name: Joi.string().required(),
    Client1Org: Joi.string().allow(""),
    Client1Street: Joi.string().required(),
    Client1CityState: Joi.string().required(),
    Client1Phone: Joi.string().required(),
    Client1Fax: Joi.string().allow(""),
    Client2Initial: Joi.string().allow(""),
    Client2Name: Joi.string().allow(""),
    Client2Org: Joi.string().allow(""),
    Client2Street: Joi.string().allow(""),
    Client2CityState: Joi.string().allow(""),
    Client2Phone: Joi.string().allow(""),
    Client2Fax: Joi.string().allow(""),
    Social: Joi.boolean(),
    Diagnostic: Joi.boolean(),
    Discharge: Joi.boolean(),
    Drugs: Joi.boolean(),
    Mental: Joi.boolean(),
    OtherType: Joi.boolean(),
    OtherTypeDetails: Joi.when("OtherType", {
      is: true,
      then: Joi.string().required(),
    }),
    Continuity: Joi.boolean(),
    Compliance: Joi.boolean(),
    Employment: Joi.boolean(),
    Legal: Joi.boolean(),
    Family: Joi.boolean(),
    Physician: Joi.boolean(),
    School: Joi.boolean(),
    OtherPurpose: Joi.boolean(),
    OtherPurposeDetails: Joi.when("OtherPurpose", {
      is: true,
      then: Joi.string().required(),
    }),
    TenDays: Joi.boolean(),
    ThreeMonths: Joi.boolean(),
    OtherTimeframe: Joi.boolean(),
    OtherTimeframeDetails: Joi.when("OtherTimeframe", {
      is: true,
      then: Joi.string().required(),
    }),
    Written: Joi.boolean(),
    Verbal: Joi.boolean(),
    Fax: Joi.boolean(),
    Audio: Joi.boolean(),
    Video: Joi.boolean(),
    Email: Joi.boolean(),
    Understand: Joi.boolean(),
    CancellationDate: Joi.string().allow(""),
    CancellationTime: Joi.string().allow(""),
    CancellationMode: Joi.string().allow(""),
  },
  "4DC4C79A-BBA2-EF11-88D0-A022DA911E48": {
    SelectedProgram: Joi.string().required(),
    RespiteLog: Joi.array()
      .items({
        _id: Joi.any(),
        IsEditable: Joi.boolean(),
        Start: Joi.string().required().label("Start of Respite"),
        End: Joi.string().required().label("End of Respite"),
        Providers: Joi.string().required().label("Respite Provider(s)"),
        Notified: Joi.string().required().label("FSM Notified"),
        Comments: Joi.string().allow(""),
      })
      .min(1),
  },
  "3FC9FC9C-EEA8-EF11-88D0-A022DA911E48": {
    SelectedProgram: Joi.string().required(),
    FamilyName: Joi.string().label("Family Name").required(),
    SafetyPlanDate: Joi.string().label("Date of Safety Plan").required(),
    Housing: Joi.boolean(),
    HousingDetails: Joi.string().allow(""),
    Food: Joi.boolean(),
    FoodDetails: Joi.string().allow(""),
    Clothing: Joi.boolean(),
    ClothingDetails: Joi.string().allow(""),
    Transportation: Joi.boolean(),
    TransportationDetails: Joi.string().allow(""),
    MedicalCare: Joi.boolean(),
    MedicalCareDetails: Joi.string().allow(""),
    Childcare: Joi.boolean(),
    ChildcareDetails: Joi.string().allow(""),
    Supervision: Joi.boolean(),
    SupervisionDetails: Joi.string().allow(""),
    DomesticViolence: Joi.boolean(),
    DomesticViolenceDetails: Joi.string().allow(""),
    FamilyConflict: Joi.boolean(),
    FamilyConflictDetails: Joi.string().allow(""),
    SubstanceAbuse: Joi.boolean(),
    SubstanceAbuseDetails: Joi.string().allow(""),
    Deescalation: Joi.boolean(),
    DeescalationDetails: Joi.string().allow(""),
    InfantSafety: Joi.boolean(),
    InfantSafetyDetails: Joi.string().allow(""),
    OtherConcerns: Joi.boolean(),
    OtherConcernsDetails: Joi.string().allow(""),
    FamilyStrengths: Joi.string()
      .label("What are the family's strengths? What is working right now?")
      .required(),
    PerspectiveOfRisk: Joi.string()
      .label("Caregiver/Family Perspective of Risk")
      .required(),
    SafetyNeeds: Joi.string()
      .label(
        "What needs to be in place to ensure the safety and wellbeing of everyone in the family?"
      )
      .required(),
    EnvironmentSteps: Joi.string()
      .label("What are steps the family can take to keep the environment safe?")
      .required(),
    MonitoringSteps: Joi.string()
      .label(
        "What are steps the family can take to have adequate monitoring/supervision?"
      )
      .required(),
    SupportForFamily: Joi.string()
      .label("Who can support the family in meeting their immediate needs?")
      .required(),
    PositiveInteractions: Joi.string()
      .label(
        "How can the family create positive interactions despite their immediate needs/crisis?"
      )
      .required(),
    AssessmentAndSteps: Joi.string()
      .label("Overall Assessment of Family Safety and Immediate Next Steps")
      .required(),
    Hotline: Joi.string().label("Hotline"),
    Hospital: Joi.string().label("Hospital/ED"),
    CrisisCenter: Joi.string().label("Crisis Center"),
    OtherEmergency: Joi.string().label("SAFY Crisis Line"),
    SAFYCrisisLine: Joi.string().label("Other"),
    Amendments: Joi.string().allow(""),
  },
  "31FDA303-C4B1-EF11-88D0-A022DA911E48": {
    SelectedProgram: Joi.string().required(),
    Family: Joi.string(),
    SAFYAware: Joi.string().required(),
    DateOfViolation: Joi.string().required(),
    ClientInitials: Joi.string().required(),
    RuleInfo: Joi.string().required(),
    Category: Joi.string().required(),
    Description: Joi.string().required(),
    MustReport: Joi.when("Category", {
      is: "Foster Parent PIP Only",
      then: Joi.string().required(),
    }),
    DateOfReport: Joi.when("Category", {
      is: "Foster Parent PIP Only",
      then: Joi.when("MustReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ReportedTo: Joi.when("Category", {
      is: "Foster Parent PIP Only",
      then: Joi.when("MustReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    NoReportReason: Joi.when("Category", {
      is: "Foster Parent PIP Only",
      then: Joi.when("MustReport", { is: "No", then: Joi.string().required() }),
    }),
    Investigation: Joi.when("Category", {
      is: "Foster Parent PIP Only",
      then: Joi.string().required(),
    }),
    HoldInternal: Joi.when("Category", {
      is: "Foster Parent PIP Only",
      then: Joi.string().required(),
    }),
    Impact: Joi.when("Category", {
      is: "Foster Parent PIP Only",
      then: Joi.string().required(),
    }),
    Removal: Joi.when("Category", {
      is: "Foster Parent PIP Only",
      then: Joi.string().required(),
    }),
    DateOfExternal: Joi.when("Category", {
      is: "Foster Parent PIP Only",
      then: Joi.when("Investigation", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ExternalOutcome: Joi.when("Category", {
      is: "Foster Parent PIP Only",
      then: Joi.when("Investigation", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ExternalDetails: Joi.when("Category", {
      is: "Foster Parent PIP Only",
      then: Joi.when("Investigation", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    Appeal: Joi.when("Category", {
      is: "Foster Parent PIP Only",
      then: Joi.when("Investigation", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DateOfAppeal: Joi.when("Category", {
      is: "Foster Parent PIP Only",
      then: Joi.when("Investigation", {
        is: "Yes",
        then: Joi.when("Appeal", { is: "Yes", then: Joi.string().required() }),
      }),
    }),
    ResultOfAppeal: Joi.when("Category", {
      is: "Foster Parent PIP Only",
      then: Joi.when("Investigation", {
        is: "Yes",
        then: Joi.when("Appeal", { is: "Yes", then: Joi.string().required() }),
      }),
    }),
    DateOfInternal: Joi.string().required(),
    InternalOutcome: Joi.string().required(),
    InternalDetails: Joi.string().required(),
    Status: Joi.string().required(),
  },
  "E0981824-E1B7-EF11-88D0-A022DA911E48": {
    SelectedProgram: Joi.string().required(),
    PlanType: Joi.string().required(),
    PlanDate: Joi.string().required(),
    ReviewDate: Joi.string().required(),
    Collateral: Joi.string().required(),
    Participants: Joi.string().required(),
    Strengths: Joi.string().required(),
    Housing: Joi.boolean(),
    Food: Joi.boolean(),
    Clothing: Joi.boolean(),
    Transportation: Joi.boolean(),
    Medical: Joi.boolean(),
    Childcare: Joi.boolean(),
    Supervision: Joi.boolean(),
    Substances: Joi.boolean(),
    Conflict: Joi.boolean(),
    Domestic: Joi.boolean(),
    Safety: Joi.boolean(),
    Deescalation: Joi.boolean(),
    OtherNeed: Joi.boolean(),
    OtherNeedDetails: Joi.when("OtherNeed", {
      is: true,
      then: Joi.string().required(),
    }),
    FamilyNeeds: Joi.string().required(),
    CaregiverNeeds: Joi.string().required(),
    ChildNeeds: Joi.string().required(),
    FSPComponents: Joi.string().required(),
  },
  "14B3E7C3-C9BB-EF11-88D0-A022DA911E48": {
    SelectedProgram: Joi.string().required(),
    DateOfIncident: Joi.string().required(),
    TimeOfIncident: Joi.string().required(),
    FosterHome: Joi.string().required(),
    NotifiedOn: Joi.string().required(),
    NotifiedBy: Joi.string().required(),
    NotifiedByOther: Joi.when("NotifiedBy", {
      is: "Other",
      then: Joi.string().required(),
    }),
    NotifiedMethod: Joi.string().required(),
    NotifiedMethodOther: Joi.when("NotifiedMethod", {
      is: "Other",
      then: Joi.string().required(),
    }),
    TypeOfIncident: Joi.string().required(),
    AbuseInHomeAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.when("AbuseInHomeAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseInHomeAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseInHomeNA: Joi.boolean(),
    AbuseInHomeDate: Joi.string().allow(""),
    AbuseInHomeTime: Joi.string().allow(""),
    AbuseInHomeNotes: Joi.string().allow(""),
    AbuseInHomeNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.when("AbuseInHomeNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseInHomeStepsTaken: Joi.string().allow(""),
    AbuseInHomeOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone in a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeAllegedBy: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeAllegedByOther: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.when("AbuseOutsideHomeAllegedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AbuseOutsideHomeAllegedAgainst: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeDescription: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AbuseOutsideHomeNA: Joi.boolean(),
    AbuseOutsideHomeDate: Joi.string().allow(""),
    AbuseOutsideHomeTime: Joi.string().allow(""),
    AbuseOutsideHomeNotes: Joi.string().allow(""),
    AbuseOutsideHomeNADetails: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.when("AbuseOutsideHomeNA", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AbuseOutsideHomeStepsTaken: Joi.string().allow(""),
    AbuseOutsideHomeOutcome: Joi.when("TypeOfIncident", {
      is: "Abuse/Neglect Allegation against someone outside of a SAFY Home",
      then: Joi.string().required(),
    }),
    AWOLDescription: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLLocated: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.string().required(),
    }),
    AWOLPoliceReport: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    AWOLDepartment: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLReportNumber: Joi.string().allow(""),
    AWOLOfficer: Joi.string().allow(""),
    AWOLNoReportReason: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "No",
        then: Joi.when("AWOLPoliceReport", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    AWOLOutcome: Joi.when("TypeOfIncident", {
      is: "AWOL",
      then: Joi.when("AWOLLocated", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathClient: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWho: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathClient", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathInvestigation: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhere: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathWhereOther: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    DeathDescription: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathPoliceReport: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathReportedBy: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathReportInfo: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DeathNoReportReason: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.when("DeathPoliceReport", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    DeathStepsTaken: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastDate: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    DeathLastTime: Joi.when("TypeOfIncident", {
      is: "Client/Immediate Family Member Death",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjury: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsWeapons: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsGuns: Joi.boolean(),
    HomicidalThoughtsKnives: Joi.boolean(),
    HomicidalThoughtsOtherWeapon: Joi.boolean(),
    HomicidalThoughtsOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsWeapons", {
        is: "Yes",
        then: Joi.when("HomicidalThoughtsOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    HomicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    HomicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Homicidal Thoughts, Gestures, Threats",
      then: Joi.when("HomicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("HomicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    HomicidalThoughtsNA: Joi.boolean(),
    HomicidalThoughtsDate: Joi.string().allow(""),
    HomicidalThoughtsTime: Joi.string().allow(""),
    RestraintAppliedBy: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintAppliedByOther: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintAppliedBy", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    RestraintLength: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintType: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintDescription: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInterventions: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInjury: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInjuryDetails: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintInjury", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    RestraintWellbeing: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintFollowup: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintModifications: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintObservation: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintInvestigation: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintOutcome: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.string().required(),
    }),
    RestraintOutcomeOther: Joi.when("TypeOfIncident", {
      is: Joi.any().valid(
        "Manual Restraint by SAFY Employee",
        "Manual Restraint by SAFY Home"
      ),
      then: Joi.when("RestraintOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicationRefusalDescription: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalSymptoms: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalSymptomDescription: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.when("MedicationRefusalSymptoms", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationRefusalChronic: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.string().required(),
    }),
    MedicationRefusalChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Medication Refusal",
      then: Joi.when("MedicationRefusalChronic", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorType: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorResponsible: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorResponsibleOther: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.when("MedicationErrorResponsible", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorDescription: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorSymptoms: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    MedicationErrorSymptomDescription: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.when("MedicationErrorSymptoms", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MedicationErrorInvestigation: Joi.when("TypeOfIncident", {
      is: "Medication Error",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyDescription: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencyOutcome: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.string().required(),
    }),
    PsychiatricEmergencySafetyPlan: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    PsychiatricEmergencyNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Psychiatric Emergency, excluding SI, HI or Self-Harm",
      then: Joi.when("PsychiatricEmergencyOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("PsychiatricEmergencySafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    PsychiatricEmergencyNA: Joi.boolean(),
    PsychiatricEmergencyDate: Joi.string().allow(""),
    PsychiatricEmergencyTime: Joi.string().allow(""),
    MedicalAttentionDrugReaction: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionDescription: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionOutcome: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.when("MedicalAttentionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    MedicalAttentionNA: Joi.boolean(),
    MedicalAttentionDate: Joi.string().allow(""),
    MedicalAttentionTime: Joi.string().allow(""),
    MedicalAttentionChronic: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.string().required(),
    }),
    MedicalAttentionChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Injury or Illness requiring medical attention",
      then: Joi.when("MedicalAttentionChronic", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsWhere: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsWhereOther: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsStepsTaken: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistory: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.when("SexualizedBehaviorsHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualizedBehaviorsFollowUp: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    SexualizedBehaviorsOutcome: Joi.when("TypeOfIncident", {
      is: "Problematic Sexualized Behaviors",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsWhere: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsWhereOther: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsIEP: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.string().required(),
    }),
    ProblematicBehaviorsPrevention: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsIEP", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsSupport: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsIEP", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    ProblematicBehaviorsOutcomeDetention: Joi.boolean(),
    ProblematicBehaviorsOutcomeSuspension: Joi.boolean(),
    ProblematicBehaviorsOutcomeExpulsion: Joi.boolean(),
    ProblematicBehaviorsOutcomeSafetyPlan: Joi.boolean(),
    ProblematicBehaviorsOutcomeIEP: Joi.boolean(),
    ProblematicBehaviorsOutcomeOther: Joi.boolean(),
    ProblematicBehaviorsOutcomeOtherDetails: Joi.when("TypeOfIncident", {
      is: "Problematic Behaviors at School/Other Care Setting",
      then: Joi.when("ProblematicBehaviorsOutcomeOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsSuicidal: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.string().required(),
    }),
    SelfHarmBehaviorsDescription: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjury: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsInjuryDetails: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsInjury", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsChronic: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsChronicTreatment: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsChronic", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SelfHarmBehaviorsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SelfHarmBehaviorsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Self-Harm Behaviors",
      then: Joi.when("SelfHarmBehaviorsSuicidal", {
        is: "No",
        then: Joi.when("SelfHarmBehaviorsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsDescription: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsCSSRs: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsNoCSSRsReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsCSSRs", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsOutcome: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.string().required(),
    }),
    SuicidalThoughtsSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicidalThoughtsNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicidal Thoughts, Gestures, Threats",
      then: Joi.when("SuicidalThoughtsOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicidalThoughtsSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicidalThoughtsNA: Joi.boolean(),
    SuicidalThoughtsDate: Joi.string().allow(""),
    SuicidalThoughtsTime: Joi.string().allow(""),
    SuicideAttemptDescription: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptExistingSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptNoExistingSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptExistingSafetyPlan", {
        is: "No",
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptOutcome: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.string().required(),
    }),
    SuicideAttemptSafetyPlan: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.string().required(),
      }),
    }),
    SuicideAttemptNoSafetyPlanReason: Joi.when("TypeOfIncident", {
      is: "Suicide Attempt",
      then: Joi.when("SuicideAttemptOutcome", {
        is: Joi.any().valid(
          "Caregiver resolved**",
          "SAFY resolved**",
          "Client evaluated by a mental health professional and released**",
          "Client treated by a medical professional and released**"
        ),
        then: Joi.when("SuicideAttemptSafetyPlan", {
          is: "No",
          then: Joi.string().required(),
        }),
      }),
    }),
    SuicideAttemptNA: Joi.boolean(),
    SuicideAttemptDate: Joi.string().allow(""),
    SuicideAttemptTime: Joi.string().allow(""),
    COVIDPositiveMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.string().required(),
    }),
    COVIDPositiveMedicalAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.when("COVIDPositiveMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    COVIDPositiveMedications: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.string().required(),
    }),
    COVIDPositiveMedicationDetails: Joi.when("TypeOfIncident", {
      is: "Positive for COVID",
      then: Joi.when("COVIDPositiveMedications", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    COVIDPositiveDate: Joi.string().allow(""),
    COVIDPositiveTime: Joi.string().allow(""),
    COVIDPositiveNA: Joi.boolean(),
    IllegalBehaviorWhere: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorWhereOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorWeapons: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorGuns: Joi.boolean(),
    IllegalBehaviorKnives: Joi.boolean(),
    IllegalBehaviorOtherWeapon: Joi.boolean(),
    IllegalBehaviorOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorWeapons", {
        is: "Yes",
        then: Joi.when("IllegalBehaviorOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    IllegalBehaviorSubstances: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorAlcohol: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorDescription: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorStepsTaken: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistory: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorHistoryDetails: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorHistory", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    IllegalBehaviorFollowUp: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorArrested: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcome: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.string().required(),
    }),
    IllegalBehaviorOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Illegal Behavior (to include substance use)",
      then: Joi.when("IllegalBehaviorOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionWhere: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionWhereOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    AggressionDescription: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnown: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionKnownDetails: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionKnown", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    AggressionFollowUp: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcome: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.string().required(),
    }),
    AggressionOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Aggression/Destruction towards people/property",
      then: Joi.when("AggressionOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    CarAccidentDescription: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicalAttention: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.string().required(),
    }),
    CarAccidentMedicationAttentionDetails: Joi.when("TypeOfIncident", {
      is: "Car Accident with SAFY Employee",
      then: Joi.when("CarAccidentMedicalAttention", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    VictimWhere: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimWhereOther: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.when("VictimWhere", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    VictimDescription: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimWeapons: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimGuns: Joi.boolean(),
    VictimKnives: Joi.boolean(),
    VictimOtherWeapon: Joi.boolean(),
    VictimOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.when("VictimWeapons", {
        is: "Yes",
        then: Joi.when("VictimOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    VictimStepsTaken: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    VictimFollowUp: Joi.when("TypeOfIncident", {
      is: "Victim in an Unsafe Peer Interaction",
      then: Joi.string().required(),
    }),
    MinorInjuryDescription: Joi.when("TypeOfIncident", {
      is: "Minor injury or illness (no medical attention necessary)",
      then: Joi.string().required(),
    }),
    MinorInjuryWeapons: Joi.when("TypeOfIncident", {
      is: "Minor injury or illness (no medical attention necessary)",
      then: Joi.string().required(),
    }),
    MinorInjuryGuns: Joi.boolean(),
    MinorInjuryKnives: Joi.boolean(),
    MinorInjuryOtherWeapon: Joi.boolean(),
    MinorInjuryOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Minor injury or illness (no medical attention necessary)",
      then: Joi.when("MinorInjuryWeapons", {
        is: "Yes",
        then: Joi.when("MinorInjuryOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    MinorInjuryStepsTaken: Joi.when("TypeOfIncident", {
      is: "Minor injury or illness (no medical attention necessary)",
      then: Joi.string().required(),
    }),
    MinorInjuryOutcome: Joi.when("TypeOfIncident", {
      is: "Minor injury or illness (no medical attention necessary)",
      then: Joi.string().required(),
    }),
    MinorInjuryOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Minor injury or illness (no medical attention necessary)",
      then: Joi.when("MinorInjuryOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    OtherTypeDescription: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeWeapons: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeGuns: Joi.boolean(),
    OtherTypeKnives: Joi.boolean(),
    OtherTypeOtherWeapon: Joi.boolean(),
    OtherTypeOtherWeaponDetails: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.when("OtherTypeWeapons", {
        is: "Yes",
        then: Joi.when("OtherTypeOtherWeapon", {
          is: true,
          then: Joi.string().required(),
        }),
      }),
    }),
    OtherTypeStepsTaken: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcome: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.string().required(),
    }),
    OtherTypeOutcomeOther: Joi.when("TypeOfIncident", {
      is: "Other",
      then: Joi.when("OtherTypeOutcome", {
        is: "Other",
        then: Joi.string().required(),
      }),
    }),
    ResolvedStatus: Joi.string().required().label("Resolved Status"),
    FollowUp: Joi.array()
      .items(Joi.string().required())
      .min(1)
      .required()
      .label("Plan of Prevention/Follow-Up"),
    CountyNotified: Joi.string().required(),
    CountyNotifiedName: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    CountyNotifiedWhen: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    CountyNotifiedComments: Joi.when("CountyNotified", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    NotNotifiedDetails: Joi.when("CountyNotified", {
      is: "No",
      then: Joi.string().required(),
    }),
    OtherNotificationsNeeded: Joi.string().required(),
    OtherNotifiedName: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedWhen: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherNotifiedComments: Joi.when("OtherNotificationsNeeded", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    ResolutionAmendments: Joi.string().allow(""),
  },
  "8F069071-CEBB-EF11-88D0-A022DA911E48": {
    SelectedProgram: Joi.string().required(),
    ReportMonth: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    ICWIS: Joi.string().required(),
    Permanency: Joi.string().required(),
    Connections: Joi.string().required(),
    ReferralDate: Joi.string().required(),
    ReferralReason: Joi.string().required(),
    PresentingProblem: Joi.string().required(),
    ServiceDetails: Joi.string().allow(""),
    AuthorizationAttempts: Joi.string().required(),
    IncidentReports: Joi.string().allow(""),
    PlanUpdates: Joi.string().required(),
    RespiteUpdates: Joi.string().required(),
    OtherServices: Joi.string().required(),
    Adjusted: Joi.string().required(),
    Progress: Joi.string().required(),
    DischargePlan: Joi.string().required(),
    ProjectedDischargeDate: Joi.string().required(),
  },
  "B40F0809-83BC-EF11-88D0-A022DA911E48": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateOfDischarge: Joi.string()
      .allow("")
      .required()
      .label("Date of Discharge"),
    DischargedTo: Joi.string()
      .allow("")
      .required()
      .label("Person/Agency to which client has been discharged"),
    DischargedToAddress: Joi.string()
      .allow("")
      .required()
      .label("Address of where client has been discharged"),
    DischargeReason: Joi.string()
      .allow("")
      .required()
      .label("Reason for discharge"),
    BriefExplanation: Joi.string()
      .allow("")
      .label("Brief Explanation")
      .when("DischargeReason", {
        is: "186460008",
        then: Joi.required(),
      })
      .when("DischargeReason", {
        is: "186460005",
        then: Joi.required(),
      })
      .when("DischargeReason", {
        is: "186460006",
        then: Joi.required(),
      }),
    OutpatientMentalHealth: Joi.boolean(),
    OutpatientMentalHealthReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("OutpatientMentalHealth", {
        is: true,
        then: Joi.required(),
      }),
    OutpatientSubstanceAbuse: Joi.string()
      .allow("")
      .label("Outpatient Alcohol/Substance Abuse"),
    OutpatientSubstanceAbuseReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("OutpatientSubstanceAbuse", {
        is: true,
        then: Joi.required(),
      }),
    HousingAssistance: Joi.boolean(),
    HousingAssistanceReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("HousingAssistance", {
        is: true,
        then: Joi.required(),
      }),
    JobTraining: Joi.boolean(),
    JobTrainingReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("JobTraining", {
        is: true,
        then: Joi.required(),
      }),
    EducationServices: Joi.boolean(),
    EducationServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("EducationServices", {
        is: true,
        then: Joi.required(),
      }),
    Tutoring: Joi.boolean(),
    TutoringReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("Tutoring", { is: true, then: Joi.required() }),
    PsychiatricAppointment: Joi.boolean(),
    PsychiatricAppointmentReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("PsychiatricAppointment", {
        is: true,
        then: Joi.required(),
      }),
    Prescriptions: Joi.boolean(),
    PrescriptionsReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("Prescriptions", {
        is: true,
        then: Joi.required(),
      }),
    MedicalServices: Joi.boolean(),
    MedicalServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("MedicalServices", {
        is: true,
        then: Joi.required(),
      }),
    Probation: Joi.boolean(),
    ProbationReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("Probation", {
        is: true,
        then: Joi.required(),
      }),
    LegalServices: Joi.boolean(),
    LegalServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("LegalServices", {
        is: true,
        then: Joi.required(),
      }),
    PhysicianAppointment: Joi.boolean(),
    PhysicianAppointmentReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("PhysicianAppointment", {
        is: true,
        then: Joi.required(),
      }),
    WelfareSupport: Joi.boolean(),
    WelfareSupportReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("WelfareSupport", {
        is: true,
        then: Joi.required(),
      }),
    FinancialSupport: Joi.boolean(),
    FinancialSupportReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("FinancialSupport", {
        is: true,
        then: Joi.required(),
      }),
    InHomeServices: Joi.boolean(),
    InHomeServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("InHomeServices", {
        is: true,
        then: Joi.required(),
      }),
    OtherServices: Joi.boolean(),
    OtherServicesReferredTo: Joi.string()
      .allow("")
      .label("Referred To")
      .when("OtherServices", {
        is: true,
        then: Joi.required(),
      }),
    LocalCrisisCenter: Joi.string()
      .allow("")
      .required()
      .label("Local Crisis Center"),
    PlacementHistory: Joi.string()
      .allow("")
      .required()
      .label("Placement History"),
    Behavior: Joi.string().required().label("Behavior"),
    SocialInteraction: Joi.string()
      .allow("")
      .required()
      .label("Social and Peer Interaction"),
    ResponseToCaregivers: Joi.string()
      .allow("")
      .required()
      .label("Response to Caregives or Redirection"),
    SchoolInformation: Joi.string()
      .allow("")
      .required()
      .label("School Information and Participation"),
    AdditionalAccomplishments: Joi.string()
      .allow("")
      .required()
      .label("Additional Accomplishments"),
    FollowUp: Joi.string()
      .allow("")
      .required()
      .label("Follow-up/Scheduled Appointments"),
  },
  "85D4705A-B0BC-EF11-88D0-A022DA911E48": {
    SelectedProgram: Joi.string().required(),
    Medicaid: Joi.string().allow(""),
    TreatmentTeam: Joi.array()
      .min(1)
      .items(
        Joi.object({
          _id: Joi.any(),
          Name: Joi.string().required(),
          Relationship: Joi.string().required(),
          Errors: Joi.any(),
          IsEditable: Joi.boolean(),
        })
      ),
  },
  "00852480-7EBD-EF11-88D0-A022DA911E48": {
    SelectedProgram: Joi.string().required(),
    FosterHome: Joi.string().allow(""),
    CaseManagers: Joi.string().allow(""),
    Therapist: Joi.string().allow(""),
    PlacementWorker: Joi.string().required(),
    WorkerPresent: Joi.boolean(),
    BinderGiven: Joi.boolean(),
    CallCompleted: Joi.boolean(),
    TDCheckInDate: Joi.string().required(),
    TDCheckInDetails: Joi.string().required(),
    F2FVisitDate: Joi.string().required(),
    CTCheckInDate: Joi.string().required(),
    CTCheckInDetails: Joi.string().required(),
    AssessmentDate: Joi.string().required(),
    AssessmentDetails: Joi.string().required(),
    StablePlanDate: Joi.string().required(),
    StablePlanDetails: Joi.string().required(),
    PaperworkDate: Joi.string().required(),
  },
  "18A837F3-7FBD-EF11-88D0-A022DA911E48": {
    SelectedProgram: Joi.string().required(),
    FamilyName: Joi.string().label("Family Name").required(),
    SafetyPlanDate: Joi.string().label("Date of Safety Plan").required(),
    Housing: Joi.boolean(),
    HousingDetails: Joi.string().allow(""),
    Food: Joi.boolean(),
    FoodDetails: Joi.string().allow(""),
    Clothing: Joi.boolean(),
    ClothingDetails: Joi.string().allow(""),
    Transportation: Joi.boolean(),
    TransportationDetails: Joi.string().allow(""),
    MedicalCare: Joi.boolean(),
    MedicalCareDetails: Joi.string().allow(""),
    Childcare: Joi.boolean(),
    ChildcareDetails: Joi.string().allow(""),
    Supervision: Joi.boolean(),
    SupervisionDetails: Joi.string().allow(""),
    DomesticViolence: Joi.boolean(),
    DomesticViolenceDetails: Joi.string().allow(""),
    FamilyConflict: Joi.boolean(),
    FamilyConflictDetails: Joi.string().allow(""),
    SubstanceAbuse: Joi.boolean(),
    SubstanceAbuseDetails: Joi.string().allow(""),
    Deescalation: Joi.boolean(),
    DeescalationDetails: Joi.string().allow(""),
    InfantSafety: Joi.boolean(),
    InfantSafetyDetails: Joi.string().allow(""),
    OtherConcerns: Joi.boolean(),
    OtherConcernsDetails: Joi.string().allow(""),
    FamilyStrengths: Joi.string()
      .label("What are the family's strengths? What is working right now?")
      .required(),
    PerspectiveOfRisk: Joi.string()
      .label("Caregiver/Family Perspective of Risk")
      .required(),
    SafetyNeeds: Joi.string()
      .label(
        "What needs to be in place to ensure the safety and wellbeing of everyone in the family?"
      )
      .required(),
    EnvironmentSteps: Joi.string()
      .label("What are steps the family can take to keep the environment safe?")
      .required(),
    MonitoringSteps: Joi.string()
      .label(
        "What are steps the family can take to have adequate monitoring/supervision?"
      )
      .required(),
    SupportForFamily: Joi.string()
      .label("Who can support the family in meeting their immediate needs?")
      .required(),
    PositiveInteractions: Joi.string()
      .label(
        "How can the family create positive interactions despite their immediate needs/crisis?"
      )
      .required(),
    Amendments: Joi.string().allow(""),
  },
  "E1B9CC1E-5BBE-EF11-88D0-A022DA911E48": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SafetyPlanDate: Joi.string().required(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    SelfHarm: Joi.boolean(),
    AWOL: Joi.boolean(),
    PropertyDestruction: Joi.boolean(),
    PhysicalAggression: Joi.boolean(),
    VerbalAggression: Joi.boolean(),
    SubstanceUse: Joi.boolean(),
    UnsafeSleepBehaviors: Joi.boolean(),
    UnsafeActsTowardsAnimals: Joi.boolean(),
    UnsafeSchoolBehaviors: Joi.boolean(),
    UnsafeSexualBehaviors: Joi.boolean(),
    HumanTraffickingVictim: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.string().allow(""),
    TriggerDetails: Joi.string().allow(""),
    BehaviorDetails: Joi.string().allow(""),
    ReasonsToLive: Joi.string().allow(""),
    FeelingToday: Joi.string().allow(""),
    FeelingAtWorst: Joi.string().allow(""),
    WorryPoint: Joi.string().allow(""),
    CheckInFrequency: Joi.string().allow(""),
    ScalingQuestion: Joi.string().allow(""),
    Sweating: Joi.boolean(),
    BreathingHard: Joi.boolean(),
    RacingHeart: Joi.boolean(),
    ClenchingTeeth: Joi.boolean(),
    ClenchingFists: Joi.boolean(),
    RedFaced: Joi.boolean(),
    LoudVoice: Joi.boolean(),
    Rocking: Joi.boolean(),
    Fidgety: Joi.boolean(),
    Crying: Joi.boolean(),
    SleepingAlot: Joi.boolean(),
    DifficultySleeping: Joi.boolean(),
    Pacing: Joi.boolean(),
    Nauseous: Joi.boolean(),
    Alone: Joi.boolean(),
    RacingThoughts: Joi.boolean(),
    FallAsleep: Joi.boolean(),
    OtherSign: Joi.boolean(),
    OtherSignDetails: Joi.string().allow(""),
    Yelling: Joi.boolean(),
    ReadingHome: Joi.boolean(),
    ExerciseHome: Joi.boolean(),
    WritingHome: Joi.boolean(),
    DrawingHome: Joi.boolean(),
    Watching: Joi.boolean(),
    SupportHome: Joi.boolean(),
    Playing: Joi.boolean(),
    Shower: Joi.boolean(),
    MusicHome: Joi.boolean(),
    WalkingHome: Joi.boolean(),
    BlanketHome: Joi.boolean(),
    AnimalsHome: Joi.boolean(),
    OtherHomeStrategy: Joi.boolean(),
    OtherHomeStrategyDetails: Joi.string().allow(""),
    ReadingSchool: Joi.boolean(),
    ExerciseSchool: Joi.boolean(),
    WritingSchool: Joi.boolean(),
    DrawingSchool: Joi.boolean(),
    SupportSchool: Joi.boolean(),
    SupportTeacher: Joi.boolean(),
    MusicSchool: Joi.boolean(),
    WalkingSchool: Joi.boolean(),
    BlanketSchool: Joi.boolean(),
    AnimalsSchool: Joi.boolean(),
    OtherSchoolStrategy: Joi.boolean(),
    OtherSchoolStrategyDetails: Joi.string().allow(""),
    MySupportsHome: Joi.string().allow(""),
    MySupportsSchool: Joi.string().allow(""),
    SafetyPlan: Joi.string().allow(""),
    TriggersAndWarnings: Joi.string().allow(""),
    TriggersAndWarningsResponse: Joi.string().allow(""),
    Visible: Joi.boolean(),
    SameRoom: Joi.boolean(),
    RestrictedOutings: Joi.boolean(),
    RoomSearch: Joi.boolean(),
    ReviewPhone: Joi.boolean(),
    Cameras: Joi.boolean(),
    RemoveDoors: Joi.boolean(),
    CheckingIn: Joi.boolean(),
    TrackFriendInfo: Joi.boolean(),
    PlanActivities: Joi.boolean(),
    OtherMonitoring: Joi.boolean(),
    OtherMonitoringDetails: Joi.string().allow(""),
    LockupWeapons: Joi.boolean(),
    LockupMeds: Joi.boolean(),
    LockupSharps: Joi.boolean(),
    LockupPoisons: Joi.boolean(),
    DoorWindowAlarms: Joi.boolean(),
    RestrictAlcohol: Joi.boolean(),
    ParkOutside: Joi.boolean(),
    LockupFireStarters: Joi.boolean(),
    KeepKeys: Joi.boolean(),
    OtherSafeStep: Joi.boolean(),
    OtherSafeStepDetails: Joi.string().allow(""),
    SupportChild: Joi.string().allow(""),
    SupportSelf: Joi.string().allow(""),
    AdditionalComments: Joi.string().allow(""),
    Diagnoses: Joi.string().allow(""),
    Medications: Joi.string().allow(""),
    WorkerName: Joi.string().allow(""),
    WorkerPhone: Joi.string().allow(""),
    SupervisorName: Joi.string().allow(""),
    SupervisorPhone: Joi.string().allow(""),
    BackupName: Joi.string().allow(""),
    BackupPhone: Joi.string().allow(""),
    Support1Name: Joi.string().allow(""),
    Support1Phone: Joi.string().allow(""),
    Support2Name: Joi.string().allow(""),
    Support2Phone: Joi.string().allow(""),
    Police: Joi.string().allow(""),
    Hotline: Joi.string().allow(""),
    Hospital: Joi.string().allow(""),
    CrisisCenter: Joi.string().allow(""),
    Other: Joi.string().allow(""),
    SAFYCrisisCenter: Joi.string().allow(""),
    Given: Joi.string(),
    GivenDate: Joi.string().allow(""),
    ResolutionAmendments: Joi.string().allow(""),
  },
  "B4E4DBA3-FAD8-EF11-88F9-FC68272BBF38": {
    SelectedProgram: Joi.string().required(),
    Ethnicity: Joi.string().required(),
    Consent: Joi.string().required(),
    SessionCount: Joi.string().required(),
    LastSessionDate: Joi.string().required(),
    DSSInvolved: Joi.string().required(),
    SummaryNarrative: Joi.string().required(),
    FamilyFunctioningDomain: Joi.string().required(),
    CaregiverFunctioningDomain: Joi.string().required(),
    ChildFunctioningDomain: Joi.string().required(),
    AftercarePlan: Joi.string().required(),
  },
  "09B2A519-52DE-EF11-88F9-FC68272BBF38": {
    SelectedProgram: Joi.string().required(),
    Parent: Joi.string().required(),
    Date: Joi.string().required(),
    Fulfill: Joi.string().required(),
    Visits: Joi.string().required(),
    OtherContact: Joi.string().required(),
    Advocated: Joi.string().required(),
    Encouraged: Joi.string().required(),
    Connected: Joi.string().required(),
    HelpConnect: Joi.string().required(),
    Communication: Joi.string().required(),
    Supported: Joi.string().required(),
    Coached: Joi.string().required(),
    Comments: Joi.string().required(),
    ConnectRelationship: Joi.string().required(),
    SupportRelationship: Joi.string().required(),
    DHSCommunication: Joi.string().required(),
    AttorneyCommunication: Joi.string().required(),
    Advocate: Joi.string().required(),
    Custody: Joi.string().required(),
    ReliableAppts: Joi.string().required(),
    FindResources: Joi.string().required(),
    NeedsContact: Joi.string().required(),
    Responsibility: Joi.string().required(),
    Willingness: Joi.string().required(),
    RatingComments: Joi.string()
      .when("ConnectRelationship", {
        is: Joi.valid(
          "Significant Improvement",
          "Remained the Same",
          "Decreased"
        ),
        then: Joi.required(),
      })
      .when("SupportRelationship", {
        is: Joi.valid(
          "Significant Improvement",
          "Remained the Same",
          "Decreased"
        ),
        then: Joi.required(),
      })
      .when("DHSCommunication", {
        is: Joi.valid(
          "Significant Improvement",
          "Remained the Same",
          "Decreased"
        ),
        then: Joi.required(),
      })
      .when("AttorneyCommunication", {
        is: Joi.valid(
          "Significant Improvement",
          "Remained the Same",
          "Decreased"
        ),
        then: Joi.required(),
      })
      .when("Advocate", {
        is: Joi.valid(
          "Significant Improvement",
          "Remained the Same",
          "Decreased"
        ),
        then: Joi.required(),
      })
      .when("Custody", {
        is: Joi.valid(
          "Significant Improvement",
          "Remained the Same",
          "Decreased"
        ),
        then: Joi.required(),
      })
      .when("ReliableAppts", {
        is: Joi.valid(
          "Significant Improvement",
          "Remained the Same",
          "Decreased"
        ),
        then: Joi.required(),
      })
      .when("FindResources", {
        is: Joi.valid(
          "Significant Improvement",
          "Remained the Same",
          "Decreased"
        ),
        then: Joi.required(),
      })
      .when("NeedsContact", {
        is: Joi.valid(
          "Significant Improvement",
          "Remained the Same",
          "Decreased"
        ),
        then: Joi.required(),
      })
      .when("Responsibility", {
        is: Joi.valid(
          "Significant Improvement",
          "Remained the Same",
          "Decreased"
        ),
        then: Joi.required(),
      })
      .when("Willingness", {
        is: Joi.valid(
          "Significant Improvement",
          "Remained the Same",
          "Decreased"
        ),
        then: Joi.required(),
      }),
  },
  "0080B92F-52DE-EF11-88F9-FC68272BBF38": {
    SelectedProgram: Joi.string().required(),
    Date: Joi.string().required(),
    FindResources: Joi.number().min(1).max(5).required(),
    GetResources: Joi.number().min(1).max(5).required(),
    Safe: Joi.number().min(1).max(5).required(),
    Decisions: Joi.number().min(1).max(5).required(),
    Listen: Joi.number().min(1).max(5).required(),
    Support: Joi.number().min(1).max(5).required(),
    Communication: Joi.number().min(1).max(5).required(),
    Crisis: Joi.number().min(1).max(5).required(),
    Advocate: Joi.number().min(1).max(5).required(),
    Understand: Joi.number().min(1).max(5).required(),
    Comfortable: Joi.number().min(1).max(5).required(),
    Relationship: Joi.string().required(),
    Comments: Joi.string().allow(""),
  },
  "614F6337-52DE-EF11-88F9-FC68272BBF38": {
    SelectedProgram: Joi.string().required(),
    Date: Joi.string().required(),
    FindResourcesEntry: Joi.number().min(1).max(5),
    FindResourcesExit: Joi.number().min(1).max(5).required(),
    GetResourcesEntry: Joi.number().min(1).max(5),
    GetResourcesExit: Joi.number().min(1).max(5).required(),
    SafeEntry: Joi.number().min(1).max(5),
    SafeExit: Joi.number().min(1).max(5).required(),
    DecisionsEntry: Joi.number().min(1).max(5),
    DecisionsExit: Joi.number().min(1).max(5).required(),
    ListenEntry: Joi.number().min(1).max(5),
    ListenExit: Joi.number().min(1).max(5).required(),
    SupportEntry: Joi.number().min(1).max(5),
    SupportExit: Joi.number().min(1).max(5).required(),
    CommunicationEntry: Joi.number().min(1).max(5),
    CommunicationExit: Joi.number().min(1).max(5).required(),
    CrisisEntry: Joi.number().min(1).max(5),
    CrisisExit: Joi.number().min(1).max(5).required(),
    AdvocateEntry: Joi.number().min(1).max(5),
    AdvocateExit: Joi.number().min(1).max(5).required(),
    UnderstandEntry: Joi.number().min(1).max(5),
    UnderstandExit: Joi.number().min(1).max(5).required(),
    ComfortableEntry: Joi.number().min(1).max(5),
    ComfortableExit: Joi.number().min(1).max(5).required(),
    Relationship: Joi.string().required(),
    Comments: Joi.string().allow(""),
  },
  "B5002F14-8ADE-EF11-88F9-FC68272BBF38": {
    SelectedProgram: Joi.string().required(),
    ReportMonth: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
  },
  "85F90953-5DDF-EF11-88F9-FC68272BBF38": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    SexAssignedAtBirth: Joi.string().required(),
    SexAssignedAtBirthDetails: Joi.when("SexAssignedAtBirth", {
      is: "Sex not listed",
      then: Joi.string().required(),
    }),
    Pronouns: Joi.string().required(),
    PronounsDescription: Joi.when("Pronouns", {
      is: "Prefer to self-describe",
      then: Joi.required(),
    }),
    GenderIdentity: Joi.string().required(),
    GenderIdentityDescription: Joi.when("GenderIdentity", {
      is: "Identity not listed",
      then: Joi.string().required(),
    }),
    DateCompleted: Joi.string().required(),
    Division: Joi.string().required(),
    PSDType: Joi.string().required(),
    InitialDADate: Joi.when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.string().required(),
    }),
    UpdateSummary: Joi.when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.string().required(),
    }),
    UpdateRecommendations: Joi.when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.string().required(),
    }),
    ISClient: Joi.boolean(),
    ISParent: Joi.boolean(),
    ISGuardian: Joi.boolean(),
    ISCaregiver: Joi.boolean(),
    ISPhysician: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISCPS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.when("ISOther", {
      is: true,
      then: Joi.string().required(),
    }),
    ReasonForReferral: Joi.string().required(),
    ClientStrengths: Joi.string().required(),
    PresentingProblem: Joi.string().required(),
    HumanTrafficking: Joi.string().required(),
    DisciplinePracticesEffective: Joi.boolean(),
    DisciplinePracticesInconsistent: Joi.boolean(),
    DisciplinePracticesIneffective: Joi.boolean(),
    FamilyHistoryDetails: Joi.string().required(),
    CurrentConcernsOfDV: Joi.boolean(),
    PastConcernsOfDV: Joi.boolean(),
    UnknownConcernsOfDV: Joi.boolean(),
    NoReportedConcernsOfDV: Joi.boolean(),
    CurrentMaritalConflict: Joi.boolean(),
    PastMaritalConflict: Joi.boolean(),
    UnknownMaritalConflict: Joi.boolean(),
    NoReportedMaritalConflict: Joi.boolean(),
    ConflictComments: Joi.when("CurrentConcernsOfDV", {
      is: true,
      then: Joi.string().required(),
    })
      .when("PastConcernsOfDV", { is: true, then: Joi.string().required() })
      .when("CurrentMaritalConflict", {
        is: true,
        then: Joi.string().required(),
      })
      .when("PastMaritalConflict", { is: true, then: Joi.string().required() }),
    EducationStatus: Joi.string().required(),
    SchoolName: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    CurrentGrade: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    RegularClassroom: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    Active504Plan: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    ActiveIEP: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    RelationshipComments: Joi.when("Bullied", {
      is: "Yes",
      then: Joi.string().required(),
    })
      .when("Bully", {
        is: "Yes",
        then: Joi.string().required(),
      })
      .when("AcceptedByPeers", {
        is: "No",
        then: Joi.string().required(),
      })
      .when("NegativeAssociations", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    LegalInvolvement: Joi.string().required(),
    CPSInvolvement: Joi.when("LegalInvolvement", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    OtherLegalDetails: Joi.when("LegalInvolvement", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    NoMedications: Joi.boolean(),
    CurrentMedications: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    MedicationCompliance: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    SideEffects: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    SideEffectsDetails: Joi.when("NoMedications", {
      is: false,
      then: Joi.when("SideEffects", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    PsychotropicMeds: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    PsychotropicMedsDetails: Joi.when("NoMedications", {
      is: false,
      then: Joi.when("PsychotropicMeds", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    MHTreatmentNA: Joi.boolean(),
    PastMentalHealthTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    PastGroupHomePlacement: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    PastHospitalPlacement: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    InvoluntaryTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    PastMentalHealthDiagnosis: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    MHTreatmentComments: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.when("PastMentalHealthTreatment", {
        is: "Yes",
        then: Joi.string().required(),
      })
        .when("PastGroupHomePlacement", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("PastHospitalPlacement", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("InvoluntaryTreatment", {
          is: "Yes",
          then: Joi.string().required(),
        }),
    }),
    MHTreatmentHistory: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    MHClientPerspectiveOfTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    MHCaregiverPerspectiveOfTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    SUAge: Joi.boolean(),
    SubstanceUseNA: Joi.boolean(),
    SUClientDenies: Joi.boolean(),
    SUClientReportsCurrent: Joi.boolean(),
    SUClientReportsPast: Joi.boolean(),
    SUClientPeers: Joi.boolean(),
    SUCaregiverSuspects: Joi.boolean(),
    SUCaregiverEvidence: Joi.boolean(),
    SUComments: Joi.when("SubstanceUseNA", {
      is: false,
      then: Joi.when("SUClientDenies", { is: true, then: Joi.required() })
        .when("SUClientReportsCurrent", {
          is: true,
          then: Joi.string().required(),
        })
        .when("SUClientReportsPast", {
          is: true,
          then: Joi.string().required(),
        })
        .when("SUClientPeers", { is: true, then: Joi.string().required() })
        .when("SUCaregiverSuspects", {
          is: true,
          then: Joi.string().required(),
        })
        .when("SUCaregiverEvidence", {
          is: true,
          then: Joi.string().required(),
        }),
    }),
    TraumaNA: Joi.boolean(),
    TraumaHistory: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    DistressingMemories: Joi.boolean(),
    BlockOut: Joi.boolean(),
    Hypervigilance: Joi.boolean(),
    PhysiologicalResponses: Joi.boolean(),
    LossOfMemories: Joi.boolean(),
    Hyperarousal: Joi.boolean(),
    SleepDisturbances: Joi.boolean(),
    DevelopmentalRegression: Joi.boolean(),
    Nightmares: Joi.boolean(),
    Avoidant: Joi.boolean(),
    DifficultyConcentratingSymptom: Joi.boolean(),
    UnhealthyBoundaries: Joi.boolean(),
    Flashbacks: Joi.boolean(),
    Detachment: Joi.boolean(),
    EmotionalDysregulation: Joi.boolean(),
    RepetitivePlayOfEvents: Joi.boolean(),
    PsychologicalDistress: Joi.boolean(),
    DiminishedInterests: Joi.boolean(),
    Dissocation: Joi.boolean(),
    NegativeCognitions: Joi.boolean(),
    SocialWithdrawalSymptom: Joi.boolean(),
    NoSymptoms: Joi.boolean(),
    SocialSupports: Joi.boolean(),
    SenseOfMastery: Joi.boolean(),
    CaregiverStability: Joi.boolean(),
    StrongSpiritualBeliefs: Joi.boolean(),
    InterpersonalSkills: Joi.boolean(),
    PositiveOutlook: Joi.boolean(),
    PlacementStability: Joi.boolean(),
    Pets: Joi.boolean(),
    ValidatingExperiences: Joi.boolean(),
    Resources: Joi.boolean(),
    TiesToExtendedFamily: Joi.boolean(),
    Adaptability: Joi.boolean(),
    SecureAttachments: Joi.boolean(),
    StrongCulturalIdentity: Joi.boolean(),
    Resilience: Joi.boolean(),
    NoTraumaProtectiveFactors: Joi.boolean(),
    CopingStrategies: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    ClientAwareOfTrauma: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    ClientPerspectiveOfTrauma: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    CaregiverPerspectiveOfTrauma: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    LethalityNA: Joi.boolean(),
    SelfAbusiveBehavior: Joi.label("Self-abusive behavior").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    SuicidalThreats: Joi.label("Suicidal threats").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    SuicideAttempt: Joi.label("Suicide attempt").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    CaregiverConcernsOfSelfHarm: Joi.label(
      "Parent/Caregiver concerns of suicide/self-harm"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    OtherConcernsOfSelfHarm: Joi.label(
      "Other expressed concerns of suicide/self-harm"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    CurrentSelfHarmRisk: Joi.label("Current Risk of Harm to Self").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    SelfHarmComments: Joi.label("Current Risk of Harm to Self comments").when(
      "LethalityNA",
      {
        is: false,
        then: Joi.when("SelfAbusiveBehavior", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
          .when("SuicidalThreats", {
            is: "None/Never",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          })
          .when("SuicideAttempt", {
            is: "None/Never",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          })
          .when("CaregiverConcernsOfSelfHarm", {
            is: "No",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          })
          .when("OtherConcernsOfOtherHarm", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("CurrentSelfHarmRisk", {
            is: "None Noted",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          }),
      }
    ),
    ThreatsToHarmOthers: Joi.label(
      "Threats to intentionally harm/endanger others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    ThoughtsOfHarm: Joi.label(
      "Thoughts of intentionally harming/endangering others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    ActsOfHarm: Joi.label("Acts of intentionally harm/endangering others").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    ActsOfHarmAnimals: Joi.label(
      "Acts of intentionally harm/endangering animals"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    ActsInvolvingWeapons: Joi.label("Acts involving weapons").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    CaregiverConcernOfOtherHarm: Joi.label(
      "Parent/Caregiver concerns of harm/endangering others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    OtherConcernsOfOtherHarm: Joi.label(
      "Other expressed concerns of harm/endangering others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    CurrentOtherHarmRisk: Joi.label("Current Risk of Harm to Others").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    OtherHarmComments: Joi.label(
      "Current Risk of Harm to Others comments"
    ).when("LethalityNA", {
      is: false,
      then: Joi.when("ThreatsToHarmOthers", {
        is: "None/Never",
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      })
        .when("ThoughtsOfHarm", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("ActsOfHarm", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("ActsOfHarmAnimals", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("ActsInvolvingWeapons", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("CaregiverConcernOfOtherHarm", {
          is: "No",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("OtherConcernsOfOtherHarm", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("CurrentOtherHarmRisk", {
          is: "None Noted",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        }),
    }),
    SafetyPlanStatus: Joi.label("Safety Plan Status").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    LethalityComments: Joi.label("Comments/Plan").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    TraumaSymptoms: Joi.boolean(),
    TraumaticExposure: Joi.boolean(),
    AvoidantTrauma: Joi.boolean(),
    HypervigilanceTrauma: Joi.boolean(),
    IntrusiveDreams: Joi.boolean(),
    NegativeThoughts: Joi.boolean(),
    CocentrationProblems: Joi.boolean(),
    RecklessBehaviorTrauma: Joi.boolean(),
    SleepDisturbancesTrauma: Joi.boolean(),
    OtherTrauma: Joi.boolean(),
    OtherTraumaDetails: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.when("OtherTrauma", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    TraumaSymptomsFrequency: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    TraumaSymptomsIntensity: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    TraumaSymptomsDuration: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    TraumaSymptomsOnset: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    AnxietyDisorder: Joi.boolean(),
    AnxietyDisorderExcessWorry: Joi.boolean(),
    AnxietyDisorderEasilyFatigued: Joi.boolean(),
    MuscleTension: Joi.boolean(),
    Overworried: Joi.boolean(),
    AnxietyDisorderDifficultyConcentrating: Joi.boolean(),
    SleepDisturbancesAnxiety: Joi.boolean(),
    RestlessAnxiety: Joi.boolean(),
    Irritability: Joi.boolean(),
    OtherAnxiety: Joi.boolean(),
    OtherAnxietyDetails: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.when("OtherAnxiety", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AnxietyDisorderFrequency: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    AnxietyDisorderIntensity: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    AnxietyDisorderDuration: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    DepressionSymptoms: Joi.boolean(),
    DepressedMood: Joi.boolean(),
    SleepChanges: Joi.boolean(),
    Guilt: Joi.boolean(),
    DiminishedInterest: Joi.boolean(),
    PurposelessMovement: Joi.boolean(),
    DifficultyConcentratingDepression: Joi.boolean(),
    WeightChanges: Joi.boolean(),
    FatigueDepression: Joi.boolean(),
    ThoughtsOfDeath: Joi.boolean(),
    OtherDepression: Joi.boolean(),
    OtherDepressionDetails: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.when("OtherDepression", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DepressionFrequency: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    DepressionIntensity: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    DepressionDuration: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    AttentionHyperactivity: Joi.boolean(),
    AttentionHyperactivityEasilyDistracted: Joi.boolean(),
    DifficultyFollowThrough: Joi.boolean(),
    Forgetful: Joi.boolean(),
    DifficultyListening: Joi.boolean(),
    DisorganizedAttention: Joi.boolean(),
    Fidgety: Joi.boolean(),
    LackOfDetails: Joi.boolean(),
    LosesThings: Joi.boolean(),
    InterruptsOthers: Joi.boolean(),
    UnableToSitStill: Joi.boolean(),
    ExcessiveTalking: Joi.boolean(),
    DifficultyWaiting: Joi.boolean(),
    OtherAttention: Joi.boolean(),
    OtherAttentionDetails: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.when("OtherAttention", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AttentionHyperactivityFrequency: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.string().required(),
    }),
    AttentionHyperactivityIntensity: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.string().required(),
    }),
    AttentionHyperactivityDuration: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.string().required(),
    }),
    SU: Joi.boolean(),
    PatternOfSubstanceUse: Joi.boolean(),
    DesiresCutDownUse: Joi.boolean(),
    TimeSpentObtaining: Joi.boolean(),
    Cravings: Joi.boolean(),
    FailureOfResponsibilities: Joi.boolean(),
    NegativeImpact: Joi.boolean(),
    AbandonsActivities: Joi.boolean(),
    Tolerance: Joi.boolean(),
    SUWithdrawal: Joi.boolean(),
    SUOther: Joi.boolean(),
    SUOtherDetails: Joi.when("SU", {
      is: true,
      then: Joi.when("SUOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    SubstanceUseFrequency: Joi.when("SU", {
      is: true,
      then: Joi.string().required(),
    }),
    SubstanceUseIntensity: Joi.when("SU", {
      is: true,
      then: Joi.string().required(),
    }),
    SubstanceUseDuration: Joi.when("SU", {
      is: true,
      then: Joi.string().required(),
    }),
    DMDD: Joi.boolean(),
    Temper: Joi.boolean(),
    OutsideOutbursts: Joi.boolean(),
    FrequentOutbursts: Joi.boolean(),
    DMDDIrritable: Joi.boolean(),
    OutburstsAroundOthers: Joi.boolean(),
    DMDDOther: Joi.boolean(),
    DMDDOtherDetails: Joi.when("DMDD", {
      is: true,
      then: Joi.when("DMDDOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DMDDFrequency: Joi.when("DMDD", {
      is: true,
      then: Joi.string().required(),
    }),
    DMDDIntensity: Joi.when("DMDD", {
      is: true,
      then: Joi.string().required(),
    }),
    DMDDDuration: Joi.when("DMDD", { is: true, then: Joi.string().required() }),
    ConductDisorder: Joi.boolean(),
    Aggression: Joi.boolean(),
    DestructionOfProperty: Joi.boolean(),
    Theft: Joi.boolean(),
    SeriousViolations: Joi.boolean(),
    OtherConductDisorder: Joi.boolean(),
    OtherConductDisorderDetails: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.when("OtherConductDisorder", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    ConductDisorderFrequency: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    ConductDisorderIntensity: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    ConductDisorderDuration: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    ODD: Joi.boolean(),
    IrritableODD: Joi.boolean(),
    Argumentative: Joi.boolean(),
    Vindictive: Joi.boolean(),
    OtherODD: Joi.boolean(),
    OtherODDDetails: Joi.when("ODD", {
      is: true,
      then: Joi.when("OtherODD", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    ODDFrequency: Joi.when("ODD", { is: true, then: Joi.string().required() }),
    ODDIntensity: Joi.when("ODD", { is: true, then: Joi.string().required() }),
    ODDDuration: Joi.when("ODD", { is: true, then: Joi.string().required() }),
    OCD: Joi.boolean(),
    OCDPresence: Joi.boolean(),
    Obsessions: Joi.boolean(),
    TimeConsuming: Joi.boolean(),
    Compulsions: Joi.boolean(),
    ReduceAnxiety: Joi.boolean(),
    SuppressUrges: Joi.boolean(),
    OCDOther: Joi.boolean(),
    OCDOtherDetails: Joi.when("OCD", {
      is: true,
      then: Joi.when("OCDOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    OCDFrequency: Joi.when("OCD", { is: true, then: Joi.string().required() }),
    OCDIntensity: Joi.when("OCD", { is: true, then: Joi.string().required() }),
    OCDDuration: Joi.when("OCD", { is: true, then: Joi.string().required() }),
    PanicDisorder: Joi.boolean(),
    PoundingHeart: Joi.boolean(),
    PanicDisorderSweating: Joi.boolean(),
    Trembling: Joi.boolean(),
    ShortnessOfBreath: Joi.boolean(),
    Choking: Joi.boolean(),
    ChestPain: Joi.boolean(),
    PanicDisorderNausea: Joi.boolean(),
    Dizzy: Joi.boolean(),
    Chills: Joi.boolean(),
    Derealization: Joi.boolean(),
    FearOfCrazy: Joi.boolean(),
    FearOfDying: Joi.boolean(),
    PanicDisorderOther: Joi.boolean(),
    PanicDisorderOtherDetails: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.when("PanicDisorderOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    PanicDisorderFrequency: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    PanicDisorderIntensity: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    PanicDisorderDuration: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    Phobias: Joi.boolean(),
    PhobiasSpecificFear: Joi.boolean(),
    ImmediateFear: Joi.boolean(),
    PhobiasAvoidance: Joi.boolean(),
    FearExaggerated: Joi.boolean(),
    PhobiasOther: Joi.boolean(),
    PhobiasOtherDetails: Joi.when("Phobias", {
      is: true,
      then: Joi.when("PhobiasOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    PhobiasFrequency: Joi.when("Phobias", {
      is: true,
      then: Joi.string().required(),
    }),
    PhobiasIntensity: Joi.when("Phobias", {
      is: true,
      then: Joi.string().required(),
    }),
    PhobiasDuration: Joi.when("Phobias", {
      is: true,
      then: Joi.string().required(),
    }),
    DI: Joi.boolean(),
    DILowIQ: Joi.boolean(),
    DISensoryImpairments: Joi.boolean(),
    DISpeechDelays: Joi.boolean(),
    DIMotorCoordinationDelays: Joi.boolean(),
    DILearningDisorder: Joi.boolean(),
    DISpatialDelays: Joi.boolean(),
    DevelopmentalImpairmentsOther: Joi.boolean(),
    DevelopmentalImpairmentsOtherDetails: Joi.when("DI", {
      is: true,
      then: Joi.when("DevelopmentalImpairmentsOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DevelopmentalImpairmentsDetails: Joi.when("DI", {
      is: true,
      then: Joi.when("DILowIQ", { is: true, then: Joi.required() })
        .when("DISensoryImpairments", { is: true, then: Joi.required() })
        .when("DISpeechDelays", { is: true, then: Joi.required() })
        .when("DIMotorCoordinationDelays", { is: true, then: Joi.required() })
        .when("DILearningDisorder", { is: true, then: Joi.required() })
        .when("DISpatialDelays", { is: true, then: Joi.required() }),
    }),
    OtherSymptoms: Joi.boolean(),
    OtherSymptomsDetails: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    OtherSymptomsFrequency: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    OtherSymptomsIntensity: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    OtherSymptomsDuration: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    ClinicalNarrativeSummary: Joi.string().required(),
    ClinicalNarrativeSummaryComments: Joi.string().allow(null, ""),
    DiagnosisDetails: Joi.string().required(),
    TreatmentRecommendations: Joi.string().required(),
  },
  "2D898372-3AE3-EF11-88F9-FC68272BBF38": {
    SelectedProgram: Joi.string().required(),
    DateOfAssessment: Joi.string().required().label("Date of Assessment"),
    TypeOfAssessment: Joi.string().required().label("Type of Assessment"),
    AssessorName: Joi.string().required().label("Assessor Name"),
    LFDFamily: Joi.string().required(),
    LFDSituation: Joi.string().required(),
    LFDSocial: Joi.string().required(),
    LFDRecreational: Joi.string().required(),
    LFDDevelopmental: Joi.string().required(),
    LFDJob: Joi.string().required(),
    LFDLegal: Joi.string().required(),
    LFDMedical: Joi.string().required(),
    LFDSexual: Joi.string().required(),
    LFDSleep: Joi.string().required(),
    LFDBehavior: Joi.string().required(),
    LFDAttendance: Joi.string().required(),
    LFDAchievement: Joi.string().required(),
    LFDDecisions: Joi.string().required(),
    LFDComments: Joi.string().allow(""),
    SDFamily: Joi.string().required(),
    SDInterpersonal: Joi.string().required(),
    SDOptimism: Joi.string().required(),
    SDEducational: Joi.string().required(),
    SDVocational: Joi.string().required(),
    SDTalents: Joi.string().required(),
    SDReligious: Joi.string().required(),
    SDCommunity: Joi.string().required(),
    SDRelationships: Joi.string().required(),
    SDResilience: Joi.string().required(),
    SDResourcefulness: Joi.string().required(),
    SDIdentity: Joi.string().required(),
    SDSupports: Joi.string().required(),
    SDComments: Joi.string().allow(""),
    CFDLanguage: Joi.string().required(),
    CFDTraditions: Joi.string().required(),
    CFDStress: Joi.string().required(),
    CFDComments: Joi.string().allow(""),
    CNRDSupervision: Joi.string().required(),
    CNRDInvolvement: Joi.string().required(),
    CNRDKnowledge: Joi.string().required(),
    CNRDOrganization: Joi.string().required(),
    CNRDResources: Joi.string().required(),
    CNRDStability: Joi.string().required(),
    CNRDMedical: Joi.string().required(),
    CNRDMental: Joi.string().required(),
    CNRDSubstances: Joi.string().required(),
    CNRDDevelopmental: Joi.string().required(),
    CNRDSafety: Joi.string().required(),
    CNRDComments: Joi.string().allow(""),
    BENDPsychosis: Joi.string().required(),
    BENDImpulsivity: Joi.string().required(),
    BENDDepression: Joi.string().required(),
    BENDAnxiety: Joi.string().required(),
    BENDOppositional: Joi.string().required(),
    BENDConduct: Joi.string().required(),
    BENDAdjustment: Joi.string().required(),
    BENDAttachment: Joi.string().required(),
    BENDAnger: Joi.string().required(),
    BENDSubstances: Joi.string().required(),
    BENDComments: Joi.string().allow(""),
    YRBDSuicide: Joi.string().required(),
    YRBDInjurious: Joi.string().required(),
    YRBDRecklessness: Joi.string().required(),
    YRBDDanger: Joi.string().required(),
    YRBDSexual: Joi.string().required(),
    YRBDRunaway: Joi.string().required(),
    YRBDDelinquent: Joi.string().required(),
    YRBDArson: Joi.string().required(),
    YRBDMisbehavior: Joi.string().required(),
    YRBDComments: Joi.string().allow(""),
    DNMCognitive: Joi.string().when("LFDDevelopmental", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    DNMCommunication: Joi.string().when("LFDDevelopmental", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    DNMDevelopmental: Joi.string().when("LFDDevelopmental", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    DNMSkills: Joi.string().when("LFDDevelopmental", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    DNMComments: Joi.string().allow(""),
    TMSexual: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMPhysical: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMNeglect: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMEmotional: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMMedical: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMDisaster: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMFamily: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMCommunity: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMCriminal: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMWarAffected: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMDisruptions: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMParental: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMDysregulation: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMIntrusions: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMHyperarousal: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMGrief: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMNumbing: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMDissociation: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMAvoidance: Joi.string().when("BENDAdjustment", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    TMComments: Joi.string().allow(""),
    SUDMSeverity: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMDuration: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMStage: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMPeer: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMParental: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMEnvironmental: Joi.string().when("BENDSubstances", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SUDMComments: Joi.string().allow(""),
    VMPhysical: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMHistory: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMDomestic: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMEnvironmental: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMBullying: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMFrustration: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMHostility: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMParanoia: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMGains: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMViolent: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMAwareness: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMResponse: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMCommitment: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMTreatment: Joi.string().when("YRBDDanger", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    VMComments: Joi.string().allow(""),
    SABMRelationship: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMThreat: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMPlanning: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMAge: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMType: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMResponse: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMConsistency: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMHistory: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMSeverity: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMPrior: Joi.string().when("YRBDSexual", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    SABMComments: Joi.string().allow(""),
    RMFrequency: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMConsistency: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMSafety: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMIllegal: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMReturn: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMInvolvement: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMExpectations: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMPlanning: Joi.string().when("YRBDRunaway", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    RMComments: Joi.string().allow(""),
    JJMHistory: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMSeriousness: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMPlanning: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMSafety: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMPeers: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMParental: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMEnvironmental: Joi.string().when("YRBDDelinquent", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    JJMComments: Joi.string().allow(""),
    FSMHistory: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMSeriousness: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMPlanning: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMAccelerants: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMIntention: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMSafety: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMResponse: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMRemorse: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMFuture: Joi.string().when("YRBDArson", {
      is: Joi.any().valid("1", "2", "3"),
      then: Joi.required(),
    }),
    FSMComments: Joi.string().allow(""),
  },
  "86E4F88A-83E5-EF11-88F9-FC68272BBF38": {
    SelectedProgram: Joi.string().required(),
    DischargeDate: Joi.string().required().label("Discharge Date"),
    DischargeReason: Joi.string().required().label("Discharge Reason"),
    Success: Joi.string().required().label("Description of success"),
    Progress: Joi.string().required().label("Progress Details"),
    Assessment: Joi.string().required().label("Did complete assessment"),
    NoAssessmentReason: Joi.when("Assessment", {
      is: "Yes",
      then: Joi.string().required(),
    }).label("No assessment explanation"),
    CessationPlan: Joi.string().required().label("Cessation plan"),
    Referrals: Joi.string().required().label("Referrals/linkages"),
    FollowUps: Joi.string().required().label("Plan for follow-ups"),
  },
  "49C0AF25-C1E7-EF11-88FA-BF17BD92B0C7": {
    SelectedProgram: Joi.string().required(),
    StartDate: Joi.string().required(),
    EndDate: Joi.string().required(),
    ServicesProvided: Joi.string().required(),
    Attendance: Joi.string().required(),
    AttendanceDetails: Joi.string().when("Attendance", {
      is: "Other",
      then: Joi.required(),
    }),
    Engagement: Joi.string().required(),
    EngagementDetails: Joi.string().when("Engagement", {
      is: "Other",
      then: Joi.required(),
    }),
    ReachOut: Joi.boolean(),
    Navigation: Joi.boolean(),
    Connected: Joi.boolean(),
    CasePlan: Joi.boolean(),
    Other: Joi.boolean(),
    OtherDetails: Joi.string().when("Other", {
      is: true,
      then: Joi.required(),
    }),
    Discharged: Joi.string().required(),
    DischargeReason: Joi.when("Discharged", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    AftercareSupportDate: Joi.when("Discharged", {
      is: "Yes",
      then: Joi.when("DischargeReason", {
        is: "Reunification/Aftercare",
        then: Joi.string().required(),
      }),
    }),
  },
  "7F1D8079-1EEE-EF11-90CC-B43FF895E3B2": {
    SelectedProgram: Joi.string().required(),
    FosterHome: Joi.string().required().label("Foster Home"),
    VisitDate: Joi.date()
      .max("now")
      .required()
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            case "date.base":
              error.message = `"Visit Date" is required`;
              break;
            case "date.max":
              error.message = `"Visit Date" cannot be future dated`;
              break;
            default:
              return error.message;
          }
        });
        return errors;
      }),
    EndDate: Joi.date()
      .max("now")
      .allow("")
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            case "date.max":
              error.message = `"End Date" cannot be future dated`;
              break;
            default:
              return error.message;
          }
        });
        return errors;
      }),
    Summary: Joi.string().required().label("Summary"),
    Tasks: Joi.string().required().label("Tasks to be completed"),
    TasksCompleted: Joi.string().required().label("Were tasks completed"),
    TasksDetails: Joi.when("TasksCompleted", {
      is: "No",
      then: Joi.string().required().label("Incomplete tasks details"),
    }),
    Skills: Joi.string().required().label("Skills to be practiced"),
    SkillsPracticed: Joi.string().required().label("Were skills practiced"),
    SkillsDetails: Joi.when("SkillsPracticed", {
      is: "No",
      then: Joi.string().required().label("Skills not practiced details"),
    }),
    Challenges: Joi.string().required().label("Challenges"),
  },
  "7E67CDE9-94EF-EF11-90CC-B43FF895E3B2": {
    SelectedProgram: Joi.string().required(),
    FosterHome: Joi.string().required().label("Foster Home"),
    ReportMonth: Joi.string().required().label("Report Month"),
    StartDate: Joi.string().required().label("Start Date"),
    EndDate: Joi.string().required().label("End Date"),
    VisitDates: Joi.string().required().label("Visit Dates"),
    Summary: Joi.string().required().label("Summary"),
    Challenges: Joi.string().required().label("Challenges"),
  },
  "DAE16E3C-E7F2-EF11-90CC-B43FF895E3B2": {
    SelectedProgram: Joi.string().required(),
    CompletedBy: Joi.string().required().label("Update completed by"),
    Date: Joi.string().required().label("Date of quarterly update"),
    Understanding: Joi.string().label(
      "Explain child's understanding of adoption:"
    ),
    Feelings: Joi.string().label("Explain child's feelings about adoption:"),
    Plan: Joi.string().label(
      "Outline your plan to prepare the youth for adoption, based on the youth's assessment:"
    ),
    Updates: Joi.string().label("Any updates to the whole-child assessment?"),
  },
  "9188912B-61F4-EF11-90CC-B43FF895E3B2": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    Month: Joi.string().required().label("Month"),
    Year: Joi.string().required().label("Year"),
    CaseType: Joi.string().required().label("Case Type"),
    FamilySupportWorker: Joi.string()
      .allow("")
      .required()
      .label("Family Support Worker"),
    Therapist: Joi.string().required().label("Therapist"),
    DHRWorker: Joi.string().required().label("DHR Worker"),
    DHRSupervisor: Joi.string().required().label("DHR Supervisor"),
    County: Joi.string().required().label("County"),
    StartDate: Joi.string().required().label("Start Date of Service"),
    AnticipatedDischargeDate: Joi.string()
      .allow("")
      .required()
      .label("Anticipated Date of Discharge"),
    CurrentPlacement: Joi.string()
      .allow("")
      .required()
      .label("Current Placement"),
    PermanencyGoals: Joi.string()
      .allow("")
      .required()
      .label("Permanency Goals"),
    ConcurrentPlan: Joi.string().required().label("Concurrent Plan"),
    RiskFactors: Joi.string()
      .allow("")
      .required()
      .label("Current Risk Factors"),
    Barriers: Joi.string().required().label("Barriers to Treatment"),
    ChildBehaviors: Joi.string()
      .allow("")
      .required()
      .label("Child's Current Behaviors"),
    ChildDiagnosis: Joi.string()
      .allow("")
      .required()
      .label("Child's DSM Diagnosis"),
    ParentsBehaviors: Joi.string()
      .allow("")
      .required()
      .label("Parents Current Behaviors"),
    ParentsDiagnosis: Joi.string()
      .allow("")
      .required()
      .label("Parents DSM Diagnosis"),
    ServicePlanGoals: Joi.string()
      .allow("")
      .required()
      .label("Service Plan Goals"),
    AgencyIntervention: Joi.string()
      .allow("")
      .required()
      .label("Agency Intervention Since Last Reporting Period"),
    MentalHealthCoordination: Joi.string()
      .allow("")
      .required()
      .label("Mental Health Care Coordination"),
    OutcomesAchieved: Joi.string()
      .allow("")
      .required()
      .label("Outcomes Achieved Since Last Period"),
    AgencyNextSteps: Joi.string()
      .allow("")
      .required()
      .label("Agency Next Steps"),
    CurrentRecommendations: Joi.string()
      .allow("")
      .required()
      .label("Current Recommendations"),
    VisitHistory: Joi.array().items(
      Joi.object({
        _id: Joi.any(),
        Date: Joi.string().required(),
        Service: Joi.string().required(),
        Duration: Joi.string().required(),
        Method: Joi.string().required(),
        Recipient: Joi.string().required(),
        Errors: Joi.any(),
      })
    ),
    MotherVisits: Joi.string().allow(""),
    FatherVisits: Joi.string().allow(""),
    VisitLocation: Joi.string().allow(""),
    UnsupervisedVisits: Joi.string().allow(""),
    OtherVisits: Joi.string().allow(""),
    AnnouncedAgencyVisits: Joi.string().allow(""),
    UnannouncedAgencyVisits: Joi.string().allow(""),
  },
  "9ECD358A-69F4-EF11-90CC-B43FF895E3B2": {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    DateCompleted: Joi.string().allow(""),
    ReportStartDate: Joi.string().allow(""),
    ReportEndDate: Joi.string().allow(""),
    Month: Joi.string().required().label("Month"),
    Year: Joi.string().required().label("Year"),
    SocialInteraction: Joi.string()
      .allow("")
      .required()
      .label("Social Interaction / Skills"),
    Activities: Joi.string()
      .allow("")
      .required()
      .label("Community and Family Activities by Child and Foster Family"),
    Legal: Joi.string().required().label("Legal"),
    Education: Joi.string().required().label("Education"),
    Facility: Joi.string().required().label("Facility"),
    IndependentLiving: Joi.string()
      .allow("")
      .required()
      .label("Independent Living"),
    Health: Joi.string()
      .allow("")
      .required()
      .label("Physical Health, Disabilities and Medication"),
    Behavior: Joi.string().required().label("Behavior and Growth"),
    PrimaryFamily: Joi.string()
      .allow("")
      .required()
      .label("Primary Family Contact/Visitation"),
    Therapy: Joi.string()
      .allow("")
      .required()
      .label("Individual or Group Therapy"),
    Recommendations: Joi.string()
      .allow("")
      .required()
      .label("Recommendations and Next Steps"),
    VisitHistory: Joi.array().items(
      Joi.object({
        _id: Joi.any(),
        Date: Joi.string().required(),
        Service: Joi.string().required(),
        Duration: Joi.string().required(),
        Method: Joi.string().required(),
        Recipient: Joi.string().required(),
        Errors: Joi.any(),
      })
    ),
    Interventions: Joi.string()
      .allow("")
      .required()
      .label("Interventions Between Recipient, SAFY Staff and Foster Parents"),
    IncidentReports: Joi.string().allow("").label("Incident Reports"),
    ServiceGoals: Joi.string().required().label("Service Goals"),
    ReportOfStaffAbuse: Joi.string().required().label("Reports of staff abuse"),
    ReportOfNonStaffAbuse: Joi.string()
      .required()
      .label("Reports of non-staff abuse"),
    UnplannedDischarge: Joi.string().required().label("Unplanned discharge"),
    LengthOfStay: Joi.string()
      .allow("")
      .label("Length of stay")
      .when("UnplannedDischarge", {
        is: "1",
        then: Joi.required(),
      }),
    VisitationPlan: Joi.string().label("Visitation plan"),
    VisitationFrequency: Joi.string()
      .allow("")
      .label("Visitation frequency")
      .when("VisitationPlan", {
        is: "1",
        then: Joi.required(),
      }),
    VisitationGoal: Joi.string()
      .label("Achieved visitation goal")
      .when("VisitationPlan", {
        is: "1",
        then: Joi.required(),
      }),
    Runaway: Joi.string().required().label("Runaway"),
    DSSRequest: Joi.string().allow(""),
    DHRRequest: Joi.string().allow(""),
  },
  "E21768C8-40F5-EF11-90CC-B43FF895E3B2": {
    SelectedProgram: Joi.string().required(),
    CompletedBy: Joi.string().required().label("Assessment completed by"),
    Date: Joi.string().required().label("Date of assessment"),
    Description: Joi.string().label("Description of child"),
    Strengths: Joi.string().label("Strengths and interests"),
    Challenges: Joi.string().label("Challenges and limitations"),
    Education: Joi.string().label("Educational status"),
    Social: Joi.string().label("Social and recreational information"),
    Medical: Joi.string().label("Medical history"),
    Psych: Joi.string().label("Psychological and behavioral information"),
    Family: Joi.string().label("Birth family history and relationships"),
    Placement: Joi.string().label(
      "Placement history and reason for placement changes"
    ),
    Other: Joi.string().label("Other relationships and connections"),
    Understanding: Joi.string().label(
      "Explain child's understanding of adoption:"
    ),
    Feelings: Joi.string().label("Explain child's feelings about adoption:"),
    Plan: Joi.string().label(
      "Outline your plan to prepare the youth for adoption, based on the youth's assessment:"
    ),
  },
  "43D8E4F5-4CF5-EF11-90CC-B43FF895E3B2": {
    SelectedProgram: Joi.string().required(),
    ReferralDate: Joi.string().allow("").label("Referral date"),
    CaseNumber: Joi.string()
      .allow("")
      .label("Custodial agency case of child ID number"),
    EnteredDate: Joi.string().allow("").label("Date child entered the system"),
    Reason: Joi.string().allow("").label("Reason child entered the system"),
    CourtDateNA: Joi.boolean(),
    CourtDate: Joi.when("CourtDateNA", {
      is: false,
      then: Joi.string()
        .allow("")
        .label("Date of next scheduled court hearing"),
    }),
    CaseReviewInfo: Joi.array().items(
      Joi.object({
        _id: Joi.any(),
        Date: Joi.date().allow("").label("Review Date"),
        Hours: Joi.number().allow("").label("Hours spent on case review"),
        CompletedBy: Joi.string().allow(""),
        Errors: Joi.any(),
      })
    ),
    CaseReviewTotalHours: Joi.number(),
    PlacementHistory: Joi.array().items(
      Joi.object({
        _id: Joi.any(),
        Date: Joi.date().allow("").label("Date"),
        Placement: Joi.string().allow("").label("Placement"),
        ContactInfo: Joi.string().allow("").label("Contact information"),
        Errors: Joi.any(),
      })
    ),
    BirthMotherName: Joi.string().allow("").label("Birth mother's name"),
    BirthMotherAKA: Joi.string().allow(""),
    BirthMotherDOB: Joi.date().allow("").label("Birth mother's date of birth"),
    BirthMotherAddress: Joi.string().allow("").label("Birth mother's address"),
    BirthMotherContact: Joi.string()
      .allow("")
      .label("Birth mother's phone/email"),
    BirthMotherOtherAddress: Joi.string().allow(""),
    BirthMotherRelatives: Joi.array().items(
      Joi.object({
        _id: Joi.any(),
        Name: Joi.string().allow("").label("Name"),
        Relationship: Joi.string().allow("").label("Relationship"),
        ContactInfo: Joi.string().allow("").label("Contact information"),
        Errors: Joi.any(),
      })
    ),
    BirthMotherConnections: Joi.array().items(
      Joi.object({
        _id: Joi.any(),
        Name: Joi.string().allow("").label("Name"),
        Relationship: Joi.string().allow("").label("Relationship"),
        ContactInfo: Joi.string().allow("").label("Contact information"),
        Errors: Joi.any(),
      })
    ),
    BirthMotherNotes: Joi.string().allow("").label("Birth mother notes"),
    AdoptiveMotherNA: Joi.boolean(),
    AdoptiveMotherName: Joi.when("AdoptiveMotherNA", {
      is: false,
      then: Joi.string().allow("").label("Adoptive mother's name"),
    }),
    AdoptiveMotherAKA: Joi.string().allow(""),
    AdoptiveMotherDOB: Joi.when("AdoptiveMotherNA", {
      is: false,
      then: Joi.date().allow("").label("Adoptive mother's date of Adoptive"),
    }),
    AdoptiveMotherAddress: Joi.when("AdoptiveMotherNA", {
      is: false,
      then: Joi.string().allow("").label("Adoptive mother's address"),
    }),
    AdoptiveMotherContact: Joi.when("AdoptiveMotherNA", {
      is: false,
      then: Joi.string().allow("").label("Adoptive mother's phone/email"),
    }),
    AdoptiveMotherOtherAddress: Joi.string().allow(""),
    AdoptiveMotherRelatives: Joi.when("AdoptiveMotherNA", {
      is: false,
      then: Joi.array()
        .items(
          Joi.object({
            _id: Joi.any(),
            Name: Joi.string().allow("").label("Name"),
            Relationship: Joi.string().allow("").label("Relationship"),
            ContactInfo: Joi.string().allow("").label("Contact information"),
            Errors: Joi.any(),
          })
        )
        .min(1),
    }),
    AdoptiveMotherConnections: Joi.when("AdoptiveMotherNA", {
      is: false,
      then: Joi.array()
        .items(
          Joi.object({
            _id: Joi.any(),
            Name: Joi.string().allow("").label("Name"),
            Relationship: Joi.string().allow("").label("Relationship"),
            ContactInfo: Joi.string().allow("").label("Contact information"),
            Errors: Joi.any(),
          })
        )
        .min(1),
    }),
    AdoptiveMotherNotes: Joi.when("AdoptiveMotherNA", {
      is: false,
      then: Joi.string().allow("").label("Adoptive mother notes"),
    }),
    BirthFatherName: Joi.string().allow("").label("Birth father's name"),
    BirthFatherAKA: Joi.string().allow(""),
    BirthFatherDOB: Joi.date().allow("").label("Birth father's date of birth"),
    BirthFatherAddress: Joi.string().allow("").label("Birth father's address"),
    BirthFatherContact: Joi.string()
      .allow("")
      .label("Birth father's phone/email"),
    BirthFatherOtherAddress: Joi.string().allow(""),
    BirthFatherRelatives: Joi.array().items(
      Joi.object({
        _id: Joi.any(),
        Name: Joi.string().allow("").label("Name"),
        Relationship: Joi.string().allow("").label("Relationship"),
        ContactInfo: Joi.string().allow("").label("Contact information"),
        Errors: Joi.any(),
      })
    ),
    BirthFatherConnections: Joi.array().items(
      Joi.object({
        _id: Joi.any(),
        Name: Joi.string().allow("").label("Name"),
        Relationship: Joi.string().allow("").label("Relationship"),
        ContactInfo: Joi.string().allow("").label("Contact information"),
        Errors: Joi.any(),
      })
    ),
    BirthFatherNotes: Joi.string().allow("").label("Birth father notes"),
    AdoptiveFatherNA: Joi.boolean(),
    AdoptiveFatherName: Joi.when("AdoptiveFatherNA", {
      is: false,
      then: Joi.string().allow("").label("Adoptive father's name"),
    }),
    AdoptiveFatherAKA: Joi.string().allow(""),
    AdoptiveFatherDOB: Joi.when("AdoptiveFatherNA", {
      is: false,
      then: Joi.date().allow("").label("Adoptive father's date of Adoptive"),
    }),
    AdoptiveFatherAddress: Joi.when("AdoptiveFatherNA", {
      is: false,
      then: Joi.string().allow("").label("Adoptive father's address"),
    }),
    AdoptiveFatherContact: Joi.when("AdoptiveFatherNA", {
      is: false,
      then: Joi.string().allow("").label("Adoptive father's phone/email"),
    }),
    AdoptiveFatherOtherAddress: Joi.string().allow(""),
    AdoptiveFatherRelatives: Joi.when("AdoptiveFatherNA", {
      is: false,
      then: Joi.array()
        .items(
          Joi.object({
            _id: Joi.any(),
            Name: Joi.string().allow("").label("Name"),
            Relationship: Joi.string().allow("").label("Relationship"),
            ContactInfo: Joi.string().allow("").label("Contact information"),
            Errors: Joi.any(),
          })
        )
        .min(1),
    }),
    AdoptiveFatherConnections: Joi.when("AdoptiveFatherNA", {
      is: false,
      then: Joi.array()
        .items(
          Joi.object({
            _id: Joi.any(),
            Name: Joi.string().allow("").label("Name"),
            Relationship: Joi.string().allow("").label("Relationship"),
            ContactInfo: Joi.string().allow("").label("Contact information"),
            Errors: Joi.any(),
          })
        )
        .min(1),
    }),
    AdoptiveFatherNotes: Joi.when("AdoptiveFatherNA", {
      is: false,
      then: Joi.string().allow("").label("Adoptive father notes"),
    }),
    SiblingsNA: Joi.boolean(),
    SiblingsInfo: Joi.when("SiblingsNA", {
      is: false,
      then: Joi.array()
        .items(
          Joi.object({
            _id: Joi.any(),
            Info: Joi.string().allow("").label("Sibling information"),
            Errors: Joi.any(),
          })
        )
        .min(1),
    }),
    SiblingsNotes: Joi.when("SiblingsNA", {
      is: false,
      then: Joi.string().allow("").label("Sibling notes"),
    }),
    SchoolInfo: Joi.array().items(
      Joi.object({
        _id: Joi.any(),
        Name: Joi.string().allow("").label("School name"),
        Dates: Joi.string().allow("").label("Dates attended"),
        ContactInfo: Joi.string().allow("").label("Contact information"),
        Errors: Joi.any(),
      })
    ),
    IEP: Joi.string().allow("").label("IEP status"),
    IEPReason: Joi.when("IEP", {
      is: "Yes",
      then: Joi.string().allow("").label("IEP reasoning"),
    }),
    IEPLastWritten: Joi.when("IEP", {
      is: "Yes",
      then: Joi.string().allow("").label("When IEP was last written"),
    }),
    SchoolRelationships: Joi.array().items(
      Joi.object({
        _id: Joi.any(),
        Name: Joi.string().allow("").label("Name"),
        Relationship: Joi.string().allow("").label("Relationship"),
        ContactInfo: Joi.string().allow("").label("Contact information"),
        Errors: Joi.any(),
      })
    ),
    MentalHealthInfo: Joi.array().items(
      Joi.object({
        _id: Joi.any(),
        Info: Joi.string().allow("").label("Mental health info"),
        Errors: Joi.any(),
      })
    ),
    TherapyInfo: Joi.string().allow("").label("Therapy/assessment information"),
    CurrentMedsNA: Joi.boolean(),
    CurrentMeds: Joi.when("CurrentMedsNA", {
      is: false,
      then: Joi.string().allow("").label("Current medications"),
    }),
    PastMHTreatmentNA: Joi.boolean(),
    PastMHTreatment: Joi.when("PastMHTreatmentNA", {
      is: false,
      then: Joi.string().allow("").label("Past treatment info"),
    }),
    MedicalInfo: Joi.string().allow("").label("Medical information"),
    SocialContacts: Joi.string().allow("").label("Social contacts"),
    SocialContactsNotes: Joi.string().allow("").label("Social contact notes"),
    PriorWorkers: Joi.string().allow("").label("Prior workers"),
    PriorGuardiansNA: Joi.boolean(),
    PriorGuardians: Joi.when("PriorGuardiansNA", {
      is: false,
      then: Joi.string().allow("").label("Prior guardians ad litem"),
    }),
    OtherPriorContacts: Joi.string().allow("").label("Other former contacts"),
    AddlContactInfo: Joi.string()
      .allow("")
      .label("Additional contact information"),
    AddlHistoryInfo: Joi.string()
      .allow("")
      .label("Additional history information"),
  },
  "4ED27362-B410-F011-90CC-D1E42B61504B": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    SexAssignedAtBirth: Joi.string().required(),
    SexAssignedAtBirthDetails: Joi.when("SexAssignedAtBirth", {
      is: "Sex not listed",
      then: Joi.string().required(),
    }),
    Pronouns: Joi.string().required(),
    PronounsDescription: Joi.when("Pronouns", {
      is: "Prefer to self-describe",
      then: Joi.required(),
    }),
    GenderIdentity: Joi.string().required(),
    GenderIdentityDescription: Joi.when("GenderIdentity", {
      is: "Identity not listed",
      then: Joi.string().required(),
    }),
    DateCompleted: Joi.string().required(),
    Division: Joi.string().required(),
    PSDType: Joi.string().required(),
    InitialDADate: Joi.when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.string().required(),
    }),
    UpdateSummary: Joi.when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.string().required(),
    }),
    UpdateRecommendations: Joi.when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.string().required(),
    }),
    ISClient: Joi.boolean(),
    ISParent: Joi.boolean(),
    ISGuardian: Joi.boolean(),
    ISCaregiver: Joi.boolean(),
    ISPhysician: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISCPS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.when("ISOther", {
      is: true,
      then: Joi.string().required(),
    }),
    ReasonForReferral: Joi.string().required(),
    ClientStrengths: Joi.string().required(),
    PresentingProblem: Joi.string().required(),
    HumanTrafficking: Joi.string().required(),
    CurrentPlacement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    OtherSupports: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CaregiverCooperation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    SupervisionDifficulties: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    DisciplinePracticesEffective: Joi.boolean(),
    DisciplinePracticesInconsistent: Joi.boolean(),
    DisciplinePracticesIneffective: Joi.boolean(),
    CurrentPlacementComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CaregiverCooperation", {
        is: "No",
        then: Joi.string().required(),
      })
        .when("SupervisionDifficulties", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("DisciplinePracticesInconsistent", {
          is: true,
          then: Joi.string().required(),
        })
        .when("DisciplinePracticesIneffective", {
          is: true,
          then: Joi.string().required(),
        }),
    }),
    FamilyHistoryDetails: Joi.string().required(),
    CurrentConcernsOfDV: Joi.boolean(),
    PastConcernsOfDV: Joi.boolean(),
    UnknownConcernsOfDV: Joi.boolean(),
    NoReportedConcernsOfDV: Joi.boolean(),
    CurrentMaritalConflict: Joi.boolean(),
    PastMaritalConflict: Joi.boolean(),
    UnknownMaritalConflict: Joi.boolean(),
    NoReportedMaritalConflict: Joi.boolean(),
    ConflictComments: Joi.when("CurrentConcernsOfDV", {
      is: true,
      then: Joi.string().required(),
    })
      .when("PastConcernsOfDV", { is: true, then: Joi.string().required() })
      .when("CurrentMaritalConflict", {
        is: true,
        then: Joi.string().required(),
      })
      .when("PastMaritalConflict", { is: true, then: Joi.string().required() }),
    CulturalGroup: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CulturalTraditions: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CulturalTraditionsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CulturalTraditions", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    NegativeCulturalExperiences: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    NegativeCulturalExperiencesDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("NegativeCulturalExperiences", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    CulturalMedicalBeliefs: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CulturalMedicalBeliefsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CulturalMedicalBeliefs", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    CulturalDifferencesDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    Religion: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    RoleOfFaith: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ReligiousTraditions: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DietaryNeeds: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    NegativeReligiousExperiences: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ReligiousMedicalBeliefs: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ReligiousDifferences: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    ReligiousComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ReligiousTraditions", {
        is: "Yes",
        then: Joi.string().required(),
      })
        .when("DietaryNeeds", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("NegativeReligiousExperiences", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("ReligiousMedicalBeliefs", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("ReligiousDifferences", {
          is: "Yes",
          then: Joi.string().required(),
        }),
    }),
    PHNoProblems: Joi.boolean(),
    PHPrenatalCare: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHExposure: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHTrauma: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHComplications: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHConcerns: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.when("PHPrenatalCare", {
          is: "Yes",
          then: Joi.string().required(),
        })
          .when("PHExposure", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("PHTrauma", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("PHComplications", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("PHConcerns", {
            is: "Yes",
            then: Joi.string().required(),
          }),
      }),
    }),
    SpecialNeeds: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    SpecializedServices: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    DHComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SpecialNeeds", {
        is: "Yes",
        then: Joi.string().required(),
      }).when("SpecializedServices", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    EducationStatus: Joi.string().required(),
    SchoolName: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    CurrentGrade: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    RegularClassroom: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    Active504Plan: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    ActiveIEP: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    SchoolExperience: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      }),
    }),
    EmploymentNA: Joi.boolean(),
    CurrentlyEmployed: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    EmployerAndTitle: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.when("CurrentlyEmployed", {
            is: "Yes",
            then: Joi.string().required(),
          }),
        }),
      }),
    }),
    EmploymentInterests: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.when("CurrentlyEmployed", {
            is: "N/A",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          }),
        }),
      }),
    }),
    MilitaryHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    MilitaryComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.when("MilitaryHistory", {
            is: "Yes",
            then: Joi.string().required(),
          }),
        }),
      }),
    }),
    ADLNA: Joi.boolean(),
    MoneyManagement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    MoneyManagementDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("MoneyManagement", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("MoneyManagement", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    FoodManagement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    FoodManagementDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("FoodManagement", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("FoodManagement", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    Hygiene: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    HygieneDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Hygiene", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Hygiene", { is: "Advanced", then: Joi.string().required() }),
      }),
    }),
    Health: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    HealthDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Health", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Health", { is: "Advanced", then: Joi.string().required() }),
      }),
    }),
    Housekeeping: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    HousekeepingDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Housekeeping", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Housekeeping", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    Transportation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    TransportationDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Transportation", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Transportation", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    SafetySkills: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SafetySkillsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("SafetySkills", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("SafetySkills", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    ResourceKnowledge: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    ResourceKnowledgeDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("ResourceKnowledge", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("ResourceKnowledge", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    TimeManagement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    TimeManagementDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("TimeManagement", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("TimeManagement", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    Interaction: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    InteractionDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Interaction", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Interaction", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    CoopSkills: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CoopSkillsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CoopSkills", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("CoopSkills", { is: "Advanced", then: Joi.string().required() }),
    }),
    CommunicationSkills: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CommunicationSkillsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CommunicationSkills", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("CommunicationSkills", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    EmotionalUnderstanding: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    EmotionalUnderstandingDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EmotionalUnderstanding", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("EmotionalUnderstanding", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    ProblemSolving: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    ProblemSolvingDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ProblemSolving", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("ProblemSolving", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    ConflictResolution: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    ConflictResolutionDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ConflictResolution", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("ConflictResolution", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    DecisionMakingSkills: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    DecisionMakingSkillsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("DecisionMakingSkills", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("DecisionMakingSkills", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    Bullied: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    Bully: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    AcceptedByPeers: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    NegativeAssociations: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    RelationshipComments: Joi.when("Bullied", {
      is: "Yes",
      then: Joi.string().required(),
    })
      .when("Bully", {
        is: "Yes",
        then: Joi.string().required(),
      })
      .when("AcceptedByPeers", {
        is: "No",
        then: Joi.string().required(),
      })
      .when("NegativeAssociations", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    CPSInvolvement: Joi.string().required(),
    TypeOfCPSInvolvement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CPSInvolvement", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    CPSHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CPSInvolvement", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    CPSCaseworker: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CPSInvolvement", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    CPSCaseworkerName: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CPSInvolvement", {
        is: "Yes",
        then: Joi.when("CPSCaseworker", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    GALCASA: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    GALCASAName: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("GALCASA", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    LegalInvolvement: Joi.string().required(),
    ProbationOfficer: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProbationOfficerName: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("ProbationOfficer", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    LegalStatus: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    LegalHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("LegalStatus", {
          is: "None Reported",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        }),
      }),
    }),
    OtherLegalDetails: Joi.when("LegalInvolvement", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    PCPUnknown: Joi.boolean(),
    PCP: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PCPUnknown", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PCPPhone: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PCPUnknown", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    LastMedicalExamDate: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    LastDentalExamDate: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Allergies", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("MedicalConditions", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("NutritionalConcerns", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("DentalConcerns", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Undiagnosed: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    UndiagnosedDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Undiagnosed", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    NoMedications: Joi.boolean(),
    CurrentMedications: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    MedicationCompliance: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    SideEffects: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    SideEffectsDetails: Joi.when("NoMedications", {
      is: false,
      then: Joi.when("SideEffects", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    PsychotropicMeds: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    PsychotropicMedsDetails: Joi.when("NoMedications", {
      is: false,
      then: Joi.when("PsychotropicMeds", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualHistoryNA: Joi.boolean(),
    SexualOrientation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexualOrientationDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexualOrientation", {
          is: "Orientation not listed",
          then: Joi.string().required(),
        }).when("SexualOrientation", {
          is: "Unable to assess",
          then: Joi.string().required(),
        }),
      }),
    }),
    SexualRelationshipsEducation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexuallyActive: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    CaregiverAware: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    UseProtection: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    AwareOfRisks: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    Pregnancy: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    Children: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SexuallyActiveComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SexualAbuseVictim: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexualBehavior: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexuallyActingOut: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexuallyAbusive: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexualHistoryComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexualAbuseVictim", {
          is: "Yes",
          then: Joi.string().required(),
        })
          .when("SexualBehavior", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("SexuallyActingOut", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("SexuallyAbusive", {
            is: "Yes",
            then: Joi.string().required(),
          }),
      }),
    }),
    MHTreatmentNA: Joi.boolean(),
    PastMentalHealthTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    PastGroupHomePlacement: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    PastHospitalPlacement: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    InvoluntaryTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    PastMentalHealthDiagnosis: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    MHTreatmentComments: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.when("PastMentalHealthTreatment", {
        is: "Yes",
        then: Joi.string().required(),
      })
        .when("PastGroupHomePlacement", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("PastHospitalPlacement", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("InvoluntaryTreatment", {
          is: "Yes",
          then: Joi.string().required(),
        }),
    }),
    MHTreatmentHistory: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    MHClientPerspectiveOfTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    MHCaregiverPerspectiveOfTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    SUAge: Joi.boolean(),
    SubstanceUseNA: Joi.boolean(),
    SUClientDenies: Joi.boolean(),
    SUClientReportsCurrent: Joi.boolean(),
    SUClientReportsPast: Joi.boolean(),
    SUClientPeers: Joi.boolean(),
    SUCaregiverSuspects: Joi.boolean(),
    SUCaregiverEvidence: Joi.boolean(),
    SUComments: Joi.when("SubstanceUseNA", {
      is: false,
      then: Joi.when("SUClientDenies", { is: true, then: Joi.required() })
        .when("SUClientReportsCurrent", {
          is: true,
          then: Joi.string().required(),
        })
        .when("SUClientReportsPast", {
          is: true,
          then: Joi.string().required(),
        })
        .when("SUClientPeers", { is: true, then: Joi.string().required() })
        .when("SUCaregiverSuspects", {
          is: true,
          then: Joi.string().required(),
        })
        .when("SUCaregiverEvidence", {
          is: true,
          then: Joi.string().required(),
        }),
    }),
    SUHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    ClientPerceptionOfSubstanceUse: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    CaregiverPerceptionOfSubstanceUse: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    NoPastTreatment: Joi.boolean(),
    SUTreatmentHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.when("NoPastTreatment", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    SUClientPerspectiveOfTreatment: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.when("NoPastTreatment", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    SUCaregiverPerspectiveOfTreatment: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.when("NoPastTreatment", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    TraumaNA: Joi.boolean(),
    TraumaHistory: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    DistressingMemories: Joi.boolean(),
    BlockOut: Joi.boolean(),
    Hypervigilance: Joi.boolean(),
    PhysiologicalResponses: Joi.boolean(),
    LossOfMemories: Joi.boolean(),
    Hyperarousal: Joi.boolean(),
    SleepDisturbances: Joi.boolean(),
    DevelopmentalRegression: Joi.boolean(),
    Nightmares: Joi.boolean(),
    Avoidant: Joi.boolean(),
    DifficultyConcentratingSymptom: Joi.boolean(),
    UnhealthyBoundaries: Joi.boolean(),
    Flashbacks: Joi.boolean(),
    Detachment: Joi.boolean(),
    EmotionalDysregulation: Joi.boolean(),
    RepetitivePlayOfEvents: Joi.boolean(),
    PsychologicalDistress: Joi.boolean(),
    DiminishedInterests: Joi.boolean(),
    Dissocation: Joi.boolean(),
    NegativeCognitions: Joi.boolean(),
    SocialWithdrawalSymptom: Joi.boolean(),
    NoSymptoms: Joi.boolean(),
    SocialSupports: Joi.boolean(),
    SenseOfMastery: Joi.boolean(),
    CaregiverStability: Joi.boolean(),
    StrongSpiritualBeliefs: Joi.boolean(),
    InterpersonalSkills: Joi.boolean(),
    PositiveOutlook: Joi.boolean(),
    PlacementStability: Joi.boolean(),
    Pets: Joi.boolean(),
    ValidatingExperiences: Joi.boolean(),
    Resources: Joi.boolean(),
    TiesToExtendedFamily: Joi.boolean(),
    Adaptability: Joi.boolean(),
    SecureAttachments: Joi.boolean(),
    StrongCulturalIdentity: Joi.boolean(),
    Resilience: Joi.boolean(),
    NoTraumaProtectiveFactors: Joi.boolean(),
    CopingStrategies: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    ClientAwareOfTrauma: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    ClientPerspectiveOfTrauma: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    CaregiverPerspectiveOfTrauma: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    AppropriateAppearance: Joi.boolean(),
    Neat: Joi.boolean(),
    Disheveled: Joi.boolean(),
    BizarreAppearance: Joi.boolean(),
    OtherAppearance: Joi.boolean(),
    OtherAppearanceDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherAppearance", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Cooperative: Joi.boolean(),
    Guarded: Joi.boolean(),
    Hyperactive: Joi.boolean(),
    Agitated: Joi.boolean(),
    Paranoid: Joi.boolean(),
    Tics: Joi.boolean(),
    Impulsive: Joi.boolean(),
    Aggressive: Joi.boolean(),
    Withdrawn: Joi.boolean(),
    BizarreBehavior: Joi.boolean(),
    Rigidity: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherBehavior", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Normal: Joi.boolean(),
    Slurred: Joi.boolean(),
    Pressured: Joi.boolean(),
    Tangential: Joi.boolean(),
    Incoherent: Joi.boolean(),
    Stutters: Joi.boolean(),
    OtherSpeech: Joi.boolean(),
    OtherSpeechDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherSpeech", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Euthymic: Joi.boolean(),
    Anxious: Joi.boolean(),
    Angry: Joi.boolean(),
    Depressed: Joi.boolean(),
    Euphoric: Joi.boolean(),
    Irritable: Joi.boolean(),
    Fearful: Joi.boolean(),
    OtherMood: Joi.boolean(),
    OtherMoodDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherMood", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    FullRange: Joi.boolean(),
    Restricted: Joi.boolean(),
    Blunted: Joi.boolean(),
    Flat: Joi.boolean(),
    Inappropriate: Joi.boolean(),
    OtherAffect: Joi.boolean(),
    OtherAffectDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherAffect", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Logical: Joi.boolean(),
    Preoccupations: Joi.boolean(),
    Delusions: Joi.boolean(),
    Hallucinations: Joi.boolean(),
    Racing: Joi.boolean(),
    Disorganized: Joi.boolean(),
    Concrete: Joi.boolean(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    OtherPerception: Joi.boolean(),
    OtherPerceptionDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherPerception", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    NoImpairment: Joi.boolean(),
    ShortAttentionSpan: Joi.boolean(),
    DifficultyConcentrating: Joi.boolean(),
    Distractibility: Joi.boolean(),
    MemoryImpairment: Joi.boolean(),
    LowIntelligence: Joi.boolean(),
    OtherCognition: Joi.boolean(),
    OtherCognitionDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherCognition", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AppropriateInsight: Joi.boolean(),
    Fair: Joi.boolean(),
    Impaired: Joi.boolean(),
    OtherInsight: Joi.boolean(),
    OtherInsightDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherInsight", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    MentalStatusComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    LethalityNA: Joi.boolean(),
    SelfAbusiveBehavior: Joi.label("Self-abusive behavior").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    SuicidalThreats: Joi.label("Suicidal threats").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    SuicideAttempt: Joi.label("Suicide attempt").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    CaregiverConcernsOfSelfHarm: Joi.label(
      "Parent/Caregiver concerns of suicide/self-harm"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    OtherConcernsOfSelfHarm: Joi.label(
      "Other expressed concerns of suicide/self-harm"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    CurrentSelfHarmRisk: Joi.label("Current Risk of Harm to Self").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    SelfHarmComments: Joi.label("Current Risk of Harm to Self comments").when(
      "LethalityNA",
      {
        is: false,
        then: Joi.when("SelfAbusiveBehavior", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
          .when("SuicidalThreats", {
            is: "None/Never",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          })
          .when("SuicideAttempt", {
            is: "None/Never",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          })
          .when("CaregiverConcernsOfSelfHarm", {
            is: "No",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          })
          .when("OtherConcernsOfOtherHarm", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("CurrentSelfHarmRisk", {
            is: "None Noted",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          }),
      }
    ),
    ThreatsToHarmOthers: Joi.label(
      "Threats to intentionally harm/endanger others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    ThoughtsOfHarm: Joi.label(
      "Thoughts of intentionally harming/endangering others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    ActsOfHarm: Joi.label("Acts of intentionally harm/endangering others").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    ActsOfHarmAnimals: Joi.label(
      "Acts of intentionally harm/endangering animals"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    ActsInvolvingWeapons: Joi.label("Acts involving weapons").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    CaregiverConcernOfOtherHarm: Joi.label(
      "Parent/Caregiver concerns of harm/endangering others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    OtherConcernsOfOtherHarm: Joi.label(
      "Other expressed concerns of harm/endangering others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    CurrentOtherHarmRisk: Joi.label("Current Risk of Harm to Others").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    OtherHarmComments: Joi.label(
      "Current Risk of Harm to Others comments"
    ).when("LethalityNA", {
      is: false,
      then: Joi.when("ThreatsToHarmOthers", {
        is: "None/Never",
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      })
        .when("ThoughtsOfHarm", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("ActsOfHarm", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("ActsOfHarmAnimals", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("ActsInvolvingWeapons", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("CaregiverConcernOfOtherHarm", {
          is: "No",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("OtherConcernsOfOtherHarm", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("CurrentOtherHarmRisk", {
          is: "None Noted",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        }),
    }),
    SafetyPlanStatus: Joi.label("Safety Plan Status").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    LethalityComments: Joi.label("Comments/Plan").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    TraumaSymptoms: Joi.boolean(),
    TraumaticExposure: Joi.boolean(),
    AvoidantTrauma: Joi.boolean(),
    HypervigilanceTrauma: Joi.boolean(),
    IntrusiveDreams: Joi.boolean(),
    NegativeThoughts: Joi.boolean(),
    CocentrationProblems: Joi.boolean(),
    RecklessBehaviorTrauma: Joi.boolean(),
    SleepDisturbancesTrauma: Joi.boolean(),
    OtherTrauma: Joi.boolean(),
    OtherTraumaDetails: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.when("OtherTrauma", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    TraumaSymptomsFrequency: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    TraumaSymptomsIntensity: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    TraumaSymptomsDuration: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    TraumaSymptomsOnset: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    AnxietyDisorder: Joi.boolean(),
    AnxietyDisorderExcessWorry: Joi.boolean(),
    AnxietyDisorderEasilyFatigued: Joi.boolean(),
    MuscleTension: Joi.boolean(),
    Overworried: Joi.boolean(),
    AnxietyDisorderDifficultyConcentrating: Joi.boolean(),
    SleepDisturbancesAnxiety: Joi.boolean(),
    RestlessAnxiety: Joi.boolean(),
    Irritability: Joi.boolean(),
    OtherAnxiety: Joi.boolean(),
    OtherAnxietyDetails: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.when("OtherAnxiety", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AnxietyDisorderFrequency: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    AnxietyDisorderIntensity: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    AnxietyDisorderDuration: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    DepressionSymptoms: Joi.boolean(),
    DepressedMood: Joi.boolean(),
    SleepChanges: Joi.boolean(),
    Guilt: Joi.boolean(),
    DiminishedInterest: Joi.boolean(),
    PurposelessMovement: Joi.boolean(),
    DifficultyConcentratingDepression: Joi.boolean(),
    WeightChanges: Joi.boolean(),
    FatigueDepression: Joi.boolean(),
    ThoughtsOfDeath: Joi.boolean(),
    OtherDepression: Joi.boolean(),
    OtherDepressionDetails: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.when("OtherDepression", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DepressionFrequency: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    DepressionIntensity: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    DepressionDuration: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    AttentionHyperactivity: Joi.boolean(),
    AttentionHyperactivityEasilyDistracted: Joi.boolean(),
    DifficultyFollowThrough: Joi.boolean(),
    Forgetful: Joi.boolean(),
    DifficultyListening: Joi.boolean(),
    DisorganizedAttention: Joi.boolean(),
    Fidgety: Joi.boolean(),
    LackOfDetails: Joi.boolean(),
    LosesThings: Joi.boolean(),
    InterruptsOthers: Joi.boolean(),
    UnableToSitStill: Joi.boolean(),
    ExcessiveTalking: Joi.boolean(),
    DifficultyWaiting: Joi.boolean(),
    OtherAttention: Joi.boolean(),
    OtherAttentionDetails: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.when("OtherAttention", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AttentionHyperactivityFrequency: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.string().required(),
    }),
    AttentionHyperactivityIntensity: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.string().required(),
    }),
    AttentionHyperactivityDuration: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.string().required(),
    }),
    SU: Joi.boolean(),
    PatternOfSubstanceUse: Joi.boolean(),
    DesiresCutDownUse: Joi.boolean(),
    TimeSpentObtaining: Joi.boolean(),
    Cravings: Joi.boolean(),
    FailureOfResponsibilities: Joi.boolean(),
    NegativeImpact: Joi.boolean(),
    AbandonsActivities: Joi.boolean(),
    Tolerance: Joi.boolean(),
    SUWithdrawal: Joi.boolean(),
    SUOther: Joi.boolean(),
    SUOtherDetails: Joi.when("SU", {
      is: true,
      then: Joi.when("SUOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    SubstanceUseFrequency: Joi.when("SU", {
      is: true,
      then: Joi.string().required(),
    }),
    SubstanceUseIntensity: Joi.when("SU", {
      is: true,
      then: Joi.string().required(),
    }),
    SubstanceUseDuration: Joi.when("SU", {
      is: true,
      then: Joi.string().required(),
    }),
    DMDD: Joi.boolean(),
    Temper: Joi.boolean(),
    OutsideOutbursts: Joi.boolean(),
    FrequentOutbursts: Joi.boolean(),
    DMDDIrritable: Joi.boolean(),
    OutburstsAroundOthers: Joi.boolean(),
    DMDDOther: Joi.boolean(),
    DMDDOtherDetails: Joi.when("DMDD", {
      is: true,
      then: Joi.when("DMDDOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DMDDFrequency: Joi.when("DMDD", {
      is: true,
      then: Joi.string().required(),
    }),
    DMDDIntensity: Joi.when("DMDD", {
      is: true,
      then: Joi.string().required(),
    }),
    DMDDDuration: Joi.when("DMDD", { is: true, then: Joi.string().required() }),
    ConductDisorder: Joi.boolean(),
    Aggression: Joi.boolean(),
    DestructionOfProperty: Joi.boolean(),
    Theft: Joi.boolean(),
    SeriousViolations: Joi.boolean(),
    OtherConductDisorder: Joi.boolean(),
    OtherConductDisorderDetails: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.when("OtherConductDisorder", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    ConductDisorderFrequency: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    ConductDisorderIntensity: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    ConductDisorderDuration: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    ODD: Joi.boolean(),
    IrritableODD: Joi.boolean(),
    Argumentative: Joi.boolean(),
    Vindictive: Joi.boolean(),
    OtherODD: Joi.boolean(),
    OtherODDDetails: Joi.when("ODD", {
      is: true,
      then: Joi.when("OtherODD", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    ODDFrequency: Joi.when("ODD", { is: true, then: Joi.string().required() }),
    ODDIntensity: Joi.when("ODD", { is: true, then: Joi.string().required() }),
    ODDDuration: Joi.when("ODD", { is: true, then: Joi.string().required() }),
    OCD: Joi.boolean(),
    OCDPresence: Joi.boolean(),
    Obsessions: Joi.boolean(),
    TimeConsuming: Joi.boolean(),
    Compulsions: Joi.boolean(),
    ReduceAnxiety: Joi.boolean(),
    SuppressUrges: Joi.boolean(),
    OCDOther: Joi.boolean(),
    OCDOtherDetails: Joi.when("OCD", {
      is: true,
      then: Joi.when("OCDOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    OCDFrequency: Joi.when("OCD", { is: true, then: Joi.string().required() }),
    OCDIntensity: Joi.when("OCD", { is: true, then: Joi.string().required() }),
    OCDDuration: Joi.when("OCD", { is: true, then: Joi.string().required() }),
    PanicDisorder: Joi.boolean(),
    PoundingHeart: Joi.boolean(),
    PanicDisorderSweating: Joi.boolean(),
    Trembling: Joi.boolean(),
    ShortnessOfBreath: Joi.boolean(),
    Choking: Joi.boolean(),
    ChestPain: Joi.boolean(),
    PanicDisorderNausea: Joi.boolean(),
    Dizzy: Joi.boolean(),
    Chills: Joi.boolean(),
    Derealization: Joi.boolean(),
    FearOfCrazy: Joi.boolean(),
    FearOfDying: Joi.boolean(),
    PanicDisorderOther: Joi.boolean(),
    PanicDisorderOtherDetails: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.when("PanicDisorderOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    PanicDisorderFrequency: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    PanicDisorderIntensity: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    PanicDisorderDuration: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    Phobias: Joi.boolean(),
    PhobiasSpecificFear: Joi.boolean(),
    ImmediateFear: Joi.boolean(),
    PhobiasAvoidance: Joi.boolean(),
    FearExaggerated: Joi.boolean(),
    PhobiasOther: Joi.boolean(),
    PhobiasOtherDetails: Joi.when("Phobias", {
      is: true,
      then: Joi.when("PhobiasOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    PhobiasFrequency: Joi.when("Phobias", {
      is: true,
      then: Joi.string().required(),
    }),
    PhobiasIntensity: Joi.when("Phobias", {
      is: true,
      then: Joi.string().required(),
    }),
    PhobiasDuration: Joi.when("Phobias", {
      is: true,
      then: Joi.string().required(),
    }),
    DI: Joi.boolean(),
    DILowIQ: Joi.boolean(),
    DISensoryImpairments: Joi.boolean(),
    DISpeechDelays: Joi.boolean(),
    DIMotorCoordinationDelays: Joi.boolean(),
    DILearningDisorder: Joi.boolean(),
    DISpatialDelays: Joi.boolean(),
    DevelopmentalImpairmentsOther: Joi.boolean(),
    DevelopmentalImpairmentsOtherDetails: Joi.when("DI", {
      is: true,
      then: Joi.when("DevelopmentalImpairmentsOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DevelopmentalImpairmentsDetails: Joi.when("DI", {
      is: true,
      then: Joi.when("DILowIQ", { is: true, then: Joi.required() })
        .when("DISensoryImpairments", { is: true, then: Joi.required() })
        .when("DISpeechDelays", { is: true, then: Joi.required() })
        .when("DIMotorCoordinationDelays", { is: true, then: Joi.required() })
        .when("DILearningDisorder", { is: true, then: Joi.required() })
        .when("DISpatialDelays", { is: true, then: Joi.required() }),
    }),
    OtherSymptoms: Joi.boolean(),
    OtherSymptomsDetails: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    OtherSymptomsFrequency: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    OtherSymptomsIntensity: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    OtherSymptomsDuration: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    ClinicalNarrativeSummary: Joi.string().required(),
    ClinicalNarrativeSummaryComments: Joi.string().allow(null, ""),
    DiagnosisDetails: Joi.string().required(),
    SeriousDisturbance: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    NoAdditionalNeeds: Joi.boolean(),
    AdditionalNeeds: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("NoAdditionalNeeds", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    TreatmentRecommendations: Joi.string().required(),
    DiagnosisEducation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    RecommendationEducation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    ClientAgrees: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    FamilyAgress: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
  },
  "DB9C7283-B910-F011-90CC-D1E42B61504B": {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    SexAssignedAtBirth: Joi.string().required(),
    SexAssignedAtBirthDetails: Joi.when("SexAssignedAtBirth", {
      is: "Sex not listed",
      then: Joi.string().required(),
    }),
    Pronouns: Joi.string().required(),
    PronounsDescription: Joi.when("Pronouns", {
      is: "Prefer to self-describe",
      then: Joi.required(),
    }),
    GenderIdentity: Joi.string().required(),
    GenderIdentityDescription: Joi.when("GenderIdentity", {
      is: "Identity not listed",
      then: Joi.string().required(),
    }),
    DateCompleted: Joi.string().required(),
    Division: Joi.string().required(),
    PSDType: Joi.string().required(),
    InitialDADate: Joi.when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.string().required(),
    }),
    UpdateSummary: Joi.when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.string().required(),
    }),
    UpdateRecommendations: Joi.when("PSDType", {
      is: "Addendum/Annual Update",
      then: Joi.string().required(),
    }),
    ISClient: Joi.boolean(),
    ISParent: Joi.boolean(),
    ISGuardian: Joi.boolean(),
    ISCaregiver: Joi.boolean(),
    ISPhysician: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISCPS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.when("ISOther", {
      is: true,
      then: Joi.string().required(),
    }),
    ReasonForReferral: Joi.string().required(),
    ClientStrengths: Joi.string().required(),
    PresentingProblem: Joi.string().required(),
    HumanTrafficking: Joi.string().required(),
    CurrentPlacement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    OtherSupports: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CaregiverCooperation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    SupervisionDifficulties: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    DisciplinePracticesEffective: Joi.boolean(),
    DisciplinePracticesInconsistent: Joi.boolean(),
    DisciplinePracticesIneffective: Joi.boolean(),
    CurrentPlacementComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CaregiverCooperation", {
        is: "No",
        then: Joi.string().required(),
      })
        .when("SupervisionDifficulties", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("DisciplinePracticesInconsistent", {
          is: true,
          then: Joi.string().required(),
        })
        .when("DisciplinePracticesIneffective", {
          is: true,
          then: Joi.string().required(),
        }),
    }),
    FamilyHistoryDetails: Joi.string().required(),
    CurrentConcernsOfDV: Joi.boolean(),
    PastConcernsOfDV: Joi.boolean(),
    UnknownConcernsOfDV: Joi.boolean(),
    NoReportedConcernsOfDV: Joi.boolean(),
    CurrentMaritalConflict: Joi.boolean(),
    PastMaritalConflict: Joi.boolean(),
    UnknownMaritalConflict: Joi.boolean(),
    NoReportedMaritalConflict: Joi.boolean(),
    ConflictComments: Joi.when("CurrentConcernsOfDV", {
      is: true,
      then: Joi.string().required(),
    })
      .when("PastConcernsOfDV", { is: true, then: Joi.string().required() })
      .when("CurrentMaritalConflict", {
        is: true,
        then: Joi.string().required(),
      })
      .when("PastMaritalConflict", { is: true, then: Joi.string().required() }),
    CulturalGroup: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CulturalTraditions: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CulturalTraditionsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CulturalTraditions", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    NegativeCulturalExperiences: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    NegativeCulturalExperiencesDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("NegativeCulturalExperiences", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    CulturalMedicalBeliefs: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CulturalMedicalBeliefsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CulturalMedicalBeliefs", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    Religion: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    RoleOfFaith: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ReligiousTraditions: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    DietaryNeeds: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    NegativeReligiousExperiences: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ReligiousMedicalBeliefs: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Religion", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ReligiousComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ReligiousTraditions", {
        is: "Yes",
        then: Joi.string().required(),
      })
        .when("DietaryNeeds", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("NegativeReligiousExperiences", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("ReligiousMedicalBeliefs", {
          is: "Yes",
          then: Joi.string().required(),
        }),
    }),
    PHNoProblems: Joi.boolean(),
    PHPrenatalCare: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHExposure: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHTrauma: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHComplications: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHConcerns: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PHComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("PHNoProblems", {
        is: false,
        then: Joi.when("PHPrenatalCare", {
          is: "Yes",
          then: Joi.string().required(),
        })
          .when("PHExposure", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("PHTrauma", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("PHComplications", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("PHConcerns", {
            is: "Yes",
            then: Joi.string().required(),
          }),
      }),
    }),
    SpecialNeeds: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().required(),
    }),
    SpecializedServices: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().required(),
    }),
    DHComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.when("SpecialNeeds", {
        is: "Yes",
        then: Joi.string().required(),
      }).when("SpecializedServices", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    EducationStatus: Joi.string().required(),
    SchoolName: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    CurrentGrade: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    RegularClassroom: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    Active504Plan: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    ActiveIEP: Joi.when("EducationStatus", {
      is: "Currently in school",
      then: Joi.string().required(),
    }),
    SchoolExperience: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      }),
    }),
    EmploymentNA: Joi.boolean(),
    CurrentlyEmployed: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    EmployerAndTitle: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.when("CurrentlyEmployed", {
            is: "Yes",
            then: Joi.string().required(),
          }),
        }),
      }),
    }),
    EmploymentInterests: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.when("CurrentlyEmployed", {
            is: "N/A",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          }),
        }),
      }),
    }),
    MilitaryHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    MilitaryComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EducationStatus", {
        is: "Client has not started school",
        then: Joi.string().allow(""),
        otherwise: Joi.when("EmploymentNA", {
          is: false,
          then: Joi.when("MilitaryHistory", {
            is: "Yes",
            then: Joi.string().required(),
          }),
        }),
      }),
    }),
    ADLNA: Joi.boolean(),
    MoneyManagement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    MoneyManagementDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("MoneyManagement", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("MoneyManagement", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    FoodManagement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    FoodManagementDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("FoodManagement", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("FoodManagement", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    Hygiene: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    HygieneDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Hygiene", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Hygiene", { is: "Advanced", then: Joi.string().required() }),
      }),
    }),
    Health: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    HealthDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Health", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Health", { is: "Advanced", then: Joi.string().required() }),
      }),
    }),
    Housekeeping: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    HousekeepingDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Housekeeping", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Housekeeping", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    Transportation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    TransportationDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Transportation", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Transportation", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    SafetySkills: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SafetySkillsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("SafetySkills", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("SafetySkills", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    ResourceKnowledge: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    ResourceKnowledgeDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("ResourceKnowledge", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("ResourceKnowledge", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    TimeManagement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    TimeManagementDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("TimeManagement", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("TimeManagement", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    Interaction: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    InteractionDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ADLNA", {
        is: false,
        then: Joi.when("Interaction", {
          is: "Regressed",
          then: Joi.string().required(),
        }).when("Interaction", {
          is: "Advanced",
          then: Joi.string().required(),
        }),
      }),
    }),
    CoopSkills: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CoopSkillsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CoopSkills", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("CoopSkills", { is: "Advanced", then: Joi.string().required() }),
    }),
    CommunicationSkills: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    CommunicationSkillsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CommunicationSkills", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("CommunicationSkills", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    EmotionalUnderstanding: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    EmotionalUnderstandingDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("EmotionalUnderstanding", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("EmotionalUnderstanding", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    ProblemSolving: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    ProblemSolvingDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ProblemSolving", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("ProblemSolving", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    ConflictResolution: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    ConflictResolutionDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("ConflictResolution", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("ConflictResolution", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    DecisionMakingSkills: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    DecisionMakingSkillsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("DecisionMakingSkills", {
        is: "Regressed",
        then: Joi.string().required(),
      }).when("DecisionMakingSkills", {
        is: "Advanced",
        then: Joi.string().required(),
      }),
    }),
    Bullied: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    Bully: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    AcceptedByPeers: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    NegativeAssociations: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    RelationshipComments: Joi.when("Bullied", {
      is: "Yes",
      then: Joi.string().required(),
    })
      .when("Bully", {
        is: "Yes",
        then: Joi.string().required(),
      })
      .when("AcceptedByPeers", {
        is: "No",
        then: Joi.string().required(),
      })
      .when("NegativeAssociations", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    CPSInvolvement: Joi.string().required(),
    TypeOfCPSInvolvement: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CPSInvolvement", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    CPSHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CPSInvolvement", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    CPSCaseworker: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CPSInvolvement", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    CPSCaseworkerName: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("CPSInvolvement", {
        is: "Yes",
        then: Joi.when("CPSCaseworker", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    GALCASA: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    GALCASAName: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("GALCASA", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    LegalInvolvement: Joi.string().required(),
    ProbationOfficer: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    ProbationOfficerName: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("ProbationOfficer", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    LegalStatus: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    LegalHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("LegalInvolvement", {
        is: "Yes",
        then: Joi.when("LegalStatus", {
          is: "None Reported",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        }),
      }),
    }),
    OtherLegalDetails: Joi.when("LegalInvolvement", {
      is: "Yes",
      then: Joi.string().required(),
    }),
    PCP: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.when("PCPUnknown", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PCPPhone: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.when("PCPUnknown", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    PCPUnknown: Joi.boolean(),
    LastMedicalExamDate: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    LastDentalExamDate: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Allergies", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("MedicalConditions", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("NutritionalConcerns", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("DentalConcerns", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Undiagnosed: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    UndiagnosedDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("Undiagnosed", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    NoMedications: Joi.boolean(),
    CurrentMedications: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    MedicationCompliance: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    SideEffects: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    SideEffectsDetails: Joi.when("NoMedications", {
      is: false,
      then: Joi.when("SideEffects", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    PsychotropicMeds: Joi.when("NoMedications", {
      is: false,
      then: Joi.string().required(),
    }),
    PsychotropicMedsDetails: Joi.when("NoMedications", {
      is: false,
      then: Joi.when("PsychotropicMeds", {
        is: "Yes",
        then: Joi.string().required(),
      }),
    }),
    SexualHistoryNA: Joi.boolean(),
    SexualOrientation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexualOrientationDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexualOrientation", {
          is: "Orientation not listed",
          then: Joi.string().required(),
        }).when("SexualOrientation", {
          is: "Unable to assess",
          then: Joi.string().required(),
        }),
      }),
    }),
    SexualRelationshipsEducation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexuallyActive: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    CaregiverAware: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    UseProtection: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    AwareOfRisks: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    Pregnancy: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    Children: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SexuallyActiveComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required(),
        }),
      }),
    }),
    SexualAbuseVictim: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexualBehavior: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexuallyActingOut: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexuallyAbusive: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    SexualHistoryComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexualAbuseVictim", {
          is: "Yes",
          then: Joi.string().required(),
        })
          .when("SexualBehavior", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("SexuallyActingOut", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("SexuallyAbusive", {
            is: "Yes",
            then: Joi.string().required(),
          }),
      }),
    }),
    MHTreatmentNA: Joi.boolean(),
    PastMentalHealthTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    PastGroupHomePlacement: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    PastHospitalPlacement: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    InvoluntaryTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    PastMentalHealthDiagnosis: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    MHTreatmentComments: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.when("PastMentalHealthTreatment", {
        is: "Yes",
        then: Joi.string().required(),
      })
        .when("PastGroupHomePlacement", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("PastHospitalPlacement", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("InvoluntaryTreatment", {
          is: "Yes",
          then: Joi.string().required(),
        }),
    }),
    MHTreatmentHistory: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    MHClientPerspectiveOfTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    MHCaregiverPerspectiveOfTreatment: Joi.when("MHTreatmentNA", {
      is: false,
      then: Joi.string().required(),
    }),
    SUAge: Joi.boolean(),
    SubstanceUseNA: Joi.boolean(),
    SUClientDenies: Joi.boolean(),
    SUClientReportsCurrent: Joi.boolean(),
    SUClientReportsPast: Joi.boolean(),
    SUClientPeers: Joi.boolean(),
    SUCaregiverSuspects: Joi.boolean(),
    SUCaregiverEvidence: Joi.boolean(),
    SUComments: Joi.when("SubstanceUseNA", {
      is: false,
      then: Joi.when("SUClientDenies", { is: true, then: Joi.required() })
        .when("SUClientReportsCurrent", {
          is: true,
          then: Joi.string().required(),
        })
        .when("SUClientReportsPast", {
          is: true,
          then: Joi.string().required(),
        })
        .when("SUClientPeers", { is: true, then: Joi.string().required() })
        .when("SUCaregiverSuspects", {
          is: true,
          then: Joi.string().required(),
        })
        .when("SUCaregiverEvidence", {
          is: true,
          then: Joi.string().required(),
        }),
    }),
    SUHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    ClientPerceptionOfSubstanceUse: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    CaregiverPerceptionOfSubstanceUse: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    NoPastTreatment: Joi.boolean(),
    SUTreatmentHistory: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.when("NoPastTreatment", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    SUClientPerspectiveOfTreatment: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.when("NoPastTreatment", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    SUCaregiverPerspectiveOfTreatment: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("SubstanceUseNA", {
        is: false,
        then: Joi.when("NoPastTreatment", {
          is: false,
          then: Joi.string().required(),
        }),
      }),
    }),
    TraumaNA: Joi.boolean(),
    TraumaHistory: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    DistressingMemories: Joi.boolean(),
    BlockOut: Joi.boolean(),
    Hypervigilance: Joi.boolean(),
    PhysiologicalResponses: Joi.boolean(),
    LossOfMemories: Joi.boolean(),
    Hyperarousal: Joi.boolean(),
    SleepDisturbances: Joi.boolean(),
    DevelopmentalRegression: Joi.boolean(),
    Nightmares: Joi.boolean(),
    Avoidant: Joi.boolean(),
    DifficultyConcentratingSymptom: Joi.boolean(),
    UnhealthyBoundaries: Joi.boolean(),
    Flashbacks: Joi.boolean(),
    Detachment: Joi.boolean(),
    EmotionalDysregulation: Joi.boolean(),
    RepetitivePlayOfEvents: Joi.boolean(),
    PsychologicalDistress: Joi.boolean(),
    DiminishedInterests: Joi.boolean(),
    Dissocation: Joi.boolean(),
    NegativeCognitions: Joi.boolean(),
    SocialWithdrawalSymptom: Joi.boolean(),
    NoSymptoms: Joi.boolean(),
    SocialSupports: Joi.boolean(),
    SenseOfMastery: Joi.boolean(),
    CaregiverStability: Joi.boolean(),
    StrongSpiritualBeliefs: Joi.boolean(),
    InterpersonalSkills: Joi.boolean(),
    PositiveOutlook: Joi.boolean(),
    PlacementStability: Joi.boolean(),
    Pets: Joi.boolean(),
    ValidatingExperiences: Joi.boolean(),
    Resources: Joi.boolean(),
    TiesToExtendedFamily: Joi.boolean(),
    Adaptability: Joi.boolean(),
    SecureAttachments: Joi.boolean(),
    StrongCulturalIdentity: Joi.boolean(),
    Resilience: Joi.boolean(),
    NoTraumaProtectiveFactors: Joi.boolean(),
    CopingStrategies: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    ClientAwareOfTrauma: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    ClientPerspectiveOfTrauma: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    CaregiverPerspectiveOfTrauma: Joi.when("TraumaNA", {
      is: false,
      then: Joi.string().required(),
    }),
    AppropriateAppearance: Joi.boolean(),
    Neat: Joi.boolean(),
    Disheveled: Joi.boolean(),
    BizarreAppearance: Joi.boolean(),
    OtherAppearance: Joi.boolean(),
    OtherAppearanceDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherAppearance", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Cooperative: Joi.boolean(),
    Guarded: Joi.boolean(),
    Hyperactive: Joi.boolean(),
    Agitated: Joi.boolean(),
    Paranoid: Joi.boolean(),
    Tics: Joi.boolean(),
    Impulsive: Joi.boolean(),
    Aggressive: Joi.boolean(),
    Withdrawn: Joi.boolean(),
    BizarreBehavior: Joi.boolean(),
    Rigidity: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherBehavior", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Normal: Joi.boolean(),
    Slurred: Joi.boolean(),
    Pressured: Joi.boolean(),
    Tangential: Joi.boolean(),
    Incoherent: Joi.boolean(),
    Stutters: Joi.boolean(),
    OtherSpeech: Joi.boolean(),
    OtherSpeechDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherSpeech", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Euthymic: Joi.boolean(),
    Anxious: Joi.boolean(),
    Angry: Joi.boolean(),
    Depressed: Joi.boolean(),
    Euphoric: Joi.boolean(),
    Irritable: Joi.boolean(),
    Fearful: Joi.boolean(),
    OtherMood: Joi.boolean(),
    OtherMoodDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherMood", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    FullRange: Joi.boolean(),
    Restricted: Joi.boolean(),
    Blunted: Joi.boolean(),
    Flat: Joi.boolean(),
    Inappropriate: Joi.boolean(),
    OtherAffect: Joi.boolean(),
    OtherAffectDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherAffect", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    Logical: Joi.boolean(),
    Preoccupations: Joi.boolean(),
    Delusions: Joi.boolean(),
    Hallucinations: Joi.boolean(),
    Racing: Joi.boolean(),
    Disorganized: Joi.boolean(),
    Concrete: Joi.boolean(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    OtherPerception: Joi.boolean(),
    OtherPerceptionDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherPerception", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    NoImpairment: Joi.boolean(),
    ShortAttentionSpan: Joi.boolean(),
    DifficultyConcentrating: Joi.boolean(),
    Distractibility: Joi.boolean(),
    MemoryImpairment: Joi.boolean(),
    LowIntelligence: Joi.boolean(),
    OtherCognition: Joi.boolean(),
    OtherCognitionDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherCognition", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AppropriateInsight: Joi.boolean(),
    Fair: Joi.boolean(),
    Impaired: Joi.boolean(),
    OtherInsight: Joi.boolean(),
    OtherInsightDetails: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("OtherInsight", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    MentalStatusComments: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    LethalityNA: Joi.boolean(),
    SelfAbusiveBehavior: Joi.label("Self-abusive behavior").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    SuicidalThreats: Joi.label("Suicidal threats").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    SuicideAttempt: Joi.label("Suicide attempt").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    CaregiverConcernsOfSelfHarm: Joi.label(
      "Parent/Caregiver concerns of suicide/self-harm"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    OtherConcernsOfSelfHarm: Joi.label(
      "Other expressed concerns of suicide/self-harm"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    CurrentSelfHarmRisk: Joi.label("Current Risk of Harm to Self").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    SelfHarmComments: Joi.label("Current Risk of Harm to Self comments").when(
      "LethalityNA",
      {
        is: false,
        then: Joi.when("SelfAbusiveBehavior", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
          .when("SuicidalThreats", {
            is: "None/Never",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          })
          .when("SuicideAttempt", {
            is: "None/Never",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          })
          .when("CaregiverConcernsOfSelfHarm", {
            is: "No",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          })
          .when("OtherConcernsOfOtherHarm", {
            is: "Yes",
            then: Joi.string().required(),
          })
          .when("CurrentSelfHarmRisk", {
            is: "None Noted",
            then: Joi.string().allow(""),
            otherwise: Joi.string().required(),
          }),
      }
    ),
    ThreatsToHarmOthers: Joi.label(
      "Threats to intentionally harm/endanger others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    ThoughtsOfHarm: Joi.label(
      "Thoughts of intentionally harming/endangering others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    ActsOfHarm: Joi.label("Acts of intentionally harm/endangering others").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    ActsOfHarmAnimals: Joi.label(
      "Acts of intentionally harm/endangering animals"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    ActsInvolvingWeapons: Joi.label("Acts involving weapons").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    CaregiverConcernOfOtherHarm: Joi.label(
      "Parent/Caregiver concerns of harm/endangering others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    OtherConcernsOfOtherHarm: Joi.label(
      "Other expressed concerns of harm/endangering others"
    ).when("LethalityNA", { is: false, then: Joi.string().required() }),
    CurrentOtherHarmRisk: Joi.label("Current Risk of Harm to Others").when(
      "LethalityNA",
      { is: false, then: Joi.string().required() }
    ),
    OtherHarmComments: Joi.label(
      "Current Risk of Harm to Others comments"
    ).when("LethalityNA", {
      is: false,
      then: Joi.when("ThreatsToHarmOthers", {
        is: "None/Never",
        then: Joi.string().allow(""),
        otherwise: Joi.string().required(),
      })
        .when("ThoughtsOfHarm", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("ActsOfHarm", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("ActsOfHarmAnimals", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("ActsInvolvingWeapons", {
          is: "None/Never",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("CaregiverConcernOfOtherHarm", {
          is: "No",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        })
        .when("OtherConcernsOfOtherHarm", {
          is: "Yes",
          then: Joi.string().required(),
        })
        .when("CurrentOtherHarmRisk", {
          is: "None Noted",
          then: Joi.string().allow(""),
          otherwise: Joi.string().required(),
        }),
    }),
    SafetyPlanStatus: Joi.label("Safety Plan Status").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    LethalityComments: Joi.label("Comments/Plan").when("LethalityNA", {
      is: false,
      then: Joi.string().required(),
    }),
    TraumaSymptoms: Joi.boolean(),
    TraumaticExposure: Joi.boolean(),
    AvoidantTrauma: Joi.boolean(),
    HypervigilanceTrauma: Joi.boolean(),
    IntrusiveDreams: Joi.boolean(),
    NegativeThoughts: Joi.boolean(),
    CocentrationProblems: Joi.boolean(),
    RecklessBehaviorTrauma: Joi.boolean(),
    SleepDisturbancesTrauma: Joi.boolean(),
    OtherTrauma: Joi.boolean(),
    OtherTraumaDetails: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.when("OtherTrauma", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    TraumaSymptomsFrequency: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    TraumaSymptomsIntensity: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    TraumaSymptomsDuration: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    TraumaSymptomsOnset: Joi.when("TraumaSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    AnxietyDisorder: Joi.boolean(),
    AnxietyDisorderExcessWorry: Joi.boolean(),
    AnxietyDisorderEasilyFatigued: Joi.boolean(),
    MuscleTension: Joi.boolean(),
    Overworried: Joi.boolean(),
    AnxietyDisorderDifficultyConcentrating: Joi.boolean(),
    SleepDisturbancesAnxiety: Joi.boolean(),
    RestlessAnxiety: Joi.boolean(),
    Irritability: Joi.boolean(),
    OtherAnxiety: Joi.boolean(),
    OtherAnxietyDetails: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.when("OtherAnxiety", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AnxietyDisorderFrequency: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    AnxietyDisorderIntensity: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    AnxietyDisorderDuration: Joi.when("AnxietyDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    DepressionSymptoms: Joi.boolean(),
    DepressedMood: Joi.boolean(),
    SleepChanges: Joi.boolean(),
    Guilt: Joi.boolean(),
    DiminishedInterest: Joi.boolean(),
    PurposelessMovement: Joi.boolean(),
    DifficultyConcentratingDepression: Joi.boolean(),
    WeightChanges: Joi.boolean(),
    FatigueDepression: Joi.boolean(),
    ThoughtsOfDeath: Joi.boolean(),
    OtherDepression: Joi.boolean(),
    OtherDepressionDetails: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.when("OtherDepression", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DepressionFrequency: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    DepressionIntensity: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    DepressionDuration: Joi.when("DepressionSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    AttentionHyperactivity: Joi.boolean(),
    AttentionHyperactivityEasilyDistracted: Joi.boolean(),
    DifficultyFollowThrough: Joi.boolean(),
    Forgetful: Joi.boolean(),
    DifficultyListening: Joi.boolean(),
    DisorganizedAttention: Joi.boolean(),
    Fidgety: Joi.boolean(),
    LackOfDetails: Joi.boolean(),
    LosesThings: Joi.boolean(),
    InterruptsOthers: Joi.boolean(),
    UnableToSitStill: Joi.boolean(),
    ExcessiveTalking: Joi.boolean(),
    DifficultyWaiting: Joi.boolean(),
    OtherAttention: Joi.boolean(),
    OtherAttentionDetails: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.when("OtherAttention", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    AttentionHyperactivityFrequency: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.string().required(),
    }),
    AttentionHyperactivityIntensity: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.string().required(),
    }),
    AttentionHyperactivityDuration: Joi.when("AttentionHyperactivity", {
      is: true,
      then: Joi.string().required(),
    }),
    SU: Joi.boolean(),
    PatternOfSubstanceUse: Joi.boolean(),
    DesiresCutDownUse: Joi.boolean(),
    TimeSpentObtaining: Joi.boolean(),
    Cravings: Joi.boolean(),
    FailureOfResponsibilities: Joi.boolean(),
    NegativeImpact: Joi.boolean(),
    AbandonsActivities: Joi.boolean(),
    Tolerance: Joi.boolean(),
    SUWithdrawal: Joi.boolean(),
    SUOther: Joi.boolean(),
    SUOtherDetails: Joi.when("SU", {
      is: true,
      then: Joi.when("SUOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    SubstanceUseFrequency: Joi.when("SU", {
      is: true,
      then: Joi.string().required(),
    }),
    SubstanceUseIntensity: Joi.when("SU", {
      is: true,
      then: Joi.string().required(),
    }),
    SubstanceUseDuration: Joi.when("SU", {
      is: true,
      then: Joi.string().required(),
    }),
    DMDD: Joi.boolean(),
    Temper: Joi.boolean(),
    OutsideOutbursts: Joi.boolean(),
    FrequentOutbursts: Joi.boolean(),
    DMDDIrritable: Joi.boolean(),
    OutburstsAroundOthers: Joi.boolean(),
    DMDDOther: Joi.boolean(),
    DMDDOtherDetails: Joi.when("DMDD", {
      is: true,
      then: Joi.when("DMDDOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DMDDFrequency: Joi.when("DMDD", {
      is: true,
      then: Joi.string().required(),
    }),
    DMDDIntensity: Joi.when("DMDD", {
      is: true,
      then: Joi.string().required(),
    }),
    DMDDDuration: Joi.when("DMDD", { is: true, then: Joi.string().required() }),
    ConductDisorder: Joi.boolean(),
    Aggression: Joi.boolean(),
    DestructionOfProperty: Joi.boolean(),
    Theft: Joi.boolean(),
    SeriousViolations: Joi.boolean(),
    OtherConductDisorder: Joi.boolean(),
    OtherConductDisorderDetails: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.when("OtherConductDisorder", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    ConductDisorderFrequency: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    ConductDisorderIntensity: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    ConductDisorderDuration: Joi.when("ConductDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    ODD: Joi.boolean(),
    IrritableODD: Joi.boolean(),
    Argumentative: Joi.boolean(),
    Vindictive: Joi.boolean(),
    OtherODD: Joi.boolean(),
    OtherODDDetails: Joi.when("ODD", {
      is: true,
      then: Joi.when("OtherODD", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    ODDFrequency: Joi.when("ODD", { is: true, then: Joi.string().required() }),
    ODDIntensity: Joi.when("ODD", { is: true, then: Joi.string().required() }),
    ODDDuration: Joi.when("ODD", { is: true, then: Joi.string().required() }),
    OCD: Joi.boolean(),
    OCDPresence: Joi.boolean(),
    Obsessions: Joi.boolean(),
    TimeConsuming: Joi.boolean(),
    Compulsions: Joi.boolean(),
    ReduceAnxiety: Joi.boolean(),
    SuppressUrges: Joi.boolean(),
    OCDOther: Joi.boolean(),
    OCDOtherDetails: Joi.when("OCD", {
      is: true,
      then: Joi.when("OCDOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    OCDFrequency: Joi.when("OCD", { is: true, then: Joi.string().required() }),
    OCDIntensity: Joi.when("OCD", { is: true, then: Joi.string().required() }),
    OCDDuration: Joi.when("OCD", { is: true, then: Joi.string().required() }),
    PanicDisorder: Joi.boolean(),
    PoundingHeart: Joi.boolean(),
    PanicDisorderSweating: Joi.boolean(),
    Trembling: Joi.boolean(),
    ShortnessOfBreath: Joi.boolean(),
    Choking: Joi.boolean(),
    ChestPain: Joi.boolean(),
    PanicDisorderNausea: Joi.boolean(),
    Dizzy: Joi.boolean(),
    Chills: Joi.boolean(),
    Derealization: Joi.boolean(),
    FearOfCrazy: Joi.boolean(),
    FearOfDying: Joi.boolean(),
    PanicDisorderOther: Joi.boolean(),
    PanicDisorderOtherDetails: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.when("PanicDisorderOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    PanicDisorderFrequency: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    PanicDisorderIntensity: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    PanicDisorderDuration: Joi.when("PanicDisorder", {
      is: true,
      then: Joi.string().required(),
    }),
    Phobias: Joi.boolean(),
    PhobiasSpecificFear: Joi.boolean(),
    ImmediateFear: Joi.boolean(),
    PhobiasAvoidance: Joi.boolean(),
    FearExaggerated: Joi.boolean(),
    PhobiasOther: Joi.boolean(),
    PhobiasOtherDetails: Joi.when("Phobias", {
      is: true,
      then: Joi.when("PhobiasOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    PhobiasFrequency: Joi.when("Phobias", {
      is: true,
      then: Joi.string().required(),
    }),
    PhobiasIntensity: Joi.when("Phobias", {
      is: true,
      then: Joi.string().required(),
    }),
    PhobiasDuration: Joi.when("Phobias", {
      is: true,
      then: Joi.string().required(),
    }),
    DI: Joi.boolean(),
    DILowIQ: Joi.boolean(),
    DISensoryImpairments: Joi.boolean(),
    DISpeechDelays: Joi.boolean(),
    DIMotorCoordinationDelays: Joi.boolean(),
    DILearningDisorder: Joi.boolean(),
    DISpatialDelays: Joi.boolean(),
    DevelopmentalImpairmentsOther: Joi.boolean(),
    DevelopmentalImpairmentsOtherDetails: Joi.when("DI", {
      is: true,
      then: Joi.when("DevelopmentalImpairmentsOther", {
        is: true,
        then: Joi.string().required(),
      }),
    }),
    DevelopmentalImpairmentsDetails: Joi.when("DI", {
      is: true,
      then: Joi.when("DILowIQ", { is: true, then: Joi.required() })
        .when("DISensoryImpairments", { is: true, then: Joi.required() })
        .when("DISpeechDelays", { is: true, then: Joi.required() })
        .when("DIMotorCoordinationDelays", { is: true, then: Joi.required() })
        .when("DILearningDisorder", { is: true, then: Joi.required() })
        .when("DISpatialDelays", { is: true, then: Joi.required() }),
    }),
    OtherSymptoms: Joi.boolean(),
    OtherSymptomsDetails: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    OtherSymptomsFrequency: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    OtherSymptomsIntensity: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    OtherSymptomsDuration: Joi.when("OtherSymptoms", {
      is: true,
      then: Joi.string().required(),
    }),
    ClinicalNarrativeSummary: Joi.string().required(),
    ClinicalNarrativeSummaryComments: Joi.string().allow(null, ""),
    DiagnosisDetails: Joi.string().required(),
    SeriousDisturbance: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    NoAdditionalNeeds: Joi.boolean(),
    AdditionalNeeds: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.when("NoAdditionalNeeds", {
        is: false,
        then: Joi.string().required(),
      }),
    }),
    TreatmentRecommendations: Joi.string().required(),
    DiagnosisEducation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    RecommendationEducation: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    ClientAgrees: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
    FamilyAgress: Joi.when("PSDType", {
      is: "Psychiatric Diagnostic Evaluation",
      then: Joi.string().allow(""),
      otherwise: Joi.string().required(),
    }),
  },
  "A774EAEA-C410-F011-90CC-D1E42B61504B": {
    SelectedProgram: Joi.string().required(),
    FosterHome: Joi.string().required(),
    IncidentDate: Joi.date().required().label("Incident Date"),
    SAFYTypeOfIncident: Joi.string().allow(""),
    SAFYAWOLLocated: Joi.string().allow(""),
    SAFYOutcome: Joi.string().allow(""),
    SAFYProblematicBehaviorsOutcomeDetention: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeSuspension: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeExpulsion: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeSafetyPlan: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeIEP: Joi.boolean(),
    SAFYProblematicBehaviorsOutcomeOther: Joi.boolean(),
  },
};
